import * as i0 from '@angular/core';
import { Component, ViewEncapsulation, Input, HostBinding, NgModule, Directive, EventEmitter, Output, ContentChild, ChangeDetectionStrategy, ContentChildren, ElementRef, ViewChildren, ViewChild, Self, Optional, Injectable, HostListener, forwardRef, Inject, InjectionToken, Pipe, Host, inject, VERSION, ViewContainerRef } from '@angular/core';
import { Subject, BehaviorSubject, fromEvent, merge, takeUntil as takeUntil$1, tap as tap$1, switchMap as switchMap$1, ReplaySubject } from 'rxjs';
import { takeUntil, filter, map, startWith, switchMap, take, debounceTime, tap } from 'rxjs/operators';
import * as i1 from '@angular/common';
import { CommonModule, DOCUMENT } from '@angular/common';
import { enforceCase, ensureScrollableAccess, enforceBoolean, platform, ALERT_ICONS, EnforceBoolean, Memo, filterListboxOptions, objectIs, differenceArray, getComboboxActionByKeyboardEvent, generateClasses, textLength, CREDIT_CARD_PLACEHOLDER, enforceNumber, getElevation, setVoiceOverFocus, toggleMobileFocusTrap, observeVirtualKeyboard, deepClone, validateDate, getActiveElement, focus, startFocus, pxToRem, normalizeText, INPUTS_TYPES_WITH_NATIVE_PLACEHOLDER, PT_BR_MONTHS, CURRENT_YEAR, CURRENT_MONTH, generateCalendarMatrix, CURRENT_DAY, formatStringToDate, isUniversalDateFormat, convertToUniversalDate, navigateCalendar, LOCALE_DATE_FORMATS, MAX_YEARS_RANGE, PT_BR_DAYS_OF_WEEK, createNavigationWithArrows, formatDateToString, toKebabCase, OPTIONS_BY_LANGUAGE, applyAspectRatioVariables, getScrollingParent, isElementBottomAboveReferenceBottom, hasFocus, brlToNumeral, EnforceNumber, scrollIntoViewX, isElementScrollable, TRACKER_STATUS_MESSAGE, Segments, Segment, applySegmentToElement, getCurrentColorMode, changeSegment } from '@ids/tools';
import { __decorate, __metadata } from 'tslib';
import * as i1$1 from '@angular/cdk/a11y';
import { A11yModule } from '@angular/cdk/a11y';
import * as i1$3 from '@angular/cdk/overlay';
import { CdkOverlayOrigin, CdkConnectedOverlay, OverlayModule, CdkScrollable, OverlayContainer } from '@angular/cdk/overlay';
import * as i1$2 from '@angular/forms';
import { FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule, Validators } from '@angular/forms';
import { trigger, transition, style, animate, query } from '@angular/animations';
import * as i1$5 from '@angular/platform-browser';
import { HammerGestureConfig, ɵSharedStylesHost } from '@angular/platform-browser';
import * as Hammer from 'hammerjs';
import * as i4 from '@angular/router';
import { RouterModule } from '@angular/router';
import * as i2 from '@angular/cdk/observers';
import { ObserversModule } from '@angular/cdk/observers';
import * as i1$4 from '@angular/cdk/platform';
import * as i2$1 from '@angular/cdk/table';
import { CdkCellDef, CdkHeaderCellDef, CdkFooterCellDef, CdkColumnDef, CdkHeaderCell, CdkFooterCell, CdkCell, CdkTable, CDK_TABLE, _COALESCED_STYLE_SCHEDULER, _CoalescedStyleScheduler, STICKY_POSITIONING_LISTENER, CDK_TABLE_TEMPLATE, CdkHeaderRowDef, CdkFooterRowDef, CdkRowDef, CdkHeaderRow, CDK_ROW_TEMPLATE, CdkFooterRow, CdkRow, CdkNoDataRow, CdkTextColumn, CdkTableModule } from '@angular/cdk/table';
import { _VIEW_REPEATER_STRATEGY, _RecycleViewRepeaterStrategy, _DisposeViewRepeaterStrategy } from '@angular/cdk/collections';
import { ComponentPortal } from '@angular/cdk/portal';

/**
 * Componente de ícone usado em elementos de interface, disponibilizado nos tamanhos pequeno "S", médio "M" e grande "L"
 *
 * *Icon component used in interface elements, available as small "S", medium "M" and large "L".*
 *
 * **Module:**
 *
 * `import { IdsIconModule } from '@ids/angular';`
 *
 *  **Componente:**
 *
 * `import { IdsIconComponent } from '@ids/angular';`
 *
 */
class IdsIconComponent {
    /**
     * Tamanho do ícone
     *
     * *Icon size*
     */
    set size(size) {
        this._size = enforceCase(size, 'upperCase');
    }
    get size() {
        return this._size;
    }
    constructor(_elementRef) {
        this._elementRef = _elementRef;
    }
    ngOnInit() {
        this.role = this._elementRef.nativeElement.hasAttribute('aria-label') ? 'img' : null;
    }
}
IdsIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsIconComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
IdsIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsIconComponent, isStandalone: true, selector: "ids-icon", inputs: { size: "size", variant: "variant", contrast: "contrast" }, host: { properties: { "class.ids-icon": "true", "class.ids-icon--small": "size === \"S\"", "class.ids-icon--large": "size === \"L\"", "class.ids-icon--xlarge": "size === \"XL\"", "class.ids-icon--primary": "variant === \"primary\"", "class.ids-icon--secondary": "variant === \"secondary\"", "class.ids-icon--neutral": "variant === \"neutral\"", "class.ids-icon--success": "variant === \"success\"", "class.ids-icon--alert": "variant === \"alert\"", "class.ids-icon--information": "variant === \"information\"", "class.ids-icon--error": "variant === \"error\"", "class.ids-icon--on-brand": "contrast === \"onBrand\"", "attr.role": "this.role" } }, ngImport: i0, template: "<span aria-hidden=\"true\">\n  <ng-content></ng-content>\n</span>\n", encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsIconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-icon', host: {
                        '[class.ids-icon]': 'true',
                        '[class.ids-icon--small]': 'size === "S"',
                        '[class.ids-icon--large]': 'size === "L"',
                        '[class.ids-icon--xlarge]': 'size === "XL"',
                        '[class.ids-icon--primary]': 'variant === "primary"',
                        '[class.ids-icon--secondary]': 'variant === "secondary"',
                        '[class.ids-icon--neutral]': 'variant === "neutral"',
                        '[class.ids-icon--success]': 'variant === "success"',
                        '[class.ids-icon--alert]': 'variant === "alert"',
                        '[class.ids-icon--information]': 'variant === "information"',
                        '[class.ids-icon--error]': 'variant === "error"',
                        '[class.ids-icon--on-brand]': 'contrast === "onBrand"',
                    }, standalone: true, encapsulation: ViewEncapsulation.None, template: "<span aria-hidden=\"true\">\n  <ng-content></ng-content>\n</span>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { size: [{
                type: Input
            }], variant: [{
                type: Input
            }], contrast: [{
                type: Input
            }], role: [{
                type: HostBinding,
                args: ['attr.role']
            }] } });

class IdsIconModule {
}
IdsIconModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsIconModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsIconModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsIconModule, imports: [IdsIconComponent], exports: [IdsIconComponent] });
IdsIconModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsIconModule, imports: [IdsIconComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsIconModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsIconComponent],
                    exports: [IdsIconComponent],
                }]
        }] });

/**
 * O idsEnsureScrollableAccess irá que se o elemento tiver rolagem ele terá o
 * atributo `tabindex` adicionado.
 *
 * **Module:**
 *
 * `import { IdsEnsureScrollableAccessModule } from '@ids/angular';`
 *
 * **Diretiva:**
 *
 * `import { IdsEnsureScrollableAccessDirective } from '@ids/angular;`
 *
 * @example
 * <div idsEnsureScrollableAccess></div>
 * <!-- Result: <div idsEnsureScrollableAccess tabindex="0"> -->
 */
class IdsEnsureScrollableAccessDirective {
    constructor(_elementRef) {
        this._elementRef = _elementRef;
    }
    ngOnInit() {
        /* istanbul ignore next */
        this.resizeObserver = new ResizeObserver(() => {
            /* istanbul ignore next */
            ensureScrollableAccess(this._elementRef.nativeElement);
        });
        this.resizeObserver.observe(this._elementRef.nativeElement);
    }
    ngOnDestroy() {
        this.resizeObserver?.disconnect();
    }
}
IdsEnsureScrollableAccessDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsEnsureScrollableAccessDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
IdsEnsureScrollableAccessDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsEnsureScrollableAccessDirective, isStandalone: true, selector: "[idsEnsureScrollableAccess]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsEnsureScrollableAccessDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsEnsureScrollableAccess]',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; } });
/** @deprecated substitua por IdsEnsureScrollableAccessDirective */
const VoxelEnsureScrollableAccessDirective = IdsEnsureScrollableAccessDirective;

class IdsEnsureScrollableAccessModule {
}
IdsEnsureScrollableAccessModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsEnsureScrollableAccessModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsEnsureScrollableAccessModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsEnsureScrollableAccessModule, imports: [IdsEnsureScrollableAccessDirective], exports: [IdsEnsureScrollableAccessDirective] });
IdsEnsureScrollableAccessModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsEnsureScrollableAccessModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsEnsureScrollableAccessModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsEnsureScrollableAccessDirective],
                    exports: [IdsEnsureScrollableAccessDirective],
                }]
        }] });
/** @deprecated substitua por IdsEnsureScrollableAccessModule */
const VoxelEnsureScrollableAccessModule = IdsEnsureScrollableAccessModule;

let NEXT_ID$s = 0;
class IdsAccordionHeaderDirective {
    constructor() {
        this.class = 'ids-reset-element';
    }
}
IdsAccordionHeaderDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAccordionHeaderDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
IdsAccordionHeaderDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsAccordionHeaderDirective, isStandalone: true, selector: "[idsAccordionHeader]", host: { properties: { "class": "this.class" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAccordionHeaderDirective, decorators: [{
            type: Directive,
            args: [{
                    standalone: true,
                    selector: '[idsAccordionHeader]',
                }]
        }], propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }] } });
class IdsAccordionIconDirective {
    constructor() {
        this.ariaHidden = true;
    }
}
IdsAccordionIconDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAccordionIconDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
IdsAccordionIconDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsAccordionIconDirective, isStandalone: true, selector: "[idsAccordionIcon]", host: { properties: { "attr.aria-hidden": "this.ariaHidden" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAccordionIconDirective, decorators: [{
            type: Directive,
            args: [{
                    standalone: true,
                    selector: '[idsAccordionIcon]',
                }]
        }], propDecorators: { ariaHidden: [{
                type: HostBinding,
                args: ['attr.aria-hidden']
            }] } });
/**
 * Lista de tópicos que podem ser expandidos ou contraidos
 *
 * **Module:**
 *
 * `import { IdsAccordionModule } from '@ids/angular';`
 *
 * **Component:**
 *
 * `import { IdsAccordionComponent, IdsAccordionGroupComponent, IdsAccordionHeaderDirective, IdsAccordionIconDirective } from '@ids/angular';`
 *
 */
class IdsAccordionComponent {
    constructor() {
        /**
         * Id do componente de accordion
         */
        this.id = `ids-accordion-${NEXT_ID$s++}`;
        this._open = false;
        /**
         * Emite eventos de clique no accordion
         */
        this.toggle = new EventEmitter();
        /**
         * Emite sempre que o estado expandido do Accordion mudar
         * Usado principalmente para facilitar o two-way binding
         */
        this.openChange = new EventEmitter();
    }
    /**
     * Estado de exibição inicial do componente
     * Valor padrão = false
     */
    set open(open) {
        this._open = enforceBoolean(open);
    }
    get open() {
        return this._open;
    }
    toggleCollapse(_event) {
        this.openChange.emit(!this.open);
        this.toggle.emit(this.createEmit(_event));
        this._open = !this._open;
    }
    createEmit(event) {
        return {
            event,
            id: this.id,
        };
    }
}
IdsAccordionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAccordionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IdsAccordionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsAccordionComponent, isStandalone: true, selector: "ids-accordion", inputs: { description: "description", header: "header", open: "open", expandedMaxHeight: "expandedMaxHeight" }, outputs: { toggle: "toggle", openChange: "openChange" }, host: { properties: { "attr.id": "this.id" } }, queries: [{ propertyName: "icon", first: true, predicate: IdsAccordionIconDirective, descendants: true, static: true }], ngImport: i0, template: "<!-- O valor 9999px foi utilizado a fim de termos um valor m\u00E1ximo, por\u00E9m sem ativar o scroll em casos\nque a pessoa usu\u00E1ria n\u00E3o esteja solicitando que haja scroll (com o uso do input expandedMaxHeight)\n\nOptamos por enviar a unidade de medida junto com o valor a fim de flexibilizar o formato da prefer\u00EAncia da pessoa. (%, rem, px.. etc) -->\n<div\n  class=\"ids-accordion\"\n  [class.ids-accordion--expanded]=\"open\"\n  style=\"--ids-accordion-max-height: {{ expandedMaxHeight || '9999px' }}\"\n>\n  <button\n    class=\"ids-accordion__trigger\"\n    [attr.aria-controls]=\"'content-' + id\"\n    [attr.aria-expanded]=\"open\"\n    (click)=\"toggleCollapse($event)\"\n  >\n    <div *ngIf=\"icon\" class=\"ids-accordion__icon\">\n      <ng-content select=\"[idsAccordionIcon]\"></ng-content>\n    </div>\n\n    <div class=\"ids-accordion__header\">\n      {{ header }}\n      <ng-content select=\"[idsAccordionHeader]\"></ng-content>\n      <span *ngIf=\"description\" class=\"ids-sr-only\"> , </span>\n      <span *ngIf=\"description\" class=\"ids-accordion__description\">\n        {{ description }}\n      </span>\n    </div>\n\n    <div class=\"ids-accordion__toggle\">\n      <!-- TODO: talvez variant neutral -->\n      <ids-icon>seta_baixo</ids-icon>\n    </div>\n  </button>\n\n  <div [id]=\"'content-' + id\" class=\"ids-accordion__body\" idsEnsureScrollableAccess>\n    <div class=\"ids-accordion__content\">\n      <ng-content></ng-content>\n    </div>\n  </div>\n</div>\n", styles: [".ids-animation-fade-in-start{opacity:0}.ids-animation-fade-in-moderate-end{opacity:1;transition:opacity .2s cubic-bezier(.42,0,.58,1)}.ids-animation-fade-out-start{opacity:1}.ids-animation-fade-out-moderate-output-end{opacity:0;transition:opacity 275ms cubic-bezier(.42,0,.58,1)}.ids-animation-scale-x-down{transform:scaleX(0);transform:scaleX(var(--ids-scale-x-down, 0))}.ids-animation-scale-x-up{transform:scaleX(1);transform:scaleX(var(--ids-scale-x-up, 100%))}.ids-animation-time-transform-slow{transition:transform 2s cubic-bezier(0,0,.58,1)}.ids-animation-width-down{width:0;width:var(--ids-width-down, 0)}.ids-animation-width-up{width:100%;width:var(--ids-width-up, 100%)}.ids-animation-time-width-slow{transition:width 2s cubic-bezier(0,0,.58,1)}.ids-motion-none,.ids-motion-none:before,.ids-motion-none:after,.ids-motion-none *,.ids-motion-none *:before,.ids-motion-none *:after{animation:none!important;transition:none!important}.ids-accordion{background-color:var(--ids_color_bg_base)}.ids-accordion__trigger{all:unset;all:revert;box-sizing:border-box;padding:0;-webkit-user-select:none;user-select:none;align-items:center;background-color:var(--ids_color_bg_base);border:0;color:var(--ids_color_text_body_01);cursor:pointer;display:flex;font-size:0;line-height:1;outline-offset:var(--ids_size_general_1x);overflow:hidden;padding:var(--ids_spacing_4x) var(--ids_spacing_4x) var(--ids_spacing_3x) 0;width:100%;border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_soft)}@media (pointer: coarse){.ids-accordion__trigger{outline:0!important}.ids-accordion__trigger:focus{outline:0!important}}@media (pointer: coarse) and (pointer: fine){.ids-accordion__trigger:focus-visible,.ids-accordion__trigger:focus.focus-visible{outline:0!important}}@media (pointer: fine){.ids-accordion__trigger:focus-visible,.ids-accordion__trigger:focus.focus-visible{outline:revert!important}}@media (pointer: fine) and (pointer: fine){.ids-accordion__trigger:focus-visible,.ids-accordion__trigger:focus.focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}}.ids-accordion__trigger:focus,.ids-accordion__trigger:hover{background-color:var(--ids_color_action_neutral_base_soft)}.ids-accordion__header{color:var(--ids_color_action_neutral_variant);display:grid;flex:1;font:var(--ids_textStyle_f02_s16_h24_wrg);text-align:left}.ids-accordion__header>*:not(.ids-accordion__description){font:inherit;font-weight:inherit}.ids-accordion__description{color:var(--ids_color_action_neutral_base);font:var(--ids_textStyle_f02_s14_h20_wrg)}.ids-accordion__toggle{align-self:center;margin-left:var(--ids_spacing_3x);transition:transform .5s}.ids-accordion__icon{margin-right:var(--ids_spacing_3x)}.ids-accordion__content{opacity:0;padding:var(--ids_size_general_24x) 0;transform:translateY(-.75rem);transition:opacity 375ms linear,visibility 375ms linear,transform .3s 50ms cubic-bezier(0,0,.58,1);visibility:hidden}.ids-accordion__body{font:var(--ids_textStyle_f02_s16_h24_wrg);max-height:0;overflow-y:hidden;transition-delay:375ms;transition-property:max-height}.ids-accordion--expanded .ids-accordion__toggle{transform:rotate(180deg)}.ids-accordion--expanded .ids-accordion__content{opacity:1;transform:none;transform:initial;transition:opacity .35s linear,visibility .35s linear,transform .3s cubic-bezier(.42,0,1,1);visibility:visible}.ids-accordion--expanded .ids-accordion__body{max-height:var(--ids-accordion-max-height);overflow-y:auto;transition-delay:0s}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: IdsIconModule }, { kind: "component", type: IdsIconComponent, selector: "ids-icon", inputs: ["size", "variant", "contrast"] }, { kind: "ngmodule", type: IdsEnsureScrollableAccessModule }, { kind: "directive", type: IdsEnsureScrollableAccessDirective, selector: "[idsEnsureScrollableAccess]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAccordionComponent, decorators: [{
            type: Component,
            args: [{ imports: [CommonModule, IdsIconModule, IdsEnsureScrollableAccessModule], selector: 'ids-accordion', standalone: true, template: "<!-- O valor 9999px foi utilizado a fim de termos um valor m\u00E1ximo, por\u00E9m sem ativar o scroll em casos\nque a pessoa usu\u00E1ria n\u00E3o esteja solicitando que haja scroll (com o uso do input expandedMaxHeight)\n\nOptamos por enviar a unidade de medida junto com o valor a fim de flexibilizar o formato da prefer\u00EAncia da pessoa. (%, rem, px.. etc) -->\n<div\n  class=\"ids-accordion\"\n  [class.ids-accordion--expanded]=\"open\"\n  style=\"--ids-accordion-max-height: {{ expandedMaxHeight || '9999px' }}\"\n>\n  <button\n    class=\"ids-accordion__trigger\"\n    [attr.aria-controls]=\"'content-' + id\"\n    [attr.aria-expanded]=\"open\"\n    (click)=\"toggleCollapse($event)\"\n  >\n    <div *ngIf=\"icon\" class=\"ids-accordion__icon\">\n      <ng-content select=\"[idsAccordionIcon]\"></ng-content>\n    </div>\n\n    <div class=\"ids-accordion__header\">\n      {{ header }}\n      <ng-content select=\"[idsAccordionHeader]\"></ng-content>\n      <span *ngIf=\"description\" class=\"ids-sr-only\"> , </span>\n      <span *ngIf=\"description\" class=\"ids-accordion__description\">\n        {{ description }}\n      </span>\n    </div>\n\n    <div class=\"ids-accordion__toggle\">\n      <!-- TODO: talvez variant neutral -->\n      <ids-icon>seta_baixo</ids-icon>\n    </div>\n  </button>\n\n  <div [id]=\"'content-' + id\" class=\"ids-accordion__body\" idsEnsureScrollableAccess>\n    <div class=\"ids-accordion__content\">\n      <ng-content></ng-content>\n    </div>\n  </div>\n</div>\n", styles: [".ids-animation-fade-in-start{opacity:0}.ids-animation-fade-in-moderate-end{opacity:1;transition:opacity .2s cubic-bezier(.42,0,.58,1)}.ids-animation-fade-out-start{opacity:1}.ids-animation-fade-out-moderate-output-end{opacity:0;transition:opacity 275ms cubic-bezier(.42,0,.58,1)}.ids-animation-scale-x-down{transform:scaleX(0);transform:scaleX(var(--ids-scale-x-down, 0))}.ids-animation-scale-x-up{transform:scaleX(1);transform:scaleX(var(--ids-scale-x-up, 100%))}.ids-animation-time-transform-slow{transition:transform 2s cubic-bezier(0,0,.58,1)}.ids-animation-width-down{width:0;width:var(--ids-width-down, 0)}.ids-animation-width-up{width:100%;width:var(--ids-width-up, 100%)}.ids-animation-time-width-slow{transition:width 2s cubic-bezier(0,0,.58,1)}.ids-motion-none,.ids-motion-none:before,.ids-motion-none:after,.ids-motion-none *,.ids-motion-none *:before,.ids-motion-none *:after{animation:none!important;transition:none!important}.ids-accordion{background-color:var(--ids_color_bg_base)}.ids-accordion__trigger{all:unset;all:revert;box-sizing:border-box;padding:0;-webkit-user-select:none;user-select:none;align-items:center;background-color:var(--ids_color_bg_base);border:0;color:var(--ids_color_text_body_01);cursor:pointer;display:flex;font-size:0;line-height:1;outline-offset:var(--ids_size_general_1x);overflow:hidden;padding:var(--ids_spacing_4x) var(--ids_spacing_4x) var(--ids_spacing_3x) 0;width:100%;border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_soft)}@media (pointer: coarse){.ids-accordion__trigger{outline:0!important}.ids-accordion__trigger:focus{outline:0!important}}@media (pointer: coarse) and (pointer: fine){.ids-accordion__trigger:focus-visible,.ids-accordion__trigger:focus.focus-visible{outline:0!important}}@media (pointer: fine){.ids-accordion__trigger:focus-visible,.ids-accordion__trigger:focus.focus-visible{outline:revert!important}}@media (pointer: fine) and (pointer: fine){.ids-accordion__trigger:focus-visible,.ids-accordion__trigger:focus.focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}}.ids-accordion__trigger:focus,.ids-accordion__trigger:hover{background-color:var(--ids_color_action_neutral_base_soft)}.ids-accordion__header{color:var(--ids_color_action_neutral_variant);display:grid;flex:1;font:var(--ids_textStyle_f02_s16_h24_wrg);text-align:left}.ids-accordion__header>*:not(.ids-accordion__description){font:inherit;font-weight:inherit}.ids-accordion__description{color:var(--ids_color_action_neutral_base);font:var(--ids_textStyle_f02_s14_h20_wrg)}.ids-accordion__toggle{align-self:center;margin-left:var(--ids_spacing_3x);transition:transform .5s}.ids-accordion__icon{margin-right:var(--ids_spacing_3x)}.ids-accordion__content{opacity:0;padding:var(--ids_size_general_24x) 0;transform:translateY(-.75rem);transition:opacity 375ms linear,visibility 375ms linear,transform .3s 50ms cubic-bezier(0,0,.58,1);visibility:hidden}.ids-accordion__body{font:var(--ids_textStyle_f02_s16_h24_wrg);max-height:0;overflow-y:hidden;transition-delay:375ms;transition-property:max-height}.ids-accordion--expanded .ids-accordion__toggle{transform:rotate(180deg)}.ids-accordion--expanded .ids-accordion__content{opacity:1;transform:none;transform:initial;transition:opacity .35s linear,visibility .35s linear,transform .3s cubic-bezier(.42,0,1,1);visibility:visible}.ids-accordion--expanded .ids-accordion__body{max-height:var(--ids-accordion-max-height);overflow-y:auto;transition-delay:0s}\n"] }]
        }], propDecorators: { id: [{
                type: HostBinding,
                args: ['attr.id']
            }], description: [{
                type: Input
            }], header: [{
                type: Input
            }], open: [{
                type: Input
            }], expandedMaxHeight: [{
                type: Input
            }], toggle: [{
                type: Output
            }], openChange: [{
                type: Output
            }], icon: [{
                type: ContentChild,
                args: [IdsAccordionIconDirective, { static: true }]
            }] } });

class IdsAccordionGroupComponent {
    constructor() {
        this._destroy = new Subject();
        /**
         * Atributo booleano para definir se o Accordion group permitirá um único Accordion expandir por vez
         * Valor default: true
         */
        this.expandOne = true;
    }
    ngAfterViewInit() {
        this.accordionList.map((accord) => accord.toggle.pipe(takeUntil(this._destroy)).subscribe((clickedAccordion) => {
            this.accordionList.forEach((accordion) => {
                if (accordion.id !== clickedAccordion.id && this.expandOne) {
                    accordion.open = false;
                }
            });
        }));
    }
    ngOnDestroy() {
        this._destroy.next();
        this._destroy.complete();
    }
}
IdsAccordionGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAccordionGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IdsAccordionGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsAccordionGroupComponent, isStandalone: true, selector: "ids-accordion-group", inputs: { expandOne: "expandOne" }, queries: [{ propertyName: "accordionList", predicate: IdsAccordionComponent }], ngImport: i0, template: '<ng-content select="ids-accordion"></ng-content>', isInline: true, changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAccordionGroupComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ids-accordion-group',
                    standalone: true,
                    template: '<ng-content select="ids-accordion"></ng-content>',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                }]
        }], propDecorators: { accordionList: [{
                type: ContentChildren,
                args: [IdsAccordionComponent]
            }], expandOne: [{
                type: Input
            }] } });

class IdsAccordionModule {
}
IdsAccordionModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAccordionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsAccordionModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsAccordionModule, imports: [IdsAccordionComponent,
        IdsAccordionGroupComponent,
        IdsAccordionHeaderDirective,
        IdsAccordionIconDirective], exports: [IdsAccordionComponent,
        IdsAccordionGroupComponent,
        IdsAccordionHeaderDirective,
        IdsAccordionIconDirective] });
IdsAccordionModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAccordionModule, imports: [IdsAccordionComponent,
        IdsAccordionGroupComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAccordionModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        IdsAccordionComponent,
                        IdsAccordionGroupComponent,
                        IdsAccordionHeaderDirective,
                        IdsAccordionIconDirective,
                    ],
                    exports: [
                        IdsAccordionComponent,
                        IdsAccordionGroupComponent,
                        IdsAccordionHeaderDirective,
                        IdsAccordionIconDirective,
                    ],
                }]
        }] });

/**
 * Os botões permitem que o usuário realize ações e façam escolhas com um único toque.
 *
 * *Buttons allow the user to perform actions and make choices with a single tap.*
 *
 * **Module:**
 *
 * `import { IdsActionButtonModule } from '@ids/angular';`
 *
 * **Componente:**
 *
 * `import { IdsActionButtonComponent } from '@ids/angular';`
 */
class IdsActionButtonComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        /**
         * Define o tamanho. Padrão: M (médio)
         *
         * *Defines the size. Default: M (medium)*
         */
        this.size = 'M';
    }
}
IdsActionButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsActionButtonComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
IdsActionButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsActionButtonComponent, isStandalone: true, selector: "[idsActionButton]", inputs: { variant: "variant", contrast: "contrast", size: "size" }, host: { properties: { "class.ids-action-button": "true", "class.ids-action-button--neutral": "variant === \"neutral\"", "class.ids-action-button--secondary": "variant === \"secondary\"", "class.ids-action-button--on-brand": "contrast === \"onBrand\"", "class.ids-action-button--small": "size === \"S\"" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, styles: [".ids-action-button,:host.ids-action-button{all:unset;all:revert;box-sizing:border-box;padding:0;-webkit-user-select:none;user-select:none;gap:var(--ids_spacing_1x);align-items:center;background-color:transparent;border:0;color:var(--ids_color_action_primary_base);cursor:pointer;display:inline-flex;font:var(--ids_textStyle_f02_s16_h24_wbd);justify-content:center;min-height:var(--ids_size_general_48x);text-decoration:none}@media (pointer: coarse){.ids-action-button,:host.ids-action-button{outline:0!important}.ids-action-button:focus,:host.ids-action-button:focus{outline:0!important}}@media (pointer: coarse) and (pointer: fine){.ids-action-button:focus-visible,.ids-action-button:focus.focus-visible,:host.ids-action-button:focus-visible,:host.ids-action-button:focus.focus-visible{outline:0!important}}@media (pointer: fine){.ids-action-button:focus-visible,.ids-action-button:focus.focus-visible,:host.ids-action-button:focus-visible,:host.ids-action-button:focus.focus-visible{outline:revert!important}}@media (pointer: fine) and (pointer: fine){.ids-action-button:focus-visible,.ids-action-button:focus.focus-visible,:host.ids-action-button:focus-visible,:host.ids-action-button:focus.focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}}.js-no-flexbox-gap .ids-action-button,.js-no-flexbox-gap :host.ids-action-button{white-space:pre}.ids-action-button--small,:host.ids-action-button--small{font:var(--ids_textStyle_f02_s14_h20_wbd)}.ids-action-button--small .ids-icon,:host.ids-action-button--small .ids-icon{font:var(--ids_textStyle_icon_small)}.ids-action-button--small ::ng-deep .ids-icon,:host.ids-action-button--small ::ng-deep .ids-icon{font:var(--ids_textStyle_icon_small)}.ids-action-button:disabled,.ids-action-button[aria-disabled=true],:host.ids-action-button:disabled,:host.ids-action-button[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){.ids-action-button:hover:not(:disabled):not([aria-disabled=true]),.ids-action-button:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-action-button:hover:not(:disabled):not([aria-disabled=true]),:host.ids-action-button:focus-visible:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_primary_variant)}}.ids-action-button:active:not(:disabled):not([aria-disabled=true]),:host.ids-action-button:active:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_primary_variant)}.ids-action-button--neutral,:host.ids-action-button--neutral{color:var(--ids_color_action_neutral_base)}@media (hover: hover) and (pointer: fine){.ids-action-button--neutral:hover:not(:disabled):not([aria-disabled=true]),.ids-action-button--neutral:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-action-button--neutral:hover:not(:disabled):not([aria-disabled=true]),:host.ids-action-button--neutral:focus-visible:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_neutral_variant)}}.ids-action-button--neutral:active:not(:disabled):not([aria-disabled=true]),:host.ids-action-button--neutral:active:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_neutral_variant)}.ids-action-button--secondary,:host.ids-action-button--secondary{color:var(--ids_color_action_secondary_base)}@media (hover: hover) and (pointer: fine){.ids-action-button--secondary:hover:not(:disabled):not([aria-disabled=true]),.ids-action-button--secondary:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-action-button--secondary:hover:not(:disabled):not([aria-disabled=true]),:host.ids-action-button--secondary:focus-visible:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_secondary_variant)}}.ids-action-button--secondary:active:not(:disabled):not([aria-disabled=true]),:host.ids-action-button--secondary:active:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_secondary_variant)}.ids-action-button--on-brand,:host.ids-action-button--on-brand{color:var(--ids_color_contrast_onBrand_primary)}.ids-action-button--on-brand:disabled,.ids-action-button--on-brand[aria-disabled=true],:host.ids-action-button--on-brand:disabled,:host.ids-action-button--on-brand[aria-disabled=true]{color:var(--ids_color_contrast_onBrand_primary_medium)}@media (hover: hover) and (pointer: fine){.ids-action-button--on-brand:hover:not(:disabled):not([aria-disabled=true]),.ids-action-button--on-brand:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-action-button--on-brand:hover:not(:disabled):not([aria-disabled=true]),:host.ids-action-button--on-brand:focus-visible:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_contrast_onBrand_primary_strong)}}.ids-action-button--on-brand:active:not(:disabled):not([aria-disabled=true]),:host.ids-action-button--on-brand:active:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_contrast_onBrand_primary_strong)}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsActionButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: '[idsActionButton]', template: '<ng-content></ng-content>', host: {
                        '[class.ids-action-button]': 'true',
                        '[class.ids-action-button--neutral]': 'variant === "neutral"',
                        '[class.ids-action-button--secondary]': 'variant === "secondary"',
                        '[class.ids-action-button--on-brand]': 'contrast === "onBrand"',
                        '[class.ids-action-button--small]': 'size === "S"',
                    }, standalone: true, styles: [".ids-action-button,:host.ids-action-button{all:unset;all:revert;box-sizing:border-box;padding:0;-webkit-user-select:none;user-select:none;gap:var(--ids_spacing_1x);align-items:center;background-color:transparent;border:0;color:var(--ids_color_action_primary_base);cursor:pointer;display:inline-flex;font:var(--ids_textStyle_f02_s16_h24_wbd);justify-content:center;min-height:var(--ids_size_general_48x);text-decoration:none}@media (pointer: coarse){.ids-action-button,:host.ids-action-button{outline:0!important}.ids-action-button:focus,:host.ids-action-button:focus{outline:0!important}}@media (pointer: coarse) and (pointer: fine){.ids-action-button:focus-visible,.ids-action-button:focus.focus-visible,:host.ids-action-button:focus-visible,:host.ids-action-button:focus.focus-visible{outline:0!important}}@media (pointer: fine){.ids-action-button:focus-visible,.ids-action-button:focus.focus-visible,:host.ids-action-button:focus-visible,:host.ids-action-button:focus.focus-visible{outline:revert!important}}@media (pointer: fine) and (pointer: fine){.ids-action-button:focus-visible,.ids-action-button:focus.focus-visible,:host.ids-action-button:focus-visible,:host.ids-action-button:focus.focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}}.js-no-flexbox-gap .ids-action-button,.js-no-flexbox-gap :host.ids-action-button{white-space:pre}.ids-action-button--small,:host.ids-action-button--small{font:var(--ids_textStyle_f02_s14_h20_wbd)}.ids-action-button--small .ids-icon,:host.ids-action-button--small .ids-icon{font:var(--ids_textStyle_icon_small)}.ids-action-button--small ::ng-deep .ids-icon,:host.ids-action-button--small ::ng-deep .ids-icon{font:var(--ids_textStyle_icon_small)}.ids-action-button:disabled,.ids-action-button[aria-disabled=true],:host.ids-action-button:disabled,:host.ids-action-button[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){.ids-action-button:hover:not(:disabled):not([aria-disabled=true]),.ids-action-button:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-action-button:hover:not(:disabled):not([aria-disabled=true]),:host.ids-action-button:focus-visible:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_primary_variant)}}.ids-action-button:active:not(:disabled):not([aria-disabled=true]),:host.ids-action-button:active:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_primary_variant)}.ids-action-button--neutral,:host.ids-action-button--neutral{color:var(--ids_color_action_neutral_base)}@media (hover: hover) and (pointer: fine){.ids-action-button--neutral:hover:not(:disabled):not([aria-disabled=true]),.ids-action-button--neutral:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-action-button--neutral:hover:not(:disabled):not([aria-disabled=true]),:host.ids-action-button--neutral:focus-visible:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_neutral_variant)}}.ids-action-button--neutral:active:not(:disabled):not([aria-disabled=true]),:host.ids-action-button--neutral:active:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_neutral_variant)}.ids-action-button--secondary,:host.ids-action-button--secondary{color:var(--ids_color_action_secondary_base)}@media (hover: hover) and (pointer: fine){.ids-action-button--secondary:hover:not(:disabled):not([aria-disabled=true]),.ids-action-button--secondary:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-action-button--secondary:hover:not(:disabled):not([aria-disabled=true]),:host.ids-action-button--secondary:focus-visible:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_secondary_variant)}}.ids-action-button--secondary:active:not(:disabled):not([aria-disabled=true]),:host.ids-action-button--secondary:active:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_secondary_variant)}.ids-action-button--on-brand,:host.ids-action-button--on-brand{color:var(--ids_color_contrast_onBrand_primary)}.ids-action-button--on-brand:disabled,.ids-action-button--on-brand[aria-disabled=true],:host.ids-action-button--on-brand:disabled,:host.ids-action-button--on-brand[aria-disabled=true]{color:var(--ids_color_contrast_onBrand_primary_medium)}@media (hover: hover) and (pointer: fine){.ids-action-button--on-brand:hover:not(:disabled):not([aria-disabled=true]),.ids-action-button--on-brand:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-action-button--on-brand:hover:not(:disabled):not([aria-disabled=true]),:host.ids-action-button--on-brand:focus-visible:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_contrast_onBrand_primary_strong)}}.ids-action-button--on-brand:active:not(:disabled):not([aria-disabled=true]),:host.ids-action-button--on-brand:active:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_contrast_onBrand_primary_strong)}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { variant: [{
                type: Input
            }], contrast: [{
                type: Input
            }], size: [{
                type: Input
            }] } });

class IdsActionButtonModule {
}
IdsActionButtonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsActionButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsActionButtonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsActionButtonModule, imports: [IdsActionButtonComponent], exports: [IdsActionButtonComponent] });
IdsActionButtonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsActionButtonModule, imports: [IdsActionButtonComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsActionButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsActionButtonComponent],
                    exports: [IdsActionButtonComponent],
                }]
        }] });

/**
 * Os botões permitem que o usuário realize ações e façam escolhas com um único toque.
 *
 * *Buttons allow the user to perform actions and make choices with a single tap.*
 *
 * **Module:**
 *
 * `import { IdsIconButtonModule } from '@ids/angular';`
 *
 * **Componente:**
 *
 * `import { IdsIconButtonComponent } from '@ids/angular';`
 */
class IdsIconButtonComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.isMobile = platform.isMobile;
    }
    ngOnInit() {
        // caso o componente receba [attr.title] ou [attr.aria-label] via binding
        // o valor não cai no @Input(), então é preciso pegar o valor diretamente do elemento
        // e jogar na variável.
        this.title = this.elementRef.nativeElement.getAttribute('title');
        this.ariaLabel = this.elementRef.nativeElement.getAttribute('aria-label');
    }
    ngAfterContentInit() {
        if (this.icon) {
            this.icon.contrast = this.contrast;
        }
    }
}
IdsIconButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsIconButtonComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
IdsIconButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsIconButtonComponent, isStandalone: true, selector: "[idsIconButton]", inputs: { variant: "variant", contrast: "contrast", size: "size", title: "title", ariaLabel: ["aria-label", "ariaLabel"] }, host: { properties: { "class.ids-icon-button": "true", "class.ids-icon-button--neutral": "variant === \"neutral\"", "class.ids-icon-button--secondary": "variant === \"secondary\"", "class.ids-icon-button--on-brand": "contrast === \"onBrand\"", "class.ids-icon-button--small": "size === \"S\"", "class.ids-icon-button--large": "size === \"L\"", "class.ids-icon-button--xlarge": "size === \"XL\"", "attr.title": "!isMobile ? title : null", "attr.aria-label": "ariaLabel || title" } }, queries: [{ propertyName: "icon", first: true, predicate: IdsIconComponent, descendants: true }], ngImport: i0, template: '<ng-content></ng-content>', isInline: true, styles: [".ids-icon-button,:host.ids-icon-button{all:unset;all:revert;box-sizing:border-box;padding:0;-webkit-user-select:none;user-select:none;align-items:center;color:inherit;display:inline-flex;flex-direction:column;flex-shrink:0;font:var(--ids_textStyle_icon_medium);font-feature-settings:\"liga\",\"dlig\";-webkit-font-smoothing:antialiased;font-style:normal;font-variant-ligatures:discretionary-ligatures;height:var(--ids_size_general_24x);justify-content:center;letter-spacing:0;overflow:hidden;text-rendering:optimizelegibility;text-transform:none;text-transform:initial;width:var(--ids_size_general_24x);background-color:transparent;border:0;color:var(--ids_color_action_primary_base);cursor:pointer;height:var(--ids_size_general_48x);padding:var(--ids_spacing_3x);width:var(--ids_size_general_48x)}@media (pointer: coarse){.ids-icon-button,:host.ids-icon-button{outline:0!important}.ids-icon-button:focus,:host.ids-icon-button:focus{outline:0!important}}@media (pointer: coarse) and (pointer: fine){.ids-icon-button:focus-visible,.ids-icon-button:focus.focus-visible,:host.ids-icon-button:focus-visible,:host.ids-icon-button:focus.focus-visible{outline:0!important}}@media (pointer: fine){.ids-icon-button:focus-visible,.ids-icon-button:focus.focus-visible,:host.ids-icon-button:focus-visible,:host.ids-icon-button:focus.focus-visible{outline:revert!important}}@media (pointer: fine) and (pointer: fine){.ids-icon-button:focus-visible,.ids-icon-button:focus.focus-visible,:host.ids-icon-button:focus-visible,:host.ids-icon-button:focus.focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}}.ids-icon-button:disabled,.ids-icon-button[aria-disabled=true],:host.ids-icon-button:disabled,:host.ids-icon-button[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){.ids-icon-button:hover:not(:disabled):not([aria-disabled=true]),.ids-icon-button:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-icon-button:hover:not(:disabled):not([aria-disabled=true]),:host.ids-icon-button:focus-visible:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_primary_variant)}}.ids-icon-button:active:not(:disabled):not([aria-disabled=true]),:host.ids-icon-button:active:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_primary_variant)}.ids-icon-button--neutral,:host.ids-icon-button--neutral{color:var(--ids_color_action_neutral_base)}@media (hover: hover) and (pointer: fine){.ids-icon-button--neutral:hover:not(:disabled):not([aria-disabled=true]),.ids-icon-button--neutral:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-icon-button--neutral:hover:not(:disabled):not([aria-disabled=true]),:host.ids-icon-button--neutral:focus-visible:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_neutral_variant)}}.ids-icon-button--neutral:active:not(:disabled):not([aria-disabled=true]),:host.ids-icon-button--neutral:active:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_neutral_variant)}.ids-icon-button--secondary,:host.ids-icon-button--secondary{color:var(--ids_color_action_secondary_base)}@media (hover: hover) and (pointer: fine){.ids-icon-button--secondary:hover:not(:disabled):not([aria-disabled=true]),.ids-icon-button--secondary:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-icon-button--secondary:hover:not(:disabled):not([aria-disabled=true]),:host.ids-icon-button--secondary:focus-visible:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_secondary_variant)}}.ids-icon-button--secondary:active:not(:disabled):not([aria-disabled=true]),:host.ids-icon-button--secondary:active:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_secondary_variant)}.ids-icon-button--on-brand,:host.ids-icon-button--on-brand{color:var(--ids_color_contrast_onBrand_primary)}.ids-icon-button--on-brand:disabled,.ids-icon-button--on-brand[aria-disabled=true],:host.ids-icon-button--on-brand:disabled,:host.ids-icon-button--on-brand[aria-disabled=true]{color:var(--ids_color_contrast_onBrand_primary_medium)}@media (hover: hover) and (pointer: fine){.ids-icon-button--on-brand:hover:not(:disabled):not([aria-disabled=true]),.ids-icon-button--on-brand:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-icon-button--on-brand:hover:not(:disabled):not([aria-disabled=true]),:host.ids-icon-button--on-brand:focus-visible:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_contrast_onBrand_primary_strong)}}.ids-icon-button--on-brand:active:not(:disabled):not([aria-disabled=true]),:host.ids-icon-button--on-brand:active:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_contrast_onBrand_primary_strong)}.ids-icon-button--small,:host.ids-icon-button--small{font:var(--ids_textStyle_icon_small)}.ids-icon-button--large,:host.ids-icon-button--large{font:var(--ids_textStyle_icon_large)}.ids-icon-button--xlarge,:host.ids-icon-button--xlarge{font:var(--ids_textStyle_icon_xLarge)}\n"], dependencies: [{ kind: "ngmodule", type: IdsIconModule }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsIconButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: '[idsIconButton]', template: '<ng-content></ng-content>', host: {
                        '[class.ids-icon-button]': 'true',
                        '[class.ids-icon-button--neutral]': 'variant === "neutral"',
                        '[class.ids-icon-button--secondary]': 'variant === "secondary"',
                        '[class.ids-icon-button--on-brand]': 'contrast === "onBrand"',
                        '[class.ids-icon-button--small]': 'size === "S"',
                        '[class.ids-icon-button--large]': 'size === "L"',
                        '[class.ids-icon-button--xlarge]': 'size === "XL"',
                        '[attr.title]': '!isMobile ? title : null',
                        '[attr.aria-label]': 'ariaLabel || title',
                    }, standalone: true, imports: [IdsIconModule], styles: [".ids-icon-button,:host.ids-icon-button{all:unset;all:revert;box-sizing:border-box;padding:0;-webkit-user-select:none;user-select:none;align-items:center;color:inherit;display:inline-flex;flex-direction:column;flex-shrink:0;font:var(--ids_textStyle_icon_medium);font-feature-settings:\"liga\",\"dlig\";-webkit-font-smoothing:antialiased;font-style:normal;font-variant-ligatures:discretionary-ligatures;height:var(--ids_size_general_24x);justify-content:center;letter-spacing:0;overflow:hidden;text-rendering:optimizelegibility;text-transform:none;text-transform:initial;width:var(--ids_size_general_24x);background-color:transparent;border:0;color:var(--ids_color_action_primary_base);cursor:pointer;height:var(--ids_size_general_48x);padding:var(--ids_spacing_3x);width:var(--ids_size_general_48x)}@media (pointer: coarse){.ids-icon-button,:host.ids-icon-button{outline:0!important}.ids-icon-button:focus,:host.ids-icon-button:focus{outline:0!important}}@media (pointer: coarse) and (pointer: fine){.ids-icon-button:focus-visible,.ids-icon-button:focus.focus-visible,:host.ids-icon-button:focus-visible,:host.ids-icon-button:focus.focus-visible{outline:0!important}}@media (pointer: fine){.ids-icon-button:focus-visible,.ids-icon-button:focus.focus-visible,:host.ids-icon-button:focus-visible,:host.ids-icon-button:focus.focus-visible{outline:revert!important}}@media (pointer: fine) and (pointer: fine){.ids-icon-button:focus-visible,.ids-icon-button:focus.focus-visible,:host.ids-icon-button:focus-visible,:host.ids-icon-button:focus.focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}}.ids-icon-button:disabled,.ids-icon-button[aria-disabled=true],:host.ids-icon-button:disabled,:host.ids-icon-button[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){.ids-icon-button:hover:not(:disabled):not([aria-disabled=true]),.ids-icon-button:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-icon-button:hover:not(:disabled):not([aria-disabled=true]),:host.ids-icon-button:focus-visible:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_primary_variant)}}.ids-icon-button:active:not(:disabled):not([aria-disabled=true]),:host.ids-icon-button:active:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_primary_variant)}.ids-icon-button--neutral,:host.ids-icon-button--neutral{color:var(--ids_color_action_neutral_base)}@media (hover: hover) and (pointer: fine){.ids-icon-button--neutral:hover:not(:disabled):not([aria-disabled=true]),.ids-icon-button--neutral:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-icon-button--neutral:hover:not(:disabled):not([aria-disabled=true]),:host.ids-icon-button--neutral:focus-visible:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_neutral_variant)}}.ids-icon-button--neutral:active:not(:disabled):not([aria-disabled=true]),:host.ids-icon-button--neutral:active:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_neutral_variant)}.ids-icon-button--secondary,:host.ids-icon-button--secondary{color:var(--ids_color_action_secondary_base)}@media (hover: hover) and (pointer: fine){.ids-icon-button--secondary:hover:not(:disabled):not([aria-disabled=true]),.ids-icon-button--secondary:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-icon-button--secondary:hover:not(:disabled):not([aria-disabled=true]),:host.ids-icon-button--secondary:focus-visible:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_secondary_variant)}}.ids-icon-button--secondary:active:not(:disabled):not([aria-disabled=true]),:host.ids-icon-button--secondary:active:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_secondary_variant)}.ids-icon-button--on-brand,:host.ids-icon-button--on-brand{color:var(--ids_color_contrast_onBrand_primary)}.ids-icon-button--on-brand:disabled,.ids-icon-button--on-brand[aria-disabled=true],:host.ids-icon-button--on-brand:disabled,:host.ids-icon-button--on-brand[aria-disabled=true]{color:var(--ids_color_contrast_onBrand_primary_medium)}@media (hover: hover) and (pointer: fine){.ids-icon-button--on-brand:hover:not(:disabled):not([aria-disabled=true]),.ids-icon-button--on-brand:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-icon-button--on-brand:hover:not(:disabled):not([aria-disabled=true]),:host.ids-icon-button--on-brand:focus-visible:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_contrast_onBrand_primary_strong)}}.ids-icon-button--on-brand:active:not(:disabled):not([aria-disabled=true]),:host.ids-icon-button--on-brand:active:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_contrast_onBrand_primary_strong)}.ids-icon-button--small,:host.ids-icon-button--small{font:var(--ids_textStyle_icon_small)}.ids-icon-button--large,:host.ids-icon-button--large{font:var(--ids_textStyle_icon_large)}.ids-icon-button--xlarge,:host.ids-icon-button--xlarge{font:var(--ids_textStyle_icon_xLarge)}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { variant: [{
                type: Input
            }], contrast: [{
                type: Input
            }], size: [{
                type: Input
            }], title: [{
                type: Input
            }], ariaLabel: [{
                type: Input,
                args: ['aria-label']
            }], icon: [{
                type: ContentChild,
                args: [IdsIconComponent]
            }] } });

class IdsIconButtonModule {
}
IdsIconButtonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsIconButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsIconButtonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsIconButtonModule, imports: [IdsIconButtonComponent], exports: [IdsIconButtonComponent] });
IdsIconButtonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsIconButtonModule, imports: [IdsIconButtonComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsIconButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsIconButtonComponent],
                    exports: [IdsIconButtonComponent],
                }]
        }] });

/**
 * O alert é composto por três variações referentes ao status de feedback: Success, Error e Neutral. Cada um deles geralmente é utilizado para notificar erros internos do sistema. Podem também conter ações contextuais que guiam o usuário a outras telas e/ou serviços.
 *
 * *The alert is composed of three variations referring to the feedback status: Success, Error and Neutral. Each of these is generally used to report internal system errors. They may also contain contextual actions that guide the user to other screens and/or services.*
 *
 * **Module:**
 *
 * `import { IdsAlertModule, IdsOverlayOriginModule } from '@ids/angular';`
 *
 * **Component:**
 *
 * `import { IdsAlertComponent, IdsOverlayOriginDirective } from '@ids/angular';`
 *
 */
class IdsAlertComponent {
    /**
     * Elemento para definir o foco quando o Alert for fechado
     *
     * Definir manualmente o origin não é obrigatório,
     * o Alert já detecta o elemento que disparou o evento de abertura do Alert
     * e retorna o foco para ele quando o Alert fechar.
     */
    set origin(value) {
        if (value instanceof CdkOverlayOrigin) {
            this._origin = value;
            return;
        }
        this._origin = new CdkOverlayOrigin(new ElementRef(value));
    }
    get origin() {
        return this._origin || this._autoDetectedOrigin;
    }
    /**
     * Define se o componente estará visível em tela (aberto).
     *
     * *Defines whether the component will be visible on screen (opened)*
     */
    set show(value) {
        const closing = !value && this._show;
        if (closing) {
            this._show = value;
            setTimeout(() => {
                this.visible = value;
            }, 200);
            this._liveAnnouncer.announce(this.closeMessage, 200);
            return;
        }
        if (value) {
            this._autoDetectedOrigin = new CdkOverlayOrigin(new ElementRef(document.activeElement));
        }
        this.visible = value;
        setTimeout(() => {
            this._show = value;
        });
    }
    get show() {
        return this._show;
    }
    get classes() {
        return {
            'ids-alert': true,
            'ids-alert--success': this.variant === 'success',
            'ids-alert--error': this.variant === 'error',
            'ids-alert--closing': !this._show,
        };
    }
    get iconName() {
        return ALERT_ICONS[this.variant];
    }
    constructor(_liveAnnouncer, _renderer) {
        this._liveAnnouncer = _liveAnnouncer;
        this._renderer = _renderer;
        this._destroy = new Subject();
        this.visible = this.show;
        /**
         * Label de acessibilidade para o botão fechar, pode ser customizada, visando outros idiomas
         *
         * *Accessibility label for the close button, can be customized for other languages*
         */
        this.closeLabel = 'fechar';
        /**
         * Texto que será lido no fechamento do componente
         *
         * *Text to be read when the component closes*
         */
        this.closeMessage = 'fechado';
        /**
         * Evento emitido quando o alert é fechado
         *
         * *Event emitter when alert is closed*
         */
        this.close = new EventEmitter();
        /**
         * Evento emitido quando o alert é fechado
         *
         * *Event emitter when alert is closed*
         */
        this.showChange = new EventEmitter();
        this.hostClass = null;
    }
    _getElementToFocus() {
        const contentElement = this.alertContentList.get(0);
        if (!contentElement) {
            return null;
        }
        const elementToFocus = contentElement.nativeElement.firstElementChild || contentElement.nativeElement;
        this._renderer.setAttribute(elementToFocus, 'tabindex', '-1');
        return elementToFocus;
    }
    ngAfterViewInit() {
        this.alertContentList.changes
            .pipe(takeUntil(this._destroy))
            .subscribe((elements) => {
            if (elements.length === 0 || !!this.skipFocus) {
                return;
            }
            const elementToFocus = this.header
                ? this.alertTitle?.nativeElement
                : this._getElementToFocus();
            if (!elementToFocus) {
                return;
            }
            setTimeout(() => {
                elementToFocus.focus();
            }, 250);
        });
    }
    ngOnDestroy() {
        this._destroy.next();
        this._destroy.complete();
    }
    onClose() {
        this.origin?.elementRef?.nativeElement?.focus();
        this.showChange.emit(!this.show);
        this.close.emit();
    }
}
IdsAlertComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAlertComponent, deps: [{ token: i1$1.LiveAnnouncer }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
IdsAlertComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsAlertComponent, isStandalone: true, selector: "ids-alert", inputs: { closeLabel: "closeLabel", closeMessage: "closeMessage", icon: "icon", header: "header", origin: "origin", show: "show", skipFocus: "skipFocus", variant: "variant" }, outputs: { close: "close", showChange: "showChange" }, host: { properties: { "class": "this.hostClass" } }, viewQueries: [{ propertyName: "alertTitle", first: true, predicate: ["alertTitleRef"], descendants: true }, { propertyName: "alertContentList", predicate: ["alertContentRef"], descendants: true }], ngImport: i0, template: "<div *ngIf=\"visible\" [class]=\"classes\">\n  <div *ngIf=\"icon\" class=\"ids-alert__icon\">\n    <ids-icon size=\"L\">\n      {{ iconName || 'informacao_outline' }}\n    </ids-icon>\n  </div>\n\n  <div class=\"ids-alert__content\">\n    <h2 #alertTitleRef tabindex=\"-1\" *ngIf=\"header\" class=\"ids-alert__title\">{{ header }}</h2>\n    <section #alertContentRef><ng-content></ng-content></section>\n  </div>\n\n  <button\n    idsIconButton\n    variant=\"neutral\"\n    size=\"S\"\n    type=\"button\"\n    [attr.aria-label]=\"closeLabel\"\n    (click)=\"onClose()\"\n  >\n    fechar\n  </button>\n</div>\n", styles: [".ids-animation-fade-in-start{opacity:0}.ids-animation-fade-in-moderate-end{opacity:1;transition:opacity .2s cubic-bezier(.42,0,.58,1)}.ids-animation-fade-out-start{opacity:1}.ids-animation-fade-out-moderate-output-end{opacity:0;transition:opacity 275ms cubic-bezier(.42,0,.58,1)}.ids-animation-scale-x-down{transform:scaleX(0);transform:scaleX(var(--ids-scale-x-down, 0))}.ids-animation-scale-x-up{transform:scaleX(1);transform:scaleX(var(--ids-scale-x-up, 100%))}.ids-animation-time-transform-slow{transition:transform 2s cubic-bezier(0,0,.58,1)}.ids-animation-width-down{width:0;width:var(--ids-width-down, 0)}.ids-animation-width-up{width:100%;width:var(--ids-width-up, 100%)}.ids-animation-time-width-slow{transition:width 2s cubic-bezier(0,0,.58,1)}.ids-motion-none,.ids-motion-none:before,.ids-motion-none:after,.ids-motion-none *,.ids-motion-none *:before,.ids-motion-none *:after{animation:none!important;transition:none!important}.ids-alert{align-items:flex-start;background-color:var(--ids_color_bg_base);border:var(--ids_size_border_small) solid var(--ids_color_feedback_neutral);border-radius:var(--ids_size_cornerRadius_card_02);color:var(--ids_color_text_body_01);display:flex;font:var(--ids_textStyle_f02_s14_h20_wrg);overflow:hidden;transition:transform .2s cubic-bezier(.42,0,.58,1),opacity .2s linear;width:100%}.ids-alert__content{padding:var(--ids_size_general_16x) 0 var(--ids_size_general_16x) var(--ids_size_general_16x);text-align:left;width:100%}.ids-alert__content>p{font:var(--ids_textStyle_f02_s14_h20_wrg)}.ids-alert__icon{align-self:center;font-size:0;line-height:1;padding-left:var(--ids_size_general_16x)}.ids-alert .ids-icon-button{border-radius:inherit}.ids-alert ::ng-deep .ids-icon-button{border-radius:inherit}.ids-alert__title{color:var(--ids_color_feedback_neutral);font:var(--ids_textStyle_f02_s14_h20_wbd)}.ids-alert--success{border-color:var(--ids_color_feedback_success)}.ids-alert--success .ids-alert__icon .ids-icon{color:var(--ids_color_feedback_success)}.ids-alert--error{border-color:var(--ids_color_feedback_error)}.ids-alert--error .ids-alert__icon .ids-icon{color:var(--ids_color_feedback_error)}.ids-alert--closing{opacity:0;transform:scale(.8)}:host(ids-alert){display:block}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: IdsIconModule }, { kind: "component", type: IdsIconComponent, selector: "ids-icon", inputs: ["size", "variant", "contrast"] }, { kind: "ngmodule", type: IdsIconButtonModule }, { kind: "component", type: IdsIconButtonComponent, selector: "[idsIconButton]", inputs: ["variant", "contrast", "size", "title", "aria-label"] }] });
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object)
], IdsAlertComponent.prototype, "icon", void 0);
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], IdsAlertComponent.prototype, "show", null);
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object)
], IdsAlertComponent.prototype, "skipFocus", void 0);
__decorate([
    Memo(['variant', '_show']),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], IdsAlertComponent.prototype, "classes", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAlertComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-alert', standalone: true, imports: [CommonModule, IdsIconModule, IdsIconButtonModule], template: "<div *ngIf=\"visible\" [class]=\"classes\">\n  <div *ngIf=\"icon\" class=\"ids-alert__icon\">\n    <ids-icon size=\"L\">\n      {{ iconName || 'informacao_outline' }}\n    </ids-icon>\n  </div>\n\n  <div class=\"ids-alert__content\">\n    <h2 #alertTitleRef tabindex=\"-1\" *ngIf=\"header\" class=\"ids-alert__title\">{{ header }}</h2>\n    <section #alertContentRef><ng-content></ng-content></section>\n  </div>\n\n  <button\n    idsIconButton\n    variant=\"neutral\"\n    size=\"S\"\n    type=\"button\"\n    [attr.aria-label]=\"closeLabel\"\n    (click)=\"onClose()\"\n  >\n    fechar\n  </button>\n</div>\n", styles: [".ids-animation-fade-in-start{opacity:0}.ids-animation-fade-in-moderate-end{opacity:1;transition:opacity .2s cubic-bezier(.42,0,.58,1)}.ids-animation-fade-out-start{opacity:1}.ids-animation-fade-out-moderate-output-end{opacity:0;transition:opacity 275ms cubic-bezier(.42,0,.58,1)}.ids-animation-scale-x-down{transform:scaleX(0);transform:scaleX(var(--ids-scale-x-down, 0))}.ids-animation-scale-x-up{transform:scaleX(1);transform:scaleX(var(--ids-scale-x-up, 100%))}.ids-animation-time-transform-slow{transition:transform 2s cubic-bezier(0,0,.58,1)}.ids-animation-width-down{width:0;width:var(--ids-width-down, 0)}.ids-animation-width-up{width:100%;width:var(--ids-width-up, 100%)}.ids-animation-time-width-slow{transition:width 2s cubic-bezier(0,0,.58,1)}.ids-motion-none,.ids-motion-none:before,.ids-motion-none:after,.ids-motion-none *,.ids-motion-none *:before,.ids-motion-none *:after{animation:none!important;transition:none!important}.ids-alert{align-items:flex-start;background-color:var(--ids_color_bg_base);border:var(--ids_size_border_small) solid var(--ids_color_feedback_neutral);border-radius:var(--ids_size_cornerRadius_card_02);color:var(--ids_color_text_body_01);display:flex;font:var(--ids_textStyle_f02_s14_h20_wrg);overflow:hidden;transition:transform .2s cubic-bezier(.42,0,.58,1),opacity .2s linear;width:100%}.ids-alert__content{padding:var(--ids_size_general_16x) 0 var(--ids_size_general_16x) var(--ids_size_general_16x);text-align:left;width:100%}.ids-alert__content>p{font:var(--ids_textStyle_f02_s14_h20_wrg)}.ids-alert__icon{align-self:center;font-size:0;line-height:1;padding-left:var(--ids_size_general_16x)}.ids-alert .ids-icon-button{border-radius:inherit}.ids-alert ::ng-deep .ids-icon-button{border-radius:inherit}.ids-alert__title{color:var(--ids_color_feedback_neutral);font:var(--ids_textStyle_f02_s14_h20_wbd)}.ids-alert--success{border-color:var(--ids_color_feedback_success)}.ids-alert--success .ids-alert__icon .ids-icon{color:var(--ids_color_feedback_success)}.ids-alert--error{border-color:var(--ids_color_feedback_error)}.ids-alert--error .ids-alert__icon .ids-icon{color:var(--ids_color_feedback_error)}.ids-alert--closing{opacity:0;transform:scale(.8)}:host(ids-alert){display:block}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.LiveAnnouncer }, { type: i0.Renderer2 }]; }, propDecorators: { closeLabel: [{
                type: Input
            }], closeMessage: [{
                type: Input
            }], icon: [{
                type: Input
            }], header: [{
                type: Input
            }], origin: [{
                type: Input
            }], show: [{
                type: Input
            }], skipFocus: [{
                type: Input
            }], variant: [{
                type: Input
            }], close: [{
                type: Output
            }], showChange: [{
                type: Output
            }], hostClass: [{
                type: HostBinding,
                args: ['class']
            }], alertContentList: [{
                type: ViewChildren,
                args: ['alertContentRef']
            }], alertTitle: [{
                type: ViewChild,
                args: ['alertTitleRef']
            }], classes: [] } });

class IdsAlertModule {
}
IdsAlertModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAlertModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsAlertModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsAlertModule, imports: [IdsAlertComponent], exports: [IdsAlertComponent] });
IdsAlertModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAlertModule, imports: [IdsAlertComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAlertModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsAlertComponent],
                    exports: [IdsAlertComponent],
                }]
        }] });

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const noop = (...args) => args;
/**
 * @internal
 */
const FormAcessorMixin = (base) => {
    class FormAcessor extends base {
        /** Emite o valor que veio do formulário reativo */
        get viewModelChange$() {
            return this._viewModelChange.asObservable();
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        constructor(...args) {
            super(...args);
            this.formState = new Subject();
            this._disabled = false;
            this._focused = false;
            this._active = false;
            this._updateFirstOnBlur = false;
            this.formAcessorChanged = noop;
            this.formAcessorTouched = noop;
            this._destroy = new Subject();
            this._viewModelChange = new BehaviorSubject(this.value);
            if (this.ngControl) {
                this.ngControl.valueAccessor = this;
            }
            this.errorState = this.formState.pipe(filter(() => Boolean(this.ngControl)), map(() => Boolean((this.ngControl.touched || this.ngControl.dirty) &&
                this.ngControl.invalid &&
                (!this.updateFirstOnBlur || (this.updateFirstOnBlur && this.ngControl.touched)))));
        }
        /**
         * @internal
         */
        ngOnDestroy() {
            this._destroy.next();
            this._destroy.complete();
            this.formState.complete();
        }
        /**
         * Valor do componente
         *
         * *Value of the component*
         */
        set value(newValue) {
            if (newValue !== this._value) {
                this._value = newValue;
                this.formAcessorChanged(newValue);
            }
        }
        get value() {
            return this._value;
        }
        /**
         * Desabilita a edição do campo
         *
         * *Disables the field editing*
         */
        set disabled(disabled) {
            this._disabled = enforceBoolean(disabled);
        }
        get disabled() {
            return this._disabled;
        }
        set focused(focused) {
            this._focused = focused;
        }
        get focused() {
            return this._focused;
        }
        set active(active) {
            this._active = active;
        }
        get active() {
            return this._active;
        }
        set updateFirstOnBlur(updateFirstOnBlur) {
            this._updateFirstOnBlur = updateFirstOnBlur;
        }
        get updateFirstOnBlur() {
            return this._updateFirstOnBlur;
        }
        formAcessorHandleChange() {
            // TODO: Implementar uma melhor forma de validar as mudanças asyncronas
            setTimeout(() => {
                this.formState.next();
            }, 0);
        }
        formAcessorHandleFocus() {
            this.focused = true;
            this.formState.next();
        }
        formAcessorHandleBlur() {
            this.focused = false;
            this.active = false;
            this.formAcessorTouched();
            this.formState.next();
        }
        writeValue(newValue) {
            if (newValue !== this._value) {
                this.value = newValue;
                this.elementRef.nativeElement.value = newValue;
                this.formAcessorTouched();
                this._viewModelChange.next(newValue);
            }
        }
        registerOnChange(fn) {
            this.formAcessorChanged = (value) => {
                if (this.focused) {
                    this.active = true;
                }
                fn(value);
                this.formState.next();
            };
        }
        registerOnTouched(fn) {
            this.formAcessorTouched = fn;
        }
        setDisabledState(isDisabled) {
            this._disabled = isDisabled;
            this.formState.next();
        }
    }
    FormAcessor.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FormAcessor, deps: "invalid", target: i0.ɵɵFactoryTarget.Directive });
    FormAcessor.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: FormAcessor, inputs: { value: "value", disabled: "disabled" }, usesInheritance: true, ngImport: i0 });
    i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FormAcessor, decorators: [{
                type: Directive
            }], ctorParameters: function () { return [{ type: undefined }]; }, propDecorators: { value: [{
                    type: Input
                }], disabled: [{
                    type: Input
                }] } });
    return FormAcessor;
};

/**
 *
 * @param position Direção que o elemento será posicionado
 ** top: acima do elemento.
 ** bottom: abaixo do elemento.
 ** auto: o posicionamento ocorre para a direção que houver mais espaço na tela.
 * @returns Lista de opções de posições para esta sobreposição.
 */
const defineOpeningPosition = (position) => {
    const bottom = {
        originX: 'start',
        originY: 'bottom',
        overlayX: 'start',
        overlayY: 'top',
    };
    const top = {
        originX: 'start',
        originY: 'top',
        overlayX: 'start',
        overlayY: 'bottom',
    };
    const positions = [];
    const setPosition = {
        top: () => positions.push(top),
        bottom: () => positions.push(bottom),
        auto: () => positions.push(bottom, top),
    };
    setPosition[position]();
    return positions;
};

class IdsFieldBase {
    constructor(ngControl, elementRef, errorState) {
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this.errorState = errorState;
    }
}
// eslint-disable-next-line @angular-eslint/directive-class-suffix
class IdsFieldMixinBase extends FormAcessorMixin(IdsFieldBase) {
    get input$() {
        return fromEvent(this.elementRef.nativeElement, 'input');
    }
    get keydown$() {
        return fromEvent(this.elementRef.nativeElement, 'keydown');
    }
    constructor(ngControl, elementRef) {
        super(ngControl, elementRef);
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this._externalDescribedBy = false;
        this.invalid = null;
        this._controlDescribedBy = null;
        this.ariaLabelledby = null;
        this.ariaLabel = null;
    }
    set controlDescribedBy(value) {
        this._externalDescribedBy = true;
        this._controlDescribedBy = value;
    }
    get controlDescribedBy() {
        return this._controlDescribedBy;
    }
    get controlAriaInvalid() {
        if (platform.os === 'IOS') {
            return null;
        }
        return this.invalid;
    }
    set controlAriaInvalid(value) {
        this.invalid = value;
    }
    get nativeElement() {
        return this.elementRef.nativeElement;
    }
    handleInvalid(invalid) {
        this.controlAriaInvalid = invalid || null;
    }
    handleDescribedby(describedById) {
        if (this._externalDescribedBy) {
            return;
        }
        this._controlDescribedBy = describedById || null;
    }
    focus() {
        this.elementRef.nativeElement.focus();
    }
}
IdsFieldMixinBase.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFieldMixinBase, deps: [{ token: i1$2.NgControl, optional: true, self: true }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
IdsFieldMixinBase.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsFieldMixinBase, selector: "do-not-use-ids-form-control-mixin-base", inputs: { controlDescribedBy: ["aria-describedby", "controlDescribedBy"], ariaLabelledby: ["aria-labelledby", "ariaLabelledby"], ariaLabel: ["aria-label", "ariaLabel"], controlAriaInvalid: ["invalid", "controlAriaInvalid"] }, host: { properties: { "attr.aria-describedby": "this.controlDescribedBy", "attr.aria-labelledby": "this.ariaLabelledby", "attr.aria-label": "this.ariaLabel", "attr.aria-invalid": "this.controlAriaInvalid" } }, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFieldMixinBase, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: 'do-not-use-ids-form-control-mixin-base',
                }]
        }], ctorParameters: function () { return [{ type: i1$2.NgControl, decorators: [{
                    type: Self
                }, {
                    type: Optional
                }] }, { type: i0.ElementRef }]; }, propDecorators: { controlDescribedBy: [{
                type: Input,
                args: ['aria-describedby']
            }, {
                type: HostBinding,
                args: ['attr.aria-describedby']
            }], ariaLabelledby: [{
                type: Input,
                args: ['aria-labelledby']
            }, {
                type: HostBinding,
                args: ['attr.aria-labelledby']
            }], ariaLabel: [{
                type: Input,
                args: ['aria-label']
            }, {
                type: HostBinding,
                args: ['attr.aria-label']
            }], controlAriaInvalid: [{
                type: Input,
                args: ['invalid']
            }, {
                type: HostBinding,
                args: ['attr.aria-invalid']
            }] } });

class IdsFormFieldService {
    constructor() {
        this.classes = [];
        this.listboxOpen = false;
        this._classesSubject = new BehaviorSubject([]);
        this._suffixIconSubject = new BehaviorSubject('');
        this._inputSubject = new Subject();
        this._listboxSubject = new Subject();
        this._formFieldElementSubject = new Subject();
        this._listboxOpenSubject = new Subject();
    }
    emitClasses() {
        this._classesSubject.next(this.classes);
    }
    emitSuffixIcon() {
        this._suffixIconSubject.next(this.suffixIcon);
    }
    emitInput() {
        this._inputSubject.next(this.input);
    }
    emitListbox() {
        this._listboxSubject.next(this.listbox);
    }
    emitFormFieldElement() {
        this._formFieldElementSubject.next(this.formFieldElement);
    }
    emitListboxOpen() {
        this._listboxOpenSubject.next(this.listboxOpen);
    }
    classes$() {
        return this._classesSubject.asObservable();
    }
    suffixIcon$() {
        return this._suffixIconSubject.asObservable();
    }
    input$() {
        return this._inputSubject.asObservable();
    }
    listbox$() {
        return this._listboxSubject.asObservable();
    }
    formFieldElement$() {
        return this._formFieldElementSubject.asObservable();
    }
    listboxOpen$() {
        return this._listboxOpenSubject.asObservable();
    }
    addClass(className) {
        this.classes.push(className);
        this.emitClasses();
    }
    sendSuffixIcon(icon) {
        this.suffixIcon = icon;
        this.emitSuffixIcon();
    }
    sendInput(input) {
        this.input = input;
        this.emitInput();
    }
    sendListbox(listbox) {
        this.listbox = listbox;
        this.emitListbox();
    }
    sendFormFieldElement(formFieldElement) {
        this.formFieldElement = formFieldElement;
        this.emitFormFieldElement();
    }
    sendListboxOpen(listboxOpen) {
        this.listboxOpen = listboxOpen;
        this.emitListboxOpen();
    }
    removeClass(className) {
        this.classes = this.classes.filter((c) => c !== className);
        this.emitClasses();
    }
    removeSuffixIcon() {
        this.suffixIcon = '';
        this.emitSuffixIcon();
    }
}
IdsFormFieldService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormFieldService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
IdsFormFieldService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormFieldService, providedIn: null });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormFieldService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: null,
                }]
        }] });

let NEXT_ID$r = 0;
/**
 *  Componente base para seleção.
 *
 * *Base component for selection.*
 */
class IdsOptionComponent {
    get title() {
        return this.label || null;
    }
    set selected(selected) {
        if (!this._selected && selected) {
            this.selectedChange.emit();
        }
        this._selected = selected;
    }
    get selected() {
        return this._selected;
    }
    set label(label) {
        if (label) {
            this._label = label;
        }
    }
    get label() {
        return this._label || (this.element.nativeElement.textContent || '').trim();
    }
    /**
     * @deprecated Use `label` ao invés de `optionLabel`.
     */
    get optionLabel() {
        return this.label;
    }
    /**
     *  Valor da opção no momento do evento.
     */
    get value() {
        return this._value;
    }
    set value(value) {
        this._value = value;
    }
    /**
     * Indica se a opção ficara desabilitato.
     */
    get disabled() {
        return this._disabled;
    }
    set disabled(disabled) {
        this._disabled = enforceBoolean(disabled);
    }
    /**
     * Indica se a variação small está ligada.
     *
     * *Indicates whether the option will be true.*
     */
    get small() {
        return this._small;
    }
    set small(value) {
        this._small = enforceBoolean(value);
    }
    onClick() {
        this.selectAndClose();
    }
    constructor(element) {
        this.element = element;
        this._destroy = new Subject();
        this.highlighted = false;
        this.showing = true;
        this._selected = false;
        /**
         *  Identificação única da opção.
         */
        this.id = `ids-option-${NEXT_ID$r++}`;
        this._disabled = false;
        this._small = false;
        /**
         * Evento disparado quando houver mudança na opção.
         */
        this.change = new EventEmitter();
        /**
         * Evento disparado quando houver mudança na opção.
         */
        this.selectedChange = new EventEmitter();
    }
    _emitOptionChangeEvent(_close) {
        this.change.emit({ option: this, close: _close });
    }
    show() {
        this.showing = true;
    }
    hide() {
        this.showing = false;
    }
    select(close = false) {
        if (this.disabled) {
            return;
        }
        this.selected = true;
        this._emitOptionChangeEvent(close);
    }
    selectAndClose() {
        this.select(true);
    }
    highlight() {
        this.highlighted = true;
    }
    unhighlight() {
        this.highlighted = false;
    }
    deselect() {
        this.selected = false;
    }
    ngOnDestroy() {
        this._destroy.next();
        this._destroy.complete();
    }
}
IdsOptionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsOptionComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
IdsOptionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsOptionComponent, isStandalone: true, selector: "ids-option", inputs: { selected: "selected", label: "label", id: "id", value: "value", disabled: "disabled", small: "small" }, outputs: { change: "change", selectedChange: "selectedChange" }, host: { listeners: { "click": "onClick()" }, properties: { "attr.id": "id", "attr.role": "\"option\"", "attr.tabindex": "disabled ? \"-1\" : \"0\"", "attr.aria-selected": "selected", "attr.aria-disabled": "disabled", "class.ids-option": "true", "class.ids-option--selected": "selected", "class.ids-option--disabled": "disabled", "class.ids-option--highlighted": "highlighted", "class.ids-option--small": "small", "class.ids-option--hide": "!showing", "attr.title": "this.title" } }, ngImport: i0, template: "<span class=\"ids-option__text\" #option>\n  <ng-content></ng-content>\n</span>\n", styles: [".ids-option,:host.ids-option{align-items:center;background-color:var(--ids_color_bg_base);border-left:var(--ids_size_border_large) solid var(--ids_color_bg_base);color:var(--ids_color_action_neutral_variant);cursor:pointer;display:flex;font:var(--ids_textStyle_label_medium_regular);min-height:var(--ids_size_general_48x);text-align:left}.ids-option:not(.ids-option--small):hover,:host.ids-option:not(.ids-option--small):hover{background-color:var(--ids_color_bg_variant_02);border-left-color:var(--ids_color_bg_variant_02)}.ids-option [aria-selected=true],.ids-option--selected,:host.ids-option [aria-selected=true],:host.ids-option--selected{border-left-color:var(--ids_color_action_primary_variant);font:var(--ids_textStyle_label_medium_bold)}.ids-option [aria-selected=true]:hover,.ids-option--selected:hover,:host.ids-option [aria-selected=true]:hover,:host.ids-option--selected:hover{border-left-color:var(--ids_color_action_primary_variant)}.ids-option [aria-disabled=true],.ids-option--disabled,:host.ids-option [aria-disabled=true],:host.ids-option--disabled{background-color:var(--ids_color_bg_variant_01);border-left-color:var(--ids_color_bg_variant_01);color:var(--ids_color_action_disabled_variant);pointer-events:none}.ids-option--highlighted,:host.ids-option--highlighted{background-color:var(--ids_color_bg_variant_02);border-left-color:var(--ids_color_bg_variant_02)}.ids-option--hide,:host.ids-option--hide{display:none}.ids-option__text,:host.ids-option__text{flex:1;overflow:hidden;padding:var(--ids_size_general_12x) var(--ids_size_general_8x);text-overflow:ellipsis;white-space:nowrap}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsOptionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-option', host: {
                        '[attr.id]': 'id',
                        '[attr.role]': '"option"',
                        '[attr.tabindex]': 'disabled ? "-1" : "0"',
                        '[attr.aria-selected]': 'selected',
                        '[attr.aria-disabled]': 'disabled',
                        '[class.ids-option]': 'true',
                        '[class.ids-option--selected]': 'selected',
                        '[class.ids-option--disabled]': 'disabled',
                        '[class.ids-option--highlighted]': 'highlighted',
                        '[class.ids-option--small]': 'small',
                        '[class.ids-option--hide]': '!showing',
                    }, standalone: true, template: "<span class=\"ids-option__text\" #option>\n  <ng-content></ng-content>\n</span>\n", styles: [".ids-option,:host.ids-option{align-items:center;background-color:var(--ids_color_bg_base);border-left:var(--ids_size_border_large) solid var(--ids_color_bg_base);color:var(--ids_color_action_neutral_variant);cursor:pointer;display:flex;font:var(--ids_textStyle_label_medium_regular);min-height:var(--ids_size_general_48x);text-align:left}.ids-option:not(.ids-option--small):hover,:host.ids-option:not(.ids-option--small):hover{background-color:var(--ids_color_bg_variant_02);border-left-color:var(--ids_color_bg_variant_02)}.ids-option [aria-selected=true],.ids-option--selected,:host.ids-option [aria-selected=true],:host.ids-option--selected{border-left-color:var(--ids_color_action_primary_variant);font:var(--ids_textStyle_label_medium_bold)}.ids-option [aria-selected=true]:hover,.ids-option--selected:hover,:host.ids-option [aria-selected=true]:hover,:host.ids-option--selected:hover{border-left-color:var(--ids_color_action_primary_variant)}.ids-option [aria-disabled=true],.ids-option--disabled,:host.ids-option [aria-disabled=true],:host.ids-option--disabled{background-color:var(--ids_color_bg_variant_01);border-left-color:var(--ids_color_bg_variant_01);color:var(--ids_color_action_disabled_variant);pointer-events:none}.ids-option--highlighted,:host.ids-option--highlighted{background-color:var(--ids_color_bg_variant_02);border-left-color:var(--ids_color_bg_variant_02)}.ids-option--hide,:host.ids-option--hide{display:none}.ids-option__text,:host.ids-option__text{flex:1;overflow:hidden;padding:var(--ids_size_general_12x) var(--ids_size_general_8x);text-overflow:ellipsis;white-space:nowrap}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { title: [{
                type: HostBinding,
                args: ['attr.title']
            }], selected: [{
                type: Input
            }], label: [{
                type: Input
            }], id: [{
                type: Input
            }], value: [{
                type: Input
            }], disabled: [{
                type: Input
            }], small: [{
                type: Input
            }], change: [{
                type: Output
            }], selectedChange: [{
                type: Output
            }], onClick: [{
                type: HostListener,
                args: ['click']
            }] } });

class IdsOptionModule {
}
IdsOptionModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsOptionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsOptionModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsOptionModule, imports: [IdsOptionComponent], exports: [IdsOptionComponent] });
IdsOptionModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsOptionModule, imports: [IdsOptionComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsOptionModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsOptionComponent],
                    exports: [IdsOptionComponent],
                }]
        }] });

class IdsMenuComponent {
    get positions() {
        if (this.position === this._lastPosition) {
            return this._positions;
        }
        this._lastPosition = this.position;
        const bottom = [
            {
                originX: 'start',
                originY: 'bottom',
                overlayX: 'start',
                overlayY: 'top',
            },
        ];
        const top = [
            {
                originX: 'start',
                originY: 'top',
                overlayX: 'start',
                overlayY: 'bottom',
            },
        ];
        const setPosition = {
            top,
            bottom,
            auto: [],
        };
        this._positions = setPosition[this.position] || [];
        return this._positions;
    }
    /**
     * Define a posição de abertura da lista de opções
     *
     * Possíveis valores: 'top' | 'bottom' | 'auto' = 'auto'
     */
    get position() {
        return this._position;
    }
    set position(position) {
        this._position = position;
    }
    /**
     * Define se a lista de opções está aberta.
     */
    set open(open) {
        this._open = enforceBoolean(open);
        if (this._open) {
            this.opened.emit();
            return;
        }
        this.closed.emit();
    }
    constructor(_cdr) {
        this._cdr = _cdr;
        this.currentPanelPosition = 'bottom';
        this._destroy = new Subject();
        this._positions = [];
        this._position = 'auto';
        this._open = false;
        /**
         * Evento emitido toda vez que a lista de opções é aberta.
         */
        this.opened = new EventEmitter();
        /**
         * Evento emitido toda vez que a lista de opções é fechada.
         */
        this.closed = new EventEmitter();
    }
    ngAfterViewInit() {
        this._listenToPositionChanges();
    }
    ngOnDestroy() {
        this._destroy.next();
        this._destroy.complete();
    }
    _listenToPositionChanges() {
        this.cdkOverlay.positionChange.pipe(takeUntil(this._destroy)).subscribe((change) => {
            const openingPosition = change.connectionPair.originY === 'bottom' ? 'bottom' : 'top';
            if (openingPosition === this.currentPanelPosition) {
                return;
            }
            this.currentPanelPosition = openingPosition;
            this._cdr.detectChanges();
        });
    }
}
IdsMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMenuComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
IdsMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsMenuComponent, selector: "ids-abstract-menu", inputs: { position: "position", open: "open" }, outputs: { opened: "opened", closed: "closed" }, viewQueries: [{ propertyName: "cdkOverlay", first: true, predicate: CdkConnectedOverlay, descendants: true, static: true }], ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMenuComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ids-abstract-menu',
                    template: '',
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { position: [{
                type: Input
            }], open: [{
                type: Input
            }], opened: [{
                type: Output
            }], closed: [{
                type: Output
            }], cdkOverlay: [{
                type: ViewChild,
                args: [CdkConnectedOverlay, { static: true }]
            }] } });

let NEXT_ID$q = 0;
/**
 * O autocomplete aprimora a caixa de texto adicionando um painel com as opções disponíveis para seleção.
 * Permitindo realizar filtros para facilitar a seleção. Semelhante ao componente select, é necessário
 * informar uma opção dentre uma das opções disponíveis na lista.
 *
 * Componente baseado na [exemplo do W3](https://www.w3.org/WAI/ARIA/apg/patterns/combobox/examples/combobox-autocomplete-list/)
 * de *Editable Combobox With List Autocomplete.*
 *
 * **Module:**
 * `import { IdsListboxModule } from '@ids/angular';`
 */
class IdsListboxComponent extends IdsMenuComponent {
    get value() {
        return this.input.value ?? '';
    }
    get parentNode() {
        return this?.elementRef.nativeElement.parentNode;
    }
    get width() {
        if (this.open) {
            if (this.input) {
                return this.input.elementRef.nativeElement.offsetWidth;
            }
            if (this.container) {
                return this.container.offsetWidth;
            }
            if (this.parentNode) {
                return this.parentNode.offsetWidth;
            }
        }
        return 0;
    }
    /**
     * Define se a lista de opções está aberta.
     */
    set open(open) {
        const booleanOpen = enforceBoolean(open);
        if (booleanOpen === this._open) {
            return;
        }
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        super.open = open;
        if (this.input) {
            this.input.ariaExpanded = this._open;
        }
    }
    get open() {
        return this._open;
    }
    get optionsArray() {
        return this.childrenOptions?.toArray() ?? [];
    }
    get visibleOptionsArray() {
        return this.optionsArray.filter((option) => !option.disabled && option.showing);
    }
    get totalAvailableItems() {
        if (this.options.length) {
            return this.filteredOptions.length;
        }
        return this.availableOptions.length;
    }
    /**
     * Define a lista de opções disponíveis para o autocomplete.
     * Nesse caso as opções são predefinidas e não possuem customização.
     */
    get options() {
        return this._options;
    }
    set options(options) {
        this._options = options;
        this._options.map((option, index) => (option.id = option.id || `ids-option-${index}`));
    }
    get filteredOptions() {
        return filterListboxOptions(this.options, String(this.value), {
            filter: this.filter,
        });
    }
    get origin() {
        return new CdkOverlayOrigin(this.input?.elementRef);
    }
    /**
     * Função para comparar os valores das opções com os valores selecionados.
     *
     * Exemplo:
     * options: IObj[] = [{ val: 1, label: 'Opção 1' },{ val: 2, label: 'Opção 2' }];
     *
     * compareFn(c1: unknown, c2: unknown): boolean {
     *   return c1 && c2 ? c1.val === c2.val : c1 === c2;
     * }
     *
     * https://angular.io/api/forms/SelectControlValueAccessor#caveat-option-selection
     */
    get compareWith() {
        return this._compareWith;
    }
    set compareWith(fn) {
        this._compareWith = fn;
    }
    get childrenOptions() {
        return this.contentChildrenOptions.length
            ? this.contentChildrenOptions
            : this.viewChildrenOptions;
    }
    get lastSelectedOption() {
        return this.childrenOptions.find((option) => option.selected) ?? null;
    }
    constructor(_cdr, _appRef, _formFieldService, elementRef) {
        super(_cdr);
        this._cdr = _cdr;
        this._appRef = _appRef;
        this._formFieldService = _formFieldService;
        this.elementRef = elementRef;
        this.maxItemsBreakpoint = 3;
        this._lastActiveEmittedOption = null;
        this._lastSelectedEmittedOption = null;
        this.availableOptions = [];
        /**
         * Define o id do componente. Caso não seja informado, um id será gerado automaticamente.
         */
        this.id = `ids-listbox-${NEXT_ID$q++}`;
        this._options = [];
        /**
         *  Define a quantidade de option no visível scroll.
         *  visibleOptions = 6; (default)
         */
        this.visibleOptions = 6;
        /**
         * Define o tipo de filtro a ser utilizado na lista de opções.
         *
         * - Startswith: Filtra todas as opções que começarem com o valor digitado;
         * - Includes: Filtra todas as opções que contenham o texto digitado em qualquer posição;
         * - custom: filterFn = `(text: string, search: string): boolean`;
         */
        this.filter = 'none';
        this._compareWith = objectIs;
        /**
         * Evento emitido sempre que uma nova opção é ativada. Ou seja,
         * a opção está selecionada na lista de opções, porém seu valor ainda não foi atribuído ao input.
         */
        this.activated = new EventEmitter();
        /**
         * Evento emitido ao selecionar uma nova opção, no momento em que seu valor é atribuído ao input.
         */
        this.selected = new EventEmitter();
        this._formFieldService.input$().subscribe((input) => {
            this.input = input;
        });
        this._formFieldService.formFieldElement$().subscribe((formFieldElement) => {
            this.container = formFieldElement;
        });
    }
    ngOnInit() {
        this._formFieldService.sendListbox(this);
    }
    ngAfterContentInit() {
        if (!this.input) {
            return;
        }
        this.input.ariaControls = this.id;
    }
    ngAfterViewInit() {
        super.ngAfterViewInit();
        this._listenToOptionsChanges();
        this._listenToViewModelChanges();
        this._listenToInputEvent();
        this._listenToKeydownEvent();
    }
    detach(shouldFocusOnInput = true) {
        this.open = false;
        if (shouldFocusOnInput) {
            this.input.focus();
        }
        if (this.lastSelectedOption && !this.input.controlValue) {
            this._resetSelection();
        }
    }
    emitActivatedEvent(option) {
        const shouldEmitActivatedEvent = option?.label !== this._lastActiveEmittedOption?.label;
        if (!shouldEmitActivatedEvent || !option) {
            return;
        }
        this._lastActiveEmittedOption = option;
        this.activated.emit(option);
    }
    emitSelectedEvent(option) {
        const shouldEmitSelectedEvent = option?.label !== this._lastSelectedEmittedOption?.label;
        if (!shouldEmitSelectedEvent || !option) {
            return;
        }
        this._lastSelectedEmittedOption = option;
        this.selected.emit(option);
    }
    _listenToOptionsChanges() {
        this.childrenOptions.changes
            .pipe(takeUntil(this._destroy), startWith(this.childrenOptions), switchMap(() => merge(...this.childrenOptions.map((option) => option.change))))
            .subscribe((optionEvent) => {
            this._setSelectedOption(optionEvent);
        });
    }
    _listenToViewModelChanges() {
        this.input.viewModelChange$.pipe(takeUntil(this._destroy)).subscribe((controlValue) => {
            if (controlValue) {
                Promise.resolve().then(() => {
                    const selectedOption = this.optionsArray.find((option) => !option.disabled && this.compareWith(option.label, this.value));
                    if (selectedOption) {
                        selectedOption.selectAndClose();
                        this.emitSelectedEvent(selectedOption);
                        return;
                    }
                });
                return;
            }
        });
    }
    _filterOptions() {
        // caso as opções sejam enviadas por uma lista de options a filtragem não
        // precisa filtrar aqui mas sim no "filteredOptions"
        if (!this.contentChildrenOptions.length) {
            return;
        }
        this.availableOptions = filterListboxOptions(this.optionsArray, String(this.value), {
            filter: this.filter,
        });
        this.availableOptions.forEach((option) => option.show());
        differenceArray(this.optionsArray, this.availableOptions).forEach((option) => option.hide());
    }
    _listenToInputEvent() {
        this.input.input$.pipe(takeUntil(this._destroy)).subscribe(() => {
            if (this.lastSelectedOption) {
                this._resetSelection();
            }
            this._filterOptions();
            if (this.position === 'auto' && this.open) {
                // Tick para aguardar as opções serem atualizadas na lista de opções, para então
                // atualizar a posição
                this._appRef.tick();
                this.cdkOverlay.overlayRef?.updatePosition();
            }
        });
    }
    _listenToKeydownEvent() {
        this.input.keydown$.pipe(takeUntil(this._destroy)).subscribe((event) => {
            if (this.input.readonly || this.input.disabled) {
                return;
            }
            this._handleKeydown(event);
        });
    }
    _setSelectedOption(optionEvent) {
        const selectedOption = optionEvent.option;
        const selectAndCloseOptions = optionEvent.close || false;
        this._deselectOptions(selectedOption, selectAndCloseOptions);
        selectedOption.show();
        this.emitActivatedEvent(selectedOption);
        if (selectAndCloseOptions) {
            const shouldEmitSelectedEvent = selectedOption.label !== this.value;
            this._setValue(selectedOption, shouldEmitSelectedEvent);
            if (this.open) {
                this.detach();
            }
            return;
        }
        if (!this.panel) {
            this.cdkOverlay.positionChange
                .pipe(take(1))
                .subscribe(() => this._scrollIntoView(selectedOption));
            return;
        }
        this._scrollIntoView(selectedOption);
    }
    _deselectOptions(selectedOption, hideOption) {
        this.childrenOptions.forEach((option) => {
            if (!this.compareWith(option.label, selectedOption.label)) {
                option.deselect();
                if (hideOption) {
                    option.hide();
                }
            }
        });
    }
    _setValue(selectedOption, shouldEmitSelectedEvent = true) {
        const value = selectedOption ? selectedOption.label : '';
        if (value) {
            this.input.setControlValue(String(value));
        }
        else {
            this.input.setControlValue('');
        }
        if (!selectedOption) {
            this._resetSelection(true);
        }
        if (shouldEmitSelectedEvent) {
            this.emitSelectedEvent(selectedOption);
        }
    }
    _resetSelection(unhideOptions = false) {
        this.optionsArray.forEach((option) => {
            option.deselect();
            if (unhideOptions) {
                option.show();
            }
        });
        this.emitActivatedEvent(null);
    }
    _resetValue() {
        this.input.resetControlValue();
        this.emitSelectedEvent(null);
    }
    _handleKeydown(event) {
        const lastOption = this.lastSelectedOption;
        const selectedOptionIdx = lastOption
            ? this.visibleOptionsArray.findIndex((opt) => opt.id === lastOption.id)
            : -1;
        const action = getComboboxActionByKeyboardEvent(event, {
            editable: true,
            hasSelectedValue: selectedOptionIdx !== -1,
            open: this.open,
            inOnTheFirstOption: selectedOptionIdx === 0,
            hasValue: !!this.input.controlValue,
        });
        if (['open', 'first', 'next', 'type', 'erase'].includes(action)) {
            this.open = true;
            if (action === 'first') {
                // precisa ser assíncrono, pois o a lista ainda não está aberta
                setTimeout(() => {
                    this.visibleOptionsArray[0]?.select();
                });
                return;
            }
            if (action === 'next') {
                const next = this.visibleOptionsArray[selectedOptionIdx === this.visibleOptionsArray.length - 1 ? 0 : selectedOptionIdx + 1] || this.visibleOptionsArray[0];
                next?.select();
                return;
            }
            return;
        }
        if (action === 'previous' || action === 'last') {
            if (this.visibleOptionsArray.length === 0) {
                return;
            }
            this.visibleOptionsArray[selectedOptionIdx === 0 || selectedOptionIdx === -1
                ? this.visibleOptionsArray.length - 1
                : selectedOptionIdx - 1].select();
            return;
        }
        if (action === 'select') {
            if (lastOption) {
                lastOption.selectAndClose();
                return;
            }
            if (this.visibleOptionsArray.length) {
                this.visibleOptionsArray[0].selectAndClose();
            }
            return;
        }
        if (action === 'clear') {
            this._resetValue();
        }
        if (action === 'close' || action === 'clear' || action === 'out') {
            if (action !== 'out') {
                event.preventDefault();
            }
            if (this.open) {
                this.detach();
                return;
            }
            if (lastOption) {
                this._setValue(null);
            }
            return;
        }
    }
    _scrollIntoView(selectedOption) {
        const panelEl = this.panel.nativeElement;
        const optionEl = selectedOption.element.nativeElement;
        const scrollPosition = optionEl.offsetTop - panelEl.scrollTop;
        if (scrollPosition >= panelEl.offsetHeight) {
            optionEl.scrollIntoView(false);
            return;
        }
        /* istanbul ignore next */
        if (scrollPosition < 0) {
            optionEl.scrollIntoView();
        }
    }
    trackByFn(_index, item) {
        return item.id;
    }
}
IdsListboxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsListboxComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ApplicationRef }, { token: IdsFormFieldService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
IdsListboxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsListboxComponent, isStandalone: true, selector: "ids-listbox", inputs: { open: "open", id: "id", input: "input", container: "container", options: "options", visibleOptions: "visibleOptions", filter: "filter", ariaLabel: ["aria-label", "ariaLabel"], compareWith: "compareWith" }, outputs: { activated: "activated", selected: "selected" }, host: { properties: { "attr.aria-label": "null", "attr.id": "null" } }, queries: [{ propertyName: "contentChildrenOptions", predicate: IdsOptionComponent, descendants: true }], viewQueries: [{ propertyName: "panel", first: true, predicate: ["panel"], descendants: true }, { propertyName: "viewChildrenOptions", predicate: IdsOptionComponent, descendants: true }], usesInheritance: true, ngImport: i0, template: "<ng-template\n  cdkConnectedOverlay\n  cdkConnectedOverlayHasBackdrop\n  cdkConnectedOverlayBackdropClass=\"cdk-overlay-transparent-backdrop\"\n  cdkConnectedOverlayPanelClass=\"ids-listbox-wrapper\"\n  [cdkConnectedOverlayOrigin]=\"origin\"\n  [cdkConnectedOverlayOpen]=\"open\"\n  [cdkConnectedOverlayPositions]=\"positions\"\n  [cdkConnectedOverlayWidth]=\"width\"\n  (backdropClick)=\"detach(false)\"\n>\n  <div\n    #panel\n    [id]=\"id\"\n    role=\"listbox\"\n    class=\"ids-listbox\"\n    [attr.aria-label]=\"ariaLabel\"\n    [style.maxHeight.rem]=\"visibleOptions * maxItemsBreakpoint\"\n    [class.ids-listbox--top]=\"currentPanelPosition === 'top'\"\n    [attr.aria-labelledby]=\"!ariaLabel && input.labelId ? input.labelId : null\"\n  >\n    <ng-content select=\"ids-option\" *ngIf=\"!options.length\"></ng-content>\n\n    <ids-option\n      *ngFor=\"let option of filteredOptions; trackBy: trackByFn\"\n      [label]=\"option.label\"\n      [id]=\"option.id || ''\"\n      [value]=\"option.value\"\n      [selected]=\"input.value === option.label\"\n    >\n      {{ option.label }}\n    </ids-option>\n  </div>\n</ng-template>\n", dependencies: [{ kind: "ngmodule", type: OverlayModule }, { kind: "directive", type: i1$3.CdkConnectedOverlay, selector: "[cdk-connected-overlay], [connected-overlay], [cdkConnectedOverlay]", inputs: ["cdkConnectedOverlayOrigin", "cdkConnectedOverlayPositions", "cdkConnectedOverlayPositionStrategy", "cdkConnectedOverlayOffsetX", "cdkConnectedOverlayOffsetY", "cdkConnectedOverlayWidth", "cdkConnectedOverlayHeight", "cdkConnectedOverlayMinWidth", "cdkConnectedOverlayMinHeight", "cdkConnectedOverlayBackdropClass", "cdkConnectedOverlayPanelClass", "cdkConnectedOverlayViewportMargin", "cdkConnectedOverlayScrollStrategy", "cdkConnectedOverlayOpen", "cdkConnectedOverlayDisableClose", "cdkConnectedOverlayTransformOriginOn", "cdkConnectedOverlayHasBackdrop", "cdkConnectedOverlayLockPosition", "cdkConnectedOverlayFlexibleDimensions", "cdkConnectedOverlayGrowAfterOpen", "cdkConnectedOverlayPush"], outputs: ["backdropClick", "positionChange", "attach", "detach", "overlayKeydown", "overlayOutsideClick"], exportAs: ["cdkConnectedOverlay"] }, { kind: "ngmodule", type: IdsOptionModule }, { kind: "component", type: IdsOptionComponent, selector: "ids-option", inputs: ["selected", "label", "id", "value", "disabled", "small"], outputs: ["change", "selectedChange"] }, { kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsListboxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-listbox', encapsulation: ViewEncapsulation.None, imports: [OverlayModule, IdsOptionModule, CommonModule], standalone: true, host: {
                        '[attr.aria-label]': 'null',
                        '[attr.id]': 'null',
                    }, template: "<ng-template\n  cdkConnectedOverlay\n  cdkConnectedOverlayHasBackdrop\n  cdkConnectedOverlayBackdropClass=\"cdk-overlay-transparent-backdrop\"\n  cdkConnectedOverlayPanelClass=\"ids-listbox-wrapper\"\n  [cdkConnectedOverlayOrigin]=\"origin\"\n  [cdkConnectedOverlayOpen]=\"open\"\n  [cdkConnectedOverlayPositions]=\"positions\"\n  [cdkConnectedOverlayWidth]=\"width\"\n  (backdropClick)=\"detach(false)\"\n>\n  <div\n    #panel\n    [id]=\"id\"\n    role=\"listbox\"\n    class=\"ids-listbox\"\n    [attr.aria-label]=\"ariaLabel\"\n    [style.maxHeight.rem]=\"visibleOptions * maxItemsBreakpoint\"\n    [class.ids-listbox--top]=\"currentPanelPosition === 'top'\"\n    [attr.aria-labelledby]=\"!ariaLabel && input.labelId ? input.labelId : null\"\n  >\n    <ng-content select=\"ids-option\" *ngIf=\"!options.length\"></ng-content>\n\n    <ids-option\n      *ngFor=\"let option of filteredOptions; trackBy: trackByFn\"\n      [label]=\"option.label\"\n      [id]=\"option.id || ''\"\n      [value]=\"option.value\"\n      [selected]=\"input.value === option.label\"\n    >\n      {{ option.label }}\n    </ids-option>\n  </div>\n</ng-template>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ApplicationRef }, { type: IdsFormFieldService }, { type: i0.ElementRef }]; }, propDecorators: { open: [{
                type: Input
            }], id: [{
                type: Input
            }], input: [{
                type: Input
            }], container: [{
                type: Input
            }], options: [{
                type: Input
            }], visibleOptions: [{
                type: Input
            }], filter: [{
                type: Input
            }], ariaLabel: [{
                type: Input,
                args: ['aria-label']
            }], compareWith: [{
                type: Input
            }], activated: [{
                type: Output
            }], selected: [{
                type: Output
            }], contentChildrenOptions: [{
                type: ContentChildren,
                args: [IdsOptionComponent, { descendants: true }]
            }], viewChildrenOptions: [{
                type: ViewChildren,
                args: [IdsOptionComponent]
            }], panel: [{
                type: ViewChild,
                args: ['panel']
            }] } });

let NEXT_ID$p = 0;
/**
 * Diretiva para customização de input
 *
 * *Directive for customizing input*
 *
 * **Module:**
 *
 * `import { IdsInputModule } from '@ids/angular';`
 */
class IdsInputDirective extends IdsFieldMixinBase {
    get isTypeNumberOnIOS() {
        return platform.os === 'IOS' && this._type === 'number';
    }
    get isTypeNumberOnMobile() {
        return platform.isMobile && this._type === 'number';
    }
    /**
     * Edição do campo só leitura
     *
     * *The field editing read only*
     */
    set readonly(readonly) {
        this._readonly = enforceBoolean(readonly);
    }
    get readonly() {
        return this._readonly;
    }
    /**
     * Indica que o input não terá uma `label` vinculada ao componente.
     * Neste caso, é obrigatório informar os atributos `aria-label` ou
     * `aria-labelledby`.
     */
    set noLabel(value) {
        this._noLabel = enforceBoolean(value);
    }
    get noLabel() {
        return this._noLabel;
    }
    get controlDisabled() {
        return (this.disabled && !this.controlValue) || null;
    }
    get controlReadOnly() {
        return (this.disabled && !!this.controlValue) || null || this.readonly;
    }
    get controlValue() {
        return this.value;
    }
    get inputClasses() {
        if (this.noStyles) {
            return null;
        }
        return generateClasses({
            'ids-input': true,
            'ids-input--large': this.size === 'L',
            'ids-input--center': this.noLabel,
            'ids-input--small': this.noLabel,
        });
    }
    /** @internal */
    set type(type) {
        this._type = type;
    }
    get type() {
        if (this.isTypeNumberOnMobile) {
            return 'text';
        }
        return this._type;
    }
    /** @internal */
    set inputmode(inputmode) {
        this._inputmode = inputmode;
    }
    get inputmode() {
        if (this.isTypeNumberOnMobile) {
            return 'decimal';
        }
        return this._inputmode;
    }
    /** @internal */
    set pattern(pattern) {
        this._pattern = pattern;
    }
    get pattern() {
        if (this.isTypeNumberOnIOS) {
            return '[0-9]*';
        }
        return this._pattern;
    }
    /**
     * Define se a primeira atualização do campo será feita no blur. Ao entrar novamente, a atualização volta para a estratégia padrão
     *
     * *Defines if the first update of the field will be done on blur. Upon re-entering, update reverts to default strategy*
     */
    set controlUpdateFirstOnBlur(value) {
        this.updateFirstOnBlur = enforceBoolean(value);
    }
    controlInput({ value, valueAsNumber }) {
        // previne alteração do comportamento nativo.
        // manipular o comportamento nativo é falho pois,
        // separadores decimais não são retornados corretamente
        if (this.type === 'number') {
            return;
        }
        const maxLength = this.elementRef.nativeElement.maxLength;
        const hasExceededMaxLength = textLength(value) > maxLength || textLength(String(valueAsNumber)) > maxLength;
        // previne que o texto exceda o maxLenght no Android
        // https://caniuse.com/maxlength
        const maxValue = hasExceededMaxLength &&
            (value?.substring(0, maxLength) || Number(String(valueAsNumber)?.substring(0, maxLength)));
        this.value = maxValue || valueAsNumber || value;
        this.valueChange.emit(this.value);
        this.elementRef.nativeElement.value = this.value;
    }
    controlChange(value) {
        this.value = value;
        this.formAcessorHandleChange();
    }
    controlFocus() {
        this.formAcessorHandleFocus();
    }
    controlBlur() {
        this.formAcessorHandleBlur();
    }
    controlKeyup(event) {
        const element = event.target;
        this.verifyAndAnnouceLimit(element);
        if (this.autoResize) {
            this.handleElementHeight(element);
        }
    }
    constructor(ngControl, elementRef, liveAnnoucer, renderer) {
        super(ngControl, elementRef) /* istanbul ignore next */;
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this.liveAnnoucer = liveAnnoucer;
        this.renderer = renderer;
        this._readonly = null;
        this._noLabel = false;
        /**
          Define se o campo de texto irá expandir verticalmente conforme a quantidade de linhas do valor.
        */
        this.autoResize = platform.isMobile;
        /** Define se a diretiva deve ser apenas para comunicação e não aplicar estilos */
        this.noStyles = false;
        this.controlId = `ids-input-${NEXT_ID$p++}`;
        /**
         * @internal
         * @deprecated Esta diretiva é usada apenas com Reactive Forms, para escutar
         * a mudança de valor, utilize this.formControl.valueChanges.subscribe()
         * https://v17.angular.io/guide/reactive-forms
         */
        this.valueChange = new EventEmitter();
    }
    verifyAndAnnouceLimit(element) {
        const maxLength = element.maxLength;
        const isMaxLengthReached = maxLength !== -1 && textLength(element.value) >= maxLength;
        // não precisa anunciar o limite no MacOS, pois o VoiceOver dele já faz isso
        // https://a11ysupport.io/tech/html/maxlength_attribute
        if (isMaxLengthReached && platform.os !== 'MacOS') {
            this.liveAnnoucer.announce('Limite de caracteres atingido', 1000);
        }
    }
    /* mobile or autoResize */
    handleElementHeight(element) {
        if (element.tagName === 'TEXTAREA') {
            element.style.height = 'auto';
            element.style.height = `${element.scrollHeight + 1}px`;
        }
    }
    ngAfterViewInit() {
        setTimeout(() => {
            this.handleElementHeight(this.nativeElement);
        }, 500);
    }
    // verifica se estão inválidos os campos que não estão em foco
    // isso serve para validar mudanças que não vieram do usuário
    ngDoCheck() {
        if (this.ngControl && this.ngControl.touched && this.ngControl.invalid && !this.active) {
            this.formAcessorHandleBlur();
        }
    }
    setControlValue(value) {
        this.renderer.setProperty(this.elementRef.nativeElement, 'value', value);
        this.value = value;
        this.valueChange.emit(value);
    }
    resetControlValue() {
        this.setControlValue('');
    }
}
IdsInputDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsInputDirective, deps: [{ token: i1$2.NgControl, optional: true, self: true }, { token: i0.ElementRef }, { token: i1$1.LiveAnnouncer }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Directive });
IdsInputDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsInputDirective, isStandalone: true, selector: "[idsInput]:not([idsDatepicker])", inputs: { readonly: "readonly", autoResize: "autoResize", noStyles: "noStyles", noLabel: "noLabel", controlId: ["id", "controlId"], type: "type", inputmode: "inputmode", pattern: "pattern", controlUpdateFirstOnBlur: ["updateFirstOnBlur", "controlUpdateFirstOnBlur"], size: "size" }, outputs: { valueChange: "valueChange" }, host: { listeners: { "input": "controlInput($event.target)", "ngModelChange": "controlChange($event)", "focus": "controlFocus()", "blur": "controlBlur()", "keyup": "controlKeyup($event)" }, properties: { "attr.disabled": "this.controlDisabled", "attr.readonly": "this.controlReadOnly", "attr.value": "this.controlValue", "attr.class": "this.inputClasses", "attr.id": "this.controlId", "attr.type": "this.type", "attr.inputmode": "this.inputmode", "attr.pattern": "this.pattern" } }, providers: [
        {
            provide: IdsFieldMixinBase,
            useExisting: forwardRef(
            /* istanbul ignore next */
            () => IdsInputDirective),
        },
    ], usesInheritance: true, ngImport: i0 });
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object)
], IdsInputDirective.prototype, "autoResize", void 0);
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object)
], IdsInputDirective.prototype, "noStyles", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsInputDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsInput]:not([idsDatepicker])',
                    providers: [
                        {
                            provide: IdsFieldMixinBase,
                            useExisting: forwardRef(
                            /* istanbul ignore next */
                            () => IdsInputDirective),
                        },
                    ],
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: i1$2.NgControl, decorators: [{
                    type: Self
                }, {
                    type: Optional
                }] }, { type: i0.ElementRef }, { type: i1$1.LiveAnnouncer }, { type: i0.Renderer2 }]; }, propDecorators: { readonly: [{
                type: Input
            }], autoResize: [{
                type: Input
            }], noStyles: [{
                type: Input
            }], noLabel: [{
                type: Input
            }], controlDisabled: [{
                type: HostBinding,
                args: ['attr.disabled']
            }], controlReadOnly: [{
                type: HostBinding,
                args: ['attr.readonly']
            }], controlValue: [{
                type: HostBinding,
                args: ['attr.value']
            }], inputClasses: [{
                type: HostBinding,
                args: ['attr.class']
            }], controlId: [{
                type: Input,
                args: ['id']
            }, {
                type: HostBinding,
                args: ['attr.id']
            }], type: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.type']
            }], inputmode: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.inputmode']
            }], pattern: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.pattern']
            }], controlUpdateFirstOnBlur: [{
                type: Input,
                args: ['updateFirstOnBlur']
            }], size: [{
                type: Input
            }], valueChange: [{
                type: Output
            }], controlInput: [{
                type: HostListener,
                args: ['input', ['$event.target']]
            }], controlChange: [{
                type: HostListener,
                args: ['ngModelChange', ['$event']]
            }], controlFocus: [{
                type: HostListener,
                args: ['focus']
            }], controlBlur: [{
                type: HostListener,
                args: ['blur']
            }], controlKeyup: [{
                type: HostListener,
                args: ['keyup', ['$event']]
            }] } });

/**
 * Esta diretiva estende o Autocomplete e é responsável por renderizar a lista de autocomplete.
 *
 * **Module:**
 * `import { IdsAutocompleteModule } from '@ids/angular';`
 */
class IdsAutocompleteDirective extends IdsInputDirective {
    get ariaActivedescendant() {
        if (this.ariaExpanded) {
            return this.listbox?.lastSelectedOption?.id ?? null;
        }
        return null;
    }
    /**
     * Define a lista de opções disponíveis para o autocomplete.
     */
    set options(options) {
        if (options !== this._options) {
            this._options = options;
            if (this.listbox) {
                this.listbox.options = options.map((option) => {
                    if (typeof option === 'string') {
                        return {
                            value: option,
                            label: option,
                        };
                    }
                    return option;
                });
            }
        }
    }
    get options() {
        return this._options;
    }
    onClick() {
        if (this.readonly || this.disabled) {
            return;
        }
        if (this.listbox) {
            this.listbox.open = true;
        }
    }
    constructor(ngControl, elementRef, liveAnnoucer, renderer, _formFieldService, _viewContainerRef) {
        super(ngControl, elementRef, liveAnnoucer, renderer);
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this.liveAnnoucer = liveAnnoucer;
        this.renderer = renderer;
        this._formFieldService = _formFieldService;
        this._viewContainerRef = _viewContainerRef;
        this._destroy = new Subject();
        this.role = 'combobox';
        this.ariaExpanded = false;
        this.ariaControls = null;
        this.autocomplete = 'off';
        this.ariaAutocomplete = 'list';
        /**
         * Evento emitido toda vez que a lista de opções é aberta.
         */
        this.opened = new EventEmitter();
        /**
         * Evento emitido toda vez que a lista de opções é fechada.
         */
        this.closed = new EventEmitter();
        /**
         * Define o tipo de filtro a ser utilizado na lista de opções.
         *
         * - Startswith: Filtra todas as opções que começarem com o valor digitado;
         * - Includes: Filtra todas as opções que contenham o texto digitado em qualquer posição;
         * - custom: filterFn = `(text: string, search: string): boolean`;
         */
        this.filter = 'none';
        /**
         * Evento emitido sempre que uma nova opção é ativada. Ou seja,
         * a opção está selecionada na lista de opções, porém seu valor ainda não foi atribuído ao input.
         */
        this.activated = new EventEmitter();
        /**
         * Evento emitido ao selecionar uma nova opção, no momento em que seu valor é atribuído ao input.
         */
        this.selected = new EventEmitter();
        this._formFieldService.listbox$().subscribe((listbox) => {
            this.listbox = listbox;
        });
        merge(this.input$, this.viewModelChange$)
            .pipe(takeUntil$1(this._destroy))
            .subscribe(() => {
            // o this.focused evita que a lista seja aberta caso seja feito um setValue
            // e o input não está em foco sendo editado pelo usuário
            if (this.listbox && this.focused) {
                this.listbox.open = true;
                setTimeout(() => {
                    const resultsMessage = this.listbox.totalAvailableItems === 1
                        ? 'resultado disponível'
                        : 'resultados disponíveis';
                    this.liveAnnoucer.announce(`${this.listbox.totalAvailableItems} ${resultsMessage}`, 1000);
                });
            }
        });
    }
    ngOnInit() {
        if (this.options) {
            this.listbox = this._viewContainerRef.createComponent(IdsListboxComponent, {
                index: 0,
            }).instance;
            this.listbox.filter = this.filter;
            this.listbox.options = this.options.map((option) => {
                if (typeof option === 'string') {
                    return {
                        value: option,
                        label: option,
                    };
                }
                return option;
            });
            // TODO: ver outra forma de uma observable escutar outra
            this.listbox.selected.pipe(takeUntil$1(this._destroy)).subscribe((option) => {
                this.selected.emit(option);
            });
            this.listbox.activated.pipe(takeUntil$1(this._destroy)).subscribe((option) => {
                this.activated.emit(option);
            });
            this.listbox.opened.pipe(takeUntil$1(this._destroy)).subscribe(() => {
                this.opened.emit();
            });
            this.listbox.closed.pipe(takeUntil$1(this._destroy)).subscribe(() => {
                this.closed.emit();
            });
        }
        this._formFieldService.sendInput(this);
        this._formFieldService.sendSuffixIcon('seta_baixo');
    }
    ngOnDestroy() {
        this._destroy.next();
        this._destroy.complete();
    }
}
IdsAutocompleteDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAutocompleteDirective, deps: [{ token: i1$2.NgControl, optional: true, self: true }, { token: i0.ElementRef, optional: true, self: true }, { token: i1$1.LiveAnnouncer }, { token: i0.Renderer2 }, { token: IdsFormFieldService }, { token: i0.ViewContainerRef }], target: i0.ɵɵFactoryTarget.Directive });
IdsAutocompleteDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsAutocompleteDirective, isStandalone: true, selector: "[idsAutocomplete]", inputs: { ariaExpanded: ["aria-expanded", "ariaExpanded"], ariaControls: ["aria-controls", "ariaControls"], autocomplete: "autocomplete", ariaAutocomplete: ["aria-autocomplete", "ariaAutocomplete"], options: "options", filter: "filter" }, outputs: { opened: "opened", closed: "closed", activated: "activated", selected: "selected" }, host: { listeners: { "click": "onClick()" }, properties: { "attr.role": "this.role", "attr.aria-expanded": "this.ariaExpanded", "attr.aria-controls": "this.ariaControls", "attr.aria-owns": "this.ariaControls", "attr.aria-activedescendant": "this.ariaActivedescendant", "autocomplete": "this.autocomplete", "attr.aria-autocomplete": "this.ariaAutocomplete" } }, providers: [
        {
            provide: IdsFieldMixinBase,
            useExisting: forwardRef(
            /* istanbul ignore next */
            () => IdsAutocompleteDirective),
        },
    ], usesInheritance: true, ngImport: i0 });
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object)
], IdsAutocompleteDirective.prototype, "ariaExpanded", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAutocompleteDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsAutocomplete]',
                    standalone: true,
                    providers: [
                        {
                            provide: IdsFieldMixinBase,
                            useExisting: forwardRef(
                            /* istanbul ignore next */
                            () => IdsAutocompleteDirective),
                        },
                    ],
                }]
        }], ctorParameters: function () { return [{ type: i1$2.NgControl, decorators: [{
                    type: Self
                }, {
                    type: Optional
                }] }, { type: i0.ElementRef, decorators: [{
                    type: Self
                }, {
                    type: Optional
                }] }, { type: i1$1.LiveAnnouncer }, { type: i0.Renderer2 }, { type: IdsFormFieldService }, { type: i0.ViewContainerRef }]; }, propDecorators: { role: [{
                type: HostBinding,
                args: ['attr.role']
            }], ariaExpanded: [{
                type: Input,
                args: ['aria-expanded']
            }, {
                type: HostBinding,
                args: ['attr.aria-expanded']
            }], ariaControls: [{
                type: Input,
                args: ['aria-controls']
            }, {
                type: HostBinding,
                args: ['attr.aria-controls']
            }, {
                type: HostBinding,
                args: ['attr.aria-owns']
            }], ariaActivedescendant: [{
                type: HostBinding,
                args: ['attr.aria-activedescendant']
            }], autocomplete: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['autocomplete']
            }], ariaAutocomplete: [{
                type: Input,
                args: ['aria-autocomplete']
            }, {
                type: HostBinding,
                args: ['attr.aria-autocomplete']
            }], options: [{
                type: Input
            }], opened: [{
                type: Output
            }], closed: [{
                type: Output
            }], filter: [{
                type: Input
            }], activated: [{
                type: Output
            }], selected: [{
                type: Output
            }], onClick: [{
                type: HostListener,
                args: ['click']
            }] } });

class IdsAutocompleteModule {
}
IdsAutocompleteModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAutocompleteModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsAutocompleteModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsAutocompleteModule, imports: [IdsAutocompleteDirective], exports: [IdsAutocompleteDirective] });
IdsAutocompleteModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAutocompleteModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAutocompleteModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsAutocompleteDirective],
                    exports: [IdsAutocompleteDirective],
                }]
        }] });

/**
 * Componente de Credit Card Brand, utilizado para representar bandeiras de cartão.
 * Pode ser utilizado dentro de outro componente ou avulso no layout.
 *
 * **Module:**
 *
 * `import { IdsCreditCardBrandComponent } from '@ids/angular';`
 */
class IdsCreditCardBrandComponent {
    constructor() {
        /**
         * Caminho da foto
         */
        this.src = CREDIT_CARD_PLACEHOLDER;
        /**
         * Define o cor de fundo
         */
        this.backgroundColor = '#D4B5D8';
        /**
         * Nome do ícone
         *
         * @deprecated Não disponibilizamos mais essa propriedade, pois...
         */
        this.icon = '';
    }
    get classes() {
        return {
            'ids-credit-card-brand': true,
            '-small': this.size === 'S',
            '-large': this.size === 'L',
        };
    }
    /**
     * Tamanho do ícone
     */
    set size(size) {
        this._size = enforceCase(size, 'upperCase');
    }
    get size() {
        return this._size || 'M';
    }
}
IdsCreditCardBrandComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsCreditCardBrandComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IdsCreditCardBrandComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsCreditCardBrandComponent, isStandalone: true, selector: "ids-credit-card-brand", inputs: { size: "size", src: "src", alt: "alt", ariaLabel: ["aria-label", "ariaLabel"], contrast: "contrast", backgroundColor: "backgroundColor", icon: "icon" }, host: { properties: { "attr.alt": "null", "attr.src": "null", "attr.size": "null" } }, ngImport: i0, template: "<img\n  [style]=\"'background-color:' + backgroundColor\"\n  [class]=\"classes\"\n  [src]=\"src\"\n  [attr.alt]=\"alt || ariaLabel\"\n  [attr.aria-hidden]=\"!ariaLabel && !alt ? true : null\"\n/>\n", styles: [".ids-credit-card-brand{border-radius:var(--ids_size_border_large);height:var(--ids_size_general_24x);object-fit:contain;width:var(--ids_size_general_32x)}.ids-credit-card-brand.-small{height:var(--ids_size_general_16x);width:var(--ids_size_general_24x)}.ids-credit-card-brand.-large{height:var(--ids_size_general_32x);width:var(--ids_size_general_48x)}:host{display:inline-flex}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsCreditCardBrandComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-credit-card-brand', standalone: true, imports: [CommonModule], host: {
                        '[attr.alt]': 'null',
                        '[attr.src]': 'null',
                        '[attr.size]': 'null',
                    }, template: "<img\n  [style]=\"'background-color:' + backgroundColor\"\n  [class]=\"classes\"\n  [src]=\"src\"\n  [attr.alt]=\"alt || ariaLabel\"\n  [attr.aria-hidden]=\"!ariaLabel && !alt ? true : null\"\n/>\n", styles: [".ids-credit-card-brand{border-radius:var(--ids_size_border_large);height:var(--ids_size_general_24x);object-fit:contain;width:var(--ids_size_general_32x)}.ids-credit-card-brand.-small{height:var(--ids_size_general_16x);width:var(--ids_size_general_24x)}.ids-credit-card-brand.-large{height:var(--ids_size_general_32x);width:var(--ids_size_general_48x)}:host{display:inline-flex}\n"] }]
        }], propDecorators: { size: [{
                type: Input
            }], src: [{
                type: Input
            }], alt: [{
                type: Input
            }], ariaLabel: [{
                type: Input,
                args: ['aria-label']
            }], contrast: [{
                type: Input
            }], backgroundColor: [{
                type: Input
            }], icon: [{
                type: Input
            }] } });

/**
 * Componente de avatar, utilizado para representar perfis de usuário e/ou contatos.
 * Pode ser utilizado dentro de outro componente ou avulso no layout.
 *
 * **Module:**
 *
 * `import { IdsAvatarComponent } from '@ids/angular';`
 */
class IdsAvatarComponent {
    constructor() {
        /**
         * Nome do ícone
         */
        this.icon = 'usuario_outline';
    }
    get type() {
        return this.text ? 'text' : this.src ? 'src' : 'icon';
    }
    get classes() {
        return {
            'ids-avatar': true,
            'ids-avatar--on-brand': this.contrast === 'onBrand',
            'ids-avatar--small': this.size === 'S',
            'ids-avatar--large': this.size === 'L',
            'ids-avatar--xlarge': this.size === 'XL',
            [`ids-avatar--${this.variant || ''}`]: !!this.variant,
        };
    }
    /**
     * Tamanho do ícone
     */
    set size(size) {
        this._size = enforceCase(size, 'upperCase');
    }
    get size() {
        return this._size;
    }
}
IdsAvatarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAvatarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IdsAvatarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsAvatarComponent, isStandalone: true, selector: "ids-avatar", inputs: { size: "size", variant: "variant", icon: "icon", text: "text", src: "src", alt: "alt", ariaLabel: ["aria-label", "ariaLabel"], contrast: "contrast" }, host: { properties: { "attr.aria-label": "null", "attr.alt": "null", "attr.src": "null", "attr.size": "null" } }, ngImport: i0, template: "<div\n  [class]=\"classes\"\n  [attr.role]=\"!src ? 'img' : null\"\n  [attr.aria-hidden]=\"!ariaLabel ? true : null\"\n  [attr.aria-label]=\"ariaLabel\"\n>\n  <ng-container [ngSwitch]=\"type\">\n    <ng-container *ngSwitchCase=\"'text'\">\n      <ng-container *ngFor=\"let word of text.split(' '); first as first; last as last\">\n        <span *ngIf=\"first || last\">{{ word.slice(0, 1) }}</span>\n      </ng-container>\n    </ng-container>\n\n    <img class=\"ids-avatar__img\" [src]=\"src\" [attr.alt]=\"alt\" *ngSwitchCase=\"'src'\" />\n\n    <span class=\"ids-avatar__icon\" *ngSwitchCase=\"'icon'\">\n      {{ icon }}\n    </span>\n  </ng-container>\n</div>\n", styles: [".ids-avatar{align-items:center;background-color:var(--ids_color_action_neutral_base);border-radius:50%;color:var(--ids_color_action_neutral_contrast);display:inline-flex;font:var(--ids_textStyle_f02_s14_h20_wrg);height:var(--ids_size_general_32x);justify-content:center;line-height:1;overflow:hidden;padding-bottom:var(--ids_size_general_1x);text-align:center;width:var(--ids_size_general_32x)}.ids-avatar--primary{background-color:var(--ids_color_action_primary_base);color:var(--ids_color_action_primary_contrast)}.ids-avatar--secondary{background-color:var(--ids_color_action_secondary_base);color:var(--ids_color_action_secondary_contrast)}.ids-avatar--neutral-variant{background-color:var(--ids_color_bg_variant_01);color:var(--ids_color_action_neutral_base)}.ids-avatar--primary-variant{background-color:var(--ids_color_bg_variant_01);color:var(--ids_color_action_primary_base)}.ids-avatar--secondary-variant{background-color:var(--ids_color_bg_variant_01);color:var(--ids_color_action_secondary_base)}.ids-avatar--on-brand{background-color:var(--ids_color_bg_base);color:var(--ids_color_action_neutral_base)}.ids-avatar--on-brand.ids-avatar--primary{color:var(--ids_color_action_primary_base)}.ids-avatar--on-brand.ids-avatar--secondary{color:var(--ids_color_action_secondary_base)}.ids-avatar__icon{font:var(--ids_textStyle_icon_small)}.ids-avatar__img{height:100%;object-fit:cover;width:100%}.ids-avatar--small{font:var(--ids_textStyle_f02_s12_h18_wrg);height:var(--ids_size_general_24x);width:var(--ids_size_general_24x)}.ids-avatar--small .ids-avatar__icon{font:var(--ids_textStyle_icon_small)}.ids-avatar--large{font:var(--ids_textStyle_f02_s20_h26_wrg);height:var(--ids_size_general_48x);width:var(--ids_size_general_48x)}.ids-avatar--large .ids-avatar__icon{font:var(--ids_textStyle_icon_medium)}.ids-avatar--xlarge{font:var(--ids_textStyle_f02_s24_h32_wrg);height:var(--ids_size_general_64x);width:var(--ids_size_general_64x)}.ids-avatar--xlarge .ids-avatar__icon{font:var(--ids_textStyle_icon_large)}:host{display:inline-flex}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAvatarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-avatar', standalone: true, imports: [CommonModule], host: {
                        '[attr.aria-label]': 'null',
                        '[attr.alt]': 'null',
                        '[attr.src]': 'null',
                        '[attr.size]': 'null',
                    }, template: "<div\n  [class]=\"classes\"\n  [attr.role]=\"!src ? 'img' : null\"\n  [attr.aria-hidden]=\"!ariaLabel ? true : null\"\n  [attr.aria-label]=\"ariaLabel\"\n>\n  <ng-container [ngSwitch]=\"type\">\n    <ng-container *ngSwitchCase=\"'text'\">\n      <ng-container *ngFor=\"let word of text.split(' '); first as first; last as last\">\n        <span *ngIf=\"first || last\">{{ word.slice(0, 1) }}</span>\n      </ng-container>\n    </ng-container>\n\n    <img class=\"ids-avatar__img\" [src]=\"src\" [attr.alt]=\"alt\" *ngSwitchCase=\"'src'\" />\n\n    <span class=\"ids-avatar__icon\" *ngSwitchCase=\"'icon'\">\n      {{ icon }}\n    </span>\n  </ng-container>\n</div>\n", styles: [".ids-avatar{align-items:center;background-color:var(--ids_color_action_neutral_base);border-radius:50%;color:var(--ids_color_action_neutral_contrast);display:inline-flex;font:var(--ids_textStyle_f02_s14_h20_wrg);height:var(--ids_size_general_32x);justify-content:center;line-height:1;overflow:hidden;padding-bottom:var(--ids_size_general_1x);text-align:center;width:var(--ids_size_general_32x)}.ids-avatar--primary{background-color:var(--ids_color_action_primary_base);color:var(--ids_color_action_primary_contrast)}.ids-avatar--secondary{background-color:var(--ids_color_action_secondary_base);color:var(--ids_color_action_secondary_contrast)}.ids-avatar--neutral-variant{background-color:var(--ids_color_bg_variant_01);color:var(--ids_color_action_neutral_base)}.ids-avatar--primary-variant{background-color:var(--ids_color_bg_variant_01);color:var(--ids_color_action_primary_base)}.ids-avatar--secondary-variant{background-color:var(--ids_color_bg_variant_01);color:var(--ids_color_action_secondary_base)}.ids-avatar--on-brand{background-color:var(--ids_color_bg_base);color:var(--ids_color_action_neutral_base)}.ids-avatar--on-brand.ids-avatar--primary{color:var(--ids_color_action_primary_base)}.ids-avatar--on-brand.ids-avatar--secondary{color:var(--ids_color_action_secondary_base)}.ids-avatar__icon{font:var(--ids_textStyle_icon_small)}.ids-avatar__img{height:100%;object-fit:cover;width:100%}.ids-avatar--small{font:var(--ids_textStyle_f02_s12_h18_wrg);height:var(--ids_size_general_24x);width:var(--ids_size_general_24x)}.ids-avatar--small .ids-avatar__icon{font:var(--ids_textStyle_icon_small)}.ids-avatar--large{font:var(--ids_textStyle_f02_s20_h26_wrg);height:var(--ids_size_general_48x);width:var(--ids_size_general_48x)}.ids-avatar--large .ids-avatar__icon{font:var(--ids_textStyle_icon_medium)}.ids-avatar--xlarge{font:var(--ids_textStyle_f02_s24_h32_wrg);height:var(--ids_size_general_64x);width:var(--ids_size_general_64x)}.ids-avatar--xlarge .ids-avatar__icon{font:var(--ids_textStyle_icon_large)}:host{display:inline-flex}\n"] }]
        }], propDecorators: { size: [{
                type: Input
            }], variant: [{
                type: Input
            }], icon: [{
                type: Input
            }], text: [{
                type: Input
            }], src: [{
                type: Input
            }], alt: [{
                type: Input
            }], ariaLabel: [{
                type: Input,
                args: ['aria-label']
            }], contrast: [{
                type: Input
            }] } });

class IdsAvatarModule {
}
IdsAvatarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAvatarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsAvatarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsAvatarModule, imports: [IdsAvatarComponent, IdsCreditCardBrandComponent], exports: [IdsAvatarComponent, IdsCreditCardBrandComponent] });
IdsAvatarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAvatarModule, imports: [IdsAvatarComponent, IdsCreditCardBrandComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAvatarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsAvatarComponent, IdsCreditCardBrandComponent],
                    exports: [IdsAvatarComponent, IdsCreditCardBrandComponent],
                }]
        }] });

/**
 * Componente Banner Highlight
 *
 * **Module:**
 *
 * `import { IdsBannerHighlightModule } from '@ids/angular';`
 */
class IdsBannerHighlightComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        /**
         * @internal
         *
         * Verificar se é tipo botão
         */
        this.hasAction = false;
        /**
         * Título do Banner.
         */
        this.title = '';
        this.hasAction = this.elementRef.nativeElement.tagName === 'BUTTON';
    }
}
IdsBannerHighlightComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsBannerHighlightComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
IdsBannerHighlightComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsBannerHighlightComponent, isStandalone: true, selector: "[idsBannerHighlight]", inputs: { title: "title", contrast: "contrast" }, host: { properties: { "class.ids-banner-highlight": "true", "class.ids-banner-highlight--on-variant": "contrast === \"onVariant\"", "class.ids-banner-highlight--on-brand": "contrast === \"onBrand\"" } }, ngImport: i0, template: "<ng-content select=\"ids-icon, ids-credit-card-brand, ids-avatar, img, .ids-brand\"></ng-content>\n<div class=\"ids-banner-highlight__container\">\n  <ng-template #titleSpan>\n    <span class=\"ids-banner-highlight__title\">{{ title }}</span>\n  </ng-template>\n\n  <p *ngIf=\"!hasAction; else titleSpan\" class=\"ids-banner-highlight__title\">\n    <strong>{{ title }}</strong>\n  </p>\n\n  <ng-template #template>\n    <ng-container *ngTemplateOutlet=\"tempOutlet\"></ng-container>\n  </ng-template>\n\n  <ng-template #tempOutlet>\n    <ng-content></ng-content>\n  </ng-template>\n\n  <p *ngIf=\"!hasAction; else template\">\n    <ng-container *ngTemplateOutlet=\"tempOutlet\"></ng-container>\n  </p>\n</div>\n<ids-icon idsBannerHighlightIcon size=\"S\" *ngIf=\"hasAction\">seta_direita</ids-icon>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "ngmodule", type: IdsIconModule }, { kind: "component", type: IdsIconComponent, selector: "ids-icon", inputs: ["size", "variant", "contrast"] }, { kind: "ngmodule", type: IdsAvatarModule }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsBannerHighlightComponent, decorators: [{
            type: Component,
            args: [{ selector: '[idsBannerHighlight]', imports: [CommonModule, IdsIconModule, IdsAvatarModule], standalone: true, host: {
                        '[class.ids-banner-highlight]': 'true',
                        '[class.ids-banner-highlight--on-variant]': 'contrast === "onVariant"',
                        '[class.ids-banner-highlight--on-brand]': 'contrast === "onBrand"',
                    }, template: "<ng-content select=\"ids-icon, ids-credit-card-brand, ids-avatar, img, .ids-brand\"></ng-content>\n<div class=\"ids-banner-highlight__container\">\n  <ng-template #titleSpan>\n    <span class=\"ids-banner-highlight__title\">{{ title }}</span>\n  </ng-template>\n\n  <p *ngIf=\"!hasAction; else titleSpan\" class=\"ids-banner-highlight__title\">\n    <strong>{{ title }}</strong>\n  </p>\n\n  <ng-template #template>\n    <ng-container *ngTemplateOutlet=\"tempOutlet\"></ng-container>\n  </ng-template>\n\n  <ng-template #tempOutlet>\n    <ng-content></ng-content>\n  </ng-template>\n\n  <p *ngIf=\"!hasAction; else template\">\n    <ng-container *ngTemplateOutlet=\"tempOutlet\"></ng-container>\n  </p>\n</div>\n<ids-icon idsBannerHighlightIcon size=\"S\" *ngIf=\"hasAction\">seta_direita</ids-icon>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { title: [{
                type: Input
            }], contrast: [{
                type: Input
            }] } });

class IdsBannerHighlightModule {
}
IdsBannerHighlightModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsBannerHighlightModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsBannerHighlightModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsBannerHighlightModule, imports: [IdsBannerHighlightComponent], exports: [IdsBannerHighlightComponent] });
IdsBannerHighlightModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsBannerHighlightModule, imports: [IdsBannerHighlightComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsBannerHighlightModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsBannerHighlightComponent],
                    exports: [IdsBannerHighlightComponent],
                }]
        }] });

class IdsOverlayOriginDirective extends CdkOverlayOrigin {
}
IdsOverlayOriginDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsOverlayOriginDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
IdsOverlayOriginDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsOverlayOriginDirective, isStandalone: true, selector: "[idsOverlayOrigin]", exportAs: ["idsOverlayOrigin"], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsOverlayOriginDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsOverlayOrigin]',
                    exportAs: 'idsOverlayOrigin',
                    standalone: true,
                }]
        }] });

class IdsOverlayOriginModule {
}
IdsOverlayOriginModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsOverlayOriginModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsOverlayOriginModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsOverlayOriginModule, imports: [IdsOverlayOriginDirective], exports: [IdsOverlayOriginDirective] });
IdsOverlayOriginModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsOverlayOriginModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsOverlayOriginModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsOverlayOriginDirective],
                    exports: [IdsOverlayOriginDirective],
                }]
        }] });

class IdsBottomSheetPresentationDirective {
}
IdsBottomSheetPresentationDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsBottomSheetPresentationDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
IdsBottomSheetPresentationDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsBottomSheetPresentationDirective, isStandalone: true, selector: "[idsBottomSheetPresentation]", host: { properties: { "class.ids-bottom-sheet__presentation": "true" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsBottomSheetPresentationDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsBottomSheetPresentation]',
                    host: {
                        '[class.ids-bottom-sheet__presentation]': 'true',
                    },
                    standalone: true,
                }]
        }] });
class IdsBottomSheetFooterDirective {
    constructor() {
        /**
         * Define se o footer ficará suspenso. Ou seja, se o conteúdo do Action Sheet irá ficar
         * atrás do footer
         */
        this.idsBottomSheetFooter = '';
    }
}
IdsBottomSheetFooterDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsBottomSheetFooterDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
IdsBottomSheetFooterDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsBottomSheetFooterDirective, isStandalone: true, selector: "[idsBottomSheetFooter]", inputs: { idsBottomSheetFooter: "idsBottomSheetFooter" }, host: { properties: { "class.ids-bottom-sheet__footer": "true", "@.disabled": "true" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsBottomSheetFooterDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsBottomSheetFooter]',
                    host: {
                        '[class.ids-bottom-sheet__footer]': 'true',
                        // Desabilita animações dos filhos para não conflitar com a do BS
                        // Ex: animação do componente loading utilizado dentro do botão
                        '[@.disabled]': 'true',
                    },
                    standalone: true,
                }]
        }], propDecorators: { idsBottomSheetFooter: [{
                type: Input
            }] } });
const EXPANDED_DRAG_INDICATOR_LABEL = 'tela cheia, recolher conteúdo';
const CONTRACTED_DRAG_INDICATOR_LABEL = 'meia tela, expandir conteúdo';
/**
 * O action sheet tem um comportamento de scroll onde o seu header fica fixo quando o scroll top
 * do sheet chega a uma determinada porcentagem de altura dentro do viewport.
 *
 * *The action sheet has a scrolling behavior where its header is fixed when the top scroll of*
 * *the sheet reaches a certain percentage of height within the viewport.*
 *
 * **Module:**
 *
 * `import { IdsBottomSheetModule } from '@ids/angular';`
 *
 * **Component:**
 *
 * `import { IdsBottomSheetComponent, IdsBottomSheetPresentationDirective, IdsBottomSheetFooterDirective, IdsOverlayOriginDirective } from '@ids/angular';`
 */
class IdsBottomSheetComponent extends HammerGestureConfig {
    get classes() {
        const defaultClass = 'ids-bottom-sheet';
        return this.class ? [defaultClass, ...this.class.split(' ')] : defaultClass;
    }
    get overlayElement() {
        return this.cdkConnectedOverlay?.overlayRef?.overlayElement;
    }
    get initialPercentage() {
        return this._initialPercentage;
    }
    get bottomSheetHeight() {
        return this._bottomSheetHeight;
    }
    /**
     * Elemento para definir a altura do componente (acima de 60%. Máximo de 80%)
     *
     * *Element to define the height of the component (above 60%. Maximum of 80%)*
     */
    set maxHeightPercentage(value) {
        this._maxHeightPercentage = enforceNumber(value);
    }
    get maxHeightPercentage() {
        return this._maxHeightPercentage;
    }
    /**
     * Elemento para definir o foco quando o Bottom-sheet for fechado
     *
     * Definir manualmente o origin não é obrigatório,
     * o Bottom-sheet já detecta o elemento que disparou o evento de abertura do Bottom-sheet
     * e retorna  o foco para ele quando o Bottom-sheet fechar.
     */
    set origin(value) {
        if (value instanceof CdkOverlayOrigin) {
            this._origin = value;
            return;
        }
        this._origin = new CdkOverlayOrigin(new ElementRef(value));
    }
    get origin() {
        return this._origin || this._autoDetectedOrigin;
    }
    /**
     * Alterna o estado do componente entre aberto e fechado
     *
     * *Toggles component state between open and closed*
     */
    get open() {
        return this._open;
    }
    set open(value) {
        const isClosing = this._open && !value;
        const shouldEmit = this._open !== value;
        if (enforceBoolean(value)) {
            this._autoDetectedOrigin = new CdkOverlayOrigin(new ElementRef(document.activeElement));
        }
        this._open = enforceBoolean(value);
        if (!this.zIndex) {
            this.zIndex = getElevation();
        }
        if (isClosing) {
            this.detach();
        }
        if (shouldEmit) {
            this._emitStateEvent(this._open);
        }
    }
    /**
     * Informar essa propriedade faz com que o componente não precise receber um elemento de origem.
     * Isso é útil quando não se deseja que o foco seja redirecionado automaticamente ao
     * fechar o componente. Nesse caso, o foco precisa ser manipulado manualmente
     */
    set noOrigin(value) {
        this._noOrigin = enforceBoolean(value);
    }
    get noOrigin() {
        return this._noOrigin;
    }
    constructor(_overlay, _renderer, _cdRef, overlayContainer, _document) {
        super();
        this._overlay = _overlay;
        this._renderer = _renderer;
        this._cdRef = _cdRef;
        this.overlayContainer = overlayContainer;
        this._document = _document;
        this.scrollStrategy = this._overlay.scrollStrategies.block();
        this.overrides = { pan: { enable: true, direction: Hammer.DIRECTION_VERTICAL, threshold: 5 } };
        this.dragIndicatorLabel = CONTRACTED_DRAG_INDICATOR_LABEL;
        this.platform = platform;
        this.isVirtualKeyboardOpen = false;
        this.virtualKeyBoardHeight = 0;
        // TODO: remover variável usada apenas para teste
        this.setVoiceOverFocus = setVoiceOverFocus;
        this._destroyVK = new Subject();
        this._expanded = false;
        this._maxHeightPercentage = 60;
        this._open = false;
        /**
         * Label do botão fechar para ser lido por leitores de tela
         *
         * *Close button label to be read by screen readers*
         */
        this.closeLabel = 'fechar';
        /**
         * Evento emitido ao alterar o valor da propriedade open
         *
         * *Event emitted when changing open property value*
         */
        this.openChange = new EventEmitter();
        /**
         * Evento emitido sempre que o componente é aberto
         *
         * *Evento emitido sempre que o componente é aberto*
         */
        this.opened = new EventEmitter();
        /**
         * Evento emitido sempre que o componente é fechado
         *
         * *Event emitted whenever the component is closed*
         */
        this.closed = new EventEmitter();
        this._adjustOverlayTopPosition = (offset) => {
            const positionStrategy = this._overlay
                .position()
                .global()
                .centerHorizontally()
                .top(`${offset}px`);
            this.cdkConnectedOverlay.overlayRef.updatePositionStrategy(positionStrategy);
            this.cdkConnectedOverlay.overlayRef.updatePosition();
        };
        this._resetOverlayOnKeyBoardClosing = () => {
            const positionStrategy = this._overlay.position().global().centerHorizontally().bottom();
            this.cdkConnectedOverlay.overlayRef.updatePositionStrategy(positionStrategy);
            this.cdkConnectedOverlay.overlayRef.updatePosition();
            if (!this._expanded) {
                this._bottomSheetHeight = this._getCurrentActionSheetSize(this._initialPercentage);
                this._setOverlayHeight(`${this._initialPercentage}%`);
            }
        };
    }
    ngOnDestroy() {
        toggleMobileFocusTrap(undefined, false);
        this.removeOverlayZIndex();
        this.stopVirtualKeyboardObserver();
        this._destroyVK.complete();
    }
    _createHammerInstance() {
        this._hammer = this.buildHammer(this.draggableAreaRef.nativeElement);
        this._createHammerObserver();
    }
    _createHammerObserver() {
        /* istanbul ignore next */
        this._hammer.on('panup pandown panend', (event) => {
            if (this.isVirtualKeyboardOpen) {
                return;
            }
            if (event.type === 'panend') {
                this._onPanEnd();
                return;
            }
            this._onPan(event);
        });
    }
    stopVirtualKeyboardObserver() {
        this._destroyVK.next();
        this.virtualKeyBoardHeight = 0;
        this.isVirtualKeyboardOpen = false;
    }
    detach() {
        this.stopVirtualKeyboardObserver();
        if (this._hammer.destroy) {
            this._hammer.destroy();
        }
        toggleMobileFocusTrap(undefined, false);
        this.removeOverlayZIndex();
        this._detachOverlay();
        if (this.noOrigin) {
            return;
        }
        if (platform.os === 'IOS') {
            this.setVoiceOverFocus(this.origin.elementRef.nativeElement);
            return;
        }
        this.origin?.elementRef?.nativeElement?.focus();
    }
    // É preciso remover o overlay manualmente já que existe uma animação e o cdk overlay
    // aguarda até o fim dessa animação para destruir o overlay. E nesse caso, ele não está
    // removendo de forma automática
    _detachOverlay() {
        let count = 1;
        const interval = setInterval(() => {
            // Apenas remover se o "open" estiver falso. Se o usuário clicar muito rápido
            // no abrir e fechar, a nova instância do action sheet pode ser removida ao abrir
            /* istanbul ignore next */
            if (!this.open) {
                this.cdkConnectedOverlay.overlayRef.detach();
            }
            if (count === 100 || !this._document.querySelector('.ids-bottom-sheet') || this.open) {
                clearInterval(interval);
            }
            count++;
        }, 250);
    }
    _emitStateEvent(open) {
        if (open) {
            this.opened.emit();
            return;
        }
        this.closed.emit();
    }
    _getCurrentActionSheetSize(percentage) {
        return (window.innerHeight * percentage) / 100;
    }
    /* istanbul ignore next */
    _onPan(event) {
        const windowHeight = window.innerHeight;
        const percentage = Number((((this._bottomSheetHeight - event.deltaY) / windowHeight) * 100).toFixed());
        this._heightPercentage = percentage > 100 ? 100 : percentage;
        this._setOverlayHeight(`${this._heightPercentage}%`);
    }
    /* istanbul ignore next */
    _onPanEnd() {
        if (this._heightPercentage <= 15) {
            this._bottomSheetHeight =
                this._heightPercentage < 0 ? 0 : this._getCurrentActionSheetSize(this._heightPercentage);
            this._cdRef.detectChanges();
            this.close();
            return;
        }
        if (this._heightPercentage > 70) {
            this._bottomSheetHeight = window.innerHeight;
            this._expanded = true;
            this._setOverlayHeight('100%');
            return;
        }
        this._setOverlayHeight(`${this._initialPercentage}%`);
        this._bottomSheetHeight = this._getCurrentActionSheetSize(this._initialPercentage);
        this._expanded = false;
    }
    _setOverlayHeight(height) {
        this._renderer.setStyle(this.overlayElement, 'height', height);
    }
    _startHammerAndFocus() {
        this._cdRef.detectChanges();
        this._createHammerInstance();
        toggleMobileFocusTrap();
        if (platform.os === 'IOS') {
            setVoiceOverFocus(this.toggleButtonRef.nativeElement);
            return;
        }
        this.toggleButtonRef.nativeElement.focus();
    }
    _validateInitialHeight() {
        const windowHeight = window.innerHeight;
        const percentage = Number((this._bottomSheetHeight / windowHeight) * 100);
        if (percentage > this.maxHeightPercentage) {
            this._bottomSheetHeight = this._getCurrentActionSheetSize(this.maxHeightPercentage);
            this._initialPercentage = this.maxHeightPercentage;
            this._setOverlayHeight(`${this.maxHeightPercentage}%`);
            return;
        }
        this._initialPercentage = percentage;
        this._setOverlayHeight(`${this._initialPercentage}%`);
    }
    attach() {
        const positionStrategy = this._overlay.position().global().centerHorizontally().bottom();
        this.cdkConnectedOverlay.overlayRef.updatePositionStrategy(positionStrategy);
        this._bottomSheetHeight = this.overlayElement.offsetHeight;
        this._expanded = false;
        this.dragIndicatorLabel = CONTRACTED_DRAG_INDICATOR_LABEL;
        this.setOverlayZIndex();
        this._startHammerAndFocus();
        this._observeVirtualKeyboard();
        this._validateInitialHeight();
        // verifica por 1.2s a altura, caso haja atraso no carregamento dos estilos
        // ficar verificando a altura não é correto, pois o bottom-sheet não deve ficar mudando
        // apenas no início deve ter a altura correta
        const resizeObserver = new ResizeObserver(() => {
            /* istanbul ignore next */
            this._validateInitialHeight();
        });
        resizeObserver.observe(this.overlayElement);
        /* istanbul ignore next */
        setTimeout(() => {
            resizeObserver.disconnect();
        }, 1200);
    }
    close() {
        this.open = false;
        this.openChange.emit(this.open);
    }
    toggleState() {
        if (this.isVirtualKeyboardOpen) {
            return;
        }
        this._expanded = !this._expanded;
        if (this._expanded) {
            this.dragIndicatorLabel = EXPANDED_DRAG_INDICATOR_LABEL;
            this._bottomSheetHeight = window.innerHeight;
            this._setOverlayHeight('100%');
            return;
        }
        this.dragIndicatorLabel = CONTRACTED_DRAG_INDICATOR_LABEL;
        this._bottomSheetHeight = this._getCurrentActionSheetSize(this._initialPercentage);
        this._setOverlayHeight(`${this._initialPercentage}%`);
    }
    removeOverlayZIndex() {
        const panel = this.overlayContainer.getContainerElement();
        if (this.zIndex) {
            this._renderer.removeStyle(panel, 'z-index');
        }
    }
    setOverlayZIndex() {
        const panel = this.overlayContainer.getContainerElement();
        if (this.zIndex) {
            this._renderer.setStyle(panel, 'z-index', this.zIndex);
        }
    }
    _observeVirtualKeyboard() {
        observeVirtualKeyboard()
            .pipe(takeUntil$1(this._destroyVK))
            .subscribe(({ isOpen, height, offsetTop }) => {
            this.isVirtualKeyboardOpen = isOpen;
            this.virtualKeyBoardHeight = height;
            if (isOpen) {
                this._adjustOverlayTopPosition(offsetTop);
                this._setOverlayHeight('100%');
                this._bottomSheetHeight = window.innerHeight;
                return;
            }
            this._resetOverlayOnKeyBoardClosing();
        });
    }
}
IdsBottomSheetComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsBottomSheetComponent, deps: [{ token: i1$3.Overlay }, { token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }, { token: i1$3.OverlayContainer }, { token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component });
IdsBottomSheetComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsBottomSheetComponent, isStandalone: true, selector: "ids-bottom-sheet", inputs: { zIndex: "zIndex", maxHeightPercentage: "maxHeightPercentage", origin: "origin", open: "open", class: "class", ariaLabelledby: ["aria-labelledby", "ariaLabelledby"], closeLabel: "closeLabel", noOrigin: "noOrigin" }, outputs: { openChange: "openChange", opened: "opened", closed: "closed" }, host: { properties: { "attr.class": "null", "attr.aria-labelledby": "null" } }, queries: [{ propertyName: "footer", first: true, predicate: IdsBottomSheetFooterDirective, descendants: true }], viewQueries: [{ propertyName: "cdkConnectedOverlay", first: true, predicate: CdkConnectedOverlay, descendants: true, static: true }, { propertyName: "draggableAreaRef", first: true, predicate: ["draggableArea"], descendants: true }, { propertyName: "toggleButtonRef", first: true, predicate: ["toggleButton"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<ng-template\n  cdkConnectedOverlay\n  cdkConnectedOverlayHasBackdrop\n  cdkConnectedOverlayBackdropClass=\"ids-bottom-sheet-backdrop\"\n  [cdkConnectedOverlayOrigin]=\"origin\"\n  [cdkConnectedOverlayOpen]=\"open\"\n  [cdkConnectedOverlayPanelClass]=\"classes\"\n  [cdkConnectedOverlayScrollStrategy]=\"scrollStrategy\"\n  (attach)=\"attach()\"\n>\n  <section\n    cdkTrapFocus\n    class=\"ids-bottom-sheet__content\"\n    role=\"dialog\"\n    [attr.aria-labelledby]=\"ariaLabelledby\"\n    [@inOut]=\"{ value: true, params: { initialHeight: bottomSheetHeight } }\"\n  >\n    <div class=\"ids-bottom-sheet__draggable-area\" #draggableArea>\n      <button\n        #toggleButton\n        [attr.aria-label]=\"dragIndicatorLabel\"\n        [attr.aria-live]=\"platform.os === 'IOS' ? null : 'polite'\"\n        class=\"ids-bottom-sheet__toggle-indicator\"\n        (click)=\"toggleState()\"\n      ></button>\n\n      <header class=\"ids-bottom-sheet__header\">\n        <ng-content select=\"[idsBottomSheetPresentation]\"></ng-content>\n        <button idsIconButton variant=\"neutral\" [attr.aria-label]=\"closeLabel\" (click)=\"close()\">\n          fechar\n        </button>\n      </header>\n    </div>\n\n    <div\n      class=\"ids-bottom-sheet__body\"\n      [class.ids-bottom-sheet__body--suspended-footer]=\"\n        footer && footer.idsBottomSheetFooter === 'suspended'\n      \"\n    >\n      <ng-content></ng-content>\n    </div>\n\n    <ng-content select=\"[idsBottomSheetFooter]\"></ng-content>\n\n    <div\n      *ngIf=\"isVirtualKeyboardOpen\"\n      class=\"dummyForVirtualKeyboard\"\n      [style.height]=\"virtualKeyBoardHeight + 'px'\"\n    ></div>\n  </section>\n</ng-template>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: OverlayModule }, { kind: "directive", type: i1$3.CdkConnectedOverlay, selector: "[cdk-connected-overlay], [connected-overlay], [cdkConnectedOverlay]", inputs: ["cdkConnectedOverlayOrigin", "cdkConnectedOverlayPositions", "cdkConnectedOverlayPositionStrategy", "cdkConnectedOverlayOffsetX", "cdkConnectedOverlayOffsetY", "cdkConnectedOverlayWidth", "cdkConnectedOverlayHeight", "cdkConnectedOverlayMinWidth", "cdkConnectedOverlayMinHeight", "cdkConnectedOverlayBackdropClass", "cdkConnectedOverlayPanelClass", "cdkConnectedOverlayViewportMargin", "cdkConnectedOverlayScrollStrategy", "cdkConnectedOverlayOpen", "cdkConnectedOverlayDisableClose", "cdkConnectedOverlayTransformOriginOn", "cdkConnectedOverlayHasBackdrop", "cdkConnectedOverlayLockPosition", "cdkConnectedOverlayFlexibleDimensions", "cdkConnectedOverlayGrowAfterOpen", "cdkConnectedOverlayPush"], outputs: ["backdropClick", "positionChange", "attach", "detach", "overlayKeydown", "overlayOutsideClick"], exportAs: ["cdkConnectedOverlay"] }, { kind: "ngmodule", type: IdsIconButtonModule }, { kind: "component", type: IdsIconButtonComponent, selector: "[idsIconButton]", inputs: ["variant", "contrast", "size", "title", "aria-label"] }, { kind: "ngmodule", type: A11yModule }, { kind: "directive", type: i1$1.CdkTrapFocus, selector: "[cdkTrapFocus]", inputs: ["cdkTrapFocus", "cdkTrapFocusAutoCapture"], exportAs: ["cdkTrapFocus"] }], animations: [
        trigger('inOut', [
            transition(':enter', [
                style({ transform: 'translateY(100%)' }),
                animate('200ms cubic-bezier(0.25, 0.46, 0.45, 0.94)'),
            ]),
            transition(':leave', [
                style({ height: '{{initialHeight}}px' }),
                animate('150ms ease-out', style({ transform: 'translateY(100%)' })),
            ]),
        ]),
    ], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsBottomSheetComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-bottom-sheet', animations: [
                        trigger('inOut', [
                            transition(':enter', [
                                style({ transform: 'translateY(100%)' }),
                                animate('200ms cubic-bezier(0.25, 0.46, 0.45, 0.94)'),
                            ]),
                            transition(':leave', [
                                style({ height: '{{initialHeight}}px' }),
                                animate('150ms ease-out', style({ transform: 'translateY(100%)' })),
                            ]),
                        ]),
                    ], host: {
                        '[attr.class]': 'null',
                        '[attr.aria-labelledby]': 'null',
                    }, encapsulation: ViewEncapsulation.None, standalone: true, imports: [CommonModule, OverlayModule, IdsIconButtonModule, A11yModule], template: "<ng-template\n  cdkConnectedOverlay\n  cdkConnectedOverlayHasBackdrop\n  cdkConnectedOverlayBackdropClass=\"ids-bottom-sheet-backdrop\"\n  [cdkConnectedOverlayOrigin]=\"origin\"\n  [cdkConnectedOverlayOpen]=\"open\"\n  [cdkConnectedOverlayPanelClass]=\"classes\"\n  [cdkConnectedOverlayScrollStrategy]=\"scrollStrategy\"\n  (attach)=\"attach()\"\n>\n  <section\n    cdkTrapFocus\n    class=\"ids-bottom-sheet__content\"\n    role=\"dialog\"\n    [attr.aria-labelledby]=\"ariaLabelledby\"\n    [@inOut]=\"{ value: true, params: { initialHeight: bottomSheetHeight } }\"\n  >\n    <div class=\"ids-bottom-sheet__draggable-area\" #draggableArea>\n      <button\n        #toggleButton\n        [attr.aria-label]=\"dragIndicatorLabel\"\n        [attr.aria-live]=\"platform.os === 'IOS' ? null : 'polite'\"\n        class=\"ids-bottom-sheet__toggle-indicator\"\n        (click)=\"toggleState()\"\n      ></button>\n\n      <header class=\"ids-bottom-sheet__header\">\n        <ng-content select=\"[idsBottomSheetPresentation]\"></ng-content>\n        <button idsIconButton variant=\"neutral\" [attr.aria-label]=\"closeLabel\" (click)=\"close()\">\n          fechar\n        </button>\n      </header>\n    </div>\n\n    <div\n      class=\"ids-bottom-sheet__body\"\n      [class.ids-bottom-sheet__body--suspended-footer]=\"\n        footer && footer.idsBottomSheetFooter === 'suspended'\n      \"\n    >\n      <ng-content></ng-content>\n    </div>\n\n    <ng-content select=\"[idsBottomSheetFooter]\"></ng-content>\n\n    <div\n      *ngIf=\"isVirtualKeyboardOpen\"\n      class=\"dummyForVirtualKeyboard\"\n      [style.height]=\"virtualKeyBoardHeight + 'px'\"\n    ></div>\n  </section>\n</ng-template>\n" }]
        }], ctorParameters: function () { return [{ type: i1$3.Overlay }, { type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }, { type: i1$3.OverlayContainer }, { type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; }, propDecorators: { zIndex: [{
                type: Input
            }], maxHeightPercentage: [{
                type: Input
            }], origin: [{
                type: Input
            }], open: [{
                type: Input
            }], class: [{
                type: Input
            }], ariaLabelledby: [{
                type: Input,
                args: ['aria-labelledby']
            }], closeLabel: [{
                type: Input
            }], noOrigin: [{
                type: Input
            }], openChange: [{
                type: Output
            }], opened: [{
                type: Output
            }], closed: [{
                type: Output
            }], cdkConnectedOverlay: [{
                type: ViewChild,
                args: [CdkConnectedOverlay, { static: true }]
            }], draggableAreaRef: [{
                type: ViewChild,
                args: ['draggableArea']
            }], toggleButtonRef: [{
                type: ViewChild,
                args: ['toggleButton']
            }], footer: [{
                type: ContentChild,
                args: [IdsBottomSheetFooterDirective]
            }] } });

class IdsBottomSheetModule {
}
IdsBottomSheetModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsBottomSheetModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsBottomSheetModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsBottomSheetModule, imports: [IdsBottomSheetComponent,
        IdsBottomSheetPresentationDirective,
        IdsBottomSheetFooterDirective,
        IdsOverlayOriginModule], exports: [IdsBottomSheetComponent,
        IdsBottomSheetPresentationDirective,
        IdsBottomSheetFooterDirective,
        IdsOverlayOriginModule] });
IdsBottomSheetModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsBottomSheetModule, imports: [IdsBottomSheetComponent,
        IdsOverlayOriginModule, IdsOverlayOriginModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsBottomSheetModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        IdsBottomSheetComponent,
                        IdsBottomSheetPresentationDirective,
                        IdsBottomSheetFooterDirective,
                        IdsOverlayOriginModule,
                    ],
                    exports: [
                        IdsBottomSheetComponent,
                        IdsBottomSheetPresentationDirective,
                        IdsBottomSheetFooterDirective,
                        IdsOverlayOriginModule,
                    ],
                }]
        }] });

let NEXT_ID$o = 0;
/**
 * O Breadcrumbs é um tipo de navegação contextual que mostra a posição da pessoa usuária dentro do site ou app e permite que ela navegue de volta pelos níveis da plataforma.
 *
 * **Module:**
 *
 * `import { IdsBreadcrumbsModule } from '@ids/angular';`
 *
 * * *Component:**
 *
 * `import { IdsBreadcrumbsComponent } from '@ids/angular';`
 */
class IdsBreadcrumbsComponent {
    constructor() {
        /** @internal */
        this.id = `ids-breadcrumb-${++NEXT_ID$o}`;
        this._items = [];
        /**
         * Propriedade que recebe o texto personalizado para aria-label.
         */
        this.ariaLabel = 'trilha de navegação';
        /**
         * Permite escolher o valor do aria-current que será aplicado no último item.
         */
        this.ariaCurrent = 'true';
        this.hostAriaLabel = null;
    }
    /**
     * Propriedade que recebe a lista de itens do tipo Breadcrumbs
     */
    get items() {
        return this._items;
    }
    set items(items) {
        const breadcrumbsSize = items.length;
        this._items = items.map((item, index) => {
            if (index === breadcrumbsSize - 1) {
                item.type = 'current-page';
                return item;
            }
            if (item.href || item.routerLink) {
                item.type = 'page-link';
                return item;
            }
            item.type = 'truncate';
            return item;
        });
    }
    onClick(event, click) {
        if (click) {
            click();
            event.preventDefault();
        }
    }
}
IdsBreadcrumbsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsBreadcrumbsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IdsBreadcrumbsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsBreadcrumbsComponent, isStandalone: true, selector: "ids-breadcrumbs", inputs: { items: "items", ariaLabel: ["aria-label", "ariaLabel"], ariaCurrent: ["aria-current", "ariaCurrent"] }, host: { properties: { "attr.aria-label": "this.hostAriaLabel" } }, ngImport: i0, template: "<nav [attr.aria-label]=\"ariaLabel\" [id]=\"id\">\n  <ul class=\"ids-breadcrumbs\">\n    <li *ngFor=\"let item of items; let last = last\">\n      <ng-container [ngSwitch]=\"item.type\">\n        <ng-container *ngSwitchCase=\"'page-link'\">\n          <a\n            class=\"ids-breadcrumbs__page-link\"\n            *ngIf=\"item.href; else routerLink\"\n            [href]=\"item.href\"\n            idsActionButton\n            variant=\"neutral\"\n            size=\"S\"\n            (click)=\"onClick($event, item.click)\"\n          >\n            <span class=\"ids-breadcrumbs__seta-esquerda\">\n              <ids-icon size=\"S\"> seta_esquerda </ids-icon>\n            </span>\n            {{ item.label }}\n            <span class=\"ids-breadcrumbs__seta-direita\">\n              <ids-icon size=\"S\"> seta_direita </ids-icon>\n            </span>\n          </a>\n\n          <ng-template #routerLink>\n            <a\n              class=\"ids-breadcrumbs__page-link\"\n              [routerLink]=\"item.routerLink\"\n              [queryParams]=\"item.queryParams\"\n              [fragment]=\"item.fragment\"\n              [queryParamsHandling]=\"item.queryParamsHandling\"\n              [state]=\"item.state\"\n              [relativeTo]=\"item.relativeTo\"\n              [preserveFragment]=\"item.preserveFragment\"\n              [skipLocationChange]=\"item.skipLocationChange\"\n              [replaceUrl]=\"item.replaceUrl\"\n              idsActionButton\n              variant=\"neutral\"\n              size=\"S\"\n              (click)=\"onClick($event, item.click)\"\n            >\n              <span class=\"ids-breadcrumbs__seta-esquerda\">\n                <ids-icon size=\"S\">seta_esquerda </ids-icon>\n              </span>\n              {{ item.label }}\n              <span class=\"ids-breadcrumbs__seta-direita\">\n                <ids-icon size=\"S\">seta_direita </ids-icon>\n              </span>\n            </a>\n          </ng-template>\n        </ng-container>\n\n        <span\n          class=\"ids-breadcrumbs__truncate\"\n          *ngSwitchCase=\"'truncate'\"\n          aria-label=\"itens colapsados\"\n        >\n          ...\n          <span class=\"ids-breadcrumbs__seta-direita\">\n            <ids-icon size=\"S\" variant=\"neutral\">seta_direita</ids-icon>\n          </span>\n        </span>\n\n        <span\n          class=\"ids-breadcrumbs__current_page\"\n          *ngSwitchCase=\"'current-page'\"\n          [attr.aria-current]=\"ariaCurrent\"\n        >\n          {{ item.label }}\n        </span>\n      </ng-container>\n    </li>\n  </ul>\n</nav>\n", styles: [".ids-breadcrumbs{all:unset;all:revert;box-sizing:border-box;margin:0;align-items:center;display:block;justify-content:center;list-style:none;padding-left:0}@media (min-width: 48rem){.ids-breadcrumbs{display:inline-flex}}.ids-breadcrumbs li{all:unset;all:revert;box-sizing:border-box;white-space:nowrap}.ids-breadcrumbs__page-link.ids-action-button{padding-left:var(--ids_spacing_2x);padding-right:var(--ids_spacing_2x)}.ids-breadcrumbs__truncate{all:unset;all:revert;box-sizing:border-box;gap:var(--ids_spacing_1x);align-items:center;color:var(--ids_color_action_neutral_base);display:inline-flex;font:var(--ids_textStyle_f02_s14_h20_wbd)}.js-no-flexbox-gap .ids-breadcrumbs__truncate{margin:calc(var(--ids_spacing_1x) / -2)!important}.js-no-flexbox-gap .ids-breadcrumbs__truncate>*{margin:calc(var(--ids_spacing_1x) / 2)!important}.ids-breadcrumbs__current_page{all:unset;all:revert;box-sizing:border-box;font:var(--ids_textStyle_f02_s14_h20_wrg)}.ids-breadcrumbs__seta-direita,.ids-breadcrumbs li:not(:nth-last-child(2)){display:none}@media (min-width: 48rem){.ids-breadcrumbs__seta-direita,.ids-breadcrumbs li:not(:nth-last-child(2)){display:inline-flex}}.ids-breadcrumbs__seta-esquerda{display:inline-flex}@media (min-width: 48rem){.ids-breadcrumbs__seta-esquerda{display:none}}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { kind: "directive", type: i1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }, { kind: "ngmodule", type: IdsActionButtonModule }, { kind: "component", type: IdsActionButtonComponent, selector: "[idsActionButton]", inputs: ["variant", "contrast", "size"] }, { kind: "ngmodule", type: IdsIconModule }, { kind: "component", type: IdsIconComponent, selector: "ids-icon", inputs: ["size", "variant", "contrast"] }, { kind: "ngmodule", type: RouterModule }, { kind: "directive", type: i4.RouterLink, selector: "[routerLink]", inputs: ["target", "queryParams", "fragment", "queryParamsHandling", "state", "relativeTo", "preserveFragment", "skipLocationChange", "replaceUrl", "routerLink"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsBreadcrumbsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-breadcrumbs', standalone: true, imports: [CommonModule, IdsActionButtonModule, IdsIconModule, RouterModule], template: "<nav [attr.aria-label]=\"ariaLabel\" [id]=\"id\">\n  <ul class=\"ids-breadcrumbs\">\n    <li *ngFor=\"let item of items; let last = last\">\n      <ng-container [ngSwitch]=\"item.type\">\n        <ng-container *ngSwitchCase=\"'page-link'\">\n          <a\n            class=\"ids-breadcrumbs__page-link\"\n            *ngIf=\"item.href; else routerLink\"\n            [href]=\"item.href\"\n            idsActionButton\n            variant=\"neutral\"\n            size=\"S\"\n            (click)=\"onClick($event, item.click)\"\n          >\n            <span class=\"ids-breadcrumbs__seta-esquerda\">\n              <ids-icon size=\"S\"> seta_esquerda </ids-icon>\n            </span>\n            {{ item.label }}\n            <span class=\"ids-breadcrumbs__seta-direita\">\n              <ids-icon size=\"S\"> seta_direita </ids-icon>\n            </span>\n          </a>\n\n          <ng-template #routerLink>\n            <a\n              class=\"ids-breadcrumbs__page-link\"\n              [routerLink]=\"item.routerLink\"\n              [queryParams]=\"item.queryParams\"\n              [fragment]=\"item.fragment\"\n              [queryParamsHandling]=\"item.queryParamsHandling\"\n              [state]=\"item.state\"\n              [relativeTo]=\"item.relativeTo\"\n              [preserveFragment]=\"item.preserveFragment\"\n              [skipLocationChange]=\"item.skipLocationChange\"\n              [replaceUrl]=\"item.replaceUrl\"\n              idsActionButton\n              variant=\"neutral\"\n              size=\"S\"\n              (click)=\"onClick($event, item.click)\"\n            >\n              <span class=\"ids-breadcrumbs__seta-esquerda\">\n                <ids-icon size=\"S\">seta_esquerda </ids-icon>\n              </span>\n              {{ item.label }}\n              <span class=\"ids-breadcrumbs__seta-direita\">\n                <ids-icon size=\"S\">seta_direita </ids-icon>\n              </span>\n            </a>\n          </ng-template>\n        </ng-container>\n\n        <span\n          class=\"ids-breadcrumbs__truncate\"\n          *ngSwitchCase=\"'truncate'\"\n          aria-label=\"itens colapsados\"\n        >\n          ...\n          <span class=\"ids-breadcrumbs__seta-direita\">\n            <ids-icon size=\"S\" variant=\"neutral\">seta_direita</ids-icon>\n          </span>\n        </span>\n\n        <span\n          class=\"ids-breadcrumbs__current_page\"\n          *ngSwitchCase=\"'current-page'\"\n          [attr.aria-current]=\"ariaCurrent\"\n        >\n          {{ item.label }}\n        </span>\n      </ng-container>\n    </li>\n  </ul>\n</nav>\n", styles: [".ids-breadcrumbs{all:unset;all:revert;box-sizing:border-box;margin:0;align-items:center;display:block;justify-content:center;list-style:none;padding-left:0}@media (min-width: 48rem){.ids-breadcrumbs{display:inline-flex}}.ids-breadcrumbs li{all:unset;all:revert;box-sizing:border-box;white-space:nowrap}.ids-breadcrumbs__page-link.ids-action-button{padding-left:var(--ids_spacing_2x);padding-right:var(--ids_spacing_2x)}.ids-breadcrumbs__truncate{all:unset;all:revert;box-sizing:border-box;gap:var(--ids_spacing_1x);align-items:center;color:var(--ids_color_action_neutral_base);display:inline-flex;font:var(--ids_textStyle_f02_s14_h20_wbd)}.js-no-flexbox-gap .ids-breadcrumbs__truncate{margin:calc(var(--ids_spacing_1x) / -2)!important}.js-no-flexbox-gap .ids-breadcrumbs__truncate>*{margin:calc(var(--ids_spacing_1x) / 2)!important}.ids-breadcrumbs__current_page{all:unset;all:revert;box-sizing:border-box;font:var(--ids_textStyle_f02_s14_h20_wrg)}.ids-breadcrumbs__seta-direita,.ids-breadcrumbs li:not(:nth-last-child(2)){display:none}@media (min-width: 48rem){.ids-breadcrumbs__seta-direita,.ids-breadcrumbs li:not(:nth-last-child(2)){display:inline-flex}}.ids-breadcrumbs__seta-esquerda{display:inline-flex}@media (min-width: 48rem){.ids-breadcrumbs__seta-esquerda{display:none}}\n"] }]
        }], propDecorators: { items: [{
                type: Input
            }], ariaLabel: [{
                type: Input,
                args: ['aria-label']
            }], ariaCurrent: [{
                type: Input,
                args: ['aria-current']
            }], hostAriaLabel: [{
                type: HostBinding,
                args: ['attr.aria-label']
            }] } });

class IdsBreadcrumbsModule {
}
IdsBreadcrumbsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsBreadcrumbsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsBreadcrumbsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsBreadcrumbsModule, imports: [IdsBreadcrumbsComponent], exports: [IdsBreadcrumbsComponent] });
IdsBreadcrumbsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsBreadcrumbsModule, imports: [IdsBreadcrumbsComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsBreadcrumbsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsBreadcrumbsComponent],
                    exports: [IdsBreadcrumbsComponent],
                }]
        }] });

class IdsCheckboxComponent {
}
IdsCheckboxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsCheckboxComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IdsCheckboxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsCheckboxComponent, isStandalone: true, selector: "ids-checkbox", ngImport: i0, template: `<span class="ids-checkbox">
    <ng-content></ng-content>
    <span class="ids-checkbox__icon ids-icon" aria-hidden="true"></span>
  </span>`, isInline: true, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsCheckboxComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ids-checkbox',
                    standalone: true,
                    template: `<span class="ids-checkbox">
    <ng-content></ng-content>
    <span class="ids-checkbox__icon ids-icon" aria-hidden="true"></span>
  </span>`,
                    encapsulation: ViewEncapsulation.None,
                }]
        }] });

class FormSelectionService {
    constructor() {
        this.labelIds = [];
        this.inputIdSubject = new Subject();
        this.labelIdsSubject = new Subject();
    }
    setInputId(id = '') {
        if (!id) {
            return;
        }
        this.inputIdSubject.next(id);
    }
    setLabelId(labelId = '', index) {
        if (!labelId || this.labelIds.includes(labelId)) {
            return;
        }
        if (typeof index === 'number') {
            this.labelIds[index] = labelId;
        }
        else {
            this.labelIds.push(labelId);
        }
        this.labelIdsSubject.next(this.labelIds);
    }
}
FormSelectionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FormSelectionService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
FormSelectionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FormSelectionService, providedIn: null });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: FormSelectionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: null,
                }]
        }] });

class IdsFormSelectionInputDirective {
    set rootClasses(classes) {
        this._rootClasses = classes;
    }
    get rootClasses() {
        return this._rootClasses;
    }
    get control() {
        /* istanbul ignore next */
        return this.ngControl?.control;
    }
    get rtlDirection() {
        return this._rtlDirection;
    }
    /**
     * Informa se o input está desabilitado.
     * *Informs if the input is disabled.*
     */
    set disabled(disabled) {
        this._disabled = enforceBoolean(disabled);
    }
    get disabled() {
        return this._disabled;
    }
    /**
     * Informa se o input está inválido.
     * *Informs if the input is invalid.*
     */
    set invalid(value) {
        this._invalid = enforceBoolean(value);
    }
    get invalid() {
        return this._invalid;
    }
    /** @internal */
    set id(id) {
        if (this.formSelectionService) {
            this.formSelectionService.setInputId(id);
        }
        this._id = id;
    }
    get id() {
        return this._id;
    }
    get ariaInvalid() {
        if (platform.os === 'IOS') {
            return null;
        }
        return this.invalid;
    }
    constructor(ngControl, elementRef, formSelectionService) {
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this.formSelectionService = formSelectionService;
        this.state = '';
        this.destroy = new Subject();
        this._rtlDirection = false;
        this._isFocused = false;
        this._disabled = false;
        this._invalid = false;
        this.subscribeLabelId();
    }
    ngOnInit() {
        if (!this.formSelectionService) {
            return;
        }
        this.formSelectionService.setInputId(this.id);
    }
    ngOnDestroy() {
        this.destroy.next();
        this.destroy.complete();
    }
    subscribeLabelId() {
        if (!this.formSelectionService) {
            return;
        }
        this.formSelectionService.labelIdsSubject
            .pipe(takeUntil$1(this.destroy))
            .subscribe((labelIds) => {
            let labelledby = '';
            labelIds.forEach((labelId) => {
                labelledby = `${labelledby} ${labelId}`;
            });
            this.ariaLabelledBy = labelledby.trim();
        });
    }
    /* istanbul ignore next */
    onFocus() {
        this._isFocused = true;
    }
    /* istanbul ignore next */
    onFocusout() {
        this._isFocused = false;
    }
}
IdsFormSelectionInputDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormSelectionInputDirective, deps: [{ token: i1$2.NgControl, optional: true, self: true }, { token: i0.ElementRef }, { token: FormSelectionService, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
IdsFormSelectionInputDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsFormSelectionInputDirective, inputs: { contrast: "contrast", disabled: "disabled", invalid: "invalid", id: "id", ariaLabelledBy: ["aria-labelledby", "ariaLabelledBy"] }, host: { listeners: { "focus": "onFocus()", "focusout": "onFocusout()" }, properties: { "attr.id": "this.id", "attr.aria-invalid": "this.ariaInvalid", "attr.aria-labelledby": "this.ariaLabelledBy" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormSelectionInputDirective, decorators: [{
            type: Directive
        }], ctorParameters: function () { return [{ type: i1$2.NgControl, decorators: [{
                    type: Self
                }, {
                    type: Optional
                }] }, { type: i0.ElementRef }, { type: FormSelectionService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { contrast: [{
                type: Input
            }], disabled: [{
                type: Input
            }], invalid: [{
                type: Input
            }], id: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.id']
            }], ariaInvalid: [{
                type: HostBinding,
                args: ['attr.aria-invalid']
            }], ariaLabelledBy: [{
                type: HostBinding,
                args: ['attr.aria-labelledby']
            }, {
                type: Input,
                args: ['aria-labelledby']
            }], 
        /* istanbul ignore next */
        onFocus: [{
                type: HostListener,
                args: ['focus']
            }], 
        /* istanbul ignore next */
        onFocusout: [{
                type: HostListener,
                args: ['focusout']
            }] } });

let NEXT_ID$n = 0;
/**
 * Diretiva para utilização do Checkbox dentro do componente form-selection
 *
 * **Module:**
 *
 * `import { IdsCheckboxModule } from '@ids/angular';`
 */
class IdsCheckboxDirective extends IdsFormSelectionInputDirective {
    constructor() {
        super(...arguments);
        this._id = `ids-checkbox-${++NEXT_ID$n}`;
    }
    get rootClasses() {
        return {
            'ids-checkbox': true,
            'ids-checkbox--invalid': this.invalid,
        };
    }
    get iconClasses() {
        return 'ids-checkbox__icon ids-icon ids-icon--medium';
    }
}
IdsCheckboxDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsCheckboxDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
IdsCheckboxDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsCheckboxDirective, isStandalone: true, selector: "[idsCheckbox]", host: { properties: { "class.ids-checkbox__input": "true", "attr.type": "\"checkbox\"" } }, providers: [{ provide: IdsFormSelectionInputDirective, useExisting: IdsCheckboxDirective }], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsCheckboxDirective, decorators: [{
            type: Directive,
            args: [{
                    // TODO: remover quando corrigir o problema
                    host: {
                        '[class.ids-checkbox__input]': 'true',
                        '[attr.type]': '"checkbox"',
                    },
                    providers: [{ provide: IdsFormSelectionInputDirective, useExisting: IdsCheckboxDirective }],
                    selector: '[idsCheckbox]',
                    standalone: true,
                }]
        }] });

class IdsCheckboxModule {
}
IdsCheckboxModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsCheckboxModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsCheckboxModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsCheckboxModule, imports: [IdsCheckboxComponent, IdsCheckboxDirective], exports: [IdsCheckboxComponent, IdsCheckboxDirective] });
IdsCheckboxModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsCheckboxModule, imports: [IdsCheckboxComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsCheckboxModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsCheckboxComponent, IdsCheckboxDirective],
                    exports: [IdsCheckboxComponent, IdsCheckboxDirective],
                }]
        }] });

/**
 * O Number Badge é um componente usado para representar números que precisam de destaque.
 * Pode ser exibido em elementos como ícones ou cards para notificar que existem
 * solicitações pendentes.
 *
 * **Module:**
 *
 * `import { IdsNumberBadgeModule } from '@ids/angular';`
 */
class IdsNumberBadgeComponent {
    /**
     * Valor máximo a ser exibido
     *
     * *Maximum value to display*
     */
    set max(value) {
        if (!value) {
            return;
        }
        this._max = enforceNumber(value);
    }
    get max() {
        return this._max;
    }
    /**
     * Variável utilizada para tornar dinâmico o conteúdo à frente do valor
     *
     * *Variable used to make content ahead of value dynamic*
     */
    set maxSymbol(symbol) {
        if (!symbol) {
            return;
        }
        this._maxSymbol = symbol;
    }
    get maxSymbol() {
        return this._maxSymbol;
    }
    get accessibleValue() {
        return this._accessibleValue;
    }
    set value(value) {
        this._value = value;
    }
    get value() {
        return this._value;
    }
    constructor(_cdr) {
        this._cdr = _cdr;
        this._max = 99;
        this._maxSymbol = '+';
        this.hostAttrNull = null;
        this._accessibleValue = '';
        this._value = '0';
    }
    ngAfterViewInit() {
        this.value = this.convertBadge(this.badgeValue.nativeElement.innerText);
        this._cdr.detectChanges();
    }
    convertBadge(value = '') {
        const valueNumber = Math.abs(enforceNumber(value));
        this._accessibleValue = `${valueNumber} `;
        if (valueNumber > this.max) {
            this._accessibleValue = `mais de ${this.max} `;
            return `${this.maxSymbol}${this.max}`;
        }
        return valueNumber.toString();
    }
    onContentChange([{ target: { textContent }, },]) {
        this.value = this.convertBadge(textContent ?? '');
    }
}
IdsNumberBadgeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsNumberBadgeComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
IdsNumberBadgeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsNumberBadgeComponent, isStandalone: true, selector: "ids-number-badge, [idsNumberBadge]", inputs: { ariaLabel: ["aria-label", "ariaLabel"], max: "max", maxSymbol: "maxSymbol", contrast: "contrast", variant: "variant", size: "size" }, host: { properties: { "attr.aria-label": "this.hostAttrNull" } }, viewQueries: [{ propertyName: "badgeValue", first: true, predicate: ["badgeValue"], descendants: true }], ngImport: i0, template: "<span\n  [ngClass]=\"variant ? 'ids-number-badge ids-number-badge--' + variant : 'ids-number-badge'\"\n  [class.ids-number-badge--on-brand]=\"contrast === 'onBrand'\"\n  [class.ids-number-badge--small]=\"size === 'S'\"\n  [attr.data-max]=\"max\"\n>\n  <span\n    #badgeValue\n    [attr.aria-hidden]=\"true\"\n    class=\"ids-number-badge__content-hidden\"\n    (cdkObserveContent)=\"onContentChange($event)\"\n  >\n    <ng-content></ng-content>\n  </span>\n  <span class=\"ids-number-badge__number-formatted\" [attr.aria-hidden]=\"ariaLabel ? true : false\">\n    {{ value }}\n  </span>\n  <span *ngIf=\"ariaLabel\" class=\"ids-number-badge__hidden-aria-label\">{{\n    accessibleValue + ariaLabel\n  }}</span>\n</span>\n", styles: [".ids-number-badge{background-color:var(--ids_color_action_primary_base);border-radius:var(--ids_size_cornerRadius_layout_01);box-sizing:border-box;color:var(--ids_color_action_primary_contrast);display:inline-block;font:var(--ids_textStyle_f02_s16_h24_wbd);height:var(--ids_size_general_24x);line-height:1.2;min-width:var(--ids_size_general_24x);padding:.0625rem var(--ids_size_general_6x);position:relative;text-align:center;-webkit-user-select:none;user-select:none}.ids-number-badge--neutral{background-color:var(--ids_color_action_neutral_base);color:var(--ids_color_action_neutral_contrast)}.ids-number-badge--secondary{background-color:var(--ids_color_action_secondary_base);color:var(--ids_color_action_secondary_contrast)}.ids-number-badge--success{background-color:var(--ids_color_feedback_success);color:var(--ids_color_feedback_success_contrast)}.ids-number-badge--error{background-color:var(--ids_color_feedback_error);color:var(--ids_color_feedback_error_contrast)}.ids-number-badge--alert{background-color:var(--ids_color_feedback_alert);color:var(--ids_color_feedback_alert_contrast)}.ids-number-badge--information{background-color:var(--ids_color_feedback_information);color:var(--ids_color_feedback_information_contrast)}.ids-number-badge--on-brand{background-color:var(--ids_color_action_primary_contrast);color:var(--ids_color_action_primary_base)}.ids-number-badge--on-brand.ids-number-badge--neutral{background-color:var(--ids_color_feedback_neutral_contrast);color:var(--ids_color_action_neutral_base)}.ids-number-badge--on-brand.ids-number-badge--secondary{background-color:var(--ids_color_action_secondary_contrast);color:var(--ids_color_action_secondary_base)}.ids-number-badge--small{font:var(--ids_textStyle_f02_s14_h20_wbd);height:var(--ids_size_general_20x);line-height:1.2;min-width:var(--ids_size_general_20x)}.ids-number-badge__content-hidden{display:none}.ids-number-badge__hidden-aria-label{display:block;font-size:.3125rem;height:100%;left:0;line-clamp:2;opacity:0;overflow:hidden;position:absolute;text-overflow:ellipsis;top:0;width:100%}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: ObserversModule }, { kind: "directive", type: i2.CdkObserveContent, selector: "[cdkObserveContent]", inputs: ["cdkObserveContentDisabled", "debounce"], outputs: ["cdkObserveContent"], exportAs: ["cdkObserveContent"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsNumberBadgeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-number-badge, [idsNumberBadge]', standalone: true, imports: [CommonModule, ObserversModule], template: "<span\n  [ngClass]=\"variant ? 'ids-number-badge ids-number-badge--' + variant : 'ids-number-badge'\"\n  [class.ids-number-badge--on-brand]=\"contrast === 'onBrand'\"\n  [class.ids-number-badge--small]=\"size === 'S'\"\n  [attr.data-max]=\"max\"\n>\n  <span\n    #badgeValue\n    [attr.aria-hidden]=\"true\"\n    class=\"ids-number-badge__content-hidden\"\n    (cdkObserveContent)=\"onContentChange($event)\"\n  >\n    <ng-content></ng-content>\n  </span>\n  <span class=\"ids-number-badge__number-formatted\" [attr.aria-hidden]=\"ariaLabel ? true : false\">\n    {{ value }}\n  </span>\n  <span *ngIf=\"ariaLabel\" class=\"ids-number-badge__hidden-aria-label\">{{\n    accessibleValue + ariaLabel\n  }}</span>\n</span>\n", styles: [".ids-number-badge{background-color:var(--ids_color_action_primary_base);border-radius:var(--ids_size_cornerRadius_layout_01);box-sizing:border-box;color:var(--ids_color_action_primary_contrast);display:inline-block;font:var(--ids_textStyle_f02_s16_h24_wbd);height:var(--ids_size_general_24x);line-height:1.2;min-width:var(--ids_size_general_24x);padding:.0625rem var(--ids_size_general_6x);position:relative;text-align:center;-webkit-user-select:none;user-select:none}.ids-number-badge--neutral{background-color:var(--ids_color_action_neutral_base);color:var(--ids_color_action_neutral_contrast)}.ids-number-badge--secondary{background-color:var(--ids_color_action_secondary_base);color:var(--ids_color_action_secondary_contrast)}.ids-number-badge--success{background-color:var(--ids_color_feedback_success);color:var(--ids_color_feedback_success_contrast)}.ids-number-badge--error{background-color:var(--ids_color_feedback_error);color:var(--ids_color_feedback_error_contrast)}.ids-number-badge--alert{background-color:var(--ids_color_feedback_alert);color:var(--ids_color_feedback_alert_contrast)}.ids-number-badge--information{background-color:var(--ids_color_feedback_information);color:var(--ids_color_feedback_information_contrast)}.ids-number-badge--on-brand{background-color:var(--ids_color_action_primary_contrast);color:var(--ids_color_action_primary_base)}.ids-number-badge--on-brand.ids-number-badge--neutral{background-color:var(--ids_color_feedback_neutral_contrast);color:var(--ids_color_action_neutral_base)}.ids-number-badge--on-brand.ids-number-badge--secondary{background-color:var(--ids_color_action_secondary_contrast);color:var(--ids_color_action_secondary_base)}.ids-number-badge--small{font:var(--ids_textStyle_f02_s14_h20_wbd);height:var(--ids_size_general_20x);line-height:1.2;min-width:var(--ids_size_general_20x)}.ids-number-badge__content-hidden{display:none}.ids-number-badge__hidden-aria-label{display:block;font-size:.3125rem;height:100%;left:0;line-clamp:2;opacity:0;overflow:hidden;position:absolute;text-overflow:ellipsis;top:0;width:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { ariaLabel: [{
                type: Input,
                args: ['aria-label']
            }], max: [{
                type: Input
            }], maxSymbol: [{
                type: Input
            }], contrast: [{
                type: Input
            }], variant: [{
                type: Input
            }], size: [{
                type: Input
            }], hostAttrNull: [{
                type: HostBinding,
                args: ['attr.aria-label']
            }], badgeValue: [{
                type: ViewChild,
                args: ['badgeValue']
            }] } });

let NEXT_ID$m = 0;
/**
 * Chips são elementos  que representam uma entrada, como uma escolha de categorias,
 * ou filtros dentre múltiplas opções.
 *
 * **Module:**
 *
 * `import { IdsChipsModule } from '@ids/angular';`
 *
 * **Component:**
 *
 * `import { IdsChipsComponent } from '@ids/angular';`
 */
class IdsChipsComponent {
    constructor() {
        /** @internal */
        this.id = `ids-chips-${NEXT_ID$m++}`;
        /**
         * Legenda do grupo de opções.
         */
        this.legend = '';
        this._options = [];
        /** @internal */
        this.optionsChange = new EventEmitter();
    }
    get classes() {
        return {
            'ids-chips': true,
            'ids-chips--on-brand': this.contrast === 'onBrand',
        };
    }
    /**
     * Opções que serão exibidas
     *
     * Nesta propriedade deve ser definido um array de objetos que implementam a interface IdsChipsOption.
     */
    set options(options) {
        if (options?.length !== this._options.length) {
            this._options = options ?? [];
        }
        (options || []).forEach((option, index) => {
            const currentOption = this._options[index];
            Object.keys(option).forEach((key) => {
                currentOption[key] = option[key];
            });
            currentOption.id = option.id || `${this.id}-${index}`;
            currentOption.name = option.name || `${this.id}-${index}`;
            currentOption.checked = Boolean(option.checked);
            currentOption.disabled = Boolean(option.disabled);
        });
    }
    get options() {
        return this._options;
    }
    isNumberBadgeContrastByChecked(checked = false) {
        const contrast = this.contrast === 'onBrand' ? !checked : checked;
        return contrast ? 'onBrand' : undefined;
    }
    onChange({ target }) {
        const input = target;
        const options = deepClone(this.options).map((option) => {
            if (this.type === 'choice') {
                return {
                    ...option,
                    checked: option.id === input.id,
                };
            }
            return {
                ...option,
                checked: option.id === input.id ? !option.checked : option.checked,
            };
        });
        this.optionsChange.emit(options);
    }
    textGrouped(option) {
        let groupedText = '';
        if (option.numberBadge?.value) {
            groupedText = option.numberBadge?.value + ' ' + option.numberBadge?.ariaLabel;
        }
        return groupedText;
    }
}
IdsChipsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsChipsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IdsChipsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsChipsComponent, isStandalone: true, selector: "ids-chips", inputs: { type: "type", id: "id", legend: "legend", icon: "icon", options: "options", disabled: "disabled", contrast: "contrast" }, outputs: { optionsChange: "optionsChange" }, host: { properties: { "attr.id": "null" } }, ngImport: i0, template: "<fieldset *ngIf=\"legend; else withoutFieldset\" [class]=\"classes\">\n  <legend *ngIf=\"legend\">{{ legend }}</legend>\n  <ng-template [ngTemplateOutlet]=\"ContentRef\"></ng-template>\n</fieldset>\n\n<ng-template #withoutFieldset>\n  <div [class]=\"classes\">\n    <ng-template [ngTemplateOutlet]=\"ContentRef\"></ng-template>\n  </div>\n</ng-template>\n\n<ng-template #ContentRef>\n  <div class=\"ids-chips__options\">\n    <div *ngFor=\"let option of options\" class=\"ids-chips__item\">\n      <div\n        [class]=\"{\n          'ids-chip': true,\n          'ids-chip--on-brand': contrast === 'onBrand'\n        }\"\n      >\n        <input\n          class=\"ids-chip__input\"\n          readonly=\"true\"\n          [id]=\"option.id\"\n          [type]=\"type === 'choice' ? 'radio' : 'checkbox'\"\n          [value]=\"option.value\"\n          [disabled]=\"option.disabled || disabled\"\n          [name]=\"type === 'choice' ? id + option : option.name\"\n          [checked]=\"option.checked\"\n          (change)=\"onChange($event)\"\n          [attr.aria-labelledby]=\"option.id + '__label'\"\n        />\n        <div class=\"ids-chip__content\" [attr.aria-hidden]=\"'true'\">\n          <label [id]=\"option.id + '__label'\" class=\"ids-chip__label\" [for]=\"option.id\">\n            {{ option.label }}\n            <span *ngIf=\"option.numberBadge?.value && !option.disabled\" class=\"ids-sr-only\">\n              {{ textGrouped(option) }}\n            </span>\n          </label>\n          <ids-icon\n            *ngIf=\"(type === 'selection' || option.icon || icon) && !option.numberBadge\"\n            size=\"S\"\n          >\n            {{ type === 'selection' ? 'seta_baixo' : option.icon || icon }}\n          </ids-icon>\n          <ids-number-badge\n            *ngIf=\"option.numberBadge && !option.disabled\"\n            size=\"S\"\n            [variant]=\"contrast && !option.checked ? 'neutral' : 'secondary'\"\n            [contrast]=\"isNumberBadgeContrastByChecked(option.checked)\"\n            [aria-label]=\"option.numberBadge.ariaLabel\"\n            [max]=\"option.numberBadge.max\"\n            [maxSymbol]=\"option.numberBadge.maxSymbol\"\n          >\n            {{ option.numberBadge.value }}\n          </ids-number-badge>\n        </div>\n      </div>\n    </div>\n  </div>\n</ng-template>\n", styles: [".ids-chip{all:unset;all:revert;box-sizing:border-box;height:100%;position:relative}.ids-chip .ids-icon{color:inherit}.ids-chip .ids-number-badge{pointer-events:none}.ids-chip__content{gap:var(--ids_size_general_8x);align-items:center;border:var(--ids_size_border_small) solid var(--ids_color_action_secondary_base);border-radius:var(--ids_size_cornerRadius_tags_02);color:var(--ids_color_action_secondary_base);display:flex;font:var(--ids_textStyle_f02_s14_h20_wbd);height:100%;min-height:var(--ids_size_general_32x);padding:var(--ids_size_general_5x) var(--ids_size_general_7x);transition:background-color .2s linear;-webkit-user-select:none;user-select:none;white-space:nowrap}.js-no-flexbox-gap .ids-chip__content>*{margin:calc(var(--ids_size_general_8x) / 2)}.js-no-flexbox-gap .ids-chip__content>*:first-child{margin-left:0}.js-no-flexbox-gap .ids-chip__content>*:last-child{margin-right:0}.ids-chip__icon{margin-left:var(--ids_size_general_12x);pointer-events:none}.ids-chip__label{font:var(--ids_textStyle_f02_s14_h20_wrg);line-height:var(--ids_size_general_20x);transition:color .2s linear}.ids-chip__input{all:unset;all:revert;box-sizing:border-box;background:transparent;border:0;display:block;-webkit-appearance:none;appearance:none;margin:0;border-radius:var(--ids_size_cornerRadius_tags_02);cursor:pointer;height:100%;outline-offset:var(--ids_size_general_2x);position:absolute;width:100%}@media (pointer: coarse){.ids-chip__input{outline:0!important}.ids-chip__input:focus{outline:0!important}}@media (pointer: coarse) and (pointer: fine){.ids-chip__input:focus-visible,.ids-chip__input:focus.focus-visible{outline:0!important}}@media (pointer: fine){.ids-chip__input:focus-visible,.ids-chip__input:focus.focus-visible{outline:revert!important}}@media (pointer: fine) and (pointer: fine){.ids-chip__input:focus-visible,.ids-chip__input:focus.focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}}@media (hover: hover) and (pointer: fine){.ids-chip__input:hover:not(:disabled):not([aria-disabled=true])+.ids-chip__content,.ids-chip__input:focus-visible:not(:disabled):not([aria-disabled=true])+.ids-chip__content{background-color:var(--ids_color_action_secondary_base_soft);border-color:var(--ids_color_action_secondary_variant);color:var(--ids_color_action_secondary_variant)}}.ids-chip__input:active:not(:disabled):not([aria-disabled=true])+.ids-chip__content{background-color:var(--ids_color_action_secondary_base_soft);border-color:var(--ids_color_action_secondary_variant);color:var(--ids_color_action_secondary_variant)}.ids-chip__input:checked+.ids-chip__content{background-color:var(--ids_color_action_secondary_base);color:var(--ids_color_action_secondary_contrast)}@media (hover: hover) and (pointer: fine){.ids-chip__input:checked:hover:not(:disabled):not([aria-disabled=true])+.ids-chip__content,.ids-chip__input:checked:focus-visible:not(:disabled):not([aria-disabled=true])+.ids-chip__content{background-color:var(--ids_color_action_secondary_variant);color:var(--ids_color_action_secondary_contrast)}}.ids-chip__input:checked:active:not(:disabled):not([aria-disabled=true])+.ids-chip__content{background-color:var(--ids_color_action_secondary_variant);color:var(--ids_color_action_secondary_contrast)}.ids-chip__input:disabled{cursor:not-allowed}.ids-chip__input:disabled+.ids-chip__content{background-color:var(--ids_color_bg_base);border-color:var(--ids_color_action_disabled_variant);color:var(--ids_color_action_disabled_variant)}.ids-chip--on-brand .ids-chip__input+.ids-chip__content{background-color:transparent;border:var(--ids_size_border_small) solid var(--ids_color_contrast_onBrand_primary);color:var(--ids_color_contrast_onBrand_primary)}@media (hover: hover) and (pointer: fine){.ids-chip--on-brand .ids-chip__input:hover:not(:disabled):not([aria-disabled=true])+.ids-chip__content,.ids-chip--on-brand .ids-chip__input:focus-visible:not(:disabled):not([aria-disabled=true])+.ids-chip__content{background-color:var(--ids_color_contrast_onBrand_primary_soft);border:var(--ids_size_border_small) solid var(--ids_color_contrast_onBrand_primary);color:var(--ids_color_contrast_onBrand_primary)}}.ids-chip--on-brand .ids-chip__input:active:not(:disabled):not([aria-disabled=true])+.ids-chip__content{background-color:var(--ids_color_contrast_onBrand_primary_soft);border:var(--ids_size_border_small) solid var(--ids_color_contrast_onBrand_primary);color:var(--ids_color_contrast_onBrand_primary)}.ids-chip--on-brand .ids-chip__input:checked+.ids-chip__content{background-color:var(--ids_color_contrast_onBrand_primary);color:var(--ids_color_action_secondary_base)}@media (hover: hover) and (pointer: fine){.ids-chip--on-brand .ids-chip__input:checked:hover:not(:disabled):not([aria-disabled=true])+.ids-chip__content,.ids-chip--on-brand .ids-chip__input:checked:focus-visible:not(:disabled):not([aria-disabled=true])+.ids-chip__content{background-color:var(--ids_color_contrast_onBrand_primary_strong);border-color:var(--ids_color_contrast_onBrand_primary);color:var(--ids_color_action_secondary_base)}}.ids-chip--on-brand .ids-chip__input:checked:active:not(:disabled):not([aria-disabled=true])+.ids-chip__content{background-color:var(--ids_color_contrast_onBrand_primary_strong);border-color:var(--ids_color_contrast_onBrand_primary);color:var(--ids_color_action_secondary_base)}.ids-chip--on-brand .ids-chip__input:disabled+.ids-chip__content{border-color:var(--ids_color_contrast_onBrand_primary_medium);color:var(--ids_color_contrast_onBrand_primary_medium)}.ids-chips__legend{font:var(--ids_textStyle_f02_s16_h24_wbd);margin-bottom:var(--ids_size_general_8x)}.ids-chips__options{gap:var(--ids_size_general_8x);align-items:stretch;display:flex;flex-wrap:wrap}.js-no-flexbox-gap .ids-chips__options{margin:calc(var(--ids_size_general_8x) / -2)!important}.js-no-flexbox-gap .ids-chips__options>*{margin:calc(var(--ids_size_general_8x) / 2)!important}.ids-chips--on-brand{color:var(--ids_color_contrast_onBrand_primary)}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "component", type: IdsIconComponent, selector: "ids-icon", inputs: ["size", "variant", "contrast"] }, { kind: "component", type: IdsNumberBadgeComponent, selector: "ids-number-badge, [idsNumberBadge]", inputs: ["aria-label", "max", "maxSymbol", "contrast", "variant", "size"] }] });
__decorate([
    Memo(['contrast']),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], IdsChipsComponent.prototype, "classes", null);
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object)
], IdsChipsComponent.prototype, "disabled", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsChipsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-chips', standalone: true, imports: [CommonModule, IdsIconComponent, IdsNumberBadgeComponent], host: {
                        '[attr.id]': 'null',
                    }, template: "<fieldset *ngIf=\"legend; else withoutFieldset\" [class]=\"classes\">\n  <legend *ngIf=\"legend\">{{ legend }}</legend>\n  <ng-template [ngTemplateOutlet]=\"ContentRef\"></ng-template>\n</fieldset>\n\n<ng-template #withoutFieldset>\n  <div [class]=\"classes\">\n    <ng-template [ngTemplateOutlet]=\"ContentRef\"></ng-template>\n  </div>\n</ng-template>\n\n<ng-template #ContentRef>\n  <div class=\"ids-chips__options\">\n    <div *ngFor=\"let option of options\" class=\"ids-chips__item\">\n      <div\n        [class]=\"{\n          'ids-chip': true,\n          'ids-chip--on-brand': contrast === 'onBrand'\n        }\"\n      >\n        <input\n          class=\"ids-chip__input\"\n          readonly=\"true\"\n          [id]=\"option.id\"\n          [type]=\"type === 'choice' ? 'radio' : 'checkbox'\"\n          [value]=\"option.value\"\n          [disabled]=\"option.disabled || disabled\"\n          [name]=\"type === 'choice' ? id + option : option.name\"\n          [checked]=\"option.checked\"\n          (change)=\"onChange($event)\"\n          [attr.aria-labelledby]=\"option.id + '__label'\"\n        />\n        <div class=\"ids-chip__content\" [attr.aria-hidden]=\"'true'\">\n          <label [id]=\"option.id + '__label'\" class=\"ids-chip__label\" [for]=\"option.id\">\n            {{ option.label }}\n            <span *ngIf=\"option.numberBadge?.value && !option.disabled\" class=\"ids-sr-only\">\n              {{ textGrouped(option) }}\n            </span>\n          </label>\n          <ids-icon\n            *ngIf=\"(type === 'selection' || option.icon || icon) && !option.numberBadge\"\n            size=\"S\"\n          >\n            {{ type === 'selection' ? 'seta_baixo' : option.icon || icon }}\n          </ids-icon>\n          <ids-number-badge\n            *ngIf=\"option.numberBadge && !option.disabled\"\n            size=\"S\"\n            [variant]=\"contrast && !option.checked ? 'neutral' : 'secondary'\"\n            [contrast]=\"isNumberBadgeContrastByChecked(option.checked)\"\n            [aria-label]=\"option.numberBadge.ariaLabel\"\n            [max]=\"option.numberBadge.max\"\n            [maxSymbol]=\"option.numberBadge.maxSymbol\"\n          >\n            {{ option.numberBadge.value }}\n          </ids-number-badge>\n        </div>\n      </div>\n    </div>\n  </div>\n</ng-template>\n", styles: [".ids-chip{all:unset;all:revert;box-sizing:border-box;height:100%;position:relative}.ids-chip .ids-icon{color:inherit}.ids-chip .ids-number-badge{pointer-events:none}.ids-chip__content{gap:var(--ids_size_general_8x);align-items:center;border:var(--ids_size_border_small) solid var(--ids_color_action_secondary_base);border-radius:var(--ids_size_cornerRadius_tags_02);color:var(--ids_color_action_secondary_base);display:flex;font:var(--ids_textStyle_f02_s14_h20_wbd);height:100%;min-height:var(--ids_size_general_32x);padding:var(--ids_size_general_5x) var(--ids_size_general_7x);transition:background-color .2s linear;-webkit-user-select:none;user-select:none;white-space:nowrap}.js-no-flexbox-gap .ids-chip__content>*{margin:calc(var(--ids_size_general_8x) / 2)}.js-no-flexbox-gap .ids-chip__content>*:first-child{margin-left:0}.js-no-flexbox-gap .ids-chip__content>*:last-child{margin-right:0}.ids-chip__icon{margin-left:var(--ids_size_general_12x);pointer-events:none}.ids-chip__label{font:var(--ids_textStyle_f02_s14_h20_wrg);line-height:var(--ids_size_general_20x);transition:color .2s linear}.ids-chip__input{all:unset;all:revert;box-sizing:border-box;background:transparent;border:0;display:block;-webkit-appearance:none;appearance:none;margin:0;border-radius:var(--ids_size_cornerRadius_tags_02);cursor:pointer;height:100%;outline-offset:var(--ids_size_general_2x);position:absolute;width:100%}@media (pointer: coarse){.ids-chip__input{outline:0!important}.ids-chip__input:focus{outline:0!important}}@media (pointer: coarse) and (pointer: fine){.ids-chip__input:focus-visible,.ids-chip__input:focus.focus-visible{outline:0!important}}@media (pointer: fine){.ids-chip__input:focus-visible,.ids-chip__input:focus.focus-visible{outline:revert!important}}@media (pointer: fine) and (pointer: fine){.ids-chip__input:focus-visible,.ids-chip__input:focus.focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}}@media (hover: hover) and (pointer: fine){.ids-chip__input:hover:not(:disabled):not([aria-disabled=true])+.ids-chip__content,.ids-chip__input:focus-visible:not(:disabled):not([aria-disabled=true])+.ids-chip__content{background-color:var(--ids_color_action_secondary_base_soft);border-color:var(--ids_color_action_secondary_variant);color:var(--ids_color_action_secondary_variant)}}.ids-chip__input:active:not(:disabled):not([aria-disabled=true])+.ids-chip__content{background-color:var(--ids_color_action_secondary_base_soft);border-color:var(--ids_color_action_secondary_variant);color:var(--ids_color_action_secondary_variant)}.ids-chip__input:checked+.ids-chip__content{background-color:var(--ids_color_action_secondary_base);color:var(--ids_color_action_secondary_contrast)}@media (hover: hover) and (pointer: fine){.ids-chip__input:checked:hover:not(:disabled):not([aria-disabled=true])+.ids-chip__content,.ids-chip__input:checked:focus-visible:not(:disabled):not([aria-disabled=true])+.ids-chip__content{background-color:var(--ids_color_action_secondary_variant);color:var(--ids_color_action_secondary_contrast)}}.ids-chip__input:checked:active:not(:disabled):not([aria-disabled=true])+.ids-chip__content{background-color:var(--ids_color_action_secondary_variant);color:var(--ids_color_action_secondary_contrast)}.ids-chip__input:disabled{cursor:not-allowed}.ids-chip__input:disabled+.ids-chip__content{background-color:var(--ids_color_bg_base);border-color:var(--ids_color_action_disabled_variant);color:var(--ids_color_action_disabled_variant)}.ids-chip--on-brand .ids-chip__input+.ids-chip__content{background-color:transparent;border:var(--ids_size_border_small) solid var(--ids_color_contrast_onBrand_primary);color:var(--ids_color_contrast_onBrand_primary)}@media (hover: hover) and (pointer: fine){.ids-chip--on-brand .ids-chip__input:hover:not(:disabled):not([aria-disabled=true])+.ids-chip__content,.ids-chip--on-brand .ids-chip__input:focus-visible:not(:disabled):not([aria-disabled=true])+.ids-chip__content{background-color:var(--ids_color_contrast_onBrand_primary_soft);border:var(--ids_size_border_small) solid var(--ids_color_contrast_onBrand_primary);color:var(--ids_color_contrast_onBrand_primary)}}.ids-chip--on-brand .ids-chip__input:active:not(:disabled):not([aria-disabled=true])+.ids-chip__content{background-color:var(--ids_color_contrast_onBrand_primary_soft);border:var(--ids_size_border_small) solid var(--ids_color_contrast_onBrand_primary);color:var(--ids_color_contrast_onBrand_primary)}.ids-chip--on-brand .ids-chip__input:checked+.ids-chip__content{background-color:var(--ids_color_contrast_onBrand_primary);color:var(--ids_color_action_secondary_base)}@media (hover: hover) and (pointer: fine){.ids-chip--on-brand .ids-chip__input:checked:hover:not(:disabled):not([aria-disabled=true])+.ids-chip__content,.ids-chip--on-brand .ids-chip__input:checked:focus-visible:not(:disabled):not([aria-disabled=true])+.ids-chip__content{background-color:var(--ids_color_contrast_onBrand_primary_strong);border-color:var(--ids_color_contrast_onBrand_primary);color:var(--ids_color_action_secondary_base)}}.ids-chip--on-brand .ids-chip__input:checked:active:not(:disabled):not([aria-disabled=true])+.ids-chip__content{background-color:var(--ids_color_contrast_onBrand_primary_strong);border-color:var(--ids_color_contrast_onBrand_primary);color:var(--ids_color_action_secondary_base)}.ids-chip--on-brand .ids-chip__input:disabled+.ids-chip__content{border-color:var(--ids_color_contrast_onBrand_primary_medium);color:var(--ids_color_contrast_onBrand_primary_medium)}.ids-chips__legend{font:var(--ids_textStyle_f02_s16_h24_wbd);margin-bottom:var(--ids_size_general_8x)}.ids-chips__options{gap:var(--ids_size_general_8x);align-items:stretch;display:flex;flex-wrap:wrap}.js-no-flexbox-gap .ids-chips__options{margin:calc(var(--ids_size_general_8x) / -2)!important}.js-no-flexbox-gap .ids-chips__options>*{margin:calc(var(--ids_size_general_8x) / 2)!important}.ids-chips--on-brand{color:var(--ids_color_contrast_onBrand_primary)}\n"] }]
        }], propDecorators: { classes: [], type: [{
                type: Input
            }], id: [{
                type: Input
            }], legend: [{
                type: Input
            }], icon: [{
                type: Input
            }], options: [{
                type: Input
            }], disabled: [{
                type: Input
            }], contrast: [{
                type: Input
            }], optionsChange: [{
                type: Output
            }] } });

class IdsChipsModule {
}
IdsChipsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsChipsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsChipsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsChipsModule, imports: [IdsChipsComponent], exports: [IdsChipsComponent] });
IdsChipsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsChipsModule, imports: [IdsChipsComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsChipsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsChipsComponent],
                    exports: [IdsChipsComponent],
                }]
        }] });

/**
 * Os botões permitem que o usuário realize ações e façam escolhas com um único toque.
 *
 * *Buttons allow the user to perform actions and make choices with a single tap.*
 *
 * **Module:**
 *
 * `import { IdsContextualButtonModule } from '@ids/angular';`
 *
 * **Componente:**
 *
 * `import { IdsContextualButtonComponent } from '@ids/angular';`
 */
class IdsContextualButtonComponent {
}
IdsContextualButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsContextualButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IdsContextualButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsContextualButtonComponent, isStandalone: true, selector: "[idsContextualButton]", inputs: { contrast: "contrast" }, host: { properties: { "class.ids-contextual-button": "true", "class.ids-contextual-button--on-brand": "contrast === \"onBrand\"" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, styles: [".ids-contextual-button,:host.ids-contextual-button{all:unset;all:revert;box-sizing:border-box;padding:0;-webkit-user-select:none;user-select:none;align-items:center;background-color:transparent;border:currentcolor solid var(--ids_size_border_small);border-radius:var(--ids_size_cornerRadius_button);color:var(--ids_color_action_secondary_base);cursor:pointer;display:inline-flex;font:var(--ids_textStyle_f02_s14_h20_wbd);justify-content:center;min-height:var(--ids_size_general_32x);outline-offset:var(--ids_size_general_4x);padding:var(--ids_size_general_5x) var(--ids_size_general_16x);text-align:center;text-decoration:none}@media (pointer: coarse){.ids-contextual-button,:host.ids-contextual-button{outline:0!important}.ids-contextual-button:focus,:host.ids-contextual-button:focus{outline:0!important}}@media (pointer: coarse) and (pointer: fine){.ids-contextual-button:focus-visible,.ids-contextual-button:focus.focus-visible,:host.ids-contextual-button:focus-visible,:host.ids-contextual-button:focus.focus-visible{outline:0!important}}@media (pointer: fine){.ids-contextual-button:focus-visible,.ids-contextual-button:focus.focus-visible,:host.ids-contextual-button:focus-visible,:host.ids-contextual-button:focus.focus-visible{outline:revert!important}}@media (pointer: fine) and (pointer: fine){.ids-contextual-button:focus-visible,.ids-contextual-button:focus.focus-visible,:host.ids-contextual-button:focus-visible,:host.ids-contextual-button:focus.focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}}.ids-contextual-button:disabled,.ids-contextual-button[aria-disabled=true],:host.ids-contextual-button:disabled,:host.ids-contextual-button[aria-disabled=true]{border-color:var(--ids_color_action_disabled_base);color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){.ids-contextual-button:hover:not(:disabled):not([aria-disabled=true]),.ids-contextual-button:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-contextual-button:hover:not(:disabled):not([aria-disabled=true]),:host.ids-contextual-button:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_secondary_base_soft);color:var(--ids_color_action_secondary_variant)}}.ids-contextual-button:active:not(:disabled):not([aria-disabled=true]),:host.ids-contextual-button:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_secondary_base_soft);color:var(--ids_color_action_secondary_variant)}.ids-contextual-button--on-brand,:host.ids-contextual-button--on-brand{color:var(--ids_color_contrast_onBrand_primary)}.ids-contextual-button--on-brand:disabled,.ids-contextual-button--on-brand[aria-disabled=true],:host.ids-contextual-button--on-brand:disabled,:host.ids-contextual-button--on-brand[aria-disabled=true]{border-color:var(--ids_color_contrast_onBrand_primary_medium);color:var(--ids_color_contrast_onBrand_primary_medium)}@media (hover: hover) and (pointer: fine){.ids-contextual-button--on-brand:hover:not(:disabled):not([aria-disabled=true]),.ids-contextual-button--on-brand:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-contextual-button--on-brand:hover:not(:disabled):not([aria-disabled=true]),:host.ids-contextual-button--on-brand:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_contrast_onBrand_primary_soft);color:var(--ids_color_contrast_onBrand_primary)}}.ids-contextual-button--on-brand:active:not(:disabled):not([aria-disabled=true]),:host.ids-contextual-button--on-brand:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_contrast_onBrand_primary_soft);color:var(--ids_color_contrast_onBrand_primary)}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsContextualButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: '[idsContextualButton]', template: '<ng-content></ng-content>', host: {
                        '[class.ids-contextual-button]': 'true',
                        '[class.ids-contextual-button--on-brand]': 'contrast === "onBrand"',
                    }, standalone: true, styles: [".ids-contextual-button,:host.ids-contextual-button{all:unset;all:revert;box-sizing:border-box;padding:0;-webkit-user-select:none;user-select:none;align-items:center;background-color:transparent;border:currentcolor solid var(--ids_size_border_small);border-radius:var(--ids_size_cornerRadius_button);color:var(--ids_color_action_secondary_base);cursor:pointer;display:inline-flex;font:var(--ids_textStyle_f02_s14_h20_wbd);justify-content:center;min-height:var(--ids_size_general_32x);outline-offset:var(--ids_size_general_4x);padding:var(--ids_size_general_5x) var(--ids_size_general_16x);text-align:center;text-decoration:none}@media (pointer: coarse){.ids-contextual-button,:host.ids-contextual-button{outline:0!important}.ids-contextual-button:focus,:host.ids-contextual-button:focus{outline:0!important}}@media (pointer: coarse) and (pointer: fine){.ids-contextual-button:focus-visible,.ids-contextual-button:focus.focus-visible,:host.ids-contextual-button:focus-visible,:host.ids-contextual-button:focus.focus-visible{outline:0!important}}@media (pointer: fine){.ids-contextual-button:focus-visible,.ids-contextual-button:focus.focus-visible,:host.ids-contextual-button:focus-visible,:host.ids-contextual-button:focus.focus-visible{outline:revert!important}}@media (pointer: fine) and (pointer: fine){.ids-contextual-button:focus-visible,.ids-contextual-button:focus.focus-visible,:host.ids-contextual-button:focus-visible,:host.ids-contextual-button:focus.focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}}.ids-contextual-button:disabled,.ids-contextual-button[aria-disabled=true],:host.ids-contextual-button:disabled,:host.ids-contextual-button[aria-disabled=true]{border-color:var(--ids_color_action_disabled_base);color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){.ids-contextual-button:hover:not(:disabled):not([aria-disabled=true]),.ids-contextual-button:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-contextual-button:hover:not(:disabled):not([aria-disabled=true]),:host.ids-contextual-button:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_secondary_base_soft);color:var(--ids_color_action_secondary_variant)}}.ids-contextual-button:active:not(:disabled):not([aria-disabled=true]),:host.ids-contextual-button:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_secondary_base_soft);color:var(--ids_color_action_secondary_variant)}.ids-contextual-button--on-brand,:host.ids-contextual-button--on-brand{color:var(--ids_color_contrast_onBrand_primary)}.ids-contextual-button--on-brand:disabled,.ids-contextual-button--on-brand[aria-disabled=true],:host.ids-contextual-button--on-brand:disabled,:host.ids-contextual-button--on-brand[aria-disabled=true]{border-color:var(--ids_color_contrast_onBrand_primary_medium);color:var(--ids_color_contrast_onBrand_primary_medium)}@media (hover: hover) and (pointer: fine){.ids-contextual-button--on-brand:hover:not(:disabled):not([aria-disabled=true]),.ids-contextual-button--on-brand:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-contextual-button--on-brand:hover:not(:disabled):not([aria-disabled=true]),:host.ids-contextual-button--on-brand:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_contrast_onBrand_primary_soft);color:var(--ids_color_contrast_onBrand_primary)}}.ids-contextual-button--on-brand:active:not(:disabled):not([aria-disabled=true]),:host.ids-contextual-button--on-brand:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_contrast_onBrand_primary_soft);color:var(--ids_color_contrast_onBrand_primary)}\n"] }]
        }], propDecorators: { contrast: [{
                type: Input
            }] } });

class IdsContextualButtonModule {
}
IdsContextualButtonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsContextualButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsContextualButtonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsContextualButtonModule, imports: [IdsContextualButtonComponent], exports: [IdsContextualButtonComponent] });
IdsContextualButtonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsContextualButtonModule, imports: [IdsContextualButtonComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsContextualButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsContextualButtonComponent],
                    exports: [IdsContextualButtonComponent],
                }]
        }] });

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function IdsCurrencyMaskMixin(base) {
    return class extends base {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        constructor(...args) {
            super(...args);
            this.currencyTemplate = {
                allowNegative: false,
                decimal: ',',
                precision: 2,
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
            };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.currencyMask = (rawValue, config) => {
                const { allowNegative, decimal, precision, thousands, prefix, suffix } = {
                    ...this.currencyTemplate,
                    ...config,
                };
                if (rawValue === '') {
                    return {
                        mask: this.regExpMask(prefix + suffix),
                        valueMask: '',
                        value: '',
                    };
                }
                const onlyNumbers = this.removeMask(rawValue, true);
                let newRawValue = onlyNumbers
                    .slice(0, onlyNumbers.length - precision)
                    .replace(/^0*/g, '')
                    .replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
                if (newRawValue === '') {
                    newRawValue = '0';
                }
                newRawValue = newRawValue.replace(/\B(?=([0-9]{3})+(?![0-9]))/g, thousands);
                const decimalPart = onlyNumbers.slice(onlyNumbers.length - precision);
                const decimalValue = parseInt(decimalPart, 10) || 0;
                let newValue = parseInt(newRawValue, 10) + decimalValue / 100;
                newValue = rawValue.indexOf('-') > -1 ? -newValue : newValue;
                if (precision > 0) {
                    if (newRawValue === '0' && decimalPart.length < precision) {
                        newRawValue += decimal + '0'.repeat(precision - 1) + decimalPart;
                    }
                    else {
                        newRawValue += decimal + decimalPart;
                    }
                }
                const operator = rawValue.indexOf('-') > -1 && allowNegative && newValue !== 0 ? '-' : '';
                const cleanValue = parseFloat(newRawValue.split(thousands).join('').replace(decimal, '.')).toFixed(precision);
                return {
                    mask: this.regExpMask(operator + prefix + newRawValue + suffix),
                    valueMask: newRawValue,
                    value: cleanValue,
                };
            };
            this.currencyTemplate = { ...this.currencyTemplate, ...args[0] };
        }
    };
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function IdsDateMaskMixin(base) {
    return class DateMask extends base {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        constructor(...args) {
            super(...args);
            this.dateTemplate = {
                format: 'dd/mm/yyyy',
            };
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            this.dateMask = (rawValue, config) => {
                const format = config?.format || this.dateTemplate.format;
                const formattedValue = [];
                const range = config?.range;
                const rangeSeparator = '-';
                let i = 0;
                format.split('').forEach((v) => {
                    if (/([^dmyHMS])/.test(v)) {
                        if (/[^0-9]/.test(rawValue.split('')[i])) {
                            i++;
                        }
                        formattedValue.push(v);
                        return;
                    }
                    /* istanbul ignore next */
                    formattedValue.push(/[^0-9]/.test(rawValue.split('')[i]) ? '' : rawValue.split('')[i]);
                    i++;
                });
                const formatArray = format.split(/([^dmyHMS])/);
                const yearIndex = format
                    .split(/([^dmyHMS])/)
                    .findIndex((year) => year.includes('yy'));
                const dayRegex = [/[0-9]/, /[0-9]/];
                const monthRegex = [/[0-9]/, /[0-9]/];
                const yearRegex = formatArray[yearIndex].length > 2
                    ? [/[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/]
                    : [/[0-9]/, /[0-9]/];
                formatArray.splice(formatArray.indexOf('dd'), 1, ...dayRegex);
                formatArray.splice(formatArray.indexOf('mm'), 1, ...monthRegex);
                /* istanbul ignore next */
                formatArray.splice(formatArray.indexOf('yyyy' || 'yy'), 1, ...yearRegex);
                if (range) {
                    formatArray.push(' ', rangeSeparator, ' ', ...formatArray);
                }
                return formatArray;
            };
            this.dateTemplate = { ...this.dateTemplate, ...args[1] };
        }
    };
}

const CURRENCY_CONFIG = new InjectionToken('currency.config');
const DATE_CONFIG = new InjectionToken('date.config');
class IdsMaskdBase {
    constructor(iCurrencyConfig, iDateConfig) {
        this.iCurrencyConfig = iCurrencyConfig;
        this.iDateConfig = iDateConfig;
    }
}
class IdsMaskService extends IdsCurrencyMaskMixin(IdsDateMaskMixin(IdsMaskdBase)) {
    constructor(iCurrencyConfig, iDateConfig) {
        super(iCurrencyConfig, iDateConfig) /* istanbul ignore next */;
        this.iCurrencyConfig = iCurrencyConfig;
        this.iDateConfig = iDateConfig;
        this.placeholderChar = '_';
    }
    removeMask(value, keepOnlyDigits = false) {
        const regex = keepOnlyDigits ? /\D/g : /[^A-Za-z0-9]/g;
        return this.valueIsNotEmpty(value) ? value.replace(regex, '') : '';
    }
    valueIsNotEmpty(value) {
        return value && value !== '';
    }
    regExpMask(mask) {
        return mask
            .split('')
            .map((item) => (Number.isNaN(parseInt(item, 10)) ? item : new RegExp(/[0-9]/)));
    }
    convertMaskToPlaceholder(mask) {
        return mask.map((char) => (char instanceof RegExp ? this.placeholderChar : char)).join('');
    }
    valueWithMask(rawValue = '', 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    mask, previousConformedValue = '', currentCaretPosition = 0, guide = false, keepCharPositions = false, allowLeadingZeros = false, 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    config) {
        let cleanValue = '';
        if (typeof mask === 'function') {
            const newMask = mask(rawValue, config);
            // eslint-disable-next-line no-param-reassign
            mask = newMask.mask ? newMask.mask : newMask;
            // eslint-disable-next-line no-param-reassign
            rawValue = Object.prototype.hasOwnProperty.call(newMask, 'valueMask')
                ? newMask.valueMask
                : rawValue;
            cleanValue = Object.prototype.hasOwnProperty.call(newMask, 'value')
                ? newMask.value
                : cleanValue;
        }
        if (allowLeadingZeros) {
            const onlyNumbers = this.removeMask(rawValue, true);
            let length = 0;
            mask
                .map((char) => {
                length = char instanceof RegExp ? length + 1 : length;
            })
                .join('');
            let newRawValue = onlyNumbers.replace(/^0*/g, '');
            if (newRawValue.length > length) {
                newRawValue = onlyNumbers.slice(0, -1);
            }
            // eslint-disable-next-line no-param-reassign
            rawValue = ('0'.repeat(length - newRawValue.length) + newRawValue);
        }
        const suppressGuide = guide === false && previousConformedValue !== undefined;
        const maskString = this.convertMaskToPlaceholder(mask);
        const editDistance = rawValue.length - previousConformedValue.length;
        const isAddition = editDistance > 0;
        const indexOfFirstChange = currentCaretPosition + (isAddition ? -editDistance : 0);
        const indexOfLastChange = indexOfFirstChange + Math.abs(editDistance);
        let conformedValue = '';
        if (!isAddition && keepCharPositions) {
            let compensatingPlaceholderChars = '';
            for (let i = indexOfFirstChange; i < indexOfLastChange; i++) {
                if (maskString[i] === this.placeholderChar) {
                    compensatingPlaceholderChars += this.placeholderChar;
                }
            }
            // eslint-disable-next-line no-param-reassign
            rawValue =
                rawValue.slice(0, indexOfFirstChange) +
                    compensatingPlaceholderChars +
                    rawValue.slice(indexOfFirstChange, rawValue.length);
        }
        const rawValueArr = rawValue.split('').map((char, i) => ({
            char,
            isNew: i >= indexOfFirstChange && i < indexOfLastChange,
        }));
        for (let i = rawValue.length - 1; i >= 0; i--) {
            if (rawValueArr[i].char !== this.placeholderChar) {
                const shouldOffset = i >= indexOfFirstChange && previousConformedValue.length === mask.length;
                if (rawValueArr[i].char === maskString[shouldOffset ? i - editDistance : i]) {
                    rawValueArr.splice(i, 1);
                }
            }
            break;
        }
        placeholderLoop: for (let i = 0; i < maskString.length; i++) {
            if (maskString[i] === this.placeholderChar) {
                if (rawValueArr.length > 0) {
                    while (rawValueArr.length > 0) {
                        const rawValueShift = rawValueArr.shift();
                        if (rawValueShift && this.placeholderChar === rawValueShift.char && !suppressGuide) {
                            conformedValue += this.placeholderChar;
                            continue placeholderLoop;
                        }
                        if (rawValueShift && mask[i].test(rawValueShift.char)) {
                            if (!keepCharPositions ||
                                !rawValueShift.isNew ||
                                previousConformedValue === '' ||
                                !guide ||
                                !isAddition) {
                                conformedValue += rawValueShift.char;
                            }
                            else {
                                let indexOfNextAvailablePlaceholderChar = null;
                                for (let index = 0; rawValueArr.length > index; index++) {
                                    const charData = rawValueArr[index];
                                    if (charData.char !== this.placeholderChar && !charData.isNew) {
                                        break;
                                    }
                                    if (charData.char === this.placeholderChar) {
                                        indexOfNextAvailablePlaceholderChar = index;
                                        break;
                                    }
                                }
                                if (indexOfNextAvailablePlaceholderChar !== null) {
                                    conformedValue += rawValueShift.char;
                                    rawValueArr.splice(indexOfNextAvailablePlaceholderChar, 1);
                                }
                                else {
                                    i--;
                                }
                            }
                            continue placeholderLoop;
                        }
                    }
                }
                if (!suppressGuide) {
                    conformedValue += maskString.substr(i, maskString.length);
                }
                break;
            }
            conformedValue += maskString[i];
        }
        if (suppressGuide && !isAddition) {
            let indexOfLastFilledPlaceholderChar = null;
            for (let i = 0; i < conformedValue.length; i++) {
                if (maskString[i] === this.placeholderChar) {
                    indexOfLastFilledPlaceholderChar = i;
                }
            }
            if (indexOfLastFilledPlaceholderChar !== null) {
                conformedValue = conformedValue.substr(0, indexOfLastFilledPlaceholderChar + 1);
            }
            else {
                conformedValue = '';
            }
        }
        cleanValue = this.verifyAndAdjustDecimal(config, conformedValue, this.valueIsNotEmpty(cleanValue) ? cleanValue : this.removeMask(conformedValue));
        return {
            valueMask: conformedValue,
            placeholder: maskString,
            value: cleanValue,
        };
    }
    adjustCaretPosition(rawValue = '', 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    conformedValue, placeholder, currentCaretPosition, previousConformedValue = '', isGuide = false, isAllowLeadingZeros = false, keepCharPositions = false, isDateMask = false, caretTrapIndexes = []) {
        if (currentCaretPosition === 0 || !rawValue.length) {
            return 0;
        }
        const rawValueLength = rawValue.length;
        const previousConformedValueLength = previousConformedValue.length;
        const placeholderLength = placeholder.length;
        const conformedValueLength = conformedValue.length;
        const editLength = rawValueLength - previousConformedValueLength;
        const isAddition = editLength > 0;
        const possiblyHasRejectedChar = isAddition && (previousConformedValue === conformedValue || conformedValue === placeholder);
        if ((!keepCharPositions || (keepCharPositions && isAddition) || isAllowLeadingZeros) &&
            (!isGuide || (isGuide && !isAddition)) &&
            (!isAllowLeadingZeros || (isAllowLeadingZeros && !isAddition)) &&
            conformedValueLength === previousConformedValueLength &&
            !possiblyHasRejectedChar &&
            conformedValue !== previousConformedValue) {
            return currentCaretPosition + 1;
        }
        let startingSearchIndex = 0;
        let targetChar = '';
        if (possiblyHasRejectedChar) {
            startingSearchIndex = currentCaretPosition - editLength;
        }
        else {
            const normalizedConformedValue = conformedValue.toLowerCase();
            const normalizedRawValue = rawValue.toLowerCase();
            const leftHalfChars = normalizedRawValue.substr(0, currentCaretPosition).split('');
            const intersection = leftHalfChars.filter((char) => normalizedConformedValue.indexOf(char) !== -1);
            targetChar = intersection[intersection.length - 1];
            const countTargetCharInIntersection = intersection.filter((char) => char === targetChar).length;
            const countTargetCharInPlaceholder = placeholder
                .substr(0, placeholder.indexOf(this.placeholderChar))
                .split('')
                .filter((char, index) => char === targetChar && rawValue[index] !== char).length;
            const requiredNumberOfMatches = countTargetCharInPlaceholder + countTargetCharInIntersection;
            let numberOfEncounteredMatches = 0;
            for (let i = 0; i < conformedValueLength; i++) {
                const conformedValueChar = normalizedConformedValue[i];
                startingSearchIndex = i + 1;
                if (conformedValueChar === targetChar) {
                    numberOfEncounteredMatches++;
                }
                if (numberOfEncounteredMatches >= requiredNumberOfMatches) {
                    break;
                }
            }
        }
        if (isAddition) {
            let lastPlaceholderChar = startingSearchIndex;
            for (let i = startingSearchIndex; i <= placeholderLength; i++) {
                if (placeholder[i] === this.placeholderChar) {
                    lastPlaceholderChar = i;
                }
                if (placeholder[i] === this.placeholderChar ||
                    (caretTrapIndexes && caretTrapIndexes.indexOf(i) !== -1) ||
                    i === placeholderLength) {
                    return lastPlaceholderChar;
                }
            }
        }
        for (let i = startingSearchIndex; i >= 0; i--) {
            const isDateMaskSeparator = isDateMask && placeholder[i - 1].search(/[ /-]/g) !== -1;
            if (placeholder[i - 1] === this.placeholderChar ||
                isDateMaskSeparator ||
                caretTrapIndexes.indexOf(i) !== -1 ||
                i === 0) {
                return i;
            }
        }
        return;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    verifyAndAdjustDecimal(config, valueWithMask, cleanValue) {
        if (!this.valueIsNotEmpty(cleanValue) || cleanValue.indexOf('.') !== -1 || !config?.decimal) {
            return cleanValue;
        }
        const { decimal, precision = 0 } = config;
        const decimalIndex = valueWithMask.indexOf(decimal);
        if (decimalIndex === -1) {
            return cleanValue;
        }
        const value = `${cleanValue.slice(0, decimalIndex)}.${cleanValue.slice(decimalIndex)}`;
        return precision > 0 ? parseFloat(value).toFixed(precision) : value;
    }
}
IdsMaskService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMaskService, deps: [{ token: CURRENCY_CONFIG, optional: true }, { token: DATE_CONFIG, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
IdsMaskService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMaskService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMaskService, decorators: [{
            type: Injectable
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [CURRENCY_CONFIG]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [DATE_CONFIG]
                }] }]; } });

/**
 * Diretiva para utilização de máscaras personalizadas em inputs
 *
 * **Module:**
 *
 * `import { IdsMaskModule } from '@ids/angular';`
 */
class IdsMaskDirective {
    constructor(ngControl, elementRef, idsMaskService, renderer, la) {
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this.idsMaskService = idsMaskService;
        this.renderer = renderer;
        this.la = la;
        this._announce = false;
        this._lastKey = '';
        this._shouldKeepMask = false;
        // eslint-disable-next-line
        this._onChange = (_) => { };
        // eslint-disable-next-line no-empty-function, @typescript-eslint/no-empty-function
        this._onTouched = () => { };
        /** máscara com guia a esquerda */
        this.allowLeadingZeros = false;
        /** Força o cursor para ficar sempre ao final do valor, útil para campos de moeda */
        this.forceEndCursor = false;
        /** máscara com guia */
        this.guide = false;
        /** define se mantém a posição de valor */
        this.keepCharPositions = false;
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
        }
    }
    ngOnInit() {
        this._handleMaskType();
    }
    ngAfterViewInit() {
        if ((this._value && typeof this._value === 'string') ||
            this._value?.length > 0 ||
            (this.guide && this.idsMask !== 'date')) {
            this.setValueMask();
        }
    }
    get isCurrencyOnIOS() {
        return platform.os === 'IOS' && this.idsMask === 'currency';
    }
    get isCurrencyOnMobile() {
        return platform.isMobile && this.idsMask === 'currency';
    }
    get isRangeDate() {
        return this.config?.range;
    }
    /** define se anuncia o valor ao preencher. Por padrão, o anúncio é feito
     * para máscaras de `data` e `moeda`.
     */
    set announce(announce) {
        this._announce = enforceBoolean(announce);
    }
    get announce() {
        const shouldAnnounce = this.idsMask === 'date' || this.idsMask === 'currency';
        return this._announce || shouldAnnounce;
    }
    /** Configuração da máscara */
    set config(config) {
        // copia a configuração para não acontecer de alterar o objeto externo
        this._config = deepClone(config);
    }
    get config() {
        return this._config;
    }
    set disabled(value) {
        this._disabled = enforceBoolean(value);
    }
    get disabled() {
        return (this._disabled ||
            (this.ngControl ? (this.ngControl.disabled && !this.controlValue) || null : null));
    }
    /** máscara customizada */
    set idsMask(value) {
        this._idsMask = value;
        if (this.ngControl?.dirty) {
            this._handleMaskType();
        }
    }
    get idsMask() {
        return this._idsMask;
    }
    set readonly(value) {
        this._readonly = enforceBoolean(value);
    }
    get readonly() {
        return (this._readonly ||
            (this.ngControl ? (this.ngControl.disabled && !!this.controlValue) || null : null));
    }
    /** define se mantém a máscara. Para `datas`, a máscara é sempre mantida */
    set shouldKeepMask(keepMask) {
        this._shouldKeepMask = enforceBoolean(keepMask);
    }
    get shouldKeepMask() {
        return this._shouldKeepMask || this.idsMask === 'date';
    }
    /** valor do input */
    set value(value) {
        if (value !== this._value) {
            this._value = this.handleValue(value);
            this._onChange(value);
        }
    }
    get value() {
        return this._value;
    }
    handleValue(value) {
        if (typeof value === 'number' &&
            (this.idsMask === 'currency' || (this.config && this.config.decimal))) {
            return value.toFixed(this.config?.precision ?? '2');
        }
        return value;
    }
    get controlValue() {
        return this._value;
    }
    get inputmode() {
        const inputmode = this.elementRef.nativeElement.getAttribute('inputmode');
        if (this.isCurrencyOnMobile) {
            return inputmode || 'decimal';
        }
        return inputmode;
    }
    get pattern() {
        const pattern = this.elementRef.nativeElement.getAttribute('pattern');
        // o pattern não deve ser aplicado no Android, pois o leitor de telas passa a
        // dizer "invalid input, invalid entry", mesmo sem o prefixo de "R$"
        // essa regra somente é necessária para mostrar o teclado numérico no iPhone
        if (this.isCurrencyOnIOS) {
            return pattern || '[0-9.?,]*';
        }
        return pattern;
    }
    /* istanbul ignore next */
    controlBlur() {
        this._onTouched();
    }
    controlChange() {
        this._onChange(this.value);
    }
    onInput(target) {
        if (this.idsMask === 'date') {
            this._handleMaskOnInput(target, (value) => this._transformDateValue(value, false));
            this.value = this.isRangeDate ? this._setDateRangeValue() : this.value;
            return;
        }
        this._handleMaskOnInput(target);
    }
    onKeyDown(code = '') {
        this._lastKey = code;
    }
    registerOnChange(fn) {
        this._onChange = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
    writeValue(value) {
        this.value = value;
        if (this._mask) {
            this.setValueMask();
        }
    }
    setValueMask() {
        const value = this.valueMask(this._value?.toString(), this.elementRef.nativeElement.selectionEnd);
        this.renderer.setProperty(this.elementRef.nativeElement, 'value', value.valueMask);
        this._previousMaskValue = value.valueMask;
    }
    valueMask(value, selectionEnd) {
        const valueMask = this.idsMaskService.valueWithMask(value, this._mask, this._previousMaskValue, selectionEnd, Boolean(this.guide), Boolean(this.keepCharPositions), Boolean(this.allowLeadingZeros), this.config);
        const position = this.idsMaskService.adjustCaretPosition(value, valueMask.valueMask, valueMask.placeholder, selectionEnd, this._previousMaskValue, Boolean(this.guide), Boolean(this.allowLeadingZeros), Boolean(this.keepCharPositions), this.idsMask === 'date');
        return {
            valueMask: valueMask.valueMask,
            cleanValue: valueMask.value,
            position,
        };
    }
    _announceValue() {
        if (this.announce) {
            const announcement = this.idsMask === 'currency' && this.prefixToBeAnnounced
                ? `${this.prefixToBeAnnounced} ${this._valueMask.valueMask}`
                : this._valueMask.valueMask;
            this.la.announce(announcement, 1000);
        }
    }
    _handleMaskOnInput(target, transformValueFn) {
        let inputValue = target.value;
        if (transformValueFn) {
            inputValue = transformValueFn(inputValue);
        }
        this._valueMask = this.valueMask(inputValue, target.selectionEnd ?? 0);
        this.value = this.shouldKeepMask ? this._valueMask.valueMask : this._valueMask.cleanValue;
        this._renderElementValue();
        this._setCursorPosition(target);
        this._previousMaskValue = this._valueMask.valueMask;
        this._announceValue();
    }
    _renderElementValue() {
        this.renderer.setProperty(this.elementRef.nativeElement, 'value', this._valueMask.valueMask);
    }
    _handleMaskType() {
        if (this.idsMask === 'currency') {
            // inicializa o valor para garantir a mascara inicial R$ 0,00
            if (!this.value || this._value === '') {
                this._value = '0';
            }
            return (this._mask = this.idsMaskService.currencyMask);
        }
        if (this.idsMask === 'date') {
            this.guide = true;
            this.keepCharPositions = true;
            return (this._mask = this.idsMaskService.dateMask);
        }
        if (typeof this.idsMask === 'string') {
            return (this._mask = this.idsMaskService.regExpMask(this.idsMask));
        }
        return (this._mask = this.idsMask);
    }
    _transformDateValue(value = '', removePlaceholder = true) {
        const placeholder = this.idsMaskService.placeholderChar;
        const searchPattern = removePlaceholder ? RegExp(`${placeholder}`, 'g') : / /g;
        const stringToReplace = removePlaceholder ? ' ' : `${placeholder}`;
        const RANGE_SEPARATOR = '-';
        const rangePattern = RegExp(`(\\s?${RANGE_SEPARATOR}\\s?)|\\s`, 'g');
        const shouldKeepPreviousMaskValue = (!value.includes(RANGE_SEPARATOR) && this._lastKey === 'Backspace') ||
            this._lastKey === 'Space' ||
            // Aqui testa se o separador tá acompanhando de alguma palavra na esquerda ou direita,
            // se for o caso, mantém o valor anterior já que caracteres nessas posições precisam ser
            // descartados.
            /\w-|-\w/.test(value);
        let transformedValue;
        if (!value) {
            return value;
        }
        transformedValue =
            removePlaceholder || !this.isRangeDate
                ? value.replace(searchPattern, stringToReplace)
                : shouldKeepPreviousMaskValue
                    ? this._previousMaskValue
                    : // A próxima linha busca pelo separador entre espaços opcionais e substitui todo
                        // os demais caracteres por "_", mantendo o separador e os espaços que o acompanham
                        value.replace(rangePattern, (_match, capture) => (capture ? capture : '_'));
        const valueWithoutMask = transformedValue.replace(/[ /-]/g, '');
        if (removePlaceholder && valueWithoutMask.length === 0) {
            transformedValue = '';
        }
        return transformedValue;
    }
    _setCursorPosition(target) {
        const hasPressedBackspace = this._lastKey === 'Backspace';
        const { position, valueMask } = this._valueMask;
        const isCursorInTheEnd = position === valueMask.length - 1 || position === valueMask.length;
        if ((this.forceEndCursor && hasPressedBackspace && isCursorInTheEnd) ||
            this.idsMask === 'currency') {
            return;
        }
        target.setSelectionRange(position ?? 0, position ?? 0, 'none');
    }
    _setDateRangeValue() {
        const { valueMask, cleanValue } = this._valueMask;
        const formatLength = this.config?.format?.length || 10;
        const cleanValueFormatLength = this.config?.format?.replace(/[/-]/g, '').length || 8;
        const secondDateValue = valueMask.substring(formatLength + 3, formatLength * 2 + 3);
        return [
            valueMask.substring(0, formatLength),
            cleanValue.length > cleanValueFormatLength ? secondDateValue : '',
        ];
    }
}
IdsMaskDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMaskDirective, deps: [{ token: i1$2.NgControl, optional: true, self: true }, { token: i0.ElementRef }, { token: IdsMaskService }, { token: i0.Renderer2 }, { token: i1$1.LiveAnnouncer }], target: i0.ɵɵFactoryTarget.Directive });
IdsMaskDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsMaskDirective, isStandalone: true, selector: "[idsMask]", inputs: { announce: "announce", allowLeadingZeros: "allowLeadingZeros", config: "config", disabled: "disabled", forceEndCursor: "forceEndCursor", guide: "guide", idsMask: "idsMask", keepCharPositions: "keepCharPositions", readonly: "readonly", shouldKeepMask: "shouldKeepMask", value: "value" }, host: { listeners: { "blur": "controlBlur()", "change": "controlChange()", "input": "onInput($event.target)", "keydown": "onKeyDown($event.code)" }, properties: { "disabled": "this.disabled", "readonly": "this.readonly", "attr.value": "this.controlValue", "attr.inputmode": "this.inputmode", "attr.pattern": "this.pattern" } }, ngImport: i0 });
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object)
], IdsMaskDirective.prototype, "allowLeadingZeros", void 0);
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object)
], IdsMaskDirective.prototype, "forceEndCursor", void 0);
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object)
], IdsMaskDirective.prototype, "guide", void 0);
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object)
], IdsMaskDirective.prototype, "keepCharPositions", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMaskDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsMask]',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: i1$2.NgControl, decorators: [{
                    type: Self
                }, {
                    type: Optional
                }] }, { type: i0.ElementRef }, { type: IdsMaskService }, { type: i0.Renderer2 }, { type: i1$1.LiveAnnouncer }]; }, propDecorators: { announce: [{
                type: Input
            }], allowLeadingZeros: [{
                type: Input
            }], config: [{
                type: Input
            }], disabled: [{
                type: Input,
                args: ['disabled']
            }, {
                type: HostBinding,
                args: ['disabled']
            }], forceEndCursor: [{
                type: Input
            }], guide: [{
                type: Input
            }], idsMask: [{
                type: Input
            }], keepCharPositions: [{
                type: Input
            }], readonly: [{
                type: Input,
                args: ['readonly']
            }, {
                type: HostBinding,
                args: ['readonly']
            }], shouldKeepMask: [{
                type: Input
            }], value: [{
                type: Input
            }], controlValue: [{
                type: HostBinding,
                args: ['attr.value']
            }], inputmode: [{
                type: HostBinding,
                args: ['attr.inputmode']
            }], pattern: [{
                type: HostBinding,
                args: ['attr.pattern']
            }], 
        /* istanbul ignore next */
        controlBlur: [{
                type: HostListener,
                args: ['blur']
            }], controlChange: [{
                type: HostListener,
                args: ['change']
            }], onInput: [{
                type: HostListener,
                args: ['input', ['$event.target']]
            }], onKeyDown: [{
                type: HostListener,
                args: ['keydown', ['$event.code']]
            }] } });

class IdsMaskPipe {
    constructor(idsMaskService) {
        this.idsMaskService = idsMaskService;
    }
    transform(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    value, mask, config) {
        this._mask = mask;
        if (typeof mask === 'string') {
            this._mask = this.idsMaskService.regExpMask(mask);
        }
        if (mask === 'date') {
            const dateConfig = config ? ('format' in config ? config : undefined) : undefined;
            this._mask = this.idsMaskService.dateMask(value, dateConfig);
        }
        if (mask === 'currency') {
            const currencyConfig = config ? ('prefix' in config ? config : undefined) : undefined;
            this._mask = this.idsMaskService.currencyMask.bind(this, value, currencyConfig);
        }
        return this.valueMask(value);
    }
    valueMask(value) {
        const valueMask = this.idsMaskService.valueWithMask(value, this._mask);
        return valueMask.valueMask;
    }
}
IdsMaskPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMaskPipe, deps: [{ token: IdsMaskService }], target: i0.ɵɵFactoryTarget.Pipe });
IdsMaskPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsMaskPipe, isStandalone: true, name: "idsMask" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMaskPipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'idsMask',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: IdsMaskService }]; } });

class IdsMaskModule {
    static forRoot(maskConfig) {
        return {
            ngModule: IdsMaskModule,
            providers: [
                {
                    provide: CURRENCY_CONFIG,
                    useValue: maskConfig.currencyConfig,
                },
                {
                    provide: DATE_CONFIG,
                    useValue: maskConfig.dateConfig,
                },
            ],
        };
    }
}
IdsMaskModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMaskModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsMaskModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsMaskModule, imports: [IdsMaskDirective, IdsMaskPipe], exports: [IdsMaskDirective, IdsMaskPipe] });
IdsMaskModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMaskModule, providers: [IdsMaskService] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMaskModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsMaskDirective, IdsMaskPipe],
                    exports: [IdsMaskDirective, IdsMaskPipe],
                    providers: [IdsMaskService],
                }]
        }] });

/* istanbul ignore file */
const idsDateValidator = ({ min, max, format, filter } = {}) => ({ value }) => {
    const valid = validateDate(value, {
        min,
        max,
        format,
        filter,
    });
    const notEmpty = value?.replace(/\D/g, '').length !== 0;
    if (notEmpty && !valid) {
        return { date: { value } };
    }
    return null;
};

let NEXT_ID$l = 0;
/**
 * O loading indica ao usuário o status de um processo que está sendo realizado,
 * exclusivo para o carregamento interno de uma sessão específica dentro da página.
 *
 * *The loading indicates to the user the status of a process that is being carried out,*
 * *exclusive for the internal loading of a specific session within the page.*
 *
 * **Module:**
 *
 * `import { IdsLoadingModule, IdsIconModule } from '@ids/angular';`
 *
 * **Componente:**
 *
 * `import { IdsLoadingComponent, IdsIconComponent } from '@ids/angular';`
 */
class IdsLoadingComponent {
    /**
     * Tamanho do loading.
     *
     * size = 'XS'
     *
     * size = 'S'
     *
     * size = 'L'
     *
     * size = 'XL'
     *
     * *Loading size*
     *
     * *size = 'XS'*
     * *size = 'S'*
     * *size = 'L'*
     * *size = 'XL'*
     */
    set size(value) {
        this._size = value;
        this.circleRadius = this._circleRadiusValues[this.size];
    }
    get size() {
        return enforceCase(this._size, 'upperCase');
    }
    constructor(liveAnnouncer) {
        this.liveAnnouncer = liveAnnouncer;
        this._circleRadiusValues = {
            XS: 8,
            S: 12,
            L: 32,
            XL: 64,
        };
        this.circleRadius = 16;
        /**
         * Id do componente
         *
         * *component id*
         */
        this.id = `ids-loading-${NEXT_ID$l++}`;
        /**
         * define um valor de string que rotula o componente
         *
         * *defines a string value that labels the component*
         */
        this.ariaLabel = 'carregando';
    }
    ngAfterViewInit() {
        if (this.ariaLive) {
            this.liveAnnouncer.announce(this.ariaLabel, this.ariaLive, 1000);
        }
    }
}
IdsLoadingComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsLoadingComponent, deps: [{ token: i1$1.LiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component });
IdsLoadingComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsLoadingComponent, isStandalone: true, selector: "ids-loading", inputs: { id: "id", ariaHidden: ["aria-hidden", "ariaHidden"], ariaLabel: ["aria-label", "ariaLabel"], ariaLive: ["aria-live", "ariaLive"], role: "role", contrast: "contrast", variant: "variant", size: "size" }, host: { properties: { "@inOut": "true", "attr.id": "null", "attr.aria-hidden": "null", "attr.aria-label": "null", "attr.aria-live": "null", "attr.role": "null" } }, ngImport: i0, template: "<div\n  class=\"ids-loading\"\n  [class.ids-loading--xsmall]=\"size === 'XS'\"\n  [class.ids-loading--small]=\"size === 'S'\"\n  [class.ids-loading--large]=\"size === 'L'\"\n  [class.ids-loading--xlarge]=\"size === 'XL'\"\n  [class.ids-loading--on-brand]=\"contrast === 'onBrand'\"\n  [class.ids-loading--secondary]=\"variant === 'secondary'\"\n  [attr.id]=\"id\"\n  [attr.aria-hidden]=\"ariaHidden\"\n  [attr.role]=\"role\"\n>\n  <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"ids-loading__svg\" role=\"img\">\n    <title>{{ ariaLabel }}</title>\n    <circle class=\"ids-loading__circle-ring\" cx=\"50%\" cy=\"50%\" [attr.r]=\"circleRadius\" />\n    <circle class=\"ids-loading__circle-spinner\" cx=\"50%\" cy=\"50%\" [attr.r]=\"circleRadius\" />\n  </svg>\n  <div class=\"ids-loading__icon\">\n    <ng-content select=\"ids-icon\"></ng-content>\n  </div>\n</div>\n", styles: ["@keyframes spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.ids-loading{color:var(--ids_color_action_primary_base);display:inline-block;height:calc(var(--ids_size_general_32x) + var(--ids_size_general_3x) * 2);position:relative;width:calc(var(--ids_size_general_32x) + var(--ids_size_general_3x) * 2)}.ids-loading__svg{animation:spin .8s linear infinite;height:calc(var(--ids_size_general_32x) + var(--ids_size_general_3x) * 2);width:calc(var(--ids_size_general_32x) + var(--ids_size_general_3x) * 2)}.ids-loading__circle-ring{fill:transparent;opacity:var(--ids_opacity_soft);stroke:currentcolor;stroke-width:var(--ids_size_general_3x)}.ids-loading__circle-spinner{--spin-value: var(--ids_size_general_3x);fill:transparent;stroke:currentcolor;stroke-dasharray:100.5309649149;stroke-dashoffset:75.3982236862;stroke-linecap:round;stroke-width:var(--ids_size_general_3x)}.ids-loading__icon{display:flex;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%)}.ids-loading--xsmall,.ids-loading--xsmall .ids-loading__svg{height:calc(var(--ids_size_general_16x) + var(--ids_size_general_2x) * 2);width:calc(var(--ids_size_general_16x) + var(--ids_size_general_2x) * 2)}.ids-loading--xsmall .ids-loading__circle-ring{stroke-width:var(--ids_size_general_2x)}.ids-loading--xsmall .ids-loading__circle-spinner{--spin-value: var(--ids_size_general_2x);stroke-dasharray:50.2654824574;stroke-dashoffset:37.6991118431;stroke-width:var(--ids_size_general_2x)}.ids-loading--small,.ids-loading--small .ids-loading__svg{height:calc(var(--ids_size_general_24x) + var(--ids_size_general_2x) * 2);width:calc(var(--ids_size_general_24x) + var(--ids_size_general_2x) * 2)}.ids-loading--small .ids-loading__circle-ring{stroke-width:var(--ids_size_general_2x)}.ids-loading--small .ids-loading__circle-spinner{--spin-value: var(--ids_size_general_2x);stroke-dasharray:75.3982236862;stroke-dashoffset:56.5486677646;stroke-width:var(--ids_size_general_2x)}.ids-loading--large,.ids-loading--large .ids-loading__svg{height:calc(var(--ids_size_general_64x) + var(--ids_size_general_4x) * 2);width:calc(var(--ids_size_general_64x) + var(--ids_size_general_4x) * 2)}.ids-loading--large .ids-loading__circle-ring{stroke-width:var(--ids_size_general_4x)}.ids-loading--large .ids-loading__circle-spinner{--spin-value: var(--ids_size_general_4x);stroke-dasharray:201.0619298297;stroke-dashoffset:150.7964473723;stroke-width:var(--ids_size_general_4x)}.ids-loading--xlarge,.ids-loading--xlarge .ids-loading__svg{height:calc(var(--ids_size_general_128x) + var(--ids_size_general_5x) * 2);width:calc(var(--ids_size_general_128x) + var(--ids_size_general_5x) * 2)}.ids-loading--xlarge .ids-loading__circle-ring{stroke-width:var(--ids_size_general_5x)}.ids-loading--xlarge .ids-loading__circle-spinner{--spin-value: var(--ids_size_general_5x);stroke-dasharray:402.1238596595;stroke-dashoffset:301.5928947446;stroke-width:var(--ids_size_general_5x)}.ids-loading--secondary{color:var(--ids_color_action_secondary_base)}.ids-loading--on-brand{color:var(--ids_color_contrast_onBrand_primary)}\n"], animations: [
        trigger('inOut', [
            transition(':enter', [
                query('.ids-loading', [
                    style({ opacity: '0' }),
                    animate('200ms ease-in-out', style({ opacity: '1' })),
                ]),
            ]),
            transition(':leave', [
                query('.ids-loading', [animate('250ms ease-in-out', style({ opacity: '0' }))]),
            ]),
        ]),
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsLoadingComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-loading', host: {
                        '[@inOut]': 'true',
                        '[attr.id]': 'null',
                        '[attr.aria-hidden]': 'null',
                        '[attr.aria-label]': 'null',
                        '[attr.aria-live]': 'null',
                        '[attr.role]': 'null',
                    }, standalone: true, animations: [
                        trigger('inOut', [
                            transition(':enter', [
                                query('.ids-loading', [
                                    style({ opacity: '0' }),
                                    animate('200ms ease-in-out', style({ opacity: '1' })),
                                ]),
                            ]),
                            transition(':leave', [
                                query('.ids-loading', [animate('250ms ease-in-out', style({ opacity: '0' }))]),
                            ]),
                        ]),
                    ], template: "<div\n  class=\"ids-loading\"\n  [class.ids-loading--xsmall]=\"size === 'XS'\"\n  [class.ids-loading--small]=\"size === 'S'\"\n  [class.ids-loading--large]=\"size === 'L'\"\n  [class.ids-loading--xlarge]=\"size === 'XL'\"\n  [class.ids-loading--on-brand]=\"contrast === 'onBrand'\"\n  [class.ids-loading--secondary]=\"variant === 'secondary'\"\n  [attr.id]=\"id\"\n  [attr.aria-hidden]=\"ariaHidden\"\n  [attr.role]=\"role\"\n>\n  <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"ids-loading__svg\" role=\"img\">\n    <title>{{ ariaLabel }}</title>\n    <circle class=\"ids-loading__circle-ring\" cx=\"50%\" cy=\"50%\" [attr.r]=\"circleRadius\" />\n    <circle class=\"ids-loading__circle-spinner\" cx=\"50%\" cy=\"50%\" [attr.r]=\"circleRadius\" />\n  </svg>\n  <div class=\"ids-loading__icon\">\n    <ng-content select=\"ids-icon\"></ng-content>\n  </div>\n</div>\n", styles: ["@keyframes spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}.ids-loading{color:var(--ids_color_action_primary_base);display:inline-block;height:calc(var(--ids_size_general_32x) + var(--ids_size_general_3x) * 2);position:relative;width:calc(var(--ids_size_general_32x) + var(--ids_size_general_3x) * 2)}.ids-loading__svg{animation:spin .8s linear infinite;height:calc(var(--ids_size_general_32x) + var(--ids_size_general_3x) * 2);width:calc(var(--ids_size_general_32x) + var(--ids_size_general_3x) * 2)}.ids-loading__circle-ring{fill:transparent;opacity:var(--ids_opacity_soft);stroke:currentcolor;stroke-width:var(--ids_size_general_3x)}.ids-loading__circle-spinner{--spin-value: var(--ids_size_general_3x);fill:transparent;stroke:currentcolor;stroke-dasharray:100.5309649149;stroke-dashoffset:75.3982236862;stroke-linecap:round;stroke-width:var(--ids_size_general_3x)}.ids-loading__icon{display:flex;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%)}.ids-loading--xsmall,.ids-loading--xsmall .ids-loading__svg{height:calc(var(--ids_size_general_16x) + var(--ids_size_general_2x) * 2);width:calc(var(--ids_size_general_16x) + var(--ids_size_general_2x) * 2)}.ids-loading--xsmall .ids-loading__circle-ring{stroke-width:var(--ids_size_general_2x)}.ids-loading--xsmall .ids-loading__circle-spinner{--spin-value: var(--ids_size_general_2x);stroke-dasharray:50.2654824574;stroke-dashoffset:37.6991118431;stroke-width:var(--ids_size_general_2x)}.ids-loading--small,.ids-loading--small .ids-loading__svg{height:calc(var(--ids_size_general_24x) + var(--ids_size_general_2x) * 2);width:calc(var(--ids_size_general_24x) + var(--ids_size_general_2x) * 2)}.ids-loading--small .ids-loading__circle-ring{stroke-width:var(--ids_size_general_2x)}.ids-loading--small .ids-loading__circle-spinner{--spin-value: var(--ids_size_general_2x);stroke-dasharray:75.3982236862;stroke-dashoffset:56.5486677646;stroke-width:var(--ids_size_general_2x)}.ids-loading--large,.ids-loading--large .ids-loading__svg{height:calc(var(--ids_size_general_64x) + var(--ids_size_general_4x) * 2);width:calc(var(--ids_size_general_64x) + var(--ids_size_general_4x) * 2)}.ids-loading--large .ids-loading__circle-ring{stroke-width:var(--ids_size_general_4x)}.ids-loading--large .ids-loading__circle-spinner{--spin-value: var(--ids_size_general_4x);stroke-dasharray:201.0619298297;stroke-dashoffset:150.7964473723;stroke-width:var(--ids_size_general_4x)}.ids-loading--xlarge,.ids-loading--xlarge .ids-loading__svg{height:calc(var(--ids_size_general_128x) + var(--ids_size_general_5x) * 2);width:calc(var(--ids_size_general_128x) + var(--ids_size_general_5x) * 2)}.ids-loading--xlarge .ids-loading__circle-ring{stroke-width:var(--ids_size_general_5x)}.ids-loading--xlarge .ids-loading__circle-spinner{--spin-value: var(--ids_size_general_5x);stroke-dasharray:402.1238596595;stroke-dashoffset:301.5928947446;stroke-width:var(--ids_size_general_5x)}.ids-loading--secondary{color:var(--ids_color_action_secondary_base)}.ids-loading--on-brand{color:var(--ids_color_contrast_onBrand_primary)}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.LiveAnnouncer }]; }, propDecorators: { id: [{
                type: Input
            }], ariaHidden: [{
                type: Input,
                args: ['aria-hidden']
            }], ariaLabel: [{
                type: Input,
                args: ['aria-label']
            }], ariaLive: [{
                type: Input,
                args: ['aria-live']
            }], role: [{
                type: Input
            }], contrast: [{
                type: Input
            }], variant: [{
                type: Input
            }], size: [{
                type: Input
            }] } });

class IdsLoadingModule {
}
IdsLoadingModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsLoadingModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsLoadingModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsLoadingModule, imports: [IdsLoadingComponent], exports: [IdsLoadingComponent] });
IdsLoadingModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsLoadingModule, imports: [IdsLoadingComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsLoadingModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsLoadingComponent],
                    exports: [IdsLoadingComponent],
                }]
        }] });

/**
 * Os botões permitem que o usuário realize ações e façam escolhas com um único toque.
 *
 * *Buttons allow the user to perform actions and make choices with a single tap.*
 *
 * **Module:**
 *
 * `import { IdsMainButtonModule } from '@ids/angular';`
 *
 * **Componente:**
 *
 * `import { IdsMainButtonComponent } from '@ids/angular';`
 */
class IdsMainButtonComponent {
    constructor() {
        this._full = false;
        this._loading = false;
    }
    /**
     * Define se o botão é full
     *
     * *Defines whether the button is full*
     */
    get full() {
        return this._full;
    }
    set full(value) {
        this._full = enforceBoolean(value);
    }
    /**
     * Define se exibe animação de carregamento
     *
     * *Sets whether to display loading animation*
     */
    get loading() {
        return this._loading;
    }
    set loading(value) {
        this._loading = enforceBoolean(value);
    }
    onKeydown(event) {
        if (this.loading) {
            event.preventDefault();
        }
    }
}
IdsMainButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMainButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IdsMainButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsMainButtonComponent, isStandalone: true, selector: "button[idsMainButton]", inputs: { contrast: "contrast", variant: "variant", full: "full", loading: "loading" }, host: { listeners: { "keydown": "onKeydown($event)" }, properties: { "class.ids-main-button": "true", "class.ids-main-button--full": "full", "class.ids-main-button--secondary": "variant === \"secondary\"", "class.ids-main-button--on-brand": "contrast === \"onBrand\"", "class.ids-main-button--loading": "loading" } }, ngImport: i0, template: "<span class=\"ids-main-button__content\" [class.ids-main-button__content--hidden]=\"loading\">\n  <ng-content></ng-content>\n</span>\n\n<ids-loading\n  *ngIf=\"loading\"\n  class=\"ids-main-button__loading\"\n  size=\"S\"\n  aria-live=\"polite\"\n  [variant]=\"variant === 'secondary' ? variant : undefined\"\n  [contrast]=\"variant === 'secondary' ? contrast : !variant && !contrast ? 'onBrand' : undefined\"\n>\n</ids-loading>\n", styles: [".ids-main-button,:host.ids-main-button{all:unset;all:revert;box-sizing:border-box;padding:0;-webkit-user-select:none;user-select:none;background:var(--ids_color_action_primary_base);border:var(--ids_size_border_small) solid transparent;border-radius:var(--ids_size_cornerRadius_button);color:var(--ids_color_action_primary_contrast);cursor:pointer;font:var(--ids_textStyle_f02_s16_h24_wbd);min-height:3.125rem;outline-offset:var(--ids_size_general_4x);padding:var(--ids_size_general_10x) calc(var(--ids_size_general_24x) - var(--ids_size_border_small));position:relative;text-align:center;text-decoration:none}@media (pointer: coarse){.ids-main-button,:host.ids-main-button{outline:0!important}.ids-main-button:focus,:host.ids-main-button:focus{outline:0!important}}@media (pointer: coarse) and (pointer: fine){.ids-main-button:focus-visible,.ids-main-button:focus.focus-visible,:host.ids-main-button:focus-visible,:host.ids-main-button:focus.focus-visible{outline:0!important}}@media (pointer: fine){.ids-main-button:focus-visible,.ids-main-button:focus.focus-visible,:host.ids-main-button:focus-visible,:host.ids-main-button:focus.focus-visible{outline:revert!important}}@media (pointer: fine) and (pointer: fine){.ids-main-button:focus-visible,.ids-main-button:focus.focus-visible,:host.ids-main-button:focus-visible,:host.ids-main-button:focus.focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}}.ids-main-button__content,:host.ids-main-button__content{gap:var(--ids_size_general_10x);align-items:center;display:inline-flex;justify-content:center}.js-no-flexbox-gap .ids-main-button__content,.js-no-flexbox-gap :host.ids-main-button__content{white-space:pre}.ids-main-button__content--hidden,:host.ids-main-button__content--hidden{visibility:hidden}.ids-main-button__loading,:host.ids-main-button__loading{left:0;position:absolute;right:0;width:100%}.ids-main-button--loading,:host.ids-main-button--loading{pointer-events:none}.ids-main-button--full,:host.ids-main-button--full{width:100%}.ids-main-button--full .ids-main-button__content,:host.ids-main-button--full .ids-main-button__content{width:100%}.ids-main-button--full .ids-icon,:host.ids-main-button--full .ids-icon{margin-left:auto}.ids-main-button--full ::ng-deep ids-icon,:host.ids-main-button--full ::ng-deep ids-icon{margin-left:auto}.ids-main-button:disabled,.ids-main-button[aria-disabled=true],:host.ids-main-button:disabled,:host.ids-main-button[aria-disabled=true]{background-color:var(--ids_color_action_disabled_base);border-color:var(--ids_color_action_disabled_base);color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){.ids-main-button:hover:not(:disabled):not([aria-disabled=true]),.ids-main-button:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-main-button:hover:not(:disabled):not([aria-disabled=true]),:host.ids-main-button:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_primary_variant)}}.ids-main-button:active:not(:disabled):not([aria-disabled=true]),:host.ids-main-button:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_primary_variant)}.ids-main-button--secondary,:host.ids-main-button--secondary{background-color:transparent;border-color:currentcolor;color:var(--ids_color_action_secondary_base)}.ids-main-button--secondary:disabled,.ids-main-button--secondary[aria-disabled=true],:host.ids-main-button--secondary:disabled,:host.ids-main-button--secondary[aria-disabled=true]{background-color:transparent;color:var(--ids_color_action_disabled_variant)}@media (hover: hover) and (pointer: fine){.ids-main-button--secondary:hover:not(:disabled):not([aria-disabled=true]),.ids-main-button--secondary:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-main-button--secondary:hover:not(:disabled):not([aria-disabled=true]),:host.ids-main-button--secondary:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_secondary_base_soft);color:var(--ids_color_action_secondary_variant)}}.ids-main-button--secondary:active:not(:disabled):not([aria-disabled=true]),:host.ids-main-button--secondary:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_secondary_base_soft);color:var(--ids_color_action_secondary_variant)}.ids-main-button--on-brand,:host.ids-main-button--on-brand{background-color:var(--ids_color_action_primary_contrast);border-color:var(--ids_color_action_primary_contrast);color:var(--ids_color_action_primary_base)}.ids-main-button--on-brand:disabled,.ids-main-button--on-brand[aria-disabled=true],:host.ids-main-button--on-brand:disabled,:host.ids-main-button--on-brand[aria-disabled=true]{background-color:var(--ids_color_action_primary_contrast);border-color:var(--ids_color_action_primary_contrast);color:var(--ids_color_action_disabled_variant)}@media (hover: hover) and (pointer: fine){.ids-main-button--on-brand:hover:not(:disabled):not([aria-disabled=true]),.ids-main-button--on-brand:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-main-button--on-brand:hover:not(:disabled):not([aria-disabled=true]),:host.ids-main-button--on-brand:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_primary_contrast);color:var(--ids_color_action_primary_variant)}}.ids-main-button--on-brand:active:not(:disabled):not([aria-disabled=true]),:host.ids-main-button--on-brand:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_primary_contrast);color:var(--ids_color_action_primary_variant)}.ids-main-button--on-brand.ids-main-button--secondary,:host.ids-main-button--on-brand.ids-main-button--secondary{background-color:transparent;border-color:currentcolor;color:var(--ids_color_action_primary_contrast)}.ids-main-button--on-brand.ids-main-button--secondary:disabled,.ids-main-button--on-brand.ids-main-button--secondary[aria-disabled=true],:host.ids-main-button--on-brand.ids-main-button--secondary:disabled,:host.ids-main-button--on-brand.ids-main-button--secondary[aria-disabled=true]{background-color:transparent;color:var(--ids_color_action_primary_contrast_medium)}@media (hover: hover) and (pointer: fine){.ids-main-button--on-brand.ids-main-button--secondary:hover:not(:disabled):not([aria-disabled=true]),.ids-main-button--on-brand.ids-main-button--secondary:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-main-button--on-brand.ids-main-button--secondary:hover:not(:disabled):not([aria-disabled=true]),:host.ids-main-button--on-brand.ids-main-button--secondary:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_primary_contrast_soft);color:var(--ids_color_action_primary_contrast)}}.ids-main-button--on-brand.ids-main-button--secondary:active:not(:disabled):not([aria-disabled=true]),:host.ids-main-button--on-brand.ids-main-button--secondary:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_primary_contrast_soft);color:var(--ids_color_action_primary_contrast)}@media (min-width: 64rem){.ids-main-button,:host.ids-main-button{font:var(--ids_textStyle_f02_s20_h26_wbd)}}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: IdsLoadingModule }, { kind: "component", type: IdsLoadingComponent, selector: "ids-loading", inputs: ["id", "aria-hidden", "aria-label", "aria-live", "role", "contrast", "variant", "size"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMainButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'button[idsMainButton]', host: {
                        '[class.ids-main-button]': 'true',
                        '[class.ids-main-button--full]': 'full',
                        '[class.ids-main-button--secondary]': 'variant === "secondary"',
                        '[class.ids-main-button--on-brand]': 'contrast === "onBrand"',
                        '[class.ids-main-button--loading]': 'loading',
                    }, standalone: true, imports: [CommonModule, IdsLoadingModule], template: "<span class=\"ids-main-button__content\" [class.ids-main-button__content--hidden]=\"loading\">\n  <ng-content></ng-content>\n</span>\n\n<ids-loading\n  *ngIf=\"loading\"\n  class=\"ids-main-button__loading\"\n  size=\"S\"\n  aria-live=\"polite\"\n  [variant]=\"variant === 'secondary' ? variant : undefined\"\n  [contrast]=\"variant === 'secondary' ? contrast : !variant && !contrast ? 'onBrand' : undefined\"\n>\n</ids-loading>\n", styles: [".ids-main-button,:host.ids-main-button{all:unset;all:revert;box-sizing:border-box;padding:0;-webkit-user-select:none;user-select:none;background:var(--ids_color_action_primary_base);border:var(--ids_size_border_small) solid transparent;border-radius:var(--ids_size_cornerRadius_button);color:var(--ids_color_action_primary_contrast);cursor:pointer;font:var(--ids_textStyle_f02_s16_h24_wbd);min-height:3.125rem;outline-offset:var(--ids_size_general_4x);padding:var(--ids_size_general_10x) calc(var(--ids_size_general_24x) - var(--ids_size_border_small));position:relative;text-align:center;text-decoration:none}@media (pointer: coarse){.ids-main-button,:host.ids-main-button{outline:0!important}.ids-main-button:focus,:host.ids-main-button:focus{outline:0!important}}@media (pointer: coarse) and (pointer: fine){.ids-main-button:focus-visible,.ids-main-button:focus.focus-visible,:host.ids-main-button:focus-visible,:host.ids-main-button:focus.focus-visible{outline:0!important}}@media (pointer: fine){.ids-main-button:focus-visible,.ids-main-button:focus.focus-visible,:host.ids-main-button:focus-visible,:host.ids-main-button:focus.focus-visible{outline:revert!important}}@media (pointer: fine) and (pointer: fine){.ids-main-button:focus-visible,.ids-main-button:focus.focus-visible,:host.ids-main-button:focus-visible,:host.ids-main-button:focus.focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}}.ids-main-button__content,:host.ids-main-button__content{gap:var(--ids_size_general_10x);align-items:center;display:inline-flex;justify-content:center}.js-no-flexbox-gap .ids-main-button__content,.js-no-flexbox-gap :host.ids-main-button__content{white-space:pre}.ids-main-button__content--hidden,:host.ids-main-button__content--hidden{visibility:hidden}.ids-main-button__loading,:host.ids-main-button__loading{left:0;position:absolute;right:0;width:100%}.ids-main-button--loading,:host.ids-main-button--loading{pointer-events:none}.ids-main-button--full,:host.ids-main-button--full{width:100%}.ids-main-button--full .ids-main-button__content,:host.ids-main-button--full .ids-main-button__content{width:100%}.ids-main-button--full .ids-icon,:host.ids-main-button--full .ids-icon{margin-left:auto}.ids-main-button--full ::ng-deep ids-icon,:host.ids-main-button--full ::ng-deep ids-icon{margin-left:auto}.ids-main-button:disabled,.ids-main-button[aria-disabled=true],:host.ids-main-button:disabled,:host.ids-main-button[aria-disabled=true]{background-color:var(--ids_color_action_disabled_base);border-color:var(--ids_color_action_disabled_base);color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){.ids-main-button:hover:not(:disabled):not([aria-disabled=true]),.ids-main-button:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-main-button:hover:not(:disabled):not([aria-disabled=true]),:host.ids-main-button:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_primary_variant)}}.ids-main-button:active:not(:disabled):not([aria-disabled=true]),:host.ids-main-button:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_primary_variant)}.ids-main-button--secondary,:host.ids-main-button--secondary{background-color:transparent;border-color:currentcolor;color:var(--ids_color_action_secondary_base)}.ids-main-button--secondary:disabled,.ids-main-button--secondary[aria-disabled=true],:host.ids-main-button--secondary:disabled,:host.ids-main-button--secondary[aria-disabled=true]{background-color:transparent;color:var(--ids_color_action_disabled_variant)}@media (hover: hover) and (pointer: fine){.ids-main-button--secondary:hover:not(:disabled):not([aria-disabled=true]),.ids-main-button--secondary:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-main-button--secondary:hover:not(:disabled):not([aria-disabled=true]),:host.ids-main-button--secondary:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_secondary_base_soft);color:var(--ids_color_action_secondary_variant)}}.ids-main-button--secondary:active:not(:disabled):not([aria-disabled=true]),:host.ids-main-button--secondary:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_secondary_base_soft);color:var(--ids_color_action_secondary_variant)}.ids-main-button--on-brand,:host.ids-main-button--on-brand{background-color:var(--ids_color_action_primary_contrast);border-color:var(--ids_color_action_primary_contrast);color:var(--ids_color_action_primary_base)}.ids-main-button--on-brand:disabled,.ids-main-button--on-brand[aria-disabled=true],:host.ids-main-button--on-brand:disabled,:host.ids-main-button--on-brand[aria-disabled=true]{background-color:var(--ids_color_action_primary_contrast);border-color:var(--ids_color_action_primary_contrast);color:var(--ids_color_action_disabled_variant)}@media (hover: hover) and (pointer: fine){.ids-main-button--on-brand:hover:not(:disabled):not([aria-disabled=true]),.ids-main-button--on-brand:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-main-button--on-brand:hover:not(:disabled):not([aria-disabled=true]),:host.ids-main-button--on-brand:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_primary_contrast);color:var(--ids_color_action_primary_variant)}}.ids-main-button--on-brand:active:not(:disabled):not([aria-disabled=true]),:host.ids-main-button--on-brand:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_primary_contrast);color:var(--ids_color_action_primary_variant)}.ids-main-button--on-brand.ids-main-button--secondary,:host.ids-main-button--on-brand.ids-main-button--secondary{background-color:transparent;border-color:currentcolor;color:var(--ids_color_action_primary_contrast)}.ids-main-button--on-brand.ids-main-button--secondary:disabled,.ids-main-button--on-brand.ids-main-button--secondary[aria-disabled=true],:host.ids-main-button--on-brand.ids-main-button--secondary:disabled,:host.ids-main-button--on-brand.ids-main-button--secondary[aria-disabled=true]{background-color:transparent;color:var(--ids_color_action_primary_contrast_medium)}@media (hover: hover) and (pointer: fine){.ids-main-button--on-brand.ids-main-button--secondary:hover:not(:disabled):not([aria-disabled=true]),.ids-main-button--on-brand.ids-main-button--secondary:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-main-button--on-brand.ids-main-button--secondary:hover:not(:disabled):not([aria-disabled=true]),:host.ids-main-button--on-brand.ids-main-button--secondary:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_primary_contrast_soft);color:var(--ids_color_action_primary_contrast)}}.ids-main-button--on-brand.ids-main-button--secondary:active:not(:disabled):not([aria-disabled=true]),:host.ids-main-button--on-brand.ids-main-button--secondary:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_primary_contrast_soft);color:var(--ids_color_action_primary_contrast)}@media (min-width: 64rem){.ids-main-button,:host.ids-main-button{font:var(--ids_textStyle_f02_s20_h26_wbd)}}\n"] }]
        }], propDecorators: { contrast: [{
                type: Input
            }], variant: [{
                type: Input
            }], full: [{
                type: Input
            }], loading: [{
                type: Input
            }], onKeydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }] } });

class IdsMainButtonModule {
}
IdsMainButtonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMainButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsMainButtonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsMainButtonModule, imports: [IdsMainButtonComponent], exports: [IdsMainButtonComponent] });
IdsMainButtonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMainButtonModule, imports: [IdsMainButtonComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMainButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsMainButtonComponent],
                    exports: [IdsMainButtonComponent],
                }]
        }] });

let NEXT_ID$k = 0;
class IdsModalService {
    constructor() {
        this.id = `ids-modal-${NEXT_ID$k++}`;
        this._closeButtonEvent = new BehaviorSubject(false);
    }
    emitCloseEvent() {
        this._closeButtonEvent.next(false);
    }
    closeEventListener() {
        return this._closeButtonEvent.asObservable();
    }
}
IdsModalService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsModalService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
IdsModalService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsModalService, providedIn: null });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsModalService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: null,
                }]
        }] });

class IdsModalTitleDirective {
    get id() {
        return `${this.idsModalService.id}-title`;
    }
    constructor(idsModalService) {
        this.idsModalService = idsModalService;
        this.class = '';
    }
}
IdsModalTitleDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsModalTitleDirective, deps: [{ token: IdsModalService }], target: i0.ɵɵFactoryTarget.Directive });
IdsModalTitleDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsModalTitleDirective, selector: "[idsModalTitle]", inputs: { class: "class" }, host: { properties: { "class": "this.class", "attr.id": "this.id" } }, exportAs: ["idsModalTitle"], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsModalTitleDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsModalTitle]',
                    exportAs: 'idsModalTitle',
                }]
        }], ctorParameters: function () { return [{ type: IdsModalService }]; }, propDecorators: { class: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['class']
            }], id: [{
                type: HostBinding,
                args: ['attr.id']
            }] } });

class idsModalCloseDirective {
    constructor(idsModalService) {
        this.idsModalService = idsModalService;
    }
    onClick() {
        this.idsModalService.emitCloseEvent();
    }
}
idsModalCloseDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: idsModalCloseDirective, deps: [{ token: IdsModalService }], target: i0.ɵɵFactoryTarget.Directive });
idsModalCloseDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: idsModalCloseDirective, selector: "[idsModalClose]", host: { listeners: { "click": "onClick($event)" } }, exportAs: ["idsModalClose"], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: idsModalCloseDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsModalClose]',
                    exportAs: 'idsModalClose',
                }]
        }], ctorParameters: function () { return [{ type: IdsModalService }]; }, propDecorators: { onClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

class IdsModalHeaderComponent {
    /**
     * Remove o botão de fechar o modal.
     */
    set noCloseButton(removeButton) {
        this._noCloseButton = enforceBoolean(removeButton);
    }
    get noCloseButton() {
        return this._noCloseButton;
    }
    /**
     * Remove divider do header do modal.
     */
    set noDivider(removeDivider) {
        this._noDivider = enforceBoolean(removeDivider);
    }
    get noDivider() {
        return this._noDivider;
    }
    constructor(idsModalService) {
        this.id = '';
        this._noCloseButton = false;
        this._noDivider = false;
        /**
         * Label do botão fechar para ser lido por leitores de tela
         */
        this.modalCloseLabel = 'fechar';
        this.id = idsModalService.id;
    }
    ngAfterContentInit() {
        if (this.modalTitle) {
            this.modalTitle.class = 'ids-modal-header__title';
        }
    }
}
IdsModalHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsModalHeaderComponent, deps: [{ token: IdsModalService }], target: i0.ɵɵFactoryTarget.Component });
IdsModalHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsModalHeaderComponent, selector: "ids-modal-header", inputs: { noCloseButton: "noCloseButton", noDivider: "noDivider", modalCloseLabel: "modalCloseLabel" }, queries: [{ propertyName: "modalTitle", first: true, predicate: IdsModalTitleDirective, descendants: true, static: true }], ngImport: i0, template: "<header class=\"ids-modal-header\">\n  <div>\n    <ng-content></ng-content>\n  </div>\n  <button\n    *ngIf=\"!noCloseButton\"\n    idsModalClose\n    idsIconButton\n    variant=\"neutral\"\n    [attr.aria-label]=\"modalCloseLabel\"\n    [id]=\"id + '-close'\"\n    [title]=\"modalCloseLabel\"\n  >\n    fechar\n  </button>\n</header>\n\n<hr *ngIf=\"!noDivider\" aria-hidden=\"true\" class=\"ids-divider -regular -soft\" />\n", dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "component", type: IdsIconButtonComponent, selector: "[idsIconButton]", inputs: ["variant", "contrast", "size", "title", "aria-label"] }, { kind: "directive", type: idsModalCloseDirective, selector: "[idsModalClose]", exportAs: ["idsModalClose"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsModalHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-modal-header', template: "<header class=\"ids-modal-header\">\n  <div>\n    <ng-content></ng-content>\n  </div>\n  <button\n    *ngIf=\"!noCloseButton\"\n    idsModalClose\n    idsIconButton\n    variant=\"neutral\"\n    [attr.aria-label]=\"modalCloseLabel\"\n    [id]=\"id + '-close'\"\n    [title]=\"modalCloseLabel\"\n  >\n    fechar\n  </button>\n</header>\n\n<hr *ngIf=\"!noDivider\" aria-hidden=\"true\" class=\"ids-divider -regular -soft\" />\n" }]
        }], ctorParameters: function () { return [{ type: IdsModalService }]; }, propDecorators: { noCloseButton: [{
                type: Input
            }], noDivider: [{
                type: Input
            }], modalCloseLabel: [{
                type: Input
            }], modalTitle: [{
                type: ContentChild,
                args: [IdsModalTitleDirective, { static: true }]
            }] } });

const WIDTH = '272px';
/**
 * Componente de Modal
 *
 * **Module:**
 *
 * `import { IdsModalModule } from '@ids/angular';`
 */
class IdsModalComponent {
    /**
     * Id do título do modal para ser lido por leitores de tela
     */
    set ariaLabelledby(value) {
        this._ariaLabelledby = value;
    }
    get ariaLabelledby() {
        if (this.ariaLabel) {
            return null;
        }
        if (this._ariaLabelledby) {
            return this._ariaLabelledby;
        }
        return `${this.id}-title`;
    }
    /**
     * Adiciona classe CSS junto ao .ids-modal
     */
    get className() {
        const shadowClass = this.positionStrategy === 'flexibleConnectedTo' ? 'ids-modal--shadow' : '';
        return `${this._className} ids-modal ${shadowClass}`.trim();
    }
    set className(className) {
        this._className = className;
    }
    get backdropClass() {
        if (this.positionStrategy === 'global') {
            return 'ids-backdrop';
        }
        return ['ids-backdrop', '-no-bg'];
    }
    /**
     * Define se o modal está aberto
     */
    set open(open) {
        if (!open && this._open) {
            this.detach();
        }
        if (!this.zIndex) {
            this.zIndex = getElevation();
        }
        if (enforceBoolean(open)) {
            /*
             * O Safari não ativa o elemento quando o mesmo é clicado, logo o document.activeElement não
             * retorna o esperado com ele. Estamos usando o event (global) para resgatar o elemento ativo
             * até que o Safari suporte esse recurso.
             */
            let legacyEvent;
            // evita erro em testes unitários
            if (typeof event !== 'undefined') {
                legacyEvent = event;
            }
            this._autoDetectedOrigin = new CdkOverlayOrigin(new ElementRef(legacyEvent?.target || getActiveElement(document)));
        }
        this._open = enforceBoolean(open);
    }
    get open() {
        return this._open;
    }
    /**
     * Elemento para definir o foco quando o Modal for fechado
     *
     * Definir manualmente o origin não é obrigatório,
     * o Modal já detecta o elemento que disparou o evento de abertura do Modal
     * e retorna o foco para ele quando o Modal fechar.
     */
    set origin(value) {
        if (!value) {
            return;
        }
        if (value instanceof CdkOverlayOrigin) {
            this._origin = value;
            return;
        }
        this._origin = new CdkOverlayOrigin(new ElementRef(value));
    }
    get origin() {
        return this._origin || this._autoDetectedOrigin;
    }
    // Modal base Methods
    /**
     * Define como o modal/dialog se comporta com rolagem da página. Valores possíveis: "block" | "reposition" | "noop" | "close".
     */
    set scrollStrategy(scrollStrategy) {
        this._scrollStrategy = scrollStrategy;
    }
    get scrollStrategy() {
        if (this._scrollStrategy) {
            return this._scrollStrategy;
        }
        if (this.positionStrategy === 'global') {
            return 'block';
        }
        return 'reposition';
    }
    get ariaModal() {
        // no VoiceOver do iOS quando usado o aria-modal="true", quebra a navegação
        // após o fechamento do modal, também impede o controle do foco na abertura,
        // que para uma leitura correta no iOS, precisa ter um certo atraso
        if (platform.os === 'IOS') {
            return;
        }
        return 'true';
    }
    constructor(overlay, overlayContainer, _renderer, idsModalService) {
        this.overlay = overlay;
        this.overlayContainer = overlayContainer;
        this._renderer = _renderer;
        this.idsModalService = idsModalService;
        this._destroy = new Subject();
        this.id = '';
        this.width = WIDTH;
        this._className = '';
        this._open = false;
        /**
         * Define a estratégia de abertura do modal, se por cima da tela toda ou com base no elemento
         */
        this.positionStrategy = 'global';
        /**
         * Envia valores de reposiocionamento do overlay (modal)
         */
        this.positions = [];
        /**
         * Emite evento quando há alteração de estado (aberto ou fechado) no modal
         */
        this.openChange = new EventEmitter();
        /**
         * Controla se o componente vai focar automaticamente ao abrir
         */
        this.autoFocus = true;
        this.idsModalService
            .closeEventListener()
            .pipe(takeUntil$1(this._destroy))
            .subscribe((event) => {
            this.openChange.emit(event);
        });
    }
    ngOnInit() {
        this.id = this.idsModalService.id;
    }
    ngOnDestroy() {
        toggleMobileFocusTrap(undefined, false);
        this._destroy.next();
        this._destroy.complete();
    }
    attach() {
        this.setOverlayPosition();
        this.setOverlayZIndex();
        if (this.autoFocus) {
            this.startFocus();
        }
    }
    setOverlayPosition() {
        if (this.positionStrategy === 'global') {
            this.setGlobalOverlayPosition();
            return;
        }
        this.setFlexibleOverlayPosition();
    }
    detach() {
        toggleMobileFocusTrap(undefined, false);
        this.removeOverlayZIndex();
        focus(this.origin?.elementRef?.nativeElement);
    }
    close() {
        this.openChange.emit(false);
    }
    startFocus() {
        toggleMobileFocusTrap();
        setTimeout(() => {
            if (this.contentRef) {
                startFocus(this.contentRef.nativeElement);
            }
        }, 0);
    }
    removeOverlayZIndex() {
        const panel = this.overlayContainer.getContainerElement();
        if (this.zIndex) {
            this._renderer.removeStyle(panel, 'z-index');
        }
    }
    setGlobalOverlayPosition() {
        const positionStrategy = this.overlay
            .position()
            .global()
            .centerHorizontally()
            .centerVertically();
        this.overlayDir.overlayRef.updatePositionStrategy(positionStrategy);
    }
    setFlexibleOverlayPosition() {
        const positionStrategy = this.overlay
            .position()
            .flexibleConnectedTo(this.origin.elementRef)
            .withPositions(this.positions)
            .withPush(Boolean(this.canPush));
        this.overlayDir.overlayRef.updatePositionStrategy(positionStrategy);
    }
    setOverlayZIndex() {
        const panel = this.overlayContainer.getContainerElement();
        if (this.zIndex) {
            this._renderer.setStyle(panel, 'z-index', this.zIndex);
        }
    }
}
IdsModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsModalComponent, deps: [{ token: i1$3.Overlay }, { token: i1$3.OverlayContainer }, { token: i0.Renderer2 }, { token: IdsModalService }], target: i0.ɵɵFactoryTarget.Component });
IdsModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsModalComponent, selector: "ids-modal", inputs: { width: "width", ariaLabelledby: ["aria-labelledby", "ariaLabelledby"], ariaLabel: ["aria-label", "ariaLabel"], className: ["class", "className"], open: "open", lang: "lang", origin: "origin", scrollStrategy: "scrollStrategy", positionStrategy: "positionStrategy", positions: "positions", canPush: "canPush", zIndex: "zIndex", autoFocus: "autoFocus" }, outputs: { openChange: "openChange" }, host: { listeners: { "click": "open()" }, properties: { "attr.aria-labelledby": "null", "attr.id": "null", "attr.class": "null", "attr.width": "null" } }, providers: [
        {
            provide: IdsModalService,
        },
    ], queries: [{ propertyName: "modalHeader", first: true, predicate: i0.forwardRef(function () { return IdsModalHeaderComponent; }), descendants: true, static: true }], viewQueries: [{ propertyName: "overlayDir", first: true, predicate: CdkConnectedOverlay, descendants: true, static: true }, { propertyName: "contentRef", first: true, predicate: ["contentRef"], descendants: true }], ngImport: i0, template: "<ng-template\n  cdkConnectedOverlay\n  [cdkConnectedOverlayOpen]=\"open\"\n  [cdkConnectedOverlayOrigin]=\"origin\"\n  cdkConnectedOverlayHasBackdrop\n  (overlayOutsideClick)=\"positionStrategy === 'flexibleConnectedTo' && close()\"\n  (backdropClick)=\"positionStrategy === 'global' && close()\"\n  (detach)=\"close()\"\n  (attach)=\"attach()\"\n  cdkConnectedOverlayPanelClass=\"ids-modal-wrapper\"\n  [cdkConnectedOverlayScrollStrategy]=\"overlay.scrollStrategies[scrollStrategy]()\"\n  [cdkConnectedOverlayBackdropClass]=\"backdropClass\"\n  [cdkConnectedOverlayDisableClose]=\"openChange.observers.length === 0\"\n>\n  <div class=\"ids-modal-wrapper__container\">\n    <section\n      cdkTrapFocus\n      [class]=\"className\"\n      [style.width]=\"width\"\n      role=\"dialog\"\n      [attr.aria-label]=\"ariaLabel\"\n      [attr.aria-labelledby]=\"ariaLabelledby\"\n      #contentRef\n      [attr.lang]=\"lang\"\n      [id]=\"id\"\n      [attr.aria-modal]=\"ariaModal\"\n    >\n      <ng-content select=\"ids-modal-header\"></ng-content>\n\n      <div class=\"ids-modal__body\" idsEnsureScrollableAccess>\n        <ng-content></ng-content>\n      </div>\n\n      <ng-content select=\"ids-modal-footer\"></ng-content>\n    </section>\n  </div>\n</ng-template>\n", dependencies: [{ kind: "directive", type: i1$1.CdkTrapFocus, selector: "[cdkTrapFocus]", inputs: ["cdkTrapFocus", "cdkTrapFocusAutoCapture"], exportAs: ["cdkTrapFocus"] }, { kind: "directive", type: i1$3.CdkConnectedOverlay, selector: "[cdk-connected-overlay], [connected-overlay], [cdkConnectedOverlay]", inputs: ["cdkConnectedOverlayOrigin", "cdkConnectedOverlayPositions", "cdkConnectedOverlayPositionStrategy", "cdkConnectedOverlayOffsetX", "cdkConnectedOverlayOffsetY", "cdkConnectedOverlayWidth", "cdkConnectedOverlayHeight", "cdkConnectedOverlayMinWidth", "cdkConnectedOverlayMinHeight", "cdkConnectedOverlayBackdropClass", "cdkConnectedOverlayPanelClass", "cdkConnectedOverlayViewportMargin", "cdkConnectedOverlayScrollStrategy", "cdkConnectedOverlayOpen", "cdkConnectedOverlayDisableClose", "cdkConnectedOverlayTransformOriginOn", "cdkConnectedOverlayHasBackdrop", "cdkConnectedOverlayLockPosition", "cdkConnectedOverlayFlexibleDimensions", "cdkConnectedOverlayGrowAfterOpen", "cdkConnectedOverlayPush"], outputs: ["backdropClick", "positionChange", "attach", "detach", "overlayKeydown", "overlayOutsideClick"], exportAs: ["cdkConnectedOverlay"] }, { kind: "directive", type: IdsEnsureScrollableAccessDirective, selector: "[idsEnsureScrollableAccess]" }], encapsulation: i0.ViewEncapsulation.None });
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object)
], IdsModalComponent.prototype, "canPush", void 0);
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object)
], IdsModalComponent.prototype, "autoFocus", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-modal', encapsulation: ViewEncapsulation.None, host: {
                        '[attr.aria-labelledby]': 'null',
                        '[attr.id]': 'null',
                        '[attr.class]': 'null',
                        '[attr.width]': 'null',
                    }, providers: [
                        {
                            provide: IdsModalService,
                        },
                    ], template: "<ng-template\n  cdkConnectedOverlay\n  [cdkConnectedOverlayOpen]=\"open\"\n  [cdkConnectedOverlayOrigin]=\"origin\"\n  cdkConnectedOverlayHasBackdrop\n  (overlayOutsideClick)=\"positionStrategy === 'flexibleConnectedTo' && close()\"\n  (backdropClick)=\"positionStrategy === 'global' && close()\"\n  (detach)=\"close()\"\n  (attach)=\"attach()\"\n  cdkConnectedOverlayPanelClass=\"ids-modal-wrapper\"\n  [cdkConnectedOverlayScrollStrategy]=\"overlay.scrollStrategies[scrollStrategy]()\"\n  [cdkConnectedOverlayBackdropClass]=\"backdropClass\"\n  [cdkConnectedOverlayDisableClose]=\"openChange.observers.length === 0\"\n>\n  <div class=\"ids-modal-wrapper__container\">\n    <section\n      cdkTrapFocus\n      [class]=\"className\"\n      [style.width]=\"width\"\n      role=\"dialog\"\n      [attr.aria-label]=\"ariaLabel\"\n      [attr.aria-labelledby]=\"ariaLabelledby\"\n      #contentRef\n      [attr.lang]=\"lang\"\n      [id]=\"id\"\n      [attr.aria-modal]=\"ariaModal\"\n    >\n      <ng-content select=\"ids-modal-header\"></ng-content>\n\n      <div class=\"ids-modal__body\" idsEnsureScrollableAccess>\n        <ng-content></ng-content>\n      </div>\n\n      <ng-content select=\"ids-modal-footer\"></ng-content>\n    </section>\n  </div>\n</ng-template>\n" }]
        }], ctorParameters: function () { return [{ type: i1$3.Overlay }, { type: i1$3.OverlayContainer }, { type: i0.Renderer2 }, { type: IdsModalService }]; }, propDecorators: { width: [{
                type: Input
            }], ariaLabelledby: [{
                type: Input,
                args: ['aria-labelledby']
            }], ariaLabel: [{
                type: Input,
                args: ['aria-label']
            }], className: [{
                type: Input,
                args: ['class']
            }], open: [{
                type: Input
            }, {
                type: HostListener,
                args: ['click']
            }], lang: [{
                type: Input
            }], origin: [{
                type: Input
            }], scrollStrategy: [{
                type: Input
            }], positionStrategy: [{
                type: Input
            }], positions: [{
                type: Input
            }], canPush: [{
                type: Input
            }], zIndex: [{
                type: Input
            }], openChange: [{
                type: Output
            }], autoFocus: [{
                type: Input
            }], modalHeader: [{
                type: ContentChild,
                args: [forwardRef(() => IdsModalHeaderComponent), { static: true }]
            }], overlayDir: [{
                type: ViewChild,
                args: [CdkConnectedOverlay, { static: true }]
            }], contentRef: [{
                type: ViewChild,
                args: ['contentRef']
            }] } });

class IdsModalDescriptionDirective {
    constructor() {
        this.class = 'ids-modal-header__description';
    }
}
IdsModalDescriptionDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsModalDescriptionDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
IdsModalDescriptionDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsModalDescriptionDirective, selector: "[idsModalDescription]", host: { properties: { "class": "this.class" } }, exportAs: ["idsModalDescription"], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsModalDescriptionDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsModalDescription]',
                    exportAs: 'idsModalDescription',
                }]
        }], propDecorators: { class: [{
                type: HostBinding,
                args: ['class']
            }] } });

class IdsModalFooterComponent {
    constructor() {
        /**
         * @internal
         * variável para setar os botões em modo inline independente do tamanho da tela. Definida para reúso de outros componentes que precisam do modal com essa variação de alinhamento, por isso não se aplica ao handoff do Modal.
         */
        this.inlineButtons = false;
    }
}
IdsModalFooterComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsModalFooterComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IdsModalFooterComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsModalFooterComponent, selector: "ids-modal-footer", inputs: { inlineButtons: "inlineButtons" }, ngImport: i0, template: "<footer class=\"ids-modal-footer\" [ngClass]=\"{ 'ids-modal-footer--inline': inlineButtons }\">\n  <ng-content></ng-content>\n</footer>\n", dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsModalFooterComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-modal-footer', template: "<footer class=\"ids-modal-footer\" [ngClass]=\"{ 'ids-modal-footer--inline': inlineButtons }\">\n  <ng-content></ng-content>\n</footer>\n" }]
        }], propDecorators: { inlineButtons: [{
                type: Input
            }] } });

class IdsModalModule {
}
IdsModalModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsModalModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsModalModule, declarations: [IdsModalComponent,
        IdsModalHeaderComponent,
        IdsModalFooterComponent,
        idsModalCloseDirective,
        IdsModalDescriptionDirective,
        IdsModalTitleDirective], imports: [A11yModule,
        CommonModule,
        OverlayModule,
        IdsIconButtonModule,
        IdsIconModule,
        IdsMainButtonModule,
        IdsOverlayOriginModule,
        IdsEnsureScrollableAccessModule], exports: [IdsModalComponent,
        IdsModalHeaderComponent,
        IdsModalFooterComponent,
        idsModalCloseDirective,
        IdsModalDescriptionDirective,
        IdsModalTitleDirective,
        IdsOverlayOriginModule,
        IdsEnsureScrollableAccessModule] });
IdsModalModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsModalModule, imports: [A11yModule,
        CommonModule,
        OverlayModule,
        IdsIconButtonModule,
        IdsIconModule,
        IdsMainButtonModule,
        IdsOverlayOriginModule,
        IdsEnsureScrollableAccessModule, IdsOverlayOriginModule,
        IdsEnsureScrollableAccessModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsModalModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        A11yModule,
                        CommonModule,
                        OverlayModule,
                        IdsIconButtonModule,
                        IdsIconModule,
                        IdsMainButtonModule,
                        IdsOverlayOriginModule,
                        IdsEnsureScrollableAccessModule,
                    ],
                    declarations: [
                        IdsModalComponent,
                        IdsModalHeaderComponent,
                        IdsModalFooterComponent,
                        idsModalCloseDirective,
                        IdsModalDescriptionDirective,
                        IdsModalTitleDirective,
                    ],
                    exports: [
                        IdsModalComponent,
                        IdsModalHeaderComponent,
                        IdsModalFooterComponent,
                        idsModalCloseDirective,
                        IdsModalDescriptionDirective,
                        IdsModalTitleDirective,
                        IdsOverlayOriginModule,
                        IdsEnsureScrollableAccessModule,
                    ],
                }]
        }] });

let NEXT_ID_PREFIX = 0;
class IdsPrefixDirective {
    constructor() {
        this.classes = true;
        this.id = `ids-prefix-${NEXT_ID_PREFIX++}`;
    }
}
IdsPrefixDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsPrefixDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
IdsPrefixDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsPrefixDirective, isStandalone: true, selector: "[idsPrefix]", inputs: { id: "id" }, host: { properties: { "class.ids-form-field__prefix": "this.classes", "attr.id": "this.id" } }, exportAs: ["idsPrefix"], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsPrefixDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsPrefix]',
                    exportAs: 'idsPrefix',
                    standalone: true,
                }]
        }], propDecorators: { classes: [{
                type: HostBinding,
                args: ['class.ids-form-field__prefix']
            }], id: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.id']
            }] } });
class IdsSuffixDirective {
}
IdsSuffixDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSuffixDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
IdsSuffixDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsSuffixDirective, isStandalone: true, selector: "[idsSuffix]", exportAs: ["idsSuffix"], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSuffixDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsSuffix]',
                    exportAs: 'idsSuffix',
                    standalone: true,
                }]
        }] });

class IdsFormFieldLabelDirective {
    get formFieldLabelClass() {
        return true;
    }
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
}
IdsFormFieldLabelDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormFieldLabelDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
IdsFormFieldLabelDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsFormFieldLabelDirective, isStandalone: true, selector: "[idsFormFieldLabel]", host: { properties: { "class.ids-form-field__label": "this.formFieldLabelClass" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormFieldLabelDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsFormFieldLabel]',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { formFieldLabelClass: [{
                type: HostBinding,
                args: ['class.ids-form-field__label']
            }] } });

let NEXT_ID$j = 0;
/**
 * O IdsFormMessage foi desenvolvido para ser utilizado em conjunto com os componentes de seleção como checkbox,
 * radiobutton e switch.
 *
 * **Module:**
 *
 * `import { IdsFormMessageModule } from '@ids/angular';`
 */
class IdsFormMessageComponent {
    get classes() {
        return {
            'ids-form-message': true,
            'ids-form-message--disabled': this.status === 'disabled',
            'ids-form-message--error': this.status === 'error',
            'ids-form-message--on-brand': this.contrast === 'onBrand',
        };
    }
    constructor(liveAnnouncer) {
        this.liveAnnouncer = liveAnnouncer;
        /* istanbul ignore next */
        this.observer = new MutationObserver(() => this._checkAriaLive());
        this.id = `ids-form-message-${++NEXT_ID$j}`;
        this._hostId = null;
        // Windows deve ser sempre off, pois ele já lê automaticamente e o aria-live duplica a leitura
        // Mobile deve iniciar como off e mudar para polite quando houver a primeira mudança de texto
        this.ariaLive = 'off';
        /**
         * Toggle para manter o elemento e só mostrar ou esconder o texto
         */
        this.show = true;
    }
    /* istanbul ignore next */
    ngAfterViewInit() {
        if (this.contentRef && this.ariaLive === 'off' && platform.os !== 'Windows') {
            this._listenToMutation();
        }
    }
    /* istanbul ignore next */
    ngOnDestroy() {
        this.observer.disconnect();
    }
    /* istanbul ignore next */
    _listenToMutation() {
        this.observer.observe(this.contentRef.nativeElement, {
            subtree: true,
            characterData: true,
        });
    }
    _checkAriaLive() {
        this.ariaLive = 'polite';
        // como no iOS o aria-live inicia como "off", não faz a leitura no Safari,
        // apenas quando o campo de texto é do tipo textarea.
        // O announceDescription traz a informação de que é textarea.
        if (platform.userAgent === 'Safari' && this.announceDescription) {
            this.liveAnnouncer.announce(this.contentRef.nativeElement.textContent, 1000);
        }
    }
}
IdsFormMessageComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormMessageComponent, deps: [{ token: i1$1.LiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component });
IdsFormMessageComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsFormMessageComponent, isStandalone: true, selector: "ids-form-message", inputs: { id: "id", contrast: "contrast", ariaLive: ["aria-live", "ariaLive"], show: "show", announceDescription: "announceDescription", status: "status" }, host: { properties: { "attr.aria-live": "null", "attr.id": "this._hostId" } }, viewQueries: [{ propertyName: "contentRef", first: true, predicate: ["content"], descendants: true }], ngImport: i0, template: "<div [class]=\"classes\" [attr.aria-live]=\"ariaLive\">\n  <ng-container *ngIf=\"show\">\n    <ids-icon size=\"S\" *ngIf=\"status === 'error'\"> aviso_outline </ids-icon>\n\n    <span [id]=\"id\" #content>\n      <ng-content></ng-content>\n    </span>\n  </ng-container>\n</div>\n", styles: [".ids-form-message{align-items:center;color:var(--ids_color_action_neutral_base);display:flex;font:var(--ids_textStyle_f02_s14_h20_wrg);margin-right:var(--ids_spacing_2x)}.ids-form-message .ids-icon{margin-right:var(--ids_size_general_4x);margin-top:var(--ids_size_general_1x)}.ids-form-message--error{color:var(--ids_color_feedback_error)}.ids-form-message--disabled{color:var(--ids_color_action_disabled_variant)}.ids-form-message--hidden{display:none}.ids-form-message--on-brand{color:var(--ids_color_contrast_onBrand_primary)}.ids-form-message--on-brand.ids-form-message--disabled{color:var(--ids_color_contrast_onBrand_primary_medium)}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: IdsIconModule }, { kind: "component", type: IdsIconComponent, selector: "ids-icon", inputs: ["size", "variant", "contrast"] }] });
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object)
], IdsFormMessageComponent.prototype, "show", void 0);
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object)
], IdsFormMessageComponent.prototype, "announceDescription", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormMessageComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-form-message', host: {
                        '[attr.aria-live]': 'null',
                    }, imports: [CommonModule, IdsIconModule], standalone: true, template: "<div [class]=\"classes\" [attr.aria-live]=\"ariaLive\">\n  <ng-container *ngIf=\"show\">\n    <ids-icon size=\"S\" *ngIf=\"status === 'error'\"> aviso_outline </ids-icon>\n\n    <span [id]=\"id\" #content>\n      <ng-content></ng-content>\n    </span>\n  </ng-container>\n</div>\n", styles: [".ids-form-message{align-items:center;color:var(--ids_color_action_neutral_base);display:flex;font:var(--ids_textStyle_f02_s14_h20_wrg);margin-right:var(--ids_spacing_2x)}.ids-form-message .ids-icon{margin-right:var(--ids_size_general_4x);margin-top:var(--ids_size_general_1x)}.ids-form-message--error{color:var(--ids_color_feedback_error)}.ids-form-message--disabled{color:var(--ids_color_action_disabled_variant)}.ids-form-message--hidden{display:none}.ids-form-message--on-brand{color:var(--ids_color_contrast_onBrand_primary)}.ids-form-message--on-brand.ids-form-message--disabled{color:var(--ids_color_contrast_onBrand_primary_medium)}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.LiveAnnouncer }]; }, propDecorators: { id: [{
                type: Input
            }], _hostId: [{
                type: HostBinding,
                args: ['attr.id']
            }], contrast: [{
                type: Input
            }], ariaLive: [{
                type: Input,
                args: ['aria-live']
            }], show: [{
                type: Input
            }], announceDescription: [{
                type: Input
            }], contentRef: [{
                type: ViewChild,
                args: ['content']
            }], status: [{
                type: Input
            }] } });

class IdsFormMessageModule {
}
IdsFormMessageModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormMessageModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsFormMessageModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsFormMessageModule, imports: [IdsFormMessageComponent], exports: [IdsFormMessageComponent] });
IdsFormMessageModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormMessageModule, imports: [IdsFormMessageComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormMessageModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsFormMessageComponent],
                    exports: [IdsFormMessageComponent],
                }]
        }] });

class PxToRemPipe {
    transform(unit = 0) {
        return pxToRem(unit);
    }
}
PxToRemPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PxToRemPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
PxToRemPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: PxToRemPipe, isStandalone: true, name: "pxToRem" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: PxToRemPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'pxToRem', standalone: true }]
        }] });

class UnitConverterModule {
}
UnitConverterModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: UnitConverterModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
UnitConverterModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: UnitConverterModule, imports: [PxToRemPipe], exports: [PxToRemPipe] });
UnitConverterModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: UnitConverterModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: UnitConverterModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [PxToRemPipe],
                    exports: [PxToRemPipe],
                }]
        }] });

let NEXT_ID$i = 0;
let lastFocusOrigin$1;
/**
 * Os formulários reativos fornecem uma abordagem orientada a modelo para lidar com entradas de formulário
 * cujo valores mudam ao longo do tempo. Este guia mostra como criar e atualizar um controle de formulário simples e
 * validar valores do formulário.
 *
 * **Module:**
 *
 * `import { IdsInputModule, IdsFormFieldModule, IdsIconModule } from '@ids/angular';`
 *
 * Este modulo possui todas as diretivas de criação de formulários do tipo formulário reativo.
 *
 * `import { ReactiveFormsModule } from '@angular/forms';`
 *
 * **Component.ts:**
 *
 *  Este import disponibiliza os recursos Angular para criar o formulário reativo.
 *
 * `import { FormControl, Validators, FormGroup } from '@angular/forms';`
import { OnInit } from '@angular/core';
 *
 */
class IdsFormFieldComponent {
    get hasValue() {
        return Boolean(this.field.value ||
            this.field.nativeElement.value ||
            // o placeholder do input "type date" não é identificado como valor ou
            // placeholder de fato, então precisa dessa verificação
            this.field.nativeElement.type === 'date');
    }
    get classes() {
        const externalClasses = this.externalClasses.join(' ');
        return this.field
            ? {
                'ids-form-field': true,
                'ids-form-field--error': this.hasError,
                'ids-form-field--large': this.size === 'L' || (this.isCurrency && this.center),
                'ids-form-field--value': this.hasValue,
                'ids-form-field--button-suffix': this.isButtonSuffix,
                'ids-form-field--center': this.center,
                'ids-form-field--placeholder': this.hasPlaceHolder,
                'ids-form-field--focus': this.isFocused,
                'ids-form-field--visible-focus': this.canShowVisibleFocus,
                'ids-form-field--disabled': this.isDisabled || this.isReadOnly,
                'ids-form-field--suffix': this.hasSuffix,
                'ids-form-field--outline': this.outline,
                'ids-form-field--on-brand': this.contrast === 'onBrand',
                'ids-form-field--secondary': this.variant === 'secondary',
                'ids-form-field--no-label': !this.hasLabel,
                'ids-form-field--no-border': this.noBorder,
                'ids-form-field--no-message': this.noMessage,
                [externalClasses]: true,
            }
            : '';
    }
    get isCurrency() {
        return this.mask && this.mask.idsMask === 'currency';
    }
    get isDisabled() {
        return Boolean(this.field.nativeElement.disabled || this.field.nativeElement.disabled || this.field.disabled);
    }
    get isReadOnly() {
        return Boolean(this.field.nativeElement.readOnly);
    }
    get hasPrefix() {
        return Boolean(this.prefix || (this.isCurrency && this.hasValue));
    }
    get hasSuffix() {
        return Boolean(this.hasContentSuffix || this.externalSuffix || this.edit);
    }
    get hasPlaceHolder() {
        return Boolean(this.field.nativeElement.placeholder);
    }
    get hasLabel() {
        return Boolean(this.labelDirective || this.label);
    }
    get isTextarea() {
        return this.field?.nativeElement?.type === 'textarea';
    }
    get maxLength() {
        return this.field.nativeElement.maxLength;
    }
    get hasMaxLength() {
        return this.maxLength >= 0;
    }
    get isButtonSuffix() {
        return !this.outline && this.suffix?.nativeElement?.querySelector('button');
    }
    get isFocused() {
        return ((this.field.focused || document.activeElement === this.field.nativeElement) &&
            !(this.field.disabled || this.field.nativeElement.disabled));
    }
    get lastCharactersMessage() {
        const remainingCharacters = this.maxLength - textLength(this.field.value.toString());
        const pluralLabel = `${remainingCharacters} ${this.charactersRemainingMessage.plural}`;
        const singularLabel = `${remainingCharacters} ${this.charactersRemainingMessage.singular}`;
        return remainingCharacters > 1 ? pluralLabel : singularLabel;
    }
    get message() {
        if (this.hasError) {
            return this.errorMessage;
        }
        return this.description;
    }
    // verifica se o campo está inválido
    // usado para validar manuelmente o campo, sem ngControl
    get isFieldInvalid() {
        return Boolean((this.field.ngControl.touched || this.field.ngControl.dirty) &&
            this.field.invalid &&
            (!this.field.updateFirstOnBlur ||
                (this.field.updateFirstOnBlur && this.field.ngControl.touched)));
    }
    get prefixWidth() {
        return this.prefixElement?.nativeElement.offsetWidth || 0;
    }
    get textWidth() {
        return this.dummy?.nativeElement.offsetWidth || 0;
    }
    set describedById(id) {
        this._externalDescription = true;
        this._describedById = id;
    }
    get describedById() {
        return this._describedById;
    }
    /**
     * limite que determina quando o polite estará ativo
     */
    set thresholdAnnounce(thresholdAnnounce) {
        this._thresholdAnnounce = enforceNumber(thresholdAnnounce);
    }
    get thresholdAnnounce() {
        return this._thresholdAnnounce;
    }
    /**
     * Indica se o input terá borda
     */
    set noBorder(value) {
        this._noBorder = enforceBoolean(value);
    }
    get noBorder() {
        return this._noBorder;
    }
    /**
     * mensagem de erro para ser exibida quando o campo é inválido
     */
    get errorMessage() {
        return this._errorMessage;
    }
    set errorMessage(msg) {
        this._errorMessage = msg;
    }
    /**
     * descrição do campo, utilizado para apoiar o preenchimento
     */
    set description(description) {
        this._description = description;
    }
    get description() {
        const lastCharacters = this.isTextarea &&
            this.hasMaxLength &&
            this.maxLength - textLength(this.field.value.toString()) <= this.thresholdAnnounce;
        if (lastCharacters) {
            return this.lastCharactersMessage;
        }
        return this._description;
    }
    set edit(value) {
        this._edit = enforceBoolean(value);
    }
    get edit() {
        return this._edit;
    }
    set noValidate(value) {
        this._noValidate = enforceBoolean(value);
    }
    get noValidate() {
        return this._noValidate;
    }
    set center(value) {
        this._center = enforceBoolean(value);
    }
    get center() {
        return this._center;
    }
    get hasContentSuffix() {
        return this.contentIcon || this.contentSuffix;
    }
    describedHandler() {
        return (this.field.active || !this.field.focused) && !this.hasError;
    }
    updateAriaLabelledByWithPrefix() {
        if (this.prefix) {
            this.field.ariaLabelledby = `${this.field.controlId} ${this.prefix.id}`;
        }
    }
    constructor(_focusMonitor, _formFieldService, cdr) {
        this._focusMonitor = _focusMonitor;
        this._formFieldService = _formFieldService;
        this.cdr = cdr;
        this._errorShowed = false;
        this.externalSuffix = '';
        this.externalClasses = [];
        this.outline = false;
        this.canShowVisibleFocus = false;
        this.hasError = false;
        this.selector = 'IdsFormFieldComponent';
        this.fieldDefined = false;
        this._describedById = `ids-describedby-${++NEXT_ID$i}`;
        this._externalDescription = false;
        this._destroy = new Subject();
        /**
         * label do campo
         */
        this.label = '';
        this._thresholdAnnounce = 15;
        this._errorMessage = 'o preenchimento do campo é obrigatório';
        this._description = '';
        this._edit = false;
        this._noValidate = false;
        this._center = false;
        /**
         * Mensagem plural/singular para caracteres que faltam
         */
        this.charactersRemainingMessage = {
            singular: 'caracter restante',
            plural: 'caracteres restantes',
        };
        this._formFieldService.classes$().subscribe((classes) => {
            this.externalClasses = classes;
        });
        this._formFieldService.suffixIcon$().subscribe((icon) => {
            this.externalSuffix = icon;
        });
    }
    ngAfterContentInit() {
        if (this.isCurrency) {
            this.fieldPrefix = this.mask.config?.prefix || 'R$';
            this.mask.prefixToBeAnnounced = this.fieldPrefix.trim();
            if (this.mask.config) {
                this.mask.config = {
                    ...this.mask.config,
                    prefix: '',
                };
                return;
            }
            this.mask.config = {
                allowNegative: false,
                decimal: ',',
                precision: 2,
                thousands: '.',
                prefix: '',
                suffix: '',
            };
        }
        this.fieldSetup();
        this.labelSetup();
    }
    ngAfterViewInit() {
        this._formFieldService.sendFormFieldElement(this.formField.nativeElement);
        this.cdr.detectChanges();
    }
    ngAfterViewChecked() {
        /* istanbul ignore next */
        if (!this.fieldDefined) {
            Promise.resolve().then(() => {
                this.fieldSetup();
            });
        }
        this.cdr.detectChanges();
    }
    initializeField() {
        this.field.errorState.pipe(startWith(false), takeUntil(this._destroy)).subscribe((state) => {
            // quando a opção noValidate está ligada o estado de erro é baseado
            // no estado do campo e não no estado do ngControl
            const hasError = this.noValidate ? this.isFieldInvalid : state;
            if (platform.os === 'IOS' && hasError !== this._errorShowed) {
                this.describedById = `ids-describedby-${++NEXT_ID$i}`;
                this._errorShowed = hasError;
            }
            this.hasError = hasError;
            this.field.handleDescribedby(this.describedById);
            if (!this.noValidate) {
                this.field.handleInvalid(this.hasError);
            }
        });
        this.updateAriaLabelledByWithPrefix();
    }
    activateFocusMonitor() {
        this._focusMonitor
            .monitor(this.field.nativeElement, true)
            .pipe(takeUntil(this._destroy))
            .subscribe((origin) => {
            this.canShowVisibleFocus =
                origin === 'keyboard' || (origin === 'program' && lastFocusOrigin$1 === 'keyboard');
            if (origin && origin !== 'program') {
                lastFocusOrigin$1 = origin;
            }
        });
    }
    labelSetup() {
        if (!this.labelDirective) {
            return;
        }
        this.labelDirective.elementRef.nativeElement.setAttribute('for', this.field.controlId);
        if (this.field.labelId) {
            this.labelDirective.elementRef.nativeElement.setAttribute('id', this.field.labelId);
        }
    }
    fieldSetup() {
        if (!this.field) {
            return;
        }
        this.initializeField();
        this.activateFocusMonitor();
        this.fieldDefined = true;
    }
    ngOnDestroy() {
        this._focusMonitor.stopMonitoring(this.field);
        this._destroy.next();
        this._destroy.complete();
    }
}
IdsFormFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormFieldComponent, deps: [{ token: i1$1.FocusMonitor }, { token: IdsFormFieldService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
IdsFormFieldComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsFormFieldComponent, isStandalone: true, selector: "ids-form-field", inputs: { describedById: ["aria-describedby", "describedById"], contrast: "contrast", label: "label", size: "size", noMessage: "noMessage", thresholdAnnounce: "thresholdAnnounce", variant: "variant", noBorder: "noBorder", errorMessage: "errorMessage", description: "description", edit: "edit", noValidate: "noValidate", center: "center", charactersRemainingMessage: "charactersRemainingMessage" }, providers: [
        {
            provide: IdsFormFieldService,
        },
        // Utilizado para não dar erro em Angular 14. Não remova enquanto não remover
        // a condição de host: VERSION no datepicker.directive
        {
            provide: IdsMaskDirective,
        },
    ], queries: [{ propertyName: "mask", first: true, predicate: IdsMaskDirective, descendants: true }, { propertyName: "field", first: true, predicate: IdsFieldMixinBase, descendants: true, static: true }, { propertyName: "prefix", first: true, predicate: IdsPrefixDirective, descendants: true, static: true }, { propertyName: "labelDirective", first: true, predicate: IdsFormFieldLabelDirective, descendants: true, static: true }, { propertyName: "contentSuffix", first: true, predicate: IdsSuffixDirective, descendants: true, static: true }, { propertyName: "contentIcon", first: true, predicate: IdsIconComponent, descendants: true, static: true }], viewQueries: [{ propertyName: "dummy", first: true, predicate: ["dummy"], descendants: true, static: true }, { propertyName: "suffix", first: true, predicate: ["suffix"], descendants: true }, { propertyName: "prefixElement", first: true, predicate: ["prefix"], descendants: true }, { propertyName: "formField", first: true, predicate: ["formField"], descendants: true }, { propertyName: "formMessage", first: true, predicate: IdsFormMessageComponent, descendants: true }], ngImport: i0, template: "<div\n  [ngClass]=\"classes\"\n  #formField\n  [ngStyle]=\"{\n    '--ids-form-field-text-width': this.center ? (textWidth | pxToRem) : 0,\n    '--ids-form-field-prefix-width': prefixWidth | pxToRem\n  }\"\n>\n  <div class=\"ids-form-field__container\">\n    <label\n      *ngIf=\"label && !labelDirective\"\n      [for]=\"field.controlId\"\n      class=\"ids-form-field__label\"\n      [attr.id]=\"field.labelId ? field.labelId : null\"\n    >\n      {{ label }}\n    </label>\n\n    <ng-content select=\"label\"></ng-content>\n\n    <div class=\"ids-form-field__content\">\n      <div\n        #prefix\n        class=\"ids-form-field__prefix\"\n        [style.visibility]=\"isCurrency && hasValue ? 'visible' : 'hidden'\"\n        aria-hidden=\"true\"\n      >\n        {{ fieldPrefix }}\n      </div>\n\n      <ng-content></ng-content>\n\n      <div #suffix class=\"ids-form-field__suffix\">\n        <ng-content select=\"ids-icon, [idsSuffix]\"></ng-content>\n\n        <ids-icon *ngIf=\"edit\" variant=\"primary\"> editar_outline </ids-icon>\n\n        <ids-icon *ngIf=\"externalSuffix && !hasContentSuffix\" variant=\"primary\">\n          {{ externalSuffix }}\n        </ids-icon>\n      </div>\n    </div>\n\n    <ng-content select=\"ids-listbox\"></ng-content>\n    <ng-content select=\"ids-listbox\"></ng-content>\n  </div>\n\n  <div class=\"ids-form-field__status-message\" *ngIf=\"!noMessage\">\n    <ids-form-message\n      [status]=\"hasError ? 'error' : undefined\"\n      [id]=\"describedById\"\n      [announceDescription]=\"!isTextarea\"\n    >\n      {{ message }}\n    </ids-form-message>\n  </div>\n\n  <div #dummy class=\"ids-input ids-dummy-width\" aria-hidden=\"true\">\n    {{ field.nativeElement.value }}\n  </div>\n</div>\n", styles: ["ids-form-field{display:block}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "ngmodule", type: IdsIconModule }, { kind: "component", type: IdsIconComponent, selector: "ids-icon", inputs: ["size", "variant", "contrast"] }, { kind: "ngmodule", type: IdsFormMessageModule }, { kind: "component", type: IdsFormMessageComponent, selector: "ids-form-message", inputs: ["id", "contrast", "aria-live", "show", "announceDescription", "status"] }, { kind: "ngmodule", type: UnitConverterModule }, { kind: "pipe", type: PxToRemPipe, name: "pxToRem" }], encapsulation: i0.ViewEncapsulation.None });
__decorate([
    Memo([
        'hasValue',
        'size',
        'hasError',
        'isButtonSuffix',
        'center',
        'hasPlaceHolder',
        'isFocused',
        'canShowVisibleFocus',
        'isDisabled',
        'isReadOnly',
        'hasSuffix',
        'outline',
        'contrast',
        'variant',
        'hasLabel',
        'noBorder',
        'noMessage',
    ]),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], IdsFormFieldComponent.prototype, "classes", null);
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object)
], IdsFormFieldComponent.prototype, "noMessage", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormFieldComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-form-field', imports: [CommonModule, IdsIconModule, IdsFormMessageModule, UnitConverterModule], standalone: true, encapsulation: ViewEncapsulation.None, providers: [
                        {
                            provide: IdsFormFieldService,
                        },
                        // Utilizado para não dar erro em Angular 14. Não remova enquanto não remover
                        // a condição de host: VERSION no datepicker.directive
                        {
                            provide: IdsMaskDirective,
                        },
                    ], template: "<div\n  [ngClass]=\"classes\"\n  #formField\n  [ngStyle]=\"{\n    '--ids-form-field-text-width': this.center ? (textWidth | pxToRem) : 0,\n    '--ids-form-field-prefix-width': prefixWidth | pxToRem\n  }\"\n>\n  <div class=\"ids-form-field__container\">\n    <label\n      *ngIf=\"label && !labelDirective\"\n      [for]=\"field.controlId\"\n      class=\"ids-form-field__label\"\n      [attr.id]=\"field.labelId ? field.labelId : null\"\n    >\n      {{ label }}\n    </label>\n\n    <ng-content select=\"label\"></ng-content>\n\n    <div class=\"ids-form-field__content\">\n      <div\n        #prefix\n        class=\"ids-form-field__prefix\"\n        [style.visibility]=\"isCurrency && hasValue ? 'visible' : 'hidden'\"\n        aria-hidden=\"true\"\n      >\n        {{ fieldPrefix }}\n      </div>\n\n      <ng-content></ng-content>\n\n      <div #suffix class=\"ids-form-field__suffix\">\n        <ng-content select=\"ids-icon, [idsSuffix]\"></ng-content>\n\n        <ids-icon *ngIf=\"edit\" variant=\"primary\"> editar_outline </ids-icon>\n\n        <ids-icon *ngIf=\"externalSuffix && !hasContentSuffix\" variant=\"primary\">\n          {{ externalSuffix }}\n        </ids-icon>\n      </div>\n    </div>\n\n    <ng-content select=\"ids-listbox\"></ng-content>\n    <ng-content select=\"ids-listbox\"></ng-content>\n  </div>\n\n  <div class=\"ids-form-field__status-message\" *ngIf=\"!noMessage\">\n    <ids-form-message\n      [status]=\"hasError ? 'error' : undefined\"\n      [id]=\"describedById\"\n      [announceDescription]=\"!isTextarea\"\n    >\n      {{ message }}\n    </ids-form-message>\n  </div>\n\n  <div #dummy class=\"ids-input ids-dummy-width\" aria-hidden=\"true\">\n    {{ field.nativeElement.value }}\n  </div>\n</div>\n", styles: ["ids-form-field{display:block}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.FocusMonitor }, { type: IdsFormFieldService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { mask: [{
                type: ContentChild,
                args: [IdsMaskDirective]
            }], dummy: [{
                type: ViewChild,
                args: ['dummy', { static: true }]
            }], classes: [], describedById: [{
                type: Input,
                args: ['aria-describedby']
            }], contrast: [{
                type: Input
            }], label: [{
                type: Input
            }], size: [{
                type: Input
            }], noMessage: [{
                type: Input
            }], thresholdAnnounce: [{
                type: Input
            }], variant: [{
                type: Input
            }], noBorder: [{
                type: Input
            }], errorMessage: [{
                type: Input
            }], description: [{
                type: Input
            }], edit: [{
                type: Input
            }], noValidate: [{
                type: Input
            }], center: [{
                type: Input
            }], charactersRemainingMessage: [{
                type: Input
            }], field: [{
                type: ContentChild,
                args: [IdsFieldMixinBase, { static: true }]
            }], suffix: [{
                type: ViewChild,
                args: ['suffix', { static: false }]
            }], prefixElement: [{
                type: ViewChild,
                args: ['prefix', { static: false }]
            }], prefix: [{
                type: ContentChild,
                args: [IdsPrefixDirective, { static: true }]
            }], labelDirective: [{
                type: ContentChild,
                args: [IdsFormFieldLabelDirective, { static: true }]
            }], contentSuffix: [{
                type: ContentChild,
                args: [IdsSuffixDirective, { static: true }]
            }], contentIcon: [{
                type: ContentChild,
                args: [IdsIconComponent, { static: true }]
            }], formField: [{
                type: ViewChild,
                args: ['formField']
            }], formMessage: [{
                type: ViewChild,
                args: [IdsFormMessageComponent]
            }] } });

const formFieldComponents = [
    IdsFormFieldComponent,
    IdsFormFieldLabelDirective,
    IdsPrefixDirective,
    IdsSuffixDirective,
];
class IdsFormFieldModule {
}
IdsFormFieldModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormFieldModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsFormFieldModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsFormFieldModule, declarations: [IdsFieldMixinBase], imports: [IdsFormFieldComponent,
        IdsFormFieldLabelDirective,
        IdsPrefixDirective,
        IdsSuffixDirective], exports: [IdsFormFieldComponent,
        IdsFormFieldLabelDirective,
        IdsPrefixDirective,
        IdsSuffixDirective, IdsFieldMixinBase] });
IdsFormFieldModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormFieldModule, imports: [IdsFormFieldComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormFieldModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [formFieldComponents],
                    exports: [formFieldComponents, IdsFieldMixinBase],
                    declarations: [IdsFieldMixinBase],
                }]
        }] });

const buildValueString = (id, value) => {
    let newVal;
    if (id === null) {
        return `${value}`;
    }
    if (value && typeof value === 'object') {
        newVal = 'Object';
    }
    return `${id}: ${newVal}`.slice(0, 50);
};
let NEXT_ID$h = 0;
/**
 * @deprecated Diretiva substituída por IdsSelectDirective
 */
class IdsNativeSelectDirective extends IdsFieldMixinBase {
    /**
     * Função para comparar os valores das opções com os valores selecionados.
     *
     * *Function to compare the option values with the selected values.*
     *
     * Exemplo:
     * options: IObj[] = [{ val: 1, label: 'Opção 1' },{ val: 2, label: 'Opção 2' }];
     *
     * compareFn(c1: any, c2: any): boolean {
     *   return c1 && c2 ? c1.val === c2.val : c1 === c2;
     * }
     *
     * https://angular.io/api/forms/SelectControlValueAccessor#caveat-option-selection
     */
    get compareWith() {
        return this._compareWith;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    set compareWith(fn) {
        this._compareWith = fn;
    }
    controlSelect({ value }) {
        this.value = this.getOptionValue(value);
        if (!this.value) {
            this._renderer.setProperty(this.elementRef.nativeElement, 'value', null);
        }
    }
    controlChange() {
        this.formAcessorHandleChange();
    }
    controlFocus() {
        this.formAcessorHandleFocus();
    }
    controlBlur() {
        this.formAcessorHandleBlur();
    }
    constructor(ngControl, elementRef, _renderer, _formFieldService) {
        super(ngControl, elementRef) /* istanbul ignore next */;
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this._renderer = _renderer;
        this._formFieldService = _formFieldService;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this._compareWith = objectIs;
        this._platform = platform;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.optionMap = new Map();
        this.idCounter = 0;
        /** @internal */
        this.controlId = `ids-native-select-${NEXT_ID$h++}`;
    }
    ngOnInit() {
        this._formFieldService.sendSuffixIcon('seta_baixo');
    }
    // verifica se estão inválidos os campos que não estão em foco
    // isso serve para validar mudanças que não vieram do usuário
    ngDoCheck() {
        /* istanbul ignore next */
        if (this.ngControl && this.ngControl.touched && this.ngControl.invalid && !this.active) {
            this.formAcessorHandleBlur();
        }
    }
    ngAfterViewInit() {
        // Validação necessária para as plataformas abaixo. Sem isso, o select seleciona
        // automaticamente a primeira opção e não atualiza o formControl ao iniciar
        if ((this._platform.os === 'IOS' || this._platform.os === 'MacOS') && !this.value) {
            this._renderer.setProperty(this.elementRef.nativeElement, 'value', null);
        }
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    writeValue(value) {
        this.value = value;
        const id = this.getOptionId(value);
        if (id === null) {
            this._renderer.setProperty(this.elementRef.nativeElement, 'selectedIndex', -1);
        }
        const valueString = buildValueString(id, value) || null;
        this._renderer.setProperty(this.elementRef.nativeElement, 'value', valueString);
    }
    registerOption() {
        return (this.idCounter++).toString();
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getOptionId(value) {
        for (const id of Array.from(this.optionMap.keys())) {
            if (this.compareWith(this.optionMap.get(id), value)) {
                return id;
            }
        }
        return null;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getOptionValue(valueString) {
        const id = this.extractId(valueString);
        return this.optionMap.has(id) ? this.optionMap.get(id) : valueString;
    }
    extractId(valueString) {
        return valueString.split(':')[0];
    }
}
IdsNativeSelectDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsNativeSelectDirective, deps: [{ token: i1$2.NgControl, optional: true, self: true }, { token: i0.ElementRef }, { token: i0.Renderer2 }, { token: IdsFormFieldService }], target: i0.ɵɵFactoryTarget.Directive });
IdsNativeSelectDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsNativeSelectDirective, isStandalone: true, selector: "[idsNativeSelect]", inputs: { controlId: ["id", "controlId"], compareWith: "compareWith" }, host: { listeners: { "change": "controlSelect($event.target)", "ngModelChange": "controlChange()", "focus": "controlFocus()", "blur": "controlBlur()" }, properties: { "attr.id": "controlId", "attr.disabled": "disabled || null", "attr.value": "value", "class.ids-input": "true" } }, providers: [
        {
            provide: IdsFieldMixinBase,
            useExisting: forwardRef(/* istanbul ignore next */ () => IdsNativeSelectDirective),
        },
    ], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsNativeSelectDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsNativeSelect]',
                    host: {
                        '[attr.id]': 'controlId',
                        '[attr.disabled]': 'disabled || null',
                        '[attr.value]': 'value',
                        '[class.ids-input]': 'true',
                    },
                    providers: [
                        {
                            provide: IdsFieldMixinBase,
                            useExisting: forwardRef(/* istanbul ignore next */ () => IdsNativeSelectDirective),
                        },
                    ],
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: i1$2.NgControl, decorators: [{
                    type: Self
                }, {
                    type: Optional
                }] }, { type: i0.ElementRef }, { type: i0.Renderer2 }, { type: IdsFormFieldService }]; }, propDecorators: { controlId: [{
                type: Input,
                args: ['id']
            }], compareWith: [{
                type: Input
            }], controlSelect: [{
                type: HostListener,
                args: ['change', ['$event.target']]
            }], controlChange: [{
                type: HostListener,
                args: ['ngModelChange']
            }], controlFocus: [{
                type: HostListener,
                args: ['focus']
            }], controlBlur: [{
                type: HostListener,
                args: ['blur']
            }] } });

class IdsNativeSelectOptionDirective {
    constructor(element, renderer, select) {
        this.element = element;
        this.renderer = renderer;
        this.select = select;
        if (this.select) {
            this.id = this.select.registerOption();
        }
    }
    /**
     * Rastreia o valor vinculado ao elemento de opção. Ao contrário da associação de valor(string),
     * `ngValue` oferece suporte à associação de objetos.
     *
     * *Tracks the value bound to the option element. Unlike the value binding,*
     * *`ngValue` supports binding to objects.*
     */
    set ngValue(value) {
        if (this.select === null) {
            return;
        }
        this.select.optionMap.set(this.id, value);
        this.setElementValue(buildValueString(this.id, value));
        this.select.writeValue(this.select.value);
    }
    /**
     * Rastreia valores de string simples vinculados ao elemento de opção.
     * Para objetos, use o parâmetro de entrada `ngValue`.
     *
     * *Tracks simple string values bound to the option element.*
     * *For objects, use the `ngValue` input binding.*
     */
    set value(value) {
        this.setElementValue(value);
        if (this.select) {
            this.select.writeValue(this.select.value);
        }
    }
    setElementValue(value) {
        this.renderer.setProperty(this.element.nativeElement, 'value', value);
    }
}
IdsNativeSelectOptionDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsNativeSelectOptionDirective, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: IdsNativeSelectDirective, host: true, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
IdsNativeSelectOptionDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsNativeSelectOptionDirective, isStandalone: true, selector: "[idsNativeOption]", inputs: { ngValue: "ngValue", value: "value" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsNativeSelectOptionDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsNativeOption]',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: IdsNativeSelectDirective, decorators: [{
                    type: Optional
                }, {
                    type: Host
                }] }]; }, propDecorators: { ngValue: [{
                type: Input
            }], value: [{
                type: Input
            }] } });

let NEXT_ID$g = 0;
/**
 * Select é um tipo de input utilizado em formulários, no qual o usuário tem a possibilidade de fazer uma escolha dentre
 * uma lista de opções, que são exibidas após o click no componente.
 *
 * *Select is a type of input used in forms, in which the user has the possibility to make a choice from a list of*
 * *options, which are displayed after clicking on the component.*
 *
 * **Module:**
 *
 * `import { IdsSelectModule, IdsFormFieldModule } from '@ids/angular';`
 *
 *  **Component:**
 *
 * `import { IdsSelectComponent, IdsOptionComponent, IdsNativeSelectDirective, IdsNativeSelectOptionDirective } from '@ids/angular';`
 */
class IdsSelectComponent extends IdsFieldMixinBase {
    get arrayOption() {
        return this.options.toArray();
    }
    get enabledOptions() {
        return this.arrayOption.filter((item) => !item.disabled && item.value);
    }
    get hightlightedDisabledOption() {
        return this.arrayOption.find((item) => item.highlighted);
    }
    get optionTextValue() {
        return this.value != null && this.value !== undefined && this.value !== ''
            ? this.options.find((option) => this.compareWith(option.value, this.value))?.optionLabel || ''
            : '';
    }
    get ariaActiveDescendant() {
        if (this.hightlightedDisabledOption) {
            return this.hightlightedDisabledOption.id;
        }
        if (this.panelOpen && this.lastSelectedOption) {
            return this.lastSelectedOption.id;
        }
        return null;
    }
    get eventObject() {
        return {
            source: this,
            value: this.value,
        };
    }
    get listMaxHeight() {
        const multiplier = 3;
        const optionHalfHeightRem = 1.5;
        return this.visibleOptions * multiplier + optionHalfHeightRem;
    }
    /** Define a posição de abertura da lista de opções */
    get position() {
        return this._position;
    }
    set position(value) {
        this._position = value;
        this.positions = defineOpeningPosition(this.position);
    }
    /**
     * Indica se o select é obrigatório. Necessário para que os leitores
     * de tela façam a leitura correta do campo.
     */
    set required(value) {
        this._required = enforceBoolean(value);
    }
    get required() {
        return this._required;
    }
    /**
     * Indica que o select não terá uma `label` vinculada ao componente.
     * Neste caso, é obrigatório informar os atributos `aria-label` ou
     * `aria-labelledby`.
     */
    set noLabel(value) {
        this._noLabel = enforceBoolean(value);
    }
    get noLabel() {
        return this._noLabel;
    }
    /**
     * Variação de select menor, mais clean
     */
    set small(value) {
        this._small = enforceBoolean(value);
    }
    get small() {
        return this._small;
    }
    /**
     * Função para comparar os valores das opções com os valores selecionados.
     *
     * Exemplo:
     * options: IObj[] = [{ val: 1, label: 'Opção 1' },{ val: 2, label: 'Opção 2' }];
     *
     * compareFn(c1: any, c2: any): boolean {
     *   return c1 && c2 ? c1.val === c2.val : c1 === c2;
     * }
     *
     * https://angular.io/api/forms/SelectlastSelectedOptionAccessor#caveat-option-selection
     */
    get compareWith() {
        return this._compareWith;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    set compareWith(fn) {
        this._compareWith = fn;
    }
    controlChange() {
        this.formAcessorHandleChange();
    }
    constructor(_appRef, _cdr, _la, _platform, ngControl, elementRef, _formFieldService) {
        super(ngControl, elementRef);
        this._appRef = _appRef;
        this._cdr = _cdr;
        this._la = _la;
        this._platform = _platform;
        this.ngControl = ngControl;
        this.elementRef = elementRef;
        this._formFieldService = _formFieldService;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this._compareWith = objectIs;
        this._destroy = new Subject();
        this._clearSearchString = new Subject();
        this.containerPadding = 24;
        this.panelId = `ids-select__panel-options-${NEXT_ID$g}`;
        this.labelId = `ids-select-label-${NEXT_ID$g}`;
        this.valueId = `ids-select-value-${NEXT_ID$g}`;
        this.panelOpen = false;
        this.panelPosition = 'bottom';
        this.searchString = '';
        this.positions = [];
        /** Identificação única do select */
        this.controlId = `ids-select-${NEXT_ID$g++}`;
        /**
         *  Define a quantidade de option no visível scroll.
         *  visibleOptions = 5; (default)
         */
        this.visibleOptions = 5;
        this._position = 'auto';
        /** Evento disparado com a mudança no select. */
        this.change = new EventEmitter();
        /** Evento disparado com o focus no select. */
        // eslint-disable-next-line @angular-eslint/no-output-rename
        this.focusOutput = new EventEmitter();
        /** Evento disparado com o blur no select. */
        this.blur = new EventEmitter();
        /** Evento disparado quando select é aberto. */
        this.opened = new EventEmitter();
        /** Evento disparado quando o select é fechado. */
        this.closed = new EventEmitter();
    }
    ngOnInit() {
        this._formFieldService.sendSuffixIcon('seta_baixo');
    }
    ngAfterContentInit() {
        this._initializeSelection();
        this._listenToControlChanges();
        this._listenToOptionsChanges();
        this._listenToPositionChanges();
        this.positions = defineOpeningPosition(this.position);
    }
    ngOnDestroy() {
        this._destroy.next();
        this._destroy.complete();
    }
    _announceValue(text) {
        this._la.announce(text, 'assertive', 1000);
    }
    _clearSelection() {
        if (this.lastSelectedOption) {
            this.lastSelectedOption.deselect();
            this.lastSelectedOption = null;
        }
    }
    _filterAndSelectOption(event) {
        const startsWithSpace = this.searchString === '' && event.code === 'Space';
        if (!/[a-zA-Z0-9-_ ]/.test(event.key) || event.key.length > 1 || startsWithSpace) {
            return;
        }
        event.preventDefault();
        this.searchString += event.key;
        this.arrayOption
            .find((o) => normalizeText(o.optionLabel ?? '').includes(this.searchString) && !o.disabled)
            ?.select();
        if (this._clearSearchString.observers.length === 0) {
            this._initializeSearchStringObserver();
        }
        this._clearSearchString.next();
    }
    _handleClosedKeydown(event) {
        const isOpenKey = event.code === 'Enter' || event.code === 'NumpadEnter' || event.code === 'Space';
        const isArrowKey = event.code === 'ArrowUp' || event.code === 'ArrowDown';
        const selectedOptionIdx = this.lastSelectedOption
            ? this.enabledOptions.findIndex((opt) => opt.id === this.lastSelectedOption?.id)
            : -1;
        if (isOpenKey || (event.altKey && isArrowKey)) {
            event.preventDefault();
            this._open();
            return;
        }
        if (event.code === 'Home') {
            event.preventDefault();
            this.enabledOptions[0].selectAndClose();
            this._announceValue(this.optionTextValue);
            return;
        }
        if (event.code === 'End') {
            event.preventDefault();
            this.enabledOptions[this.enabledOptions.length - 1].selectAndClose();
            this._announceValue(this.optionTextValue);
            return;
        }
        if ((event.code === 'ArrowUp' || event.code === 'ArrowLeft') && !event.altKey) {
            event.preventDefault();
            const optionToSelect = this.enabledOptions[selectedOptionIdx - 1] ||
                (selectedOptionIdx !== -1 &&
                    !this.compareWith(this.enabledOptions[selectedOptionIdx].value, this.arrayOption[0].value)
                    ? this.arrayOption[0]
                    : null);
            if (!optionToSelect) {
                return;
            }
            optionToSelect.selectAndClose();
            this._announceValue(this.optionTextValue);
            return;
        }
        if ((event.code === 'ArrowDown' || event.code === 'ArrowRight') && !event.altKey) {
            event.preventDefault();
            const optionToSelect = this.enabledOptions[selectedOptionIdx + 1];
            if (!optionToSelect) {
                return;
            }
            optionToSelect.selectAndClose();
            this._announceValue(this.optionTextValue);
            return;
        }
    }
    _handleOpenKeydown(event) {
        const isEnterKey = event.code === 'Enter' || event.code === 'NumpadEnter';
        const isArrowKey = event.code === 'ArrowUp' || event.code === 'ArrowDown';
        const announceValue = this._platform.SAFARI; // VO on SAFARI does not announce the new value selected when navigating by keyboard
        if (isEnterKey ||
            event.code === 'Tab' ||
            (isArrowKey && event.altKey) ||
            (event.code === 'Space' && this.searchString === '')) {
            event.preventDefault();
            if (this.hightlightedDisabledOption) {
                return;
            }
            if (this.lastSelectedOption && !this.compareWith(this.lastSelectedOption.value, this.value)) {
                this.lastSelectedOption.selectAndClose();
                return;
            }
            if (this.panelOpen) {
                this.detach();
            }
            return;
        }
        if (event.code === 'Escape') {
            event.preventDefault();
            if (this.panelOpen) {
                this.detach();
            }
            return;
        }
        if (event.code === 'Home') {
            event.preventDefault();
            this.enabledOptions[0].select();
            if (announceValue) {
                this._announceValue(this.optionTextValue);
            }
            return;
        }
        if (event.code === 'End') {
            event.preventDefault();
            this.enabledOptions[this.enabledOptions.length - 1].select();
            if (announceValue) {
                this._announceValue(this.optionTextValue);
            }
            return;
        }
        if (event.code === 'ArrowUp' && !event.altKey) {
            event.preventDefault();
            this._setSelectedOptionByIndex(-1);
            if (announceValue) {
                this._announceValue(this.optionTextValue);
            }
            return;
        }
        if (event.code === 'ArrowDown' && !event.altKey) {
            event.preventDefault();
            this._setSelectedOptionByIndex(1);
            if (announceValue) {
                this._announceValue(this.optionTextValue);
            }
            return;
        }
        this._filterAndSelectOption(event);
    }
    _initializeSearchStringObserver() {
        this._clearSearchString.pipe(debounceTime(1000), takeUntil(this._destroy)).subscribe(() => {
            this.searchString = '';
        });
    }
    _initializeSelection() {
        const value = this.ngControl ? this.ngControl.value : this.value;
        const selectedOption = this.enabledOptions.find((opt) => this.compareWith(opt.value, value));
        if (!selectedOption) {
            if (value) {
                this._setControlValue(null);
                this._clearSelection();
            }
            return;
        }
        // Timeout para evitar o erro "expression has changed after it was checked"
        setTimeout(() => {
            selectedOption.select();
        });
    }
    _open() {
        const parentWidth = this.elementRef.nativeElement.parentElement?.parentElement?.offsetWidth ||
            this.elementRef.nativeElement.offsetWidth;
        this.panelOpen = true;
        this.selectWidth = parentWidth;
        if (this.arrayOption.length > 0 && !this.lastSelectedOption) {
            this.arrayOption[0].select();
        }
        if (this.value &&
            this.lastSelectedOption &&
            !this.compareWith(this.value, this.lastSelectedOption.value)) {
            if (this.hightlightedDisabledOption) {
                this.hightlightedDisabledOption.unhighlight();
            }
            this.arrayOption.find((option) => this.compareWith(this.value, option.value))?.select();
        }
        this.opened.emit(this.eventObject);
    }
    _listenToControlChanges() {
        if (!this.ngControl) {
            return;
        }
        this.ngControl.valueChanges?.pipe(takeUntil(this._destroy)).subscribe((value) => {
            if (value &&
                (!this.lastSelectedOption || !this.compareWith(this.lastSelectedOption.value, value))) {
                // Tick para rodar a detecção de mudança e atualizar as opções
                // antes de selecionar
                this._appRef.tick();
                this._initializeSelection();
                return;
            }
            if (!this.value && this.lastSelectedOption) {
                this._clearSelection();
            }
        });
    }
    _listenToOptionsChanges() {
        this.options.changes
            .pipe(takeUntil(this._destroy), startWith(this.options), switchMap(() => merge(...this.options.map((option) => option.change))))
            .subscribe((optionEvent) => {
            this._setSelectedOption(optionEvent);
        });
    }
    _listenToPositionChanges() {
        this.overlayDir.positionChange.pipe(takeUntil(this._destroy)).subscribe((change) => {
            const openingPosition = change.connectionPair.originY === 'bottom' ? 'bottom' : 'top';
            if (openingPosition === this.panelPosition) {
                return;
            }
            this.panelPosition = openingPosition;
            this._cdr.detectChanges();
        });
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _setControlValue(value) {
        this.value = value;
        this.nativeElement.value = value;
    }
    _setSelectedOption(optionEvent) {
        const selectedOption = optionEvent.option;
        const selectAndCloseOptions = optionEvent.close || false;
        if (this.lastSelectedOption &&
            !this.compareWith(this.lastSelectedOption.value, selectedOption.value)) {
            this.lastSelectedOption.deselect();
        }
        this.lastSelectedOption = selectedOption;
        if (selectAndCloseOptions) {
            if (!this.compareWith(selectedOption.value, this.value)) {
                this._setControlValue(selectedOption.value);
                this.change.emit(this.eventObject);
            }
            if (!this.value && this.lastSelectedOption) {
                this._clearSelection();
            }
            if (this.panelOpen) {
                this.detach();
            }
            return;
        }
        if (!this.panel) {
            this.overlayDir.positionChange
                .pipe(take(1))
                .subscribe(() => this._setScrollPosition(selectedOption));
            return;
        }
        this._setScrollPosition(selectedOption);
    }
    _setScrollPosition(selectedOption) {
        const panelEl = this.panel.nativeElement;
        const optionEl = selectedOption.element.nativeElement;
        const scrollPosition = optionEl.offsetTop - panelEl.scrollTop;
        if (scrollPosition / optionEl.offsetHeight >= this.visibleOptions) {
            optionEl.scrollIntoView(false);
            return;
        }
        /* istanbul ignore next */
        if (scrollPosition < 0) {
            optionEl.scrollIntoView();
        }
    }
    _setSelectedOptionByIndex(index = 1) {
        const selectedOptionIndex = this.lastSelectedOption || this.hightlightedDisabledOption
            ? this.arrayOption.findIndex((opt) => opt.highlighted || opt.selected)
            : -1;
        const newOption = this.arrayOption[selectedOptionIndex + index];
        if (!newOption) {
            return;
        }
        if (newOption.disabled) {
            newOption.highlight();
            this.lastSelectedOption?.deselect();
            this._clearSelection();
            this._setScrollPosition(newOption);
            return;
        }
        if (this.hightlightedDisabledOption) {
            this.hightlightedDisabledOption.unhighlight();
        }
        newOption.select();
    }
    attach() {
        this.overlayDir.positionChange.pipe(take(1)).subscribe(() => {
            if (this.lastSelectedOption) {
                this._setScrollPosition(this.lastSelectedOption);
            }
        });
    }
    detach() {
        this.panelOpen = false;
        this.select.nativeElement.focus();
        this.closed.emit(this.eventObject);
    }
    handleKeydown(event) {
        if (this.disabled) {
            return;
        }
        if (this.panelOpen) {
            this._handleOpenKeydown(event);
            return;
        }
        this._handleClosedKeydown(event);
    }
    onBlur() {
        this.formAcessorHandleBlur();
        this.blur.emit(this.eventObject);
    }
    onFocus() {
        this.formAcessorHandleFocus();
        this.focusOutput.emit(this.eventObject);
    }
    toggle() {
        if (this.disabled) {
            return;
        }
        if (this.panelOpen) {
            this.detach();
            return;
        }
        this._open();
    }
}
IdsSelectComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSelectComponent, deps: [{ token: i0.ApplicationRef }, { token: i0.ChangeDetectorRef }, { token: i1$1.LiveAnnouncer }, { token: i1$4.Platform }, { token: i1$2.NgControl, optional: true, self: true }, { token: i0.ElementRef }, { token: IdsFormFieldService }], target: i0.ɵɵFactoryTarget.Component });
IdsSelectComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsSelectComponent, isStandalone: true, selector: "ids-select", inputs: { controlId: ["id", "controlId"], visibleOptions: "visibleOptions", position: "position", required: "required", noLabel: "noLabel", small: "small", compareWith: "compareWith" }, outputs: { change: "change", focusOutput: "focus", blur: "blur", opened: "opened", closed: "closed" }, host: { listeners: { "ngModelChange": "controlChange()" }, properties: { "attr.id": "null", "attr.aria-labelledby": "null", "attr.aria-label": "null" } }, providers: [
        {
            provide: IdsFieldMixinBase,
            useExisting: forwardRef(/* istanbul ignore next */ () => IdsSelectComponent),
        },
    ], queries: [{ propertyName: "options", predicate: IdsOptionComponent, descendants: true }], viewQueries: [{ propertyName: "select", first: true, predicate: ["select"], descendants: true, static: true }, { propertyName: "overlayDir", first: true, predicate: CdkConnectedOverlay, descendants: true, static: true }, { propertyName: "panel", first: true, predicate: ["panel"], descendants: true }], usesInheritance: true, ngImport: i0, template: "<div\n  #select\n  cdkOverlayOrigin\n  #origin=\"cdkOverlayOrigin\"\n  role=\"combobox\"\n  [id]=\"controlId\"\n  class=\"ids-input\"\n  [class.ids-input--disabled]=\"disabled\"\n  [class.ids-input--center]=\"noLabel\"\n  [class.ids-input--small]=\"small\"\n  (click)=\"toggle()\"\n  (keydown)=\"handleKeydown($event)\"\n  [attr.aria-disabled]=\"disabled || null\"\n  [attr.aria-expanded]=\"panelOpen\"\n  [attr.aria-label]=\"ariaLabel\"\n  [attr.aria-describedby]=\"controlDescribedBy\"\n  [attr.aria-labelledby]=\"!ariaLabel ? ariaLabelledby || labelId : null\"\n  [attr.aria-invalid]=\"controlAriaInvalid\"\n  [attr.aria-activedescendant]=\"ariaActiveDescendant\"\n  [attr.aria-controls]=\"panelId\"\n  [attr.aria-required]=\"required\"\n  aria-haspopup=\"listbox\"\n  [tabindex]=\"disabled && !value ? '-1' : '0'\"\n  (focus)=\"onFocus()\"\n  (blur)=\"onBlur()\"\n>\n  {{ optionTextValue }}\n</div>\n\n<ng-template\n  cdkConnectedOverlay\n  cdkConnectedOverlayHasBackdrop\n  cdkConnectedOverlayBackdropClass=\"cdk-overlay-transparent-backdrop\"\n  cdkConnectedOverlayPanelClass=\"ids-listbox-wrapper\"\n  [cdkConnectedOverlayOrigin]=\"origin\"\n  [cdkConnectedOverlayOpen]=\"panelOpen\"\n  [cdkConnectedOverlayPositions]=\"positions\"\n  [cdkConnectedOverlayWidth]=\"selectWidth\"\n  (backdropClick)=\"detach()\"\n  (attach)=\"attach()\"\n>\n  <div\n    #panel\n    role=\"listbox\"\n    tabindex=\"-1\"\n    [id]=\"panelId\"\n    class=\"ids-listbox\"\n    [class.ids-listbox--top]=\"panelPosition === 'top'\"\n    (keydown)=\"handleKeydown($event)\"\n    [attr.aria-labelledby]=\"labelId\"\n    [attr.aria-hidden]=\"!panelOpen\"\n    [style.maxHeight.rem]=\"listMaxHeight\"\n  >\n    <ng-content select=\"ids-option\"></ng-content>\n  </div>\n</ng-template>\n", dependencies: [{ kind: "ngmodule", type: OverlayModule }, { kind: "directive", type: i1$3.CdkConnectedOverlay, selector: "[cdk-connected-overlay], [connected-overlay], [cdkConnectedOverlay]", inputs: ["cdkConnectedOverlayOrigin", "cdkConnectedOverlayPositions", "cdkConnectedOverlayPositionStrategy", "cdkConnectedOverlayOffsetX", "cdkConnectedOverlayOffsetY", "cdkConnectedOverlayWidth", "cdkConnectedOverlayHeight", "cdkConnectedOverlayMinWidth", "cdkConnectedOverlayMinHeight", "cdkConnectedOverlayBackdropClass", "cdkConnectedOverlayPanelClass", "cdkConnectedOverlayViewportMargin", "cdkConnectedOverlayScrollStrategy", "cdkConnectedOverlayOpen", "cdkConnectedOverlayDisableClose", "cdkConnectedOverlayTransformOriginOn", "cdkConnectedOverlayHasBackdrop", "cdkConnectedOverlayLockPosition", "cdkConnectedOverlayFlexibleDimensions", "cdkConnectedOverlayGrowAfterOpen", "cdkConnectedOverlayPush"], outputs: ["backdropClick", "positionChange", "attach", "detach", "overlayKeydown", "overlayOutsideClick"], exportAs: ["cdkConnectedOverlay"] }, { kind: "directive", type: i1$3.CdkOverlayOrigin, selector: "[cdk-overlay-origin], [overlay-origin], [cdkOverlayOrigin]", exportAs: ["cdkOverlayOrigin"] }, { kind: "ngmodule", type: IdsIconModule }, { kind: "ngmodule", type: IdsOptionModule }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSelectComponent, decorators: [{
            type: Component,
            args: [{ encapsulation: ViewEncapsulation.None, selector: 'ids-select', host: {
                        '[attr.id]': 'null',
                        '[attr.aria-labelledby]': 'null',
                        '[attr.aria-label]': 'null',
                    }, imports: [OverlayModule, IdsIconModule, IdsOptionModule], providers: [
                        {
                            provide: IdsFieldMixinBase,
                            useExisting: forwardRef(/* istanbul ignore next */ () => IdsSelectComponent),
                        },
                    ], standalone: true, template: "<div\n  #select\n  cdkOverlayOrigin\n  #origin=\"cdkOverlayOrigin\"\n  role=\"combobox\"\n  [id]=\"controlId\"\n  class=\"ids-input\"\n  [class.ids-input--disabled]=\"disabled\"\n  [class.ids-input--center]=\"noLabel\"\n  [class.ids-input--small]=\"small\"\n  (click)=\"toggle()\"\n  (keydown)=\"handleKeydown($event)\"\n  [attr.aria-disabled]=\"disabled || null\"\n  [attr.aria-expanded]=\"panelOpen\"\n  [attr.aria-label]=\"ariaLabel\"\n  [attr.aria-describedby]=\"controlDescribedBy\"\n  [attr.aria-labelledby]=\"!ariaLabel ? ariaLabelledby || labelId : null\"\n  [attr.aria-invalid]=\"controlAriaInvalid\"\n  [attr.aria-activedescendant]=\"ariaActiveDescendant\"\n  [attr.aria-controls]=\"panelId\"\n  [attr.aria-required]=\"required\"\n  aria-haspopup=\"listbox\"\n  [tabindex]=\"disabled && !value ? '-1' : '0'\"\n  (focus)=\"onFocus()\"\n  (blur)=\"onBlur()\"\n>\n  {{ optionTextValue }}\n</div>\n\n<ng-template\n  cdkConnectedOverlay\n  cdkConnectedOverlayHasBackdrop\n  cdkConnectedOverlayBackdropClass=\"cdk-overlay-transparent-backdrop\"\n  cdkConnectedOverlayPanelClass=\"ids-listbox-wrapper\"\n  [cdkConnectedOverlayOrigin]=\"origin\"\n  [cdkConnectedOverlayOpen]=\"panelOpen\"\n  [cdkConnectedOverlayPositions]=\"positions\"\n  [cdkConnectedOverlayWidth]=\"selectWidth\"\n  (backdropClick)=\"detach()\"\n  (attach)=\"attach()\"\n>\n  <div\n    #panel\n    role=\"listbox\"\n    tabindex=\"-1\"\n    [id]=\"panelId\"\n    class=\"ids-listbox\"\n    [class.ids-listbox--top]=\"panelPosition === 'top'\"\n    (keydown)=\"handleKeydown($event)\"\n    [attr.aria-labelledby]=\"labelId\"\n    [attr.aria-hidden]=\"!panelOpen\"\n    [style.maxHeight.rem]=\"listMaxHeight\"\n  >\n    <ng-content select=\"ids-option\"></ng-content>\n  </div>\n</ng-template>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ApplicationRef }, { type: i0.ChangeDetectorRef }, { type: i1$1.LiveAnnouncer }, { type: i1$4.Platform }, { type: i1$2.NgControl, decorators: [{
                    type: Self
                }, {
                    type: Optional
                }] }, { type: i0.ElementRef }, { type: IdsFormFieldService }]; }, propDecorators: { controlId: [{
                type: Input,
                args: ['id']
            }], visibleOptions: [{
                type: Input
            }], position: [{
                type: Input
            }], required: [{
                type: Input
            }], noLabel: [{
                type: Input
            }], small: [{
                type: Input
            }], compareWith: [{
                type: Input
            }], change: [{
                type: Output
            }], focusOutput: [{
                type: Output,
                args: ['focus']
            }], blur: [{
                type: Output
            }], opened: [{
                type: Output
            }], closed: [{
                type: Output
            }], options: [{
                type: ContentChildren,
                args: [IdsOptionComponent, { descendants: true }]
            }], select: [{
                type: ViewChild,
                args: ['select', { static: true }]
            }], overlayDir: [{
                type: ViewChild,
                args: [CdkConnectedOverlay, { static: true }]
            }], panel: [{
                type: ViewChild,
                args: ['panel']
            }], controlChange: [{
                type: HostListener,
                args: ['ngModelChange']
            }] } });

class IdsSelectModule {
}
IdsSelectModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSelectModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsSelectModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsSelectModule, imports: [IdsSelectComponent, IdsNativeSelectDirective, IdsNativeSelectOptionDirective], exports: [IdsSelectComponent,
        IdsNativeSelectDirective,
        IdsNativeSelectOptionDirective,
        IdsOptionModule] });
IdsSelectModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSelectModule, imports: [IdsSelectComponent, IdsOptionModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSelectModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsSelectComponent, IdsNativeSelectDirective, IdsNativeSelectOptionDirective],
                    exports: [
                        IdsSelectComponent,
                        IdsNativeSelectDirective,
                        IdsNativeSelectOptionDirective,
                        IdsOptionModule,
                    ],
                }]
        }] });

class IdsFormControlService {
    constructor() {
        this.descriptionIdSubject = new Subject();
        this.suffixSubject = new Subject();
        this.inputIdSubject = new Subject();
        this.inputFocusSubject = new Subject();
        this.inputFocusVisibleSubject = new Subject();
    }
    get errors() {
        return this.input?.errors;
    }
    get invalid() {
        return this.error || (this.validate && this.input?.invalid);
    }
}
IdsFormControlService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormControlService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
IdsFormControlService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormControlService, providedIn: null });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormControlService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: null,
                }]
        }] });

let NEXT_ID$f = 0;
/**
 * O IdsFormMessage foi desenvolvido para ser utilizado em conjunto com os componentes de seleção como checkbox,
 * radiobutton e switch.
 *
 * **Module:**
 *
 * `import { IdsFormMessageModule } from '@ids/angular';`
 */
class IdsHelperTextComponent {
    get ariaLive() {
        if (platform.os === 'Windows' || !this.focused) {
            return 'off';
        }
        return 'polite';
    }
    get classes() {
        return {
            'ids-form-message': true,
            'ids-form-message--disabled': this.status === 'disabled',
            'ids-form-message--error': this.status === 'error',
            'ids-form-message--on-brand': this.contrast === 'onBrand',
        };
    }
    /**
     * Estado da descrição, se desabilitado ou de erro
     */
    set status(value) {
        this._status = value;
    }
    get status() {
        if (this._fieldService.invalid) {
            return 'error';
        }
        return this._status;
    }
    get message() {
        const errors = Object.keys(this._fieldService.errors || {});
        if (this.status === 'error') {
            if (errors.length) {
                return this.messageByError[errors[0]] || this.errorMessage || '';
            }
            return this.errorMessage;
        }
        return null;
    }
    constructor(liveAnnouncer, _fieldService) {
        this.liveAnnouncer = liveAnnouncer;
        this._fieldService = _fieldService;
        this._lastContent = '';
        this.focused = false;
        /* istanbul ignore next */
        this._observer = new MutationObserver(() => this._checkChangeId());
        this.id = `ids-helper-text-${++NEXT_ID$f}`;
        this.errorMessage = '';
        this.messageByError = {};
        this._fieldService?.inputFocusSubject.subscribe((focused) => {
            this.focused = focused;
        });
    }
    ngOnInit() {
        this._fieldService?.descriptionIdSubject.next(this.id);
    }
    /* istanbul ignore next */
    ngAfterViewInit() {
        this._lastContent = this.contentRef.nativeElement.textContent;
        this._listenToMutation();
    }
    /* istanbul ignore next */
    ngOnDestroy() {
        this._observer.disconnect();
    }
    /* istanbul ignore next */
    _listenToMutation() {
        this._observer.observe(this.contentRef.nativeElement, {
            subtree: true,
            characterData: true,
        });
    }
    /* istanbul ignore next */
    _checkChangeId() {
        if (this._lastContent !== this.contentRef.nativeElement.textContent) {
            const newId = `ids-helper-text-${Date.now()}`;
            this._lastContent = this.contentRef.nativeElement.textContent;
            this._fieldService.descriptionIdSubject.next(newId);
            this.id = newId;
        }
    }
}
IdsHelperTextComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsHelperTextComponent, deps: [{ token: i1$1.LiveAnnouncer }, { token: IdsFormControlService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
IdsHelperTextComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsHelperTextComponent, isStandalone: true, selector: "ids-helper-text", inputs: { id: "id", contrast: "contrast", status: "status", errorMessage: "errorMessage", messageByError: "messageByError" }, host: { properties: { "attr.aria-live": "null", "attr.id": "null" } }, viewQueries: [{ propertyName: "contentRef", first: true, predicate: ["content"], descendants: true }], ngImport: i0, template: `
    <div [class]="classes" [attr.aria-live]="ariaLive">
      <ids-icon size="S" *ngIf="status === 'error'"> aviso_outline </ids-icon>

      <span [id]="id" #content>
        <ng-container *ngIf="message; else ngContent">
          {{ message }}
        </ng-container>

        <ng-template #ngContent>
          <ng-content></ng-content>
        </ng-template>
      </span>
    </div>
  `, isInline: true, styles: [".ids-form-message{align-items:center;color:var(--ids_color_action_neutral_base);display:flex;font:var(--ids_textStyle_f02_s14_h20_wrg);margin-right:var(--ids_spacing_2x)}.ids-form-message .ids-icon{margin-right:var(--ids_size_general_4x);margin-top:var(--ids_size_general_1x)}.ids-form-message--error{color:var(--ids_color_feedback_error)}.ids-form-message--disabled{color:var(--ids_color_action_disabled_variant)}.ids-form-message--hidden{display:none}.ids-form-message--on-brand{color:var(--ids_color_contrast_onBrand_primary)}.ids-form-message--on-brand.ids-form-message--disabled{color:var(--ids_color_contrast_onBrand_primary_medium)}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: IdsIconModule }, { kind: "component", type: IdsIconComponent, selector: "ids-icon", inputs: ["size", "variant", "contrast"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsHelperTextComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-helper-text', template: `
    <div [class]="classes" [attr.aria-live]="ariaLive">
      <ids-icon size="S" *ngIf="status === 'error'"> aviso_outline </ids-icon>

      <span [id]="id" #content>
        <ng-container *ngIf="message; else ngContent">
          {{ message }}
        </ng-container>

        <ng-template #ngContent>
          <ng-content></ng-content>
        </ng-template>
      </span>
    </div>
  `, host: {
                        '[attr.aria-live]': 'null',
                        '[attr.id]': 'null',
                    }, imports: [CommonModule, IdsIconModule], standalone: true, styles: [".ids-form-message{align-items:center;color:var(--ids_color_action_neutral_base);display:flex;font:var(--ids_textStyle_f02_s14_h20_wrg);margin-right:var(--ids_spacing_2x)}.ids-form-message .ids-icon{margin-right:var(--ids_size_general_4x);margin-top:var(--ids_size_general_1x)}.ids-form-message--error{color:var(--ids_color_feedback_error)}.ids-form-message--disabled{color:var(--ids_color_action_disabled_variant)}.ids-form-message--hidden{display:none}.ids-form-message--on-brand{color:var(--ids_color_contrast_onBrand_primary)}.ids-form-message--on-brand.ids-form-message--disabled{color:var(--ids_color_contrast_onBrand_primary_medium)}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.LiveAnnouncer }, { type: IdsFormControlService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { id: [{
                type: Input
            }], contrast: [{
                type: Input
            }], contentRef: [{
                type: ViewChild,
                args: ['content']
            }], status: [{
                type: Input
            }], errorMessage: [{
                type: Input
            }], messageByError: [{
                type: Input
            }] } });

class HelperTextModule {
}
HelperTextModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: HelperTextModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
HelperTextModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: HelperTextModule, imports: [IdsHelperTextComponent], exports: [IdsHelperTextComponent] });
HelperTextModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: HelperTextModule, imports: [IdsHelperTextComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: HelperTextModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsHelperTextComponent],
                    exports: [IdsHelperTextComponent],
                }]
        }] });

class IdsFormControlComponent {
    set validate(value) {
        const validate = enforceBoolean(value);
        this._fieldService.validate = validate;
    }
    set error(value) {
        const error = enforceBoolean(value);
        this._fieldService.error = error;
    }
    get classes() {
        return {
            'ids-form-field': true,
            'ids-form-field--error': this._fieldService.invalid,
            'ids-form-field--value': this._fieldService.input?.visibleValue,
            'ids-form-field--focus': this.isFocused,
            'ids-form-field--visible-focus': this.isFocusedVisible,
            'ids-form-field--disabled': this.inputElement?.disabled,
            'ids-form-field--suffix': this.suffix,
        };
    }
    constructor(_fieldService) {
        this._fieldService = _fieldService;
        this.suffix = '';
        this.isFocused = false;
        this.isFocusedVisible = false;
        this._fieldService.inputFocusSubject.subscribe((isFocused) => {
            this.isFocused = isFocused;
        });
        this._fieldService.inputFocusVisibleSubject.subscribe((isFocusedVisible) => {
            this.isFocusedVisible = isFocusedVisible;
        });
        this._fieldService.suffixSubject.subscribe((suffix) => {
            this.suffix = suffix;
        });
    }
}
IdsFormControlComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormControlComponent, deps: [{ token: IdsFormControlService }], target: i0.ɵɵFactoryTarget.Component });
IdsFormControlComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsFormControlComponent, isStandalone: true, selector: "ids-form-control", inputs: { validate: "validate", error: "error" }, providers: [
        {
            provide: IdsFormControlService,
        },
    ], ngImport: i0, template: `
    <div [ngClass]="classes">
      <div class="ids-form-field__container">
        <div class="ids-form-field__content">
          <ng-content select="label"></ng-content>

          <ng-content></ng-content>
        </div>

        <div class="ids-form-field__suffix">
          <ng-content select="ids-icon, [idsSuffix]"></ng-content>

          <ng-container *ngIf="suffix">
            <ids-icon variant="primary">{{ suffix }}</ids-icon>
          </ng-container>
        </div>
      </div>

      <div class="ids-form-field__status-message">
        <ng-content select="ids-helper-text"></ng-content>
      </div>
    </div>
  `, isInline: true, dependencies: [{ kind: "ngmodule", type: IdsIconModule }, { kind: "component", type: IdsIconComponent, selector: "ids-icon", inputs: ["size", "variant", "contrast"] }, { kind: "ngmodule", type: IdsFormMessageModule }, { kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], IdsFormControlComponent.prototype, "validate", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormControlComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ids-form-control',
                    standalone: true,
                    imports: [IdsIconModule, IdsFormMessageModule, CommonModule, IdsIconModule],
                    template: `
    <div [ngClass]="classes">
      <div class="ids-form-field__container">
        <div class="ids-form-field__content">
          <ng-content select="label"></ng-content>

          <ng-content></ng-content>
        </div>

        <div class="ids-form-field__suffix">
          <ng-content select="ids-icon, [idsSuffix]"></ng-content>

          <ng-container *ngIf="suffix">
            <ids-icon variant="primary">{{ suffix }}</ids-icon>
          </ng-container>
        </div>
      </div>

      <div class="ids-form-field__status-message">
        <ng-content select="ids-helper-text"></ng-content>
      </div>
    </div>
  `,
                    providers: [
                        {
                            provide: IdsFormControlService,
                        },
                    ],
                }]
        }], ctorParameters: function () { return [{ type: IdsFormControlService }]; }, propDecorators: { validate: [{
                type: Input
            }], error: [{
                type: Input
            }] } });

let NEXT_ID$e = 0;
let lastFocusOrigin;
class IdsTextFieldDirective {
    get visibleValue() {
        const element = this.elementRef.nativeElement;
        const { type } = element;
        const hasPlaceholder = element.placeholder || INPUTS_TYPES_WITH_NATIVE_PLACEHOLDER.includes(type);
        return element.value || hasPlaceholder;
    }
    get invalid() {
        return this.ngControl?.invalid && (this.ngControl?.dirty || this.ngControl?.touched);
    }
    get errors() {
        return this.ngControl?.errors;
    }
    constructor(elementRef, _focusMonitor, fieldService, ngControl) {
        this.elementRef = elementRef;
        this._focusMonitor = _focusMonitor;
        this.fieldService = fieldService;
        this.ngControl = ngControl;
        this._destroy = new Subject();
        this.focused = false;
        this.id = `ids-field-input-${NEXT_ID$e++}`;
        this.describedby = '';
        this.classes = true;
        this.fieldService?.descriptionIdSubject.subscribe((description) => {
            this.describedby = description;
        });
        this.startFocusMonitor();
    }
    ngOnInit() {
        this.fieldService.input = this;
        this.fieldService.inputIdSubject.next(this.id);
    }
    onFocus() {
        this.focused = true;
        this.fieldService.inputFocusSubject.next(true);
    }
    onBlur() {
        this.focused = false;
        this.fieldService.inputFocusSubject.next(false);
        this.fieldService.inputFocusVisibleSubject.next(false);
    }
    ngOnDestroy() {
        this._focusMonitor.stopMonitoring(this.elementRef.nativeElement);
        this._destroy.next();
        this._destroy.complete();
    }
    startFocusMonitor() {
        this._focusMonitor
            .monitor(this.elementRef.nativeElement, true)
            .pipe(takeUntil$1(this._destroy))
            .subscribe((origin) => {
            const isFocusVisible = origin === 'keyboard' || (origin === 'program' && lastFocusOrigin === 'keyboard');
            if (origin && origin !== 'program') {
                lastFocusOrigin = origin;
            }
            this.fieldService.inputFocusVisibleSubject.next(isFocusVisible);
        });
    }
}
IdsTextFieldDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTextFieldDirective, deps: [{ token: i0.ElementRef }, { token: i1$1.FocusMonitor, optional: true }, { token: IdsFormControlService, optional: true }, { token: i1$2.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Directive });
IdsTextFieldDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsTextFieldDirective, isStandalone: true, selector: "input[idsField]:not(type=\"number\"), input[idsTextField]:not(type=\"number\"), input[idsFieldInput]:not(type=\"number\")", inputs: { idsTextField: "idsTextField", id: "id" }, host: { listeners: { "focus": "onFocus()", "blur": "onBlur()" }, properties: { "attr.id": "this.id", "attr.aria-describedby": "this.describedby", "class.ids-input": "this.classes" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTextFieldDirective, decorators: [{
            type: Directive,
            args: [{
                    // TODO: remover nome idsFieldInput
                    selector: 'input[idsField]:not(type="number"), input[idsTextField]:not(type="number"), input[idsFieldInput]:not(type="number")',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1$1.FocusMonitor, decorators: [{
                    type: Optional
                }] }, { type: IdsFormControlService, decorators: [{
                    type: Optional
                }] }, { type: i1$2.NgControl, decorators: [{
                    type: Self
                }, {
                    type: Optional
                }] }]; }, propDecorators: { idsTextField: [{
                type: Input
            }], id: [{
                type: Input,
                args: ['id']
            }, {
                type: HostBinding,
                args: ['attr.id']
            }], describedby: [{
                type: HostBinding,
                args: ['attr.aria-describedby']
            }], classes: [{
                type: HostBinding,
                args: ['class.ids-input']
            }], onFocus: [{
                type: HostListener,
                args: ['focus']
            }], onBlur: [{
                type: HostListener,
                args: ['blur']
            }] } });

class IdsNumberFieldDirective extends IdsTextFieldDirective {
    constructor() {
        super(...arguments);
        /** @internal */
        this.inputmode = 'decimal';
    }
    /** @internal */
    set type(type) {
        this._type = type;
    }
    get type() {
        if (platform.isMobile) {
            return 'text';
        }
        return this._type;
    }
    /** @internal */
    set pattern(pattern) {
        this._pattern = pattern;
    }
    get pattern() {
        // o pattern é usado para mostrar o teclado numérico no iOS
        // não deve ser usado no Android, pois este também serve para validação do valor
        // https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/pattern
        // TODO: ver um pattern que sirva para todos Android também
        if (platform.os === 'IOS' && !this._pattern) {
            return '[0-9]*';
        }
        return this._pattern;
    }
}
IdsNumberFieldDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsNumberFieldDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
IdsNumberFieldDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsNumberFieldDirective, isStandalone: true, selector: "[idsTextField][type=\"number\"], [idsField][type=\"number\"]", inputs: { type: "type", pattern: "pattern", inputmode: "inputmode" }, host: { properties: { "attr.type": "this.type", "attr.pattern": "this.pattern", "attr.inputmode": "this.inputmode" } }, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsNumberFieldDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsTextField][type="number"], [idsField][type="number"]',
                    standalone: true,
                }]
        }], propDecorators: { type: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.type']
            }], pattern: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.pattern']
            }], inputmode: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.inputmode']
            }] } });

class IdsLabelDirective {
    get htmlFor() {
        return this.inputId;
    }
    constructor(_fieldService) {
        this._fieldService = _fieldService;
        this.inputId = '';
        this.classes = true;
        this._fieldService.inputIdSubject.subscribe((inputId) => {
            this.inputId = inputId;
        });
    }
}
IdsLabelDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsLabelDirective, deps: [{ token: IdsFormControlService }], target: i0.ɵɵFactoryTarget.Directive });
IdsLabelDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsLabelDirective, isStandalone: true, selector: "[idsLabel]", host: { properties: { "class.ids-form-field__label": "this.classes", "attr.for": "this.htmlFor" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsLabelDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsLabel]',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: IdsFormControlService }]; }, propDecorators: { classes: [{
                type: HostBinding,
                args: ['class.ids-form-field__label']
            }], htmlFor: [{
                type: HostBinding,
                args: ['attr.for']
            }] } });

class IdsSelectDirective extends IdsTextFieldDirective {
    get visibleValue() {
        const element = this.elementRef.nativeElement;
        const selectedOption = element?.options[element.selectedIndex];
        return selectedOption?.text || selectedOption?.label;
    }
    constructor(elementRef, focusMonitor, fieldService, ngControl) {
        super(elementRef, focusMonitor, fieldService, ngControl);
        this.elementRef = elementRef;
        this.focusMonitor = focusMonitor;
        this.fieldService = fieldService;
        this.ngControl = ngControl;
        this.focused = false;
    }
    ngOnInit() {
        super.ngOnInit();
        this.fieldService.suffixSubject.next('seta_baixo');
    }
    onInput() {
        // O TalkBack passa o foco para o elemento abaixo do option em tela, então
        // ao receber o evento de "input" indica que o usuário enviou um valor,
        // então o foco pode voltar para o select.
        if (platform.os === 'Android') {
            this.elementRef.nativeElement.focus();
        }
    }
}
IdsSelectDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSelectDirective, deps: [{ token: i0.ElementRef }, { token: i1$1.FocusMonitor }, { token: IdsFormControlService, optional: true }, { token: i1$2.NgControl, optional: true, self: true }], target: i0.ɵɵFactoryTarget.Directive });
IdsSelectDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsSelectDirective, isStandalone: true, selector: "[idsSelect], select[idsField]", host: { listeners: { "input": "onInput()" } }, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSelectDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsSelect], select[idsField]',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1$1.FocusMonitor }, { type: IdsFormControlService, decorators: [{
                    type: Optional
                }] }, { type: i1$2.NgControl, decorators: [{
                    type: Self
                }, {
                    type: Optional
                }] }]; }, propDecorators: { onInput: [{
                type: HostListener,
                args: ['input']
            }] } });

class IdsFormControlModule {
}
IdsFormControlModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormControlModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsFormControlModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsFormControlModule, imports: [IdsFormControlComponent,
        IdsTextFieldDirective,
        IdsLabelDirective,
        IdsSelectDirective,
        HelperTextModule,
        IdsNumberFieldDirective], exports: [IdsFormControlComponent,
        IdsTextFieldDirective,
        IdsLabelDirective,
        IdsSelectDirective,
        HelperTextModule,
        IdsNumberFieldDirective] });
IdsFormControlModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormControlModule, imports: [IdsFormControlComponent,
        HelperTextModule, HelperTextModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormControlModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        IdsFormControlComponent,
                        IdsTextFieldDirective,
                        IdsLabelDirective,
                        IdsSelectDirective,
                        HelperTextModule,
                        IdsNumberFieldDirective,
                    ],
                    exports: [
                        IdsFormControlComponent,
                        IdsTextFieldDirective,
                        IdsLabelDirective,
                        IdsSelectDirective,
                        HelperTextModule,
                        IdsNumberFieldDirective,
                    ],
                }]
        }] });

class IdsDatepickerService {
    constructor() {
        // Emite o valor da data selecionada e confirmada
        this.valueSubject = new BehaviorSubject(null);
        // Emite o valor da data previamente marcada no calendário.
        this.selectedDateSubject = new BehaviorSubject(null);
    }
}
IdsDatepickerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsDatepickerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
IdsDatepickerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsDatepickerService });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsDatepickerService, decorators: [{
            type: Injectable
        }] });

/* istanbul ignore file */
class IdsDomChangeDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.idsDomChange = new EventEmitter();
        const element = this.elementRef.nativeElement;
        this.changes = new MutationObserver((mutations) => this.idsDomChange.emit(mutations));
        this.changes.observe(element, {
            characterData: true,
            characterDataOldValue: true,
            subtree: true,
        });
    }
    ngOnDestroy() {
        this.changes.disconnect();
    }
}
IdsDomChangeDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsDomChangeDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
IdsDomChangeDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsDomChangeDirective, isStandalone: true, selector: "[idsDomChange]", outputs: { idsDomChange: "idsDomChange" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsDomChangeDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsDomChange]',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { idsDomChange: [{
                type: Output
            }] } });

class IdsDatepickerSelectedDateDirective {
    formatToString(date) {
        const day = date.getDate();
        const monthWriting = PT_BR_MONTHS[date.getMonth()].name;
        const year = date.getFullYear();
        return `${day} de ${monthWriting} de ${year}`;
    }
    setSelectedDate(date) {
        this.elementRef.nativeElement.innerText = date ? this.formatToString(date) : '';
    }
    constructor(elementRef, idsDatepickerService) {
        this.elementRef = elementRef;
        this.idsDatepickerService = idsDatepickerService;
        this.idsDatepickerService.valueSubject.subscribe((value) => {
            this.setSelectedDate(value);
        });
        this.idsDatepickerService.selectedDateSubject.subscribe((date) => {
            this.setSelectedDate(date);
        });
    }
}
IdsDatepickerSelectedDateDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsDatepickerSelectedDateDirective, deps: [{ token: i0.ElementRef }, { token: IdsDatepickerService }], target: i0.ɵɵFactoryTarget.Directive });
IdsDatepickerSelectedDateDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsDatepickerSelectedDateDirective, isStandalone: true, selector: "[idsDatepickerSelectedDate]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsDatepickerSelectedDateDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsDatepickerSelectedDate]',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: IdsDatepickerService }]; } });

let NEXT_ID$d = 0;
/**
 * O componente de input date picker é uma forma visual e interativa de selecionar uma data.
 *
 * **Module:**
 *
 * `import { IdsDatepickerModule } from '@ids/angular';`
 *
 * **Component:**
 *
 * `import { IdsDatepickerComponent } from '@ids/angular';`
 *
 */
class IdsDatepickerComponent {
    /**
     * Variável que guarda a data mínima a ser exibida.
     * É possível informar tanto valores em formato string: 22/08/2024 como em formato Date: Thu Aug 22 2024 17:14:36 GMT-0300 (Brasilia Standard Time).
     * Caso não seja informada uma data, será atribuido data atual - 120 anos seguintes.
     */
    get min() {
        return this._minDate;
    }
    set min(value) {
        const newDate = this.verifyIsUniversalDate(value);
        if (newDate) {
            this._minDate = newDate;
        }
    }
    /**
     * Variável que guarda a data limite a ser exibida.
     * É possível informar tanto valores em formato string: 22/08/2024 ou 2024/08/22 como em formato Date: Thu Aug 22 2024 17:14:36 GMT-0300 (Brasilia Standard Time)
     * Caso não seja informado uma data, será atribuido data atual + 120 anos seguintes.
     */
    get max() {
        return this._maxDate;
    }
    set max(value) {
        const newDate = this.verifyIsUniversalDate(value);
        if (newDate) {
            this._maxDate = newDate;
        }
    }
    /**
     *  Armazena a data selecionada completa salva
     */
    get value() {
        return this._value;
    }
    set value(date) {
        this._value = date;
        this.year = date ? date.getFullYear() : CURRENT_YEAR;
        this.month = date ? date.getMonth() : CURRENT_MONTH;
        this.day = date ? date.getDate() : 0;
        this.setDate(this.year, this.month, this.day);
    }
    get years() {
        return Array.from({ length: this.maxYear - this.minYear + 1 }, (_, i) => this.minYear + i);
    }
    get month() {
        return this.activeMonths.some((m) => m.id === this._month)
            ? this._month
            : this.activeMonths[0].id;
    }
    set month(month) {
        const monthNumber = enforceNumber(month);
        if (this.activeMonths.some((m) => m.id === monthNumber) && this._month !== monthNumber) {
            this._month = monthNumber;
            this.changedMonth = true;
        }
    }
    get activeMonths() {
        let start = 0;
        let end = 12;
        if (this.year === this.minYear) {
            start = this._minDate.getMonth();
        }
        if (this.year === this.maxYear) {
            end = this._maxDate.getMonth() + 1;
        }
        const newListMonth = this.calendarConfig.months.slice(start, end);
        return newListMonth;
    }
    /**
     * Habilita o modo de abertura dialog (global). Por padrão é desabilitado em desktop e habilitado em mobile.
     */
    get positionStrategy() {
        if (this.isMobile) {
            return 'global';
        }
        return this._positionStrategy;
    }
    set positionStrategy(value) {
        this._positionStrategy = value;
    }
    get selectedDateLabel() {
        return this.typeDate === 'range' ? 'Período selecionado' : 'Data selecionada';
    }
    get minYear() {
        return this._minDate.getFullYear();
    }
    get maxYear() {
        return this._maxDate.getFullYear();
    }
    get calendar() {
        if (this._memoYear !== this.year || this._memoMonth !== this.month) {
            this._calendar = generateCalendarMatrix(this.year, this.month);
            this._memoYear = this.year;
            this._memoMonth = this.month;
        }
        return this._calendar;
    }
    setDate(year, month, startDay) {
        this.selectedDay = enforceNumber(startDay);
        this.selectedYear = year;
        this.selectedMonth = month;
        const selectedDate = new Date(this.selectedYear, this.selectedMonth, this.selectedDay);
        // Zera as horas para evitar problemas de timezone
        selectedDate.setHours(0, 0, 0, 0);
        this.dateSelected.emit(startDay !== 0 ? selectedDate : null);
        this.monthSelected.emit(this.selectedMonth);
        this.yearSelected.emit(this.selectedYear);
    }
    saveDate() {
        if (!this.selectedDay || document.activeElement?.getAttribute('aria-disabled') === 'true') {
            return;
        }
        const newDate = new Date(this.selectedYear, this.selectedMonth, this.selectedDay);
        // Zera as horas para evitar problemas de timezone
        newDate.setHours(0, 0, 0, 0);
        this.valueChange.emit(newDate);
        this.openChange.emit(false);
    }
    verifyIsSelectedDate(year, month, day) {
        return (this.selectedYear === year &&
            this.selectedMonth === month &&
            this.selectedDay === enforceNumber(day));
    }
    verifyIsCurrentDate(year, month, day) {
        return CURRENT_YEAR === year && CURRENT_MONTH === month && CURRENT_DAY === enforceNumber(day);
    }
    verifyIsActiveDay(year, month, day) {
        if (!this.verifyIsDateOnRange(year, month, day)) {
            return false;
        }
        if (this.filter) {
            const date = formatStringToDate(`${day}/${month + 1}/${year}`);
            return this.filter(date);
        }
        return true;
    }
    verifyIsDateOnRange(year, month, day) {
        const dayIndex = new Date(year, month, enforceNumber(day));
        if (dayIndex.getTime() < this._minDate.getTime() ||
            dayIndex.getTime() > this._maxDate.getTime()) {
            return false;
        }
        return true;
    }
    verifyIsUniversalDate(date) {
        if (!date) {
            return;
        }
        return typeof date === 'string' && !isUniversalDateFormat(date)
            ? new Date(convertToUniversalDate(date, this.dateFormat))
            : new Date(date);
    }
    onDomChange($event) {
        this._renderingTable = !$event;
        this.changedMonth = false;
        this._configCalendar();
        // Chama a função que está guardada em callback
        if (this.callback) {
            this.callback();
            this.callback = null;
        }
    }
    _configCalendar() {
        const daysOfTheMonth = this.calendar.join().split(',');
        const isSelectedDay = daysOfTheMonth.filter((day) => this.verifyIsSelectedDate(this.year, this.month, day));
        const isCurrentDay = daysOfTheMonth.filter((day) => this.verifyIsCurrentDate(this.year, this.month, day));
        FIRSTDAY: for (const week of this.calendar) {
            for (const day of week) {
                this._firstDay = this.verifyIsActiveDay(this.year, this.month, day) ? day : '';
                if (this._firstDay) {
                    break FIRSTDAY;
                }
            }
        }
        this.isFocusDay = isSelectedDay[0] || isCurrentDay[0] || this._firstDay;
    }
    _focusDay(row, col, currentActive) {
        if (this._renderingTable) {
            // Deixando a função em standby enquanto a tabela é renderizada.
            this.callback = () => {
                this._focusDay(row, col, currentActive);
            };
            return;
        }
        const newDay = document.querySelector(`button[data-row="${row}"][data-col="${col}"]`);
        if (newDay) {
            currentActive?.setAttribute('tabindex', '-1');
            newDay?.setAttribute('tabindex', '0');
            newDay.focus();
            return;
        }
        currentActive.focus();
    }
    _goToPrevMonth() {
        if (this.month === 0) {
            this.year -= 1;
            this.month = 11;
        }
        else {
            this.month -= 1;
        }
        if (this.changedMonth) {
            this._renderingTable = true;
        }
    }
    _goToNextMonth() {
        if (this.month === 11) {
            this.year += 1;
            this.month = 0;
        }
        else {
            this.month += 1;
        }
        if (this.changedMonth) {
            this._renderingTable = true;
        }
    }
    _navigateCalendar(command) {
        /* istanbul ignore next */
        if (this._renderingTable) {
            return;
        }
        navigateCalendar({
            command: command,
            calendar: this.calendar,
            goToNextMonth: this._goToNextMonth.bind(this),
            goToPrevMonth: this._goToPrevMonth.bind(this),
            focusDay: this._focusDay.bind(this),
            getCalendar: () => this.calendar,
        });
    }
    constructor(idsDatepickerService) {
        this.idsDatepickerService = idsDatepickerService;
        this._renderingTable = false;
        this.selectedOpen = false;
        this.selectedDay = 0;
        this.selectedMonth = 0;
        this.selectedYear = 0;
        this.day = 0;
        this.year = CURRENT_YEAR;
        this.changedMonth = false;
        /** @internal */
        this.id = `ids-datepicker-${++NEXT_ID$d}`;
        /**
         * Emite evento quando há alteração de estado (aberto ou fechado) do datepicker
         */
        this.openChange = new EventEmitter();
        /**
         * Define a posição de abertura do datepiker
         */
        this.position = 'auto';
        /**
         * Define as rotas de posicionamento do modal
         */
        this.positions = defineOpeningPosition(this.position);
        /**
         *  Define a localidade da data.
         */
        this.lang = 'pt-BR';
        /**
         * Define o formato da data. Por padrão é baseado na localidade.
         * Exemplo: pt-BR = dd/mm/yyyy
         */
        this.dateFormat = LOCALE_DATE_FORMATS[this.lang];
        this._minDate = new Date(CURRENT_YEAR - MAX_YEARS_RANGE, CURRENT_MONTH, CURRENT_DAY);
        this._maxDate = new Date(CURRENT_YEAR + MAX_YEARS_RANGE, CURRENT_MONTH, CURRENT_DAY);
        /**
         * Emite a data selecionada.
         */
        this.valueChange = new EventEmitter();
        /**
         * Emite a data selecionada no calendário. Isto não implica uma alteração na data selecionada.
         */
        this.dateSelected = new EventEmitter();
        /**
         * Emite o ano selecionado na visão calendário. Isto não implica uma alteração na data selecionada.
         */
        this.yearSelected = new EventEmitter();
        /**
         * Emite o mês selecionado na visualização do ano. Isto não implica uma alteração na data selecionada.
         */
        this.monthSelected = new EventEmitter();
        /**
         * Define a configuração de palavras usadas no datepicker.
         * Útil para troca de idioma.
         */
        this.calendarConfig = {
            months: PT_BR_MONTHS,
            weekNames: PT_BR_DAYS_OF_WEEK,
        };
        this.isMobile = platform.isMobile;
        this._month = CURRENT_MONTH;
        this._positionStrategy = 'flexibleConnectedTo';
        this._calendar = [];
        this._memoYear = -1;
        this._memoMonth = -1;
        this.onKeydownEvent = createNavigationWithArrows(this._navigateCalendar.bind(this));
        this.valueChange.subscribe((date) => {
            this.idsDatepickerService.valueSubject.next(date);
        });
        this.dateSelected.subscribe((date) => {
            this.idsDatepickerService.selectedDateSubject.next(date);
        });
    }
}
IdsDatepickerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsDatepickerComponent, deps: [{ token: IdsDatepickerService }], target: i0.ɵɵFactoryTarget.Component });
IdsDatepickerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsDatepickerComponent, isStandalone: true, selector: "ids-datepicker", inputs: { id: "id", open: "open", position: "position", positions: "positions", canPush: "canPush", typeDate: "typeDate", lang: "lang", dateFormat: "dateFormat", zIndex: "zIndex", min: "min", max: "max", value: "value", calendarConfig: "calendarConfig", filter: "filter", origin: "origin", positionStrategy: "positionStrategy" }, outputs: { openChange: "openChange", valueChange: "valueChange", dateSelected: "dateSelected", yearSelected: "yearSelected", monthSelected: "monthSelected" }, host: { properties: { "attr.aria-labelledby": "null", "attr.id": "null", "attr.class": "null", "attr.width": "null" } }, providers: [IdsMaskService, IdsDatepickerService], queries: [{ propertyName: "infoBox", first: true, predicate: IdsBannerHighlightComponent, descendants: true, static: true }], viewQueries: [{ propertyName: "modal", first: true, predicate: IdsModalComponent, descendants: true, static: true }], ngImport: i0, template: "<ids-modal\n  [open]=\"open\"\n  [origin]=\"origin\"\n  (openChange)=\"openChange.emit($event)\"\n  width=\"312px\"\n  zIndex=\"10002\"\n  [positionStrategy]=\"positionStrategy\"\n  [positions]=\"positions\"\n  [canPush]=\"canPush\"\n  [aria-label]=\"!isMobile ? 'selecione a data' : null\"\n  class=\"ids-datepicker\"\n>\n  <ids-modal-header *ngIf=\"isMobile\">\n    <h2 idsModalTitle>Selecione a data</h2>\n  </ids-modal-header>\n\n  <div [id]=\"id\">\n    <div class=\"ids-datepicker__controller\">\n      <ng-container\n        *ngTemplateOutlet=\"\n          selectTemplate;\n          context: {\n            data: activeMonths,\n            ariaLabel: 'selecione o m\u00EAs',\n            type: 'month',\n            value: 'id',\n            label: 'name'\n          }\n        \"\n      ></ng-container>\n\n      <ng-container\n        *ngTemplateOutlet=\"\n          selectTemplate;\n          context: {\n            data: years,\n            ariaLabel: 'selecione o ano',\n            type: 'year'\n          }\n        \"\n      ></ng-container>\n    </div>\n\n    <div class=\"ids-datepicker__body\">\n      <div role=\"application\" class=\"ids-mb-2\">\n        <table\n          #tableDays\n          class=\"ids-calendar\"\n          [class.ids-calendar--out-focus]=\"this.selectedOpen\"\n          role=\"presentation\"\n          (keydown)=\"onKeydownEvent($event)\"\n        >\n          <thead>\n            <tr>\n              <th\n                *ngFor=\"let week of calendarConfig.weekNames; index as i\"\n                scope=\"col\"\n                [abbr]=\"week.name\"\n                [attr.aria-hidden]=\"true\"\n              >\n                {{ week.abbr }}\n              </th>\n            </tr>\n          </thead>\n          <tbody (idsDomChange)=\"onDomChange($event)\" (keyup.enter)=\"saveDate()\">\n            <tr *ngFor=\"let week of calendar; index as row\">\n              <td *ngFor=\"let day of week; index as col\">\n                <button\n                  *ngIf=\"day\"\n                  class=\"ids-calendar-day\"\n                  role=\"checkbox\"\n                  [attr.data-row]=\"row\"\n                  [attr.data-col]=\"col\"\n                  [attr.aria-checked]=\"\n                    verifyIsActiveDay(year, month, day) && verifyIsSelectedDate(year, month, day)\n                  \"\n                  [attr.aria-label]=\"\n                    this.calendarConfig.weekNames[col].name +\n                    ' ' +\n                    day +\n                    ' ' +\n                    calendarConfig.months[month].name +\n                    ' ' +\n                    year\n                  \"\n                  [attr.tabindex]=\"isFocusDay === day ? '0' : '-1'\"\n                  [attr.aria-disabled]=\"!verifyIsActiveDay(year, month, day)\"\n                  [class.ids-calendar-day--selected]=\"verifyIsSelectedDate(year, month, day)\"\n                  [class.ids-calendar-day--current]=\"verifyIsCurrentDate(year, month, day)\"\n                  (click)=\"verifyIsActiveDay(year, month, day) && setDate(year, month, day)\"\n                >\n                  {{ day }}\n                </button>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n\n      <!-- para uso direto no componente -->\n      <ng-content select=\"[idsBannerHighlight]\"></ng-content>\n\n      <div idsBannerHighlight title=\"{{ selectedDateLabel }}\" *ngIf=\"!infoBox\">\n        <span idsDatepickerSelectedDate></span>\n        <ids-icon>calendario_outline</ids-icon>\n      </div>\n    </div>\n  </div>\n\n  <ids-modal-footer [inlineButtons]=\"true\">\n    <button idsMainButton idsModalClose variant=\"secondary\">cancelar</button>\n    <button idsMainButton (click)=\"saveDate()\" [disabled]=\"!selectedDay\">confirmar</button>\n  </ids-modal-footer>\n</ids-modal>\n\n<ng-template\n  #selectTemplate\n  let-data=\"data\"\n  let-ariaLabel=\"ariaLabel\"\n  let-type=\"type\"\n  let-value=\"value\"\n  let-label=\"label\"\n>\n  <ids-form-control noMessage noBorder *ngIf=\"isMobile\">\n    <select\n      [id]=\"'ids-datepicker-select-' + type\"\n      idsSelect\n      [ngModel]=\"type === 'month' ? month : years.includes(year) ? year : years[0]\"\n      (ngModelChange)=\"type === 'month' ? (month = $event) : (year = $event)\"\n      (opened)=\"selectedOpen = true\"\n      (closed)=\"selectedOpen = false\"\n      [attr.aria-label]=\"ariaLabel\"\n    >\n      <option *ngFor=\"let item of data; let i = index\" [value]=\"value ? item[value] : item\">\n        {{ label ? item[label] : item }}\n      </option>\n    </select>\n  </ids-form-control>\n\n  <ids-form-field noMessage noBorder *ngIf=\"!isMobile\">\n    <ids-select\n      [id]=\"'ids-datepicker-select-' + type\"\n      small\n      [aria-label]=\"ariaLabel\"\n      [ngModel]=\"type === 'month' ? month : years.includes(year) ? year : years[0]\"\n      (ngModelChange)=\"type === 'month' ? (month = $event) : (year = $event)\"\n      (opened)=\"selectedOpen = true\"\n      (closed)=\"selectedOpen = false\"\n      position=\"bottom\"\n    >\n      <ids-option\n        *ngFor=\"let item of data; let i = index\"\n        [value]=\"value ? item[value] : item\"\n        small\n      >\n        {{ label ? item[label] : item }}\n      </ids-option>\n    </ids-select>\n  </ids-form-field>\n</ng-template>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: IdsDomChangeDirective, selector: "[idsDomChange]", outputs: ["idsDomChange"] }, { kind: "ngmodule", type: IdsIconModule }, { kind: "component", type: IdsIconComponent, selector: "ids-icon", inputs: ["size", "variant", "contrast"] }, { kind: "ngmodule", type: IdsIconButtonModule }, { kind: "ngmodule", type: IdsModalModule }, { kind: "component", type: IdsModalComponent, selector: "ids-modal", inputs: ["width", "aria-labelledby", "aria-label", "class", "open", "lang", "origin", "scrollStrategy", "positionStrategy", "positions", "canPush", "zIndex", "autoFocus"], outputs: ["openChange"] }, { kind: "component", type: IdsModalHeaderComponent, selector: "ids-modal-header", inputs: ["noCloseButton", "noDivider", "modalCloseLabel"] }, { kind: "component", type: IdsModalFooterComponent, selector: "ids-modal-footer", inputs: ["inlineButtons"] }, { kind: "directive", type: idsModalCloseDirective, selector: "[idsModalClose]", exportAs: ["idsModalClose"] }, { kind: "directive", type: IdsModalTitleDirective, selector: "[idsModalTitle]", inputs: ["class"], exportAs: ["idsModalTitle"] }, { kind: "ngmodule", type: IdsMainButtonModule }, { kind: "component", type: IdsMainButtonComponent, selector: "button[idsMainButton]", inputs: ["contrast", "variant", "full", "loading"] }, { kind: "ngmodule", type: IdsFormFieldModule }, { kind: "component", type: IdsFormFieldComponent, selector: "ids-form-field", inputs: ["aria-describedby", "contrast", "label", "size", "noMessage", "thresholdAnnounce", "variant", "noBorder", "errorMessage", "description", "edit", "noValidate", "center", "charactersRemainingMessage"] }, { kind: "ngmodule", type: IdsSelectModule }, { kind: "component", type: IdsSelectComponent, selector: "ids-select", inputs: ["id", "visibleOptions", "position", "required", "noLabel", "small", "compareWith"], outputs: ["change", "focus", "blur", "opened", "closed"] }, { kind: "component", type: IdsOptionComponent, selector: "ids-option", inputs: ["selected", "label", "id", "value", "disabled", "small"], outputs: ["change", "selectedChange"] }, { kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i1$2.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i1$2.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { kind: "directive", type: i1$2.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "ngmodule", type: IdsBannerHighlightModule }, { kind: "component", type: IdsBannerHighlightComponent, selector: "[idsBannerHighlight]", inputs: ["title", "contrast"] }, { kind: "directive", type: IdsDatepickerSelectedDateDirective, selector: "[idsDatepickerSelectedDate]" }, { kind: "ngmodule", type: IdsFormControlModule }, { kind: "component", type: IdsFormControlComponent, selector: "ids-form-control", inputs: ["validate", "error"] }, { kind: "directive", type: IdsSelectDirective, selector: "[idsSelect], select[idsField]" }], encapsulation: i0.ViewEncapsulation.None });
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object)
], IdsDatepickerComponent.prototype, "open", void 0);
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object)
], IdsDatepickerComponent.prototype, "canPush", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsDatepickerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-datepicker', standalone: true, encapsulation: ViewEncapsulation.None, host: {
                        '[attr.aria-labelledby]': 'null',
                        '[attr.id]': 'null',
                        '[attr.class]': 'null',
                        '[attr.width]': 'null',
                    }, imports: [
                        CommonModule,
                        IdsDomChangeDirective,
                        IdsIconModule,
                        IdsIconButtonModule,
                        IdsModalModule,
                        IdsMainButtonModule,
                        IdsFormFieldModule,
                        IdsSelectModule,
                        FormsModule,
                        IdsBannerHighlightModule,
                        IdsDatepickerSelectedDateDirective,
                        IdsFormControlModule,
                    ], providers: [IdsMaskService, IdsDatepickerService], template: "<ids-modal\n  [open]=\"open\"\n  [origin]=\"origin\"\n  (openChange)=\"openChange.emit($event)\"\n  width=\"312px\"\n  zIndex=\"10002\"\n  [positionStrategy]=\"positionStrategy\"\n  [positions]=\"positions\"\n  [canPush]=\"canPush\"\n  [aria-label]=\"!isMobile ? 'selecione a data' : null\"\n  class=\"ids-datepicker\"\n>\n  <ids-modal-header *ngIf=\"isMobile\">\n    <h2 idsModalTitle>Selecione a data</h2>\n  </ids-modal-header>\n\n  <div [id]=\"id\">\n    <div class=\"ids-datepicker__controller\">\n      <ng-container\n        *ngTemplateOutlet=\"\n          selectTemplate;\n          context: {\n            data: activeMonths,\n            ariaLabel: 'selecione o m\u00EAs',\n            type: 'month',\n            value: 'id',\n            label: 'name'\n          }\n        \"\n      ></ng-container>\n\n      <ng-container\n        *ngTemplateOutlet=\"\n          selectTemplate;\n          context: {\n            data: years,\n            ariaLabel: 'selecione o ano',\n            type: 'year'\n          }\n        \"\n      ></ng-container>\n    </div>\n\n    <div class=\"ids-datepicker__body\">\n      <div role=\"application\" class=\"ids-mb-2\">\n        <table\n          #tableDays\n          class=\"ids-calendar\"\n          [class.ids-calendar--out-focus]=\"this.selectedOpen\"\n          role=\"presentation\"\n          (keydown)=\"onKeydownEvent($event)\"\n        >\n          <thead>\n            <tr>\n              <th\n                *ngFor=\"let week of calendarConfig.weekNames; index as i\"\n                scope=\"col\"\n                [abbr]=\"week.name\"\n                [attr.aria-hidden]=\"true\"\n              >\n                {{ week.abbr }}\n              </th>\n            </tr>\n          </thead>\n          <tbody (idsDomChange)=\"onDomChange($event)\" (keyup.enter)=\"saveDate()\">\n            <tr *ngFor=\"let week of calendar; index as row\">\n              <td *ngFor=\"let day of week; index as col\">\n                <button\n                  *ngIf=\"day\"\n                  class=\"ids-calendar-day\"\n                  role=\"checkbox\"\n                  [attr.data-row]=\"row\"\n                  [attr.data-col]=\"col\"\n                  [attr.aria-checked]=\"\n                    verifyIsActiveDay(year, month, day) && verifyIsSelectedDate(year, month, day)\n                  \"\n                  [attr.aria-label]=\"\n                    this.calendarConfig.weekNames[col].name +\n                    ' ' +\n                    day +\n                    ' ' +\n                    calendarConfig.months[month].name +\n                    ' ' +\n                    year\n                  \"\n                  [attr.tabindex]=\"isFocusDay === day ? '0' : '-1'\"\n                  [attr.aria-disabled]=\"!verifyIsActiveDay(year, month, day)\"\n                  [class.ids-calendar-day--selected]=\"verifyIsSelectedDate(year, month, day)\"\n                  [class.ids-calendar-day--current]=\"verifyIsCurrentDate(year, month, day)\"\n                  (click)=\"verifyIsActiveDay(year, month, day) && setDate(year, month, day)\"\n                >\n                  {{ day }}\n                </button>\n              </td>\n            </tr>\n          </tbody>\n        </table>\n      </div>\n\n      <!-- para uso direto no componente -->\n      <ng-content select=\"[idsBannerHighlight]\"></ng-content>\n\n      <div idsBannerHighlight title=\"{{ selectedDateLabel }}\" *ngIf=\"!infoBox\">\n        <span idsDatepickerSelectedDate></span>\n        <ids-icon>calendario_outline</ids-icon>\n      </div>\n    </div>\n  </div>\n\n  <ids-modal-footer [inlineButtons]=\"true\">\n    <button idsMainButton idsModalClose variant=\"secondary\">cancelar</button>\n    <button idsMainButton (click)=\"saveDate()\" [disabled]=\"!selectedDay\">confirmar</button>\n  </ids-modal-footer>\n</ids-modal>\n\n<ng-template\n  #selectTemplate\n  let-data=\"data\"\n  let-ariaLabel=\"ariaLabel\"\n  let-type=\"type\"\n  let-value=\"value\"\n  let-label=\"label\"\n>\n  <ids-form-control noMessage noBorder *ngIf=\"isMobile\">\n    <select\n      [id]=\"'ids-datepicker-select-' + type\"\n      idsSelect\n      [ngModel]=\"type === 'month' ? month : years.includes(year) ? year : years[0]\"\n      (ngModelChange)=\"type === 'month' ? (month = $event) : (year = $event)\"\n      (opened)=\"selectedOpen = true\"\n      (closed)=\"selectedOpen = false\"\n      [attr.aria-label]=\"ariaLabel\"\n    >\n      <option *ngFor=\"let item of data; let i = index\" [value]=\"value ? item[value] : item\">\n        {{ label ? item[label] : item }}\n      </option>\n    </select>\n  </ids-form-control>\n\n  <ids-form-field noMessage noBorder *ngIf=\"!isMobile\">\n    <ids-select\n      [id]=\"'ids-datepicker-select-' + type\"\n      small\n      [aria-label]=\"ariaLabel\"\n      [ngModel]=\"type === 'month' ? month : years.includes(year) ? year : years[0]\"\n      (ngModelChange)=\"type === 'month' ? (month = $event) : (year = $event)\"\n      (opened)=\"selectedOpen = true\"\n      (closed)=\"selectedOpen = false\"\n      position=\"bottom\"\n    >\n      <ids-option\n        *ngFor=\"let item of data; let i = index\"\n        [value]=\"value ? item[value] : item\"\n        small\n      >\n        {{ label ? item[label] : item }}\n      </ids-option>\n    </ids-select>\n  </ids-form-field>\n</ng-template>\n" }]
        }], ctorParameters: function () { return [{ type: IdsDatepickerService }]; }, propDecorators: { id: [{
                type: Input
            }], open: [{
                type: Input
            }], openChange: [{
                type: Output
            }], position: [{
                type: Input
            }], positions: [{
                type: Input
            }], canPush: [{
                type: Input
            }], typeDate: [{
                type: Input
            }], lang: [{
                type: Input
            }], dateFormat: [{
                type: Input
            }], zIndex: [{
                type: Input
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], value: [{
                type: Input
            }], valueChange: [{
                type: Output
            }], dateSelected: [{
                type: Output
            }], yearSelected: [{
                type: Output
            }], monthSelected: [{
                type: Output
            }], calendarConfig: [{
                type: Input
            }], filter: [{
                type: Input
            }], modal: [{
                type: ViewChild,
                args: [IdsModalComponent, { static: true }]
            }], origin: [{
                type: Input
            }], infoBox: [{
                type: ContentChild,
                args: [IdsBannerHighlightComponent, { static: true }]
            }], positionStrategy: [{
                type: Input
            }] } });

let NEXT_ID$c = 0;
/**
 * Diretiva para utilização do InputDatepicker
 *
 * **Module:**
 *
 * `import { IdsDatepickerModule } from '@ids/angular';`
 *
 * * **Component**
 *
 * `import { IdsDatepickerComponent } from '@ids/angular';`
 */
class IdsDatepickerDirective extends IdsInputDirective {
    /**
     * Define a data mínima.
     * Caso não seja informado, será atribuido a (data atual - 120 anos).
     */
    set min(min) {
        this._min = min;
        if (this._datepickerRef) {
            this.datepicker.min = min;
        }
    }
    get min() {
        return this._min;
    }
    /**
     * Define a data máxima.
     * Caso não seja informado, será atribuido a (data atual - 120 anos).
     */
    set max(max) {
        this._max = max;
        if (this._datepickerRef) {
            this.datepicker.max = max;
        }
    }
    get max() {
        return this._max;
    }
    set filter(filter) {
        this._filter = filter;
        if (this._datepickerRef) {
            this.datepicker.filter = filter;
        }
    }
    get filter() {
        return this._filter;
    }
    /**
     * Define se o calendário está visível.
     */
    set open(open) {
        const booleanOpen = enforceBoolean(open);
        this._open = booleanOpen;
        if (this._datepickerRef) {
            this.datepicker.open = booleanOpen;
        }
    }
    get open() {
        return this._open;
    }
    /**
     * Define a posição de abertura do datepiker
     *
     */
    set position(position) {
        this._position = position;
        if (this._datepickerRef) {
            this.datepicker.position = position;
        }
    }
    get position() {
        return this._position;
    }
    /**
     * Desabilita os validadores padrão do datepicker, permitindo o uso de validadores customizados.
     */
    set disableDefaultValidators(disableDefaultValidators) {
        this._disableDefaultValidators = enforceBoolean(disableDefaultValidators);
    }
    get disableDefaultValidators() {
        return this._disableDefaultValidators;
    }
    click() {
        if (this.disabled || this.readonly) {
            return;
        }
        if (!this.open) {
            this._openCalendar();
        }
    }
    keydown({ key }) {
        if (this.disabled || this.readonly) {
            return;
        }
        if (key === 'ArrowDown') {
            if (!this.open) {
                this._openCalendar();
            }
            this.datepicker.modal.startFocus();
        }
    }
    focus() {
        if (this.disabled || this.readonly || platform.os !== 'Android') {
            return;
        }
        this._openCalendar();
    }
    get controlAria() {
        return this.controlId;
    }
    get datepicker() {
        return this._datepickerRef.instance;
    }
    constructor(ngControl, renderer, liveAnnoucer, elementRef, _viewContainerRef, idsMaskDirective, _cdr, _formFieldService) {
        super(ngControl, elementRef, liveAnnoucer, renderer);
        this.ngControl = ngControl;
        this.renderer = renderer;
        this.liveAnnoucer = liveAnnoucer;
        this.elementRef = elementRef;
        this._viewContainerRef = _viewContainerRef;
        this.idsMaskDirective = idsMaskDirective;
        this._cdr = _cdr;
        this._formFieldService = _formFieldService;
        this.inputDatepicker = this.elementRef.nativeElement;
        this._mask = inject(IdsMaskDirective, {
            self: Number(VERSION.major) > 14,
        });
        /** @internal */
        this.controlId = `ids-datepicker-input-${++NEXT_ID$c}`;
        /**
         *  Define a localidade da data.
         */
        this.lang = 'pt-BR';
        this._min = formatDateToString(new Date(CURRENT_YEAR - MAX_YEARS_RANGE, CURRENT_MONTH, CURRENT_DAY), {
            lang: 'en-ZA',
        });
        this._max = formatDateToString(new Date(CURRENT_YEAR + MAX_YEARS_RANGE, CURRENT_MONTH, CURRENT_DAY), {
            lang: 'en-ZA',
        });
        this._open = false;
        this._position = 'auto';
        /**
         * Define se o calendário é do tipo seleção única (single) ou período (range)
         */
        this.typeDate = 'single';
        this._disableDefaultValidators = false;
        this._mask.idsMask = 'date';
    }
    ngOnInit() {
        this._formFieldService.sendSuffixIcon('calendario_outline');
        if (!this.dateFormat) {
            this.dateFormat = LOCALE_DATE_FORMATS[this.lang];
        }
        this._mask.config = {
            format: this.dateFormat,
        };
        this._datepickerRef = this._viewContainerRef.createComponent(IdsDatepickerComponent, {
            index: 0,
        });
        this.datepicker.origin = new CdkOverlayOrigin(this.elementRef);
        this.datepicker.position = this.position;
        this.datepicker.filter = this.filter;
        this.datepicker.canPush = Boolean(this.canPush);
        this.datepicker.min = this.min;
        this.datepicker.max = this.max;
        // define falso para o autoFocus para que o datepicker não abra o teclado ao abrir, o foco no input será iniciado quando houver comandos para entrar no calendário.
        this.datepicker.modal.autoFocus = false;
        this.datepicker.open = this.open;
        if (this.typeDate) {
            this.datepicker.typeDate = this.typeDate;
        }
        this._addValidators();
        if (this.value) {
            const newDate = new Date(convertToUniversalDate(this.value.toString(), this.dateFormat));
            this.datepicker.value = newDate;
            this._setDateInput(newDate);
        }
        this.datepicker.valueChange.subscribe((date) => {
            if (date) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                super.value = formatDateToString(date);
                this._setDateInput(date);
            }
        });
        this.datepicker.openChange.subscribe((event) => {
            this.open = event;
        });
        /**
         * Anulando o comportamento de "abrir teclado" para o Input
         */
        this._inputmode = 'none';
        this._cdr.detectChanges();
    }
    // Ativa o validador do Form field de acordo com as validações da diretiva (data vazia, data válida, data minima e data máxima)
    _addValidators() {
        if (this.ngControl) {
            this.ngControl.valueAccessor = this;
            if (!this.disableDefaultValidators) {
                const control = this.ngControl.control;
                if (control) {
                    // Se o formControl já tiver validadores, define eles novamente e adiciona o validate daqui. Caso contrário, só define o validate.
                    const validators = control.validator
                        ? [control.validator, this._validate.bind(this)]
                        : [this._validate.bind(this)];
                    control.setValidators(validators);
                }
            }
        }
    }
    _openCalendar() {
        let newDate = null;
        if (this.value &&
            validateDate(this.value.toString(), {
                min: this.min,
                max: this.max,
                format: this.dateFormat,
                filter: this.filter,
            })) {
            newDate = this._formatDate(this.value);
        }
        this.datepicker.value = newDate;
        this.open = true;
    }
    _formatDate(value) {
        const date = value.toString().replace('-', '/');
        const newDate = new Date(convertToUniversalDate(date, this.dateFormat));
        return newDate;
    }
    _setDateInput(date) {
        this.renderer.setProperty(this.inputDatepicker, 'value', formatDateToString(date));
    }
    _validate(control) {
        // O idsDateValidator é ativado no momento de carregamento da diretiva, e valida a informação em tempo de digitação.
        return idsDateValidator({
            min: this.min,
            max: this.max,
            format: this.dateFormat,
            filter: this.filter,
        })(control);
    }
}
IdsDatepickerDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsDatepickerDirective, deps: [{ token: i1$2.NgControl, optional: true, self: true }, { token: i0.Renderer2 }, { token: i1$1.LiveAnnouncer }, { token: i0.ElementRef }, { token: i0.ViewContainerRef }, { token: IdsMaskDirective }, { token: i0.ChangeDetectorRef }, { token: IdsFormFieldService }], target: i0.ɵɵFactoryTarget.Directive });
IdsDatepickerDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsDatepickerDirective, isStandalone: true, selector: "[idsDatepicker]", inputs: { controlId: ["id", "controlId"], lang: "lang", dateFormat: "dateFormat", min: "min", max: "max", filter: "filter", open: "open", position: "position", canPush: "canPush", typeDate: "typeDate", disableDefaultValidators: "disableDefaultValidators" }, host: { listeners: { "click": "click()", "keydown": "keydown($event)", "focus": "focus()" }, properties: { "attr.aria-expanded": "open || \"false\"", "attr.aria-haspopup": "\"dialog\"", "attr.role": "\"combobox\"", "attr.aria-controls": "this.controlAria" } }, providers: [
        {
            provide: IdsFieldMixinBase,
            useExisting: forwardRef(() => IdsDatepickerDirective),
        },
    ], usesInheritance: true, hostDirectives: [{ directive: IdsMaskDirective }], ngImport: i0 });
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object)
], IdsDatepickerDirective.prototype, "canPush", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsDatepickerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsDatepicker]',
                    standalone: true,
                    providers: [
                        {
                            provide: IdsFieldMixinBase,
                            useExisting: forwardRef(() => IdsDatepickerDirective),
                        },
                    ],
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore não compatível com angular 14
                    // eslint-disable-next-line no-restricted-syntax
                    hostDirectives: [
                        {
                            directive: IdsMaskDirective,
                        },
                    ],
                    host: {
                        '[attr.aria-expanded]': 'open || "false"',
                        '[attr.aria-haspopup]': '"dialog"',
                        '[attr.role]': '"combobox"',
                    },
                }]
        }], ctorParameters: function () { return [{ type: i1$2.NgControl, decorators: [{
                    type: Self
                }, {
                    type: Optional
                }] }, { type: i0.Renderer2 }, { type: i1$1.LiveAnnouncer }, { type: i0.ElementRef }, { type: i0.ViewContainerRef }, { type: IdsMaskDirective }, { type: i0.ChangeDetectorRef }, { type: IdsFormFieldService }]; }, propDecorators: { controlId: [{
                type: Input,
                args: ['id']
            }], lang: [{
                type: Input
            }], dateFormat: [{
                type: Input
            }], min: [{
                type: Input
            }], max: [{
                type: Input
            }], filter: [{
                type: Input
            }], open: [{
                type: Input
            }], position: [{
                type: Input
            }], canPush: [{
                type: Input
            }], typeDate: [{
                type: Input
            }], disableDefaultValidators: [{
                type: Input
            }], click: [{
                type: HostListener,
                args: ['click']
            }], keydown: [{
                type: HostListener,
                args: ['keydown', ['$event']]
            }], focus: [{
                type: HostListener,
                args: ['focus']
            }], controlAria: [{
                type: HostBinding,
                args: ['attr.aria-controls']
            }] } });

class IdsDatepickerModule {
}
IdsDatepickerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsDatepickerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsDatepickerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsDatepickerModule, imports: [IdsDatepickerComponent,
        IdsDatepickerDirective,
        IdsDomChangeDirective,
        IdsDatepickerSelectedDateDirective,
        IdsMaskModule], exports: [IdsDatepickerComponent,
        IdsDatepickerDirective,
        IdsDomChangeDirective,
        IdsDatepickerSelectedDateDirective] });
IdsDatepickerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsDatepickerModule, imports: [IdsDatepickerComponent,
        IdsMaskModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsDatepickerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        IdsDatepickerComponent,
                        IdsDatepickerDirective,
                        IdsDomChangeDirective,
                        IdsDatepickerSelectedDateDirective,
                        IdsMaskModule,
                    ],
                    exports: [
                        IdsDatepickerComponent,
                        IdsDatepickerDirective,
                        IdsDomChangeDirective,
                        IdsDatepickerSelectedDateDirective,
                    ],
                }]
        }] });

/**
 * Os botões permitem que o usuário realize ações e façam escolhas com um único toque.
 *
 * *Buttons allow the user to perform actions and make choices with a single tap.*
 *
 * **Module:**
 *
 * `import { IdsDirectionalButtonModule } from '@ids/angular';`
 *
 * **Component:**
 *
 * `import { IdsDirectionalButtonComponent } from '@ids/angular';`
 */
class IdsDirectionalButtonComponent {
    constructor() {
        this.size = 'M';
    }
}
IdsDirectionalButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsDirectionalButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IdsDirectionalButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsDirectionalButtonComponent, isStandalone: true, selector: "[idsDirectionalButton]", inputs: { variant: "variant", contrast: "contrast", size: "size" }, host: { properties: { "class.ids-directional-button": "true", "class.ids-directional-button--neutral": "variant === \"neutral\"", "class.ids-directional-button--secondary": "variant === \"secondary\"", "class.ids-directional-button--on-brand": "contrast === \"onBrand\"", "class.ids-directional-button--small": "size === \"S\"" } }, ngImport: i0, template: '<ng-content></ng-content> <ids-icon size="S">seta_direita</ids-icon>', isInline: true, styles: [".ids-directional-button,:host.ids-directional-button{all:unset;all:revert;box-sizing:border-box;padding:0;-webkit-user-select:none;user-select:none;gap:var(--ids_spacing_1x);align-items:center;background-color:transparent;border:0;color:var(--ids_color_action_primary_base);cursor:pointer;display:inline-flex;font:var(--ids_textStyle_f02_s16_h24_wbd);justify-content:center;min-height:var(--ids_size_general_48x);text-align:center;text-decoration:none}@media (pointer: coarse){.ids-directional-button,:host.ids-directional-button{outline:0!important}.ids-directional-button:focus,:host.ids-directional-button:focus{outline:0!important}}@media (pointer: coarse) and (pointer: fine){.ids-directional-button:focus-visible,.ids-directional-button:focus.focus-visible,:host.ids-directional-button:focus-visible,:host.ids-directional-button:focus.focus-visible{outline:0!important}}@media (pointer: fine){.ids-directional-button:focus-visible,.ids-directional-button:focus.focus-visible,:host.ids-directional-button:focus-visible,:host.ids-directional-button:focus.focus-visible{outline:revert!important}}@media (pointer: fine) and (pointer: fine){.ids-directional-button:focus-visible,.ids-directional-button:focus.focus-visible,:host.ids-directional-button:focus-visible,:host.ids-directional-button:focus.focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}}.js-no-flexbox-gap .ids-directional-button,.js-no-flexbox-gap :host.ids-directional-button{white-space:pre}.ids-directional-button--small,:host.ids-directional-button--small{font:var(--ids_textStyle_f02_s14_h20_wrg)}.ids-directional-button:disabled,.ids-directional-button[aria-disabled=true],:host.ids-directional-button:disabled,:host.ids-directional-button[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){.ids-directional-button:hover:not(:disabled):not([aria-disabled=true]),.ids-directional-button:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-directional-button:hover:not(:disabled):not([aria-disabled=true]),:host.ids-directional-button:focus-visible:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_primary_variant)}}.ids-directional-button:active:not(:disabled):not([aria-disabled=true]),:host.ids-directional-button:active:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_primary_variant)}.ids-directional-button--neutral,:host.ids-directional-button--neutral{color:var(--ids_color_action_neutral_base)}@media (hover: hover) and (pointer: fine){.ids-directional-button--neutral:hover:not(:disabled):not([aria-disabled=true]),.ids-directional-button--neutral:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-directional-button--neutral:hover:not(:disabled):not([aria-disabled=true]),:host.ids-directional-button--neutral:focus-visible:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_neutral_variant)}}.ids-directional-button--neutral:active:not(:disabled):not([aria-disabled=true]),:host.ids-directional-button--neutral:active:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_neutral_variant)}.ids-directional-button--secondary,:host.ids-directional-button--secondary{color:var(--ids_color_action_secondary_base)}@media (hover: hover) and (pointer: fine){.ids-directional-button--secondary:hover:not(:disabled):not([aria-disabled=true]),.ids-directional-button--secondary:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-directional-button--secondary:hover:not(:disabled):not([aria-disabled=true]),:host.ids-directional-button--secondary:focus-visible:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_secondary_variant)}}.ids-directional-button--secondary:active:not(:disabled):not([aria-disabled=true]),:host.ids-directional-button--secondary:active:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_secondary_variant)}.ids-directional-button--on-brand,:host.ids-directional-button--on-brand{color:var(--ids_color_contrast_onBrand_primary)}.ids-directional-button--on-brand:disabled,.ids-directional-button--on-brand[aria-disabled=true],:host.ids-directional-button--on-brand:disabled,:host.ids-directional-button--on-brand[aria-disabled=true]{color:var(--ids_color_contrast_onBrand_primary_medium)}@media (hover: hover) and (pointer: fine){.ids-directional-button--on-brand:hover:not(:disabled):not([aria-disabled=true]),.ids-directional-button--on-brand:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-directional-button--on-brand:hover:not(:disabled):not([aria-disabled=true]),:host.ids-directional-button--on-brand:focus-visible:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_contrast_onBrand_primary_strong)}}.ids-directional-button--on-brand:active:not(:disabled):not([aria-disabled=true]),:host.ids-directional-button--on-brand:active:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_contrast_onBrand_primary_strong)}\n"], dependencies: [{ kind: "ngmodule", type: IdsIconModule }, { kind: "component", type: IdsIconComponent, selector: "ids-icon", inputs: ["size", "variant", "contrast"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsDirectionalButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: '[idsDirectionalButton]', template: '<ng-content></ng-content> <ids-icon size="S">seta_direita</ids-icon>', host: {
                        '[class.ids-directional-button]': 'true',
                        '[class.ids-directional-button--neutral]': 'variant === "neutral"',
                        '[class.ids-directional-button--secondary]': 'variant === "secondary"',
                        '[class.ids-directional-button--on-brand]': 'contrast === "onBrand"',
                        '[class.ids-directional-button--small]': 'size === "S"',
                    }, standalone: true, imports: [IdsIconModule], styles: [".ids-directional-button,:host.ids-directional-button{all:unset;all:revert;box-sizing:border-box;padding:0;-webkit-user-select:none;user-select:none;gap:var(--ids_spacing_1x);align-items:center;background-color:transparent;border:0;color:var(--ids_color_action_primary_base);cursor:pointer;display:inline-flex;font:var(--ids_textStyle_f02_s16_h24_wbd);justify-content:center;min-height:var(--ids_size_general_48x);text-align:center;text-decoration:none}@media (pointer: coarse){.ids-directional-button,:host.ids-directional-button{outline:0!important}.ids-directional-button:focus,:host.ids-directional-button:focus{outline:0!important}}@media (pointer: coarse) and (pointer: fine){.ids-directional-button:focus-visible,.ids-directional-button:focus.focus-visible,:host.ids-directional-button:focus-visible,:host.ids-directional-button:focus.focus-visible{outline:0!important}}@media (pointer: fine){.ids-directional-button:focus-visible,.ids-directional-button:focus.focus-visible,:host.ids-directional-button:focus-visible,:host.ids-directional-button:focus.focus-visible{outline:revert!important}}@media (pointer: fine) and (pointer: fine){.ids-directional-button:focus-visible,.ids-directional-button:focus.focus-visible,:host.ids-directional-button:focus-visible,:host.ids-directional-button:focus.focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}}.js-no-flexbox-gap .ids-directional-button,.js-no-flexbox-gap :host.ids-directional-button{white-space:pre}.ids-directional-button--small,:host.ids-directional-button--small{font:var(--ids_textStyle_f02_s14_h20_wrg)}.ids-directional-button:disabled,.ids-directional-button[aria-disabled=true],:host.ids-directional-button:disabled,:host.ids-directional-button[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){.ids-directional-button:hover:not(:disabled):not([aria-disabled=true]),.ids-directional-button:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-directional-button:hover:not(:disabled):not([aria-disabled=true]),:host.ids-directional-button:focus-visible:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_primary_variant)}}.ids-directional-button:active:not(:disabled):not([aria-disabled=true]),:host.ids-directional-button:active:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_primary_variant)}.ids-directional-button--neutral,:host.ids-directional-button--neutral{color:var(--ids_color_action_neutral_base)}@media (hover: hover) and (pointer: fine){.ids-directional-button--neutral:hover:not(:disabled):not([aria-disabled=true]),.ids-directional-button--neutral:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-directional-button--neutral:hover:not(:disabled):not([aria-disabled=true]),:host.ids-directional-button--neutral:focus-visible:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_neutral_variant)}}.ids-directional-button--neutral:active:not(:disabled):not([aria-disabled=true]),:host.ids-directional-button--neutral:active:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_neutral_variant)}.ids-directional-button--secondary,:host.ids-directional-button--secondary{color:var(--ids_color_action_secondary_base)}@media (hover: hover) and (pointer: fine){.ids-directional-button--secondary:hover:not(:disabled):not([aria-disabled=true]),.ids-directional-button--secondary:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-directional-button--secondary:hover:not(:disabled):not([aria-disabled=true]),:host.ids-directional-button--secondary:focus-visible:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_secondary_variant)}}.ids-directional-button--secondary:active:not(:disabled):not([aria-disabled=true]),:host.ids-directional-button--secondary:active:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_action_secondary_variant)}.ids-directional-button--on-brand,:host.ids-directional-button--on-brand{color:var(--ids_color_contrast_onBrand_primary)}.ids-directional-button--on-brand:disabled,.ids-directional-button--on-brand[aria-disabled=true],:host.ids-directional-button--on-brand:disabled,:host.ids-directional-button--on-brand[aria-disabled=true]{color:var(--ids_color_contrast_onBrand_primary_medium)}@media (hover: hover) and (pointer: fine){.ids-directional-button--on-brand:hover:not(:disabled):not([aria-disabled=true]),.ids-directional-button--on-brand:focus-visible:not(:disabled):not([aria-disabled=true]),:host.ids-directional-button--on-brand:hover:not(:disabled):not([aria-disabled=true]),:host.ids-directional-button--on-brand:focus-visible:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_contrast_onBrand_primary_strong)}}.ids-directional-button--on-brand:active:not(:disabled):not([aria-disabled=true]),:host.ids-directional-button--on-brand:active:not(:disabled):not([aria-disabled=true]){color:var(--ids_color_contrast_onBrand_primary_strong)}\n"] }]
        }], propDecorators: { variant: [{
                type: Input
            }], contrast: [{
                type: Input
            }], size: [{
                type: Input
            }] } });

class IdsDirectionalButtonModule {
}
IdsDirectionalButtonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsDirectionalButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsDirectionalButtonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsDirectionalButtonModule, imports: [IdsDirectionalButtonComponent], exports: [IdsDirectionalButtonComponent] });
IdsDirectionalButtonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsDirectionalButtonModule, imports: [IdsDirectionalButtonComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsDirectionalButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsDirectionalButtonComponent],
                    exports: [IdsDirectionalButtonComponent],
                }]
        }] });

/**
 * Componente utilizado para representar a seleção de um item. Pode ser utilizado dentro de outro componente ou avulso no layout.
 *
 * **Module:**
 *
 * `import { IdsFavoriteButtonModule } from '@ids/angular';`
 *
 *  **Component:**
 *
 * `import { IdsFavoriteButtonComponent } from '@ids/angular';`
 *
 */
class IdsFavoriteButtonComponent {
    get ariaLabel() {
        return this.checked
            ? `${this.checkedLabel} ${this.label}`.trim()
            : `${this.uncheckedLabel} ${this.label}`.trim();
    }
    get iconContent() {
        const defaultIcon = 'favorito';
        if (!this.content) {
            return '';
        }
        if (!this.content.nativeElement.innerText) {
            if (this.checked) {
                return this.checkedIcon || defaultIcon;
            }
            return this.uncheckedIcon || `${defaultIcon}_outline`;
        }
        return this.checked
            ? this.content.nativeElement.innerText.trim()
            : this.content.nativeElement.innerText.trim() + '_outline';
    }
    /**
     * define o estado do componente como marcado
     *
     * *define component state to checked*
     */
    set checked(value) {
        this._checked = enforceBoolean(value);
    }
    get checked() {
        return this._checked;
    }
    /**
     * define o estado do componente como desabilitado
     *
     * *define component state to disabled*
     */
    set disabled(value) {
        this._disabled = enforceBoolean(value);
    }
    get disabled() {
        return this._disabled;
    }
    constructor(_cdr) {
        this._cdr = _cdr;
        this._checked = false;
        this._disabled = false;
        this.userPlatform = platform;
        this.label = '';
        /**
         * texto que será lido por leitores de tela quando marcado
         *
         * *text that will be read by screen readers when checked*
         */
        this.checkedLabel = 'desfavoritar';
        /**
         * texto que será lido por leitores de tela quando não marcado
         *
         * *text that will be read by screen readers when unchecked*
         */
        this.uncheckedLabel = 'favoritar';
        /**
         * emite o evento quando o componente tem seu status alterado
         *
         * *emits the event when the component has its status changed*
         */
        this.checkedChange = new EventEmitter();
    }
    ngOnInit() {
        this._cdr.detectChanges();
    }
    select() {
        this.checked = !this.checked;
        this.checkedChange.emit(this.checked);
    }
}
IdsFavoriteButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFavoriteButtonComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
IdsFavoriteButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsFavoriteButtonComponent, isStandalone: true, selector: "ids-favorite-button", inputs: { label: "label", checkedLabel: "checkedLabel", uncheckedLabel: "uncheckedLabel", checkedIcon: "checkedIcon", uncheckedIcon: "uncheckedIcon", ariaDescribedby: ["aria-describedby", "ariaDescribedby"], checked: "checked", disabled: "disabled" }, outputs: { checkedChange: "checkedChange" }, host: { properties: { "attr.aria-describedby": "null" } }, viewQueries: [{ propertyName: "content", first: true, predicate: ["content"], descendants: true }], ngImport: i0, template: "<button\n  idsIconButton\n  [class.ids-icon-button--neutral]=\"!checked\"\n  [attr.aria-label]=\"ariaLabel\"\n  [attr.aria-describedby]=\"ariaDescribedby\"\n  (click)=\"select()\"\n  [disabled]=\"disabled\"\n  [attr.aria-live]=\"userPlatform.os === 'Android' ? 'polite' : null\"\n>\n  {{ iconContent }}\n</button>\n\n<span hidden #content>\n  <ng-content></ng-content>\n</span>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "ngmodule", type: IdsIconButtonModule }, { kind: "component", type: IdsIconButtonComponent, selector: "[idsIconButton]", inputs: ["variant", "contrast", "size", "title", "aria-label"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFavoriteButtonComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-favorite-button', host: {
                        '[attr.aria-describedby]': 'null',
                    }, standalone: true, imports: [CommonModule, IdsIconButtonModule], template: "<button\n  idsIconButton\n  [class.ids-icon-button--neutral]=\"!checked\"\n  [attr.aria-label]=\"ariaLabel\"\n  [attr.aria-describedby]=\"ariaDescribedby\"\n  (click)=\"select()\"\n  [disabled]=\"disabled\"\n  [attr.aria-live]=\"userPlatform.os === 'Android' ? 'polite' : null\"\n>\n  {{ iconContent }}\n</button>\n\n<span hidden #content>\n  <ng-content></ng-content>\n</span>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { label: [{
                type: Input
            }], checkedLabel: [{
                type: Input
            }], uncheckedLabel: [{
                type: Input
            }], checkedIcon: [{
                type: Input
            }], uncheckedIcon: [{
                type: Input
            }], ariaDescribedby: [{
                type: Input,
                args: ['aria-describedby']
            }], checked: [{
                type: Input
            }], disabled: [{
                type: Input
            }], checkedChange: [{
                type: Output
            }], content: [{
                type: ViewChild,
                args: ['content']
            }] } });

class IdsFavoriteButtonModule {
}
IdsFavoriteButtonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFavoriteButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsFavoriteButtonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsFavoriteButtonModule, imports: [IdsFavoriteButtonComponent], exports: [IdsFavoriteButtonComponent] });
IdsFavoriteButtonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFavoriteButtonModule, imports: [IdsFavoriteButtonComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFavoriteButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsFavoriteButtonComponent],
                    exports: [IdsFavoriteButtonComponent],
                }]
        }] });

class IdsFormSelectionLegendDirective {
    constructor() {
        this._formSelectionGroupLegendClass = true;
    }
}
IdsFormSelectionLegendDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormSelectionLegendDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
IdsFormSelectionLegendDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsFormSelectionLegendDirective, isStandalone: true, selector: "ids-form-selection-group legend", host: { properties: { "class.ids-form-selection-legend": "this._formSelectionGroupLegendClass" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormSelectionLegendDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: 'ids-form-selection-group legend',
                    standalone: true,
                }]
        }], propDecorators: { _formSelectionGroupLegendClass: [{
                type: HostBinding,
                args: ['class.ids-form-selection-legend']
            }] } });

/**
 * O Selector foi desenvolvido para ser utilizado em componentes de seleção como checkbox,
 * radiobutton e switch.
 *
 * **Module:**
 *
 * `import { IdsFormSelectionModule } from '@ids/angular';`
 */
class IdsFormSelectionComponent {
    constructor(_cdr) {
        this._cdr = _cdr;
        this._destroy = new Subject();
        this.COMPONENT_NOT_FOUND = 'IdsComponents: Não foi possível encontrar a diretiva idsCheckbox ou idsRadioButton, nem o input type="checkbox" ou type="radio" dentro do ids-form-selection.';
        /* no IOS, ao navegar por caracteres, o VoiceOver lê a label inteira de uma vez
        por conta do aria-labelledby, por isso foi necessário remover o ariaHidden
        para que leia corretamente por caractere e use apenas o label=for sem aria-labelledby
        que foi colocado na diretiva do form selection */
        this.ariaHidden = platform.os !== 'IOS';
    }
    ngOnInit() {
        if (this.input) {
            this.input.contrast = this.contrast;
        }
    }
    ngAfterContentInit() {
        if (!this.input) {
            throw new Error(this.COMPONENT_NOT_FOUND);
        }
    }
    ngAfterViewInit() {
        const link = this.formSelectionLabel.nativeElement.getElementsByTagName('a');
        if (link.length) {
            this.ariaHidden = null;
            this.formSelectionLabel.nativeElement.style.position = 'relative';
            this._cdr.detectChanges();
        }
    }
    ngAfterContentChecked() {
        /* no IOS, ao navegar por caracteres, o VoiceOver lê a label inteira de uma vez
        por conta do aria-labelledby, então ao menos que a pessoa dev passar um valor,
        o padrão é deixar sem para IOS */
        this.input.ariaLabelledBy = platform.os !== 'IOS' ? `${this.input.id}-label` : '';
        this._cdr.detectChanges();
    }
    ngOnDestroy() {
        this._destroy.next();
        this._destroy.complete();
    }
}
IdsFormSelectionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormSelectionComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
IdsFormSelectionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsFormSelectionComponent, isStandalone: true, selector: "ids-form-selection", inputs: { contrast: "contrast" }, queries: [{ propertyName: "input", first: true, predicate: IdsFormSelectionInputDirective, descendants: true, static: true }, { propertyName: "status", predicate: IdsFormMessageComponent }], viewQueries: [{ propertyName: "formSelectionLabel", first: true, predicate: ["formSelectionLabel"], descendants: true }], ngImport: i0, template: "<div\n  class=\"ids-form-selection\"\n  [class.ids-form-selection--on-brand]=\"contrast === 'onBrand' || input.contrast === 'onBrand'\"\n  [class.ids-form-selection--disabled]=\"input.disabled || input.elementRef.nativeElement.disabled\"\n  [class.ids-form-selection--invalid]=\"\n    input.ariaInvalid || input.elementRef.nativeElement.getAttribute('aria-invalid') === 'true'\n  \"\n  [class.ids-form-selection--rtl]=\"input.rtlDirection\"\n>\n  <div class=\"ids-form-selection__input\" #inputRef>\n    <span [class]=\"input.rootClasses\">\n      <ng-content select=\"input\"></ng-content>\n\n      <i [class]=\"input.iconClasses\" aria-hidden=\"true\"></i>\n    </span>\n  </div>\n\n  <label\n    #formSelectionLabel\n    class=\"ids-form-selection__label\"\n    [attr.aria-hidden]=\"ariaHidden\"\n    [for]=\"input.id\"\n    [id]=\"input.id + '-label'\"\n  >\n    <ng-content></ng-content>\n  </label>\n</div>\n\n<ng-content select=\"ids-form-message\"></ng-content>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormSelectionComponent, decorators: [{
            type: Component,
            args: [{ encapsulation: ViewEncapsulation.None, imports: [CommonModule], selector: 'ids-form-selection', standalone: true, template: "<div\n  class=\"ids-form-selection\"\n  [class.ids-form-selection--on-brand]=\"contrast === 'onBrand' || input.contrast === 'onBrand'\"\n  [class.ids-form-selection--disabled]=\"input.disabled || input.elementRef.nativeElement.disabled\"\n  [class.ids-form-selection--invalid]=\"\n    input.ariaInvalid || input.elementRef.nativeElement.getAttribute('aria-invalid') === 'true'\n  \"\n  [class.ids-form-selection--rtl]=\"input.rtlDirection\"\n>\n  <div class=\"ids-form-selection__input\" #inputRef>\n    <span [class]=\"input.rootClasses\">\n      <ng-content select=\"input\"></ng-content>\n\n      <i [class]=\"input.iconClasses\" aria-hidden=\"true\"></i>\n    </span>\n  </div>\n\n  <label\n    #formSelectionLabel\n    class=\"ids-form-selection__label\"\n    [attr.aria-hidden]=\"ariaHidden\"\n    [for]=\"input.id\"\n    [id]=\"input.id + '-label'\"\n  >\n    <ng-content></ng-content>\n  </label>\n</div>\n\n<ng-content select=\"ids-form-message\"></ng-content>\n" }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { contrast: [{
                type: Input
            }], input: [{
                type: ContentChild,
                args: [IdsFormSelectionInputDirective, { static: true }]
            }], status: [{
                type: ContentChildren,
                args: [IdsFormMessageComponent]
            }], formSelectionLabel: [{
                type: ViewChild,
                args: ['formSelectionLabel']
            }] } });

let NEXT_ID$b = 0;
/**
 * O Form Selection Group foi desenvolvido para agrupar componentes de seleção como checkbox,
 * radiobutton e switch (wip).
 *
 * **Module:**
 *
 * `import { IdsFormSelectionModule } from '@ids/angular';`
 *
 * Este modulo possui todas as declarações dos componentes citados acima.
 */
class IdsFormSelectionGroupComponent {
    constructor() {
        /** @internal */
        this.id = `ids-selection-group-${++NEXT_ID$b}`;
        this._hostId = null;
        this._inline = false;
        this.legend = '';
    }
    /**
     * Indica se o grupo vai estar disposto em linha
     *
     * *Indicates if the group will be inline*
     */
    set inline(inline) {
        this._inline = enforceBoolean(inline);
    }
    get inline() {
        return this._inline;
    }
}
IdsFormSelectionGroupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormSelectionGroupComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IdsFormSelectionGroupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsFormSelectionGroupComponent, isStandalone: true, selector: "ids-form-selection-group", inputs: { id: "id", inline: "inline", legend: "legend" }, host: { properties: { "attr.id": "this._hostId" } }, queries: [{ propertyName: "options", predicate: IdsFormSelectionComponent }, { propertyName: "status", predicate: IdsFormMessageComponent }], ngImport: i0, template: "<fieldset\n  [id]=\"id\"\n  class=\"ids-form-selection-group\"\n  [class.ids-form-selection-group--inline]=\"inline\"\n>\n  <legend *ngIf=\"legend\">\n    {{ legend }}\n  </legend>\n  <ng-content select=\"legend\"></ng-content>\n\n  <div class=\"ids-form-selection-group__options\">\n    <ng-content select=\"ids-form-selection\"></ng-content>\n  </div>\n</fieldset>\n", styles: [".ids-form-selection-group__options{display:grid}.ids-form-selection-group--inline .ids-form-selection-group__options{gap:var(--ids_size_general_24x);display:flex;flex-wrap:wrap;width:100%}.js-no-flexbox-gap .ids-form-selection-group--inline .ids-form-selection-group__options{margin:calc(var(--ids_size_general_24x) / -2)!important}.js-no-flexbox-gap .ids-form-selection-group--inline .ids-form-selection-group__options>*{margin:calc(var(--ids_size_general_24x) / 2)!important}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormSelectionGroupComponent, decorators: [{
            type: Component,
            args: [{ imports: [CommonModule], selector: 'ids-form-selection-group', standalone: true, template: "<fieldset\n  [id]=\"id\"\n  class=\"ids-form-selection-group\"\n  [class.ids-form-selection-group--inline]=\"inline\"\n>\n  <legend *ngIf=\"legend\">\n    {{ legend }}\n  </legend>\n  <ng-content select=\"legend\"></ng-content>\n\n  <div class=\"ids-form-selection-group__options\">\n    <ng-content select=\"ids-form-selection\"></ng-content>\n  </div>\n</fieldset>\n", styles: [".ids-form-selection-group__options{display:grid}.ids-form-selection-group--inline .ids-form-selection-group__options{gap:var(--ids_size_general_24x);display:flex;flex-wrap:wrap;width:100%}.js-no-flexbox-gap .ids-form-selection-group--inline .ids-form-selection-group__options{margin:calc(var(--ids_size_general_24x) / -2)!important}.js-no-flexbox-gap .ids-form-selection-group--inline .ids-form-selection-group__options>*{margin:calc(var(--ids_size_general_24x) / 2)!important}\n"] }]
        }], propDecorators: { id: [{
                type: Input
            }], _hostId: [{
                type: HostBinding,
                args: ['attr.id']
            }], inline: [{
                type: Input
            }], legend: [{
                type: Input
            }], options: [{
                type: ContentChildren,
                args: [IdsFormSelectionComponent]
            }], status: [{
                type: ContentChildren,
                args: [IdsFormMessageComponent]
            }] } });

class IdsFormSelectionGroupModule {
}
IdsFormSelectionGroupModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormSelectionGroupModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsFormSelectionGroupModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsFormSelectionGroupModule, imports: [IdsFormSelectionGroupComponent, IdsFormSelectionLegendDirective], exports: [IdsFormSelectionGroupComponent, IdsFormSelectionLegendDirective] });
IdsFormSelectionGroupModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormSelectionGroupModule, imports: [IdsFormSelectionGroupComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormSelectionGroupModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsFormSelectionGroupComponent, IdsFormSelectionLegendDirective],
                    exports: [IdsFormSelectionGroupComponent, IdsFormSelectionLegendDirective],
                }]
        }] });

class IdsFormSelectionModule {
}
IdsFormSelectionModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormSelectionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsFormSelectionModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsFormSelectionModule, imports: [IdsFormSelectionComponent], exports: [IdsFormSelectionComponent] });
IdsFormSelectionModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormSelectionModule, imports: [IdsFormSelectionComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormSelectionModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsFormSelectionComponent],
                    exports: [IdsFormSelectionComponent],
                }]
        }] });

/**
 * Os botões permitem que a pessoa usuária realize ações e façam escolhas com um único toque.
 *
 * *Buttons allow the user to perform actions and make choices with a single tap.*
 *
 * **Module:**
 *
 * `import { IdsHighlightButtonModule } from '@ids/angular';`
 *
 * **Componente:**
 *
 * `import { IdsHighlightButtonComponent } from '@ids/angular';`
 */
class IdsHighlightButtonComponent {
}
IdsHighlightButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsHighlightButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IdsHighlightButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsHighlightButtonComponent, isStandalone: true, selector: "[idsHighlightButton]", inputs: { aspectRatio: "aspectRatio", variant: "variant", contrast: "contrast", size: "size" }, host: { properties: { "class.ids-highlight-button": "true", "class.ids-highlight-button--neutral": "variant === \"neutral\"", "class.ids-highlight-button--rectangular": "aspectRatio === \"2:1\"", "class.ids-highlight-button--secondary": "variant === \"secondary\"", "class.ids-highlight-button--on-brand": "contrast === \"onBrand\"", "class.ids-highlight-button--large": "size === \"L\"" } }, ngImport: i0, template: `<span class="ids-highlight-button__content">
    <ng-content></ng-content>
  </span>`, isInline: true, styles: [":host.ids-highlight-button,.ids-highlight-button{all:unset;all:revert;box-sizing:border-box;-webkit-user-select:none;user-select:none;align-items:center;background:var(--ids_color_action_primary_base);border-color:var(--ids_color_action_primary_variant);border-radius:var(--ids_size_cornerRadius_card_01);border-style:solid;border-width:var(--ids_size_border_small);color:var(--ids_color_action_primary_contrast);cursor:pointer;display:inline-flex;font:var(--ids_textStyle_f02_s14_h20_wrg);justify-content:center;min-height:var(--ids_size_general_24x);outline-offset:var(--ids_size_general_4x);padding:0;position:relative;text-align:left;text-decoration:none;width:100%}@media (pointer: coarse){:host.ids-highlight-button,.ids-highlight-button{outline:0!important}:host.ids-highlight-button:focus,.ids-highlight-button:focus{outline:0!important}}@media (pointer: coarse) and (pointer: fine){:host.ids-highlight-button:focus-visible,:host.ids-highlight-button:focus.focus-visible,.ids-highlight-button:focus-visible,.ids-highlight-button:focus.focus-visible{outline:0!important}}@media (pointer: fine){:host.ids-highlight-button:focus-visible,:host.ids-highlight-button:focus.focus-visible,.ids-highlight-button:focus-visible,.ids-highlight-button:focus.focus-visible{outline:revert!important}}@media (pointer: fine) and (pointer: fine){:host.ids-highlight-button:focus-visible,:host.ids-highlight-button:focus.focus-visible,.ids-highlight-button:focus-visible,.ids-highlight-button:focus.focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}}:host.ids-highlight-button:before,.ids-highlight-button:before{content:\"\";display:block;padding-bottom:100%}:host.ids-highlight-button .ids-icon,.ids-highlight-button .ids-icon{font:var(--ids_textStyle_icon_medium);line-height:inherit}:host.ids-highlight-button ::ng-deep .ids-icon,.ids-highlight-button ::ng-deep .ids-icon{font:var(--ids_textStyle_icon_medium);line-height:inherit}:host.ids-highlight-button:disabled,:host.ids-highlight-button[aria-disabled=true],.ids-highlight-button:disabled,.ids-highlight-button[aria-disabled=true]{background-color:var(--ids_color_action_disabled_base);border-color:var(--ids_color_action_disabled_base);color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){:host.ids-highlight-button:hover:not(:disabled):not([aria-disabled=true]),:host.ids-highlight-button:focus-visible:not(:disabled):not([aria-disabled=true]),.ids-highlight-button:hover:not(:disabled):not([aria-disabled=true]),.ids-highlight-button:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_primary_variant)}}:host.ids-highlight-button:active:not(:disabled):not([aria-disabled=true]),.ids-highlight-button:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_primary_variant)}:host.ids-highlight-button__content,.ids-highlight-button__content{align-items:flex-start;display:flex;flex-direction:column;gap:var(--ids_size_general_8x);height:100%;justify-content:space-between;left:0;padding:var(--ids_size_general_10x);position:absolute;top:0;width:100%}:host.ids-highlight-button--secondary,.ids-highlight-button--secondary{background-color:var(--ids_color_action_secondary_base);border-color:var(--ids_color_action_secondary_variant)}:host.ids-highlight-button--secondary:disabled,:host.ids-highlight-button--secondary[aria-disabled=true],.ids-highlight-button--secondary:disabled,.ids-highlight-button--secondary[aria-disabled=true]{background-color:var(--ids_color_bg_base);border-color:var(--ids_color_action_disabled_base);color:var(--ids_color_action_disabled_variant)}@media (hover: hover) and (pointer: fine){:host.ids-highlight-button--secondary:hover:not(:disabled):not([aria-disabled=true]),:host.ids-highlight-button--secondary:focus-visible:not(:disabled):not([aria-disabled=true]),.ids-highlight-button--secondary:hover:not(:disabled):not([aria-disabled=true]),.ids-highlight-button--secondary:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_secondary_variant)}}:host.ids-highlight-button--secondary:active:not(:disabled):not([aria-disabled=true]),.ids-highlight-button--secondary:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_secondary_variant)}:host.ids-highlight-button--neutral,.ids-highlight-button--neutral{background-color:var(--ids_color_bg_base);border-color:var(--ids_color_action_neutral_base);color:var(--ids_color_action_neutral_base)}:host.ids-highlight-button--neutral:disabled,:host.ids-highlight-button--neutral[aria-disabled=true],.ids-highlight-button--neutral:disabled,.ids-highlight-button--neutral[aria-disabled=true]{background-color:var(--ids_color_bg_base);border-color:var(--ids_color_action_disabled_variant);color:var(--ids_color_action_disabled_variant)}@media (hover: hover) and (pointer: fine){:host.ids-highlight-button--neutral:hover:not(:disabled):not([aria-disabled=true]),:host.ids-highlight-button--neutral:focus-visible:not(:disabled):not([aria-disabled=true]),.ids-highlight-button--neutral:hover:not(:disabled):not([aria-disabled=true]),.ids-highlight-button--neutral:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft);border-color:var(--ids_color_action_neutral_variant);color:var(--ids_color_action_neutral_variant)}}:host.ids-highlight-button--neutral:active:not(:disabled):not([aria-disabled=true]),.ids-highlight-button--neutral:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft);border-color:var(--ids_color_action_neutral_variant);color:var(--ids_color_action_neutral_variant)}:host.ids-highlight-button--on-brand,.ids-highlight-button--on-brand{background-color:transparent;border-color:var(--ids_color_contrast_onBrand_primary);color:var(--ids_color_contrast_onBrand_primary)}:host.ids-highlight-button--on-brand:disabled,:host.ids-highlight-button--on-brand[aria-disabled=true],.ids-highlight-button--on-brand:disabled,.ids-highlight-button--on-brand[aria-disabled=true]{background-color:transparent;border-color:var(--ids_color_contrast_onBrand_primary_medium);color:var(--ids_color_contrast_onBrand_primary_medium)}@media (hover: hover) and (pointer: fine){:host.ids-highlight-button--on-brand:hover:not(:disabled):not([aria-disabled=true]),:host.ids-highlight-button--on-brand:focus-visible:not(:disabled):not([aria-disabled=true]),.ids-highlight-button--on-brand:hover:not(:disabled):not([aria-disabled=true]),.ids-highlight-button--on-brand:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_contrast_onBrand_primary_soft);border-color:var(--ids_color_contrast_onBrand_primary);color:var(--ids_color_contrast_onBrand_primary_strong)}}:host.ids-highlight-button--on-brand:active:not(:disabled):not([aria-disabled=true]),.ids-highlight-button--on-brand:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_contrast_onBrand_primary_soft);border-color:var(--ids_color_contrast_onBrand_primary);color:var(--ids_color_contrast_onBrand_primary_strong)}:host.ids-highlight-button--large,.ids-highlight-button--large{font:var(--ids_textStyle_f02_s16_h24_wrg)}:host.ids-highlight-button--large .ids-highlight-button__content,.ids-highlight-button--large .ids-highlight-button__content{padding:var(--ids_size_general_16x)}:host.ids-highlight-button--large .ids-icon,.ids-highlight-button--large .ids-icon{font:var(--ids_textStyle_icon_large)}:host.ids-highlight-button--large ::ng-deep .ids-icon,.ids-highlight-button--large ::ng-deep .ids-icon{font:var(--ids_textStyle_icon_large)}:host.ids-highlight-button--rectangular:before,.ids-highlight-button--rectangular:before{padding-bottom:calc(50% - var(--ids_size_general_1x))}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsHighlightButtonComponent, decorators: [{
            type: Component,
            args: [{ host: {
                        '[class.ids-highlight-button]': 'true',
                        '[class.ids-highlight-button--neutral]': 'variant === "neutral"',
                        '[class.ids-highlight-button--rectangular]': 'aspectRatio === "2:1"',
                        '[class.ids-highlight-button--secondary]': 'variant === "secondary"',
                        '[class.ids-highlight-button--on-brand]': 'contrast === "onBrand"',
                        '[class.ids-highlight-button--large]': 'size === "L"',
                    }, selector: '[idsHighlightButton]', standalone: true, template: `<span class="ids-highlight-button__content">
    <ng-content></ng-content>
  </span>`, styles: [":host.ids-highlight-button,.ids-highlight-button{all:unset;all:revert;box-sizing:border-box;-webkit-user-select:none;user-select:none;align-items:center;background:var(--ids_color_action_primary_base);border-color:var(--ids_color_action_primary_variant);border-radius:var(--ids_size_cornerRadius_card_01);border-style:solid;border-width:var(--ids_size_border_small);color:var(--ids_color_action_primary_contrast);cursor:pointer;display:inline-flex;font:var(--ids_textStyle_f02_s14_h20_wrg);justify-content:center;min-height:var(--ids_size_general_24x);outline-offset:var(--ids_size_general_4x);padding:0;position:relative;text-align:left;text-decoration:none;width:100%}@media (pointer: coarse){:host.ids-highlight-button,.ids-highlight-button{outline:0!important}:host.ids-highlight-button:focus,.ids-highlight-button:focus{outline:0!important}}@media (pointer: coarse) and (pointer: fine){:host.ids-highlight-button:focus-visible,:host.ids-highlight-button:focus.focus-visible,.ids-highlight-button:focus-visible,.ids-highlight-button:focus.focus-visible{outline:0!important}}@media (pointer: fine){:host.ids-highlight-button:focus-visible,:host.ids-highlight-button:focus.focus-visible,.ids-highlight-button:focus-visible,.ids-highlight-button:focus.focus-visible{outline:revert!important}}@media (pointer: fine) and (pointer: fine){:host.ids-highlight-button:focus-visible,:host.ids-highlight-button:focus.focus-visible,.ids-highlight-button:focus-visible,.ids-highlight-button:focus.focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}}:host.ids-highlight-button:before,.ids-highlight-button:before{content:\"\";display:block;padding-bottom:100%}:host.ids-highlight-button .ids-icon,.ids-highlight-button .ids-icon{font:var(--ids_textStyle_icon_medium);line-height:inherit}:host.ids-highlight-button ::ng-deep .ids-icon,.ids-highlight-button ::ng-deep .ids-icon{font:var(--ids_textStyle_icon_medium);line-height:inherit}:host.ids-highlight-button:disabled,:host.ids-highlight-button[aria-disabled=true],.ids-highlight-button:disabled,.ids-highlight-button[aria-disabled=true]{background-color:var(--ids_color_action_disabled_base);border-color:var(--ids_color_action_disabled_base);color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){:host.ids-highlight-button:hover:not(:disabled):not([aria-disabled=true]),:host.ids-highlight-button:focus-visible:not(:disabled):not([aria-disabled=true]),.ids-highlight-button:hover:not(:disabled):not([aria-disabled=true]),.ids-highlight-button:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_primary_variant)}}:host.ids-highlight-button:active:not(:disabled):not([aria-disabled=true]),.ids-highlight-button:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_primary_variant)}:host.ids-highlight-button__content,.ids-highlight-button__content{align-items:flex-start;display:flex;flex-direction:column;gap:var(--ids_size_general_8x);height:100%;justify-content:space-between;left:0;padding:var(--ids_size_general_10x);position:absolute;top:0;width:100%}:host.ids-highlight-button--secondary,.ids-highlight-button--secondary{background-color:var(--ids_color_action_secondary_base);border-color:var(--ids_color_action_secondary_variant)}:host.ids-highlight-button--secondary:disabled,:host.ids-highlight-button--secondary[aria-disabled=true],.ids-highlight-button--secondary:disabled,.ids-highlight-button--secondary[aria-disabled=true]{background-color:var(--ids_color_bg_base);border-color:var(--ids_color_action_disabled_base);color:var(--ids_color_action_disabled_variant)}@media (hover: hover) and (pointer: fine){:host.ids-highlight-button--secondary:hover:not(:disabled):not([aria-disabled=true]),:host.ids-highlight-button--secondary:focus-visible:not(:disabled):not([aria-disabled=true]),.ids-highlight-button--secondary:hover:not(:disabled):not([aria-disabled=true]),.ids-highlight-button--secondary:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_secondary_variant)}}:host.ids-highlight-button--secondary:active:not(:disabled):not([aria-disabled=true]),.ids-highlight-button--secondary:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_secondary_variant)}:host.ids-highlight-button--neutral,.ids-highlight-button--neutral{background-color:var(--ids_color_bg_base);border-color:var(--ids_color_action_neutral_base);color:var(--ids_color_action_neutral_base)}:host.ids-highlight-button--neutral:disabled,:host.ids-highlight-button--neutral[aria-disabled=true],.ids-highlight-button--neutral:disabled,.ids-highlight-button--neutral[aria-disabled=true]{background-color:var(--ids_color_bg_base);border-color:var(--ids_color_action_disabled_variant);color:var(--ids_color_action_disabled_variant)}@media (hover: hover) and (pointer: fine){:host.ids-highlight-button--neutral:hover:not(:disabled):not([aria-disabled=true]),:host.ids-highlight-button--neutral:focus-visible:not(:disabled):not([aria-disabled=true]),.ids-highlight-button--neutral:hover:not(:disabled):not([aria-disabled=true]),.ids-highlight-button--neutral:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft);border-color:var(--ids_color_action_neutral_variant);color:var(--ids_color_action_neutral_variant)}}:host.ids-highlight-button--neutral:active:not(:disabled):not([aria-disabled=true]),.ids-highlight-button--neutral:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft);border-color:var(--ids_color_action_neutral_variant);color:var(--ids_color_action_neutral_variant)}:host.ids-highlight-button--on-brand,.ids-highlight-button--on-brand{background-color:transparent;border-color:var(--ids_color_contrast_onBrand_primary);color:var(--ids_color_contrast_onBrand_primary)}:host.ids-highlight-button--on-brand:disabled,:host.ids-highlight-button--on-brand[aria-disabled=true],.ids-highlight-button--on-brand:disabled,.ids-highlight-button--on-brand[aria-disabled=true]{background-color:transparent;border-color:var(--ids_color_contrast_onBrand_primary_medium);color:var(--ids_color_contrast_onBrand_primary_medium)}@media (hover: hover) and (pointer: fine){:host.ids-highlight-button--on-brand:hover:not(:disabled):not([aria-disabled=true]),:host.ids-highlight-button--on-brand:focus-visible:not(:disabled):not([aria-disabled=true]),.ids-highlight-button--on-brand:hover:not(:disabled):not([aria-disabled=true]),.ids-highlight-button--on-brand:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_contrast_onBrand_primary_soft);border-color:var(--ids_color_contrast_onBrand_primary);color:var(--ids_color_contrast_onBrand_primary_strong)}}:host.ids-highlight-button--on-brand:active:not(:disabled):not([aria-disabled=true]),.ids-highlight-button--on-brand:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_contrast_onBrand_primary_soft);border-color:var(--ids_color_contrast_onBrand_primary);color:var(--ids_color_contrast_onBrand_primary_strong)}:host.ids-highlight-button--large,.ids-highlight-button--large{font:var(--ids_textStyle_f02_s16_h24_wrg)}:host.ids-highlight-button--large .ids-highlight-button__content,.ids-highlight-button--large .ids-highlight-button__content{padding:var(--ids_size_general_16x)}:host.ids-highlight-button--large .ids-icon,.ids-highlight-button--large .ids-icon{font:var(--ids_textStyle_icon_large)}:host.ids-highlight-button--large ::ng-deep .ids-icon,.ids-highlight-button--large ::ng-deep .ids-icon{font:var(--ids_textStyle_icon_large)}:host.ids-highlight-button--rectangular:before,.ids-highlight-button--rectangular:before{padding-bottom:calc(50% - var(--ids_size_general_1x))}\n"] }]
        }], propDecorators: { aspectRatio: [{
                type: Input
            }], variant: [{
                type: Input
            }], contrast: [{
                type: Input
            }], size: [{
                type: Input
            }] } });

class IdsHighlightButtonModule {
}
IdsHighlightButtonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsHighlightButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsHighlightButtonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsHighlightButtonModule, imports: [IdsHighlightButtonComponent], exports: [IdsHighlightButtonComponent] });
IdsHighlightButtonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsHighlightButtonModule, imports: [IdsHighlightButtonComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsHighlightButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsHighlightButtonComponent],
                    exports: [IdsHighlightButtonComponent],
                }]
        }] });

class IdsInputModule {
}
IdsInputModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsInputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsInputModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsInputModule, imports: [IdsInputDirective], exports: [IdsInputDirective] });
IdsInputModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsInputModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsInputModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsInputDirective],
                    exports: [IdsInputDirective],
                }]
        }] });

/**
 * O IdsInputSearchModule foi desenvolvido para ser utilizado em conjunto com o componente de input text,
 *
 * **Module:**
 *
 * `import { IdsInputSearchModule } from '@ids/angular';`
 *
 * **Component:**
 *
 * `import { IdsInputSearchComponent } from '@ids/angular';`
 */
class IdsInputSearchComponent {
    /**
     * Define a label do botão de limpar o campo de busca que será lida pelos leitores de tela.
     *
     * *Defines a search bar's label that will be read on screen reader*
     */
    set clearButtonLabel(value) {
        this._clearButtonLabel = value;
    }
    get clearButtonLabel() {
        return this._clearButtonLabel;
    }
    /**
     * Define a mensagem para o leitor de telas que será lida após a limpeza do campo
     *
     * *Defines a message for screen readers that will be read after the field is clean *
     */
    set cleanNotice(value) {
        this._cleanNotice = value;
    }
    get cleanNotice() {
        return this._cleanNotice;
    }
    constructor(_la) {
        this._la = _la;
        this._clearButtonLabel = 'limpar';
        this._cleanNotice = 'campo de texto limpo';
        /** Evento emitido ao limpar o campo */
        this.cleared = new EventEmitter();
    }
    ngAfterContentInit() {
        if (this.field) {
            this.field.noStyles = true;
        }
        /* istanbul ignore next */
        if (this.suffix) {
            this.suffix.contrast = this.contrast;
        }
    }
    _clearField() {
        if (this.field.ngControl) {
            this.field.ngControl.reset('');
            return;
        }
        this.field.value = '';
        this.field.nativeElement.value = '';
    }
    clearInput() {
        this._clearField();
        this._la.announce(this.cleanNotice, 1000);
        this.cleared.emit();
        // * No talkback, o foco se perdia ao limpar o campo, apenas com settimeout de
        // * 1ms que foi possível fazer o foco voltar pro input
        setTimeout(() => {
            this.field.nativeElement.focus();
        }, 10);
    }
}
IdsInputSearchComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsInputSearchComponent, deps: [{ token: i1$1.LiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component });
IdsInputSearchComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsInputSearchComponent, isStandalone: true, selector: "ids-input-search", inputs: { clearButtonLabel: "clearButtonLabel", cleanNotice: "cleanNotice", contrast: "contrast", variant: "variant" }, outputs: { cleared: "cleared" }, queries: [{ propertyName: "field", first: true, predicate: IdsInputDirective, descendants: true }, { propertyName: "suffix", first: true, predicate: IdsIconButtonComponent, descendants: true }], ngImport: i0, template: "<div\n  class=\"ids-box-field ids-box-field--suffix\"\n  [class.ids-box-field--on-brand]=\"contrast === 'onBrand'\"\n>\n  <!-- Inserido aria-label pois o aria-hidden n\u00E3o funcionou para talkback/NVDA  -->\n  <div class=\"ids-box-field__prefix\">\n    <ids-icon [contrast]=\"contrast\">busca_outline</ids-icon>\n  </div>\n\n  <ng-content select=\"[idsInput]\"></ng-content>\n\n  <div class=\"ids-box-field__suffix\">\n    <button\n      idsIconButton\n      variant=\"neutral\"\n      size=\"S\"\n      [contrast]=\"contrast\"\n      *ngIf=\"field?.value; else templateButton\"\n      [attr.title]=\"clearButtonLabel\"\n      (click)=\"clearInput()\"\n      type=\"button\"\n    >\n      fechar\n    </button>\n\n    <ng-template #templateButton>\n      <ng-content select=\"button\"></ng-content>\n    </ng-template>\n  </div>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: IdsMainButtonModule }, { kind: "ngmodule", type: IdsFormFieldModule }, { kind: "ngmodule", type: IdsInputModule }, { kind: "ngmodule", type: IdsIconModule }, { kind: "component", type: IdsIconComponent, selector: "ids-icon", inputs: ["size", "variant", "contrast"] }, { kind: "ngmodule", type: IdsIconButtonModule }, { kind: "component", type: IdsIconButtonComponent, selector: "[idsIconButton]", inputs: ["variant", "contrast", "size", "title", "aria-label"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsInputSearchComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-input-search', standalone: true, imports: [
                        CommonModule,
                        IdsMainButtonModule,
                        IdsFormFieldModule,
                        IdsInputModule,
                        IdsIconModule,
                        IdsIconButtonModule,
                    ], encapsulation: ViewEncapsulation.None, template: "<div\n  class=\"ids-box-field ids-box-field--suffix\"\n  [class.ids-box-field--on-brand]=\"contrast === 'onBrand'\"\n>\n  <!-- Inserido aria-label pois o aria-hidden n\u00E3o funcionou para talkback/NVDA  -->\n  <div class=\"ids-box-field__prefix\">\n    <ids-icon [contrast]=\"contrast\">busca_outline</ids-icon>\n  </div>\n\n  <ng-content select=\"[idsInput]\"></ng-content>\n\n  <div class=\"ids-box-field__suffix\">\n    <button\n      idsIconButton\n      variant=\"neutral\"\n      size=\"S\"\n      [contrast]=\"contrast\"\n      *ngIf=\"field?.value; else templateButton\"\n      [attr.title]=\"clearButtonLabel\"\n      (click)=\"clearInput()\"\n      type=\"button\"\n    >\n      fechar\n    </button>\n\n    <ng-template #templateButton>\n      <ng-content select=\"button\"></ng-content>\n    </ng-template>\n  </div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i1$1.LiveAnnouncer }]; }, propDecorators: { clearButtonLabel: [{
                type: Input
            }], cleanNotice: [{
                type: Input
            }], contrast: [{
                type: Input
            }], variant: [{
                type: Input
            }], cleared: [{
                type: Output
            }], field: [{
                type: ContentChild,
                args: [IdsInputDirective]
            }], suffix: [{
                type: ContentChild,
                args: [IdsIconButtonComponent]
            }] } });

class IdsInputSearchModule {
}
IdsInputSearchModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsInputSearchModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsInputSearchModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsInputSearchModule, imports: [IdsInputSearchComponent], exports: [IdsInputSearchComponent] });
IdsInputSearchModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsInputSearchModule, imports: [IdsInputSearchComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsInputSearchModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsInputSearchComponent],
                    exports: [IdsInputSearchComponent],
                }]
        }] });

let NEXT_ID$a = 0;
class IdsLikeComponent {
    constructor() {
        /**
         * Variável que define o id do componente
         *
         * *Variable that defines the id of the component*
         */
        this.id = `ids-like-${++NEXT_ID$a}`;
        this._hostId = null;
        /**
         * Variavel que define o aria-label do botão like
         *
         * *Variable that defines the aria-label of the button like*
         */
        this.ariaLabelLike = 'Curtir conteúdo';
        /**
         * Variavel que define o aria-label do botão dislike
         *
         * *Variable that defines the aria-label of the button dislike*
         */
        this.ariaLabelDislike = 'Não curtir conteúdo';
        /**
         * Emite o evento quando o componente tem seu valor alterado
         *
         * *Emits the event when the component has its value changed*
         */
        this.valueChange = new EventEmitter();
        /**
         * Evento disparado quando o componente recebe foco.
         *
         * *Event triggered when component receive focus.*
         */
        this.focus = new EventEmitter();
        /**
         * Evento disparado quando o componente perde o foco.
         *
         * *Event triggered when component loses focus.*
         */
        this.blur = new EventEmitter();
        // eslint-disable-next-line
        this._onChange = (_) => { };
        // eslint-disable-next-line
        this._onTouched = () => { };
    }
    /**
     * Define se o botão está desabilitado
     *
     * *sets whether the button is disabled*
     */
    set disabled(disabled) {
        this._disabled = enforceBoolean(disabled);
    }
    get disabled() {
        return this._disabled;
    }
    /**
     * Variável que define o valor do botão selecionado
     *
     * *Variable that defines of the selected button*
     */
    set value(value) {
        if (this.value === value) {
            return;
        }
        this._value = value;
        this.emitChange(this._value);
    }
    get value() {
        return this._value;
    }
    emitChange(option) {
        this.value = option;
        this._onChange(this.value);
        this.valueChange.emit(this.value);
    }
    onBlur() {
        this._onTouched();
        this.blur.emit(this.value);
    }
    onFocus() {
        this.focus.emit(this.value);
    }
    onSelect(option) {
        this.value = this.value === option ? undefined : option;
    }
    writeValue(value) {
        this.value = value;
    }
    registerOnChange(fn) {
        this._onChange = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
}
IdsLikeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsLikeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IdsLikeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsLikeComponent, isStandalone: true, selector: "ids-like", inputs: { id: "id", ariaLabelLike: "ariaLabelLike", ariaLabelDislike: "ariaLabelDislike", disabled: "disabled", value: "value" }, outputs: { valueChange: "valueChange", focus: "focus", blur: "blur" }, host: { properties: { "attr.id": "this._hostId" } }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: IdsLikeComponent,
        },
    ], ngImport: i0, template: "<!-- Com componente -->\n<fieldset class=\"ids-like\" [disabled]=\"disabled\">\n  <button\n    [attr.aria-label]=\"ariaLabelLike\"\n    [attr.aria-checked]=\"value === 'like'\"\n    class=\"ids-like__button\"\n    (click)=\"onSelect('like')\"\n    (focus)=\"onFocus()\"\n    (blur)=\"onBlur()\"\n    [id]=\"id + '-like-button'\"\n    role=\"radio\"\n    type=\"button\"\n    value=\"like\"\n  >\n    <ids-icon>{{ value === 'like' ? 'curtir' : 'curtir_outline' }}</ids-icon>\n  </button>\n\n  <button\n    [attr.aria-label]=\"ariaLabelDislike\"\n    [attr.aria-checked]=\"value === 'dislike'\"\n    class=\"ids-like__button\"\n    (click)=\"onSelect('dislike')\"\n    (focus)=\"onFocus()\"\n    (blur)=\"onBlur()\"\n    [id]=\"id + '-dislike-button'\"\n    role=\"radio\"\n    type=\"button\"\n    value=\"dislike\"\n  >\n    <ids-icon>{{ value === 'dislike' ? 'descurtiror' : 'descurtir_outline' }}</ids-icon>\n  </button>\n</fieldset>\n", styles: [".ids-like{display:flex;gap:var(--ids_size_general_24x)}.ids-like__legend{color:var(--ids_color_action_neutral_base);font:var(--ids_textStyle_f01_s24_h32_wrg)}.ids-like__button{align-items:center;-webkit-appearance:none;appearance:none;background:none;border:0;cursor:pointer;display:flex;font-size:0;height:var(--ids_size_general_48x);justify-content:center;width:var(--ids_size_general_48x)}.ids-like__button:not(:disabled) .ids-icon{color:inherit}.ids-like__button:disabled{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}.ids-like__button:not(:disabled)[aria-checked=true]{animation:color-me-in 175ms linear;color:var(--ids_color_action_primary_base)}.ids-like__button[aria-checked=false]{animation:color-me-out .15s linear}.ids-like__button:not(:disabled,[aria-invalid]):hover{color:var(--ids_color_action_neutral_variant)}.ids-like__button[aria-checked=true]:not(:disabled):hover{color:var(--ids_color_action_primary_variant)}@keyframes color-me-in{0%{opacity:.3}to{opacity:1}}@keyframes color-me-out{0%{opacity:.2}to{opacity:1}}\n"], dependencies: [{ kind: "ngmodule", type: IdsIconModule }, { kind: "component", type: IdsIconComponent, selector: "ids-icon", inputs: ["size", "variant", "contrast"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsLikeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-like', standalone: true, imports: [IdsIconModule], providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            multi: true,
                            useExisting: IdsLikeComponent,
                        },
                    ], template: "<!-- Com componente -->\n<fieldset class=\"ids-like\" [disabled]=\"disabled\">\n  <button\n    [attr.aria-label]=\"ariaLabelLike\"\n    [attr.aria-checked]=\"value === 'like'\"\n    class=\"ids-like__button\"\n    (click)=\"onSelect('like')\"\n    (focus)=\"onFocus()\"\n    (blur)=\"onBlur()\"\n    [id]=\"id + '-like-button'\"\n    role=\"radio\"\n    type=\"button\"\n    value=\"like\"\n  >\n    <ids-icon>{{ value === 'like' ? 'curtir' : 'curtir_outline' }}</ids-icon>\n  </button>\n\n  <button\n    [attr.aria-label]=\"ariaLabelDislike\"\n    [attr.aria-checked]=\"value === 'dislike'\"\n    class=\"ids-like__button\"\n    (click)=\"onSelect('dislike')\"\n    (focus)=\"onFocus()\"\n    (blur)=\"onBlur()\"\n    [id]=\"id + '-dislike-button'\"\n    role=\"radio\"\n    type=\"button\"\n    value=\"dislike\"\n  >\n    <ids-icon>{{ value === 'dislike' ? 'descurtiror' : 'descurtir_outline' }}</ids-icon>\n  </button>\n</fieldset>\n", styles: [".ids-like{display:flex;gap:var(--ids_size_general_24x)}.ids-like__legend{color:var(--ids_color_action_neutral_base);font:var(--ids_textStyle_f01_s24_h32_wrg)}.ids-like__button{align-items:center;-webkit-appearance:none;appearance:none;background:none;border:0;cursor:pointer;display:flex;font-size:0;height:var(--ids_size_general_48x);justify-content:center;width:var(--ids_size_general_48x)}.ids-like__button:not(:disabled) .ids-icon{color:inherit}.ids-like__button:disabled{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}.ids-like__button:not(:disabled)[aria-checked=true]{animation:color-me-in 175ms linear;color:var(--ids_color_action_primary_base)}.ids-like__button[aria-checked=false]{animation:color-me-out .15s linear}.ids-like__button:not(:disabled,[aria-invalid]):hover{color:var(--ids_color_action_neutral_variant)}.ids-like__button[aria-checked=true]:not(:disabled):hover{color:var(--ids_color_action_primary_variant)}@keyframes color-me-in{0%{opacity:.3}to{opacity:1}}@keyframes color-me-out{0%{opacity:.2}to{opacity:1}}\n"] }]
        }], propDecorators: { id: [{
                type: Input
            }], _hostId: [{
                type: HostBinding,
                args: ['attr.id']
            }], ariaLabelLike: [{
                type: Input
            }], ariaLabelDislike: [{
                type: Input
            }], disabled: [{
                type: Input
            }], value: [{
                type: Input
            }], valueChange: [{
                type: Output
            }], focus: [{
                type: Output
            }], blur: [{
                type: Output
            }] } });

class IdsLikeModule {
}
IdsLikeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsLikeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsLikeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsLikeModule, imports: [IdsLikeComponent], exports: [IdsLikeComponent] });
IdsLikeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsLikeModule, imports: [IdsLikeComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsLikeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsLikeComponent],
                    exports: [IdsLikeComponent],
                }]
        }] });

/**
 * Permite que url dinâmicas de imagens sejam usadas no HTML.
 *
 * **Module:**
 *
 * `import { SanitizeUrlModule } from '@ids/angular';`
 *
 * **Pipe:**
 *
 * `import { SanitizeUrlPipe } from '@ids/angular;`
 *
 * @example
 * <img [src]="'https://example.com/image.jpg' | sanitizeUrl" />
 * <!-- Result: <img src="https://example.com/image.jpg" /> -->
 */
class SanitizeUrlPipe {
    constructor(domSanitizer) {
        this.domSanitizer = domSanitizer;
    }
    transform(url) {
        return this.domSanitizer.bypassSecurityTrustUrl(url);
    }
}
SanitizeUrlPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SanitizeUrlPipe, deps: [{ token: i1$5.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
SanitizeUrlPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: SanitizeUrlPipe, name: "sanitizeUrl" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SanitizeUrlPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'sanitizeUrl' }]
        }], ctorParameters: function () { return [{ type: i1$5.DomSanitizer }]; } });

class SanitizeUrlModule {
}
SanitizeUrlModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SanitizeUrlModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
SanitizeUrlModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: SanitizeUrlModule, declarations: [SanitizeUrlPipe], exports: [SanitizeUrlPipe] });
SanitizeUrlModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SanitizeUrlModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: SanitizeUrlModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SanitizeUrlPipe],
                    exports: [SanitizeUrlPipe],
                }]
        }] });

/**
 * Transforma o texto em kebab-case.
 *
 * **Module:**
 *
 * `import { KebabCaseModule } from '@ids/angular';`
 *
 * **Pipe:**
 *
 * `import { KebabCasePipe } from '@ids/angular;`
 *
 * @example
 * <span>{{ 'Hello World' | kebabCase }}</span>
 * <!-- Result: hello-world -->
 */
class KebabCasePipe {
    transform(text) {
        return toKebabCase(text);
    }
}
KebabCasePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: KebabCasePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
KebabCasePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: KebabCasePipe, name: "kebabCase" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: KebabCasePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'kebabCase' }]
        }] });

class KebabCaseModule {
}
KebabCaseModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: KebabCaseModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
KebabCaseModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: KebabCaseModule, declarations: [KebabCasePipe], exports: [KebabCasePipe] });
KebabCaseModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: KebabCaseModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: KebabCaseModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [KebabCasePipe],
                    exports: [KebabCasePipe],
                }]
        }] });

let NEXT_ID$9 = 1;
/**
 * Likert é um elemento baseado numa escala de pesquisa que combina estatística à psicologia,
 * para extrair insights qualitativos a partir de uma pergunta estruturada de forma quantitativa.
 * Utilizamos para avaliar a experiência do usuário referente a um fluxo.
 *
 * *Likert is an element based on a research scale that combines statistics with psychology*
 * *to extract qualitative insights from a quantitatively structured question.*
 * *We use it to assess the user experience for a flow.*
 *
 *  **Module:**
 *
 * `import { IdsLikertModule } from '@ids/angular';`
 *
 * <example-url>../../demo/index.html#/portfolio/likert?componentOnly=true</example-url>
 */
class IdsLikertComponent {
    constructor() {
        /**
         * Define o idioma
         *
         * lang = 'pt'
         *
         * lang = 'en'
         *
         * lang = 'es'
         */
        this.lang = 'pt-BR';
        /**
         * Define o gênero
         *
         * gender = 'male'
         *
         * gender = 'female'
         */
        this.gender = 'male';
        /**
         * Variavel que define o id do componente
         *
         * *Variable that defines the id of the component*
         */
        this.id = `ids-likert-${NEXT_ID$9++}`;
        /**
         * Evento de resposta do likert
         *
         * *Likert response event*
         *
         * {key: "good", value: "bom"}
         */
        this.change = new EventEmitter();
        /**
         * Evento disparado com o focus no likert.
         *
         * *Event triggered with focus on likert.*
         */
        this.focus = new EventEmitter();
        /**
         * Evento disparado com o blur no likert.
         *
         * *Event triggered with blur on likert.*
         */
        this.blur = new EventEmitter();
        // eslint-disable-next-line
        this._onChange = (_) => { };
        // eslint-disable-next-line
        this._onTouched = () => { };
    }
    get options() {
        if (this._options) {
            return this._options;
        }
        this._options = OPTIONS_BY_LANGUAGE[this.lang].map((option) => ({
            ...option,
            value: Array.isArray(option.value)
                ? this.gender === 'female'
                    ? option.value[1]
                    : option.value[0]
                : option.value,
        }));
        return this._options;
    }
    onFocus() {
        this.focus.emit();
    }
    onBlur() {
        this._onTouched();
        this.blur.emit();
    }
    onChange(optionKey) {
        this.value = optionKey;
        this._onChange(optionKey);
        this.change.emit(optionKey);
    }
    writeValue(value) {
        this.value = value;
    }
    registerOnChange(fn) {
        this._onChange = fn;
    }
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
}
IdsLikertComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsLikertComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IdsLikertComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsLikertComponent, isStandalone: true, selector: "ids-likert", inputs: { lang: "lang", gender: "gender", contrast: "contrast", value: "value", id: "id" }, outputs: { change: "change", focus: "focus", blur: "blur" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: IdsLikertComponent,
        },
    ], ngImport: i0, template: "<fieldset\n  class=\"ids-likert\"\n  [id]=\"id\"\n  [lang]=\"lang\"\n  [class.ids-likert--on-brand]=\"contrast === 'onBrand'\"\n>\n  <legend class=\"ids-label\">\n    <ng-content></ng-content>\n  </legend>\n\n  <div class=\"ids-likert__list\">\n    <button\n      *ngFor=\"let option of options\"\n      type=\"button\"\n      class=\"ids-likert-item\"\n      [class.ids-likert-item--on-brand]=\"contrast === 'onBrand'\"\n      [class.ids-likert-item--selected]=\"value === option?.key\"\n      [id]=\"id + '-' + (option.key | kebabCase)\"\n      role=\"radio\"\n      [attr.aria-checked]=\"option.key === value\"\n      (click)=\"onChange(option.key)\"\n      (focus)=\"onFocus()\"\n      (blur)=\"onBlur()\"\n    >\n      <img\n        class=\"ids-likert-item__face\"\n        aria-hidden=\"true\"\n        [src]=\"option.face | sanitizeUrl\"\n        [style]=\"{ 'margin-left': option.key === 'bad' && '-1px' }\"\n      />\n\n      <span class=\"ids-likert-item__name\">\n        {{ option.value }}\n      </span>\n    </button>\n  </div>\n</fieldset>\n", styles: [".ids-likert-item{all:unset;all:revert;box-sizing:border-box;padding:0;-webkit-user-select:none;user-select:none;align-items:center;background:none;border:none;color:var(--ids_color_action_neutral_base);cursor:pointer;display:flex;flex:1;flex-direction:column;font:var(--ids_textStyle_f02_s14_h20_wrg);padding:0 var(--ids_size_general_6x);position:relative}@media (pointer: coarse){.ids-likert-item{outline:0!important}.ids-likert-item:focus{outline:0!important}}@media (pointer: coarse) and (pointer: fine){.ids-likert-item:focus-visible,.ids-likert-item:focus.focus-visible{outline:0!important}}@media (pointer: fine){.ids-likert-item:focus-visible,.ids-likert-item:focus.focus-visible{outline:revert!important}}@media (pointer: fine) and (pointer: fine){.ids-likert-item:focus-visible,.ids-likert-item:focus.focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}}.ids-likert-item__face{box-sizing:border-box;height:1.5rem;margin-bottom:var(--ids_size_general_8x);position:relative;width:auto}.ids-likert-item--selected{font:var(--ids_textStyle_f02_s14_h20_wbd)}.ids-likert-item--selected:before{background-color:#000;border-radius:50%;box-sizing:border-box;content:\"\";display:block;height:1.75rem;position:absolute;top:-.125rem;width:1.75rem}.ids-likert-item--on-brand{color:var(--ids_color_contrast_onBrand_primary)}.ids-likert-item--on-brand.ids-likert-item--selected .ids-likert-item__face{border-color:var(--ids_color_contrast_onBrand_primary)}.ids-likert-item:hover{font:var(--ids_textStyle_f02_s14_h20_wbd)}.ids-likert{border:0;color:var(--ids_color_text_body_01);display:block;margin:0;overflow:hidden;padding:0}.ids-likert__list{display:flex;justify-content:space-around;margin:var(--ids_size_general_28x) 0}.ids-likert--on-brand .ids-label{color:var(--ids_color_contrast_onBrand_primary)}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "ngmodule", type: ReactiveFormsModule }, { kind: "ngmodule", type: KebabCaseModule }, { kind: "pipe", type: KebabCasePipe, name: "kebabCase" }, { kind: "ngmodule", type: SanitizeUrlModule }, { kind: "pipe", type: SanitizeUrlPipe, name: "sanitizeUrl" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsLikertComponent, decorators: [{
            type: Component,
            args: [{ imports: [CommonModule, ReactiveFormsModule, KebabCaseModule, SanitizeUrlModule], providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            multi: true,
                            useExisting: IdsLikertComponent,
                        },
                    ], selector: 'ids-likert', standalone: true, template: "<fieldset\n  class=\"ids-likert\"\n  [id]=\"id\"\n  [lang]=\"lang\"\n  [class.ids-likert--on-brand]=\"contrast === 'onBrand'\"\n>\n  <legend class=\"ids-label\">\n    <ng-content></ng-content>\n  </legend>\n\n  <div class=\"ids-likert__list\">\n    <button\n      *ngFor=\"let option of options\"\n      type=\"button\"\n      class=\"ids-likert-item\"\n      [class.ids-likert-item--on-brand]=\"contrast === 'onBrand'\"\n      [class.ids-likert-item--selected]=\"value === option?.key\"\n      [id]=\"id + '-' + (option.key | kebabCase)\"\n      role=\"radio\"\n      [attr.aria-checked]=\"option.key === value\"\n      (click)=\"onChange(option.key)\"\n      (focus)=\"onFocus()\"\n      (blur)=\"onBlur()\"\n    >\n      <img\n        class=\"ids-likert-item__face\"\n        aria-hidden=\"true\"\n        [src]=\"option.face | sanitizeUrl\"\n        [style]=\"{ 'margin-left': option.key === 'bad' && '-1px' }\"\n      />\n\n      <span class=\"ids-likert-item__name\">\n        {{ option.value }}\n      </span>\n    </button>\n  </div>\n</fieldset>\n", styles: [".ids-likert-item{all:unset;all:revert;box-sizing:border-box;padding:0;-webkit-user-select:none;user-select:none;align-items:center;background:none;border:none;color:var(--ids_color_action_neutral_base);cursor:pointer;display:flex;flex:1;flex-direction:column;font:var(--ids_textStyle_f02_s14_h20_wrg);padding:0 var(--ids_size_general_6x);position:relative}@media (pointer: coarse){.ids-likert-item{outline:0!important}.ids-likert-item:focus{outline:0!important}}@media (pointer: coarse) and (pointer: fine){.ids-likert-item:focus-visible,.ids-likert-item:focus.focus-visible{outline:0!important}}@media (pointer: fine){.ids-likert-item:focus-visible,.ids-likert-item:focus.focus-visible{outline:revert!important}}@media (pointer: fine) and (pointer: fine){.ids-likert-item:focus-visible,.ids-likert-item:focus.focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}}.ids-likert-item__face{box-sizing:border-box;height:1.5rem;margin-bottom:var(--ids_size_general_8x);position:relative;width:auto}.ids-likert-item--selected{font:var(--ids_textStyle_f02_s14_h20_wbd)}.ids-likert-item--selected:before{background-color:#000;border-radius:50%;box-sizing:border-box;content:\"\";display:block;height:1.75rem;position:absolute;top:-.125rem;width:1.75rem}.ids-likert-item--on-brand{color:var(--ids_color_contrast_onBrand_primary)}.ids-likert-item--on-brand.ids-likert-item--selected .ids-likert-item__face{border-color:var(--ids_color_contrast_onBrand_primary)}.ids-likert-item:hover{font:var(--ids_textStyle_f02_s14_h20_wbd)}.ids-likert{border:0;color:var(--ids_color_text_body_01);display:block;margin:0;overflow:hidden;padding:0}.ids-likert__list{display:flex;justify-content:space-around;margin:var(--ids_size_general_28x) 0}.ids-likert--on-brand .ids-label{color:var(--ids_color_contrast_onBrand_primary)}\n"] }]
        }], propDecorators: { lang: [{
                type: Input
            }], gender: [{
                type: Input
            }], contrast: [{
                type: Input
            }], value: [{
                type: Input
            }], id: [{
                type: Input
            }], change: [{
                type: Output
            }], focus: [{
                type: Output
            }], blur: [{
                type: Output
            }] } });

class IdsLikertModule {
}
IdsLikertModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsLikertModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsLikertModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsLikertModule, imports: [IdsLikertComponent], exports: [IdsLikertComponent] });
IdsLikertModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsLikertModule, imports: [IdsLikertComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsLikertModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsLikertComponent],
                    exports: [IdsLikertComponent],
                }]
        }] });

let NEXT_ID$8 = 0;
/**
 * Diretiva para utilização do RadioButton dentro do componente selector
 *
 * **Module:**
 *
 * `import { IdsRadioButtonModule } from '@ids/angular';`
 */
class IdsRadioButtonDirective extends IdsFormSelectionInputDirective {
    constructor() {
        super(...arguments);
        this._id = `ids-radio-button-${++NEXT_ID$8}`;
        this.inputClasses = 'ids-radio-button__input';
        this.type = 'radio';
    }
    get rootClasses() {
        return {
            'ids-radio-button': true,
            'ids-radio-button--invalid': this.invalid,
        };
    }
    get iconClasses() {
        return 'ids-radio-button__icon ids-icon ids-icon--medium';
    }
}
IdsRadioButtonDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsRadioButtonDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
IdsRadioButtonDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsRadioButtonDirective, isStandalone: true, selector: "[idsRadioButton]", host: { properties: { "class.ids-radio-button__input": "true", "attr.type": "\"radio\"", "attr.class": "this.inputClasses", "type": "this.type" } }, providers: [{ provide: IdsFormSelectionInputDirective, useExisting: IdsRadioButtonDirective }], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsRadioButtonDirective, decorators: [{
            type: Directive,
            args: [{
                    host: {
                        '[class.ids-radio-button__input]': 'true',
                        '[attr.type]': '"radio"',
                    },
                    providers: [{ provide: IdsFormSelectionInputDirective, useExisting: IdsRadioButtonDirective }],
                    selector: '[idsRadioButton]',
                    standalone: true,
                }]
        }], propDecorators: { inputClasses: [{
                type: HostBinding,
                args: ['attr.class']
            }], type: [{
                type: HostBinding
            }] } });

let NEXT_ID$7 = 0;
/**
 * Diretiva para utilização do Checkbox dentro do componente form selection
 *
 * **Module:**
 *
 * `import { IdsSwitchModule } from '@ids/angular';`
 */
class IdsSwitchDirective extends IdsFormSelectionInputDirective {
    constructor() {
        super(...arguments);
        this._id = `ids-switch-${++NEXT_ID$7}`;
        this.trigger = 0;
        this._rtlDirection = true;
    }
    get iconClasses() {
        return 'ids-switch__icon';
    }
    ngOnInit() {
        super.ngOnInit();
        this.rootClasses = {
            'ids-switch': true,
            'ids-switch--on-brand': this.contrast === 'onBrand',
        };
    }
    get ariaSelected() {
        return this.elementRef.nativeElement.checked;
    }
    input() {
        this.trigger = new Date().getTime();
    }
    keyup() {
        this.elementRef.nativeElement.click();
    }
}
IdsSwitchDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSwitchDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
IdsSwitchDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsSwitchDirective, isStandalone: true, selector: "[idsSwitch]", host: { listeners: { "input": "input()", "change": "input()", "keyup.enter": "keyup()" }, properties: { "class.ids-switch__input": "true", "attr.aria-labelledby": "ariaLabelledBy", "attr.aria-pressed": "ariaSelected", "attr.role": "\"button\"" } }, providers: [{ provide: IdsFormSelectionInputDirective, useExisting: IdsSwitchDirective }], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSwitchDirective, decorators: [{
            type: Directive,
            args: [{
                    host: {
                        '[class.ids-switch__input]': 'true',
                        '[attr.aria-labelledby]': 'ariaLabelledBy',
                        '[attr.aria-pressed]': 'ariaSelected',
                        '[attr.role]': '"button"',
                    },
                    providers: [{ provide: IdsFormSelectionInputDirective, useExisting: IdsSwitchDirective }],
                    selector: '[idsSwitch]',
                    standalone: true,
                }]
        }], propDecorators: { input: [{
                type: HostListener,
                args: ['input']
            }, {
                type: HostListener,
                args: ['change']
            }], keyup: [{
                type: HostListener,
                args: ['keyup.enter']
            }] } });

/**
 * Texto principal do item da lista.
 *
 * **Component:**
 *
 * `import { IdsListItemTextComponent } from '@ids/angular';`
 */
class IdsListItemTextComponent {
    get ariaHidden() {
        return this.isLabel ? 'true' : null;
    }
    get id() {
        if (!this.selectorId) {
            return null;
        }
        return this.selectorId + '-label-text';
    }
    get isLabel() {
        return this.elementRef.nativeElement.tagName === 'LABEL' || this.selectorId;
    }
    get for() {
        return this.isLabel ? this.selectorId : null;
    }
    constructor(elementRef, formSelectionService) {
        this.elementRef = elementRef;
        this.formSelectionService = formSelectionService;
        this.doubleLine = false;
        this.selectorId = '';
        this.destroy = new Subject();
        this.formSelectionService.inputIdSubject.pipe(takeUntil$1(this.destroy)).subscribe((id) => {
            this.selectorId = id;
            this.formSelectionService.setLabelId(this.id || '', 0);
        });
    }
    ngAfterContentInit() {
        if (!this.elementRef.nativeElement.nextElementSibling?.hasAttribute('idslisubtext')) {
            this.doubleLine = true;
        }
    }
    ngOnDestroy() {
        this.destroy.next();
        this.destroy.complete();
    }
}
IdsListItemTextComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsListItemTextComponent, deps: [{ token: i0.ElementRef }, { token: FormSelectionService }], target: i0.ɵɵFactoryTarget.Component });
IdsListItemTextComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsListItemTextComponent, isStandalone: true, selector: "[idsLiText]", host: { properties: { "class.ids-list-item__text": "true", "class.ids-list-item__text--double-line": "doubleLine", "attr.id": "id", "attr.for": "for", "attr.aria-hidden": "ariaHidden" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, styles: [".ids-list-item,:host.ids-list-item{--ids-list-item-label-width: minmax(15%, auto);--ids-list-item-description-width: fit-content(100%);all:unset;all:revert;background:var(--ids_color_bg_base);border:0;border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_soft);box-sizing:border-box;color:var(--ids_color_feedback_neutral);display:block;font:var(--ids_textStyle_f02_s16_h24_wbd);text-align:left;text-decoration:inherit;width:100%}.ids-list-item .ids-icon-button,:host.ids-list-item .ids-icon-button{margin-right:var(--ids_size_general_1x);min-height:auto;padding-bottom:0;padding-top:0}.ids-list-item ::ng-deep .ids-icon-button,:host.ids-list-item ::ng-deep .ids-icon-button{margin-right:var(--ids_size_general_1x);min-height:auto;padding-bottom:0;padding-top:0}.ids-list-item__content,:host.ids-list-item__content{all:unset;all:revert;align-items:center;box-sizing:border-box;display:grid;grid-template-areas:\"icon text description action\" \"icon sub-text sub-description action\";grid-template-columns:min-content var(--ids-list-item-label-width) var(--ids-list-item-description-width) min-content;min-height:3.9375rem;overflow:hidden;padding:var(--ids_size_general_16x) 0 calc(var(--ids_size_general_16x) - var(--ids_size_border_small))}.ids-list-item__content:has(.ids-list-item__sub-text),:host.ids-list-item__content:has(.ids-list-item__sub-text){min-height:4.9375rem}.ids-list-item__icon,:host.ids-list-item__icon{align-self:center;grid-area:icon;line-height:1;margin-right:var(--ids_size_general_16x);text-align:center}::ng-deep .ids-list-item__icon,::ng-deep :host.ids-list-item__icon{align-self:center;grid-area:icon;line-height:1;margin-right:var(--ids_size_general_16x);text-align:center}.ids-list-item__text,:host.ids-list-item__text{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;align-self:flex-end;grid-area:text;overflow:hidden}.ids-list-item__text--double-line,:host.ids-list-item__text--double-line{align-self:initial;grid-row:span 2}::ng-deep .ids-list-item__text,::ng-deep :host.ids-list-item__text{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;align-self:flex-end;grid-area:text;overflow:hidden}::ng-deep .ids-list-item__text--double-line,::ng-deep :host.ids-list-item__text--double-line{align-self:initial;grid-row:span 2}.ids-list-item__description,:host.ids-list-item__description{align-self:flex-end;grid-area:description;margin-left:var(--ids_size_general_8x);text-align:right}.ids-list-item__description:not(.ids-tag):not(.ids-number-badge),:host.ids-list-item__description:not(.ids-tag):not(.ids-number-badge){font:var(--ids_textStyle_f02_s16_h24_wrg)}.ids-list-item__description--double-line,:host.ids-list-item__description--double-line{align-self:initial;grid-row:span 2}::ng-deep .ids-list-item__description,::ng-deep :host.ids-list-item__description{align-self:flex-end;grid-area:description;margin-left:var(--ids_size_general_8x);text-align:right}::ng-deep .ids-list-item__description:not(.ids-tag):not(.ids-number-badge),::ng-deep :host.ids-list-item__description:not(.ids-tag):not(.ids-number-badge){font:var(--ids_textStyle_f02_s16_h24_wrg)}::ng-deep .ids-list-item__description--double-line,::ng-deep :host.ids-list-item__description--double-line{align-self:initial;grid-row:span 2}.ids-list-item__action,:host.ids-list-item__action{align-self:center;color:var(--ids_color_feedback_neutral);display:flex;grid-area:action;justify-content:center;margin-left:var(--ids_size_general_8x);min-width:var(--ids_size_general_24x);text-align:center}::ng-deep .ids-list-item__action,::ng-deep :host.ids-list-item__action{align-self:center;color:var(--ids_color_feedback_neutral);display:flex;grid-area:action;justify-content:center;margin-left:var(--ids_size_general_8x);min-width:var(--ids_size_general_24x);text-align:center}.ids-list-item__sub-text,:host.ids-list-item__sub-text{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s16_h24_wrg);grid-area:sub-text}::ng-deep .ids-list-item__sub-text,::ng-deep :host.ids-list-item__sub-text{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s16_h24_wrg);grid-area:sub-text}.ids-list-item__sub-description,:host.ids-list-item__sub-description{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s14_h20_wrg);grid-area:sub-description;margin-left:var(--ids_size_general_8x);text-align:right}::ng-deep .ids-list-item__sub-description,::ng-deep :host.ids-list-item__sub-description{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s14_h20_wrg);grid-area:sub-description;margin-left:var(--ids_size_general_8x);text-align:right}.ids-list-item--selector,:host.ids-list-item--selector{position:relative}@supports (-webkit-touch-callout: none){.ids-list-item--selector,:host.ids-list-item--selector{overflow:hidden}}.ids-list-item--selector .ids-switch,.ids-list-item--selector .ids-radio-button,.ids-list-item--selector .ids-checkbox,:host.ids-list-item--selector .ids-switch,:host.ids-list-item--selector .ids-radio-button,:host.ids-list-item--selector .ids-checkbox{min-height:auto;position:static}.ids-list-item--selector .ids-switch__input,.ids-list-item--selector .ids-radio-button__input,.ids-list-item--selector .ids-checkbox__input,:host.ids-list-item--selector .ids-switch__input,:host.ids-list-item--selector .ids-radio-button__input,:host.ids-list-item--selector .ids-checkbox__input{outline-offset:0}.ids-list-item--selector ::ng-deep .ids-switch,.ids-list-item--selector ::ng-deep .ids-checkbox,.ids-list-item--selector ::ng-deep .ids-radio-button,:host.ids-list-item--selector ::ng-deep .ids-switch,:host.ids-list-item--selector ::ng-deep .ids-checkbox,:host.ids-list-item--selector ::ng-deep .ids-radio-button{min-height:auto;position:static}.ids-list-item--selector ::ng-deep .ids-switch__input,.ids-list-item--selector ::ng-deep .ids-checkbox__input,.ids-list-item--selector ::ng-deep .ids-radio-button__input,:host.ids-list-item--selector ::ng-deep .ids-switch__input,:host.ids-list-item--selector ::ng-deep .ids-checkbox__input,:host.ids-list-item--selector ::ng-deep .ids-radio-button__input{outline-offset:0}button.ids-list-item,button:host.ids-list-item{background-color:transparent;border-left:0;border-right:0;border-top:0;cursor:pointer;padding:0;text-decoration:none}button.ids-list-item:not(.ids-list-item--line-off),button:host.ids-list-item:not(.ids-list-item--line-off){border-bottom-color:var(--ids_color_border_soft)}button.ids-list-item:disabled,button.ids-list-item[aria-disabled=true],button:host.ids-list-item:disabled,button:host.ids-list-item[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}button.ids-list-item:disabled .ids-list-item__sub-text,button.ids-list-item:disabled .ids-list-item__sub-description,button.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,button.ids-list-item[aria-disabled=true] .ids-list-item__sub-description,button:host.ids-list-item:disabled .ids-list-item__sub-text,button:host.ids-list-item:disabled .ids-list-item__sub-description,button:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,button:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-description{color:inherit}button.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,button.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description{color:inherit}button.ids-list-item:disabled ::ng-deep .ids-list-item__action,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__action,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}button.ids-list-item:disabled .ids-list-item__action,button.ids-list-item[aria-disabled=true] .ids-list-item__action,button:host.ids-list-item:disabled .ids-list-item__action,button:host.ids-list-item[aria-disabled=true] .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){button.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),button.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}}button.ids-list-item:active:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}a.ids-list-item,a:host.ids-list-item{background-color:transparent;border-left:0;border-right:0;border-top:0;cursor:pointer;padding:0;text-decoration:none}a.ids-list-item:not(.ids-list-item--line-off),a:host.ids-list-item:not(.ids-list-item--line-off){border-bottom-color:var(--ids_color_border_soft)}a.ids-list-item:disabled,a.ids-list-item[aria-disabled=true],a:host.ids-list-item:disabled,a:host.ids-list-item[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}a.ids-list-item:disabled .ids-list-item__sub-text,a.ids-list-item:disabled .ids-list-item__sub-description,a.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,a.ids-list-item[aria-disabled=true] .ids-list-item__sub-description,a:host.ids-list-item:disabled .ids-list-item__sub-text,a:host.ids-list-item:disabled .ids-list-item__sub-description,a:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,a:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-description{color:inherit}a.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,a.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description{color:inherit}a.ids-list-item:disabled ::ng-deep .ids-list-item__action,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__action,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}a.ids-list-item:disabled .ids-list-item__action,a.ids-list-item[aria-disabled=true] .ids-list-item__action,a:host.ids-list-item:disabled .ids-list-item__action,a:host.ids-list-item[aria-disabled=true] .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){a.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),a.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}}a.ids-list-item:active:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}.ids-list-item--line-off,:host.ids-list-item--line-off{border-bottom-color:transparent}.ids-list,:host.ids-list{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;background-color:var(--ids_color_bg_base);color:var(--ids_color_feedback_neutral);font:var(--ids_textStyle_f02_s16_h24_wrg);list-style:none}.ids-list>li:not(.ids-list-item),:host.ids-list>li:not(.ids-list-item){all:unset;all:revert;box-sizing:border-box}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsListItemTextComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, host: {
                        '[class.ids-list-item__text]': 'true',
                        '[class.ids-list-item__text--double-line]': 'doubleLine',
                        '[attr.id]': 'id',
                        '[attr.for]': 'for',
                        '[attr.aria-hidden]': 'ariaHidden',
                    }, selector: '[idsLiText]', standalone: true, template: '<ng-content></ng-content>', styles: [".ids-list-item,:host.ids-list-item{--ids-list-item-label-width: minmax(15%, auto);--ids-list-item-description-width: fit-content(100%);all:unset;all:revert;background:var(--ids_color_bg_base);border:0;border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_soft);box-sizing:border-box;color:var(--ids_color_feedback_neutral);display:block;font:var(--ids_textStyle_f02_s16_h24_wbd);text-align:left;text-decoration:inherit;width:100%}.ids-list-item .ids-icon-button,:host.ids-list-item .ids-icon-button{margin-right:var(--ids_size_general_1x);min-height:auto;padding-bottom:0;padding-top:0}.ids-list-item ::ng-deep .ids-icon-button,:host.ids-list-item ::ng-deep .ids-icon-button{margin-right:var(--ids_size_general_1x);min-height:auto;padding-bottom:0;padding-top:0}.ids-list-item__content,:host.ids-list-item__content{all:unset;all:revert;align-items:center;box-sizing:border-box;display:grid;grid-template-areas:\"icon text description action\" \"icon sub-text sub-description action\";grid-template-columns:min-content var(--ids-list-item-label-width) var(--ids-list-item-description-width) min-content;min-height:3.9375rem;overflow:hidden;padding:var(--ids_size_general_16x) 0 calc(var(--ids_size_general_16x) - var(--ids_size_border_small))}.ids-list-item__content:has(.ids-list-item__sub-text),:host.ids-list-item__content:has(.ids-list-item__sub-text){min-height:4.9375rem}.ids-list-item__icon,:host.ids-list-item__icon{align-self:center;grid-area:icon;line-height:1;margin-right:var(--ids_size_general_16x);text-align:center}::ng-deep .ids-list-item__icon,::ng-deep :host.ids-list-item__icon{align-self:center;grid-area:icon;line-height:1;margin-right:var(--ids_size_general_16x);text-align:center}.ids-list-item__text,:host.ids-list-item__text{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;align-self:flex-end;grid-area:text;overflow:hidden}.ids-list-item__text--double-line,:host.ids-list-item__text--double-line{align-self:initial;grid-row:span 2}::ng-deep .ids-list-item__text,::ng-deep :host.ids-list-item__text{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;align-self:flex-end;grid-area:text;overflow:hidden}::ng-deep .ids-list-item__text--double-line,::ng-deep :host.ids-list-item__text--double-line{align-self:initial;grid-row:span 2}.ids-list-item__description,:host.ids-list-item__description{align-self:flex-end;grid-area:description;margin-left:var(--ids_size_general_8x);text-align:right}.ids-list-item__description:not(.ids-tag):not(.ids-number-badge),:host.ids-list-item__description:not(.ids-tag):not(.ids-number-badge){font:var(--ids_textStyle_f02_s16_h24_wrg)}.ids-list-item__description--double-line,:host.ids-list-item__description--double-line{align-self:initial;grid-row:span 2}::ng-deep .ids-list-item__description,::ng-deep :host.ids-list-item__description{align-self:flex-end;grid-area:description;margin-left:var(--ids_size_general_8x);text-align:right}::ng-deep .ids-list-item__description:not(.ids-tag):not(.ids-number-badge),::ng-deep :host.ids-list-item__description:not(.ids-tag):not(.ids-number-badge){font:var(--ids_textStyle_f02_s16_h24_wrg)}::ng-deep .ids-list-item__description--double-line,::ng-deep :host.ids-list-item__description--double-line{align-self:initial;grid-row:span 2}.ids-list-item__action,:host.ids-list-item__action{align-self:center;color:var(--ids_color_feedback_neutral);display:flex;grid-area:action;justify-content:center;margin-left:var(--ids_size_general_8x);min-width:var(--ids_size_general_24x);text-align:center}::ng-deep .ids-list-item__action,::ng-deep :host.ids-list-item__action{align-self:center;color:var(--ids_color_feedback_neutral);display:flex;grid-area:action;justify-content:center;margin-left:var(--ids_size_general_8x);min-width:var(--ids_size_general_24x);text-align:center}.ids-list-item__sub-text,:host.ids-list-item__sub-text{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s16_h24_wrg);grid-area:sub-text}::ng-deep .ids-list-item__sub-text,::ng-deep :host.ids-list-item__sub-text{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s16_h24_wrg);grid-area:sub-text}.ids-list-item__sub-description,:host.ids-list-item__sub-description{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s14_h20_wrg);grid-area:sub-description;margin-left:var(--ids_size_general_8x);text-align:right}::ng-deep .ids-list-item__sub-description,::ng-deep :host.ids-list-item__sub-description{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s14_h20_wrg);grid-area:sub-description;margin-left:var(--ids_size_general_8x);text-align:right}.ids-list-item--selector,:host.ids-list-item--selector{position:relative}@supports (-webkit-touch-callout: none){.ids-list-item--selector,:host.ids-list-item--selector{overflow:hidden}}.ids-list-item--selector .ids-switch,.ids-list-item--selector .ids-radio-button,.ids-list-item--selector .ids-checkbox,:host.ids-list-item--selector .ids-switch,:host.ids-list-item--selector .ids-radio-button,:host.ids-list-item--selector .ids-checkbox{min-height:auto;position:static}.ids-list-item--selector .ids-switch__input,.ids-list-item--selector .ids-radio-button__input,.ids-list-item--selector .ids-checkbox__input,:host.ids-list-item--selector .ids-switch__input,:host.ids-list-item--selector .ids-radio-button__input,:host.ids-list-item--selector .ids-checkbox__input{outline-offset:0}.ids-list-item--selector ::ng-deep .ids-switch,.ids-list-item--selector ::ng-deep .ids-checkbox,.ids-list-item--selector ::ng-deep .ids-radio-button,:host.ids-list-item--selector ::ng-deep .ids-switch,:host.ids-list-item--selector ::ng-deep .ids-checkbox,:host.ids-list-item--selector ::ng-deep .ids-radio-button{min-height:auto;position:static}.ids-list-item--selector ::ng-deep .ids-switch__input,.ids-list-item--selector ::ng-deep .ids-checkbox__input,.ids-list-item--selector ::ng-deep .ids-radio-button__input,:host.ids-list-item--selector ::ng-deep .ids-switch__input,:host.ids-list-item--selector ::ng-deep .ids-checkbox__input,:host.ids-list-item--selector ::ng-deep .ids-radio-button__input{outline-offset:0}button.ids-list-item,button:host.ids-list-item{background-color:transparent;border-left:0;border-right:0;border-top:0;cursor:pointer;padding:0;text-decoration:none}button.ids-list-item:not(.ids-list-item--line-off),button:host.ids-list-item:not(.ids-list-item--line-off){border-bottom-color:var(--ids_color_border_soft)}button.ids-list-item:disabled,button.ids-list-item[aria-disabled=true],button:host.ids-list-item:disabled,button:host.ids-list-item[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}button.ids-list-item:disabled .ids-list-item__sub-text,button.ids-list-item:disabled .ids-list-item__sub-description,button.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,button.ids-list-item[aria-disabled=true] .ids-list-item__sub-description,button:host.ids-list-item:disabled .ids-list-item__sub-text,button:host.ids-list-item:disabled .ids-list-item__sub-description,button:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,button:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-description{color:inherit}button.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,button.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description{color:inherit}button.ids-list-item:disabled ::ng-deep .ids-list-item__action,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__action,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}button.ids-list-item:disabled .ids-list-item__action,button.ids-list-item[aria-disabled=true] .ids-list-item__action,button:host.ids-list-item:disabled .ids-list-item__action,button:host.ids-list-item[aria-disabled=true] .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){button.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),button.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}}button.ids-list-item:active:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}a.ids-list-item,a:host.ids-list-item{background-color:transparent;border-left:0;border-right:0;border-top:0;cursor:pointer;padding:0;text-decoration:none}a.ids-list-item:not(.ids-list-item--line-off),a:host.ids-list-item:not(.ids-list-item--line-off){border-bottom-color:var(--ids_color_border_soft)}a.ids-list-item:disabled,a.ids-list-item[aria-disabled=true],a:host.ids-list-item:disabled,a:host.ids-list-item[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}a.ids-list-item:disabled .ids-list-item__sub-text,a.ids-list-item:disabled .ids-list-item__sub-description,a.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,a.ids-list-item[aria-disabled=true] .ids-list-item__sub-description,a:host.ids-list-item:disabled .ids-list-item__sub-text,a:host.ids-list-item:disabled .ids-list-item__sub-description,a:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,a:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-description{color:inherit}a.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,a.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description{color:inherit}a.ids-list-item:disabled ::ng-deep .ids-list-item__action,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__action,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}a.ids-list-item:disabled .ids-list-item__action,a.ids-list-item[aria-disabled=true] .ids-list-item__action,a:host.ids-list-item:disabled .ids-list-item__action,a:host.ids-list-item[aria-disabled=true] .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){a.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),a.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}}a.ids-list-item:active:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}.ids-list-item--line-off,:host.ids-list-item--line-off{border-bottom-color:transparent}.ids-list,:host.ids-list{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;background-color:var(--ids_color_bg_base);color:var(--ids_color_feedback_neutral);font:var(--ids_textStyle_f02_s16_h24_wrg);list-style:none}.ids-list>li:not(.ids-list-item),:host.ids-list>li:not(.ids-list-item){all:unset;all:revert;box-sizing:border-box}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: FormSelectionService }]; } });
/**
 * Sub texto do item da lista.
 *
 * **Component:**
 *
 * `import { IdsListItemSubTextComponent } from '@ids/angular';`
 */
class IdsListItemSubTextComponent {
    get ariaHidden() {
        return this.isLabel ? 'true' : null;
    }
    get id() {
        if (!this.selectorId) {
            return null;
        }
        return this.selectorId + '-label-sub-text';
    }
    get isLabel() {
        return this.elementRef.nativeElement.tagName === 'LABEL' || this.selectorId;
    }
    get for() {
        return this.isLabel ? this.selectorId : null;
    }
    constructor(elementRef, formSelectionService) {
        this.elementRef = elementRef;
        this.formSelectionService = formSelectionService;
        this.selectorId = '';
        this.destroy = new Subject();
        this.formSelectionService.inputIdSubject.pipe(takeUntil$1(this.destroy)).subscribe((id) => {
            this.selectorId = id;
            this.formSelectionService.setLabelId(this.id || '', 1);
        });
    }
    ngOnDestroy() {
        this.destroy.next();
        this.destroy.complete();
    }
}
IdsListItemSubTextComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsListItemSubTextComponent, deps: [{ token: i0.ElementRef }, { token: FormSelectionService }], target: i0.ɵɵFactoryTarget.Component });
IdsListItemSubTextComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsListItemSubTextComponent, isStandalone: true, selector: "[idsLiSubText]", host: { properties: { "class.ids-list-item__sub-text": "true", "attr.id": "id", "attr.for": "for", "attr.aria-hidden": "ariaHidden" } }, ngImport: i0, template: `
    <span class="ids-sr-only">&nbsp;</span>
    <ng-content></ng-content>
  `, isInline: true, styles: [".ids-list-item,:host.ids-list-item{--ids-list-item-label-width: minmax(15%, auto);--ids-list-item-description-width: fit-content(100%);all:unset;all:revert;background:var(--ids_color_bg_base);border:0;border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_soft);box-sizing:border-box;color:var(--ids_color_feedback_neutral);display:block;font:var(--ids_textStyle_f02_s16_h24_wbd);text-align:left;text-decoration:inherit;width:100%}.ids-list-item .ids-icon-button,:host.ids-list-item .ids-icon-button{margin-right:var(--ids_size_general_1x);min-height:auto;padding-bottom:0;padding-top:0}.ids-list-item ::ng-deep .ids-icon-button,:host.ids-list-item ::ng-deep .ids-icon-button{margin-right:var(--ids_size_general_1x);min-height:auto;padding-bottom:0;padding-top:0}.ids-list-item__content,:host.ids-list-item__content{all:unset;all:revert;align-items:center;box-sizing:border-box;display:grid;grid-template-areas:\"icon text description action\" \"icon sub-text sub-description action\";grid-template-columns:min-content var(--ids-list-item-label-width) var(--ids-list-item-description-width) min-content;min-height:3.9375rem;overflow:hidden;padding:var(--ids_size_general_16x) 0 calc(var(--ids_size_general_16x) - var(--ids_size_border_small))}.ids-list-item__content:has(.ids-list-item__sub-text),:host.ids-list-item__content:has(.ids-list-item__sub-text){min-height:4.9375rem}.ids-list-item__icon,:host.ids-list-item__icon{align-self:center;grid-area:icon;line-height:1;margin-right:var(--ids_size_general_16x);text-align:center}::ng-deep .ids-list-item__icon,::ng-deep :host.ids-list-item__icon{align-self:center;grid-area:icon;line-height:1;margin-right:var(--ids_size_general_16x);text-align:center}.ids-list-item__text,:host.ids-list-item__text{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;align-self:flex-end;grid-area:text;overflow:hidden}.ids-list-item__text--double-line,:host.ids-list-item__text--double-line{align-self:initial;grid-row:span 2}::ng-deep .ids-list-item__text,::ng-deep :host.ids-list-item__text{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;align-self:flex-end;grid-area:text;overflow:hidden}::ng-deep .ids-list-item__text--double-line,::ng-deep :host.ids-list-item__text--double-line{align-self:initial;grid-row:span 2}.ids-list-item__description,:host.ids-list-item__description{align-self:flex-end;grid-area:description;margin-left:var(--ids_size_general_8x);text-align:right}.ids-list-item__description:not(.ids-tag):not(.ids-number-badge),:host.ids-list-item__description:not(.ids-tag):not(.ids-number-badge){font:var(--ids_textStyle_f02_s16_h24_wrg)}.ids-list-item__description--double-line,:host.ids-list-item__description--double-line{align-self:initial;grid-row:span 2}::ng-deep .ids-list-item__description,::ng-deep :host.ids-list-item__description{align-self:flex-end;grid-area:description;margin-left:var(--ids_size_general_8x);text-align:right}::ng-deep .ids-list-item__description:not(.ids-tag):not(.ids-number-badge),::ng-deep :host.ids-list-item__description:not(.ids-tag):not(.ids-number-badge){font:var(--ids_textStyle_f02_s16_h24_wrg)}::ng-deep .ids-list-item__description--double-line,::ng-deep :host.ids-list-item__description--double-line{align-self:initial;grid-row:span 2}.ids-list-item__action,:host.ids-list-item__action{align-self:center;color:var(--ids_color_feedback_neutral);display:flex;grid-area:action;justify-content:center;margin-left:var(--ids_size_general_8x);min-width:var(--ids_size_general_24x);text-align:center}::ng-deep .ids-list-item__action,::ng-deep :host.ids-list-item__action{align-self:center;color:var(--ids_color_feedback_neutral);display:flex;grid-area:action;justify-content:center;margin-left:var(--ids_size_general_8x);min-width:var(--ids_size_general_24x);text-align:center}.ids-list-item__sub-text,:host.ids-list-item__sub-text{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s16_h24_wrg);grid-area:sub-text}::ng-deep .ids-list-item__sub-text,::ng-deep :host.ids-list-item__sub-text{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s16_h24_wrg);grid-area:sub-text}.ids-list-item__sub-description,:host.ids-list-item__sub-description{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s14_h20_wrg);grid-area:sub-description;margin-left:var(--ids_size_general_8x);text-align:right}::ng-deep .ids-list-item__sub-description,::ng-deep :host.ids-list-item__sub-description{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s14_h20_wrg);grid-area:sub-description;margin-left:var(--ids_size_general_8x);text-align:right}.ids-list-item--selector,:host.ids-list-item--selector{position:relative}@supports (-webkit-touch-callout: none){.ids-list-item--selector,:host.ids-list-item--selector{overflow:hidden}}.ids-list-item--selector .ids-switch,.ids-list-item--selector .ids-radio-button,.ids-list-item--selector .ids-checkbox,:host.ids-list-item--selector .ids-switch,:host.ids-list-item--selector .ids-radio-button,:host.ids-list-item--selector .ids-checkbox{min-height:auto;position:static}.ids-list-item--selector .ids-switch__input,.ids-list-item--selector .ids-radio-button__input,.ids-list-item--selector .ids-checkbox__input,:host.ids-list-item--selector .ids-switch__input,:host.ids-list-item--selector .ids-radio-button__input,:host.ids-list-item--selector .ids-checkbox__input{outline-offset:0}.ids-list-item--selector ::ng-deep .ids-switch,.ids-list-item--selector ::ng-deep .ids-checkbox,.ids-list-item--selector ::ng-deep .ids-radio-button,:host.ids-list-item--selector ::ng-deep .ids-switch,:host.ids-list-item--selector ::ng-deep .ids-checkbox,:host.ids-list-item--selector ::ng-deep .ids-radio-button{min-height:auto;position:static}.ids-list-item--selector ::ng-deep .ids-switch__input,.ids-list-item--selector ::ng-deep .ids-checkbox__input,.ids-list-item--selector ::ng-deep .ids-radio-button__input,:host.ids-list-item--selector ::ng-deep .ids-switch__input,:host.ids-list-item--selector ::ng-deep .ids-checkbox__input,:host.ids-list-item--selector ::ng-deep .ids-radio-button__input{outline-offset:0}button.ids-list-item,button:host.ids-list-item{background-color:transparent;border-left:0;border-right:0;border-top:0;cursor:pointer;padding:0;text-decoration:none}button.ids-list-item:not(.ids-list-item--line-off),button:host.ids-list-item:not(.ids-list-item--line-off){border-bottom-color:var(--ids_color_border_soft)}button.ids-list-item:disabled,button.ids-list-item[aria-disabled=true],button:host.ids-list-item:disabled,button:host.ids-list-item[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}button.ids-list-item:disabled .ids-list-item__sub-text,button.ids-list-item:disabled .ids-list-item__sub-description,button.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,button.ids-list-item[aria-disabled=true] .ids-list-item__sub-description,button:host.ids-list-item:disabled .ids-list-item__sub-text,button:host.ids-list-item:disabled .ids-list-item__sub-description,button:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,button:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-description{color:inherit}button.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,button.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description{color:inherit}button.ids-list-item:disabled ::ng-deep .ids-list-item__action,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__action,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}button.ids-list-item:disabled .ids-list-item__action,button.ids-list-item[aria-disabled=true] .ids-list-item__action,button:host.ids-list-item:disabled .ids-list-item__action,button:host.ids-list-item[aria-disabled=true] .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){button.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),button.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}}button.ids-list-item:active:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}a.ids-list-item,a:host.ids-list-item{background-color:transparent;border-left:0;border-right:0;border-top:0;cursor:pointer;padding:0;text-decoration:none}a.ids-list-item:not(.ids-list-item--line-off),a:host.ids-list-item:not(.ids-list-item--line-off){border-bottom-color:var(--ids_color_border_soft)}a.ids-list-item:disabled,a.ids-list-item[aria-disabled=true],a:host.ids-list-item:disabled,a:host.ids-list-item[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}a.ids-list-item:disabled .ids-list-item__sub-text,a.ids-list-item:disabled .ids-list-item__sub-description,a.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,a.ids-list-item[aria-disabled=true] .ids-list-item__sub-description,a:host.ids-list-item:disabled .ids-list-item__sub-text,a:host.ids-list-item:disabled .ids-list-item__sub-description,a:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,a:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-description{color:inherit}a.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,a.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description{color:inherit}a.ids-list-item:disabled ::ng-deep .ids-list-item__action,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__action,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}a.ids-list-item:disabled .ids-list-item__action,a.ids-list-item[aria-disabled=true] .ids-list-item__action,a:host.ids-list-item:disabled .ids-list-item__action,a:host.ids-list-item[aria-disabled=true] .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){a.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),a.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}}a.ids-list-item:active:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}.ids-list-item--line-off,:host.ids-list-item--line-off{border-bottom-color:transparent}.ids-list,:host.ids-list{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;background-color:var(--ids_color_bg_base);color:var(--ids_color_feedback_neutral);font:var(--ids_textStyle_f02_s16_h24_wrg);list-style:none}.ids-list>li:not(.ids-list-item),:host.ids-list>li:not(.ids-list-item){all:unset;all:revert;box-sizing:border-box}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsListItemSubTextComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, host: {
                        '[class.ids-list-item__sub-text]': 'true',
                        '[attr.id]': 'id',
                        '[attr.for]': 'for',
                        '[attr.aria-hidden]': 'ariaHidden',
                    }, selector: '[idsLiSubText]', standalone: true, template: `
    <span class="ids-sr-only">&nbsp;</span>
    <ng-content></ng-content>
  `, styles: [".ids-list-item,:host.ids-list-item{--ids-list-item-label-width: minmax(15%, auto);--ids-list-item-description-width: fit-content(100%);all:unset;all:revert;background:var(--ids_color_bg_base);border:0;border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_soft);box-sizing:border-box;color:var(--ids_color_feedback_neutral);display:block;font:var(--ids_textStyle_f02_s16_h24_wbd);text-align:left;text-decoration:inherit;width:100%}.ids-list-item .ids-icon-button,:host.ids-list-item .ids-icon-button{margin-right:var(--ids_size_general_1x);min-height:auto;padding-bottom:0;padding-top:0}.ids-list-item ::ng-deep .ids-icon-button,:host.ids-list-item ::ng-deep .ids-icon-button{margin-right:var(--ids_size_general_1x);min-height:auto;padding-bottom:0;padding-top:0}.ids-list-item__content,:host.ids-list-item__content{all:unset;all:revert;align-items:center;box-sizing:border-box;display:grid;grid-template-areas:\"icon text description action\" \"icon sub-text sub-description action\";grid-template-columns:min-content var(--ids-list-item-label-width) var(--ids-list-item-description-width) min-content;min-height:3.9375rem;overflow:hidden;padding:var(--ids_size_general_16x) 0 calc(var(--ids_size_general_16x) - var(--ids_size_border_small))}.ids-list-item__content:has(.ids-list-item__sub-text),:host.ids-list-item__content:has(.ids-list-item__sub-text){min-height:4.9375rem}.ids-list-item__icon,:host.ids-list-item__icon{align-self:center;grid-area:icon;line-height:1;margin-right:var(--ids_size_general_16x);text-align:center}::ng-deep .ids-list-item__icon,::ng-deep :host.ids-list-item__icon{align-self:center;grid-area:icon;line-height:1;margin-right:var(--ids_size_general_16x);text-align:center}.ids-list-item__text,:host.ids-list-item__text{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;align-self:flex-end;grid-area:text;overflow:hidden}.ids-list-item__text--double-line,:host.ids-list-item__text--double-line{align-self:initial;grid-row:span 2}::ng-deep .ids-list-item__text,::ng-deep :host.ids-list-item__text{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;align-self:flex-end;grid-area:text;overflow:hidden}::ng-deep .ids-list-item__text--double-line,::ng-deep :host.ids-list-item__text--double-line{align-self:initial;grid-row:span 2}.ids-list-item__description,:host.ids-list-item__description{align-self:flex-end;grid-area:description;margin-left:var(--ids_size_general_8x);text-align:right}.ids-list-item__description:not(.ids-tag):not(.ids-number-badge),:host.ids-list-item__description:not(.ids-tag):not(.ids-number-badge){font:var(--ids_textStyle_f02_s16_h24_wrg)}.ids-list-item__description--double-line,:host.ids-list-item__description--double-line{align-self:initial;grid-row:span 2}::ng-deep .ids-list-item__description,::ng-deep :host.ids-list-item__description{align-self:flex-end;grid-area:description;margin-left:var(--ids_size_general_8x);text-align:right}::ng-deep .ids-list-item__description:not(.ids-tag):not(.ids-number-badge),::ng-deep :host.ids-list-item__description:not(.ids-tag):not(.ids-number-badge){font:var(--ids_textStyle_f02_s16_h24_wrg)}::ng-deep .ids-list-item__description--double-line,::ng-deep :host.ids-list-item__description--double-line{align-self:initial;grid-row:span 2}.ids-list-item__action,:host.ids-list-item__action{align-self:center;color:var(--ids_color_feedback_neutral);display:flex;grid-area:action;justify-content:center;margin-left:var(--ids_size_general_8x);min-width:var(--ids_size_general_24x);text-align:center}::ng-deep .ids-list-item__action,::ng-deep :host.ids-list-item__action{align-self:center;color:var(--ids_color_feedback_neutral);display:flex;grid-area:action;justify-content:center;margin-left:var(--ids_size_general_8x);min-width:var(--ids_size_general_24x);text-align:center}.ids-list-item__sub-text,:host.ids-list-item__sub-text{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s16_h24_wrg);grid-area:sub-text}::ng-deep .ids-list-item__sub-text,::ng-deep :host.ids-list-item__sub-text{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s16_h24_wrg);grid-area:sub-text}.ids-list-item__sub-description,:host.ids-list-item__sub-description{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s14_h20_wrg);grid-area:sub-description;margin-left:var(--ids_size_general_8x);text-align:right}::ng-deep .ids-list-item__sub-description,::ng-deep :host.ids-list-item__sub-description{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s14_h20_wrg);grid-area:sub-description;margin-left:var(--ids_size_general_8x);text-align:right}.ids-list-item--selector,:host.ids-list-item--selector{position:relative}@supports (-webkit-touch-callout: none){.ids-list-item--selector,:host.ids-list-item--selector{overflow:hidden}}.ids-list-item--selector .ids-switch,.ids-list-item--selector .ids-radio-button,.ids-list-item--selector .ids-checkbox,:host.ids-list-item--selector .ids-switch,:host.ids-list-item--selector .ids-radio-button,:host.ids-list-item--selector .ids-checkbox{min-height:auto;position:static}.ids-list-item--selector .ids-switch__input,.ids-list-item--selector .ids-radio-button__input,.ids-list-item--selector .ids-checkbox__input,:host.ids-list-item--selector .ids-switch__input,:host.ids-list-item--selector .ids-radio-button__input,:host.ids-list-item--selector .ids-checkbox__input{outline-offset:0}.ids-list-item--selector ::ng-deep .ids-switch,.ids-list-item--selector ::ng-deep .ids-checkbox,.ids-list-item--selector ::ng-deep .ids-radio-button,:host.ids-list-item--selector ::ng-deep .ids-switch,:host.ids-list-item--selector ::ng-deep .ids-checkbox,:host.ids-list-item--selector ::ng-deep .ids-radio-button{min-height:auto;position:static}.ids-list-item--selector ::ng-deep .ids-switch__input,.ids-list-item--selector ::ng-deep .ids-checkbox__input,.ids-list-item--selector ::ng-deep .ids-radio-button__input,:host.ids-list-item--selector ::ng-deep .ids-switch__input,:host.ids-list-item--selector ::ng-deep .ids-checkbox__input,:host.ids-list-item--selector ::ng-deep .ids-radio-button__input{outline-offset:0}button.ids-list-item,button:host.ids-list-item{background-color:transparent;border-left:0;border-right:0;border-top:0;cursor:pointer;padding:0;text-decoration:none}button.ids-list-item:not(.ids-list-item--line-off),button:host.ids-list-item:not(.ids-list-item--line-off){border-bottom-color:var(--ids_color_border_soft)}button.ids-list-item:disabled,button.ids-list-item[aria-disabled=true],button:host.ids-list-item:disabled,button:host.ids-list-item[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}button.ids-list-item:disabled .ids-list-item__sub-text,button.ids-list-item:disabled .ids-list-item__sub-description,button.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,button.ids-list-item[aria-disabled=true] .ids-list-item__sub-description,button:host.ids-list-item:disabled .ids-list-item__sub-text,button:host.ids-list-item:disabled .ids-list-item__sub-description,button:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,button:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-description{color:inherit}button.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,button.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description{color:inherit}button.ids-list-item:disabled ::ng-deep .ids-list-item__action,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__action,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}button.ids-list-item:disabled .ids-list-item__action,button.ids-list-item[aria-disabled=true] .ids-list-item__action,button:host.ids-list-item:disabled .ids-list-item__action,button:host.ids-list-item[aria-disabled=true] .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){button.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),button.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}}button.ids-list-item:active:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}a.ids-list-item,a:host.ids-list-item{background-color:transparent;border-left:0;border-right:0;border-top:0;cursor:pointer;padding:0;text-decoration:none}a.ids-list-item:not(.ids-list-item--line-off),a:host.ids-list-item:not(.ids-list-item--line-off){border-bottom-color:var(--ids_color_border_soft)}a.ids-list-item:disabled,a.ids-list-item[aria-disabled=true],a:host.ids-list-item:disabled,a:host.ids-list-item[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}a.ids-list-item:disabled .ids-list-item__sub-text,a.ids-list-item:disabled .ids-list-item__sub-description,a.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,a.ids-list-item[aria-disabled=true] .ids-list-item__sub-description,a:host.ids-list-item:disabled .ids-list-item__sub-text,a:host.ids-list-item:disabled .ids-list-item__sub-description,a:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,a:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-description{color:inherit}a.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,a.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description{color:inherit}a.ids-list-item:disabled ::ng-deep .ids-list-item__action,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__action,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}a.ids-list-item:disabled .ids-list-item__action,a.ids-list-item[aria-disabled=true] .ids-list-item__action,a:host.ids-list-item:disabled .ids-list-item__action,a:host.ids-list-item[aria-disabled=true] .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){a.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),a.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}}a.ids-list-item:active:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}.ids-list-item--line-off,:host.ids-list-item--line-off{border-bottom-color:transparent}.ids-list,:host.ids-list{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;background-color:var(--ids_color_bg_base);color:var(--ids_color_feedback_neutral);font:var(--ids_textStyle_f02_s16_h24_wrg);list-style:none}.ids-list>li:not(.ids-list-item),:host.ids-list>li:not(.ids-list-item){all:unset;all:revert;box-sizing:border-box}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: FormSelectionService }]; } });
/**
 * Elemento que fica antes do texto no item da lista.
 *
 * **Directive:**
 *
 * `import { IdsListItemIconDirective } from '@ids/angular';`
 */
class IdsListItemIconDirective {
}
IdsListItemIconDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsListItemIconDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
IdsListItemIconDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsListItemIconDirective, isStandalone: true, selector: "[idsLiIcon]", host: { properties: { "class.ids-list-item__icon": "true", "attr.aria-hidden": "true" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsListItemIconDirective, decorators: [{
            type: Directive,
            args: [{
                    host: {
                        '[class.ids-list-item__icon]': 'true',
                        '[attr.aria-hidden]': 'true',
                    },
                    selector: '[idsLiIcon]',
                    standalone: true,
                }]
        }] });
/**
 * Texto auxiliar do item da lista.
 *
 * **Directive:**
 *
 * `import { IdsListItemDescriptionDirective } from '@ids/angular';`
 */
class IdsListItemDescriptionDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.doubleLine = false;
    }
    ngAfterContentInit() {
        if (!this.elementRef.nativeElement.nextElementSibling?.hasAttribute('idslisubdescription')) {
            this.doubleLine = true;
        }
    }
    ngAfterViewInit() {
        const span = document.createElement('span');
        span.innerHTML = '&nbsp;';
        span.classList.add('ids-sr-only');
        this.elementRef.nativeElement.insertAdjacentElement('afterbegin', span);
    }
}
IdsListItemDescriptionDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsListItemDescriptionDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
IdsListItemDescriptionDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsListItemDescriptionDirective, isStandalone: true, selector: "[idsLiDescription]", host: { properties: { "class.ids-list-item__description": "true", "class.ids-list-item__description--double-line": "doubleLine" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsListItemDescriptionDirective, decorators: [{
            type: Directive,
            args: [{
                    host: {
                        '[class.ids-list-item__description]': 'true',
                        '[class.ids-list-item__description--double-line]': 'doubleLine',
                    },
                    selector: '[idsLiDescription]',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; } });
/**
 * Sub texto auxiliar do item da lista.
 *
 * **Component:**
 *
 * `import { IdsListSubDescriptionComponent } from '@ids/angular';`
 */
class IdsListSubDescriptionComponent {
}
IdsListSubDescriptionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsListSubDescriptionComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IdsListSubDescriptionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsListSubDescriptionComponent, isStandalone: true, selector: "[idsLiSubDescription]", host: { properties: { "class.ids-list-item__sub-description": "true" } }, ngImport: i0, template: `
    <span class="ids-sr-only">&nbsp;</span>
    <ng-content></ng-content>
  `, isInline: true, styles: [".ids-list-item,:host.ids-list-item{--ids-list-item-label-width: minmax(15%, auto);--ids-list-item-description-width: fit-content(100%);all:unset;all:revert;background:var(--ids_color_bg_base);border:0;border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_soft);box-sizing:border-box;color:var(--ids_color_feedback_neutral);display:block;font:var(--ids_textStyle_f02_s16_h24_wbd);text-align:left;text-decoration:inherit;width:100%}.ids-list-item .ids-icon-button,:host.ids-list-item .ids-icon-button{margin-right:var(--ids_size_general_1x);min-height:auto;padding-bottom:0;padding-top:0}.ids-list-item ::ng-deep .ids-icon-button,:host.ids-list-item ::ng-deep .ids-icon-button{margin-right:var(--ids_size_general_1x);min-height:auto;padding-bottom:0;padding-top:0}.ids-list-item__content,:host.ids-list-item__content{all:unset;all:revert;align-items:center;box-sizing:border-box;display:grid;grid-template-areas:\"icon text description action\" \"icon sub-text sub-description action\";grid-template-columns:min-content var(--ids-list-item-label-width) var(--ids-list-item-description-width) min-content;min-height:3.9375rem;overflow:hidden;padding:var(--ids_size_general_16x) 0 calc(var(--ids_size_general_16x) - var(--ids_size_border_small))}.ids-list-item__content:has(.ids-list-item__sub-text),:host.ids-list-item__content:has(.ids-list-item__sub-text){min-height:4.9375rem}.ids-list-item__icon,:host.ids-list-item__icon{align-self:center;grid-area:icon;line-height:1;margin-right:var(--ids_size_general_16x);text-align:center}::ng-deep .ids-list-item__icon,::ng-deep :host.ids-list-item__icon{align-self:center;grid-area:icon;line-height:1;margin-right:var(--ids_size_general_16x);text-align:center}.ids-list-item__text,:host.ids-list-item__text{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;align-self:flex-end;grid-area:text;overflow:hidden}.ids-list-item__text--double-line,:host.ids-list-item__text--double-line{align-self:initial;grid-row:span 2}::ng-deep .ids-list-item__text,::ng-deep :host.ids-list-item__text{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;align-self:flex-end;grid-area:text;overflow:hidden}::ng-deep .ids-list-item__text--double-line,::ng-deep :host.ids-list-item__text--double-line{align-self:initial;grid-row:span 2}.ids-list-item__description,:host.ids-list-item__description{align-self:flex-end;grid-area:description;margin-left:var(--ids_size_general_8x);text-align:right}.ids-list-item__description:not(.ids-tag):not(.ids-number-badge),:host.ids-list-item__description:not(.ids-tag):not(.ids-number-badge){font:var(--ids_textStyle_f02_s16_h24_wrg)}.ids-list-item__description--double-line,:host.ids-list-item__description--double-line{align-self:initial;grid-row:span 2}::ng-deep .ids-list-item__description,::ng-deep :host.ids-list-item__description{align-self:flex-end;grid-area:description;margin-left:var(--ids_size_general_8x);text-align:right}::ng-deep .ids-list-item__description:not(.ids-tag):not(.ids-number-badge),::ng-deep :host.ids-list-item__description:not(.ids-tag):not(.ids-number-badge){font:var(--ids_textStyle_f02_s16_h24_wrg)}::ng-deep .ids-list-item__description--double-line,::ng-deep :host.ids-list-item__description--double-line{align-self:initial;grid-row:span 2}.ids-list-item__action,:host.ids-list-item__action{align-self:center;color:var(--ids_color_feedback_neutral);display:flex;grid-area:action;justify-content:center;margin-left:var(--ids_size_general_8x);min-width:var(--ids_size_general_24x);text-align:center}::ng-deep .ids-list-item__action,::ng-deep :host.ids-list-item__action{align-self:center;color:var(--ids_color_feedback_neutral);display:flex;grid-area:action;justify-content:center;margin-left:var(--ids_size_general_8x);min-width:var(--ids_size_general_24x);text-align:center}.ids-list-item__sub-text,:host.ids-list-item__sub-text{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s16_h24_wrg);grid-area:sub-text}::ng-deep .ids-list-item__sub-text,::ng-deep :host.ids-list-item__sub-text{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s16_h24_wrg);grid-area:sub-text}.ids-list-item__sub-description,:host.ids-list-item__sub-description{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s14_h20_wrg);grid-area:sub-description;margin-left:var(--ids_size_general_8x);text-align:right}::ng-deep .ids-list-item__sub-description,::ng-deep :host.ids-list-item__sub-description{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s14_h20_wrg);grid-area:sub-description;margin-left:var(--ids_size_general_8x);text-align:right}.ids-list-item--selector,:host.ids-list-item--selector{position:relative}@supports (-webkit-touch-callout: none){.ids-list-item--selector,:host.ids-list-item--selector{overflow:hidden}}.ids-list-item--selector .ids-switch,.ids-list-item--selector .ids-radio-button,.ids-list-item--selector .ids-checkbox,:host.ids-list-item--selector .ids-switch,:host.ids-list-item--selector .ids-radio-button,:host.ids-list-item--selector .ids-checkbox{min-height:auto;position:static}.ids-list-item--selector .ids-switch__input,.ids-list-item--selector .ids-radio-button__input,.ids-list-item--selector .ids-checkbox__input,:host.ids-list-item--selector .ids-switch__input,:host.ids-list-item--selector .ids-radio-button__input,:host.ids-list-item--selector .ids-checkbox__input{outline-offset:0}.ids-list-item--selector ::ng-deep .ids-switch,.ids-list-item--selector ::ng-deep .ids-checkbox,.ids-list-item--selector ::ng-deep .ids-radio-button,:host.ids-list-item--selector ::ng-deep .ids-switch,:host.ids-list-item--selector ::ng-deep .ids-checkbox,:host.ids-list-item--selector ::ng-deep .ids-radio-button{min-height:auto;position:static}.ids-list-item--selector ::ng-deep .ids-switch__input,.ids-list-item--selector ::ng-deep .ids-checkbox__input,.ids-list-item--selector ::ng-deep .ids-radio-button__input,:host.ids-list-item--selector ::ng-deep .ids-switch__input,:host.ids-list-item--selector ::ng-deep .ids-checkbox__input,:host.ids-list-item--selector ::ng-deep .ids-radio-button__input{outline-offset:0}button.ids-list-item,button:host.ids-list-item{background-color:transparent;border-left:0;border-right:0;border-top:0;cursor:pointer;padding:0;text-decoration:none}button.ids-list-item:not(.ids-list-item--line-off),button:host.ids-list-item:not(.ids-list-item--line-off){border-bottom-color:var(--ids_color_border_soft)}button.ids-list-item:disabled,button.ids-list-item[aria-disabled=true],button:host.ids-list-item:disabled,button:host.ids-list-item[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}button.ids-list-item:disabled .ids-list-item__sub-text,button.ids-list-item:disabled .ids-list-item__sub-description,button.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,button.ids-list-item[aria-disabled=true] .ids-list-item__sub-description,button:host.ids-list-item:disabled .ids-list-item__sub-text,button:host.ids-list-item:disabled .ids-list-item__sub-description,button:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,button:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-description{color:inherit}button.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,button.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description{color:inherit}button.ids-list-item:disabled ::ng-deep .ids-list-item__action,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__action,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}button.ids-list-item:disabled .ids-list-item__action,button.ids-list-item[aria-disabled=true] .ids-list-item__action,button:host.ids-list-item:disabled .ids-list-item__action,button:host.ids-list-item[aria-disabled=true] .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){button.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),button.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}}button.ids-list-item:active:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}a.ids-list-item,a:host.ids-list-item{background-color:transparent;border-left:0;border-right:0;border-top:0;cursor:pointer;padding:0;text-decoration:none}a.ids-list-item:not(.ids-list-item--line-off),a:host.ids-list-item:not(.ids-list-item--line-off){border-bottom-color:var(--ids_color_border_soft)}a.ids-list-item:disabled,a.ids-list-item[aria-disabled=true],a:host.ids-list-item:disabled,a:host.ids-list-item[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}a.ids-list-item:disabled .ids-list-item__sub-text,a.ids-list-item:disabled .ids-list-item__sub-description,a.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,a.ids-list-item[aria-disabled=true] .ids-list-item__sub-description,a:host.ids-list-item:disabled .ids-list-item__sub-text,a:host.ids-list-item:disabled .ids-list-item__sub-description,a:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,a:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-description{color:inherit}a.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,a.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description{color:inherit}a.ids-list-item:disabled ::ng-deep .ids-list-item__action,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__action,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}a.ids-list-item:disabled .ids-list-item__action,a.ids-list-item[aria-disabled=true] .ids-list-item__action,a:host.ids-list-item:disabled .ids-list-item__action,a:host.ids-list-item[aria-disabled=true] .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){a.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),a.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}}a.ids-list-item:active:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}.ids-list-item--line-off,:host.ids-list-item--line-off{border-bottom-color:transparent}.ids-list,:host.ids-list{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;background-color:var(--ids_color_bg_base);color:var(--ids_color_feedback_neutral);font:var(--ids_textStyle_f02_s16_h24_wrg);list-style:none}.ids-list>li:not(.ids-list-item),:host.ids-list>li:not(.ids-list-item){all:unset;all:revert;box-sizing:border-box}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsListSubDescriptionComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, host: {
                        '[class.ids-list-item__sub-description]': 'true',
                    }, selector: '[idsLiSubDescription]', standalone: true, template: `
    <span class="ids-sr-only">&nbsp;</span>
    <ng-content></ng-content>
  `, styles: [".ids-list-item,:host.ids-list-item{--ids-list-item-label-width: minmax(15%, auto);--ids-list-item-description-width: fit-content(100%);all:unset;all:revert;background:var(--ids_color_bg_base);border:0;border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_soft);box-sizing:border-box;color:var(--ids_color_feedback_neutral);display:block;font:var(--ids_textStyle_f02_s16_h24_wbd);text-align:left;text-decoration:inherit;width:100%}.ids-list-item .ids-icon-button,:host.ids-list-item .ids-icon-button{margin-right:var(--ids_size_general_1x);min-height:auto;padding-bottom:0;padding-top:0}.ids-list-item ::ng-deep .ids-icon-button,:host.ids-list-item ::ng-deep .ids-icon-button{margin-right:var(--ids_size_general_1x);min-height:auto;padding-bottom:0;padding-top:0}.ids-list-item__content,:host.ids-list-item__content{all:unset;all:revert;align-items:center;box-sizing:border-box;display:grid;grid-template-areas:\"icon text description action\" \"icon sub-text sub-description action\";grid-template-columns:min-content var(--ids-list-item-label-width) var(--ids-list-item-description-width) min-content;min-height:3.9375rem;overflow:hidden;padding:var(--ids_size_general_16x) 0 calc(var(--ids_size_general_16x) - var(--ids_size_border_small))}.ids-list-item__content:has(.ids-list-item__sub-text),:host.ids-list-item__content:has(.ids-list-item__sub-text){min-height:4.9375rem}.ids-list-item__icon,:host.ids-list-item__icon{align-self:center;grid-area:icon;line-height:1;margin-right:var(--ids_size_general_16x);text-align:center}::ng-deep .ids-list-item__icon,::ng-deep :host.ids-list-item__icon{align-self:center;grid-area:icon;line-height:1;margin-right:var(--ids_size_general_16x);text-align:center}.ids-list-item__text,:host.ids-list-item__text{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;align-self:flex-end;grid-area:text;overflow:hidden}.ids-list-item__text--double-line,:host.ids-list-item__text--double-line{align-self:initial;grid-row:span 2}::ng-deep .ids-list-item__text,::ng-deep :host.ids-list-item__text{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;align-self:flex-end;grid-area:text;overflow:hidden}::ng-deep .ids-list-item__text--double-line,::ng-deep :host.ids-list-item__text--double-line{align-self:initial;grid-row:span 2}.ids-list-item__description,:host.ids-list-item__description{align-self:flex-end;grid-area:description;margin-left:var(--ids_size_general_8x);text-align:right}.ids-list-item__description:not(.ids-tag):not(.ids-number-badge),:host.ids-list-item__description:not(.ids-tag):not(.ids-number-badge){font:var(--ids_textStyle_f02_s16_h24_wrg)}.ids-list-item__description--double-line,:host.ids-list-item__description--double-line{align-self:initial;grid-row:span 2}::ng-deep .ids-list-item__description,::ng-deep :host.ids-list-item__description{align-self:flex-end;grid-area:description;margin-left:var(--ids_size_general_8x);text-align:right}::ng-deep .ids-list-item__description:not(.ids-tag):not(.ids-number-badge),::ng-deep :host.ids-list-item__description:not(.ids-tag):not(.ids-number-badge){font:var(--ids_textStyle_f02_s16_h24_wrg)}::ng-deep .ids-list-item__description--double-line,::ng-deep :host.ids-list-item__description--double-line{align-self:initial;grid-row:span 2}.ids-list-item__action,:host.ids-list-item__action{align-self:center;color:var(--ids_color_feedback_neutral);display:flex;grid-area:action;justify-content:center;margin-left:var(--ids_size_general_8x);min-width:var(--ids_size_general_24x);text-align:center}::ng-deep .ids-list-item__action,::ng-deep :host.ids-list-item__action{align-self:center;color:var(--ids_color_feedback_neutral);display:flex;grid-area:action;justify-content:center;margin-left:var(--ids_size_general_8x);min-width:var(--ids_size_general_24x);text-align:center}.ids-list-item__sub-text,:host.ids-list-item__sub-text{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s16_h24_wrg);grid-area:sub-text}::ng-deep .ids-list-item__sub-text,::ng-deep :host.ids-list-item__sub-text{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s16_h24_wrg);grid-area:sub-text}.ids-list-item__sub-description,:host.ids-list-item__sub-description{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s14_h20_wrg);grid-area:sub-description;margin-left:var(--ids_size_general_8x);text-align:right}::ng-deep .ids-list-item__sub-description,::ng-deep :host.ids-list-item__sub-description{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s14_h20_wrg);grid-area:sub-description;margin-left:var(--ids_size_general_8x);text-align:right}.ids-list-item--selector,:host.ids-list-item--selector{position:relative}@supports (-webkit-touch-callout: none){.ids-list-item--selector,:host.ids-list-item--selector{overflow:hidden}}.ids-list-item--selector .ids-switch,.ids-list-item--selector .ids-radio-button,.ids-list-item--selector .ids-checkbox,:host.ids-list-item--selector .ids-switch,:host.ids-list-item--selector .ids-radio-button,:host.ids-list-item--selector .ids-checkbox{min-height:auto;position:static}.ids-list-item--selector .ids-switch__input,.ids-list-item--selector .ids-radio-button__input,.ids-list-item--selector .ids-checkbox__input,:host.ids-list-item--selector .ids-switch__input,:host.ids-list-item--selector .ids-radio-button__input,:host.ids-list-item--selector .ids-checkbox__input{outline-offset:0}.ids-list-item--selector ::ng-deep .ids-switch,.ids-list-item--selector ::ng-deep .ids-checkbox,.ids-list-item--selector ::ng-deep .ids-radio-button,:host.ids-list-item--selector ::ng-deep .ids-switch,:host.ids-list-item--selector ::ng-deep .ids-checkbox,:host.ids-list-item--selector ::ng-deep .ids-radio-button{min-height:auto;position:static}.ids-list-item--selector ::ng-deep .ids-switch__input,.ids-list-item--selector ::ng-deep .ids-checkbox__input,.ids-list-item--selector ::ng-deep .ids-radio-button__input,:host.ids-list-item--selector ::ng-deep .ids-switch__input,:host.ids-list-item--selector ::ng-deep .ids-checkbox__input,:host.ids-list-item--selector ::ng-deep .ids-radio-button__input{outline-offset:0}button.ids-list-item,button:host.ids-list-item{background-color:transparent;border-left:0;border-right:0;border-top:0;cursor:pointer;padding:0;text-decoration:none}button.ids-list-item:not(.ids-list-item--line-off),button:host.ids-list-item:not(.ids-list-item--line-off){border-bottom-color:var(--ids_color_border_soft)}button.ids-list-item:disabled,button.ids-list-item[aria-disabled=true],button:host.ids-list-item:disabled,button:host.ids-list-item[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}button.ids-list-item:disabled .ids-list-item__sub-text,button.ids-list-item:disabled .ids-list-item__sub-description,button.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,button.ids-list-item[aria-disabled=true] .ids-list-item__sub-description,button:host.ids-list-item:disabled .ids-list-item__sub-text,button:host.ids-list-item:disabled .ids-list-item__sub-description,button:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,button:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-description{color:inherit}button.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,button.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description{color:inherit}button.ids-list-item:disabled ::ng-deep .ids-list-item__action,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__action,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}button.ids-list-item:disabled .ids-list-item__action,button.ids-list-item[aria-disabled=true] .ids-list-item__action,button:host.ids-list-item:disabled .ids-list-item__action,button:host.ids-list-item[aria-disabled=true] .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){button.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),button.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}}button.ids-list-item:active:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}a.ids-list-item,a:host.ids-list-item{background-color:transparent;border-left:0;border-right:0;border-top:0;cursor:pointer;padding:0;text-decoration:none}a.ids-list-item:not(.ids-list-item--line-off),a:host.ids-list-item:not(.ids-list-item--line-off){border-bottom-color:var(--ids_color_border_soft)}a.ids-list-item:disabled,a.ids-list-item[aria-disabled=true],a:host.ids-list-item:disabled,a:host.ids-list-item[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}a.ids-list-item:disabled .ids-list-item__sub-text,a.ids-list-item:disabled .ids-list-item__sub-description,a.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,a.ids-list-item[aria-disabled=true] .ids-list-item__sub-description,a:host.ids-list-item:disabled .ids-list-item__sub-text,a:host.ids-list-item:disabled .ids-list-item__sub-description,a:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,a:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-description{color:inherit}a.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,a.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description{color:inherit}a.ids-list-item:disabled ::ng-deep .ids-list-item__action,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__action,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}a.ids-list-item:disabled .ids-list-item__action,a.ids-list-item[aria-disabled=true] .ids-list-item__action,a:host.ids-list-item:disabled .ids-list-item__action,a:host.ids-list-item[aria-disabled=true] .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){a.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),a.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}}a.ids-list-item:active:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}.ids-list-item--line-off,:host.ids-list-item--line-off{border-bottom-color:transparent}.ids-list,:host.ids-list{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;background-color:var(--ids_color_bg_base);color:var(--ids_color_feedback_neutral);font:var(--ids_textStyle_f02_s16_h24_wrg);list-style:none}.ids-list>li:not(.ids-list-item),:host.ids-list>li:not(.ids-list-item){all:unset;all:revert;box-sizing:border-box}\n"] }]
        }] });
/**
 * Item da lista, pode ser do tipo View ou Action.
 *
 * **Module:**
 *
 * `import { IdsListModule } from '@ids/angular';`
 *
 * **Component:**
 *
 *`import { IdsListItemComponent } from '@ids/angular';`
 */
class IdsListItemComponent {
    /**
     * define se irá ter uma linha separadora entre os itens da lista
     */
    set lineOff(value) {
        this._lineOff = enforceBoolean(value);
    }
    get lineOff() {
        return this._lineOff;
    }
    get isSelector() {
        const isLabel = this.tagName === 'LABEL';
        return isLabel || this.hasRadioButton || this.hasCheckbox || this.hasSwitch;
    }
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.tagName = 'LI';
        this.isAction = false;
        this._lineOff = false;
        /** define o ícone para lista de ação */
        this.actionIcon = 'seta_direita';
    }
    ngOnInit() {
        this.tagName = this.elementRef.nativeElement.tagName;
        this.isAction =
            this.tagName === 'BUTTON' ||
                this.tagName === 'A' ||
                this.elementRef.nativeElement.getAttribute('role') === 'button';
    }
}
IdsListItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsListItemComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
IdsListItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsListItemComponent, isStandalone: true, selector: "[idsLi]", inputs: { lineOff: "lineOff", actionIcon: "actionIcon", labelWidth: "labelWidth", descriptionWidth: "descriptionWidth" }, host: { properties: { "class.ids-list-item": "true", "class.ids-list-item--action": "isAction", "class.ids-list-item--selector": "isSelector", "class.ids-list-item--line-off": "lineOff", "style.--ids-list-item-label-width": "this.labelWidth", "style.--ids-list-item-description-width": "this.descriptionWidth" } }, providers: [
        {
            provide: FormSelectionService,
        },
    ], queries: [{ propertyName: "hasRadioButton", first: true, predicate: IdsRadioButtonDirective, descendants: true }, { propertyName: "hasCheckbox", first: true, predicate: IdsCheckboxDirective, descendants: true }, { propertyName: "hasSwitch", first: true, predicate: IdsSwitchDirective, descendants: true }, { propertyName: "hasFavoriteButton", first: true, predicate: IdsFavoriteButtonComponent, descendants: true }], ngImport: i0, template: `<span
    class="ids-list-item__content"
    [attr.role]="!isSelector && !hasFavoriteButton ? 'text' : null"
  >
    <ng-content></ng-content>
    <!-- TODO: mudar para neutral -->
    <ids-icon class="ids-list-item__action" *ngIf="isAction" size="S">
      {{ actionIcon }}
    </ids-icon>
  </span>`, isInline: true, styles: [".ids-list-item,:host.ids-list-item{--ids-list-item-label-width: minmax(15%, auto);--ids-list-item-description-width: fit-content(100%);all:unset;all:revert;background:var(--ids_color_bg_base);border:0;border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_soft);box-sizing:border-box;color:var(--ids_color_feedback_neutral);display:block;font:var(--ids_textStyle_f02_s16_h24_wbd);text-align:left;text-decoration:inherit;width:100%}.ids-list-item .ids-icon-button,:host.ids-list-item .ids-icon-button{margin-right:var(--ids_size_general_1x);min-height:auto;padding-bottom:0;padding-top:0}.ids-list-item ::ng-deep .ids-icon-button,:host.ids-list-item ::ng-deep .ids-icon-button{margin-right:var(--ids_size_general_1x);min-height:auto;padding-bottom:0;padding-top:0}.ids-list-item__content,:host.ids-list-item__content{all:unset;all:revert;align-items:center;box-sizing:border-box;display:grid;grid-template-areas:\"icon text description action\" \"icon sub-text sub-description action\";grid-template-columns:min-content var(--ids-list-item-label-width) var(--ids-list-item-description-width) min-content;min-height:3.9375rem;overflow:hidden;padding:var(--ids_size_general_16x) 0 calc(var(--ids_size_general_16x) - var(--ids_size_border_small))}.ids-list-item__content:has(.ids-list-item__sub-text),:host.ids-list-item__content:has(.ids-list-item__sub-text){min-height:4.9375rem}.ids-list-item__icon,:host.ids-list-item__icon{align-self:center;grid-area:icon;line-height:1;margin-right:var(--ids_size_general_16x);text-align:center}::ng-deep .ids-list-item__icon,::ng-deep :host.ids-list-item__icon{align-self:center;grid-area:icon;line-height:1;margin-right:var(--ids_size_general_16x);text-align:center}.ids-list-item__text,:host.ids-list-item__text{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;align-self:flex-end;grid-area:text;overflow:hidden}.ids-list-item__text--double-line,:host.ids-list-item__text--double-line{align-self:initial;grid-row:span 2}::ng-deep .ids-list-item__text,::ng-deep :host.ids-list-item__text{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;align-self:flex-end;grid-area:text;overflow:hidden}::ng-deep .ids-list-item__text--double-line,::ng-deep :host.ids-list-item__text--double-line{align-self:initial;grid-row:span 2}.ids-list-item__description,:host.ids-list-item__description{align-self:flex-end;grid-area:description;margin-left:var(--ids_size_general_8x);text-align:right}.ids-list-item__description:not(.ids-tag):not(.ids-number-badge),:host.ids-list-item__description:not(.ids-tag):not(.ids-number-badge){font:var(--ids_textStyle_f02_s16_h24_wrg)}.ids-list-item__description--double-line,:host.ids-list-item__description--double-line{align-self:initial;grid-row:span 2}::ng-deep .ids-list-item__description,::ng-deep :host.ids-list-item__description{align-self:flex-end;grid-area:description;margin-left:var(--ids_size_general_8x);text-align:right}::ng-deep .ids-list-item__description:not(.ids-tag):not(.ids-number-badge),::ng-deep :host.ids-list-item__description:not(.ids-tag):not(.ids-number-badge){font:var(--ids_textStyle_f02_s16_h24_wrg)}::ng-deep .ids-list-item__description--double-line,::ng-deep :host.ids-list-item__description--double-line{align-self:initial;grid-row:span 2}.ids-list-item__action,:host.ids-list-item__action{align-self:center;color:var(--ids_color_feedback_neutral);display:flex;grid-area:action;justify-content:center;margin-left:var(--ids_size_general_8x);min-width:var(--ids_size_general_24x);text-align:center}::ng-deep .ids-list-item__action,::ng-deep :host.ids-list-item__action{align-self:center;color:var(--ids_color_feedback_neutral);display:flex;grid-area:action;justify-content:center;margin-left:var(--ids_size_general_8x);min-width:var(--ids_size_general_24x);text-align:center}.ids-list-item__sub-text,:host.ids-list-item__sub-text{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s16_h24_wrg);grid-area:sub-text}::ng-deep .ids-list-item__sub-text,::ng-deep :host.ids-list-item__sub-text{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s16_h24_wrg);grid-area:sub-text}.ids-list-item__sub-description,:host.ids-list-item__sub-description{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s14_h20_wrg);grid-area:sub-description;margin-left:var(--ids_size_general_8x);text-align:right}::ng-deep .ids-list-item__sub-description,::ng-deep :host.ids-list-item__sub-description{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s14_h20_wrg);grid-area:sub-description;margin-left:var(--ids_size_general_8x);text-align:right}.ids-list-item--selector,:host.ids-list-item--selector{position:relative}@supports (-webkit-touch-callout: none){.ids-list-item--selector,:host.ids-list-item--selector{overflow:hidden}}.ids-list-item--selector .ids-switch,.ids-list-item--selector .ids-radio-button,.ids-list-item--selector .ids-checkbox,:host.ids-list-item--selector .ids-switch,:host.ids-list-item--selector .ids-radio-button,:host.ids-list-item--selector .ids-checkbox{min-height:auto;position:static}.ids-list-item--selector .ids-switch__input,.ids-list-item--selector .ids-radio-button__input,.ids-list-item--selector .ids-checkbox__input,:host.ids-list-item--selector .ids-switch__input,:host.ids-list-item--selector .ids-radio-button__input,:host.ids-list-item--selector .ids-checkbox__input{outline-offset:0}.ids-list-item--selector ::ng-deep .ids-switch,.ids-list-item--selector ::ng-deep .ids-checkbox,.ids-list-item--selector ::ng-deep .ids-radio-button,:host.ids-list-item--selector ::ng-deep .ids-switch,:host.ids-list-item--selector ::ng-deep .ids-checkbox,:host.ids-list-item--selector ::ng-deep .ids-radio-button{min-height:auto;position:static}.ids-list-item--selector ::ng-deep .ids-switch__input,.ids-list-item--selector ::ng-deep .ids-checkbox__input,.ids-list-item--selector ::ng-deep .ids-radio-button__input,:host.ids-list-item--selector ::ng-deep .ids-switch__input,:host.ids-list-item--selector ::ng-deep .ids-checkbox__input,:host.ids-list-item--selector ::ng-deep .ids-radio-button__input{outline-offset:0}button.ids-list-item,button:host.ids-list-item{background-color:transparent;border-left:0;border-right:0;border-top:0;cursor:pointer;padding:0;text-decoration:none}button.ids-list-item:not(.ids-list-item--line-off),button:host.ids-list-item:not(.ids-list-item--line-off){border-bottom-color:var(--ids_color_border_soft)}button.ids-list-item:disabled,button.ids-list-item[aria-disabled=true],button:host.ids-list-item:disabled,button:host.ids-list-item[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}button.ids-list-item:disabled .ids-list-item__sub-text,button.ids-list-item:disabled .ids-list-item__sub-description,button.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,button.ids-list-item[aria-disabled=true] .ids-list-item__sub-description,button:host.ids-list-item:disabled .ids-list-item__sub-text,button:host.ids-list-item:disabled .ids-list-item__sub-description,button:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,button:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-description{color:inherit}button.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,button.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description{color:inherit}button.ids-list-item:disabled ::ng-deep .ids-list-item__action,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__action,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}button.ids-list-item:disabled .ids-list-item__action,button.ids-list-item[aria-disabled=true] .ids-list-item__action,button:host.ids-list-item:disabled .ids-list-item__action,button:host.ids-list-item[aria-disabled=true] .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){button.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),button.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}}button.ids-list-item:active:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}a.ids-list-item,a:host.ids-list-item{background-color:transparent;border-left:0;border-right:0;border-top:0;cursor:pointer;padding:0;text-decoration:none}a.ids-list-item:not(.ids-list-item--line-off),a:host.ids-list-item:not(.ids-list-item--line-off){border-bottom-color:var(--ids_color_border_soft)}a.ids-list-item:disabled,a.ids-list-item[aria-disabled=true],a:host.ids-list-item:disabled,a:host.ids-list-item[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}a.ids-list-item:disabled .ids-list-item__sub-text,a.ids-list-item:disabled .ids-list-item__sub-description,a.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,a.ids-list-item[aria-disabled=true] .ids-list-item__sub-description,a:host.ids-list-item:disabled .ids-list-item__sub-text,a:host.ids-list-item:disabled .ids-list-item__sub-description,a:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,a:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-description{color:inherit}a.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,a.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description{color:inherit}a.ids-list-item:disabled ::ng-deep .ids-list-item__action,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__action,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}a.ids-list-item:disabled .ids-list-item__action,a.ids-list-item[aria-disabled=true] .ids-list-item__action,a:host.ids-list-item:disabled .ids-list-item__action,a:host.ids-list-item[aria-disabled=true] .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){a.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),a.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}}a.ids-list-item:active:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}.ids-list-item--line-off,:host.ids-list-item--line-off{border-bottom-color:transparent}.ids-list,:host.ids-list{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;background-color:var(--ids_color_bg_base);color:var(--ids_color_feedback_neutral);font:var(--ids_textStyle_f02_s16_h24_wrg);list-style:none}.ids-list>li:not(.ids-list-item),:host.ids-list>li:not(.ids-list-item){all:unset;all:revert;box-sizing:border-box}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: IdsIconModule }, { kind: "component", type: IdsIconComponent, selector: "ids-icon", inputs: ["size", "variant", "contrast"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsListItemComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, host: {
                        '[class.ids-list-item]': 'true',
                        '[class.ids-list-item--action]': 'isAction',
                        '[class.ids-list-item--selector]': 'isSelector',
                        '[class.ids-list-item--line-off]': 'lineOff',
                    }, imports: [CommonModule, IdsIconModule], selector: '[idsLi]', standalone: true, template: `<span
    class="ids-list-item__content"
    [attr.role]="!isSelector && !hasFavoriteButton ? 'text' : null"
  >
    <ng-content></ng-content>
    <!-- TODO: mudar para neutral -->
    <ids-icon class="ids-list-item__action" *ngIf="isAction" size="S">
      {{ actionIcon }}
    </ids-icon>
  </span>`, providers: [
                        {
                            provide: FormSelectionService,
                        },
                    ], styles: [".ids-list-item,:host.ids-list-item{--ids-list-item-label-width: minmax(15%, auto);--ids-list-item-description-width: fit-content(100%);all:unset;all:revert;background:var(--ids_color_bg_base);border:0;border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_soft);box-sizing:border-box;color:var(--ids_color_feedback_neutral);display:block;font:var(--ids_textStyle_f02_s16_h24_wbd);text-align:left;text-decoration:inherit;width:100%}.ids-list-item .ids-icon-button,:host.ids-list-item .ids-icon-button{margin-right:var(--ids_size_general_1x);min-height:auto;padding-bottom:0;padding-top:0}.ids-list-item ::ng-deep .ids-icon-button,:host.ids-list-item ::ng-deep .ids-icon-button{margin-right:var(--ids_size_general_1x);min-height:auto;padding-bottom:0;padding-top:0}.ids-list-item__content,:host.ids-list-item__content{all:unset;all:revert;align-items:center;box-sizing:border-box;display:grid;grid-template-areas:\"icon text description action\" \"icon sub-text sub-description action\";grid-template-columns:min-content var(--ids-list-item-label-width) var(--ids-list-item-description-width) min-content;min-height:3.9375rem;overflow:hidden;padding:var(--ids_size_general_16x) 0 calc(var(--ids_size_general_16x) - var(--ids_size_border_small))}.ids-list-item__content:has(.ids-list-item__sub-text),:host.ids-list-item__content:has(.ids-list-item__sub-text){min-height:4.9375rem}.ids-list-item__icon,:host.ids-list-item__icon{align-self:center;grid-area:icon;line-height:1;margin-right:var(--ids_size_general_16x);text-align:center}::ng-deep .ids-list-item__icon,::ng-deep :host.ids-list-item__icon{align-self:center;grid-area:icon;line-height:1;margin-right:var(--ids_size_general_16x);text-align:center}.ids-list-item__text,:host.ids-list-item__text{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;align-self:flex-end;grid-area:text;overflow:hidden}.ids-list-item__text--double-line,:host.ids-list-item__text--double-line{align-self:initial;grid-row:span 2}::ng-deep .ids-list-item__text,::ng-deep :host.ids-list-item__text{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;align-self:flex-end;grid-area:text;overflow:hidden}::ng-deep .ids-list-item__text--double-line,::ng-deep :host.ids-list-item__text--double-line{align-self:initial;grid-row:span 2}.ids-list-item__description,:host.ids-list-item__description{align-self:flex-end;grid-area:description;margin-left:var(--ids_size_general_8x);text-align:right}.ids-list-item__description:not(.ids-tag):not(.ids-number-badge),:host.ids-list-item__description:not(.ids-tag):not(.ids-number-badge){font:var(--ids_textStyle_f02_s16_h24_wrg)}.ids-list-item__description--double-line,:host.ids-list-item__description--double-line{align-self:initial;grid-row:span 2}::ng-deep .ids-list-item__description,::ng-deep :host.ids-list-item__description{align-self:flex-end;grid-area:description;margin-left:var(--ids_size_general_8x);text-align:right}::ng-deep .ids-list-item__description:not(.ids-tag):not(.ids-number-badge),::ng-deep :host.ids-list-item__description:not(.ids-tag):not(.ids-number-badge){font:var(--ids_textStyle_f02_s16_h24_wrg)}::ng-deep .ids-list-item__description--double-line,::ng-deep :host.ids-list-item__description--double-line{align-self:initial;grid-row:span 2}.ids-list-item__action,:host.ids-list-item__action{align-self:center;color:var(--ids_color_feedback_neutral);display:flex;grid-area:action;justify-content:center;margin-left:var(--ids_size_general_8x);min-width:var(--ids_size_general_24x);text-align:center}::ng-deep .ids-list-item__action,::ng-deep :host.ids-list-item__action{align-self:center;color:var(--ids_color_feedback_neutral);display:flex;grid-area:action;justify-content:center;margin-left:var(--ids_size_general_8x);min-width:var(--ids_size_general_24x);text-align:center}.ids-list-item__sub-text,:host.ids-list-item__sub-text{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s16_h24_wrg);grid-area:sub-text}::ng-deep .ids-list-item__sub-text,::ng-deep :host.ids-list-item__sub-text{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s16_h24_wrg);grid-area:sub-text}.ids-list-item__sub-description,:host.ids-list-item__sub-description{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s14_h20_wrg);grid-area:sub-description;margin-left:var(--ids_size_general_8x);text-align:right}::ng-deep .ids-list-item__sub-description,::ng-deep :host.ids-list-item__sub-description{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s14_h20_wrg);grid-area:sub-description;margin-left:var(--ids_size_general_8x);text-align:right}.ids-list-item--selector,:host.ids-list-item--selector{position:relative}@supports (-webkit-touch-callout: none){.ids-list-item--selector,:host.ids-list-item--selector{overflow:hidden}}.ids-list-item--selector .ids-switch,.ids-list-item--selector .ids-radio-button,.ids-list-item--selector .ids-checkbox,:host.ids-list-item--selector .ids-switch,:host.ids-list-item--selector .ids-radio-button,:host.ids-list-item--selector .ids-checkbox{min-height:auto;position:static}.ids-list-item--selector .ids-switch__input,.ids-list-item--selector .ids-radio-button__input,.ids-list-item--selector .ids-checkbox__input,:host.ids-list-item--selector .ids-switch__input,:host.ids-list-item--selector .ids-radio-button__input,:host.ids-list-item--selector .ids-checkbox__input{outline-offset:0}.ids-list-item--selector ::ng-deep .ids-switch,.ids-list-item--selector ::ng-deep .ids-checkbox,.ids-list-item--selector ::ng-deep .ids-radio-button,:host.ids-list-item--selector ::ng-deep .ids-switch,:host.ids-list-item--selector ::ng-deep .ids-checkbox,:host.ids-list-item--selector ::ng-deep .ids-radio-button{min-height:auto;position:static}.ids-list-item--selector ::ng-deep .ids-switch__input,.ids-list-item--selector ::ng-deep .ids-checkbox__input,.ids-list-item--selector ::ng-deep .ids-radio-button__input,:host.ids-list-item--selector ::ng-deep .ids-switch__input,:host.ids-list-item--selector ::ng-deep .ids-checkbox__input,:host.ids-list-item--selector ::ng-deep .ids-radio-button__input{outline-offset:0}button.ids-list-item,button:host.ids-list-item{background-color:transparent;border-left:0;border-right:0;border-top:0;cursor:pointer;padding:0;text-decoration:none}button.ids-list-item:not(.ids-list-item--line-off),button:host.ids-list-item:not(.ids-list-item--line-off){border-bottom-color:var(--ids_color_border_soft)}button.ids-list-item:disabled,button.ids-list-item[aria-disabled=true],button:host.ids-list-item:disabled,button:host.ids-list-item[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}button.ids-list-item:disabled .ids-list-item__sub-text,button.ids-list-item:disabled .ids-list-item__sub-description,button.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,button.ids-list-item[aria-disabled=true] .ids-list-item__sub-description,button:host.ids-list-item:disabled .ids-list-item__sub-text,button:host.ids-list-item:disabled .ids-list-item__sub-description,button:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,button:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-description{color:inherit}button.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,button.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description{color:inherit}button.ids-list-item:disabled ::ng-deep .ids-list-item__action,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__action,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}button.ids-list-item:disabled .ids-list-item__action,button.ids-list-item[aria-disabled=true] .ids-list-item__action,button:host.ids-list-item:disabled .ids-list-item__action,button:host.ids-list-item[aria-disabled=true] .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){button.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),button.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}}button.ids-list-item:active:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}a.ids-list-item,a:host.ids-list-item{background-color:transparent;border-left:0;border-right:0;border-top:0;cursor:pointer;padding:0;text-decoration:none}a.ids-list-item:not(.ids-list-item--line-off),a:host.ids-list-item:not(.ids-list-item--line-off){border-bottom-color:var(--ids_color_border_soft)}a.ids-list-item:disabled,a.ids-list-item[aria-disabled=true],a:host.ids-list-item:disabled,a:host.ids-list-item[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}a.ids-list-item:disabled .ids-list-item__sub-text,a.ids-list-item:disabled .ids-list-item__sub-description,a.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,a.ids-list-item[aria-disabled=true] .ids-list-item__sub-description,a:host.ids-list-item:disabled .ids-list-item__sub-text,a:host.ids-list-item:disabled .ids-list-item__sub-description,a:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,a:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-description{color:inherit}a.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,a.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description{color:inherit}a.ids-list-item:disabled ::ng-deep .ids-list-item__action,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__action,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}a.ids-list-item:disabled .ids-list-item__action,a.ids-list-item[aria-disabled=true] .ids-list-item__action,a:host.ids-list-item:disabled .ids-list-item__action,a:host.ids-list-item[aria-disabled=true] .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){a.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),a.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}}a.ids-list-item:active:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}.ids-list-item--line-off,:host.ids-list-item--line-off{border-bottom-color:transparent}.ids-list,:host.ids-list{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;background-color:var(--ids_color_bg_base);color:var(--ids_color_feedback_neutral);font:var(--ids_textStyle_f02_s16_h24_wrg);list-style:none}.ids-list>li:not(.ids-list-item),:host.ids-list>li:not(.ids-list-item){all:unset;all:revert;box-sizing:border-box}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { lineOff: [{
                type: Input
            }], actionIcon: [{
                type: Input
            }], labelWidth: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['style.--ids-list-item-label-width']
            }], descriptionWidth: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['style.--ids-list-item-description-width']
            }], hasRadioButton: [{
                type: ContentChild,
                args: [IdsRadioButtonDirective]
            }], hasCheckbox: [{
                type: ContentChild,
                args: [IdsCheckboxDirective]
            }], hasSwitch: [{
                type: ContentChild,
                args: [IdsSwitchDirective]
            }], hasFavoriteButton: [{
                type: ContentChild,
                args: [IdsFavoriteButtonComponent]
            }] } });

/**
 * Componente Tag de Lista
 *
 * **Module:**
 *
 * `import { IdsListModule } from '@ids/angular';`
 *
 * **Component:**
 *
 * `import { IdsListTagComponent } from '@ids/angular';`
 */
class IdsListTagComponent {
}
IdsListTagComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsListTagComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IdsListTagComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsListTagComponent, isStandalone: true, selector: "[idsList]", host: { attributes: { "role": "list" }, classAttribute: "ids-list" }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, styles: [".ids-list-item,:host.ids-list-item{--ids-list-item-label-width: minmax(15%, auto);--ids-list-item-description-width: fit-content(100%);all:unset;all:revert;background:var(--ids_color_bg_base);border:0;border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_soft);box-sizing:border-box;color:var(--ids_color_feedback_neutral);display:block;font:var(--ids_textStyle_f02_s16_h24_wbd);text-align:left;text-decoration:inherit;width:100%}.ids-list-item .ids-icon-button,:host.ids-list-item .ids-icon-button{margin-right:var(--ids_size_general_1x);min-height:auto;padding-bottom:0;padding-top:0}.ids-list-item ::ng-deep .ids-icon-button,:host.ids-list-item ::ng-deep .ids-icon-button{margin-right:var(--ids_size_general_1x);min-height:auto;padding-bottom:0;padding-top:0}.ids-list-item__content,:host.ids-list-item__content{all:unset;all:revert;align-items:center;box-sizing:border-box;display:grid;grid-template-areas:\"icon text description action\" \"icon sub-text sub-description action\";grid-template-columns:min-content var(--ids-list-item-label-width) var(--ids-list-item-description-width) min-content;min-height:3.9375rem;overflow:hidden;padding:var(--ids_size_general_16x) 0 calc(var(--ids_size_general_16x) - var(--ids_size_border_small))}.ids-list-item__content:has(.ids-list-item__sub-text),:host.ids-list-item__content:has(.ids-list-item__sub-text){min-height:4.9375rem}.ids-list-item__icon,:host.ids-list-item__icon{align-self:center;grid-area:icon;line-height:1;margin-right:var(--ids_size_general_16x);text-align:center}::ng-deep .ids-list-item__icon,::ng-deep :host.ids-list-item__icon{align-self:center;grid-area:icon;line-height:1;margin-right:var(--ids_size_general_16x);text-align:center}.ids-list-item__text,:host.ids-list-item__text{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;align-self:flex-end;grid-area:text;overflow:hidden}.ids-list-item__text--double-line,:host.ids-list-item__text--double-line{align-self:initial;grid-row:span 2}::ng-deep .ids-list-item__text,::ng-deep :host.ids-list-item__text{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;align-self:flex-end;grid-area:text;overflow:hidden}::ng-deep .ids-list-item__text--double-line,::ng-deep :host.ids-list-item__text--double-line{align-self:initial;grid-row:span 2}.ids-list-item__description,:host.ids-list-item__description{align-self:flex-end;grid-area:description;margin-left:var(--ids_size_general_8x);text-align:right}.ids-list-item__description:not(.ids-tag):not(.ids-number-badge),:host.ids-list-item__description:not(.ids-tag):not(.ids-number-badge){font:var(--ids_textStyle_f02_s16_h24_wrg)}.ids-list-item__description--double-line,:host.ids-list-item__description--double-line{align-self:initial;grid-row:span 2}::ng-deep .ids-list-item__description,::ng-deep :host.ids-list-item__description{align-self:flex-end;grid-area:description;margin-left:var(--ids_size_general_8x);text-align:right}::ng-deep .ids-list-item__description:not(.ids-tag):not(.ids-number-badge),::ng-deep :host.ids-list-item__description:not(.ids-tag):not(.ids-number-badge){font:var(--ids_textStyle_f02_s16_h24_wrg)}::ng-deep .ids-list-item__description--double-line,::ng-deep :host.ids-list-item__description--double-line{align-self:initial;grid-row:span 2}.ids-list-item__action,:host.ids-list-item__action{align-self:center;color:var(--ids_color_feedback_neutral);display:flex;grid-area:action;justify-content:center;margin-left:var(--ids_size_general_8x);min-width:var(--ids_size_general_24x);text-align:center}::ng-deep .ids-list-item__action,::ng-deep :host.ids-list-item__action{align-self:center;color:var(--ids_color_feedback_neutral);display:flex;grid-area:action;justify-content:center;margin-left:var(--ids_size_general_8x);min-width:var(--ids_size_general_24x);text-align:center}.ids-list-item__sub-text,:host.ids-list-item__sub-text{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s16_h24_wrg);grid-area:sub-text}::ng-deep .ids-list-item__sub-text,::ng-deep :host.ids-list-item__sub-text{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s16_h24_wrg);grid-area:sub-text}.ids-list-item__sub-description,:host.ids-list-item__sub-description{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s14_h20_wrg);grid-area:sub-description;margin-left:var(--ids_size_general_8x);text-align:right}::ng-deep .ids-list-item__sub-description,::ng-deep :host.ids-list-item__sub-description{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s14_h20_wrg);grid-area:sub-description;margin-left:var(--ids_size_general_8x);text-align:right}.ids-list-item--selector,:host.ids-list-item--selector{position:relative}@supports (-webkit-touch-callout: none){.ids-list-item--selector,:host.ids-list-item--selector{overflow:hidden}}.ids-list-item--selector .ids-switch,.ids-list-item--selector .ids-radio-button,.ids-list-item--selector .ids-checkbox,:host.ids-list-item--selector .ids-switch,:host.ids-list-item--selector .ids-radio-button,:host.ids-list-item--selector .ids-checkbox{min-height:auto;position:static}.ids-list-item--selector .ids-switch__input,.ids-list-item--selector .ids-radio-button__input,.ids-list-item--selector .ids-checkbox__input,:host.ids-list-item--selector .ids-switch__input,:host.ids-list-item--selector .ids-radio-button__input,:host.ids-list-item--selector .ids-checkbox__input{outline-offset:0}.ids-list-item--selector ::ng-deep .ids-switch,.ids-list-item--selector ::ng-deep .ids-checkbox,.ids-list-item--selector ::ng-deep .ids-radio-button,:host.ids-list-item--selector ::ng-deep .ids-switch,:host.ids-list-item--selector ::ng-deep .ids-checkbox,:host.ids-list-item--selector ::ng-deep .ids-radio-button{min-height:auto;position:static}.ids-list-item--selector ::ng-deep .ids-switch__input,.ids-list-item--selector ::ng-deep .ids-checkbox__input,.ids-list-item--selector ::ng-deep .ids-radio-button__input,:host.ids-list-item--selector ::ng-deep .ids-switch__input,:host.ids-list-item--selector ::ng-deep .ids-checkbox__input,:host.ids-list-item--selector ::ng-deep .ids-radio-button__input{outline-offset:0}button.ids-list-item,button:host.ids-list-item{background-color:transparent;border-left:0;border-right:0;border-top:0;cursor:pointer;padding:0;text-decoration:none}button.ids-list-item:not(.ids-list-item--line-off),button:host.ids-list-item:not(.ids-list-item--line-off){border-bottom-color:var(--ids_color_border_soft)}button.ids-list-item:disabled,button.ids-list-item[aria-disabled=true],button:host.ids-list-item:disabled,button:host.ids-list-item[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}button.ids-list-item:disabled .ids-list-item__sub-text,button.ids-list-item:disabled .ids-list-item__sub-description,button.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,button.ids-list-item[aria-disabled=true] .ids-list-item__sub-description,button:host.ids-list-item:disabled .ids-list-item__sub-text,button:host.ids-list-item:disabled .ids-list-item__sub-description,button:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,button:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-description{color:inherit}button.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,button.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description{color:inherit}button.ids-list-item:disabled ::ng-deep .ids-list-item__action,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__action,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}button.ids-list-item:disabled .ids-list-item__action,button.ids-list-item[aria-disabled=true] .ids-list-item__action,button:host.ids-list-item:disabled .ids-list-item__action,button:host.ids-list-item[aria-disabled=true] .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){button.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),button.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}}button.ids-list-item:active:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}a.ids-list-item,a:host.ids-list-item{background-color:transparent;border-left:0;border-right:0;border-top:0;cursor:pointer;padding:0;text-decoration:none}a.ids-list-item:not(.ids-list-item--line-off),a:host.ids-list-item:not(.ids-list-item--line-off){border-bottom-color:var(--ids_color_border_soft)}a.ids-list-item:disabled,a.ids-list-item[aria-disabled=true],a:host.ids-list-item:disabled,a:host.ids-list-item[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}a.ids-list-item:disabled .ids-list-item__sub-text,a.ids-list-item:disabled .ids-list-item__sub-description,a.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,a.ids-list-item[aria-disabled=true] .ids-list-item__sub-description,a:host.ids-list-item:disabled .ids-list-item__sub-text,a:host.ids-list-item:disabled .ids-list-item__sub-description,a:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,a:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-description{color:inherit}a.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,a.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description{color:inherit}a.ids-list-item:disabled ::ng-deep .ids-list-item__action,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__action,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}a.ids-list-item:disabled .ids-list-item__action,a.ids-list-item[aria-disabled=true] .ids-list-item__action,a:host.ids-list-item:disabled .ids-list-item__action,a:host.ids-list-item[aria-disabled=true] .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){a.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),a.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}}a.ids-list-item:active:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}.ids-list-item--line-off,:host.ids-list-item--line-off{border-bottom-color:transparent}.ids-list,:host.ids-list{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;background-color:var(--ids_color_bg_base);color:var(--ids_color_feedback_neutral);font:var(--ids_textStyle_f02_s16_h24_wrg);list-style:none}.ids-list>li:not(.ids-list-item),:host.ids-list>li:not(.ids-list-item){all:unset;all:revert;box-sizing:border-box}\n"], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsListTagComponent, decorators: [{
            type: Component,
            args: [{ host: {
                        role: 'list',
                        class: 'ids-list',
                    }, selector: '[idsList]', changeDetection: ChangeDetectionStrategy.OnPush, standalone: true, template: '<ng-content></ng-content>', styles: [".ids-list-item,:host.ids-list-item{--ids-list-item-label-width: minmax(15%, auto);--ids-list-item-description-width: fit-content(100%);all:unset;all:revert;background:var(--ids_color_bg_base);border:0;border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_soft);box-sizing:border-box;color:var(--ids_color_feedback_neutral);display:block;font:var(--ids_textStyle_f02_s16_h24_wbd);text-align:left;text-decoration:inherit;width:100%}.ids-list-item .ids-icon-button,:host.ids-list-item .ids-icon-button{margin-right:var(--ids_size_general_1x);min-height:auto;padding-bottom:0;padding-top:0}.ids-list-item ::ng-deep .ids-icon-button,:host.ids-list-item ::ng-deep .ids-icon-button{margin-right:var(--ids_size_general_1x);min-height:auto;padding-bottom:0;padding-top:0}.ids-list-item__content,:host.ids-list-item__content{all:unset;all:revert;align-items:center;box-sizing:border-box;display:grid;grid-template-areas:\"icon text description action\" \"icon sub-text sub-description action\";grid-template-columns:min-content var(--ids-list-item-label-width) var(--ids-list-item-description-width) min-content;min-height:3.9375rem;overflow:hidden;padding:var(--ids_size_general_16x) 0 calc(var(--ids_size_general_16x) - var(--ids_size_border_small))}.ids-list-item__content:has(.ids-list-item__sub-text),:host.ids-list-item__content:has(.ids-list-item__sub-text){min-height:4.9375rem}.ids-list-item__icon,:host.ids-list-item__icon{align-self:center;grid-area:icon;line-height:1;margin-right:var(--ids_size_general_16x);text-align:center}::ng-deep .ids-list-item__icon,::ng-deep :host.ids-list-item__icon{align-self:center;grid-area:icon;line-height:1;margin-right:var(--ids_size_general_16x);text-align:center}.ids-list-item__text,:host.ids-list-item__text{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;align-self:flex-end;grid-area:text;overflow:hidden}.ids-list-item__text--double-line,:host.ids-list-item__text--double-line{align-self:initial;grid-row:span 2}::ng-deep .ids-list-item__text,::ng-deep :host.ids-list-item__text{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;align-self:flex-end;grid-area:text;overflow:hidden}::ng-deep .ids-list-item__text--double-line,::ng-deep :host.ids-list-item__text--double-line{align-self:initial;grid-row:span 2}.ids-list-item__description,:host.ids-list-item__description{align-self:flex-end;grid-area:description;margin-left:var(--ids_size_general_8x);text-align:right}.ids-list-item__description:not(.ids-tag):not(.ids-number-badge),:host.ids-list-item__description:not(.ids-tag):not(.ids-number-badge){font:var(--ids_textStyle_f02_s16_h24_wrg)}.ids-list-item__description--double-line,:host.ids-list-item__description--double-line{align-self:initial;grid-row:span 2}::ng-deep .ids-list-item__description,::ng-deep :host.ids-list-item__description{align-self:flex-end;grid-area:description;margin-left:var(--ids_size_general_8x);text-align:right}::ng-deep .ids-list-item__description:not(.ids-tag):not(.ids-number-badge),::ng-deep :host.ids-list-item__description:not(.ids-tag):not(.ids-number-badge){font:var(--ids_textStyle_f02_s16_h24_wrg)}::ng-deep .ids-list-item__description--double-line,::ng-deep :host.ids-list-item__description--double-line{align-self:initial;grid-row:span 2}.ids-list-item__action,:host.ids-list-item__action{align-self:center;color:var(--ids_color_feedback_neutral);display:flex;grid-area:action;justify-content:center;margin-left:var(--ids_size_general_8x);min-width:var(--ids_size_general_24x);text-align:center}::ng-deep .ids-list-item__action,::ng-deep :host.ids-list-item__action{align-self:center;color:var(--ids_color_feedback_neutral);display:flex;grid-area:action;justify-content:center;margin-left:var(--ids_size_general_8x);min-width:var(--ids_size_general_24x);text-align:center}.ids-list-item__sub-text,:host.ids-list-item__sub-text{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s16_h24_wrg);grid-area:sub-text}::ng-deep .ids-list-item__sub-text,::ng-deep :host.ids-list-item__sub-text{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s16_h24_wrg);grid-area:sub-text}.ids-list-item__sub-description,:host.ids-list-item__sub-description{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s14_h20_wrg);grid-area:sub-description;margin-left:var(--ids_size_general_8x);text-align:right}::ng-deep .ids-list-item__sub-description,::ng-deep :host.ids-list-item__sub-description{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s14_h20_wrg);grid-area:sub-description;margin-left:var(--ids_size_general_8x);text-align:right}.ids-list-item--selector,:host.ids-list-item--selector{position:relative}@supports (-webkit-touch-callout: none){.ids-list-item--selector,:host.ids-list-item--selector{overflow:hidden}}.ids-list-item--selector .ids-switch,.ids-list-item--selector .ids-radio-button,.ids-list-item--selector .ids-checkbox,:host.ids-list-item--selector .ids-switch,:host.ids-list-item--selector .ids-radio-button,:host.ids-list-item--selector .ids-checkbox{min-height:auto;position:static}.ids-list-item--selector .ids-switch__input,.ids-list-item--selector .ids-radio-button__input,.ids-list-item--selector .ids-checkbox__input,:host.ids-list-item--selector .ids-switch__input,:host.ids-list-item--selector .ids-radio-button__input,:host.ids-list-item--selector .ids-checkbox__input{outline-offset:0}.ids-list-item--selector ::ng-deep .ids-switch,.ids-list-item--selector ::ng-deep .ids-checkbox,.ids-list-item--selector ::ng-deep .ids-radio-button,:host.ids-list-item--selector ::ng-deep .ids-switch,:host.ids-list-item--selector ::ng-deep .ids-checkbox,:host.ids-list-item--selector ::ng-deep .ids-radio-button{min-height:auto;position:static}.ids-list-item--selector ::ng-deep .ids-switch__input,.ids-list-item--selector ::ng-deep .ids-checkbox__input,.ids-list-item--selector ::ng-deep .ids-radio-button__input,:host.ids-list-item--selector ::ng-deep .ids-switch__input,:host.ids-list-item--selector ::ng-deep .ids-checkbox__input,:host.ids-list-item--selector ::ng-deep .ids-radio-button__input{outline-offset:0}button.ids-list-item,button:host.ids-list-item{background-color:transparent;border-left:0;border-right:0;border-top:0;cursor:pointer;padding:0;text-decoration:none}button.ids-list-item:not(.ids-list-item--line-off),button:host.ids-list-item:not(.ids-list-item--line-off){border-bottom-color:var(--ids_color_border_soft)}button.ids-list-item:disabled,button.ids-list-item[aria-disabled=true],button:host.ids-list-item:disabled,button:host.ids-list-item[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}button.ids-list-item:disabled .ids-list-item__sub-text,button.ids-list-item:disabled .ids-list-item__sub-description,button.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,button.ids-list-item[aria-disabled=true] .ids-list-item__sub-description,button:host.ids-list-item:disabled .ids-list-item__sub-text,button:host.ids-list-item:disabled .ids-list-item__sub-description,button:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,button:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-description{color:inherit}button.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,button.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description{color:inherit}button.ids-list-item:disabled ::ng-deep .ids-list-item__action,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__action,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}button.ids-list-item:disabled .ids-list-item__action,button.ids-list-item[aria-disabled=true] .ids-list-item__action,button:host.ids-list-item:disabled .ids-list-item__action,button:host.ids-list-item[aria-disabled=true] .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){button.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),button.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}}button.ids-list-item:active:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}a.ids-list-item,a:host.ids-list-item{background-color:transparent;border-left:0;border-right:0;border-top:0;cursor:pointer;padding:0;text-decoration:none}a.ids-list-item:not(.ids-list-item--line-off),a:host.ids-list-item:not(.ids-list-item--line-off){border-bottom-color:var(--ids_color_border_soft)}a.ids-list-item:disabled,a.ids-list-item[aria-disabled=true],a:host.ids-list-item:disabled,a:host.ids-list-item[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}a.ids-list-item:disabled .ids-list-item__sub-text,a.ids-list-item:disabled .ids-list-item__sub-description,a.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,a.ids-list-item[aria-disabled=true] .ids-list-item__sub-description,a:host.ids-list-item:disabled .ids-list-item__sub-text,a:host.ids-list-item:disabled .ids-list-item__sub-description,a:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,a:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-description{color:inherit}a.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,a.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description{color:inherit}a.ids-list-item:disabled ::ng-deep .ids-list-item__action,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__action,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}a.ids-list-item:disabled .ids-list-item__action,a.ids-list-item[aria-disabled=true] .ids-list-item__action,a:host.ids-list-item:disabled .ids-list-item__action,a:host.ids-list-item[aria-disabled=true] .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){a.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),a.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}}a.ids-list-item:active:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}.ids-list-item--line-off,:host.ids-list-item--line-off{border-bottom-color:transparent}.ids-list,:host.ids-list{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;background-color:var(--ids_color_bg_base);color:var(--ids_color_feedback_neutral);font:var(--ids_textStyle_f02_s16_h24_wrg);list-style:none}.ids-list>li:not(.ids-list-item),:host.ids-list>li:not(.ids-list-item){all:unset;all:revert;box-sizing:border-box}\n"] }]
        }] });
/**
 * Componente de Lista
 *
 * **Module:**
 *
 * `import { IdsListModule } from '@ids/angular';`
 *
 * **Component:**
 *
 * `import { IdsListComponent } from '@ids/angular';`
 *
 * A lista utiliza subcomponentes para especificar o tipo de item que será adicionado.
 * Também possui diretivas para a construção e customização desses itens.
 *
 * Sendo os componentes:
 * * list: `<ids-list>`*
 * * list-item: `<li listItem>`
 *
 * Sendo e os elementos do item:
 *
 * - text: `<[idsLiText]>`*
 * - sub-text: `<[idsLiSubText]>`*
 * - description: `<[idsLiDescription]>`*
 * - subdescription: `<[idsLiSubDescription]>`*
 */
class IdsListComponent {
}
IdsListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IdsListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsListComponent, isStandalone: true, selector: "ids-list", ngImport: i0, template: `<ul idsList>
    <ng-content></ng-content>
  </ul>`, isInline: true, styles: [".ids-list-item,:host.ids-list-item{--ids-list-item-label-width: minmax(15%, auto);--ids-list-item-description-width: fit-content(100%);all:unset;all:revert;background:var(--ids_color_bg_base);border:0;border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_soft);box-sizing:border-box;color:var(--ids_color_feedback_neutral);display:block;font:var(--ids_textStyle_f02_s16_h24_wbd);text-align:left;text-decoration:inherit;width:100%}.ids-list-item .ids-icon-button,:host.ids-list-item .ids-icon-button{margin-right:var(--ids_size_general_1x);min-height:auto;padding-bottom:0;padding-top:0}.ids-list-item ::ng-deep .ids-icon-button,:host.ids-list-item ::ng-deep .ids-icon-button{margin-right:var(--ids_size_general_1x);min-height:auto;padding-bottom:0;padding-top:0}.ids-list-item__content,:host.ids-list-item__content{all:unset;all:revert;align-items:center;box-sizing:border-box;display:grid;grid-template-areas:\"icon text description action\" \"icon sub-text sub-description action\";grid-template-columns:min-content var(--ids-list-item-label-width) var(--ids-list-item-description-width) min-content;min-height:3.9375rem;overflow:hidden;padding:var(--ids_size_general_16x) 0 calc(var(--ids_size_general_16x) - var(--ids_size_border_small))}.ids-list-item__content:has(.ids-list-item__sub-text),:host.ids-list-item__content:has(.ids-list-item__sub-text){min-height:4.9375rem}.ids-list-item__icon,:host.ids-list-item__icon{align-self:center;grid-area:icon;line-height:1;margin-right:var(--ids_size_general_16x);text-align:center}::ng-deep .ids-list-item__icon,::ng-deep :host.ids-list-item__icon{align-self:center;grid-area:icon;line-height:1;margin-right:var(--ids_size_general_16x);text-align:center}.ids-list-item__text,:host.ids-list-item__text{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;align-self:flex-end;grid-area:text;overflow:hidden}.ids-list-item__text--double-line,:host.ids-list-item__text--double-line{align-self:initial;grid-row:span 2}::ng-deep .ids-list-item__text,::ng-deep :host.ids-list-item__text{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;align-self:flex-end;grid-area:text;overflow:hidden}::ng-deep .ids-list-item__text--double-line,::ng-deep :host.ids-list-item__text--double-line{align-self:initial;grid-row:span 2}.ids-list-item__description,:host.ids-list-item__description{align-self:flex-end;grid-area:description;margin-left:var(--ids_size_general_8x);text-align:right}.ids-list-item__description:not(.ids-tag):not(.ids-number-badge),:host.ids-list-item__description:not(.ids-tag):not(.ids-number-badge){font:var(--ids_textStyle_f02_s16_h24_wrg)}.ids-list-item__description--double-line,:host.ids-list-item__description--double-line{align-self:initial;grid-row:span 2}::ng-deep .ids-list-item__description,::ng-deep :host.ids-list-item__description{align-self:flex-end;grid-area:description;margin-left:var(--ids_size_general_8x);text-align:right}::ng-deep .ids-list-item__description:not(.ids-tag):not(.ids-number-badge),::ng-deep :host.ids-list-item__description:not(.ids-tag):not(.ids-number-badge){font:var(--ids_textStyle_f02_s16_h24_wrg)}::ng-deep .ids-list-item__description--double-line,::ng-deep :host.ids-list-item__description--double-line{align-self:initial;grid-row:span 2}.ids-list-item__action,:host.ids-list-item__action{align-self:center;color:var(--ids_color_feedback_neutral);display:flex;grid-area:action;justify-content:center;margin-left:var(--ids_size_general_8x);min-width:var(--ids_size_general_24x);text-align:center}::ng-deep .ids-list-item__action,::ng-deep :host.ids-list-item__action{align-self:center;color:var(--ids_color_feedback_neutral);display:flex;grid-area:action;justify-content:center;margin-left:var(--ids_size_general_8x);min-width:var(--ids_size_general_24x);text-align:center}.ids-list-item__sub-text,:host.ids-list-item__sub-text{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s16_h24_wrg);grid-area:sub-text}::ng-deep .ids-list-item__sub-text,::ng-deep :host.ids-list-item__sub-text{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s16_h24_wrg);grid-area:sub-text}.ids-list-item__sub-description,:host.ids-list-item__sub-description{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s14_h20_wrg);grid-area:sub-description;margin-left:var(--ids_size_general_8x);text-align:right}::ng-deep .ids-list-item__sub-description,::ng-deep :host.ids-list-item__sub-description{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s14_h20_wrg);grid-area:sub-description;margin-left:var(--ids_size_general_8x);text-align:right}.ids-list-item--selector,:host.ids-list-item--selector{position:relative}@supports (-webkit-touch-callout: none){.ids-list-item--selector,:host.ids-list-item--selector{overflow:hidden}}.ids-list-item--selector .ids-switch,.ids-list-item--selector .ids-radio-button,.ids-list-item--selector .ids-checkbox,:host.ids-list-item--selector .ids-switch,:host.ids-list-item--selector .ids-radio-button,:host.ids-list-item--selector .ids-checkbox{min-height:auto;position:static}.ids-list-item--selector .ids-switch__input,.ids-list-item--selector .ids-radio-button__input,.ids-list-item--selector .ids-checkbox__input,:host.ids-list-item--selector .ids-switch__input,:host.ids-list-item--selector .ids-radio-button__input,:host.ids-list-item--selector .ids-checkbox__input{outline-offset:0}.ids-list-item--selector ::ng-deep .ids-switch,.ids-list-item--selector ::ng-deep .ids-checkbox,.ids-list-item--selector ::ng-deep .ids-radio-button,:host.ids-list-item--selector ::ng-deep .ids-switch,:host.ids-list-item--selector ::ng-deep .ids-checkbox,:host.ids-list-item--selector ::ng-deep .ids-radio-button{min-height:auto;position:static}.ids-list-item--selector ::ng-deep .ids-switch__input,.ids-list-item--selector ::ng-deep .ids-checkbox__input,.ids-list-item--selector ::ng-deep .ids-radio-button__input,:host.ids-list-item--selector ::ng-deep .ids-switch__input,:host.ids-list-item--selector ::ng-deep .ids-checkbox__input,:host.ids-list-item--selector ::ng-deep .ids-radio-button__input{outline-offset:0}button.ids-list-item,button:host.ids-list-item{background-color:transparent;border-left:0;border-right:0;border-top:0;cursor:pointer;padding:0;text-decoration:none}button.ids-list-item:not(.ids-list-item--line-off),button:host.ids-list-item:not(.ids-list-item--line-off){border-bottom-color:var(--ids_color_border_soft)}button.ids-list-item:disabled,button.ids-list-item[aria-disabled=true],button:host.ids-list-item:disabled,button:host.ids-list-item[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}button.ids-list-item:disabled .ids-list-item__sub-text,button.ids-list-item:disabled .ids-list-item__sub-description,button.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,button.ids-list-item[aria-disabled=true] .ids-list-item__sub-description,button:host.ids-list-item:disabled .ids-list-item__sub-text,button:host.ids-list-item:disabled .ids-list-item__sub-description,button:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,button:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-description{color:inherit}button.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,button.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description{color:inherit}button.ids-list-item:disabled ::ng-deep .ids-list-item__action,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__action,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}button.ids-list-item:disabled .ids-list-item__action,button.ids-list-item[aria-disabled=true] .ids-list-item__action,button:host.ids-list-item:disabled .ids-list-item__action,button:host.ids-list-item[aria-disabled=true] .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){button.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),button.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}}button.ids-list-item:active:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}a.ids-list-item,a:host.ids-list-item{background-color:transparent;border-left:0;border-right:0;border-top:0;cursor:pointer;padding:0;text-decoration:none}a.ids-list-item:not(.ids-list-item--line-off),a:host.ids-list-item:not(.ids-list-item--line-off){border-bottom-color:var(--ids_color_border_soft)}a.ids-list-item:disabled,a.ids-list-item[aria-disabled=true],a:host.ids-list-item:disabled,a:host.ids-list-item[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}a.ids-list-item:disabled .ids-list-item__sub-text,a.ids-list-item:disabled .ids-list-item__sub-description,a.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,a.ids-list-item[aria-disabled=true] .ids-list-item__sub-description,a:host.ids-list-item:disabled .ids-list-item__sub-text,a:host.ids-list-item:disabled .ids-list-item__sub-description,a:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,a:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-description{color:inherit}a.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,a.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description{color:inherit}a.ids-list-item:disabled ::ng-deep .ids-list-item__action,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__action,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}a.ids-list-item:disabled .ids-list-item__action,a.ids-list-item[aria-disabled=true] .ids-list-item__action,a:host.ids-list-item:disabled .ids-list-item__action,a:host.ids-list-item[aria-disabled=true] .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){a.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),a.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}}a.ids-list-item:active:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}.ids-list-item--line-off,:host.ids-list-item--line-off{border-bottom-color:transparent}.ids-list,:host.ids-list{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;background-color:var(--ids_color_bg_base);color:var(--ids_color_feedback_neutral);font:var(--ids_textStyle_f02_s16_h24_wrg);list-style:none}.ids-list>li:not(.ids-list-item),:host.ids-list>li:not(.ids-list-item){all:unset;all:revert;box-sizing:border-box}\n"], dependencies: [{ kind: "component", type: IdsListTagComponent, selector: "[idsList]" }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsListComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, selector: 'ids-list', standalone: true, template: `<ul idsList>
    <ng-content></ng-content>
  </ul>`, imports: [IdsListTagComponent], styles: [".ids-list-item,:host.ids-list-item{--ids-list-item-label-width: minmax(15%, auto);--ids-list-item-description-width: fit-content(100%);all:unset;all:revert;background:var(--ids_color_bg_base);border:0;border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_soft);box-sizing:border-box;color:var(--ids_color_feedback_neutral);display:block;font:var(--ids_textStyle_f02_s16_h24_wbd);text-align:left;text-decoration:inherit;width:100%}.ids-list-item .ids-icon-button,:host.ids-list-item .ids-icon-button{margin-right:var(--ids_size_general_1x);min-height:auto;padding-bottom:0;padding-top:0}.ids-list-item ::ng-deep .ids-icon-button,:host.ids-list-item ::ng-deep .ids-icon-button{margin-right:var(--ids_size_general_1x);min-height:auto;padding-bottom:0;padding-top:0}.ids-list-item__content,:host.ids-list-item__content{all:unset;all:revert;align-items:center;box-sizing:border-box;display:grid;grid-template-areas:\"icon text description action\" \"icon sub-text sub-description action\";grid-template-columns:min-content var(--ids-list-item-label-width) var(--ids-list-item-description-width) min-content;min-height:3.9375rem;overflow:hidden;padding:var(--ids_size_general_16x) 0 calc(var(--ids_size_general_16x) - var(--ids_size_border_small))}.ids-list-item__content:has(.ids-list-item__sub-text),:host.ids-list-item__content:has(.ids-list-item__sub-text){min-height:4.9375rem}.ids-list-item__icon,:host.ids-list-item__icon{align-self:center;grid-area:icon;line-height:1;margin-right:var(--ids_size_general_16x);text-align:center}::ng-deep .ids-list-item__icon,::ng-deep :host.ids-list-item__icon{align-self:center;grid-area:icon;line-height:1;margin-right:var(--ids_size_general_16x);text-align:center}.ids-list-item__text,:host.ids-list-item__text{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;align-self:flex-end;grid-area:text;overflow:hidden}.ids-list-item__text--double-line,:host.ids-list-item__text--double-line{align-self:initial;grid-row:span 2}::ng-deep .ids-list-item__text,::ng-deep :host.ids-list-item__text{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;align-self:flex-end;grid-area:text;overflow:hidden}::ng-deep .ids-list-item__text--double-line,::ng-deep :host.ids-list-item__text--double-line{align-self:initial;grid-row:span 2}.ids-list-item__description,:host.ids-list-item__description{align-self:flex-end;grid-area:description;margin-left:var(--ids_size_general_8x);text-align:right}.ids-list-item__description:not(.ids-tag):not(.ids-number-badge),:host.ids-list-item__description:not(.ids-tag):not(.ids-number-badge){font:var(--ids_textStyle_f02_s16_h24_wrg)}.ids-list-item__description--double-line,:host.ids-list-item__description--double-line{align-self:initial;grid-row:span 2}::ng-deep .ids-list-item__description,::ng-deep :host.ids-list-item__description{align-self:flex-end;grid-area:description;margin-left:var(--ids_size_general_8x);text-align:right}::ng-deep .ids-list-item__description:not(.ids-tag):not(.ids-number-badge),::ng-deep :host.ids-list-item__description:not(.ids-tag):not(.ids-number-badge){font:var(--ids_textStyle_f02_s16_h24_wrg)}::ng-deep .ids-list-item__description--double-line,::ng-deep :host.ids-list-item__description--double-line{align-self:initial;grid-row:span 2}.ids-list-item__action,:host.ids-list-item__action{align-self:center;color:var(--ids_color_feedback_neutral);display:flex;grid-area:action;justify-content:center;margin-left:var(--ids_size_general_8x);min-width:var(--ids_size_general_24x);text-align:center}::ng-deep .ids-list-item__action,::ng-deep :host.ids-list-item__action{align-self:center;color:var(--ids_color_feedback_neutral);display:flex;grid-area:action;justify-content:center;margin-left:var(--ids_size_general_8x);min-width:var(--ids_size_general_24x);text-align:center}.ids-list-item__sub-text,:host.ids-list-item__sub-text{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s16_h24_wrg);grid-area:sub-text}::ng-deep .ids-list-item__sub-text,::ng-deep :host.ids-list-item__sub-text{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s16_h24_wrg);grid-area:sub-text}.ids-list-item__sub-description,:host.ids-list-item__sub-description{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s14_h20_wrg);grid-area:sub-description;margin-left:var(--ids_size_general_8x);text-align:right}::ng-deep .ids-list-item__sub-description,::ng-deep :host.ids-list-item__sub-description{all:unset;all:revert;box-sizing:border-box;align-self:flex-start;color:inherit;font:var(--ids_textStyle_f02_s14_h20_wrg);grid-area:sub-description;margin-left:var(--ids_size_general_8x);text-align:right}.ids-list-item--selector,:host.ids-list-item--selector{position:relative}@supports (-webkit-touch-callout: none){.ids-list-item--selector,:host.ids-list-item--selector{overflow:hidden}}.ids-list-item--selector .ids-switch,.ids-list-item--selector .ids-radio-button,.ids-list-item--selector .ids-checkbox,:host.ids-list-item--selector .ids-switch,:host.ids-list-item--selector .ids-radio-button,:host.ids-list-item--selector .ids-checkbox{min-height:auto;position:static}.ids-list-item--selector .ids-switch__input,.ids-list-item--selector .ids-radio-button__input,.ids-list-item--selector .ids-checkbox__input,:host.ids-list-item--selector .ids-switch__input,:host.ids-list-item--selector .ids-radio-button__input,:host.ids-list-item--selector .ids-checkbox__input{outline-offset:0}.ids-list-item--selector ::ng-deep .ids-switch,.ids-list-item--selector ::ng-deep .ids-checkbox,.ids-list-item--selector ::ng-deep .ids-radio-button,:host.ids-list-item--selector ::ng-deep .ids-switch,:host.ids-list-item--selector ::ng-deep .ids-checkbox,:host.ids-list-item--selector ::ng-deep .ids-radio-button{min-height:auto;position:static}.ids-list-item--selector ::ng-deep .ids-switch__input,.ids-list-item--selector ::ng-deep .ids-checkbox__input,.ids-list-item--selector ::ng-deep .ids-radio-button__input,:host.ids-list-item--selector ::ng-deep .ids-switch__input,:host.ids-list-item--selector ::ng-deep .ids-checkbox__input,:host.ids-list-item--selector ::ng-deep .ids-radio-button__input{outline-offset:0}button.ids-list-item,button:host.ids-list-item{background-color:transparent;border-left:0;border-right:0;border-top:0;cursor:pointer;padding:0;text-decoration:none}button.ids-list-item:not(.ids-list-item--line-off),button:host.ids-list-item:not(.ids-list-item--line-off){border-bottom-color:var(--ids_color_border_soft)}button.ids-list-item:disabled,button.ids-list-item[aria-disabled=true],button:host.ids-list-item:disabled,button:host.ids-list-item[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}button.ids-list-item:disabled .ids-list-item__sub-text,button.ids-list-item:disabled .ids-list-item__sub-description,button.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,button.ids-list-item[aria-disabled=true] .ids-list-item__sub-description,button:host.ids-list-item:disabled .ids-list-item__sub-text,button:host.ids-list-item:disabled .ids-list-item__sub-description,button:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,button:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-description{color:inherit}button.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,button.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description{color:inherit}button.ids-list-item:disabled ::ng-deep .ids-list-item__action,button.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action,button:host.ids-list-item:disabled ::ng-deep .ids-list-item__action,button:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}button.ids-list-item:disabled .ids-list-item__action,button.ids-list-item[aria-disabled=true] .ids-list-item__action,button:host.ids-list-item:disabled .ids-list-item__action,button:host.ids-list-item[aria-disabled=true] .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){button.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),button.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}}button.ids-list-item:active:not(:disabled):not([aria-disabled=true]),button:host.ids-list-item:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}a.ids-list-item,a:host.ids-list-item{background-color:transparent;border-left:0;border-right:0;border-top:0;cursor:pointer;padding:0;text-decoration:none}a.ids-list-item:not(.ids-list-item--line-off),a:host.ids-list-item:not(.ids-list-item--line-off){border-bottom-color:var(--ids_color_border_soft)}a.ids-list-item:disabled,a.ids-list-item[aria-disabled=true],a:host.ids-list-item:disabled,a:host.ids-list-item[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}a.ids-list-item:disabled .ids-list-item__sub-text,a.ids-list-item:disabled .ids-list-item__sub-description,a.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,a.ids-list-item[aria-disabled=true] .ids-list-item__sub-description,a:host.ids-list-item:disabled .ids-list-item__sub-text,a:host.ids-list-item:disabled .ids-list-item__sub-description,a:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-text,a:host.ids-list-item[aria-disabled=true] .ids-list-item__sub-description{color:inherit}a.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,a.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-text,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__sub-description,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-text,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__sub-description{color:inherit}a.ids-list-item:disabled ::ng-deep .ids-list-item__action,a.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action,a:host.ids-list-item:disabled ::ng-deep .ids-list-item__action,a:host.ids-list-item[aria-disabled=true] ::ng-deep .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}a.ids-list-item:disabled .ids-list-item__action,a.ids-list-item[aria-disabled=true] .ids-list-item__action,a:host.ids-list-item:disabled .ids-list-item__action,a:host.ids-list-item[aria-disabled=true] .ids-list-item__action{color:var(--ids_color_action_disabled_variant);cursor:not-allowed}@media (hover: hover) and (pointer: fine){a.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),a.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:hover:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:focus-visible:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}}a.ids-list-item:active:not(:disabled):not([aria-disabled=true]),a:host.ids-list-item:active:not(:disabled):not([aria-disabled=true]){background-color:var(--ids_color_action_neutral_base_soft)}.ids-list-item--line-off,:host.ids-list-item--line-off{border-bottom-color:transparent}.ids-list,:host.ids-list{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;background-color:var(--ids_color_bg_base);color:var(--ids_color_feedback_neutral);font:var(--ids_textStyle_f02_s16_h24_wrg);list-style:none}.ids-list>li:not(.ids-list-item),:host.ids-list>li:not(.ids-list-item){all:unset;all:revert;box-sizing:border-box}\n"] }]
        }] });

const list = [
    IdsListComponent,
    IdsListTagComponent,
    IdsListItemTextComponent,
    IdsListItemSubTextComponent,
    IdsListItemDescriptionDirective,
    IdsListItemIconDirective,
    IdsListItemComponent,
    IdsListSubDescriptionComponent,
];
class IdsListModule {
}
IdsListModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsListModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsListModule, imports: [IdsListComponent,
        IdsListTagComponent,
        IdsListItemTextComponent,
        IdsListItemSubTextComponent,
        IdsListItemDescriptionDirective,
        IdsListItemIconDirective,
        IdsListItemComponent,
        IdsListSubDescriptionComponent], exports: [IdsListComponent,
        IdsListTagComponent,
        IdsListItemTextComponent,
        IdsListItemSubTextComponent,
        IdsListItemDescriptionDirective,
        IdsListItemIconDirective,
        IdsListItemComponent,
        IdsListSubDescriptionComponent] });
IdsListModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsListModule, imports: [IdsListComponent,
        IdsListTagComponent,
        IdsListItemTextComponent,
        IdsListItemSubTextComponent,
        IdsListItemComponent,
        IdsListSubDescriptionComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsListModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [list],
                    exports: [list],
                }]
        }] });

class IdsListboxModule {
}
IdsListboxModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsListboxModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsListboxModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsListboxModule, imports: [IdsListboxComponent], exports: [IdsListboxComponent, IdsOptionModule] });
IdsListboxModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsListboxModule, imports: [IdsListboxComponent, IdsOptionModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsListboxModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsListboxComponent],
                    exports: [IdsListboxComponent, IdsOptionModule],
                }]
        }] });

/**
 * Usa a variável --ids-aspect-ratio que contem a porcentagem da razão de aspecto.
 * Aplica o valor da altura na variável --ids-height: auto;
 */
class IdsAspectRatioDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
    }
    ngOnInit() {
        /* istanbul ignore next */
        this.resizeObserver = new ResizeObserver(() => {
            /* istanbul ignore next */
            applyAspectRatioVariables(this.elementRef.nativeElement);
        });
        this.resizeObserver.observe(this.elementRef.nativeElement);
    }
    ngOnDestroy() {
        this.resizeObserver?.disconnect();
    }
}
IdsAspectRatioDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAspectRatioDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
IdsAspectRatioDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsAspectRatioDirective, isStandalone: true, selector: "[idsAspectRatio]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAspectRatioDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsAspectRatio]',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; } });

/**
 * **Module:**
 * `import { IdsShortcutModule } from '@ids/angular';`
 */
class IdsShortcutComponent extends IdsAspectRatioDirective {
    onFocus() {
        if (platform.os !== 'IOS') {
            return;
        }
        this.el.nativeElement.scrollIntoView({ block: 'nearest' });
    }
    constructor(el) {
        super(el);
        this.el = el;
        // TouchStart é necessário pra que a pseudo-classe :active funcione no iOS
        // Ver: https://stackoverflow.com/questions/3885018/active-pseudo-class-doesnt-work-in-mobile-safari?rq=3
        /* istanbul ignore next */
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.onTouchStart = () => { };
    }
}
IdsShortcutComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsShortcutComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
IdsShortcutComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsShortcutComponent, isStandalone: true, selector: "button[idsShortcut]", inputs: { variant: "variant", contrast: "contrast", type: "type", size: "size", proportion: "proportion", highlighted: "highlighted", disabled: "disabled" }, host: { listeners: { "touchstart": "onTouchStart()", "focus": "onFocus()" }, properties: { "class.ids-shortcut": "true", "class.ids-shortcut--secondary": "variant === \"secondary\"", "class.ids-shortcut--neutral": "variant === \"neutral\"", "class.ids-shortcut--highlight": "highlighted", "class.ids-shortcut--on-variant": "contrast === \"onVariant\"", "class.ids-shortcut--on-brand": "contrast === \"onBrand\"", "class.ids-shortcut--outline": "type === \"addNew\"", "class.ids-shortcut--small": "size === \"S\"", "class.ids-shortcut--2x1": "proportion === \"2x1\"", "disabled": "disabled" } }, usesInheritance: true, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, styles: [".ids-shortcut,:host.ids-shortcut{all:unset;all:revert;box-sizing:border-box;cursor:pointer;padding:0;-webkit-user-select:none;user-select:none;aspect-ratio:1/1;align-items:flex-start;background-color:var(--ids_color_action_primary_base);border:0;border-radius:var(--ids_size_cornerRadius_card_01);color:var(--ids_color_action_primary_contrast);display:inline-flex;flex-direction:column;font:var(--ids_textStyle_f02_s16_h24_wbd);-webkit-hyphens:none;hyphens:none;justify-content:space-between;outline-offset:var(--ids_size_general_3x);padding:var(--ids_size_general_16x);text-align:left;text-decoration:none;word-break:break-word}@media (pointer: coarse){.ids-shortcut,:host.ids-shortcut{outline:0!important}.ids-shortcut:focus,:host.ids-shortcut:focus{outline:0!important}}@media (pointer: coarse) and (pointer: fine){.ids-shortcut:focus-visible,.ids-shortcut:focus.focus-visible,:host.ids-shortcut:focus-visible,:host.ids-shortcut:focus.focus-visible{outline:0!important}}@media (pointer: fine){.ids-shortcut:focus-visible,.ids-shortcut:focus.focus-visible,:host.ids-shortcut:focus-visible,:host.ids-shortcut:focus.focus-visible{outline:revert!important}}@media (pointer: fine) and (pointer: fine){.ids-shortcut:focus-visible,.ids-shortcut:focus.focus-visible,:host.ids-shortcut:focus-visible,:host.ids-shortcut:focus.focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}}@supports not (aspect-ratio: 1/1){.ids-shortcut,:host.ids-shortcut{--ids-aspect-ratio: 1;--ids-height: auto;height:auto;height:var(--ids-height)}}.ids-shortcut:not(.ids-shortcut--neutral) .ids-avatar,.ids-shortcut .ids-shortcut--highlight .ids-avatar,:host.ids-shortcut:not(.ids-shortcut--neutral) .ids-avatar,:host.ids-shortcut .ids-shortcut--highlight .ids-avatar{background-color:var(--ids_color_bg_base);color:var(--ids_color_action_neutral_base)}.ids-shortcut:not(.ids-shortcut--neutral) ::ng-deep .ids-avatar,.ids-shortcut .ids-shortcut--highlight ::ng-deep .ids-avatar,:host.ids-shortcut:not(.ids-shortcut--neutral) ::ng-deep .ids-avatar,:host.ids-shortcut .ids-shortcut--highlight ::ng-deep .ids-avatar{background-color:var(--ids_color_bg_base);color:var(--ids_color_action_neutral_base)}.ids-shortcut:not(.ids-shortcut--neutral) .ids-tag,.ids-shortcut .ids-shortcut--highlight .ids-tag,:host.ids-shortcut:not(.ids-shortcut--neutral) .ids-tag,:host.ids-shortcut .ids-shortcut--highlight .ids-tag{background-color:var(--ids_color_bg_base);border-color:var(--ids_color_bg_base);color:var(--ids_color_feedback_neutral)}.ids-shortcut:not(.ids-shortcut--neutral) ::ng-deep .ids-tag,.ids-shortcut .ids-shortcut--highlight ::ng-deep .ids-tag,:host.ids-shortcut:not(.ids-shortcut--neutral) ::ng-deep .ids-tag,:host.ids-shortcut .ids-shortcut--highlight ::ng-deep .ids-tag{background-color:var(--ids_color_bg_base);border-color:var(--ids_color_bg_base);color:var(--ids_color_feedback_neutral)}.ids-shortcut:active:not(:disabled),:host.ids-shortcut:active:not(:disabled){background-color:var(--ids_color_action_primary_variant)}.ids-shortcut:disabled,:host.ids-shortcut:disabled{background-color:var(--ids_color_action_disabled_base);color:var(--ids_color_action_disabled_variant);cursor:no-drop}.ids-shortcut--small,:host.ids-shortcut--small{font:var(--ids_textStyle_f02_s14_h20_wbd);padding:var(--ids_size_general_10x)}.ids-shortcut--small .ids-icon,:host.ids-shortcut--small .ids-icon{font:var(--ids_textStyle_icon_medium)}.ids-shortcut--small ::ng-deep .ids-icon,:host.ids-shortcut--small ::ng-deep .ids-icon{font:var(--ids_textStyle_icon_medium)}.ids-shortcut--2x1,:host.ids-shortcut--2x1{aspect-ratio:2/1}@supports not (aspect-ratio: 1/1){.ids-shortcut--2x1,:host.ids-shortcut--2x1{--ids-aspect-ratio: 2;--ids-height: auto;height:auto;height:var(--ids-height)}}.ids-shortcut--outline,:host.ids-shortcut--outline{background-color:transparent;border:var(--ids_size_border_small) dashed var(--ids_color_action_neutral_base);color:var(--ids_color_action_neutral_base)}.ids-shortcut--outline:not(:disabled) .ids-icon,:host.ids-shortcut--outline:not(:disabled) .ids-icon{color:var(--ids_color_action_primary_base)}.ids-shortcut--outline:not(:disabled) ::ng-deep .ids-icon,:host.ids-shortcut--outline:not(:disabled) ::ng-deep .ids-icon{color:var(--ids_color_action_primary_base)}.ids-shortcut--outline:not(:disabled):active,:host.ids-shortcut--outline:not(:disabled):active{background-color:var(--ids_color_action_primary_base_soft);border-color:var(--ids_color_action_neutral_variant);color:var(--ids_color_action_neutral_variant)}.ids-shortcut--outline:not(:disabled):active .ids-icon,:host.ids-shortcut--outline:not(:disabled):active .ids-icon{color:var(--ids_color_action_primary_variant)}.ids-shortcut--outline:not(:disabled):active ::ng-deep .ids-icon,:host.ids-shortcut--outline:not(:disabled):active ::ng-deep .ids-icon{color:var(--ids_color_action_primary_variant)}.ids-shortcut--secondary,:host.ids-shortcut--secondary{background-color:var(--ids_color_action_secondary_base)}.ids-shortcut--secondary:active:not(:disabled),:host.ids-shortcut--secondary:active:not(:disabled){background-color:var(--ids_color_action_secondary_variant)}.ids-shortcut--secondary.ids-shortcut--outline,:host.ids-shortcut--secondary.ids-shortcut--outline{background-color:inherit}.ids-shortcut--secondary.ids-shortcut--outline .ids-icon,:host.ids-shortcut--secondary.ids-shortcut--outline .ids-icon{color:var(--ids_color_action_secondary_base)}.ids-shortcut--secondary.ids-shortcut--outline ::ng-deep .ids-icon,:host.ids-shortcut--secondary.ids-shortcut--outline ::ng-deep .ids-icon{color:var(--ids_color_action_secondary_base)}.ids-shortcut--secondary.ids-shortcut--outline:active:not(:disabled),:host.ids-shortcut--secondary.ids-shortcut--outline:active:not(:disabled){background-color:var(--ids_color_action_secondary_base_soft)}.ids-shortcut--secondary.ids-shortcut--outline:active:not(:disabled) .ids-icon,:host.ids-shortcut--secondary.ids-shortcut--outline:active:not(:disabled) .ids-icon{color:var(--ids_color_action_secondary_variant)}.ids-shortcut--secondary.ids-shortcut--outline:active:not(:disabled) ::ng-deep .ids-icon,:host.ids-shortcut--secondary.ids-shortcut--outline:active:not(:disabled) ::ng-deep .ids-icon{color:var(--ids_color_action_secondary_variant)}.ids-shortcut--neutral:not(.ids-shortcut--highlight),:host.ids-shortcut--neutral:not(.ids-shortcut--highlight){background-color:var(--ids_color_bg_variant_01);color:var(--ids_color_action_neutral_base)}.ids-shortcut--neutral:not(.ids-shortcut--highlight):not(:disabled) .ids-icon,:host.ids-shortcut--neutral:not(.ids-shortcut--highlight):not(:disabled) .ids-icon{color:var(--ids_color_action_primary_base)}.ids-shortcut--neutral:not(.ids-shortcut--highlight):not(:disabled) ::ng-deep .ids-icon,:host.ids-shortcut--neutral:not(.ids-shortcut--highlight):not(:disabled) ::ng-deep .ids-icon{color:var(--ids_color_action_primary_base)}.ids-shortcut--neutral:not(.ids-shortcut--highlight):not(:disabled):active,:host.ids-shortcut--neutral:not(.ids-shortcut--highlight):not(:disabled):active{background-color:var(--ids_color_bg_variant_02);color:var(--ids_color_action_neutral_variant)}.ids-shortcut--neutral:not(.ids-shortcut--highlight):not(:disabled):active .ids-icon,:host.ids-shortcut--neutral:not(.ids-shortcut--highlight):not(:disabled):active .ids-icon{color:var(--ids_color_action_primary_variant)}.ids-shortcut--neutral:not(.ids-shortcut--highlight):not(:disabled):active ::ng-deep .ids-icon,:host.ids-shortcut--neutral:not(.ids-shortcut--highlight):not(:disabled):active ::ng-deep .ids-icon{color:var(--ids_color_action_primary_variant)}.ids-shortcut--neutral:not(.ids-shortcut--highlight).ids-shortcut--on-variant,:host.ids-shortcut--neutral:not(.ids-shortcut--highlight).ids-shortcut--on-variant{background-color:var(--ids_color_bg_base);color:var(--ids_color_action_neutral_variant)}.ids-shortcut--neutral:not(.ids-shortcut--highlight).ids-shortcut--on-variant:active:not(:disabled),:host.ids-shortcut--neutral:not(.ids-shortcut--highlight).ids-shortcut--on-variant:active:not(:disabled){background-color:var(--ids_color_bg_variant_02)}.ids-shortcut--neutral:not(.ids-shortcut--highlight).ids-shortcut--on-variant:disabled,:host.ids-shortcut--neutral:not(.ids-shortcut--highlight).ids-shortcut--on-variant:disabled{background-color:var(--ids_color_action_disabled_base);color:var(--ids_color_action_disabled_variant);cursor:no-drop}.ids-shortcut--neutral:not(.ids-shortcut--highlight).ids-shortcut--on-variant.ids-shortcut--outline,:host.ids-shortcut--neutral:not(.ids-shortcut--highlight).ids-shortcut--on-variant.ids-shortcut--outline{background-color:inherit}.ids-shortcut--neutral:not(.ids-shortcut--highlight).ids-shortcut--outline,:host.ids-shortcut--neutral:not(.ids-shortcut--highlight).ids-shortcut--outline{background-color:inherit}.ids-shortcut--neutral:not(.ids-shortcut--highlight).ids-shortcut--outline:active:not(:disabled),:host.ids-shortcut--neutral:not(.ids-shortcut--highlight).ids-shortcut--outline:active:not(:disabled){background-color:var(--ids_color_bg_variant_02)}.ids-shortcut--on-brand,:host.ids-shortcut--on-brand{background-color:var(--ids_color_action_primary_variant)}.ids-shortcut--on-brand:active:not(:disabled),:host.ids-shortcut--on-brand:active:not(:disabled){background-color:var(--ids_color_action_primary_variant_strong)}.ids-shortcut--on-brand.ids-shortcut--outline,:host.ids-shortcut--on-brand.ids-shortcut--outline{background-color:inherit;border-color:var(--ids_color_action_primary_contrast);color:var(--ids_color_action_primary_contrast)}.ids-shortcut--on-brand.ids-shortcut--outline .ids-icon,:host.ids-shortcut--on-brand.ids-shortcut--outline .ids-icon{color:inherit}.ids-shortcut--on-brand.ids-shortcut--outline ::ng-deep .ids-icon,:host.ids-shortcut--on-brand.ids-shortcut--outline ::ng-deep .ids-icon{color:inherit}.ids-shortcut--on-brand.ids-shortcut--outline:active:not(:disabled),:host.ids-shortcut--on-brand.ids-shortcut--outline:active:not(:disabled){background-color:var(--ids_color_action_primary_variant);border-color:inherit;color:inherit}.ids-shortcut--on-brand.ids-shortcut--outline:active:not(:disabled) .ids-icon,:host.ids-shortcut--on-brand.ids-shortcut--outline:active:not(:disabled) .ids-icon{color:inherit}.ids-shortcut--on-brand.ids-shortcut--outline:active:not(:disabled) ::ng-deep .ids-icon,:host.ids-shortcut--on-brand.ids-shortcut--outline:active:not(:disabled) ::ng-deep .ids-icon{color:inherit}\n"] });
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object)
], IdsShortcutComponent.prototype, "highlighted", void 0);
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object)
], IdsShortcutComponent.prototype, "disabled", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsShortcutComponent, decorators: [{
            type: Component,
            args: [{ selector: 'button[idsShortcut]', template: '<ng-content></ng-content>', host: {
                        '[class.ids-shortcut]': 'true',
                        '[class.ids-shortcut--secondary]': 'variant === "secondary"',
                        '[class.ids-shortcut--neutral]': 'variant === "neutral"',
                        '[class.ids-shortcut--highlight]': 'highlighted',
                        '[class.ids-shortcut--on-variant]': 'contrast === "onVariant"',
                        '[class.ids-shortcut--on-brand]': 'contrast === "onBrand"',
                        '[class.ids-shortcut--outline]': 'type === "addNew"',
                        '[class.ids-shortcut--small]': 'size === "S"',
                        '[class.ids-shortcut--2x1]': 'proportion === "2x1"',
                        '[disabled]': 'disabled',
                    }, standalone: true, styles: [".ids-shortcut,:host.ids-shortcut{all:unset;all:revert;box-sizing:border-box;cursor:pointer;padding:0;-webkit-user-select:none;user-select:none;aspect-ratio:1/1;align-items:flex-start;background-color:var(--ids_color_action_primary_base);border:0;border-radius:var(--ids_size_cornerRadius_card_01);color:var(--ids_color_action_primary_contrast);display:inline-flex;flex-direction:column;font:var(--ids_textStyle_f02_s16_h24_wbd);-webkit-hyphens:none;hyphens:none;justify-content:space-between;outline-offset:var(--ids_size_general_3x);padding:var(--ids_size_general_16x);text-align:left;text-decoration:none;word-break:break-word}@media (pointer: coarse){.ids-shortcut,:host.ids-shortcut{outline:0!important}.ids-shortcut:focus,:host.ids-shortcut:focus{outline:0!important}}@media (pointer: coarse) and (pointer: fine){.ids-shortcut:focus-visible,.ids-shortcut:focus.focus-visible,:host.ids-shortcut:focus-visible,:host.ids-shortcut:focus.focus-visible{outline:0!important}}@media (pointer: fine){.ids-shortcut:focus-visible,.ids-shortcut:focus.focus-visible,:host.ids-shortcut:focus-visible,:host.ids-shortcut:focus.focus-visible{outline:revert!important}}@media (pointer: fine) and (pointer: fine){.ids-shortcut:focus-visible,.ids-shortcut:focus.focus-visible,:host.ids-shortcut:focus-visible,:host.ids-shortcut:focus.focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}}@supports not (aspect-ratio: 1/1){.ids-shortcut,:host.ids-shortcut{--ids-aspect-ratio: 1;--ids-height: auto;height:auto;height:var(--ids-height)}}.ids-shortcut:not(.ids-shortcut--neutral) .ids-avatar,.ids-shortcut .ids-shortcut--highlight .ids-avatar,:host.ids-shortcut:not(.ids-shortcut--neutral) .ids-avatar,:host.ids-shortcut .ids-shortcut--highlight .ids-avatar{background-color:var(--ids_color_bg_base);color:var(--ids_color_action_neutral_base)}.ids-shortcut:not(.ids-shortcut--neutral) ::ng-deep .ids-avatar,.ids-shortcut .ids-shortcut--highlight ::ng-deep .ids-avatar,:host.ids-shortcut:not(.ids-shortcut--neutral) ::ng-deep .ids-avatar,:host.ids-shortcut .ids-shortcut--highlight ::ng-deep .ids-avatar{background-color:var(--ids_color_bg_base);color:var(--ids_color_action_neutral_base)}.ids-shortcut:not(.ids-shortcut--neutral) .ids-tag,.ids-shortcut .ids-shortcut--highlight .ids-tag,:host.ids-shortcut:not(.ids-shortcut--neutral) .ids-tag,:host.ids-shortcut .ids-shortcut--highlight .ids-tag{background-color:var(--ids_color_bg_base);border-color:var(--ids_color_bg_base);color:var(--ids_color_feedback_neutral)}.ids-shortcut:not(.ids-shortcut--neutral) ::ng-deep .ids-tag,.ids-shortcut .ids-shortcut--highlight ::ng-deep .ids-tag,:host.ids-shortcut:not(.ids-shortcut--neutral) ::ng-deep .ids-tag,:host.ids-shortcut .ids-shortcut--highlight ::ng-deep .ids-tag{background-color:var(--ids_color_bg_base);border-color:var(--ids_color_bg_base);color:var(--ids_color_feedback_neutral)}.ids-shortcut:active:not(:disabled),:host.ids-shortcut:active:not(:disabled){background-color:var(--ids_color_action_primary_variant)}.ids-shortcut:disabled,:host.ids-shortcut:disabled{background-color:var(--ids_color_action_disabled_base);color:var(--ids_color_action_disabled_variant);cursor:no-drop}.ids-shortcut--small,:host.ids-shortcut--small{font:var(--ids_textStyle_f02_s14_h20_wbd);padding:var(--ids_size_general_10x)}.ids-shortcut--small .ids-icon,:host.ids-shortcut--small .ids-icon{font:var(--ids_textStyle_icon_medium)}.ids-shortcut--small ::ng-deep .ids-icon,:host.ids-shortcut--small ::ng-deep .ids-icon{font:var(--ids_textStyle_icon_medium)}.ids-shortcut--2x1,:host.ids-shortcut--2x1{aspect-ratio:2/1}@supports not (aspect-ratio: 1/1){.ids-shortcut--2x1,:host.ids-shortcut--2x1{--ids-aspect-ratio: 2;--ids-height: auto;height:auto;height:var(--ids-height)}}.ids-shortcut--outline,:host.ids-shortcut--outline{background-color:transparent;border:var(--ids_size_border_small) dashed var(--ids_color_action_neutral_base);color:var(--ids_color_action_neutral_base)}.ids-shortcut--outline:not(:disabled) .ids-icon,:host.ids-shortcut--outline:not(:disabled) .ids-icon{color:var(--ids_color_action_primary_base)}.ids-shortcut--outline:not(:disabled) ::ng-deep .ids-icon,:host.ids-shortcut--outline:not(:disabled) ::ng-deep .ids-icon{color:var(--ids_color_action_primary_base)}.ids-shortcut--outline:not(:disabled):active,:host.ids-shortcut--outline:not(:disabled):active{background-color:var(--ids_color_action_primary_base_soft);border-color:var(--ids_color_action_neutral_variant);color:var(--ids_color_action_neutral_variant)}.ids-shortcut--outline:not(:disabled):active .ids-icon,:host.ids-shortcut--outline:not(:disabled):active .ids-icon{color:var(--ids_color_action_primary_variant)}.ids-shortcut--outline:not(:disabled):active ::ng-deep .ids-icon,:host.ids-shortcut--outline:not(:disabled):active ::ng-deep .ids-icon{color:var(--ids_color_action_primary_variant)}.ids-shortcut--secondary,:host.ids-shortcut--secondary{background-color:var(--ids_color_action_secondary_base)}.ids-shortcut--secondary:active:not(:disabled),:host.ids-shortcut--secondary:active:not(:disabled){background-color:var(--ids_color_action_secondary_variant)}.ids-shortcut--secondary.ids-shortcut--outline,:host.ids-shortcut--secondary.ids-shortcut--outline{background-color:inherit}.ids-shortcut--secondary.ids-shortcut--outline .ids-icon,:host.ids-shortcut--secondary.ids-shortcut--outline .ids-icon{color:var(--ids_color_action_secondary_base)}.ids-shortcut--secondary.ids-shortcut--outline ::ng-deep .ids-icon,:host.ids-shortcut--secondary.ids-shortcut--outline ::ng-deep .ids-icon{color:var(--ids_color_action_secondary_base)}.ids-shortcut--secondary.ids-shortcut--outline:active:not(:disabled),:host.ids-shortcut--secondary.ids-shortcut--outline:active:not(:disabled){background-color:var(--ids_color_action_secondary_base_soft)}.ids-shortcut--secondary.ids-shortcut--outline:active:not(:disabled) .ids-icon,:host.ids-shortcut--secondary.ids-shortcut--outline:active:not(:disabled) .ids-icon{color:var(--ids_color_action_secondary_variant)}.ids-shortcut--secondary.ids-shortcut--outline:active:not(:disabled) ::ng-deep .ids-icon,:host.ids-shortcut--secondary.ids-shortcut--outline:active:not(:disabled) ::ng-deep .ids-icon{color:var(--ids_color_action_secondary_variant)}.ids-shortcut--neutral:not(.ids-shortcut--highlight),:host.ids-shortcut--neutral:not(.ids-shortcut--highlight){background-color:var(--ids_color_bg_variant_01);color:var(--ids_color_action_neutral_base)}.ids-shortcut--neutral:not(.ids-shortcut--highlight):not(:disabled) .ids-icon,:host.ids-shortcut--neutral:not(.ids-shortcut--highlight):not(:disabled) .ids-icon{color:var(--ids_color_action_primary_base)}.ids-shortcut--neutral:not(.ids-shortcut--highlight):not(:disabled) ::ng-deep .ids-icon,:host.ids-shortcut--neutral:not(.ids-shortcut--highlight):not(:disabled) ::ng-deep .ids-icon{color:var(--ids_color_action_primary_base)}.ids-shortcut--neutral:not(.ids-shortcut--highlight):not(:disabled):active,:host.ids-shortcut--neutral:not(.ids-shortcut--highlight):not(:disabled):active{background-color:var(--ids_color_bg_variant_02);color:var(--ids_color_action_neutral_variant)}.ids-shortcut--neutral:not(.ids-shortcut--highlight):not(:disabled):active .ids-icon,:host.ids-shortcut--neutral:not(.ids-shortcut--highlight):not(:disabled):active .ids-icon{color:var(--ids_color_action_primary_variant)}.ids-shortcut--neutral:not(.ids-shortcut--highlight):not(:disabled):active ::ng-deep .ids-icon,:host.ids-shortcut--neutral:not(.ids-shortcut--highlight):not(:disabled):active ::ng-deep .ids-icon{color:var(--ids_color_action_primary_variant)}.ids-shortcut--neutral:not(.ids-shortcut--highlight).ids-shortcut--on-variant,:host.ids-shortcut--neutral:not(.ids-shortcut--highlight).ids-shortcut--on-variant{background-color:var(--ids_color_bg_base);color:var(--ids_color_action_neutral_variant)}.ids-shortcut--neutral:not(.ids-shortcut--highlight).ids-shortcut--on-variant:active:not(:disabled),:host.ids-shortcut--neutral:not(.ids-shortcut--highlight).ids-shortcut--on-variant:active:not(:disabled){background-color:var(--ids_color_bg_variant_02)}.ids-shortcut--neutral:not(.ids-shortcut--highlight).ids-shortcut--on-variant:disabled,:host.ids-shortcut--neutral:not(.ids-shortcut--highlight).ids-shortcut--on-variant:disabled{background-color:var(--ids_color_action_disabled_base);color:var(--ids_color_action_disabled_variant);cursor:no-drop}.ids-shortcut--neutral:not(.ids-shortcut--highlight).ids-shortcut--on-variant.ids-shortcut--outline,:host.ids-shortcut--neutral:not(.ids-shortcut--highlight).ids-shortcut--on-variant.ids-shortcut--outline{background-color:inherit}.ids-shortcut--neutral:not(.ids-shortcut--highlight).ids-shortcut--outline,:host.ids-shortcut--neutral:not(.ids-shortcut--highlight).ids-shortcut--outline{background-color:inherit}.ids-shortcut--neutral:not(.ids-shortcut--highlight).ids-shortcut--outline:active:not(:disabled),:host.ids-shortcut--neutral:not(.ids-shortcut--highlight).ids-shortcut--outline:active:not(:disabled){background-color:var(--ids_color_bg_variant_02)}.ids-shortcut--on-brand,:host.ids-shortcut--on-brand{background-color:var(--ids_color_action_primary_variant)}.ids-shortcut--on-brand:active:not(:disabled),:host.ids-shortcut--on-brand:active:not(:disabled){background-color:var(--ids_color_action_primary_variant_strong)}.ids-shortcut--on-brand.ids-shortcut--outline,:host.ids-shortcut--on-brand.ids-shortcut--outline{background-color:inherit;border-color:var(--ids_color_action_primary_contrast);color:var(--ids_color_action_primary_contrast)}.ids-shortcut--on-brand.ids-shortcut--outline .ids-icon,:host.ids-shortcut--on-brand.ids-shortcut--outline .ids-icon{color:inherit}.ids-shortcut--on-brand.ids-shortcut--outline ::ng-deep .ids-icon,:host.ids-shortcut--on-brand.ids-shortcut--outline ::ng-deep .ids-icon{color:inherit}.ids-shortcut--on-brand.ids-shortcut--outline:active:not(:disabled),:host.ids-shortcut--on-brand.ids-shortcut--outline:active:not(:disabled){background-color:var(--ids_color_action_primary_variant);border-color:inherit;color:inherit}.ids-shortcut--on-brand.ids-shortcut--outline:active:not(:disabled) .ids-icon,:host.ids-shortcut--on-brand.ids-shortcut--outline:active:not(:disabled) .ids-icon{color:inherit}.ids-shortcut--on-brand.ids-shortcut--outline:active:not(:disabled) ::ng-deep .ids-icon,:host.ids-shortcut--on-brand.ids-shortcut--outline:active:not(:disabled) ::ng-deep .ids-icon{color:inherit}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { variant: [{
                type: Input
            }], contrast: [{
                type: Input
            }], type: [{
                type: Input
            }], size: [{
                type: Input
            }], proportion: [{
                type: Input
            }], highlighted: [{
                type: Input
            }], disabled: [{
                type: Input
            }], 
        /* istanbul ignore next */
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onTouchStart: [{
                type: HostListener,
                args: ['touchstart']
            }], onFocus: [{
                type: HostListener,
                args: ['focus']
            }] } });

class IdsShortcutModule {
}
IdsShortcutModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsShortcutModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsShortcutModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsShortcutModule, imports: [IdsShortcutComponent], exports: [IdsShortcutComponent] });
IdsShortcutModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsShortcutModule, imports: [IdsShortcutComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsShortcutModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsShortcutComponent],
                    exports: [IdsShortcutComponent],
                }]
        }] });

class IdsAutoFocusDirective {
    constructor(_elementRef) {
        this._elementRef = _elementRef;
    }
    ngOnInit() {
        focus(this._elementRef.nativeElement);
    }
}
IdsAutoFocusDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAutoFocusDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
IdsAutoFocusDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsAutoFocusDirective, isStandalone: true, selector: "[idsAutoFocus]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAutoFocusDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsAutoFocus]',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; } });

class IdsMobileHeaderTitleContentDirective {
    constructor() {
        this.class = 'ids-mobile-header__title';
    }
}
IdsMobileHeaderTitleContentDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMobileHeaderTitleContentDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
IdsMobileHeaderTitleContentDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsMobileHeaderTitleContentDirective, isStandalone: true, selector: "[idsMobileHeaderTitle]", host: { properties: { "class": "this.class" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMobileHeaderTitleContentDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsMobileHeaderTitle]',
                    standalone: true,
                }]
        }], propDecorators: { class: [{
                type: HostBinding
            }] } });
class IdsMobileHeaderActionContentDirective {
    constructor() {
        this.class = 'ids-mobile-header__button';
    }
}
IdsMobileHeaderActionContentDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMobileHeaderActionContentDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
IdsMobileHeaderActionContentDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsMobileHeaderActionContentDirective, isStandalone: true, selector: "[idsMobileHeaderAction]", host: { properties: { "class": "this.class" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMobileHeaderActionContentDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsMobileHeaderAction]',
                    standalone: true,
                }]
        }], propDecorators: { class: [{
                type: HostBinding
            }] } });
class IdsMobileHeaderControlsContentDirective {
    constructor() {
        this.class = 'ids-mobile-header__button';
    }
}
IdsMobileHeaderControlsContentDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMobileHeaderControlsContentDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
IdsMobileHeaderControlsContentDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsMobileHeaderControlsContentDirective, isStandalone: true, selector: "[idsMobileHeaderControls]", host: { properties: { "class": "this.class" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMobileHeaderControlsContentDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsMobileHeaderControls]',
                    standalone: true,
                }]
        }], propDecorators: { class: [{
                type: HostBinding
            }] } });
/**
 * O Mobile Header exibe informações e ações relacionadas à página atual. É usado para orientar qual página o
 * cliente está, permitindo a navegação e o filtro, no caso do tipo completo de Header.
 *
 * *The Mobile Header displays information and actions related to the current page. It is used to guide which*
 * *page the client is on, allowing navigation and filtering, in the case of the full Header type.*
 *
 * **Module:**
 *
 * `import { IdsMobileHeaderModule, IdsIconButtonModule } from '@ids/angular';`
 *
 */
class IdsMobileHeaderComponent {
    get headingText() {
        return this.headingElement?.textContent || '';
    }
    get elementWithScroll() {
        return this.scrollElement || getScrollingParent(this.headingElement) || this._document;
    }
    get currentContrast() {
        return this.collapsed ? this.collapsedContrast : this.contrast;
    }
    get currentBgColor() {
        return this.collapsed ? this.collapsedBgColor : this.bgColor;
    }
    constructor(_document) {
        this._document = _document;
        this._destroy = new Subject();
        this._mutationObserver = new MutationObserver(this.verifyAndCollapse.bind(this));
        this._resizeObserver = new ResizeObserver(this.verifyAndCollapse.bind(this));
        this.collapsed = false;
        this.verifyAndCollapse = this.verifyAndCollapse.bind(this);
    }
    ngAfterContentInit() {
        if (this.childHeading) {
            return;
        }
        this._listenToMutation();
        this._listenToScrollEvent();
        // timeout para aguardar toda a tela ser carregada para então definir o
        // o posicionamento correto.
        setTimeout(() => {
            this.verifyAndCollapse();
        });
    }
    ngOnDestroy() {
        this._destroy.next();
        this._destroy.complete();
        this._mutationObserver.disconnect();
        this._resizeObserver.disconnect();
    }
    _listenToMutation() {
        if (!this.headingElement) {
            return;
        }
        this._mutationObserver.observe(this.headingElement, {
            attributes: true,
            childList: true,
            subtree: true,
            characterData: true,
        });
        this._resizeObserver.observe(this.headingElement);
    }
    _listenToScrollEvent() {
        const observables = [fromEvent(window, 'resize'), fromEvent(window, 'load')];
        if (this.elementWithScroll instanceof HTMLElement) {
            observables.push(fromEvent(this.elementWithScroll, 'scroll'));
        }
        if (!(this.elementWithScroll instanceof Document)) {
            observables.push(fromEvent(this._document, 'scroll'));
        }
        merge(...observables)
            .pipe(takeUntil(this._destroy))
            .subscribe(this.verifyAndCollapse);
    }
    verifyAndCollapse() {
        if (!this.headingElement) {
            return;
        }
        // O font-size geralmente não ocupa exatamente a altura em px que está declarado.
        // O valor 4 representa a diferença em px entre o tamanho da fonte line-height 1
        // menos o espaço que sobra abaixo ou acima dela. Este tamanho pode variar.
        const FONT_SIZE_BOX_DIFFERENCE = 4;
        const { fontSize, lineHeight } = getComputedStyle(this.headingElement);
        const difference = parseFloat(fontSize) / 2 - parseFloat(lineHeight) / 2 - FONT_SIZE_BOX_DIFFERENCE;
        this.collapsed = isElementBottomAboveReferenceBottom(this.headingElement, this.headerEl.nativeElement, difference);
    }
}
IdsMobileHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMobileHeaderComponent, deps: [{ token: DOCUMENT }], target: i0.ɵɵFactoryTarget.Component });
IdsMobileHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsMobileHeaderComponent, isStandalone: true, selector: "ids-mobile-header", inputs: { contrast: "contrast", collapsedContrast: "collapsedContrast", scrollElement: "scrollElement", headingElement: "headingElement", bgColor: "bgColor", collapsedBgColor: "collapsedBgColor" }, host: { properties: { "class.ids-mobile-header-wrapper": "true" } }, queries: [{ propertyName: "childHeading", first: true, predicate: IdsMobileHeaderTitleContentDirective, descendants: true }], viewQueries: [{ propertyName: "headerEl", first: true, predicate: ["headerEl"], descendants: true }, { propertyName: "headerTitle", first: true, predicate: ["headerTitle"], descendants: true }], ngImport: i0, template: "<header\n  class=\"ids-mobile-header\"\n  [class.ids-mobile-header--on-brand]=\"currentContrast === 'onBrand'\"\n  [class.ids-mobile-header--collapsed]=\"collapsed || childHeading\"\n  #headerEl\n  [style.background-color]=\"currentBgColor\"\n>\n  <ng-content select=\"[idsMobileHeaderAction]\"></ng-content>\n\n  <div class=\"ids-mobile-header__presentation\">\n    <ng-content select=\"[idsMobileHeaderTitle]\"></ng-content>\n\n    <div *ngIf=\"headingElement\" #headerTitle class=\"ids-mobile-header__title\" aria-hidden=\"true\">\n      {{ headingText }}\n    </div>\n  </div>\n\n  <div class=\"ids-mobile-header__controls\">\n    <ng-content select=\"[idsMobileHeaderControls]\"></ng-content>\n  </div>\n</header>\n", styles: [".ids-animation-fade-in-start{opacity:0}.ids-animation-fade-in-moderate-end{opacity:1;transition:opacity .2s cubic-bezier(.42,0,.58,1)}.ids-animation-fade-out-start{opacity:1}.ids-animation-fade-out-moderate-output-end{opacity:0;transition:opacity 275ms cubic-bezier(.42,0,.58,1)}.ids-animation-scale-x-down{transform:scaleX(0);transform:scaleX(var(--ids-scale-x-down, 0))}.ids-animation-scale-x-up{transform:scaleX(1);transform:scaleX(var(--ids-scale-x-up, 100%))}.ids-animation-time-transform-slow{transition:transform 2s cubic-bezier(0,0,.58,1)}.ids-animation-width-down{width:0;width:var(--ids-width-down, 0)}.ids-animation-width-up{width:100%;width:var(--ids-width-up, 100%)}.ids-animation-time-width-slow{transition:width 2s cubic-bezier(0,0,.58,1)}.ids-motion-none,.ids-motion-none:before,.ids-motion-none:after,.ids-motion-none *,.ids-motion-none *:before,.ids-motion-none *:after{animation:none!important;transition:none!important}.ids-mobile-header,:host.ids-mobile-header{align-items:center;background-color:var(--ids_color_bg_base);border-bottom:var(--ids_size_border_small) solid transparent;box-sizing:border-box;display:flex;justify-content:space-between;left:0;min-height:var(--ids_size_general_72x);padding:0 var(--ids_spacing_2x);position:sticky;top:0;transition:background-color .2s cubic-bezier(.42,0,1,1),color .2s cubic-bezier(.42,0,1,1);width:100%}.ids-mobile-header .ids-icon-button,:host.ids-mobile-header .ids-icon-button{color:var(--ids_color_action_neutral_base)}.ids-mobile-header ::ng-deep .ids-icon-button,:host.ids-mobile-header ::ng-deep .ids-icon-button{color:var(--ids_color_action_neutral_base)}.ids-mobile-header__presentation,:host.ids-mobile-header__presentation{font:var(--ids_textStyle_f02_s16_h24_wrg);margin-left:var(--ids_spacing_4x);opacity:0;overflow:hidden;pointer-events:initial;text-overflow:ellipsis;white-space:nowrap}.ids-mobile-header__presentation>*,:host.ids-mobile-header__presentation>*{font:inherit;margin:0;overflow:inherit;text-overflow:inherit}.ids-mobile-header__controls,:host.ids-mobile-header__controls{display:flex;margin-left:auto}.ids-mobile-header__button,:host.ids-mobile-header__button{background-color:transparent;border:none;color:var(--ids_color_action_neutral_base);height:var(--ids_size_general_48x);line-height:1;width:var(--ids_size_general_48x)}.ids-mobile-header__button+.ids-mobile-header__presentation,:host.ids-mobile-header__button+.ids-mobile-header__presentation{margin-left:var(--ids_spacing_2x)}.ids-mobile-header--collapsed,:host.ids-mobile-header--collapsed{border-color:var(--ids_color_border_soft);transition:background-color .25s cubic-bezier(.42,0,1,1),color .25s cubic-bezier(.42,0,1,1);z-index:1000}.ids-mobile-header--collapsed .ids-mobile-header__presentation,:host.ids-mobile-header--collapsed .ids-mobile-header__presentation{flex:auto;opacity:1;pointer-events:initial;transition:opacity .25s ease-in}.ids-mobile-header--on-brand,:host.ids-mobile-header--on-brand{color:var(--ids_color_contrast_onBrand_primary)}.ids-mobile-header--on-brand .ids-icon-button,:host.ids-mobile-header--on-brand .ids-icon-button{color:inherit}.ids-mobile-header--on-brand ::ng-deep .ids-icon-button,:host.ids-mobile-header--on-brand ::ng-deep .ids-icon-button{color:inherit}.ids-mobile-header--on-brand.ids-mobile-header--collapsed,:host.ids-mobile-header--on-brand.ids-mobile-header--collapsed{border-color:var(--ids_color_action_primary_contrast_soft)}.ids-mobile-header-wrapper{display:block;position:sticky;top:0}.voxel-theme-empresas .ids-mobile-header:not(.ids-mobile-header--on-brand){background:var(--ids_color_bg_brand_gradient);color:var(--ids_color_contrast_onBrand_primary)}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMobileHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-mobile-header', host: {
                        '[class.ids-mobile-header-wrapper]': 'true',
                    }, standalone: true, imports: [CommonModule], template: "<header\n  class=\"ids-mobile-header\"\n  [class.ids-mobile-header--on-brand]=\"currentContrast === 'onBrand'\"\n  [class.ids-mobile-header--collapsed]=\"collapsed || childHeading\"\n  #headerEl\n  [style.background-color]=\"currentBgColor\"\n>\n  <ng-content select=\"[idsMobileHeaderAction]\"></ng-content>\n\n  <div class=\"ids-mobile-header__presentation\">\n    <ng-content select=\"[idsMobileHeaderTitle]\"></ng-content>\n\n    <div *ngIf=\"headingElement\" #headerTitle class=\"ids-mobile-header__title\" aria-hidden=\"true\">\n      {{ headingText }}\n    </div>\n  </div>\n\n  <div class=\"ids-mobile-header__controls\">\n    <ng-content select=\"[idsMobileHeaderControls]\"></ng-content>\n  </div>\n</header>\n", styles: [".ids-animation-fade-in-start{opacity:0}.ids-animation-fade-in-moderate-end{opacity:1;transition:opacity .2s cubic-bezier(.42,0,.58,1)}.ids-animation-fade-out-start{opacity:1}.ids-animation-fade-out-moderate-output-end{opacity:0;transition:opacity 275ms cubic-bezier(.42,0,.58,1)}.ids-animation-scale-x-down{transform:scaleX(0);transform:scaleX(var(--ids-scale-x-down, 0))}.ids-animation-scale-x-up{transform:scaleX(1);transform:scaleX(var(--ids-scale-x-up, 100%))}.ids-animation-time-transform-slow{transition:transform 2s cubic-bezier(0,0,.58,1)}.ids-animation-width-down{width:0;width:var(--ids-width-down, 0)}.ids-animation-width-up{width:100%;width:var(--ids-width-up, 100%)}.ids-animation-time-width-slow{transition:width 2s cubic-bezier(0,0,.58,1)}.ids-motion-none,.ids-motion-none:before,.ids-motion-none:after,.ids-motion-none *,.ids-motion-none *:before,.ids-motion-none *:after{animation:none!important;transition:none!important}.ids-mobile-header,:host.ids-mobile-header{align-items:center;background-color:var(--ids_color_bg_base);border-bottom:var(--ids_size_border_small) solid transparent;box-sizing:border-box;display:flex;justify-content:space-between;left:0;min-height:var(--ids_size_general_72x);padding:0 var(--ids_spacing_2x);position:sticky;top:0;transition:background-color .2s cubic-bezier(.42,0,1,1),color .2s cubic-bezier(.42,0,1,1);width:100%}.ids-mobile-header .ids-icon-button,:host.ids-mobile-header .ids-icon-button{color:var(--ids_color_action_neutral_base)}.ids-mobile-header ::ng-deep .ids-icon-button,:host.ids-mobile-header ::ng-deep .ids-icon-button{color:var(--ids_color_action_neutral_base)}.ids-mobile-header__presentation,:host.ids-mobile-header__presentation{font:var(--ids_textStyle_f02_s16_h24_wrg);margin-left:var(--ids_spacing_4x);opacity:0;overflow:hidden;pointer-events:initial;text-overflow:ellipsis;white-space:nowrap}.ids-mobile-header__presentation>*,:host.ids-mobile-header__presentation>*{font:inherit;margin:0;overflow:inherit;text-overflow:inherit}.ids-mobile-header__controls,:host.ids-mobile-header__controls{display:flex;margin-left:auto}.ids-mobile-header__button,:host.ids-mobile-header__button{background-color:transparent;border:none;color:var(--ids_color_action_neutral_base);height:var(--ids_size_general_48x);line-height:1;width:var(--ids_size_general_48x)}.ids-mobile-header__button+.ids-mobile-header__presentation,:host.ids-mobile-header__button+.ids-mobile-header__presentation{margin-left:var(--ids_spacing_2x)}.ids-mobile-header--collapsed,:host.ids-mobile-header--collapsed{border-color:var(--ids_color_border_soft);transition:background-color .25s cubic-bezier(.42,0,1,1),color .25s cubic-bezier(.42,0,1,1);z-index:1000}.ids-mobile-header--collapsed .ids-mobile-header__presentation,:host.ids-mobile-header--collapsed .ids-mobile-header__presentation{flex:auto;opacity:1;pointer-events:initial;transition:opacity .25s ease-in}.ids-mobile-header--on-brand,:host.ids-mobile-header--on-brand{color:var(--ids_color_contrast_onBrand_primary)}.ids-mobile-header--on-brand .ids-icon-button,:host.ids-mobile-header--on-brand .ids-icon-button{color:inherit}.ids-mobile-header--on-brand ::ng-deep .ids-icon-button,:host.ids-mobile-header--on-brand ::ng-deep .ids-icon-button{color:inherit}.ids-mobile-header--on-brand.ids-mobile-header--collapsed,:host.ids-mobile-header--on-brand.ids-mobile-header--collapsed{border-color:var(--ids_color_action_primary_contrast_soft)}.ids-mobile-header-wrapper{display:block;position:sticky;top:0}.voxel-theme-empresas .ids-mobile-header:not(.ids-mobile-header--on-brand){background:var(--ids_color_bg_brand_gradient);color:var(--ids_color_contrast_onBrand_primary)}\n"] }]
        }], ctorParameters: function () { return [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }]; }, propDecorators: { contrast: [{
                type: Input
            }], collapsedContrast: [{
                type: Input
            }], scrollElement: [{
                type: Input
            }], headingElement: [{
                type: Input
            }], bgColor: [{
                type: Input
            }], collapsedBgColor: [{
                type: Input
            }], childHeading: [{
                type: ContentChild,
                args: [IdsMobileHeaderTitleContentDirective]
            }], headerEl: [{
                type: ViewChild,
                args: ['headerEl']
            }], headerTitle: [{
                type: ViewChild,
                args: ['headerTitle']
            }] } });

class IdsMobileHeaderModule {
}
IdsMobileHeaderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMobileHeaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsMobileHeaderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsMobileHeaderModule, imports: [IdsMobileHeaderComponent,
        IdsMobileHeaderActionContentDirective,
        IdsMobileHeaderControlsContentDirective,
        IdsMobileHeaderTitleContentDirective,
        IdsAutoFocusDirective,
        IdsIconButtonModule], exports: [IdsMobileHeaderComponent,
        IdsMobileHeaderActionContentDirective,
        IdsMobileHeaderControlsContentDirective,
        IdsMobileHeaderTitleContentDirective,
        IdsAutoFocusDirective,
        IdsIconButtonModule] });
IdsMobileHeaderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMobileHeaderModule, imports: [IdsMobileHeaderComponent,
        IdsIconButtonModule, IdsIconButtonModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMobileHeaderModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        IdsMobileHeaderComponent,
                        IdsMobileHeaderActionContentDirective,
                        IdsMobileHeaderControlsContentDirective,
                        IdsMobileHeaderTitleContentDirective,
                        IdsAutoFocusDirective,
                        IdsIconButtonModule,
                    ],
                    exports: [
                        IdsMobileHeaderComponent,
                        IdsMobileHeaderActionContentDirective,
                        IdsMobileHeaderControlsContentDirective,
                        IdsMobileHeaderTitleContentDirective,
                        IdsAutoFocusDirective,
                        IdsIconButtonModule,
                    ],
                }]
        }] });

class IdsNumberBadgeModule {
}
IdsNumberBadgeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsNumberBadgeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsNumberBadgeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsNumberBadgeModule, imports: [IdsNumberBadgeComponent], exports: [IdsNumberBadgeComponent] });
IdsNumberBadgeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsNumberBadgeModule, imports: [IdsNumberBadgeComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsNumberBadgeModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsNumberBadgeComponent],
                    exports: [IdsNumberBadgeComponent],
                }]
        }] });

let NEXT_ID$6 = 0;
/**
 * **Module:**
 *
 * `import { IdsPaginationDotsModule } from '@ids/angular';`
 *
 * **Component:**
 *
 * `import { IdsPaginationDotsComponent } from '@ids/angular';`
 *
 */
class IdsPaginationDotsComponent {
    get classes() {
        return {
            'ids-pagination-dots': true,
            'ids-pagination-dots--on-brand': this.contrast === 'onBrand',
            'ids-pagination-dots--with-arrow': this.arrows,
        };
    }
    get dotsQuantity() {
        return this.dots?.length;
    }
    ariaControlsByIndex(index) {
        return `${this.ariaControlsId}-${index}`;
    }
    /**
     * Define se o componente terá setas de navegação.
     */
    set arrows(arrows) {
        this._arrows = arrows;
    }
    get arrows() {
        return this._arrows || (this.nextLiteral && this.previousLiteral);
    }
    /**
     * Define o dot atual.
     */
    set current(value) {
        if (this._current === value) {
            return;
        }
        this._current = value;
        if (this.currentLiteral) {
            setTimeout(() => {
                this._liveAnnouncer.announce(this.currentLiteral, 1000);
            });
            return;
        }
        if (platform.os === 'IOS') {
            this._liveAnnouncer.announce(`Item ${this._current + 1} de ${this.dotsQuantity}, selecionado`, 1000);
            return;
        }
        this._liveAnnouncer.announce(`Item ${this._current + 1} de ${this.dotsQuantity}`, 1000);
    }
    get current() {
        return this._current;
    }
    /**
     * Define a quantidade de dots com aria-label's.
     */
    set dots(value) {
        if (Array.isArray(value)) {
            this._dots = value;
            return;
        }
        this._dots = Array.from({ length: value }, (_, i) => `Item ${i + 1}`);
    }
    get dots() {
        return this._dots;
    }
    /**
     * Define a quantidade de dots.
     *
     * @deprecated este atributo define a quantidade
     * com aria-labels padrão ( Item `Número` ) para cada dot, utilize o atributo `dots` para definir os labels
     * de cada dot.
     *
     * @example
     * ```typescript
     * // Como usar o atributo dots:
     * dots = [
     *  'Página 1 Informações sobre crédito',
     *  'Página 2 Informações pessoais',
     *  'Página Sobre Uniclass',
     *  'Página 4 Sobre seguro'
     * ];
     * ```
     *
     * ```html
     * <!--Como passar para o componente-->
     * <ids-pagination-dots [dots]="dots"></ids-pagination-dots>
     * ```
     */
    set steps(value) {
        this.dots = value;
    }
    get steps() {
        return this.dots?.length;
    }
    constructor(_liveAnnouncer) {
        this._liveAnnouncer = _liveAnnouncer;
        this._arrows = Boolean(this.steps);
        this._current = 0;
        /**
         * @internal
         */
        this.id = `ids-pagination-dots-${NEXT_ID$6++}`;
        /**
         * Devolve a posição do dot atual.
         */
        this.currentChange = new EventEmitter();
    }
    select(index) {
        if (this.current === index || index < 0 || index >= this.dotsQuantity) {
            return;
        }
        this.current = index;
        this.currentChange.emit(index);
    }
    /**
     * @internal
     *
     * @link https://angular.io/api/core/TrackByFunction
     */
    /* istanbul ignore next */
    trackByIndex(index) {
        return this.id + index;
    }
    onKeydown({ key, target }) {
        if (key === 'ArrowRight' && target.nextElementSibling) {
            target?.nextElementSibling?.focus();
            return;
        }
        if (key === 'ArrowLeft' && target.previousElementSibling) {
            target?.previousElementSibling?.focus();
            return;
        }
    }
}
IdsPaginationDotsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsPaginationDotsComponent, deps: [{ token: i1$1.LiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component });
IdsPaginationDotsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsPaginationDotsComponent, isStandalone: true, selector: "ids-pagination-dots", inputs: { ariaControlsId: ["aria-controls", "ariaControlsId"], arrows: "arrows", contrast: "contrast", current: "current", currentLiteral: "currentLiteral", dots: "dots", id: "id", nextLiteral: "nextLiteral", previousLiteral: "previousLiteral", steps: "steps" }, outputs: { currentChange: "currentChange" }, host: { properties: { "attr.aria-controls": "null" } }, ngImport: i0, template: "<div [id]=\"id\" [class]=\"classes\">\n  <button\n    *ngIf=\"arrows\"\n    idsIconButton\n    size=\"S\"\n    variant=\"neutral\"\n    [contrast]=\"contrast\"\n    [attr.aria-disabled]=\"current === 0\"\n    [attr.title]=\"previousLiteral ?? 'Item anterior'\"\n    (click)=\"select(current - 1)\"\n  >\n    seta_esquerda\n  </button>\n  <div class=\"ids-pagination-dots__items\" role=\"tablist\">\n    <button\n      *ngFor=\"let dot of dots; let i = index; trackBy: trackByIndex\"\n      class=\"ids-pagination-dots__item\"\n      type=\"button\"\n      role=\"tab\"\n      (keydown)=\"onKeydown($event)\"\n      (click)=\"select(i)\"\n      [attr.aria-label]=\"dot\"\n      [attr.aria-controls]=\"ariaControlsId && ariaControlsByIndex(i)\"\n      [attr.aria-selected]=\"!current ? i === 0 : i === current\"\n    ></button>\n  </div>\n  <button\n    *ngIf=\"arrows\"\n    idsIconButton\n    size=\"S\"\n    variant=\"neutral\"\n    [contrast]=\"contrast\"\n    [attr.aria-disabled]=\"current === dots.length - 1\"\n    [attr.title]=\"nextLiteral ?? 'Pr\u00F3ximo item'\"\n    (click)=\"select(current + 1)\"\n  >\n    seta_direita\n  </button>\n</div>\n", styles: [".ids-pagination-dots{align-items:center;border-radius:var(--ids_size_general_48x);display:flex;height:var(--ids_size_general_48x);max-width:-moz-fit-content;max-width:fit-content;transition:background-color var(--ids_motion_time_superslow_01) var(--ids_motion_easing_effective_02)}.ids-pagination-dots .ids-icon-button{border-radius:50% 0 0 50%}.ids-pagination-dots .ids-icon-button:last-child{border-radius:0 50% 50% 0}.ids-pagination-dots__items{align-items:center;display:flex;gap:var(--ids_size_general_4x);padding:0 var(--ids_size_general_16x)}.ids-pagination-dots__item{background-color:var(--ids_color_action_neutral_variant_soft);border:none;border-radius:var(--ids_size_general_10x);height:var(--ids_size_general_6x);outline-offset:var(--ids_size_general_2x);padding:0;transition:width var(--ids_motion_time_superslow_01) var(--ids_motion_easing_effective_02),background-color var(--ids_motion_time_superslow_01) var(--ids_motion_easing_effective_02);width:var(--ids_size_general_6x)}.ids-pagination-dots__item--selected,.ids-pagination-dots__item[aria-selected=true]{background-color:var(--ids_color_action_primary_base);width:var(--ids_size_general_20x)}.ids-pagination-dots--on-brand{background-color:var(--ids_color_contrast_onBrand_primary_soft)}.ids-pagination-dots--on-brand .ids-pagination-dots__item{background-color:var(--ids_color_contrast_onBrand_primary_medium)}.ids-pagination-dots--on-brand .ids-pagination-dots__item--selected,.ids-pagination-dots--on-brand .ids-pagination-dots__item[aria-selected=true]{background-color:var(--ids_color_action_primary_contrast)}.ids-pagination-dots--with-arrow .ids-pagination-dots__items{padding:0}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: IdsIconModule }, { kind: "ngmodule", type: IdsIconButtonModule }, { kind: "component", type: IdsIconButtonComponent, selector: "[idsIconButton]", inputs: ["variant", "contrast", "size", "title", "aria-label"] }] });
__decorate([
    Memo(['contrast', 'arrows']),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], IdsPaginationDotsComponent.prototype, "classes", null);
__decorate([
    Memo(['dots']),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], IdsPaginationDotsComponent.prototype, "dotsQuantity", null);
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], IdsPaginationDotsComponent.prototype, "arrows", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsPaginationDotsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-pagination-dots', standalone: true, imports: [CommonModule, IdsIconModule, IdsIconButtonModule], host: {
                        '[attr.aria-controls]': 'null',
                    }, template: "<div [id]=\"id\" [class]=\"classes\">\n  <button\n    *ngIf=\"arrows\"\n    idsIconButton\n    size=\"S\"\n    variant=\"neutral\"\n    [contrast]=\"contrast\"\n    [attr.aria-disabled]=\"current === 0\"\n    [attr.title]=\"previousLiteral ?? 'Item anterior'\"\n    (click)=\"select(current - 1)\"\n  >\n    seta_esquerda\n  </button>\n  <div class=\"ids-pagination-dots__items\" role=\"tablist\">\n    <button\n      *ngFor=\"let dot of dots; let i = index; trackBy: trackByIndex\"\n      class=\"ids-pagination-dots__item\"\n      type=\"button\"\n      role=\"tab\"\n      (keydown)=\"onKeydown($event)\"\n      (click)=\"select(i)\"\n      [attr.aria-label]=\"dot\"\n      [attr.aria-controls]=\"ariaControlsId && ariaControlsByIndex(i)\"\n      [attr.aria-selected]=\"!current ? i === 0 : i === current\"\n    ></button>\n  </div>\n  <button\n    *ngIf=\"arrows\"\n    idsIconButton\n    size=\"S\"\n    variant=\"neutral\"\n    [contrast]=\"contrast\"\n    [attr.aria-disabled]=\"current === dots.length - 1\"\n    [attr.title]=\"nextLiteral ?? 'Pr\u00F3ximo item'\"\n    (click)=\"select(current + 1)\"\n  >\n    seta_direita\n  </button>\n</div>\n", styles: [".ids-pagination-dots{align-items:center;border-radius:var(--ids_size_general_48x);display:flex;height:var(--ids_size_general_48x);max-width:-moz-fit-content;max-width:fit-content;transition:background-color var(--ids_motion_time_superslow_01) var(--ids_motion_easing_effective_02)}.ids-pagination-dots .ids-icon-button{border-radius:50% 0 0 50%}.ids-pagination-dots .ids-icon-button:last-child{border-radius:0 50% 50% 0}.ids-pagination-dots__items{align-items:center;display:flex;gap:var(--ids_size_general_4x);padding:0 var(--ids_size_general_16x)}.ids-pagination-dots__item{background-color:var(--ids_color_action_neutral_variant_soft);border:none;border-radius:var(--ids_size_general_10x);height:var(--ids_size_general_6x);outline-offset:var(--ids_size_general_2x);padding:0;transition:width var(--ids_motion_time_superslow_01) var(--ids_motion_easing_effective_02),background-color var(--ids_motion_time_superslow_01) var(--ids_motion_easing_effective_02);width:var(--ids_size_general_6x)}.ids-pagination-dots__item--selected,.ids-pagination-dots__item[aria-selected=true]{background-color:var(--ids_color_action_primary_base);width:var(--ids_size_general_20x)}.ids-pagination-dots--on-brand{background-color:var(--ids_color_contrast_onBrand_primary_soft)}.ids-pagination-dots--on-brand .ids-pagination-dots__item{background-color:var(--ids_color_contrast_onBrand_primary_medium)}.ids-pagination-dots--on-brand .ids-pagination-dots__item--selected,.ids-pagination-dots--on-brand .ids-pagination-dots__item[aria-selected=true]{background-color:var(--ids_color_action_primary_contrast)}.ids-pagination-dots--with-arrow .ids-pagination-dots__items{padding:0}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.LiveAnnouncer }]; }, propDecorators: { classes: [], dotsQuantity: [], ariaControlsId: [{
                type: Input,
                args: ['aria-controls']
            }], arrows: [{
                type: Input
            }], contrast: [{
                type: Input
            }], current: [{
                type: Input
            }], currentLiteral: [{
                type: Input
            }], dots: [{
                type: Input
            }], id: [{
                type: Input
            }], nextLiteral: [{
                type: Input
            }], previousLiteral: [{
                type: Input
            }], steps: [{
                type: Input
            }], currentChange: [{
                type: Output
            }] } });

class IdsPaginationDotsModule {
}
IdsPaginationDotsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsPaginationDotsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsPaginationDotsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsPaginationDotsModule, imports: [IdsPaginationDotsComponent], exports: [IdsPaginationDotsComponent] });
IdsPaginationDotsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsPaginationDotsModule, imports: [IdsPaginationDotsComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsPaginationDotsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsPaginationDotsComponent],
                    exports: [IdsPaginationDotsComponent],
                }]
        }] });

let NEXT_ID$5 = 0;
/**
 * O componente tem o objetivo de indicar uma progressão numérica de conteúdo,
 * pode ser utilizado em paginação e em outras composições.
 *
 * **Module:**
 *
 * `import { IdsPaginationNumberModule } from '@ids/angular';`
 *
 * **Component:**
 *
 * `import { IdsPaginationNumberComponent } from '@ids/angular';`
 * **
 */
class IdsPaginationNumberComponent {
    /**
     * Define o rótulo acessível para a barra de progresso
     */
    set ariaLabel(value) {
        this._ariaLabel = value;
    }
    get ariaLabel() {
        if (!this._ariaLabel) {
            return `${this.context} ${this.current} de ${this.steps}`;
        }
        return this._ariaLabel;
    }
    /**
     * Define a página selecionada/atual
     */
    set current(value) {
        const currentValue = Math.abs(Math.round(enforceNumber(value))) || 1;
        this._current = currentValue;
        if (this.steps > 1) {
            this._current = currentValue > this.steps ? this.steps : currentValue;
        }
        if (this.isAndroid && this.arrows && this.currentIsOnLimit) {
            this.handleScreenReader();
        }
        this.calculateFill();
    }
    get current() {
        return this._current;
    }
    /**
     * Define a quantidade de números do indicador
     */
    set steps(value) {
        this._steps = Math.abs(Math.round(enforceNumber(value)));
        this.calculateFill();
    }
    get steps() {
        return this._steps;
    }
    set fill(value) {
        this._fill = value;
    }
    get fill() {
        return this._fill;
    }
    get currentIsOnLimit() {
        return this.current === 1 || this.current === this.steps;
    }
    get mustReadDisabledButton() {
        return this.isAndroid && this.arrows && this.currentIsOnLimit;
    }
    constructor(_liveAnnouncer, _appRef) {
        this._liveAnnouncer = _liveAnnouncer;
        this._appRef = _appRef;
        this.isAndroid = platform.os === 'Android';
        this._ariaLabel = '';
        this.hostAriaLabel = null;
        this.id = `ids-pagination-number-${NEXT_ID$5++}`;
        this.hostId = null;
        /**
         * Define o contexto do pagination number, se é imagem, card, item (padrão).
         */
        this.context = 'Item';
        this._current = 1;
        /**
         * Define a literal do botão próximo (aria-label). Exemplo: Próxima Imagem, Próximo Cartão.
         *
         * *Defines next button's literal (aria-label)*
         */
        this.nextLiteral = 'próximo item';
        /**
         * Define a literal do botão anterior (aria-label). Exemplo: Imagem anterior, Cartão anterior.
         *
         * *Defines previous button's literal (aria-label)*
         */
        this.previousLiteral = 'item anterior';
        this._steps = 1;
        this.currentChange = new EventEmitter();
        this._fill = 0;
    }
    ngOnInit() {
        this.current = this.current <= this.steps ? this.current : this.steps;
        this.calculateFill();
    }
    calculateFill() {
        this.fill = Number(((100 * this.current) / this.steps).toFixed());
    }
    announceValue() {
        this._appRef.tick();
        if (this.mustReadDisabledButton) {
            this.handleScreenReader();
            return;
        }
        this._liveAnnouncer.announce(this.ariaLabel, 1000);
    }
    handleScreenReader() {
        const literal = this.current === 1 ? this.previousLiteral : this.nextLiteral;
        this._liveAnnouncer.announce(`${literal}, botão, desativado`, 1000);
    }
    next() {
        if (this.current === this.steps) {
            return;
        }
        this.current = this.current + 1;
        this.currentChange.emit(this.current);
        this.announceValue();
    }
    previous() {
        if (this.current === 1) {
            return;
        }
        this.current = this.current - 1;
        this.currentChange.emit(this.current);
        this.announceValue();
    }
}
IdsPaginationNumberComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsPaginationNumberComponent, deps: [{ token: i1$1.LiveAnnouncer }, { token: i0.ApplicationRef }], target: i0.ɵɵFactoryTarget.Component });
IdsPaginationNumberComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsPaginationNumberComponent, isStandalone: true, selector: "ids-pagination-number", inputs: { ariaLabel: ["aria-label", "ariaLabel"], id: "id", arrows: "arrows", context: "context", contrast: "contrast", current: "current", nextLiteral: "nextLiteral", previousLiteral: "previousLiteral", steps: "steps" }, outputs: { currentChange: "currentChange" }, host: { properties: { "attr.aria-label": "this.hostAriaLabel", "attr.id": "this.hostId" } }, ngImport: i0, template: "<div\n  class=\"ids-pagination-number\"\n  [id]=\"id\"\n  [class.ids-pagination-number--on-brand]=\"contrast === 'onBrand'\"\n>\n  <button\n    *ngIf=\"arrows\"\n    idsIconButton\n    [contrast]=\"contrast\"\n    [tabindex]=\"current === 1 ? -1 : 0\"\n    [attr.aria-disabled]=\"current === 1\"\n    variant=\"neutral\"\n    [attr.aria-label]=\"previousLiteral\"\n    (click)=\"previous()\"\n  >\n    <ids-icon>seta_esquerda</ids-icon>\n  </button>\n\n  <div class=\"ids-pagination-number__container\" [attr.aria-label]=\"ariaLabel\" role=\"img\">\n    <span class=\"ids-pagination-number__label ids-pagination-number__label--bold\">\n      {{ current }}\n    </span>\n\n    <div class=\"ids-pagination-number__progress-bar\" [style.backgroundSize]=\"fill + '% 100%'\"></div>\n\n    <span\n      class=\"ids-pagination-number__label\"\n      [class.ids-pagination-number__label--bold]=\"fill === 100\"\n    >\n      {{ steps }}\n    </span>\n  </div>\n\n  <button\n    *ngIf=\"arrows\"\n    idsIconButton\n    [contrast]=\"contrast\"\n    [tabindex]=\"current === steps ? -1 : 0\"\n    [attr.aria-disabled]=\"current === steps\"\n    variant=\"neutral\"\n    [attr.aria-label]=\"nextLiteral\"\n    (click)=\"next()\"\n  >\n    <ids-icon>seta_direita</ids-icon>\n  </button>\n</div>\n", styles: [".ids-pagination-number{display:flex}.ids-pagination-number__container{gap:var(--ids_size_general_8x);align-items:center;display:flex}.js-no-flexbox-gap .ids-pagination-number__container{margin:calc(var(--ids_size_general_8x) / -2)!important}.js-no-flexbox-gap .ids-pagination-number__container>*{margin:calc(var(--ids_size_general_8x) / 2)!important}.ids-pagination-number__label{color:var(--ids_color_action_neutral_base);font:var(--ids_textStyle_f02_s12_h18_wrg)}.ids-pagination-number__label--bold{font:var(--ids_textStyle_f02_s12_h18_wbd)}.ids-pagination-number__progress-bar{align-self:center;background:linear-gradient(to right,var(--ids_color_action_neutral_variant) 0%,var(--ids_color_action_neutral_variant) 100%);background-color:var(--ids_color_action_neutral_base_soft);background-repeat:no-repeat;border-radius:var(--ids_size_general_4x);height:var(--ids_size_general_4x);transition:background-size 175ms ease-in;width:var(--ids_size_general_32x)}.ids-pagination-number--on-brand .ids-pagination-number__label{color:var(--ids_color_contrast_onBrand_primary)}.ids-pagination-number--on-brand .ids-pagination-number__progress-bar{background:linear-gradient(to right,var(--ids_color_contrast_onBrand_primary) 0%,var(--ids_color_contrast_onBrand_primary) 100%);background-color:var(--ids_color_contrast_onBrand_primary_soft);background-repeat:no-repeat}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: IdsIconModule }, { kind: "component", type: IdsIconComponent, selector: "ids-icon", inputs: ["size", "variant", "contrast"] }, { kind: "ngmodule", type: IdsIconButtonModule }, { kind: "component", type: IdsIconButtonComponent, selector: "[idsIconButton]", inputs: ["variant", "contrast", "size", "title", "aria-label"] }] });
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object)
], IdsPaginationNumberComponent.prototype, "arrows", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsPaginationNumberComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-pagination-number', standalone: true, imports: [CommonModule, IdsIconModule, IdsIconButtonModule], template: "<div\n  class=\"ids-pagination-number\"\n  [id]=\"id\"\n  [class.ids-pagination-number--on-brand]=\"contrast === 'onBrand'\"\n>\n  <button\n    *ngIf=\"arrows\"\n    idsIconButton\n    [contrast]=\"contrast\"\n    [tabindex]=\"current === 1 ? -1 : 0\"\n    [attr.aria-disabled]=\"current === 1\"\n    variant=\"neutral\"\n    [attr.aria-label]=\"previousLiteral\"\n    (click)=\"previous()\"\n  >\n    <ids-icon>seta_esquerda</ids-icon>\n  </button>\n\n  <div class=\"ids-pagination-number__container\" [attr.aria-label]=\"ariaLabel\" role=\"img\">\n    <span class=\"ids-pagination-number__label ids-pagination-number__label--bold\">\n      {{ current }}\n    </span>\n\n    <div class=\"ids-pagination-number__progress-bar\" [style.backgroundSize]=\"fill + '% 100%'\"></div>\n\n    <span\n      class=\"ids-pagination-number__label\"\n      [class.ids-pagination-number__label--bold]=\"fill === 100\"\n    >\n      {{ steps }}\n    </span>\n  </div>\n\n  <button\n    *ngIf=\"arrows\"\n    idsIconButton\n    [contrast]=\"contrast\"\n    [tabindex]=\"current === steps ? -1 : 0\"\n    [attr.aria-disabled]=\"current === steps\"\n    variant=\"neutral\"\n    [attr.aria-label]=\"nextLiteral\"\n    (click)=\"next()\"\n  >\n    <ids-icon>seta_direita</ids-icon>\n  </button>\n</div>\n", styles: [".ids-pagination-number{display:flex}.ids-pagination-number__container{gap:var(--ids_size_general_8x);align-items:center;display:flex}.js-no-flexbox-gap .ids-pagination-number__container{margin:calc(var(--ids_size_general_8x) / -2)!important}.js-no-flexbox-gap .ids-pagination-number__container>*{margin:calc(var(--ids_size_general_8x) / 2)!important}.ids-pagination-number__label{color:var(--ids_color_action_neutral_base);font:var(--ids_textStyle_f02_s12_h18_wrg)}.ids-pagination-number__label--bold{font:var(--ids_textStyle_f02_s12_h18_wbd)}.ids-pagination-number__progress-bar{align-self:center;background:linear-gradient(to right,var(--ids_color_action_neutral_variant) 0%,var(--ids_color_action_neutral_variant) 100%);background-color:var(--ids_color_action_neutral_base_soft);background-repeat:no-repeat;border-radius:var(--ids_size_general_4x);height:var(--ids_size_general_4x);transition:background-size 175ms ease-in;width:var(--ids_size_general_32x)}.ids-pagination-number--on-brand .ids-pagination-number__label{color:var(--ids_color_contrast_onBrand_primary)}.ids-pagination-number--on-brand .ids-pagination-number__progress-bar{background:linear-gradient(to right,var(--ids_color_contrast_onBrand_primary) 0%,var(--ids_color_contrast_onBrand_primary) 100%);background-color:var(--ids_color_contrast_onBrand_primary_soft);background-repeat:no-repeat}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.LiveAnnouncer }, { type: i0.ApplicationRef }]; }, propDecorators: { ariaLabel: [{
                type: Input,
                args: ['aria-label']
            }], hostAriaLabel: [{
                type: HostBinding,
                args: ['attr.aria-label']
            }], id: [{
                type: Input
            }], hostId: [{
                type: HostBinding,
                args: ['attr.id']
            }], arrows: [{
                type: Input
            }], context: [{
                type: Input
            }], contrast: [{
                type: Input
            }], current: [{
                type: Input
            }], nextLiteral: [{
                type: Input
            }], previousLiteral: [{
                type: Input
            }], steps: [{
                type: Input
            }], currentChange: [{
                type: Output
            }] } });

class IdsPaginationNumberModule {
}
IdsPaginationNumberModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsPaginationNumberModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsPaginationNumberModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsPaginationNumberModule, imports: [IdsPaginationNumberComponent], exports: [IdsPaginationNumberComponent] });
IdsPaginationNumberModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsPaginationNumberModule, imports: [IdsPaginationNumberComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsPaginationNumberModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsPaginationNumberComponent],
                    exports: [IdsPaginationNumberComponent],
                }]
        }] });

class IdsPaginationComponent {
    get pageIndex() {
        return this.currentPage - 1;
    }
    get firstVisibleItem() {
        return this.pageIndex * this.currentPageSize + 1;
    }
    get lastVisibleItem() {
        const lastItem = this.firstVisibleItem + this.currentPageSize - 1;
        return lastItem > this.total ? this.total : lastItem;
    }
    get totalPages() {
        return Math.ceil(this.total / this.currentPageSize);
    }
    get pageInputPattern() {
        const repeater = this.totalPages.toString().length;
        return '0'.repeat(repeater);
    }
    get itemsCountText() {
        return `exibindo ${this.firstVisibleItem} - ${this.lastVisibleItem} de ${this.total} ${this.total === 1 ? 'item' : 'itens'}`;
    }
    get pagesCountText() {
        return `página ${this.currentPage} de ${this.totalPages}`;
    }
    /** Opções de itens por página */
    get pageSizes() {
        return this._pageSizes;
    }
    set pageSizes(value) {
        if (this._pageSizes === value || !value) {
            return;
        }
        this._pageSizes = value;
        if (this._isInitialized) {
            this._currentPageSize = this.pageSizes[0];
        }
    }
    /** Itens por página atualmente selecionado. Por padrão é sempre a primeira opção da lista */
    get currentPageSize() {
        return this._currentPageSize;
    }
    set currentPageSize(value) {
        if (this._currentPageSize === value ||
            !value ||
            (this._isInitialized && !this.pageSizes.includes(value))) {
            return;
        }
        this._currentPageSize = value;
    }
    /** Quantidade total de registros */
    get total() {
        return this._total;
    }
    set total(value) {
        const valueAsNumber = Number(value);
        if (this._total === valueAsNumber || !valueAsNumber || valueAsNumber <= 0) {
            return;
        }
        this._total = valueAsNumber;
    }
    /** Define a página atual */
    get currentPage() {
        return this._currentPage;
    }
    set currentPage(value) {
        if (this._currentPage === value || !value) {
            return;
        }
        if (this._isInitialized) {
            this._validateCurrentPage(value);
            this._announceCurrentPage();
            return;
        }
        this._currentPage = value;
        this._announceCurrentPage();
    }
    /** Remove a seleção de itens por página */
    set hideItemsPerPage(value) {
        this._hideItemsPerPage = enforceBoolean(value);
    }
    get hideItemsPerPage() {
        return this._hideItemsPerPage;
    }
    /** Remove o contador de páginas */
    set hidePageCounter(value) {
        this._hidePageCounter = enforceBoolean(value);
    }
    get hidePageCounter() {
        return this._hidePageCounter;
    }
    /** Remove os botões de controle */
    set hideControls(value) {
        this._hideControls = enforceBoolean(value);
    }
    get hideControls() {
        return this._hideControls;
    }
    constructor(_renderer, _la) {
        this._renderer = _renderer;
        this._la = _la;
        this._isInitialized = false;
        /**
         * Define o texto de acessibilidade para o
         * container do pagination.
         */
        this.ariaLabel = 'paginação da tabela';
        this._pageSizes = [10, 20, 30, 40, 50];
        this._currentPageSize = 10;
        this._total = 1;
        this._currentPage = 1;
        this._hideItemsPerPage = false;
        this._hidePageCounter = false;
        this._hideControls = false;
        /** Evento emitido ao alterar a paginação */
        this.paginate = new EventEmitter();
        /** @internal */
        this.currentPageChange = new EventEmitter();
        /** @internal */
        this.currentPageSizeChange = new EventEmitter();
    }
    ngOnInit() {
        this._validateCurrentPageSize();
        this._validateCurrentPage();
        this._isInitialized = true;
    }
    _announceCurrentPage() {
        this._la.announce(`página ${this.currentPage} selecionada`, 1000);
    }
    _handlePagination(announce = true) {
        this._emitValueChanges();
        this._emitPaginationEvent();
        if (announce) {
            this._announceCurrentPage();
        }
    }
    _emitPaginationEvent() {
        const event = {
            currentPage: this.currentPage,
            pageIndex: this.pageIndex,
            pageSize: this.currentPageSize,
            total: this.total,
            totalPages: this.totalPages,
        };
        this.paginate.emit(event);
    }
    _emitValueChanges() {
        this.currentPageChange.emit(this.currentPage);
        this.currentPageSizeChange.emit(this.currentPageSize);
    }
    _refreshPageInputViewValue() {
        this._renderer.setProperty(this.currentPageInput.nativeElement, 'value', this.currentPage);
    }
    _validateCurrentPage(value) {
        const currentPageValue = value || this.currentPage;
        this._currentPage =
            currentPageValue < this.totalPages
                ? currentPageValue < 1
                    ? 1
                    : currentPageValue
                : this.totalPages;
    }
    _validateCurrentPageSize() {
        this._currentPageSize = !this.pageSizes.includes(this.currentPageSize)
            ? this.pageSizes[0]
            : this.currentPageSize;
    }
    previousPage() {
        this._currentPage--;
        this._handlePagination();
    }
    nextPage() {
        this._currentPage++;
        this._handlePagination();
    }
    onKeydown(event) {
        if (event.code === 'Enter' || event.code === 'NumpadEnter' || event.code === 'Space') {
            const inputValue = Number(event.target.value);
            if (inputValue <= 0) {
                if (this.currentPage !== 1) {
                    this._currentPage = 1;
                    this._handlePagination();
                    return;
                }
                this._refreshPageInputViewValue();
                return;
            }
            if (inputValue > this.totalPages) {
                if (this.currentPage !== this.totalPages) {
                    this._currentPage = this.totalPages;
                    this._handlePagination();
                    return;
                }
                this._refreshPageInputViewValue();
                return;
            }
            if (this.currentPage === inputValue) {
                return;
            }
            this._currentPage = inputValue;
            this._handlePagination();
        }
    }
    onBlur(event) {
        if (Number(event.target.value) !== this.currentPage) {
            this._refreshPageInputViewValue();
        }
    }
    onPageSizeChange() {
        if (this.currentPage === 1) {
            this._handlePagination(false);
            return;
        }
        this._currentPage = 1;
        this._handlePagination();
    }
}
IdsPaginationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsPaginationComponent, deps: [{ token: i0.Renderer2 }, { token: i1$1.LiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component });
IdsPaginationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsPaginationComponent, isStandalone: true, selector: "ids-pagination", inputs: { ariaLabelledby: ["aria-labelledby", "ariaLabelledby"], ariaLabel: ["aria-label", "ariaLabel"], borderStyle: "borderStyle", pageSizes: "pageSizes", currentPageSize: "currentPageSize", total: "total", currentPage: "currentPage", hideItemsPerPage: "hideItemsPerPage", hidePageCounter: "hidePageCounter", hideControls: "hideControls" }, outputs: { paginate: "paginate", currentPageChange: "currentPageChange", currentPageSizeChange: "currentPageSizeChange" }, viewQueries: [{ propertyName: "currentPageInput", first: true, predicate: ["currentPageInput"], descendants: true }], ngImport: i0, template: "<section\n  class=\"ids-pagination\"\n  [class.ids-pagination--solid-border]=\"borderStyle === 'solid'\"\n  [attr.aria-label]=\"!ariaLabelledby ? ariaLabel : null\"\n  [attr.aria-labelledby]=\"ariaLabelledby\"\n>\n  <ng-container *ngIf=\"!hideItemsPerPage\">\n    <label class=\"ids-pagination__text\" id=\"pageSizeLabelId\" for=\"pageSizeId\"\n      >itens por p\u00E1gina</label\n    >\n    <ids-form-field noMessage>\n      <ids-select\n        id=\"pageSizeId\"\n        noLabel\n        aria-labelledby=\"pageSizeLabelId\"\n        [(ngModel)]=\"currentPageSize\"\n        (change)=\"onPageSizeChange()\"\n      >\n        <ids-option *ngFor=\"let size of pageSizes\" [value]=\"size\">{{ size }}</ids-option>\n      </ids-select>\n    </ids-form-field>\n\n    <hr class=\"ids-pagination__separator\" aria-hidden=\"true\" />\n\n    <span class=\"ids-pagination__text\">{{ itemsCountText }}</span>\n\n    <hr class=\"ids-pagination__separator\" aria-hidden=\"true\" />\n  </ng-container>\n\n  <ng-container *ngIf=\"!hidePageCounter\">\n    <ids-form-field class=\"ids-pagination__page-control\" noMessage>\n      <input\n        #currentPageInput\n        idsInput\n        id=\"currentPageId\"\n        noLabel\n        type=\"text\"\n        [idsMask]=\"pageInputPattern\"\n        [ngModel]=\"currentPage\"\n        (keydown)=\"onKeydown($event)\"\n        (blur)=\"onBlur($event)\"\n        aria-label=\"ir para a p\u00E1gina\"\n      />\n    </ids-form-field>\n\n    <span class=\"ids-pagination__text\" id=\"totalPagesId\">{{ pagesCountText }}</span>\n  </ng-container>\n\n  <ng-container *ngIf=\"!hideControls\">\n    <div class=\"ids-pagination__controls\">\n      <button\n        idsIconButton\n        id=\"previousPageId\"\n        title=\"p\u00E1gina anterior\"\n        [disabled]=\"currentPage <= 1\"\n        (click)=\"previousPage()\"\n      >\n        seta_esquerda\n      </button>\n      <button\n        idsIconButton\n        id=\"nextPageId\"\n        title=\"pr\u00F3xima p\u00E1gina\"\n        [disabled]=\"currentPage >= totalPages\"\n        (click)=\"nextPage()\"\n      >\n        seta_direita\n      </button>\n    </div>\n  </ng-container>\n</section>\n", styles: [":host{display:block}.ids-pagination{align-items:center;color:var(--ids_color_text_body_02);display:flex;font:var(--ids_textStyle_f02_s16_h24_wrg);gap:var(--ids_spacing_6x);justify-content:flex-end;min-height:var(--ids_size_general_64x);padding:var(--ids_spacing_2x) var(--ids_spacing_4x)}.ids-pagination ::ng-deep .ids-input{font:var(--ids_textStyle_f02_s16_h24_wrg);height:var(--ids_size_general_36x);text-align:center}.ids-pagination ::ng-deep .ids-form-field__suffix{bottom:.3125rem}.ids-pagination__separator{background-color:var(--ids_color_text_body_02);height:var(--ids_size_general_24x);width:var(--ids_size_general_1x)}.ids-pagination__controls{display:flex;gap:var(--ids_spacing_4x)}.ids-pagination__text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ids-pagination__page-control{flex:0 0 var(--ids_size_general_48x)}.ids-pagination__page-control input{padding-left:0}.ids-pagination--solid-border{border:solid var(--ids_size_general_1x) var(--ids_color_border_medium);border-radius:0 0 var(--ids_size_general_4x) var(--ids_size_general_4x)}.ids-pagination ::ng-deep .ids-form-field__status-message{display:none}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i1$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "ngmodule", type: IdsFormFieldModule }, { kind: "component", type: IdsFormFieldComponent, selector: "ids-form-field", inputs: ["aria-describedby", "contrast", "label", "size", "noMessage", "thresholdAnnounce", "variant", "noBorder", "errorMessage", "description", "edit", "noValidate", "center", "charactersRemainingMessage"] }, { kind: "ngmodule", type: IdsIconButtonModule }, { kind: "component", type: IdsIconButtonComponent, selector: "[idsIconButton]", inputs: ["variant", "contrast", "size", "title", "aria-label"] }, { kind: "ngmodule", type: IdsInputModule }, { kind: "directive", type: IdsInputDirective, selector: "[idsInput]:not([idsDatepicker])", inputs: ["readonly", "autoResize", "noStyles", "noLabel", "id", "type", "inputmode", "pattern", "updateFirstOnBlur", "size"], outputs: ["valueChange"] }, { kind: "ngmodule", type: IdsMaskModule }, { kind: "directive", type: IdsMaskDirective, selector: "[idsMask]", inputs: ["announce", "allowLeadingZeros", "config", "disabled", "forceEndCursor", "guide", "idsMask", "keepCharPositions", "readonly", "shouldKeepMask", "value"] }, { kind: "ngmodule", type: IdsSelectModule }, { kind: "component", type: IdsSelectComponent, selector: "ids-select", inputs: ["id", "visibleOptions", "position", "required", "noLabel", "small", "compareWith"], outputs: ["change", "focus", "blur", "opened", "closed"] }, { kind: "component", type: IdsOptionComponent, selector: "ids-option", inputs: ["selected", "label", "id", "value", "disabled", "small"], outputs: ["change", "selectedChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsPaginationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-pagination', standalone: true, imports: [
                        CommonModule,
                        FormsModule,
                        IdsFormFieldModule,
                        IdsIconButtonModule,
                        IdsInputModule,
                        IdsMaskModule,
                        IdsSelectModule,
                    ], template: "<section\n  class=\"ids-pagination\"\n  [class.ids-pagination--solid-border]=\"borderStyle === 'solid'\"\n  [attr.aria-label]=\"!ariaLabelledby ? ariaLabel : null\"\n  [attr.aria-labelledby]=\"ariaLabelledby\"\n>\n  <ng-container *ngIf=\"!hideItemsPerPage\">\n    <label class=\"ids-pagination__text\" id=\"pageSizeLabelId\" for=\"pageSizeId\"\n      >itens por p\u00E1gina</label\n    >\n    <ids-form-field noMessage>\n      <ids-select\n        id=\"pageSizeId\"\n        noLabel\n        aria-labelledby=\"pageSizeLabelId\"\n        [(ngModel)]=\"currentPageSize\"\n        (change)=\"onPageSizeChange()\"\n      >\n        <ids-option *ngFor=\"let size of pageSizes\" [value]=\"size\">{{ size }}</ids-option>\n      </ids-select>\n    </ids-form-field>\n\n    <hr class=\"ids-pagination__separator\" aria-hidden=\"true\" />\n\n    <span class=\"ids-pagination__text\">{{ itemsCountText }}</span>\n\n    <hr class=\"ids-pagination__separator\" aria-hidden=\"true\" />\n  </ng-container>\n\n  <ng-container *ngIf=\"!hidePageCounter\">\n    <ids-form-field class=\"ids-pagination__page-control\" noMessage>\n      <input\n        #currentPageInput\n        idsInput\n        id=\"currentPageId\"\n        noLabel\n        type=\"text\"\n        [idsMask]=\"pageInputPattern\"\n        [ngModel]=\"currentPage\"\n        (keydown)=\"onKeydown($event)\"\n        (blur)=\"onBlur($event)\"\n        aria-label=\"ir para a p\u00E1gina\"\n      />\n    </ids-form-field>\n\n    <span class=\"ids-pagination__text\" id=\"totalPagesId\">{{ pagesCountText }}</span>\n  </ng-container>\n\n  <ng-container *ngIf=\"!hideControls\">\n    <div class=\"ids-pagination__controls\">\n      <button\n        idsIconButton\n        id=\"previousPageId\"\n        title=\"p\u00E1gina anterior\"\n        [disabled]=\"currentPage <= 1\"\n        (click)=\"previousPage()\"\n      >\n        seta_esquerda\n      </button>\n      <button\n        idsIconButton\n        id=\"nextPageId\"\n        title=\"pr\u00F3xima p\u00E1gina\"\n        [disabled]=\"currentPage >= totalPages\"\n        (click)=\"nextPage()\"\n      >\n        seta_direita\n      </button>\n    </div>\n  </ng-container>\n</section>\n", styles: [":host{display:block}.ids-pagination{align-items:center;color:var(--ids_color_text_body_02);display:flex;font:var(--ids_textStyle_f02_s16_h24_wrg);gap:var(--ids_spacing_6x);justify-content:flex-end;min-height:var(--ids_size_general_64x);padding:var(--ids_spacing_2x) var(--ids_spacing_4x)}.ids-pagination ::ng-deep .ids-input{font:var(--ids_textStyle_f02_s16_h24_wrg);height:var(--ids_size_general_36x);text-align:center}.ids-pagination ::ng-deep .ids-form-field__suffix{bottom:.3125rem}.ids-pagination__separator{background-color:var(--ids_color_text_body_02);height:var(--ids_size_general_24x);width:var(--ids_size_general_1x)}.ids-pagination__controls{display:flex;gap:var(--ids_spacing_4x)}.ids-pagination__text{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.ids-pagination__page-control{flex:0 0 var(--ids_size_general_48x)}.ids-pagination__page-control input{padding-left:0}.ids-pagination--solid-border{border:solid var(--ids_size_general_1x) var(--ids_color_border_medium);border-radius:0 0 var(--ids_size_general_4x) var(--ids_size_general_4x)}.ids-pagination ::ng-deep .ids-form-field__status-message{display:none}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i1$1.LiveAnnouncer }]; }, propDecorators: { ariaLabelledby: [{
                type: Input,
                args: ['aria-labelledby']
            }], ariaLabel: [{
                type: Input,
                args: ['aria-label']
            }], borderStyle: [{
                type: Input
            }], pageSizes: [{
                type: Input
            }], currentPageSize: [{
                type: Input
            }], total: [{
                type: Input
            }], currentPage: [{
                type: Input
            }], hideItemsPerPage: [{
                type: Input
            }], hidePageCounter: [{
                type: Input
            }], hideControls: [{
                type: Input
            }], paginate: [{
                type: Output
            }], currentPageChange: [{
                type: Output
            }], currentPageSizeChange: [{
                type: Output
            }], currentPageInput: [{
                type: ViewChild,
                args: ['currentPageInput']
            }] } });

class IdsPaginationModule {
}
IdsPaginationModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsPaginationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsPaginationModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsPaginationModule, imports: [IdsPaginationComponent], exports: [IdsPaginationComponent] });
IdsPaginationModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsPaginationModule, imports: [IdsPaginationComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsPaginationModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsPaginationComponent],
                    exports: [IdsPaginationComponent],
                }]
        }] });

class IdsInputPasswordDirective {
    get inputElement() {
        return this.elementRef.nativeElement;
    }
    get valueLength() {
        return this.inputElement.value.length;
    }
    get inputMode() {
        return 'numeric';
    }
    get type() {
        return this.showPassword || this.passwordType === 'otp' ? 'text' : 'password';
    }
    /**
     * Define o tamanho máximo do campo. O padrão é 6.
     */
    set maxLength(maxLength) {
        this._maxLength = enforceNumber(maxLength);
    }
    get maxLength() {
        return this._maxLength;
    }
    onInput({ target }) {
        target.value = target.value.replace(/[^0-9.]/g, '');
    }
    onPaste(event) {
        const pastedData = event.clipboardData?.getData('text');
        if (!pastedData.match(this.pattern)) {
            return false;
        }
        return true;
    }
    onMouseDown() {
        this.ready = false;
    }
    setCursorByZoneOfClick(event) {
        const { offsetWidth } = this.inputElement;
        const inputPositionOnScreen = this.inputElement.getBoundingClientRect().left;
        const squareWidth = offsetWidth / this._maxLength;
        const squareIndex = Math.floor((event.clientX - inputPositionOnScreen) / squareWidth);
        const selectionEnd = squareIndex >= this.valueLength ? this.valueLength : squareIndex + 1;
        this.inputElement.setSelectionRange(squareIndex, selectionEnd);
        this.ready = true;
    }
    constructor(elementRef, _focusMonitor) {
        this.elementRef = elementRef;
        this._focusMonitor = _focusMonitor;
        this._destroy = new Subject();
        this.ready = true;
        /**
         * Variações:
         *
         * *Variations:*
         *
         * - password
         * - otp
         */
        this.passwordType = 'password';
        this.className = 'ids-input-password';
        this.pattern = '[0-9]';
        this._maxLength = 6;
    }
    ngAfterContentInit() {
        this.activateFocusMonitor();
    }
    ngOnDestroy() {
        this._focusMonitor.stopMonitoring(this.elementRef);
        this._destroy.next();
        this._destroy.complete();
    }
    /* istanbul ignore next */
    activateFocusMonitor() {
        /* istanbul ignore next */
        this._focusMonitor
            .monitor(this.elementRef.nativeElement, true)
            .pipe(takeUntil$1(this._destroy))
            .subscribe((origin) => (this.canShowVisibleFocus = origin === 'keyboard'));
    }
}
IdsInputPasswordDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsInputPasswordDirective, deps: [{ token: i0.ElementRef }, { token: i1$1.FocusMonitor }], target: i0.ɵɵFactoryTarget.Directive });
IdsInputPasswordDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsInputPasswordDirective, isStandalone: true, selector: "[idsInputPassword]", inputs: { passwordType: "passwordType", showPassword: "showPassword", maxLength: ["maxlength", "maxLength"] }, host: { listeners: { "input": "onInput($event)", "paste": "onPaste($event)", "mousedown": "onMouseDown($event)", "click": "setCursorByZoneOfClick($event)" }, properties: { "attr.class": "this.className", "attr.inputmode": "this.inputMode", "attr.pattern": "this.pattern", "attr.type": "this.type", "attr.maxlength": "this.maxLength" } }, ngImport: i0 });
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object)
], IdsInputPasswordDirective.prototype, "showPassword", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsInputPasswordDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsInputPassword]',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1$1.FocusMonitor }]; }, propDecorators: { passwordType: [{
                type: Input
            }], showPassword: [{
                type: Input
            }], className: [{
                type: HostBinding,
                args: ['attr.class']
            }], inputMode: [{
                type: HostBinding,
                args: ['attr.inputmode']
            }], pattern: [{
                type: HostBinding,
                args: ['attr.pattern']
            }], type: [{
                type: HostBinding,
                args: ['attr.type']
            }], maxLength: [{
                type: Input,
                args: ['maxlength']
            }, {
                type: HostBinding,
                args: ['attr.maxlength']
            }], onInput: [{
                type: HostListener,
                args: ['input', ['$event']]
            }], onPaste: [{
                type: HostListener,
                args: ['paste', ['$event']]
            }], onMouseDown: [{
                type: HostListener,
                args: ['mousedown', ['$event']]
            }], setCursorByZoneOfClick: [{
                type: HostListener,
                args: ['click', ['$event']]
            }] } });

let NEXT_ID$4 = 0;
/**
 * **Module:**
 *
 * `import { IdsPasswordModule } from '@ids/angular';`
 *
 * **Component:**
 *
 * `import { IdsPasswordComponent } from '@ids/angular';`
 *
 */
class IdsPasswordComponent {
    get canShowVisibleFocus() {
        return this.field.canShowVisibleFocus;
    }
    get classes() {
        return {
            'ids-password': true,
            'ids-password--visible-focus': this.canShowVisibleFocus,
            'ids-password--on-brand': this.contrast === 'onBrand',
            'ids-password--disabled': this.disabled,
        };
    }
    get cursorPosition() {
        const position = (this.inputEl.selectionStart || 0) + 1;
        return position > this.inputEl.maxLength ? this.inputEl.maxLength : position;
    }
    get disabled() {
        return this.inputEl.disabled;
    }
    get fieldsArray() {
        return new Array(this.inputEl.maxLength).fill(0);
    }
    get inputEl() {
        return this.field.elementRef.nativeElement;
    }
    get hasFocus() {
        return hasFocus(this.inputEl);
    }
    get ready() {
        return this.field.ready;
    }
    get showPassword() {
        return !!this.field.showPassword;
    }
    set showPassword(value) {
        this.field.showPassword = !!value;
    }
    get type() {
        return this.field.passwordType;
    }
    get value() {
        return this.inputEl.value;
    }
    get valueLength() {
        return this.inputEl.value.length;
    }
    constructor(liveAnnouncer) {
        this.liveAnnouncer = liveAnnouncer;
        /**
         * Mensagem de erro para ser exibida quando o campo é inválido
         */
        this.errorMessage = 'senha incorreta';
    }
    ngOnChanges(changes) {
        if (changes.showPassword?.previousValue && !changes.showPassword?.currentValue) {
            this.liveAnnouncer.announce('senha ocultada', 1000);
        }
        else if (!changes.showPassword?.previousValue && changes.showPassword?.currentValue) {
            this.liveAnnouncer.announce('senha exibida', 1000);
        }
    }
    ngAfterContentInit() {
        if (this.button) {
            this.button.elementRef.nativeElement.disabled = this.disabled;
            this.button.contrast = this.contrast;
            this.button.elementRef.nativeElement.type = 'button';
            if (this.contrast !== 'onBrand') {
                this.button.variant = 'neutral';
            }
        }
        this._defineInputId();
    }
    _defineInputId() {
        this.id = this.inputEl.id || `ids-password-${++NEXT_ID$4}`;
        this.inputEl.id = this.id;
    }
}
IdsPasswordComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsPasswordComponent, deps: [{ token: i1$1.LiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component });
IdsPasswordComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsPasswordComponent, isStandalone: true, selector: "ids-password", inputs: { contrast: "contrast", error: "error", errorMessage: "errorMessage", label: "label", withButton: "withButton" }, queries: [{ propertyName: "button", first: true, predicate: IdsActionButtonComponent, descendants: true }, { propertyName: "field", first: true, predicate: IdsInputPasswordDirective, descendants: true }, { propertyName: "message", first: true, predicate: IdsFormMessageComponent, descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div [class]=\"classes\">\n  <div class=\"ids-password__field\">\n    <div class=\"ids-password__form-message\">\n      <label *ngIf=\"label && !error\" class=\"ids-password__label\" [for]=\"id\">\n        {{ label }}\n      </label>\n      <ids-form-message [status]=\"error ? 'error' : undefined\" [contrast]=\"contrast\">\n        {{ error ? errorMessage : '' }}\n      </ids-form-message>\n    </div>\n\n    <div class=\"ids-password__container\">\n      <ng-content select=\"[idsInputPassword]\"></ng-content>\n\n      <div *ngFor=\"let item of fieldsArray; let i = index\">\n        <div\n          [attr.aria-hidden]=\"true\"\n          [class.ids-password__fake-input]=\"true\"\n          [class.ids-password__fake-input--error]=\"error\"\n          [class.ids-password__fake-input--value]=\"\n            !showPassword && type !== 'otp' && valueLength > i\n          \"\n          [class.ids-password__fake-input--active]=\"\n            hasFocus && ready && (cursorPosition === i + 1 || (cursorPosition === 0 && i === 0))\n          \"\n        >\n          {{ showPassword || type === 'otp' ? value[i] : '' }}\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <ng-container *ngIf=\"button && !withButton\">\n    <ng-content></ng-content>\n  </ng-container>\n\n  <button\n    *ngIf=\"withButton\"\n    idsActionButton\n    [disabled]=\"disabled\"\n    [contrast]=\"contrast\"\n    [variant]=\"contrast !== 'onBrand' ? 'neutral' : undefined\"\n    (click)=\"showPassword = !showPassword\"\n    type=\"button\"\n  >\n    <ids-icon>\n      {{ showPassword ? 'olho_inativo_outline' : 'visivel_outline' }}\n    </ids-icon>\n    {{ showPassword ? 'ocultar senha' : 'mostrar senha' }}\n  </button>\n</div>\n", dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: IdsActionButtonModule }, { kind: "component", type: IdsActionButtonComponent, selector: "[idsActionButton]", inputs: ["variant", "contrast", "size"] }, { kind: "component", type: IdsIconComponent, selector: "ids-icon", inputs: ["size", "variant", "contrast"] }, { kind: "ngmodule", type: IdsFormMessageModule }, { kind: "component", type: IdsFormMessageComponent, selector: "ids-form-message", inputs: ["id", "contrast", "aria-live", "show", "announceDescription", "status"] }], encapsulation: i0.ViewEncapsulation.None });
__decorate([
    Memo(['canShowVisibleFocus', 'contrast', 'disabled']),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], IdsPasswordComponent.prototype, "classes", null);
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object)
], IdsPasswordComponent.prototype, "error", void 0);
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object)
], IdsPasswordComponent.prototype, "withButton", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsPasswordComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-password', standalone: true, encapsulation: ViewEncapsulation.None, imports: [
                        CommonModule,
                        IdsActionButtonModule,
                        IdsIconComponent,
                        IdsFormMessageModule,
                        IdsInputPasswordDirective,
                        IdsInputDirective,
                    ], template: "<div [class]=\"classes\">\n  <div class=\"ids-password__field\">\n    <div class=\"ids-password__form-message\">\n      <label *ngIf=\"label && !error\" class=\"ids-password__label\" [for]=\"id\">\n        {{ label }}\n      </label>\n      <ids-form-message [status]=\"error ? 'error' : undefined\" [contrast]=\"contrast\">\n        {{ error ? errorMessage : '' }}\n      </ids-form-message>\n    </div>\n\n    <div class=\"ids-password__container\">\n      <ng-content select=\"[idsInputPassword]\"></ng-content>\n\n      <div *ngFor=\"let item of fieldsArray; let i = index\">\n        <div\n          [attr.aria-hidden]=\"true\"\n          [class.ids-password__fake-input]=\"true\"\n          [class.ids-password__fake-input--error]=\"error\"\n          [class.ids-password__fake-input--value]=\"\n            !showPassword && type !== 'otp' && valueLength > i\n          \"\n          [class.ids-password__fake-input--active]=\"\n            hasFocus && ready && (cursorPosition === i + 1 || (cursorPosition === 0 && i === 0))\n          \"\n        >\n          {{ showPassword || type === 'otp' ? value[i] : '' }}\n        </div>\n      </div>\n    </div>\n  </div>\n\n  <ng-container *ngIf=\"button && !withButton\">\n    <ng-content></ng-content>\n  </ng-container>\n\n  <button\n    *ngIf=\"withButton\"\n    idsActionButton\n    [disabled]=\"disabled\"\n    [contrast]=\"contrast\"\n    [variant]=\"contrast !== 'onBrand' ? 'neutral' : undefined\"\n    (click)=\"showPassword = !showPassword\"\n    type=\"button\"\n  >\n    <ids-icon>\n      {{ showPassword ? 'olho_inativo_outline' : 'visivel_outline' }}\n    </ids-icon>\n    {{ showPassword ? 'ocultar senha' : 'mostrar senha' }}\n  </button>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i1$1.LiveAnnouncer }]; }, propDecorators: { classes: [], contrast: [{
                type: Input
            }], error: [{
                type: Input
            }], errorMessage: [{
                type: Input
            }], label: [{
                type: Input
            }], withButton: [{
                type: Input
            }], button: [{
                type: ContentChild,
                args: [IdsActionButtonComponent]
            }], field: [{
                type: ContentChild,
                args: [IdsInputPasswordDirective]
            }], message: [{
                type: ContentChild,
                args: [IdsFormMessageComponent]
            }] } });

class IdsPasswordModule {
}
IdsPasswordModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsPasswordModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsPasswordModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsPasswordModule, imports: [IdsPasswordComponent, IdsInputPasswordDirective], exports: [IdsPasswordComponent, IdsInputPasswordDirective] });
IdsPasswordModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsPasswordModule, imports: [IdsPasswordComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsPasswordModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsPasswordComponent, IdsInputPasswordDirective],
                    exports: [IdsPasswordComponent, IdsInputPasswordDirective],
                }]
        }] });

/**
 * As barras de progresso expressam a evolução de um processo ou valor
 *
 * **Module:**
 *
 * `import { IdsProgressBarModule } from '@ids/angular';`
 *
 * **Component:**
 *
 * `import { IdsProgressBarComponent } from '@ids/angular';`
 */
class IdsProgressBarComponent {
    /**
     * Define a label acessível para a barra de progresso
     */
    set a11yLabel(value) {
        this._a11yLabel = value;
    }
    get a11yLabel() {
        if (!this._a11yLabel) {
            return `O progresso é de ${this.fill}%`;
        }
        return this._a11yLabel;
    }
    /**
     * Define se a barra de progresso é crescente ou decrescente
     */
    set decrescent(value) {
        this._decrescent = enforceBoolean(value);
    }
    get decrescent() {
        return this._decrescent;
    }
    /**
     * Define a porcentagem preenchida da barra da progresso
     */
    set fill(value) {
        const fill = enforceNumber(value);
        this._fill = fill > 100 ? 100 : fill;
    }
    get fill() {
        if (this._min !== 0 || this._max !== 100) {
            return this.calculateFill();
        }
        return this._fill;
    }
    /**
     * Define se a barra de progresso é gradiente
     *
     * @deprecated depreciado desde a versão angular-v1.24.0,
     * use o caso de uso padrão sem gradiente ou os casos de usos secundário ou de feedback
     */
    set gradient(value) {
        this._gradient = enforceBoolean(value);
    }
    get gradient() {
        return this._gradient;
    }
    /**
     * Define o máximo da barra
     */
    set max(value) {
        this._max = enforceNumber(value);
    }
    get max() {
        return this._max;
    }
    /**
     * Define o mínimo da barra
     */
    set min(value) {
        this._min = enforceNumber(value);
    }
    get min() {
        return this._min;
    }
    /**
     * Define o valor da barra (reflete o aria-valuenow).
     * Quando o min e max não são alterados, é necessário passar apenas o fill (porcentagem)
     *
     * Documentação: https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-valuenow
     */
    set value(value) {
        this._value = enforceNumber(value);
    }
    get value() {
        if (this._min === 0 && this._max === 100) {
            return this.fill;
        }
        return this._value;
    }
    get classes() {
        return {
            'ids-progress-bar': true,
            'ids-progress-bar--over-half': this.animationAfterLoaded
                ? false
                : this.decrescent
                    ? this.fill >= 50
                    : this.fill > 50,
            'ids-progress-bar--after-loaded': this.animationAfterLoaded,
            'ids-progress-bar--weight': this.weight === 'heavy',
            'ids-progress-bar--gradient': this.gradient,
            'ids-progress-bar--decrescent': this.decrescent,
            'ids-progress-bar--secondary': this.variant === 'secondary',
            'ids-progress-bar--information': this.variant === 'information',
            'ids-progress-bar--success': this.variant === 'success',
            'ids-progress-bar--alert': this.variant === 'alert',
            'ids-progress-bar--error': this.variant === 'error',
        };
    }
    constructor(_platform) {
        this._platform = _platform;
        this.role = this._platform.ANDROID || this._platform.IOS ? 'progressbar' : 'img';
        this.animationAfterLoaded = false;
        this.lastFill = 0;
        this._a11yLabel = '';
        this._decrescent = false;
        this._fill = 0;
        this._gradient = false;
        this._max = 100;
        this._min = 0;
        this._value = 0;
        this.hostAriaLabel = null;
    }
    ngOnChanges(changes) {
        if (changes.fill && !changes.fill.isFirstChange()) {
            this.lastFill = changes.fill.previousValue;
            this.animationAfterLoaded = true;
        }
    }
    calculateFill() {
        if (this.value <= this.min) {
            return 0;
        }
        if (this.value >= this.max) {
            return 100;
        }
        const proportion = (this.value - this.min) / (this.max - this.min);
        return proportion * 100;
    }
}
IdsProgressBarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsProgressBarComponent, deps: [{ token: i1$4.Platform }], target: i0.ɵɵFactoryTarget.Component });
IdsProgressBarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsProgressBarComponent, isStandalone: true, selector: "ids-progress-bar", inputs: { a11yLabel: ["aria-label", "a11yLabel"], decrescent: "decrescent", fill: "fill", gradient: "gradient", weight: "weight", variant: "variant", max: "max", min: "min", value: "value" }, host: { properties: { "attr.aria-label": "this.hostAriaLabel" } }, usesOnChanges: true, ngImport: i0, template: "<div\n  [class]=\"classes\"\n  [attr.aria-label]=\"a11yLabel\"\n  [attr.aria-valuenow]=\"value\"\n  [attr.aria-valuemin]=\"min\"\n  [attr.aria-valuemax]=\"max\"\n  [attr.role]=\"role\"\n  tabindex=\"-1\"\n  [ngStyle]=\"{\n    '--ids-progress-bar-width': fill + '%',\n    '--ids-progress-bar-last-width': lastFill + '%'\n  }\"\n></div>\n", styles: ["@charset \"UTF-8\";.ids-animation-fade-in-start{opacity:0}.ids-animation-fade-in-moderate-end{opacity:1;transition:opacity .2s cubic-bezier(.42,0,.58,1)}.ids-animation-fade-out-start{opacity:1}.ids-animation-fade-out-moderate-output-end{opacity:0;transition:opacity 275ms cubic-bezier(.42,0,.58,1)}.ids-animation-scale-x-down{transform:scaleX(0);transform:scaleX(var(--ids-scale-x-down, 0))}.ids-animation-scale-x-up{transform:scaleX(1);transform:scaleX(var(--ids-scale-x-up, 100%))}.ids-animation-time-transform-slow{transition:transform 2s cubic-bezier(0,0,.58,1)}.ids-animation-width-down{width:0;width:var(--ids-width-down, 0)}.ids-animation-width-up{width:100%;width:var(--ids-width-up, 100%)}.ids-animation-time-width-slow{transition:width 2s cubic-bezier(0,0,.58,1)}.ids-motion-none,.ids-motion-none:before,.ids-motion-none:after,.ids-motion-none *,.ids-motion-none *:before,.ids-motion-none *:after{animation:none!important;transition:none!important}.ids-progress-bar{background:var(--ids_color_bg_variant_02);border-radius:var(--ids_size_general_8x);height:var(--ids_size_general_8x)}.ids-progress-bar:before{animation:ids-progress-bar-to-half var(--ids_motion_time_slow_02);background:var(--ids_color_bg_brand_primary);border-radius:var(--ids_size_general_8x);content:\"\";display:block;height:100%;overflow:hidden;transition:var(--ids_motion_time_slow_02) var(--ids_motion_easing_effective_standard);width:var(--ids-progress-bar-width)}.ids-progress-bar--gradient:before{background:var(--ids_color_bg_brand_gradient)}.ids-progress-bar--weight{border-radius:var(--ids_size_general_8x);height:var(--ids_size_general_16x)}.ids-progress-bar--weight:before{border-radius:var(--ids_size_general_8x)}.ids-progress-bar--over-half:before{animation:ids-progress-bar-over-half var(--ids_motion_time_slow_02)}.ids-progress-bar--decrescent:before{animation:ids-progress-bar-decrescent-to-half var(--ids_motion_time_slow_02)}.ids-progress-bar--decrescent.ids-progress-bar--over-half:before{animation:ids-progress-bar-decrescent-over-half var(--ids_motion_time_slow_02)}.ids-progress-bar--after-loaded:before{animation:ids-progress-bar-after-loaded var(--ids_motion_time_slow_02)}.ids-progress-bar--secondary:before{background:var(--ids_color_bg_brand_secondary)}.ids-progress-bar--information:before{background:var(--ids_color_feedback_information)}.ids-progress-bar--success:before{background:var(--ids_color_feedback_success)}.ids-progress-bar--alert:before{background:var(--ids_color_feedback_alert)}.ids-progress-bar--error:before{background:var(--ids_color_feedback_error)}@keyframes ids-progress-bar-to-half{0%{width:var(--ids_motion_scale_0)}to{width:var(--ids-progress-bar-width)}}@keyframes ids-progress-bar-over-half{0%{width:50%}to{width:var(--ids-progress-bar-width)}}@keyframes ids-progress-bar-decrescent-to-half{0%{width:50%}to{width:var(--ids-progress-bar-width)}}@keyframes ids-progress-bar-decrescent-over-half{0%{width:calc(var(--ids_motion_scale_100) * 1%)}to{width:var(--ids-progress-bar-width)}}@keyframes ids-progress-bar-after-loaded{0%{width:var(--ids-progress-bar-last-width)}to{width:var(--ids-progress-bar-width)}}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] });
__decorate([
    Memo(['animationAfterLoaded', 'decrescent', 'fill', 'variant', 'gradient', 'weight']),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], IdsProgressBarComponent.prototype, "classes", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsProgressBarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-progress-bar', standalone: true, imports: [CommonModule], template: "<div\n  [class]=\"classes\"\n  [attr.aria-label]=\"a11yLabel\"\n  [attr.aria-valuenow]=\"value\"\n  [attr.aria-valuemin]=\"min\"\n  [attr.aria-valuemax]=\"max\"\n  [attr.role]=\"role\"\n  tabindex=\"-1\"\n  [ngStyle]=\"{\n    '--ids-progress-bar-width': fill + '%',\n    '--ids-progress-bar-last-width': lastFill + '%'\n  }\"\n></div>\n", styles: ["@charset \"UTF-8\";.ids-animation-fade-in-start{opacity:0}.ids-animation-fade-in-moderate-end{opacity:1;transition:opacity .2s cubic-bezier(.42,0,.58,1)}.ids-animation-fade-out-start{opacity:1}.ids-animation-fade-out-moderate-output-end{opacity:0;transition:opacity 275ms cubic-bezier(.42,0,.58,1)}.ids-animation-scale-x-down{transform:scaleX(0);transform:scaleX(var(--ids-scale-x-down, 0))}.ids-animation-scale-x-up{transform:scaleX(1);transform:scaleX(var(--ids-scale-x-up, 100%))}.ids-animation-time-transform-slow{transition:transform 2s cubic-bezier(0,0,.58,1)}.ids-animation-width-down{width:0;width:var(--ids-width-down, 0)}.ids-animation-width-up{width:100%;width:var(--ids-width-up, 100%)}.ids-animation-time-width-slow{transition:width 2s cubic-bezier(0,0,.58,1)}.ids-motion-none,.ids-motion-none:before,.ids-motion-none:after,.ids-motion-none *,.ids-motion-none *:before,.ids-motion-none *:after{animation:none!important;transition:none!important}.ids-progress-bar{background:var(--ids_color_bg_variant_02);border-radius:var(--ids_size_general_8x);height:var(--ids_size_general_8x)}.ids-progress-bar:before{animation:ids-progress-bar-to-half var(--ids_motion_time_slow_02);background:var(--ids_color_bg_brand_primary);border-radius:var(--ids_size_general_8x);content:\"\";display:block;height:100%;overflow:hidden;transition:var(--ids_motion_time_slow_02) var(--ids_motion_easing_effective_standard);width:var(--ids-progress-bar-width)}.ids-progress-bar--gradient:before{background:var(--ids_color_bg_brand_gradient)}.ids-progress-bar--weight{border-radius:var(--ids_size_general_8x);height:var(--ids_size_general_16x)}.ids-progress-bar--weight:before{border-radius:var(--ids_size_general_8x)}.ids-progress-bar--over-half:before{animation:ids-progress-bar-over-half var(--ids_motion_time_slow_02)}.ids-progress-bar--decrescent:before{animation:ids-progress-bar-decrescent-to-half var(--ids_motion_time_slow_02)}.ids-progress-bar--decrescent.ids-progress-bar--over-half:before{animation:ids-progress-bar-decrescent-over-half var(--ids_motion_time_slow_02)}.ids-progress-bar--after-loaded:before{animation:ids-progress-bar-after-loaded var(--ids_motion_time_slow_02)}.ids-progress-bar--secondary:before{background:var(--ids_color_bg_brand_secondary)}.ids-progress-bar--information:before{background:var(--ids_color_feedback_information)}.ids-progress-bar--success:before{background:var(--ids_color_feedback_success)}.ids-progress-bar--alert:before{background:var(--ids_color_feedback_alert)}.ids-progress-bar--error:before{background:var(--ids_color_feedback_error)}@keyframes ids-progress-bar-to-half{0%{width:var(--ids_motion_scale_0)}to{width:var(--ids-progress-bar-width)}}@keyframes ids-progress-bar-over-half{0%{width:50%}to{width:var(--ids-progress-bar-width)}}@keyframes ids-progress-bar-decrescent-to-half{0%{width:50%}to{width:var(--ids-progress-bar-width)}}@keyframes ids-progress-bar-decrescent-over-half{0%{width:calc(var(--ids_motion_scale_100) * 1%)}to{width:var(--ids-progress-bar-width)}}@keyframes ids-progress-bar-after-loaded{0%{width:var(--ids-progress-bar-last-width)}to{width:var(--ids-progress-bar-width)}}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$4.Platform }]; }, propDecorators: { a11yLabel: [{
                type: Input,
                args: ['aria-label']
            }], decrescent: [{
                type: Input
            }], fill: [{
                type: Input
            }], gradient: [{
                type: Input
            }], weight: [{
                type: Input
            }], variant: [{
                type: Input
            }], max: [{
                type: Input
            }], min: [{
                type: Input
            }], value: [{
                type: Input
            }], hostAriaLabel: [{
                type: HostBinding,
                args: ['attr.aria-label']
            }], classes: [] } });

class IdsProgressBarModule {
}
IdsProgressBarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsProgressBarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsProgressBarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsProgressBarModule, imports: [IdsProgressBarComponent], exports: [IdsProgressBarComponent] });
IdsProgressBarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsProgressBarModule, imports: [IdsProgressBarComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsProgressBarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsProgressBarComponent],
                    exports: [IdsProgressBarComponent],
                }]
        }] });

class IdsRadioButtonComponent {
}
IdsRadioButtonComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsRadioButtonComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IdsRadioButtonComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsRadioButtonComponent, isStandalone: true, selector: "ids-radio-button", ngImport: i0, template: `<span class="ids-radio-button">
    <ng-content></ng-content>
    <span class="ids-radio-button__icon ids-icon" aria-hidden="true"></span>
  </span>`, isInline: true, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsRadioButtonComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ids-radio-button',
                    standalone: true,
                    template: `<span class="ids-radio-button">
    <ng-content></ng-content>
    <span class="ids-radio-button__icon ids-icon" aria-hidden="true"></span>
  </span>`,
                    encapsulation: ViewEncapsulation.None,
                }]
        }] });

class IdsRadioButtonModule {
}
IdsRadioButtonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsRadioButtonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsRadioButtonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsRadioButtonModule, imports: [IdsRadioButtonComponent, IdsRadioButtonDirective], exports: [IdsRadioButtonComponent, IdsRadioButtonDirective] });
IdsRadioButtonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsRadioButtonModule, imports: [IdsRadioButtonComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsRadioButtonModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsRadioButtonComponent, IdsRadioButtonDirective],
                    exports: [IdsRadioButtonComponent, IdsRadioButtonDirective],
                }]
        }] });

/**
 * O loading shimmer O Shimmer usado para indicar visualmente que um conteúdo está sendo carregado pela aplicação.
 *
 * *The loading shimmer The shimmer used to visually indicate that content is being loaded by the application.*
 *
 * **Module:**
 *
 * `import { IdsShimmerModule } from '@ids/angular';`
 */
class IdsShimmerComponent {
    /**
     * Mostrar shimmer
     *
     * *Show shimmer*
     */
    get show() {
        return this._show;
    }
    set show(value) {
        this._show = enforceBoolean(value);
        if (this._show) {
            this._announceValue(this.loadingTitle);
        }
        else {
            this._announceValue(this.loadedTitle);
        }
    }
    /**
     * Largura do shimmer
     *
     * *Shimmer width*
     */
    set width(value) {
        this._width = value;
    }
    get width() {
        return this.show ? this._width : null;
    }
    /**
     * Altura do shimmer
     *
     * *Shimmer height*
     */
    set height(value) {
        this._height = value;
    }
    get height() {
        return this.show ? this._height : null;
    }
    get classes() {
        return {
            'ids-shimmer': this.show,
            'ids-shimmer--on-brand': this.show && this.contrast === 'onBrand',
        };
    }
    constructor(la) {
        this.la = la;
        /**
         * Define o valor do atributo aria-live.
         *
         * *Sets the value of the aria-live attribute.*
         */
        this.ariaLive = 'assertive';
        /**
         * Título do shimmer enquanto está carregando
         *
         * *Shimmer title while charging*
         */
        this.loadingTitle = 'carregando';
        /**
         * Título do shimmer quando carregado
         *
         * *Shimmer title when loaded*
         */
        this.loadedTitle = 'carregado';
        this._show = true;
        /**
         * Valor do atributo aria-live
         *
         * *Aria-live attribute value*
         */
        this.ariaLiveHost = null;
    }
    _announceValue(text) {
        this.la.announce(text, this.ariaLive, 10000);
    }
}
IdsShimmerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsShimmerComponent, deps: [{ token: i1$1.LiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component });
IdsShimmerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsShimmerComponent, isStandalone: true, selector: "ids-shimmer", inputs: { ariaLive: ["aria-live", "ariaLive"], loadingTitle: "loadingTitle", loadedTitle: "loadedTitle", show: "show", contrast: "contrast", width: "width", height: "height" }, host: { properties: { "attr.aria-live": "this.ariaLiveHost", "style.width": "this.width", "style.height": "this.height", "class": "this.classes" } }, ngImport: i0, template: '<ng-content></ng-content>', isInline: true, styles: [".ids-shimmer,:host.ids-shimmer{animation:shimmer 1s ease infinite;background-image:var(--ids_color_bg_shimmer_gradient);background-size:200%;border-radius:var(--ids_size_general_8x);color:transparent;display:block;min-height:var(--ids_size_general_24x);overflow:hidden;position:relative}.ids-shimmer--on-brand,:host.ids-shimmer--on-brand{background-image:var(--ids_color_bg_shimmer_gradient_onDark)}.ids-shimmer>*,:host.ids-shimmer>*{opacity:0!important;visibility:hidden!important}.ids-shimmer ::ng-deep>*,:host.ids-shimmer ::ng-deep>*{opacity:0!important;visibility:hidden!important}@keyframes shimmer{0%{background-position-x:200%}to{background-position-x:0%}}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsShimmerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-shimmer', template: '<ng-content></ng-content>', standalone: true, imports: [CommonModule], styles: [".ids-shimmer,:host.ids-shimmer{animation:shimmer 1s ease infinite;background-image:var(--ids_color_bg_shimmer_gradient);background-size:200%;border-radius:var(--ids_size_general_8x);color:transparent;display:block;min-height:var(--ids_size_general_24x);overflow:hidden;position:relative}.ids-shimmer--on-brand,:host.ids-shimmer--on-brand{background-image:var(--ids_color_bg_shimmer_gradient_onDark)}.ids-shimmer>*,:host.ids-shimmer>*{opacity:0!important;visibility:hidden!important}.ids-shimmer ::ng-deep>*,:host.ids-shimmer ::ng-deep>*{opacity:0!important;visibility:hidden!important}@keyframes shimmer{0%{background-position-x:200%}to{background-position-x:0%}}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.LiveAnnouncer }]; }, propDecorators: { ariaLive: [{
                type: Input,
                args: ['aria-live']
            }], loadingTitle: [{
                type: Input
            }], loadedTitle: [{
                type: Input
            }], show: [{
                type: Input
            }], contrast: [{
                type: Input
            }], ariaLiveHost: [{
                type: HostBinding,
                args: ['attr.aria-live']
            }], width: [{
                type: Input,
                args: ['width']
            }, {
                type: HostBinding,
                args: ['style.width']
            }], height: [{
                type: Input,
                args: ['height']
            }, {
                type: HostBinding,
                args: ['style.height']
            }], classes: [{
                type: HostBinding,
                args: ['class']
            }] } });

class IdsShimmerModule {
}
IdsShimmerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsShimmerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsShimmerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsShimmerModule, imports: [CommonModule, IdsShimmerComponent], exports: [IdsShimmerComponent] });
IdsShimmerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsShimmerModule, imports: [CommonModule, IdsShimmerComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsShimmerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, IdsShimmerComponent],
                    exports: [IdsShimmerComponent],
                }]
        }] });

class IdsShortcutCarouselItemDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
IdsShortcutCarouselItemDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsShortcutCarouselItemDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
IdsShortcutCarouselItemDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsShortcutCarouselItemDirective, isStandalone: true, selector: "[idsShortcutCarouselItem]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsShortcutCarouselItemDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsShortcutCarouselItem]',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });
class IdsShortcutCarouselComponent {
    constructor() {
        this._destroy = new Subject();
        // deve iniciar escondido até que os atributos do shortcut sejam aplicados. Necessário
        // para evitar que os botões mudem de tamanho e cor durante a renderização do componente.
        this.isHidden = true;
        this._hasAddNew = false;
        this._disabled = false;
    }
    /** Define a variante. Padrão: primária */
    set variant(value) {
        this._variant = value;
        this._styleShortcuts();
    }
    get variant() {
        return this._variant;
    }
    /** Define o contraste. Opcões: `variant` ou `onBrand` */
    set contrast(value) {
        this._contrast = value;
        this._styleShortcuts();
    }
    get contrast() {
        return this._contrast;
    }
    /** Define o último shortcut da lista com o tipo `addNew` */
    set hasAddNew(value) {
        this._hasAddNew = enforceBoolean(value);
        this._styleShortcuts();
    }
    get hasAddNew() {
        return this._hasAddNew;
    }
    /** Desabilita todos os shortcuts */
    set disabled(value) {
        this._disabled = enforceBoolean(value);
        this._styleShortcuts();
    }
    get disabled() {
        return this._disabled;
    }
    _listenToShortcutChanges() {
        this.shortcuts.changes.pipe(takeUntil$1(this._destroy)).subscribe(() => {
            setTimeout(() => {
                this._styleShortcuts();
                this.isHidden = false;
            });
        });
    }
    _styleShortcuts() {
        if (!this.shortcuts) {
            return;
        }
        this.shortcuts.forEach((shortcut, index) => {
            shortcut.variant = this.variant;
            shortcut.contrast = this.contrast;
            shortcut.disabled = shortcut.disabled || this.disabled;
            shortcut.size = 'S';
            if (index === this.shortcuts.length - 1) {
                shortcut.type = this.hasAddNew ? 'addNew' : undefined;
            }
        });
    }
    ngAfterContentInit() {
        this._listenToShortcutChanges();
    }
    ngOnDestroy() {
        this._destroy.next();
        this._destroy.complete();
    }
}
IdsShortcutCarouselComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsShortcutCarouselComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IdsShortcutCarouselComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsShortcutCarouselComponent, isStandalone: true, selector: "ids-shortcut-carousel", inputs: { variant: "variant", contrast: "contrast", hasAddNew: "hasAddNew", disabled: "disabled" }, queries: [{ propertyName: "shortcuts", predicate: IdsShortcutComponent, descendants: true }, { propertyName: "shortcutRefs", predicate: IdsShortcutCarouselItemDirective, descendants: true }], viewQueries: [{ propertyName: "carousel", first: true, predicate: ["carousel"], descendants: true }], ngImport: i0, template: "<ul #carousel class=\"ids-shortcut-carousel\" [style.display]=\"isHidden ? 'none' : null\" role=\"list\">\n  <ng-container *ngFor=\"let shortcut of shortcutRefs\">\n    <li role=\"listitem\">\n      <ng-container [ngTemplateOutlet]=\"shortcut.templateRef\"></ng-container>\n    </li>\n  </ng-container>\n</ul>\n", styles: [".ids-shortcut-carousel,:host.ids-shortcut-carousel{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;gap:var(--ids_size_general_8x);container-name:idsshortcutcarousel;container-type:inline-size;display:flex;overflow:auto}.js-no-flexbox-gap .ids-shortcut-carousel,.js-no-flexbox-gap :host.ids-shortcut-carousel{margin:calc(var(--ids_size_general_8x) / -2)!important}.js-no-flexbox-gap .ids-shortcut-carousel>*,.js-no-flexbox-gap :host.ids-shortcut-carousel>*{margin:calc(var(--ids_size_general_8x) / 2)!important}.ids-shortcut-carousel::-webkit-scrollbar,:host.ids-shortcut-carousel::-webkit-scrollbar{display:none}.ids-shortcut-carousel .ids-shortcut,:host.ids-shortcut-carousel .ids-shortcut{height:9.375rem;outline-offset:-.1875rem;width:9.375rem}.ids-shortcut-carousel .ids-shortcut--2x1,:host.ids-shortcut-carousel .ids-shortcut--2x1{width:18.75rem}.ids-shortcut-carousel .ids-shortcut--small,:host.ids-shortcut-carousel .ids-shortcut--small{height:var(--ids_size_general_100x);width:var(--ids_size_general_100x)}.ids-shortcut-carousel .ids-shortcut--small.ids-shortcut--2x1,:host.ids-shortcut-carousel .ids-shortcut--small.ids-shortcut--2x1{width:12.5rem}.ids-shortcut-carousel ::ng-deep .ids-shortcut,:host.ids-shortcut-carousel ::ng-deep .ids-shortcut{height:9.375rem;outline-offset:-.1875rem;width:9.375rem}.ids-shortcut-carousel ::ng-deep .ids-shortcut--2x1,:host.ids-shortcut-carousel ::ng-deep .ids-shortcut--2x1{width:18.75rem}.ids-shortcut-carousel ::ng-deep .ids-shortcut--small,:host.ids-shortcut-carousel ::ng-deep .ids-shortcut--small{height:var(--ids_size_general_100x);width:var(--ids_size_general_100x)}.ids-shortcut-carousel ::ng-deep .ids-shortcut--small.ids-shortcut--2x1,:host.ids-shortcut-carousel ::ng-deep .ids-shortcut--small.ids-shortcut--2x1{width:12.5rem}.ids-shortcut-carousel>li,:host.ids-shortcut-carousel>li{all:unset;all:revert;box-sizing:border-box;list-style-type:none}@container idsshortcutcarousel ((inline-size > 13rem) and (inline-size < 13.5rem)) or ((inline-size > 19.75rem) and (inline-size < 20.25rem)) or ((inline-size > 26.5rem) and (inline-size < 27rem)) or ((inline-size > 33.25rem) and (inline-size < 33.75rem)) or ((inline-size > 40rem) and (inline-size < 40.5rem)){.ids-shortcut-carousel>*:first-child,:host.ids-shortcut-carousel>*:first-child{margin-left:var(--ids_spacing_6x)}}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsShortcutCarouselComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-shortcut-carousel', standalone: true, imports: [CommonModule], template: "<ul #carousel class=\"ids-shortcut-carousel\" [style.display]=\"isHidden ? 'none' : null\" role=\"list\">\n  <ng-container *ngFor=\"let shortcut of shortcutRefs\">\n    <li role=\"listitem\">\n      <ng-container [ngTemplateOutlet]=\"shortcut.templateRef\"></ng-container>\n    </li>\n  </ng-container>\n</ul>\n", styles: [".ids-shortcut-carousel,:host.ids-shortcut-carousel{all:unset;all:revert;box-sizing:border-box;margin:0;padding-left:0;gap:var(--ids_size_general_8x);container-name:idsshortcutcarousel;container-type:inline-size;display:flex;overflow:auto}.js-no-flexbox-gap .ids-shortcut-carousel,.js-no-flexbox-gap :host.ids-shortcut-carousel{margin:calc(var(--ids_size_general_8x) / -2)!important}.js-no-flexbox-gap .ids-shortcut-carousel>*,.js-no-flexbox-gap :host.ids-shortcut-carousel>*{margin:calc(var(--ids_size_general_8x) / 2)!important}.ids-shortcut-carousel::-webkit-scrollbar,:host.ids-shortcut-carousel::-webkit-scrollbar{display:none}.ids-shortcut-carousel .ids-shortcut,:host.ids-shortcut-carousel .ids-shortcut{height:9.375rem;outline-offset:-.1875rem;width:9.375rem}.ids-shortcut-carousel .ids-shortcut--2x1,:host.ids-shortcut-carousel .ids-shortcut--2x1{width:18.75rem}.ids-shortcut-carousel .ids-shortcut--small,:host.ids-shortcut-carousel .ids-shortcut--small{height:var(--ids_size_general_100x);width:var(--ids_size_general_100x)}.ids-shortcut-carousel .ids-shortcut--small.ids-shortcut--2x1,:host.ids-shortcut-carousel .ids-shortcut--small.ids-shortcut--2x1{width:12.5rem}.ids-shortcut-carousel ::ng-deep .ids-shortcut,:host.ids-shortcut-carousel ::ng-deep .ids-shortcut{height:9.375rem;outline-offset:-.1875rem;width:9.375rem}.ids-shortcut-carousel ::ng-deep .ids-shortcut--2x1,:host.ids-shortcut-carousel ::ng-deep .ids-shortcut--2x1{width:18.75rem}.ids-shortcut-carousel ::ng-deep .ids-shortcut--small,:host.ids-shortcut-carousel ::ng-deep .ids-shortcut--small{height:var(--ids_size_general_100x);width:var(--ids_size_general_100x)}.ids-shortcut-carousel ::ng-deep .ids-shortcut--small.ids-shortcut--2x1,:host.ids-shortcut-carousel ::ng-deep .ids-shortcut--small.ids-shortcut--2x1{width:12.5rem}.ids-shortcut-carousel>li,:host.ids-shortcut-carousel>li{all:unset;all:revert;box-sizing:border-box;list-style-type:none}@container idsshortcutcarousel ((inline-size > 13rem) and (inline-size < 13.5rem)) or ((inline-size > 19.75rem) and (inline-size < 20.25rem)) or ((inline-size > 26.5rem) and (inline-size < 27rem)) or ((inline-size > 33.25rem) and (inline-size < 33.75rem)) or ((inline-size > 40rem) and (inline-size < 40.5rem)){.ids-shortcut-carousel>*:first-child,:host.ids-shortcut-carousel>*:first-child{margin-left:var(--ids_spacing_6x)}}\n"] }]
        }], propDecorators: { variant: [{
                type: Input
            }], contrast: [{
                type: Input
            }], hasAddNew: [{
                type: Input
            }], disabled: [{
                type: Input
            }], shortcuts: [{
                type: ContentChildren,
                args: [IdsShortcutComponent, { descendants: true }]
            }], shortcutRefs: [{
                type: ContentChildren,
                args: [IdsShortcutCarouselItemDirective, { descendants: true }]
            }], carousel: [{
                type: ViewChild,
                args: ['carousel']
            }] } });

class IdsShortcutCarouselModule {
}
IdsShortcutCarouselModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsShortcutCarouselModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsShortcutCarouselModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsShortcutCarouselModule, imports: [IdsShortcutCarouselComponent, IdsShortcutCarouselItemDirective, IdsShortcutComponent], exports: [IdsShortcutCarouselComponent, IdsShortcutCarouselItemDirective, IdsShortcutComponent] });
IdsShortcutCarouselModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsShortcutCarouselModule, imports: [IdsShortcutCarouselComponent, IdsShortcutComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsShortcutCarouselModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsShortcutCarouselComponent, IdsShortcutCarouselItemDirective, IdsShortcutComponent],
                    exports: [IdsShortcutCarouselComponent, IdsShortcutCarouselItemDirective, IdsShortcutComponent],
                }]
        }] });

/**
 * Valor mínimo e máximo para ser usado com a diretiva Slider.
 *
 * **Module:**
 *
 * `import { IdsSliderRangeModule } from '@ids/angular';`
 *
 * **Component:**
 *
 * `import { IdsSliderRangeComponent } from '@ids/angular';`
 */
class IdsSliderRangeComponent {
    /** @internal */
    get formattedMin() {
        /* istanbul ignore next */
        if (!this.input) {
            return '0';
        }
        if (!this.input.mask) {
            return this.input.min;
        }
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(this.input.min));
    }
    /** @internal */
    get formattedMax() {
        /* istanbul ignore next */
        if (!this.input) {
            return '100';
        }
        if (!this.input.mask) {
            return this.input.max;
        }
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(this.input.max));
    }
    constructor(cdRef) {
        this.cdRef = cdRef;
        this._idsSliderRange = true;
    }
}
IdsSliderRangeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSliderRangeComponent, deps: [{ token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
IdsSliderRangeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsSliderRangeComponent, isStandalone: true, selector: "ids-slider-range", inputs: { input: "input" }, host: { properties: { "class.ids-slider-range": "this._idsSliderRange" } }, ngImport: i0, template: "<ng-container *ngIf=\"input\">\n  <span [attr.id]=\"input.minId\" role=\"text\" [attr.aria-label]=\"input.labelMin + ' ' + formattedMin\">\n    {{ formattedMin }}\n  </span>\n\n  <span [attr.id]=\"input.maxId\" role=\"text\" [attr.aria-label]=\"input.labelMax + ' ' + formattedMax\">\n    {{ formattedMax }}\n  </span>\n</ng-container>\n", styles: [":host(.ids-slider-range),.ids-slider-range{color:var(--ids_color_action_neutral_base);display:flex;flex-direction:row;font:var(--ids_textStyle_f02_s16_h24_wrg);justify-content:space-between;position:relative;-webkit-user-select:none;user-select:none;width:100%}.ids-slider:disabled+:host(.ids-slider-range),.ids-slider:disabled+.ids-slider-range{color:var(--ids_color_action_disabled_base)}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSliderRangeComponent, decorators: [{
            type: Component,
            args: [{ changeDetection: ChangeDetectionStrategy.OnPush, imports: [CommonModule], selector: 'ids-slider-range', standalone: true, template: "<ng-container *ngIf=\"input\">\n  <span [attr.id]=\"input.minId\" role=\"text\" [attr.aria-label]=\"input.labelMin + ' ' + formattedMin\">\n    {{ formattedMin }}\n  </span>\n\n  <span [attr.id]=\"input.maxId\" role=\"text\" [attr.aria-label]=\"input.labelMax + ' ' + formattedMax\">\n    {{ formattedMax }}\n  </span>\n</ng-container>\n", styles: [":host(.ids-slider-range),.ids-slider-range{color:var(--ids_color_action_neutral_base);display:flex;flex-direction:row;font:var(--ids_textStyle_f02_s16_h24_wrg);justify-content:space-between;position:relative;-webkit-user-select:none;user-select:none;width:100%}.ids-slider:disabled+:host(.ids-slider-range),.ids-slider:disabled+.ids-slider-range{color:var(--ids_color_action_disabled_base)}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }]; }, propDecorators: { input: [{
                type: Input
            }], _idsSliderRange: [{
                type: HostBinding,
                args: ['class.ids-slider-range']
            }] } });

let NEXT_ID$3 = 0;
/**
 * Slider é um elemento que permite que a pessoa usuária selecione um número dentro de um alcance pré-definido.
 * Ele pode deslizar o cursor do ponto inicial ao ponto final e encontrar a opção desejada através
 * da indicação imediata do elemento.
 *
 * **Module:**
 *
 * `import { IdsSliderModule } from '@ids/angular';`
 *
 * **Directive:**
 *
 * `import { IdsSliderDirective } from '@ids/angular';`
 */
class IdsSliderDirective {
    get maxId() {
        return `${this.id}-max`;
    }
    get minId() {
        return `${this.id}-min`;
    }
    get percentage() {
        const inputEl = this.elementRef.nativeElement;
        const numberValue = Number(inputEl.value);
        const numberMin = Number(inputEl.min) || 0;
        const numberMax = Number(inputEl.max);
        return ((numberValue - numberMin) * 100) / (numberMax - numberMin);
    }
    get ariaDescribedby() {
        return `${this.minId} ${this.maxId}`;
    }
    get formattedCurrent() {
        if (!this.mask) {
            return this.value;
        }
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(Number(this.value));
    }
    change(target) {
        const number = parseFloat(target.value);
        const step = Number(this.step);
        const roundedNumber = Math.round(number / step) * step;
        this._focused = false;
        this.value = String(roundedNumber);
    }
    get percentageString() {
        return `${this.percentage}%`;
    }
    /**
     * Valor deve ser definido a partir MDC do min e do max; ou será zerado caso o valor informado seja zero
     */
    set value(value) {
        if (value === null) {
            return;
        }
        const stringValue = String(value || 0);
        if (this._value === stringValue) {
            return;
        }
        this._value = stringValue;
        this.valueChange.emit(this._value);
    }
    get value() {
        return this._value;
    }
    onStartChange() {
        this._focused = true;
    }
    set step(step) {
        this._step = step;
    }
    get step() {
        if (this._focused) {
            if (!this._step || this._step === '1') {
                const min = Number(this.min);
                const max = Number(this.max);
                const range = max - min;
                return String(range / 100);
            }
            return this._step || '1';
        }
        return '1';
    }
    constructor(_viewContainerRef, elementRef) {
        this._viewContainerRef = _viewContainerRef;
        this.elementRef = elementRef;
        /**
         * valor máximo da label de acessibilidade
         */
        this.labelMax = ' valor máximo';
        /**
         * valor mínimo da label de acessibilidade
         */
        this.labelMin = ' valor mínimo';
        this.type = 'range';
        this.tabindex = 0;
        this._idsSlider = true;
        this.id = `ids-slider-${NEXT_ID$3++}`;
        /**
         * define o valor máximo que pode ser selecionado
         */
        this.max = '100';
        /**
         * define o valor mínimo que pode ser selecionado
         */
        this.min = '0';
        this._value = '0';
        this.valueChange = new EventEmitter();
        this._step = '1';
    }
    ngOnInit() {
        this._rangeRef = this._viewContainerRef.createComponent(IdsSliderRangeComponent, {
            index: 0,
        });
        this._rangeRef.instance.input = this;
    }
    ngAfterViewInit() {
        this._rangeRef.instance.cdRef.detectChanges();
    }
}
IdsSliderDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSliderDirective, deps: [{ token: i0.ViewContainerRef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
IdsSliderDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsSliderDirective, isStandalone: true, selector: "[idsSlider]", inputs: { labelMax: "labelMax", labelMin: "labelMin", mask: "mask", id: "id", max: "max", min: "min", value: "value", step: "step" }, outputs: { valueChange: "valueChange" }, host: { listeners: { "change": "change($event.target)", "input": "change($event.target)", "keydown": "onStartChange()" }, properties: { "type": "this.type", "tabindex": "this.tabindex", "class.ids-slider": "this._idsSlider", "attr.aria-describedby": "this.ariaDescribedby", "attr.id": "this.id", "attr.aria-valuetext": "this.formattedCurrent", "max": "this.max", "min": "this.min", "style.--slider-percent": "this.percentageString", "value": "this.value", "attr.aria-valuenow": "this.value", "step": "this.step" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSliderDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsSlider]',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: i0.ViewContainerRef }, { type: i0.ElementRef }]; }, propDecorators: { labelMax: [{
                type: Input
            }], labelMin: [{
                type: Input
            }], mask: [{
                type: Input
            }], type: [{
                type: HostBinding
            }], tabindex: [{
                type: HostBinding
            }], _idsSlider: [{
                type: HostBinding,
                args: ['class.ids-slider']
            }], ariaDescribedby: [{
                type: HostBinding,
                args: ['attr.aria-describedby']
            }], id: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.id']
            }], formattedCurrent: [{
                type: HostBinding,
                args: ['attr.aria-valuetext']
            }], max: [{
                type: Input
            }, {
                type: HostBinding
            }], min: [{
                type: Input
            }, {
                type: HostBinding
            }], change: [{
                type: HostListener,
                args: ['change', ['$event.target']]
            }, {
                type: HostListener,
                args: ['input', ['$event.target']]
            }], percentageString: [{
                type: HostBinding,
                args: ['style.--slider-percent']
            }], value: [{
                type: Input
            }, {
                type: HostBinding
            }, {
                type: HostBinding,
                args: ['attr.aria-valuenow']
            }], valueChange: [{
                type: Output
            }], onStartChange: [{
                type: HostListener,
                args: ['keydown']
            }], step: [{
                type: Input
            }, {
                type: HostBinding
            }] } });

class IdsSliderModule {
}
IdsSliderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSliderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsSliderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsSliderModule, imports: [IdsSliderDirective, IdsSliderRangeComponent], exports: [IdsSliderDirective, IdsSliderRangeComponent] });
IdsSliderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSliderModule, imports: [IdsSliderRangeComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSliderModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsSliderDirective, IdsSliderRangeComponent],
                    exports: [IdsSliderDirective, IdsSliderRangeComponent],
                }]
        }] });

let NEXT_ID$2 = 0;
/**
 * **Module:**
 *
 * `import { IdsSliderCurrencyModule } from '@ids/angular';`
 *
 * **Component:**
 *
 * `import { IdsSliderCurrencyComponent } from '@ids/angular';`
 */
class IdsSliderCurrencyComponent {
    constructor() {
        this._destroy = new Subject();
        this.isMobile = platform.isMobile;
        this.isAndroid = platform.os === 'Android';
        this.errorMessage = '';
        this._value = '0';
        /**
         * Valor selecionado
         */
        this.label = '';
        /**
         * define o valor máximo que pode ser selecionado
         *
         * *defines the maximum value to be selected*
         */
        this.max = '100';
        /**
         * valor máximo da label de acessibilidade
         *
         * *maximum value accessibility label*
         */
        this.labelMax = ' valor máximo';
        /**
         * valor mínimo da label de acessibilidade
         *
         * *minimum value accessibility label*
         */
        this.labelMin = ' valor mínimo';
        /**
         * define o valor mínimo que pode ser selecionado
         *
         * *defines the minimum value to be selected*
         */
        this.min = '0';
        this.id = `ids-slider-currency-${NEXT_ID$2++}`;
        this.valueChange = new EventEmitter();
        this.change = new EventEmitter();
        this.blur = new EventEmitter();
        // eslint-disable-next-line
        this._onChange = (_) => { };
        // eslint-disable-next-line
        this._onTouched = () => { };
    }
    /**
     * Valor selecionado
     */
    set value(value) {
        if (Number(value) > Number(this.max)) {
            this.errorMessage = 'valor acima do máximo permitido';
        }
        else if (Number(value) < Number(this.min)) {
            this.errorMessage = 'valor abaixo do mínimo permitido';
        }
        else {
            this.errorMessage = '';
        }
        if (this._value === value) {
            return;
        }
        this._value = value;
        this._onChange(value);
        this.change.emit(String(value));
        this.valueChange.emit(String(value));
    }
    get value() {
        return this._value;
    }
    get maxLength() {
        const length = this.max.length;
        const totalSeparators = Math.floor((length - 1) / 3);
        return length + totalSeparators + 3;
    }
    get ariaDescribedby() {
        if (this.errorMessage) {
            return this.staticFormField.describedById;
        }
        return this.id + '-slider-min ' + this.id + '-slider-max';
    }
    get classes() {
        return {
            'ids-slider-currency': true,
        };
    }
    get maskedValue() {
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
            .format(Number(this.value))
            .trim()
            .replace('R$', '');
    }
    ngAfterContentInit() {
        this.bindSliderAttributes();
        this.bindInputAttributes();
    }
    _hideNativeKeyboard(input) {
        input.setAttribute('readonly', 'readonly');
        setTimeout(() => {
            input.blur();
            input.focus();
            input.removeAttribute('readonly');
        });
    }
    ngOnDestroy() {
        this._destroy.next();
        this._destroy.complete();
    }
    bindInputAttributes() {
        const { input } = this;
        if (!input) {
            return;
        }
        this.formField.errorMessage = this.errorMessage;
        this.formField.noValidate = true;
        this.formField.edit = true;
        this.formField.center = true;
        this.formField.size = 'L';
        input.elementRef.nativeElement.setAttribute('maxlength', this.maxLength);
        input.elementRef.nativeElement.value = this.maskedValue;
        input.controlDescribedBy = this.slider?.ariaDescribedby ?? '';
        input.invalid = !!this.errorMessage;
        if (this.isAndroid) {
            input.elementRef.nativeElement.setAttribute('enterkeyhint', 'done');
        }
        this.valueChange.pipe(takeUntil(this._destroy)).subscribe(() => {
            if (input.elementRef.nativeElement.value === this.maskedValue) {
                return;
            }
            this.formField.errorMessage = this.errorMessage;
            input.invalid = !!this.errorMessage;
            input.elementRef.nativeElement.value = this.maskedValue;
            if (input.invalid) {
                input.controlDescribedBy = this.formField.describedById;
            }
            else {
                input.controlDescribedBy = this.slider?.ariaDescribedby ?? '';
            }
        });
        fromEvent(input.elementRef.nativeElement, 'blur')
            .pipe(takeUntil(this._destroy))
            .subscribe(this.onBlurInput.bind(this));
        fromEvent(input.elementRef.nativeElement, 'keyup')
            .pipe(takeUntil(this._destroy), filter((e) => e.code === 'Enter' ||
            e.code === 'NumpadEnter' ||
            e.key === 'Enter'), tap(() => {
            if (this.isAndroid) {
                this._hideNativeKeyboard(input.nativeElement);
            }
        }))
            .subscribe(this.onBlurInput.bind(this));
    }
    bindSliderAttributes() {
        const { slider } = this;
        if (!slider) {
            return;
        }
        slider.mask = 'currency';
        slider.min = this.min;
        slider.max = this.max;
        slider.labelMin = this.labelMin;
        slider.labelMax = this.labelMax;
        slider.step = this.step;
        slider.value = this.value;
        slider.tabindex = 0;
        if (this.isMobile) {
            slider.elementRef.nativeElement.setAttribute('aria-hidden', 'true');
        }
        if (this.input) {
            const ariaLabel = this.input.elementRef.nativeElement.getAttribute('aria-label');
            slider.elementRef.nativeElement.setAttribute('aria-label', ariaLabel);
        }
        slider.valueChange.pipe(takeUntil(this._destroy)).subscribe((value) => {
            if (this.value === value) {
                return;
            }
            this.value = value;
        });
        this.valueChange.pipe(takeUntil(this._destroy)).subscribe((value) => {
            if (slider.value === value) {
                return;
            }
            slider.value = value;
        });
    }
    onKeyUp(event) {
        const isEnterKey = event.code === 'Enter' || event.code === 'NumpadEnter' || event.key === 'Enter';
        if (!isEnterKey) {
            return;
        }
        if (this.isAndroid) {
            this._hideNativeKeyboard(this.staticInput.nativeElement);
        }
        this.onBlurInput(event);
    }
    onBlurInput(event) {
        const { value } = event.target;
        const unmaskedValue = brlToNumeral(value);
        if (this.value === String(unmaskedValue)) {
            return;
        }
        this.value = String(unmaskedValue);
        this._onTouched();
    }
    /** ControlValueAccessor.writeValue */
    writeValue(value) {
        this.value = value;
    }
    /** ControlValueAccessor.registerOnChange */
    registerOnChange(fn) {
        this._onChange = fn;
    }
    /** ControlValueAccessor.registerOnTouched */
    registerOnTouched(fn) {
        this._onTouched = fn;
    }
}
IdsSliderCurrencyComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSliderCurrencyComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IdsSliderCurrencyComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsSliderCurrencyComponent, isStandalone: true, selector: "ids-slider-currency", inputs: { value: "value", label: "label", max: "max", step: "step", labelMax: "labelMax", labelMin: "labelMin", min: "min", id: "id" }, outputs: { valueChange: "valueChange", change: "change", blur: "blur" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: IdsSliderCurrencyComponent,
        },
    ], queries: [{ propertyName: "slider", first: true, predicate: IdsSliderDirective, descendants: true, static: true }, { propertyName: "formField", first: true, predicate: IdsFormFieldComponent, descendants: true }, { propertyName: "input", first: true, predicate: IdsInputDirective, descendants: true, static: true }], viewQueries: [{ propertyName: "staticFormField", first: true, predicate: IdsFormFieldComponent, descendants: true }, { propertyName: "staticInput", first: true, predicate: IdsInputDirective, descendants: true }], ngImport: i0, template: "<div [class]=\"classes\">\n  <ids-form-field\n    #staticFormField\n    edit\n    center\n    [label]=\"label\"\n    size=\"L\"\n    *ngIf=\"!input\"\n    [errorMessage]=\"errorMessage\"\n    noValidate\n  >\n    <input\n      #staticInput\n      idsInput\n      [ngModel]=\"maskedValue\"\n      idsMask=\"currency\"\n      forceEndCursor\n      (blur)=\"onBlurInput($event)\"\n      (keyup)=\"onKeyUp($event)\"\n      [id]=\"id + '-input'\"\n      [maxlength]=\"maxLength\"\n      [invalid]=\"!!errorMessage\"\n      [attr.enterkeyhint]=\"isAndroid ? 'done' : null\"\n      [aria-describedby]=\"ariaDescribedby\"\n    />\n  </ids-form-field>\n\n  <ng-content select=\"ids-form-field\"></ng-content>\n\n  <input\n    *ngIf=\"!slider\"\n    idsSlider\n    [labelMin]=\"labelMin\"\n    [labelMax]=\"labelMax\"\n    [min]=\"min\"\n    [max]=\"max\"\n    [step]=\"step\"\n    [(value)]=\"value\"\n    mask=\"currency\"\n    [attr.aria-label]=\"label\"\n    [attr.aria-hidden]=\"isMobile\"\n    [id]=\"id + '-slider'\"\n    tabindex=\"0\"\n  />\n\n  <ng-content></ng-content>\n</div>\n", styles: [".ids-slider-currency{padding:0 var(--ids_spacing_4x)}.ids-slider-currency .ids-form-field,.ids-slider-currency ::ng-deep .ids-form-field{margin-bottom:var(--ids_spacing_6x)}.ids-slider-currency .ids-form-field .ids-input,.ids-slider-currency ::ng-deep .ids-form-field .ids-input{min-width:3.75rem}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: FormsModule }, { kind: "directive", type: i1$2.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "ngmodule", type: IdsFormFieldModule }, { kind: "component", type: IdsFormFieldComponent, selector: "ids-form-field", inputs: ["aria-describedby", "contrast", "label", "size", "noMessage", "thresholdAnnounce", "variant", "noBorder", "errorMessage", "description", "edit", "noValidate", "center", "charactersRemainingMessage"] }, { kind: "ngmodule", type: IdsInputModule }, { kind: "directive", type: IdsInputDirective, selector: "[idsInput]:not([idsDatepicker])", inputs: ["readonly", "autoResize", "noStyles", "noLabel", "id", "type", "inputmode", "pattern", "updateFirstOnBlur", "size"], outputs: ["valueChange"] }, { kind: "ngmodule", type: IdsMaskModule }, { kind: "directive", type: IdsMaskDirective, selector: "[idsMask]", inputs: ["announce", "allowLeadingZeros", "config", "disabled", "forceEndCursor", "guide", "idsMask", "keepCharPositions", "readonly", "shouldKeepMask", "value"] }, { kind: "ngmodule", type: IdsSliderModule }, { kind: "directive", type: IdsSliderDirective, selector: "[idsSlider]", inputs: ["labelMax", "labelMin", "mask", "id", "max", "min", "value", "step"], outputs: ["valueChange"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSliderCurrencyComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-slider-currency', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            multi: true,
                            useExisting: IdsSliderCurrencyComponent,
                        },
                    ], standalone: true, imports: [
                        CommonModule,
                        FormsModule,
                        IdsFormFieldModule,
                        IdsInputModule,
                        IdsMaskModule,
                        IdsSliderModule,
                    ], template: "<div [class]=\"classes\">\n  <ids-form-field\n    #staticFormField\n    edit\n    center\n    [label]=\"label\"\n    size=\"L\"\n    *ngIf=\"!input\"\n    [errorMessage]=\"errorMessage\"\n    noValidate\n  >\n    <input\n      #staticInput\n      idsInput\n      [ngModel]=\"maskedValue\"\n      idsMask=\"currency\"\n      forceEndCursor\n      (blur)=\"onBlurInput($event)\"\n      (keyup)=\"onKeyUp($event)\"\n      [id]=\"id + '-input'\"\n      [maxlength]=\"maxLength\"\n      [invalid]=\"!!errorMessage\"\n      [attr.enterkeyhint]=\"isAndroid ? 'done' : null\"\n      [aria-describedby]=\"ariaDescribedby\"\n    />\n  </ids-form-field>\n\n  <ng-content select=\"ids-form-field\"></ng-content>\n\n  <input\n    *ngIf=\"!slider\"\n    idsSlider\n    [labelMin]=\"labelMin\"\n    [labelMax]=\"labelMax\"\n    [min]=\"min\"\n    [max]=\"max\"\n    [step]=\"step\"\n    [(value)]=\"value\"\n    mask=\"currency\"\n    [attr.aria-label]=\"label\"\n    [attr.aria-hidden]=\"isMobile\"\n    [id]=\"id + '-slider'\"\n    tabindex=\"0\"\n  />\n\n  <ng-content></ng-content>\n</div>\n", styles: [".ids-slider-currency{padding:0 var(--ids_spacing_4x)}.ids-slider-currency .ids-form-field,.ids-slider-currency ::ng-deep .ids-form-field{margin-bottom:var(--ids_spacing_6x)}.ids-slider-currency .ids-form-field .ids-input,.ids-slider-currency ::ng-deep .ids-form-field .ids-input{min-width:3.75rem}\n"] }]
        }], propDecorators: { value: [{
                type: Input
            }], label: [{
                type: Input
            }], max: [{
                type: Input
            }], step: [{
                type: Input
            }], labelMax: [{
                type: Input
            }], labelMin: [{
                type: Input
            }], min: [{
                type: Input
            }], id: [{
                type: Input
            }], valueChange: [{
                type: Output
            }], change: [{
                type: Output
            }], blur: [{
                type: Output
            }], slider: [{
                type: ContentChild,
                args: [IdsSliderDirective, { static: true }]
            }], formField: [{
                type: ContentChild,
                args: [IdsFormFieldComponent]
            }], staticFormField: [{
                type: ViewChild,
                args: [IdsFormFieldComponent]
            }], input: [{
                type: ContentChild,
                args: [IdsInputDirective, { static: true }]
            }], staticInput: [{
                type: ViewChild,
                args: [IdsInputDirective]
            }] } });

class IdsSliderCurrencyModule {
}
IdsSliderCurrencyModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSliderCurrencyModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsSliderCurrencyModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsSliderCurrencyModule, imports: [IdsSliderCurrencyComponent], exports: [IdsSliderCurrencyComponent] });
IdsSliderCurrencyModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSliderCurrencyModule, imports: [IdsSliderCurrencyComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSliderCurrencyModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsSliderCurrencyComponent],
                    exports: [IdsSliderCurrencyComponent],
                }]
        }] });

let currentSnackbarOpen;
/**
 * **Module:**
 *
 * `import { IdsSnackbarModule } from '@ids/angular';`
 */
class IdsSnackbarComponent {
    constructor() {
        /**
         * Define o papel do componente para tecnologias assistivas.
         */
        this.role = 'status';
        /**
         * Define a polí­tica de atualização para tecnologias assistivas.
         */
        this.ariaLive = 'polite';
        /**
         * Define a distância do snackbar em relação aos limites da tela.
         */
        this.bottom = 24;
        /**
         * Define a duração em segundos que o snackbar ficará visível.
         */
        this.duration = 4;
        this._show = false;
        this.hideTimeout = null;
        /**
         * Emite um evento quando a visibilidade do snackbar muda.
         */
        this.showChange = new EventEmitter();
    }
    get animation() {
        return {
            '--ids-snackbar-duration': `${this.duration}s`,
            '--ids-snackbar-bottom': pxToRem(this.bottom),
        };
    }
    get classes() {
        return {
            'ids-snackbar': true,
            [`-${this.variant}`]: !!this.variant,
            '-on-brand': this.contrast === 'onBrand',
        };
    }
    /**
     * Define se o snackbar está visível.
     */
    set show(value) {
        if (currentSnackbarOpen !== this) {
            currentSnackbarOpen?.hideSnackbar();
        }
        this._show = value;
        if (this._show) {
            this.showSnackbar();
            return;
        }
        this.hideSnackbar();
    }
    get show() {
        return this._show;
    }
    showSnackbar() {
        this.clearHideTimeout();
        this.hideTimeout = setTimeout(() => {
            this._show = false;
            this.showChange.emit(!!this._show);
            this.hideSnackbar();
        }, this.duration * 1000);
        this.component?.nativeElement?.showPopover();
        this.showChange.emit(!!this._show);
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        currentSnackbarOpen = this;
    }
    hideSnackbar() {
        this.component?.nativeElement?.hidePopover();
        currentSnackbarOpen = undefined;
    }
    clearHideTimeout() {
        if (this.hideTimeout) {
            clearTimeout(this.hideTimeout);
            this.hideTimeout = null;
        }
    }
    ngOnDestroy() {
        this.clearHideTimeout();
    }
}
IdsSnackbarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSnackbarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IdsSnackbarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsSnackbarComponent, isStandalone: true, selector: "ids-snackbar", inputs: { role: "role", ariaLive: "ariaLive", bottom: "bottom", contrast: "contrast", duration: "duration", show: "show", variant: "variant" }, outputs: { showChange: "showChange" }, host: { properties: { "attr.role": "this.role", "attr.aria-live": "this.ariaLive" } }, viewQueries: [{ propertyName: "component", first: true, predicate: ["component"], descendants: true }], ngImport: i0, template: "<div [class]=\"classes\" [ngStyle]=\"animation\" popover=\"manual\" #component>\n  <ng-content></ng-content>\n</div>\n", styles: ["@keyframes ids-snackbar-fade-in{0%{bottom:0;opacity:var(--ids_motion_opacity_0)}to{bottom:var(--ids-snackbar-bottom);opacity:var(--ids_motion_opacity_100)}}@keyframes ids-snackbar-fade-out{0%{bottom:var(--ids-snackbar-bottom);opacity:var(--ids_motion_opacity_100)}to{bottom:0;opacity:var(--ids_motion_opacity_0)}}.ids-snackbar{--ids-snackbar-bottom: rem(24);--ids-snackbar-duration: 4s;align-items:center;background:var(--ids_color_feedback_neutral);border-radius:var(--ids_size_cornerRadius_snackbar);color:var(--ids_color_feedback_neutral_contrast);font:var(--ids_textStyle_f02_s14_h20_wrg);gap:var(--ids_size_general_12x);max-width:45rem;min-width:17rem;padding:var(--ids_size_general_16x)}.ids-snackbar:popover-open{animation:ids-snackbar-fade-in var(--ids_motion_time_slow_01) var(--ids_motion_easing_effective_decelerate_standard),ids-snackbar-fade-out var(--ids_motion_time_fast_03) var(--ids_motion_easing_effective_accelerate_standard) calc(var(--ids-snackbar-duration) - .18s);display:flex;inset:auto var(--ids_size_general_24x) var(--ids-snackbar-bottom) var(--ids_size_general_24x);margin:0 auto;position:fixed}.ids-snackbar.\\:popover-open{animation:ids-snackbar-fade-in var(--ids_motion_time_slow_01) var(--ids_motion_easing_effective_decelerate_standard),ids-snackbar-fade-out var(--ids_motion_time_fast_03) var(--ids_motion_easing_effective_accelerate_standard) calc(var(--ids-snackbar-duration) - .18s);display:flex;inset:auto var(--ids_size_general_24x) var(--ids-snackbar-bottom) var(--ids_size_general_24x);margin:0 auto;position:fixed}.ids-snackbar.-warning{background:var(--ids_color_feedback_alert);color:var(--ids_color_feedback_alert_contrast)}.ids-snackbar.-success{background:var(--ids_color_feedback_success);color:var(--ids_color_feedback_success_contrast)}.ids-snackbar.-error{background:var(--ids_color_feedback_error);color:var(--ids_color_feedback_error_contrast)}.ids-snackbar.-information{background:var(--ids_color_feedback_information);color:var(--ids_color_feedback_information_contrast)}.ids-snackbar.-on-brand{background:var(--ids_color_bg_base);color:var(--ids_color_feedback_neutral)}@media screen and (min-width: 64rem){.ids-snackbar{max-width:100rem}}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] });
__decorate([
    Memo(['duration', 'bottom']),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], IdsSnackbarComponent.prototype, "animation", null);
__decorate([
    Memo(['variant', 'contrast']),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], IdsSnackbarComponent.prototype, "classes", null);
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], IdsSnackbarComponent.prototype, "show", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSnackbarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-snackbar', standalone: true, imports: [CommonModule], template: "<div [class]=\"classes\" [ngStyle]=\"animation\" popover=\"manual\" #component>\n  <ng-content></ng-content>\n</div>\n", styles: ["@keyframes ids-snackbar-fade-in{0%{bottom:0;opacity:var(--ids_motion_opacity_0)}to{bottom:var(--ids-snackbar-bottom);opacity:var(--ids_motion_opacity_100)}}@keyframes ids-snackbar-fade-out{0%{bottom:var(--ids-snackbar-bottom);opacity:var(--ids_motion_opacity_100)}to{bottom:0;opacity:var(--ids_motion_opacity_0)}}.ids-snackbar{--ids-snackbar-bottom: rem(24);--ids-snackbar-duration: 4s;align-items:center;background:var(--ids_color_feedback_neutral);border-radius:var(--ids_size_cornerRadius_snackbar);color:var(--ids_color_feedback_neutral_contrast);font:var(--ids_textStyle_f02_s14_h20_wrg);gap:var(--ids_size_general_12x);max-width:45rem;min-width:17rem;padding:var(--ids_size_general_16x)}.ids-snackbar:popover-open{animation:ids-snackbar-fade-in var(--ids_motion_time_slow_01) var(--ids_motion_easing_effective_decelerate_standard),ids-snackbar-fade-out var(--ids_motion_time_fast_03) var(--ids_motion_easing_effective_accelerate_standard) calc(var(--ids-snackbar-duration) - .18s);display:flex;inset:auto var(--ids_size_general_24x) var(--ids-snackbar-bottom) var(--ids_size_general_24x);margin:0 auto;position:fixed}.ids-snackbar.\\:popover-open{animation:ids-snackbar-fade-in var(--ids_motion_time_slow_01) var(--ids_motion_easing_effective_decelerate_standard),ids-snackbar-fade-out var(--ids_motion_time_fast_03) var(--ids_motion_easing_effective_accelerate_standard) calc(var(--ids-snackbar-duration) - .18s);display:flex;inset:auto var(--ids_size_general_24x) var(--ids-snackbar-bottom) var(--ids_size_general_24x);margin:0 auto;position:fixed}.ids-snackbar.-warning{background:var(--ids_color_feedback_alert);color:var(--ids_color_feedback_alert_contrast)}.ids-snackbar.-success{background:var(--ids_color_feedback_success);color:var(--ids_color_feedback_success_contrast)}.ids-snackbar.-error{background:var(--ids_color_feedback_error);color:var(--ids_color_feedback_error_contrast)}.ids-snackbar.-information{background:var(--ids_color_feedback_information);color:var(--ids_color_feedback_information_contrast)}.ids-snackbar.-on-brand{background:var(--ids_color_bg_base);color:var(--ids_color_feedback_neutral)}@media screen and (min-width: 64rem){.ids-snackbar{max-width:100rem}}\n"] }]
        }], propDecorators: { animation: [], classes: [], role: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.role']
            }], ariaLive: [{
                type: Input
            }, {
                type: HostBinding,
                args: ['attr.aria-live']
            }], bottom: [{
                type: Input
            }], contrast: [{
                type: Input
            }], duration: [{
                type: Input
            }], show: [{
                type: Input
            }], variant: [{
                type: Input
            }], showChange: [{
                type: Output
            }], component: [{
                type: ViewChild,
                args: ['component']
            }] } });

class IdsSnackbarModule {
}
IdsSnackbarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSnackbarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsSnackbarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsSnackbarModule, imports: [IdsSnackbarComponent], exports: [IdsSnackbarComponent] });
IdsSnackbarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSnackbarModule, imports: [IdsSnackbarComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSnackbarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsSnackbarComponent],
                    exports: [IdsSnackbarComponent],
                }]
        }] });

class IdsSwitchComponent {
}
IdsSwitchComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSwitchComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IdsSwitchComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsSwitchComponent, isStandalone: true, selector: "ids-switch", ngImport: i0, template: `<span class="ids-switch">
    <ng-content></ng-content>
    <span class="ids-switch__icon" aria-hidden="true"></span>
  </span>`, isInline: true, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSwitchComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ids-switch',
                    standalone: true,
                    template: `<span class="ids-switch">
    <ng-content></ng-content>
    <span class="ids-switch__icon" aria-hidden="true"></span>
  </span>`,
                    encapsulation: ViewEncapsulation.None,
                }]
        }] });

class IdsSwitchModule {
}
IdsSwitchModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSwitchModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsSwitchModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsSwitchModule, imports: [IdsSwitchComponent, IdsSwitchDirective], exports: [IdsSwitchComponent, IdsSwitchDirective] });
IdsSwitchModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSwitchModule, imports: [IdsSwitchComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSwitchModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsSwitchComponent, IdsSwitchDirective],
                    exports: [IdsSwitchComponent, IdsSwitchDirective],
                }]
        }] });

/**
 * Define as células da tabela.
 * Captura o modelo da célula da tabela, além das propriedades específicas da célula.
 */
class IdsCellDefDirective extends CdkCellDef {
}
IdsCellDefDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsCellDefDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
IdsCellDefDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsCellDefDirective, selector: "[idsCellDef]", providers: [{ provide: CdkCellDef, useExisting: IdsCellDefDirective }], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsCellDefDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsCellDef]',
                    providers: [{ provide: CdkCellDef, useExisting: IdsCellDefDirective }],
                }]
        }] });
/**
 * Define as células do cabeçalho da tabela.
 * Captura o modelo da célula do cabeçalho da tabela, além das propriedades específicas da célula.
 */
class IdsHeaderCellDefDirective extends CdkHeaderCellDef {
}
IdsHeaderCellDefDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsHeaderCellDefDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
IdsHeaderCellDefDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsHeaderCellDefDirective, selector: "[idsHeaderCellDef]", providers: [{ provide: CdkHeaderCellDef, useExisting: IdsHeaderCellDefDirective }], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsHeaderCellDefDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsHeaderCellDef]',
                    providers: [{ provide: CdkHeaderCellDef, useExisting: IdsHeaderCellDefDirective }],
                }]
        }] });
/**
 * Define as células do rodapé da tabela.
 * Captura o modelo da célula do rodapé da tabela, além das propriedades específicas da célula.
 */
class IdsFooterCellDefDirective extends CdkFooterCellDef {
}
IdsFooterCellDefDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFooterCellDefDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
IdsFooterCellDefDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsFooterCellDefDirective, selector: "[idsFooterCellDef]", providers: [{ provide: CdkFooterCellDef, useExisting: IdsFooterCellDefDirective }], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFooterCellDefDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsFooterCellDef]',
                    providers: [{ provide: CdkFooterCellDef, useExisting: IdsFooterCellDefDirective }],
                }]
        }] });
/**
 * Define as colunas da tabela.
 * Define um conjunto de células disponíveis para uma coluna da tabela.
 */
class IdsColumnDefDirective extends CdkColumnDef {
    constructor() {
        super(...arguments);
        /** Define se a coluna deve truncar o conteúdo */
        this.truncate = false;
    }
    /** Nome único para a coluna */
    get name() {
        return this._name;
    }
    set name(name) {
        this._setNameInput(name);
    }
    _updateColumnCssClassName() {
        super._updateColumnCssClassName();
        if (this._columnCssClassName) {
            this._columnCssClassName.push(`ids-column-${this.cssClassFriendlyName}`);
        }
    }
}
IdsColumnDefDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsColumnDefDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
IdsColumnDefDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsColumnDefDirective, selector: "[idsColumnDef]", inputs: { sticky: "sticky", name: ["idsColumnDef", "name"], truncate: "truncate", maxWidth: "maxWidth" }, providers: [
        { provide: CdkColumnDef, useExisting: IdsColumnDefDirective },
        { provide: 'IDS_SORT_HEADER_COLUMN_DEF', useExisting: IdsColumnDefDirective },
    ], usesInheritance: true, ngImport: i0 });
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object)
], IdsColumnDefDirective.prototype, "truncate", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsColumnDefDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsColumnDef]',
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['sticky'],
                    providers: [
                        { provide: CdkColumnDef, useExisting: IdsColumnDefDirective },
                        { provide: 'IDS_SORT_HEADER_COLUMN_DEF', useExisting: IdsColumnDefDirective },
                    ],
                }]
        }], propDecorators: { name: [{
                type: Input,
                args: ['idsColumnDef']
            }], truncate: [{
                type: Input
            }], maxWidth: [{
                type: Input
            }] } });
/** Container para o conteúdo das células de cabeçalho. Adiciona classes e role correta. */
class IdsHeaderCellDirective extends CdkHeaderCell {
    constructor(_columnDef, _elementRef) {
        super(_columnDef, _elementRef);
        this.columnDef = _columnDef;
        this.elementRef = _elementRef;
    }
}
IdsHeaderCellDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsHeaderCellDirective, deps: [{ token: IdsColumnDefDirective }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
IdsHeaderCellDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsHeaderCellDirective, selector: "ids-header-cell, th[idsHeaderCell]", host: { attributes: { "role": "columnheader" }, properties: { "style.maxWidth": "columnDef?.maxWidth" }, classAttribute: "ids-table__header-cell" }, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsHeaderCellDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ids-header-cell, th[idsHeaderCell]',
                    host: {
                        class: 'ids-table__header-cell',
                        '[style.maxWidth]': 'columnDef?.maxWidth',
                        role: 'columnheader',
                    },
                }]
        }], ctorParameters: function () { return [{ type: IdsColumnDefDirective }, { type: i0.ElementRef }]; } });
/** Container para o conteúdo das células de rodapé. Também adiciona classes. */
class IdsFooterCellDirective extends CdkFooterCell {
    constructor(_columnDef, _elementRef) {
        super(_columnDef, _elementRef);
        this.columnDef = _columnDef;
        this.elementRef = _elementRef;
    }
}
IdsFooterCellDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFooterCellDirective, deps: [{ token: IdsColumnDefDirective }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
IdsFooterCellDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsFooterCellDirective, selector: "ids-footer-cell, td[idsFooterCell]", host: { properties: { "style.maxWidth": "columnDef?.maxWidth" }, classAttribute: "ids-table__footer-cell" }, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFooterCellDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ids-footer-cell, td[idsFooterCell]',
                    host: {
                        class: 'ids-table__footer-cell',
                        '[style.maxWidth]': 'columnDef?.maxWidth',
                    },
                }]
        }], ctorParameters: function () { return [{ type: IdsColumnDefDirective }, { type: i0.ElementRef }]; } });
/** Container para o conteúdo das células da tabela. Também adiciona classes. */
class IdsCellDirective extends CdkCell {
    constructor(_columnDef, _elementRef) {
        super(_columnDef, _elementRef);
        this.columnDef = _columnDef;
        this.elementRef = _elementRef;
    }
}
IdsCellDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsCellDirective, deps: [{ token: IdsColumnDefDirective }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
IdsCellDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsCellDirective, selector: "ids-cell, td[idsCell]", host: { properties: { "class.ids-table__cell--truncate": "columnDef?.truncate || false", "attr.title": "columnDef?.truncate ? elementRef?.nativeElement?.textContent : null", "style.maxWidth": "columnDef?.maxWidth" }, classAttribute: "ids-table__cell" }, usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsCellDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ids-cell, td[idsCell]',
                    host: {
                        class: 'ids-table__cell',
                        '[class.ids-table__cell--truncate]': 'columnDef?.truncate || false',
                        '[attr.title]': 'columnDef?.truncate ? elementRef?.nativeElement?.textContent : null',
                        '[style.maxWidth]': 'columnDef?.maxWidth',
                    },
                }]
        }], ctorParameters: function () { return [{ type: IdsColumnDefDirective }, { type: i0.ElementRef }]; } });

class IdsSortComponent {
    /**
     * Nome da coluna. Deve ser único para cada coluna, pois é usado como identificador.
     * Necessário informar apenas quando não estiver sendo utilizado em conjunto com a
     * diretiva `idsColumnDef`.
     */
    set name(value) {
        this._name = value;
    }
    get name() {
        // Caso o nome não tenha sido informado, retorna o valor da definicão da coluna
        return this._name || this.columnDef.name;
    }
    constructor(_la, columnDef) {
        this._la = _la;
        this.columnDef = columnDef;
        /** @internal */
        this.sort = new EventEmitter();
    }
    ngAfterViewInit() {
        if (this.contentRef.nativeElement) {
            this._headerText = this.contentRef.nativeElement.textContent.trim();
        }
        if (this.direction) {
            // Timeout para permitir que o evento seja enviado após o início da escuta
            // do contentChildren no componente de tabela.
            setTimeout(() => {
                this._emitSortEvent();
            });
        }
    }
    _announceSorting() {
        const sortDirection = this.direction
            ? this.direction === 'asc'
                ? 'crescente'
                : 'decrescente'
            : null;
        if (!sortDirection) {
            this._la.announce('ordenação removida', 'assertive', 1000);
            return;
        }
        this._la.announce(`ordenado por ${this._headerText}, ${sortDirection}`, 'assertive', 1000);
    }
    _emitSortEvent() {
        this.sort.emit({
            direction: this.direction,
            name: this.name,
        });
    }
    handleClick() {
        this.direction = this.direction ? (this.direction === 'asc' ? 'desc' : undefined) : 'asc';
        this._emitSortEvent();
        this._announceSorting();
    }
    handleKeydown(event) {
        if (event.code === 'Enter' || event.code === 'NumpadEnter' || event.code === 'Space') {
            event.preventDefault();
            this.handleClick();
        }
    }
}
IdsSortComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSortComponent, deps: [{ token: i1$1.LiveAnnouncer }, { token: 'IDS_SORT_HEADER_COLUMN_DEF', optional: true }], target: i0.ɵɵFactoryTarget.Component });
IdsSortComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsSortComponent, selector: "[idsSort]", inputs: { name: "name", direction: "direction" }, outputs: { sort: "sort" }, host: { listeners: { "click": "handleClick()", "keydown": "handleKeydown($event)" }, properties: { "attr.aria-sort": "direction ? direction === 'asc' ? 'ascending' : 'descending' : 'none'" }, classAttribute: "ids-sort" }, viewQueries: [{ propertyName: "contentRef", first: true, predicate: ["content"], descendants: true }], exportAs: ["idsSort"], ngImport: i0, template: "<!--\n  O `tabindex` foi definido em um elemento dentro do cabe\u00E7alho da tabela, em vez do pr\u00F3prio cabe\u00E7alho,\n  por causa de um bug no NVDA onde ter um `tabindex` em um `th` quebra a navega\u00E7\u00E3o do teclado na\n  tabela (ver https://github.com/nvaccess/nvda/issues/7718). Isso permite que o cabe\u00E7alho seja\n  focaliz\u00E1vel e faz com que os leitores de tela leiam seu estado `aria-sort`. Est\u00E1 abordagem \u00E9\n  melhor no momento, do que ter um bot\u00E3o com um `aria-label` dentro do cabe\u00E7alho, porque o\n  `aria-label` do bot\u00E3o vai ser lido enquanto o usu\u00E1rio navega nas c\u00E9lulas da tabela (ver #13012).\n\n  Solu\u00E7\u00E3o baseada em: https://www.w3.org/WAI/ARIA/apg/patterns/table/examples/sortable-table/\n-->\n\n<div class=\"ids-sort__content\" tabindex=\"0\" role=\"button\">\n  <span #content>\n    <ng-content></ng-content>\n  </span>\n\n  <ids-icon aria-hidden=\"true\" size=\"S\" class=\"ids-sort__icon\">{{\n    direction ? (direction === 'asc' ? 'sort_up' : 'sort_down') : 'ordenar'\n  }}</ids-icon>\n</div>\n", styles: [".ids-sort__content,:host.ids-sort__content{align-items:center;background-color:transparent;border:0;cursor:pointer;display:flex;gap:var(--ids_spacing_2x);height:100%;justify-content:center;outline-offset:-.125rem;padding:0 var(--ids_spacing_4x);width:100%}.ids-sort__icon,:host.ids-sort__icon{min-width:var(--ids_size_general_14x)}\n"], dependencies: [{ kind: "component", type: IdsIconComponent, selector: "ids-icon", inputs: ["size", "variant", "contrast"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSortComponent, decorators: [{
            type: Component,
            args: [{ selector: '[idsSort]', exportAs: 'idsSort', host: {
                        class: 'ids-sort',
                        '(click)': 'handleClick()',
                        '(keydown)': 'handleKeydown($event)',
                        '[attr.aria-sort]': "direction ? direction === 'asc' ? 'ascending' : 'descending' : 'none'",
                    }, template: "<!--\n  O `tabindex` foi definido em um elemento dentro do cabe\u00E7alho da tabela, em vez do pr\u00F3prio cabe\u00E7alho,\n  por causa de um bug no NVDA onde ter um `tabindex` em um `th` quebra a navega\u00E7\u00E3o do teclado na\n  tabela (ver https://github.com/nvaccess/nvda/issues/7718). Isso permite que o cabe\u00E7alho seja\n  focaliz\u00E1vel e faz com que os leitores de tela leiam seu estado `aria-sort`. Est\u00E1 abordagem \u00E9\n  melhor no momento, do que ter um bot\u00E3o com um `aria-label` dentro do cabe\u00E7alho, porque o\n  `aria-label` do bot\u00E3o vai ser lido enquanto o usu\u00E1rio navega nas c\u00E9lulas da tabela (ver #13012).\n\n  Solu\u00E7\u00E3o baseada em: https://www.w3.org/WAI/ARIA/apg/patterns/table/examples/sortable-table/\n-->\n\n<div class=\"ids-sort__content\" tabindex=\"0\" role=\"button\">\n  <span #content>\n    <ng-content></ng-content>\n  </span>\n\n  <ids-icon aria-hidden=\"true\" size=\"S\" class=\"ids-sort__icon\">{{\n    direction ? (direction === 'asc' ? 'sort_up' : 'sort_down') : 'ordenar'\n  }}</ids-icon>\n</div>\n", styles: [".ids-sort__content,:host.ids-sort__content{align-items:center;background-color:transparent;border:0;cursor:pointer;display:flex;gap:var(--ids_spacing_2x);height:100%;justify-content:center;outline-offset:-.125rem;padding:0 var(--ids_spacing_4x);width:100%}.ids-sort__icon,:host.ids-sort__icon{min-width:var(--ids_size_general_14x)}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.LiveAnnouncer }, { type: IdsColumnDefDirective, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: ['IDS_SORT_HEADER_COLUMN_DEF']
                }] }]; }, propDecorators: { name: [{
                type: Input
            }], direction: [{
                type: Input
            }], sort: [{
                type: Output
            }], contentRef: [{
                type: ViewChild,
                args: ['content']
            }] } });

/**
 * Ativa a estratégia recycle view repeater, o que reduz a latência de
 * renderização. Não compatível com tabelas que animam linhas.
 */
class IdsRecycleRowsDirective {
}
IdsRecycleRowsDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsRecycleRowsDirective, deps: [], target: i0.ɵɵFactoryTarget.Directive });
IdsRecycleRowsDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsRecycleRowsDirective, selector: "table[idsTable][recycleRows]", providers: [{ provide: _VIEW_REPEATER_STRATEGY, useClass: _RecycleViewRepeaterStrategy }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsRecycleRowsDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'table[idsTable][recycleRows]',
                    providers: [{ provide: _VIEW_REPEATER_STRATEGY, useClass: _RecycleViewRepeaterStrategy }],
                }]
        }] });
/**
 * Componente de tabela do iDS.
 *
 * **Module:**
 *
 * `import { IdsTableModule, IdsPaginationModule } from '@ids/angular';`
 */
class IdsTableComponent extends CdkTable {
    constructor() {
        super(...arguments);
        this._destroy = new Subject();
        /** Sobrescreve a classe CSS sticky definida pelo `CdkTable`. */
        this.stickyCssClass = 'ids-table-sticky';
        /** Sobrescreve a necessidade de adicionar position: sticky em todos elementos de célula no `CdkTable`. */
        this.needsPositionStickyOnElement = false;
        /** Define se está carregando */
        this.loading = false;
        /** Define a quantidade de linhas que aparece quando está carregando */
        this.loadingRows = 10;
        /** Evento disparado ao ordenar as colunas */
        this.sort = new EventEmitter();
    }
    get columns() {
        return this.columnsWithSorting.toArray();
    }
    _addSortingCaption() {
        const text = 'cabeçalhos com botões possuem ordenação';
        const existingCaptionEl = this._elementRef.nativeElement?.querySelector('caption');
        if (existingCaptionEl) {
            const sortingTipEl = document.createElement('span');
            sortingTipEl.classList.add('ids-sr-only');
            sortingTipEl.innerText = `, ${text}`;
            existingCaptionEl.appendChild(sortingTipEl);
            return;
        }
        const captionEl = document.createElement('caption');
        captionEl.classList.add('ids-sr-only');
        captionEl.innerText = text;
        if (this._elementRef.nativeElement) {
            this._elementRef.nativeElement.prepend(captionEl);
        }
    }
    _sortData(event) {
        this.columns.forEach((column) => {
            if (column.name !== event.name) {
                column.direction = undefined;
            }
        });
        this.sort.emit(event);
    }
    ngAfterContentInit() {
        this.columnsWithSorting.changes
            .pipe(takeUntil$1(this._destroy), tap$1(() => this._addSortingCaption()), switchMap$1(() => merge(...this.columnsWithSorting.map((column) => column.sort))))
            .subscribe((event) => {
            this._sortData(event);
        });
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this._destroy.next();
        this._destroy.complete();
    }
}
IdsTableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTableComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
IdsTableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsTableComponent, selector: "table[idsTable]", inputs: { borderStyle: "borderStyle", cellSpace: "cellSpace", rowStyle: "rowStyle", loading: "loading", loadingRows: "loadingRows" }, outputs: { sort: "sort" }, host: { properties: { "class.ids-table--solid-border": "borderStyle === 'solid'", "class.ids-table--full-border": "borderStyle === 'full'", "class.ids-table--horizontal-border": "borderStyle === 'horizontal'", "class.ids-table--no-border": "borderStyle === 'none'", "class.ids-table--zebra-style": "rowStyle === 'zebra'", "class.ids-table--comfortable": "cellSpace === 'comfortable'", "class.ids-table--compact": "cellSpace === 'compact'", "class.ids-table--loading": "loading" }, classAttribute: "ids-table" }, providers: [
        { provide: CdkTable, useExisting: IdsTableComponent },
        { provide: CDK_TABLE, useExisting: IdsTableComponent },
        { provide: _COALESCED_STYLE_SCHEDULER, useClass: _CoalescedStyleScheduler },
        { provide: _VIEW_REPEATER_STRATEGY, useClass: _DisposeViewRepeaterStrategy },
        // Impede que as tabelas aninhadas vejam o StickyPositioningListener desta tabela.
        { provide: STICKY_POSITIONING_LISTENER, useValue: null },
    ], queries: [{ propertyName: "columnsWithSorting", predicate: IdsSortComponent }], exportAs: ["idsTable"], usesInheritance: true, ngImport: i0, template: "<ng-container *ngIf=\"loading\"\n      ><div class=\"ids-shimmer\" *ngFor=\"let i of [].constructor(loadingRows)\"></div\n    ></ng-container>\n    \n  <ng-content select=\"caption\"></ng-content>\n  <ng-content select=\"colgroup, col\"></ng-content>\n  <ng-container headerRowOutlet></ng-container>\n  <ng-container rowOutlet></ng-container>\n  <ng-container noDataRowOutlet></ng-container>\n  <ng-container footerRowOutlet></ng-container>\n", isInline: true, dependencies: [{ kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i2$1.DataRowOutlet, selector: "[rowOutlet]" }, { kind: "directive", type: i2$1.HeaderRowOutlet, selector: "[headerRowOutlet]" }, { kind: "directive", type: i2$1.FooterRowOutlet, selector: "[footerRowOutlet]" }, { kind: "directive", type: i2$1.NoDataRowOutlet, selector: "[noDataRowOutlet]" }], encapsulation: i0.ViewEncapsulation.None });
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object)
], IdsTableComponent.prototype, "loading", void 0);
__decorate([
    EnforceNumber(),
    __metadata("design:type", Object)
], IdsTableComponent.prototype, "loadingRows", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTableComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'table[idsTable]',
                    exportAs: 'idsTable',
                    template: `<ng-container *ngIf="loading"
      ><div class="ids-shimmer" *ngFor="let i of [].constructor(loadingRows)"></div
    ></ng-container>
    ${CDK_TABLE_TEMPLATE}`,
                    host: {
                        class: 'ids-table',
                        '[class.ids-table--solid-border]': "borderStyle === 'solid'",
                        '[class.ids-table--full-border]': "borderStyle === 'full'",
                        '[class.ids-table--horizontal-border]': "borderStyle === 'horizontal'",
                        '[class.ids-table--no-border]': "borderStyle === 'none'",
                        '[class.ids-table--zebra-style]': "rowStyle === 'zebra'",
                        '[class.ids-table--comfortable]': "cellSpace === 'comfortable'",
                        '[class.ids-table--compact]': "cellSpace === 'compact'",
                        '[class.ids-table--loading]': 'loading',
                    },
                    providers: [
                        { provide: CdkTable, useExisting: IdsTableComponent },
                        { provide: CDK_TABLE, useExisting: IdsTableComponent },
                        { provide: _COALESCED_STYLE_SCHEDULER, useClass: _CoalescedStyleScheduler },
                        { provide: _VIEW_REPEATER_STRATEGY, useClass: _DisposeViewRepeaterStrategy },
                        // Impede que as tabelas aninhadas vejam o StickyPositioningListener desta tabela.
                        { provide: STICKY_POSITIONING_LISTENER, useValue: null },
                    ],
                    encapsulation: ViewEncapsulation.None,
                }]
        }], propDecorators: { borderStyle: [{
                type: Input
            }], cellSpace: [{
                type: Input
            }], rowStyle: [{
                type: Input
            }], loading: [{
                type: Input
            }], loadingRows: [{
                type: Input
            }], sort: [{
                type: Output
            }], columnsWithSorting: [{
                type: ContentChildren,
                args: [IdsSortComponent]
            }] } });

class IdsTableWrapperComponent {
    constructor() {
        this.outline = false;
    }
    set borderStyle(value) {
        this._borderStyle = value;
        this.setTableBorderStyles();
    }
    get borderStyle() {
        return this._borderStyle;
    }
    ngAfterContentChecked() {
        this.setTableBorderStyles();
    }
    setTableBorderStyles() {
        if (this.table) {
            this.table.borderStyle = this.borderStyle;
        }
    }
}
IdsTableWrapperComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTableWrapperComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IdsTableWrapperComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsTableWrapperComponent, selector: "ids-table-wrapper", inputs: { outline: "outline", borderStyle: "borderStyle", maxHeight: "maxHeight" }, queries: [{ propertyName: "table", first: true, predicate: IdsTableComponent, descendants: true }, { propertyName: "pagination", first: true, predicate: IdsPaginationComponent, descendants: true }], ngImport: i0, template: `
    <section class="ids-table-wrapper" [class.ids-table-wrapper--outline]="outline">
      <div
        idsEnsureScrollableAccess
        class="ids-table-wrapper__table"
        [style.max-height]="maxHeight ? maxHeight : null"
      >
        <ng-content select="[idsTable]"></ng-content>
      </div>
      <ng-content select="ids-pagination"></ng-content>
    </section>
  `, isInline: true, dependencies: [{ kind: "directive", type: IdsEnsureScrollableAccessDirective, selector: "[idsEnsureScrollableAccess]" }] });
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object)
], IdsTableWrapperComponent.prototype, "outline", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTableWrapperComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ids-table-wrapper',
                    template: `
    <section class="ids-table-wrapper" [class.ids-table-wrapper--outline]="outline">
      <div
        idsEnsureScrollableAccess
        class="ids-table-wrapper__table"
        [style.max-height]="maxHeight ? maxHeight : null"
      >
        <ng-content select="[idsTable]"></ng-content>
      </div>
      <ng-content select="ids-pagination"></ng-content>
    </section>
  `,
                }]
        }], propDecorators: { outline: [{
                type: Input
            }], borderStyle: [{
                type: Input
            }], maxHeight: [{
                type: Input
            }], table: [{
                type: ContentChild,
                args: [IdsTableComponent]
            }], pagination: [{
                type: ContentChild,
                args: [IdsPaginationComponent]
            }] } });

/**
 * Define a linha do cabeçalho da tabela.
 * Captura o modelo da linha e outras propriedades do cabeçalho, como as colunas a serem exibidas.
 */
class IdsHeaderRowDefDirective extends CdkHeaderRowDef {
}
IdsHeaderRowDefDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsHeaderRowDefDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
IdsHeaderRowDefDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsHeaderRowDefDirective, selector: "[idsHeaderRowDef]", inputs: { columns: ["idsHeaderRowDef", "columns"], sticky: ["idsHeaderRowDefSticky", "sticky"] }, providers: [{ provide: CdkHeaderRowDef, useExisting: IdsHeaderRowDefDirective }], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsHeaderRowDefDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsHeaderRowDef]',
                    providers: [{ provide: CdkHeaderRowDef, useExisting: IdsHeaderRowDefDirective }],
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['columns: idsHeaderRowDef', 'sticky: idsHeaderRowDefSticky'],
                }]
        }] });
/**
 * Define a linha do rodapé da tabela.
 * Captura o modelo da linha e outras propriedades do rodapé, como as colunas a serem exibidas.
 */
class IdsFooterRowDefDirective extends CdkFooterRowDef {
}
IdsFooterRowDefDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFooterRowDefDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
IdsFooterRowDefDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsFooterRowDefDirective, selector: "[idsFooterRowDef]", inputs: { columns: ["idsFooterRowDef", "columns"], sticky: ["idsFooterRowDefSticky", "sticky"] }, providers: [{ provide: CdkFooterRowDef, useExisting: IdsFooterRowDefDirective }], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFooterRowDefDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsFooterRowDef]',
                    providers: [{ provide: CdkFooterRowDef, useExisting: IdsFooterRowDefDirective }],
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['columns: idsFooterRowDef', 'sticky: idsFooterRowDefSticky'],
                }]
        }] });
/**
 * Define as linhas da tabela.
 * Captura o modelo das linhas e outras propriedades da tabela, como as colunas a serem exibidas.
 */
class IdsRowDefDirective extends CdkRowDef {
}
IdsRowDefDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsRowDefDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
IdsRowDefDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsRowDefDirective, selector: "[idsRowDef]", inputs: { columns: ["idsRowDefColumns", "columns"], when: ["idsRowDefWhen", "when"] }, providers: [{ provide: CdkRowDef, useExisting: IdsRowDefDirective }], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsRowDefDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsRowDef]',
                    providers: [{ provide: CdkRowDef, useExisting: IdsRowDefDirective }],
                    // eslint-disable-next-line @angular-eslint/no-inputs-metadata-property
                    inputs: ['columns: idsRowDefColumns', 'when: idsRowDefWhen'],
                }]
        }] });
/** Container para o conteúdo da linha do cabeçalho. Adiciona classes e role correta. */
class IdsHeaderRowComponent extends CdkHeaderRow {
}
IdsHeaderRowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsHeaderRowComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
IdsHeaderRowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsHeaderRowComponent, selector: "ids-header-row, tr[idsHeaderRow]", inputs: { borderStyle: "borderStyle", backgroundStyle: "backgroundStyle" }, host: { attributes: { "role": "row" }, properties: { "class.ids-table__header-row--horizontal-border": "borderStyle === 'horizontal'", "class.ids-table__header-row--no-border": "borderStyle === 'none'", "class.ids-table__header-row--no-background": "backgroundStyle === 'transparent'" }, classAttribute: "ids-table__header-row" }, providers: [{ provide: CdkHeaderRow, useExisting: IdsHeaderRowComponent }], exportAs: ["idsHeaderRow"], usesInheritance: true, ngImport: i0, template: "<ng-container cdkCellOutlet></ng-container>", isInline: true, dependencies: [{ kind: "directive", type: i2$1.CdkCellOutlet, selector: "[cdkCellOutlet]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsHeaderRowComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ids-header-row, tr[idsHeaderRow]',
                    template: CDK_ROW_TEMPLATE,
                    host: {
                        class: 'ids-table__header-row',
                        '[class.ids-table__header-row--horizontal-border]': "borderStyle === 'horizontal'",
                        '[class.ids-table__header-row--no-border]': "borderStyle === 'none'",
                        '[class.ids-table__header-row--no-background]': "backgroundStyle === 'transparent'",
                        role: 'row',
                    },
                    exportAs: 'idsHeaderRow',
                    providers: [{ provide: CdkHeaderRow, useExisting: IdsHeaderRowComponent }],
                }]
        }], propDecorators: { borderStyle: [{
                type: Input
            }], backgroundStyle: [{
                type: Input
            }] } });
/** Container para o conteúdo da linha do rodapé. Adiciona classes e role correta. */
class IdsFooterRowComponent extends CdkFooterRow {
}
IdsFooterRowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFooterRowComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
IdsFooterRowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsFooterRowComponent, selector: "ids-footer-row, tr[idsFooterRow]", inputs: { borderStyle: "borderStyle", backgroundStyle: "backgroundStyle" }, host: { attributes: { "role": "row" }, properties: { "class.ids-table__footer-row--horizontal-border": "borderStyle === 'horizontal'", "class.ids-table__footer-row-no-border": "borderStyle === 'none'", "class.ids-table__footer-row--no-background": "backgroundStyle === 'transparent'" }, classAttribute: "ids-table__footer-row" }, providers: [{ provide: CdkFooterRow, useExisting: IdsFooterRowComponent }], exportAs: ["idsFooterRow"], usesInheritance: true, ngImport: i0, template: "<ng-container cdkCellOutlet></ng-container>", isInline: true, dependencies: [{ kind: "directive", type: i2$1.CdkCellOutlet, selector: "[cdkCellOutlet]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFooterRowComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ids-footer-row, tr[idsFooterRow]',
                    template: CDK_ROW_TEMPLATE,
                    host: {
                        class: 'ids-table__footer-row',
                        '[class.ids-table__footer-row--horizontal-border]': "borderStyle === 'horizontal'",
                        '[class.ids-table__footer-row-no-border]': "borderStyle === 'none'",
                        '[class.ids-table__footer-row--no-background]': "backgroundStyle === 'transparent'",
                        role: 'row',
                    },
                    exportAs: 'idsFooterRow',
                    providers: [{ provide: CdkFooterRow, useExisting: IdsFooterRowComponent }],
                }]
        }], propDecorators: { borderStyle: [{
                type: Input
            }], backgroundStyle: [{
                type: Input
            }] } });
/** Container para o conteúdo das linhas da tabela. Adiciona classes e role correta. */
class IdsRowComponent extends CdkRow {
}
IdsRowComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsRowComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
IdsRowComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsRowComponent, selector: "ids-row, tr[idsRow]", inputs: { borderStyle: "borderStyle", backgroundStyle: "backgroundStyle" }, host: { attributes: { "role": "row" }, properties: { "class.ids-table__row--full-border": "borderStyle === 'full'", "class.ids-table__row--horizontal-border": "borderStyle === 'horizontal'", "class.ids-table__row--no-border": "borderStyle === 'none'", "class.ids-table__row--no-background": "backgroundStyle === 'transparent'" }, classAttribute: "ids-table__row" }, providers: [{ provide: CdkRow, useExisting: IdsRowComponent }], exportAs: ["idsRow"], usesInheritance: true, ngImport: i0, template: "<ng-container cdkCellOutlet></ng-container>", isInline: true, dependencies: [{ kind: "directive", type: i2$1.CdkCellOutlet, selector: "[cdkCellOutlet]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsRowComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ids-row, tr[idsRow]',
                    template: CDK_ROW_TEMPLATE,
                    host: {
                        class: 'ids-table__row',
                        '[class.ids-table__row--full-border]': "borderStyle === 'full'",
                        '[class.ids-table__row--horizontal-border]': "borderStyle === 'horizontal'",
                        '[class.ids-table__row--no-border]': "borderStyle === 'none'",
                        '[class.ids-table__row--no-background]': "backgroundStyle === 'transparent'",
                        role: 'row',
                    },
                    exportAs: 'idsRow',
                    providers: [{ provide: CdkRow, useExisting: IdsRowComponent }],
                }]
        }], propDecorators: { borderStyle: [{
                type: Input
            }], backgroundStyle: [{
                type: Input
            }] } });
/** Linha utilizada para exibir mensagem quando a tabela estiver vazia. */
class IdsNoDataRowDirective extends CdkNoDataRow {
    constructor() {
        super(...arguments);
        this._contentClassName = 'ids-table__no-data-row';
    }
}
IdsNoDataRowDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsNoDataRowDirective, deps: null, target: i0.ɵɵFactoryTarget.Directive });
IdsNoDataRowDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsNoDataRowDirective, selector: "ng-template[idsNoDataRow]", providers: [{ provide: CdkNoDataRow, useExisting: IdsNoDataRowDirective }], usesInheritance: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsNoDataRowDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: 'ng-template[idsNoDataRow]',
                    providers: [{ provide: CdkNoDataRow, useExisting: IdsNoDataRowDirective }],
                }]
        }] });

const LITERAL_FOR_CHECK_UNCHECK_ALL = ['Marcar todas as linhas', 'Desmarcar todas as linhas'];
class IdsCheckboxColumnComponent {
    /** Define qual coluna representa o checkbox */
    get name() {
        return this._name;
    }
    set name(name) {
        this._name = name;
        this._syncColumnDefName();
    }
    /** Define a literal do checkbox que marca/desmarca todos os registros, por padrão é
     * Marcar todas as linhas / Desmarcar todas as linhas
     * */
    set literalForCheckUnCheckAll(value) {
        this._literalForCheckUnCheckAll =
            Array.isArray(value) && value.length === 2 ? value : LITERAL_FOR_CHECK_UNCHECK_ALL;
    }
    get literalForCheckUnCheckAll() {
        return this._literalForCheckUnCheckAll;
    }
    constructor(_table) {
        this._table = _table;
        this._literalForCheckUnCheckAll = LITERAL_FOR_CHECK_UNCHECK_ALL;
        /** Evento disparado ao marcar / desmarcar todas as linhas, cujo valor é um boolean que indica
         * true caso todas as linhas sejam marcadas e false caso todas as linhas sejam desmarcadas
         */
        this.checkAll = new EventEmitter();
        /** Evento disparado ao marcar / desmarcar uma linha específica, cujo valor emitido é a própria
         * linha
         */
        this.checkRow = new EventEmitter();
        this.headerCheckboxState = 'none';
        this.checkboxAll = false;
    }
    ngOnInit() {
        this._syncColumnDefName();
        if (this._table) {
            // Registra a coluna na table
            this.columnDef.cell = this.cell;
            this.columnDef.headerCell = this.headerCell;
            this._table.addColumnDef(this.columnDef);
        }
    }
    ngOnDestroy() {
        if (this._table) {
            this._table.removeColumnDef(this.columnDef);
        }
    }
    headerRowAriaLabel() {
        if (this.checkboxAll) {
            return this.literalForCheckUnCheckAll[1];
        }
        return this.literalForCheckUnCheckAll[0];
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    rowAriaLabel(checked, row, index) {
        let ariaLabel = checked ? 'desmarcar ' : 'marcar ';
        if (this.additionalColumnInfo) {
            return (ariaLabel += row[this.additionalColumnInfo]);
        }
        return (ariaLabel += `linha ${index + 2}`);
    }
    toggleCheckAll({ target }) {
        const checked = target.checked;
        this.checkboxes.forEach((checkbox) => (checkbox.nativeElement.checked = checked));
        this.headerCheckboxState = checked ? 'all' : 'none';
        this.checkAll.emit(checked);
    }
    toggleChecked(row) {
        this.handleHeaderCheckboxState();
        this.checkRow.emit(row);
    }
    handleHeaderCheckboxState() {
        let someSelected = false;
        const allSelected = this.checkboxes.toArray().every((chk) => chk.nativeElement.checked);
        this.checkboxAll = allSelected;
        if (!allSelected) {
            someSelected = !allSelected && this.checkboxes.some((chk) => chk.nativeElement.checked);
        }
        this.headerCheckboxState = allSelected ? 'all' : someSelected ? 'some' : 'none';
    }
    /** Synchronizes the column definition name with the text column name. */
    _syncColumnDefName() {
        if (this.columnDef) {
            this.columnDef.name = this.name;
        }
    }
}
IdsCheckboxColumnComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsCheckboxColumnComponent, deps: [{ token: IdsTableComponent }], target: i0.ɵɵFactoryTarget.Component });
IdsCheckboxColumnComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsCheckboxColumnComponent, selector: "ids-checkbox-column", inputs: { name: "name", literalForCheckUnCheckAll: "literalForCheckUnCheckAll", additionalColumnInfo: "additionalColumnInfo" }, outputs: { checkAll: "checkAll", checkRow: "checkRow" }, viewQueries: [{ propertyName: "columnDef", first: true, predicate: IdsColumnDefDirective, descendants: true, static: true }, { propertyName: "cell", first: true, predicate: IdsCellDefDirective, descendants: true, static: true }, { propertyName: "headerCell", first: true, predicate: IdsHeaderCellDefDirective, descendants: true, static: true }, { propertyName: "checkboxes", predicate: ["idsCheckboxCell"], descendants: true }], ngImport: i0, template: `
    <ng-container idsColumnDef>
      <th idsHeaderCell *idsHeaderCellDef>
        <ids-checkbox>
          <input
            idsCheckbox
            type="checkbox"
            [(ngModel)]="checkboxAll"
            [attr.aria-label]="headerRowAriaLabel()"
            [indeterminate]="headerCheckboxState === 'some'"
            (change)="toggleCheckAll($event)"
          />
        </ids-checkbox>
      </th>
      <td idsCell *idsCellDef="let row; let i = index">
        <ids-checkbox>
          <input
            idsCheckbox
            type="checkbox"
            [(ngModel)]="row[name]"
            [attr.aria-label]="rowAriaLabel(row[name], row, i)"
            #idsCheckboxCell
            (change)="toggleChecked(row)"
          />
        </ids-checkbox>
      </td>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: i1$2.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { kind: "directive", type: i1$2.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { kind: "directive", type: i1$2.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { kind: "component", type: IdsCheckboxComponent, selector: "ids-checkbox" }, { kind: "directive", type: IdsCheckboxDirective, selector: "[idsCheckbox]" }, { kind: "directive", type: IdsHeaderCellDefDirective, selector: "[idsHeaderCellDef]" }, { kind: "directive", type: IdsColumnDefDirective, selector: "[idsColumnDef]", inputs: ["sticky", "idsColumnDef", "truncate", "maxWidth"] }, { kind: "directive", type: IdsCellDefDirective, selector: "[idsCellDef]" }, { kind: "directive", type: IdsHeaderCellDirective, selector: "ids-header-cell, th[idsHeaderCell]" }, { kind: "directive", type: IdsCellDirective, selector: "ids-cell, td[idsCell]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsCheckboxColumnComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ids-checkbox-column',
                    template: `
    <ng-container idsColumnDef>
      <th idsHeaderCell *idsHeaderCellDef>
        <ids-checkbox>
          <input
            idsCheckbox
            type="checkbox"
            [(ngModel)]="checkboxAll"
            [attr.aria-label]="headerRowAriaLabel()"
            [indeterminate]="headerCheckboxState === 'some'"
            (change)="toggleCheckAll($event)"
          />
        </ids-checkbox>
      </th>
      <td idsCell *idsCellDef="let row; let i = index">
        <ids-checkbox>
          <input
            idsCheckbox
            type="checkbox"
            [(ngModel)]="row[name]"
            [attr.aria-label]="rowAriaLabel(row[name], row, i)"
            #idsCheckboxCell
            (change)="toggleChecked(row)"
          />
        </ids-checkbox>
      </td>
    </ng-container>
  `,
                }]
        }], ctorParameters: function () { return [{ type: IdsTableComponent }]; }, propDecorators: { name: [{
                type: Input
            }], literalForCheckUnCheckAll: [{
                type: Input
            }], additionalColumnInfo: [{
                type: Input
            }], checkAll: [{
                type: Output
            }], checkRow: [{
                type: Output
            }], columnDef: [{
                type: ViewChild,
                args: [IdsColumnDefDirective, { static: true }]
            }], cell: [{
                type: ViewChild,
                args: [IdsCellDefDirective, { static: true }]
            }], headerCell: [{
                type: ViewChild,
                args: [IdsHeaderCellDefDirective, { static: true }]
            }], checkboxes: [{
                type: ViewChildren,
                args: ['idsCheckboxCell']
            }] } });

/**
 * Componente para exibir uma coluna de texto na tabela,
 * renderizando cada célula com o valor de dados correspondente. É uma forma mais simples
 * de utilização.
 */
class IdsTextColumnComponent extends CdkTextColumn {
}
IdsTextColumnComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTextColumnComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
IdsTextColumnComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsTextColumnComponent, selector: "ids-text-column", usesInheritance: true, ngImport: i0, template: `
    <ng-container idsColumnDef>
      <th idsHeaderCell *idsHeaderCellDef>
        {{ headerText }}
      </th>
      <td idsCell *idsCellDef="let data">
        {{ dataAccessor(data, name) }}
      </td>
    </ng-container>
  `, isInline: true, dependencies: [{ kind: "directive", type: IdsHeaderCellDefDirective, selector: "[idsHeaderCellDef]" }, { kind: "directive", type: IdsColumnDefDirective, selector: "[idsColumnDef]", inputs: ["sticky", "idsColumnDef", "truncate", "maxWidth"] }, { kind: "directive", type: IdsCellDefDirective, selector: "[idsCellDef]" }, { kind: "directive", type: IdsHeaderCellDirective, selector: "ids-header-cell, th[idsHeaderCell]" }, { kind: "directive", type: IdsCellDirective, selector: "ids-cell, td[idsCell]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTextColumnComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ids-text-column',
                    template: `
    <ng-container idsColumnDef>
      <th idsHeaderCell *idsHeaderCellDef>
        {{ headerText }}
      </th>
      <td idsCell *idsCellDef="let data">
        {{ dataAccessor(data, name) }}
      </td>
    </ng-container>
  `,
                }]
        }] });

const EXPORTED_COMPONENTS = [
    // Componente de tabela
    IdsTableComponent,
    IdsTableWrapperComponent,
    IdsRecycleRowsDirective,
    // Definições de template
    IdsHeaderRowDefDirective,
    IdsHeaderCellDefDirective,
    IdsRowDefDirective,
    IdsColumnDefDirective,
    IdsCellDefDirective,
    IdsFooterRowDefDirective,
    IdsFooterCellDefDirective,
    // Componentes de célula
    IdsHeaderCellDirective,
    IdsCellDirective,
    IdsFooterCellDirective,
    // Componentes de linha
    IdsHeaderRowComponent,
    IdsRowComponent,
    IdsFooterRowComponent,
    IdsNoDataRowDirective,
    // Componente facilitador de coluna
    IdsTextColumnComponent,
    // Componente para coluna com checkbox
    IdsCheckboxColumnComponent,
    // Componente para ordenação
    IdsSortComponent,
];
class IdsTableModule {
}
IdsTableModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTableModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsTableModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsTableModule, declarations: [
        // Componente de tabela
        IdsTableComponent,
        IdsTableWrapperComponent,
        IdsRecycleRowsDirective,
        // Definições de template
        IdsHeaderRowDefDirective,
        IdsHeaderCellDefDirective,
        IdsRowDefDirective,
        IdsColumnDefDirective,
        IdsCellDefDirective,
        IdsFooterRowDefDirective,
        IdsFooterCellDefDirective,
        // Componentes de célula
        IdsHeaderCellDirective,
        IdsCellDirective,
        IdsFooterCellDirective,
        // Componentes de linha
        IdsHeaderRowComponent,
        IdsRowComponent,
        IdsFooterRowComponent,
        IdsNoDataRowDirective,
        // Componente facilitador de coluna
        IdsTextColumnComponent,
        // Componente para coluna com checkbox
        IdsCheckboxColumnComponent,
        // Componente para ordenação
        IdsSortComponent], imports: [CommonModule,
        FormsModule,
        CdkTableModule,
        IdsCheckboxModule,
        IdsIconModule,
        IdsShimmerModule,
        IdsEnsureScrollableAccessModule], exports: [
        // Componente de tabela
        IdsTableComponent,
        IdsTableWrapperComponent,
        IdsRecycleRowsDirective,
        // Definições de template
        IdsHeaderRowDefDirective,
        IdsHeaderCellDefDirective,
        IdsRowDefDirective,
        IdsColumnDefDirective,
        IdsCellDefDirective,
        IdsFooterRowDefDirective,
        IdsFooterCellDefDirective,
        // Componentes de célula
        IdsHeaderCellDirective,
        IdsCellDirective,
        IdsFooterCellDirective,
        // Componentes de linha
        IdsHeaderRowComponent,
        IdsRowComponent,
        IdsFooterRowComponent,
        IdsNoDataRowDirective,
        // Componente facilitador de coluna
        IdsTextColumnComponent,
        // Componente para coluna com checkbox
        IdsCheckboxColumnComponent,
        // Componente para ordenação
        IdsSortComponent] });
IdsTableModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTableModule, imports: [CommonModule,
        FormsModule,
        CdkTableModule,
        IdsCheckboxModule,
        IdsIconModule,
        IdsShimmerModule,
        IdsEnsureScrollableAccessModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTableModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EXPORTED_COMPONENTS],
                    imports: [
                        CommonModule,
                        FormsModule,
                        CdkTableModule,
                        IdsCheckboxModule,
                        IdsIconModule,
                        IdsShimmerModule,
                        IdsEnsureScrollableAccessModule,
                    ],
                    exports: [EXPORTED_COMPONENTS],
                }]
        }] });

let NEXT_ID$1 = 0;
class IdsTabsPanelDirective {
    constructor(templateRef) {
        this.templateRef = templateRef;
    }
}
IdsTabsPanelDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTabsPanelDirective, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive });
IdsTabsPanelDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsTabsPanelDirective, isStandalone: true, selector: "[idsTabsPanel]", ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTabsPanelDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsTabsPanel]',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }]; } });
/**
 * As abas são uma maneira fácil de organizar o conteúdo, agrupando informações semelhantes na mesma página.
 *
 * **Module:**
 *
 * `import { IdsTabsModule } from '@ids/angular';`
 *
 * **Component:**
 *
 * `import { IdsTabsComponent, IdsTabsPanelDirective } from '@ids/angular';`
 */
class IdsTabsComponent {
    get panelId() {
        return this._userInformedPanelId || `${this.id}-panel-${this._selectedTabIndex + 1}`;
    }
    get isIOS() {
        return platform.os === 'IOS';
    }
    get scrollBehavior() {
        return this.isIOS || platform.os === 'MacOS' ? 'auto' : 'smooth';
    }
    /**
     * Recebe um array de objetos contendo as configurações do tabs:
     */
    get tabs() {
        return this._tabs;
    }
    set tabs(value) {
        this._tabs = value;
        this._selectedTabIndex = this._tabs.findIndex((item) => item.selected);
    }
    constructor(_renderer, _la) {
        this._renderer = _renderer;
        this._la = _la;
        // TODO: remover variável usada apenas para teste
        this.scrollIntoViewX = scrollIntoViewX;
        this.setVoiceOverFocus = setVoiceOverFocus;
        /**
         * Recebe um ID customizado para os tabs
         */
        this.id = `ids-tabs-${NEXT_ID$1++}`;
        /**
         * Palavra a ser anunciada pelo VoiceOver quando o foco for perdido e uma nova tab selecionada.
         * Quando o foco se perde, o item selecionado não é anunciado. Por esse motivo, é necessário
         * fazer o anúncio manualmente.
         */
        this.selectedTabLiteral = 'selecionado';
        /**
         * @deprecated
         *
         * **Nota:** Este evento foi substituído pelo evento `selected` e será removido em versões futuras.
         *
         * Evento disparado ao selecionar uma aba.
         */
        this.change = new EventEmitter();
        /**
         * Evento disparado ao selecionar uma aba.
         */
        this.selected = new EventEmitter();
        this.hostId = null;
    }
    ngAfterContentInit() {
        this._createSelectedTabPanel();
    }
    ngAfterViewInit() {
        const selectedTabEl = this.tabElList.get(this._selectedTabIndex);
        if (!isElementScrollable(this.tabListEl.nativeElement) || !selectedTabEl) {
            return;
        }
        this.scrollIntoViewX(selectedTabEl.nativeElement, this.tabListEl.nativeElement, 'auto');
    }
    _createSelectedTabPanel() {
        const selectedTabTemplateRef = this.tabPanels.get(this._selectedTabIndex)?.templateRef;
        if (selectedTabTemplateRef) {
            if (this._view) {
                this.viewContainer.remove(0);
            }
            this._view = this.viewContainer.createEmbeddedView(selectedTabTemplateRef);
            const rootEl = this._view.rootNodes[0];
            this._renderer.setAttribute(rootEl, 'role', 'tabpanel');
            this._userInformedPanelId = rootEl.getAttribute('id');
            if (!this._userInformedPanelId) {
                this._renderer.setAttribute(rootEl, 'id', this.panelId);
            }
        }
    }
    // Esta função é necessária para setar o foco no item selecionado quando o
    // VoiceOver estiver sendo utilizado, já que ele se perde e foca em itens
    // errados aleatoriamente.
    _focusOnCorrectTab(target, selected = true) {
        setTimeout(() => {
            this.setVoiceOverFocus(target);
            // Quando o foco se perde, o item selecionado não é anunciado.
            // Por esse motivo, é necessário fazer o anúncio manualmente.
            if (selected) {
                this._la.announce(this.selectedTabLiteral, 1000);
            }
        }, 100);
    }
    selectTab(event, index) {
        const element = event.target;
        if (this.tabs[index].disabled) {
            if (this.isIOS) {
                this._focusOnCorrectTab(element, false);
            }
            return;
        }
        this.tabs.forEach((item) => (item.selected = false));
        this.tabs[index].selected = true;
        this._selectedTabIndex = index;
        this.change.emit(event);
        this.selected.emit(event);
        this._createSelectedTabPanel();
        if (this.isIOS) {
            this._focusOnCorrectTab(element);
        }
    }
    onKeyDown(event, index) {
        const element = event.target;
        if (event.code === 'ArrowRight' || event.code === 'ArrowDown') {
            event.preventDefault();
            const nextTab = element.nextElementSibling;
            if (nextTab && nextTab.tagName === 'BUTTON') {
                nextTab.focus();
                return;
            }
            element.focus();
            return;
        }
        if (event.code === 'ArrowLeft' || event.code === 'ArrowUp') {
            event.preventDefault();
            const previousTab = element.previousElementSibling;
            if (previousTab && previousTab.tagName === 'BUTTON') {
                previousTab.focus();
                return;
            }
            element.focus();
            return;
        }
        if (event.code === 'Enter' || event.code === 'NumpadEnter' || event.code === 'Space') {
            if (this.tabs[index].disabled) {
                return;
            }
            event.preventDefault();
            this.selectTab(event, index);
            return;
        }
    }
}
IdsTabsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTabsComponent, deps: [{ token: i0.Renderer2 }, { token: i1$1.LiveAnnouncer }], target: i0.ɵɵFactoryTarget.Component });
IdsTabsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsTabsComponent, isStandalone: true, selector: "ids-tabs", inputs: { id: "id", tabs: "tabs", contrast: "contrast", selectedTabLiteral: "selectedTabLiteral" }, outputs: { change: "change", selected: "selected" }, host: { properties: { "attr.id": "this.hostId" } }, queries: [{ propertyName: "tabPanels", predicate: IdsTabsPanelDirective }], viewQueries: [{ propertyName: "viewContainer", first: true, predicate: ["viewContainer"], descendants: true, read: ViewContainerRef, static: true }, { propertyName: "tabListEl", first: true, predicate: ["tabListEl"], descendants: true }, { propertyName: "tabElList", predicate: ["tabEl"], descendants: true }], ngImport: i0, template: "<div\n  #tabListEl\n  class=\"ids-tabs\"\n  [class.ids-tabs--on-brand]=\"contrast === 'onBrand'\"\n  [id]=\"id\"\n  role=\"tablist\"\n>\n  <button\n    #tabEl\n    *ngFor=\"let tab of tabs; index as index\"\n    [id]=\"id + '-' + (index + 1)\"\n    role=\"tab\"\n    class=\"ids-tabs__item\"\n    [class.ids-tabs__item--selected]=\"tab.selected\"\n    [attr.aria-selected]=\"tab.selected ? 'true' : 'false'\"\n    [attr.aria-controls]=\"tab.selected ? panelId : null\"\n    [attr.aria-disabled]=\"tab.disabled || null\"\n    (focus)=\"scrollIntoViewX(tabEl, tabListEl, scrollBehavior)\"\n    (keydown)=\"onKeyDown($event, index)\"\n    (mousedown)=\"selectTab($event, index)\"\n  >\n    {{ tab.label || tab.name }}\n\n    <ids-number-badge\n      *ngIf=\"tab.numberBadge\"\n      [aria-label]=\"tab.numberBadge.ariaLabel\"\n      [max]=\"tab.numberBadge.max\"\n      [maxSymbol]=\"tab.numberBadge.maxSymbol\"\n      [variant]=\"tab.numberBadge.variant\"\n      [contrast]=\"contrast\"\n    >\n      {{ tab.numberBadge.value }}\n    </ids-number-badge>\n  </button>\n</div>\n\n<ng-container #viewContainer></ng-container>\n", styles: [".ids-tabs{display:flex;min-height:var(--ids_size_general_56x);overflow-x:scroll;position:relative;scroll-snap-type:x mandatory;scrollbar-width:none}.ids-tabs::-webkit-scrollbar{display:none}.ids-tabs:after{border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_medium);content:\"\";width:100%}.ids-tabs__item{all:unset;all:revert;box-sizing:border-box;padding:0;-webkit-user-select:none;user-select:none;gap:var(--ids_spacing_2x);align-items:center;background-color:var(--ids_opacity_empty);border:none;color:var(--ids_color_action_neutral_base);cursor:pointer;display:flex;font:var(--ids_textStyle_f02_s16_h24_wrg);outline-offset:-.0625rem;padding:0 var(--ids_size_general_12x);scroll-snap-align:center;white-space:nowrap;border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_medium)}@media (pointer: coarse){.ids-tabs__item{outline:0!important}.ids-tabs__item:focus{outline:0!important}}@media (pointer: coarse) and (pointer: fine){.ids-tabs__item:focus-visible,.ids-tabs__item:focus.focus-visible{outline:0!important}}@media (pointer: fine){.ids-tabs__item:focus-visible,.ids-tabs__item:focus.focus-visible{outline:revert!important}}@media (pointer: fine) and (pointer: fine){.ids-tabs__item:focus-visible,.ids-tabs__item:focus.focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}}.js-no-flexbox-gap .ids-tabs__item{white-space:pre}.ids-tabs__item:disabled,.ids-tabs__item[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);pointer-events:none}.ids-tabs__item:hover{background-color:var(--ids_color_action_neutral_base_soft)}.ids-tabs__item[aria-selected=true],.ids-tabs__item--selected{border-bottom:var(--ids_size_border_medium) solid var(--ids_color_action_primary_base);font:var(--ids_textStyle_f02_s16_h24_wbd)}.ids-tabs--on-brand:after{border-color:var(--ids_color_contrast_onBrand_primary_medium)}.ids-tabs--on-brand .ids-tabs__item{border-color:var(--ids_color_contrast_onBrand_primary_medium);color:var(--ids_color_contrast_onBrand_primary)}.ids-tabs--on-brand .ids-tabs__item:disabled,.ids-tabs--on-brand .ids-tabs__item[aria-disabled=true]{color:var(--ids_color_contrast_onBrand_primary_medium)}.ids-tabs--on-brand .ids-tabs__item:hover{background-color:var(--ids_color_contrast_onBrand_primary_soft)}.ids-tabs--on-brand .ids-tabs__item[aria-selected=true],.ids-tabs--on-brand .ids-tabs__item--selected{border-bottom:var(--ids_size_border_medium) solid var(--ids_color_contrast_onBrand_primary_medium)}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: IdsNumberBadgeModule }, { kind: "component", type: IdsNumberBadgeComponent, selector: "ids-number-badge, [idsNumberBadge]", inputs: ["aria-label", "max", "maxSymbol", "contrast", "variant", "size"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTabsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-tabs', standalone: true, imports: [CommonModule, IdsNumberBadgeModule], template: "<div\n  #tabListEl\n  class=\"ids-tabs\"\n  [class.ids-tabs--on-brand]=\"contrast === 'onBrand'\"\n  [id]=\"id\"\n  role=\"tablist\"\n>\n  <button\n    #tabEl\n    *ngFor=\"let tab of tabs; index as index\"\n    [id]=\"id + '-' + (index + 1)\"\n    role=\"tab\"\n    class=\"ids-tabs__item\"\n    [class.ids-tabs__item--selected]=\"tab.selected\"\n    [attr.aria-selected]=\"tab.selected ? 'true' : 'false'\"\n    [attr.aria-controls]=\"tab.selected ? panelId : null\"\n    [attr.aria-disabled]=\"tab.disabled || null\"\n    (focus)=\"scrollIntoViewX(tabEl, tabListEl, scrollBehavior)\"\n    (keydown)=\"onKeyDown($event, index)\"\n    (mousedown)=\"selectTab($event, index)\"\n  >\n    {{ tab.label || tab.name }}\n\n    <ids-number-badge\n      *ngIf=\"tab.numberBadge\"\n      [aria-label]=\"tab.numberBadge.ariaLabel\"\n      [max]=\"tab.numberBadge.max\"\n      [maxSymbol]=\"tab.numberBadge.maxSymbol\"\n      [variant]=\"tab.numberBadge.variant\"\n      [contrast]=\"contrast\"\n    >\n      {{ tab.numberBadge.value }}\n    </ids-number-badge>\n  </button>\n</div>\n\n<ng-container #viewContainer></ng-container>\n", styles: [".ids-tabs{display:flex;min-height:var(--ids_size_general_56x);overflow-x:scroll;position:relative;scroll-snap-type:x mandatory;scrollbar-width:none}.ids-tabs::-webkit-scrollbar{display:none}.ids-tabs:after{border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_medium);content:\"\";width:100%}.ids-tabs__item{all:unset;all:revert;box-sizing:border-box;padding:0;-webkit-user-select:none;user-select:none;gap:var(--ids_spacing_2x);align-items:center;background-color:var(--ids_opacity_empty);border:none;color:var(--ids_color_action_neutral_base);cursor:pointer;display:flex;font:var(--ids_textStyle_f02_s16_h24_wrg);outline-offset:-.0625rem;padding:0 var(--ids_size_general_12x);scroll-snap-align:center;white-space:nowrap;border-bottom:var(--ids_size_border_small) solid var(--ids_color_border_medium)}@media (pointer: coarse){.ids-tabs__item{outline:0!important}.ids-tabs__item:focus{outline:0!important}}@media (pointer: coarse) and (pointer: fine){.ids-tabs__item:focus-visible,.ids-tabs__item:focus.focus-visible{outline:0!important}}@media (pointer: fine){.ids-tabs__item:focus-visible,.ids-tabs__item:focus.focus-visible{outline:revert!important}}@media (pointer: fine) and (pointer: fine){.ids-tabs__item:focus-visible,.ids-tabs__item:focus.focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}}.js-no-flexbox-gap .ids-tabs__item{white-space:pre}.ids-tabs__item:disabled,.ids-tabs__item[aria-disabled=true]{color:var(--ids_color_action_disabled_variant);pointer-events:none}.ids-tabs__item:hover{background-color:var(--ids_color_action_neutral_base_soft)}.ids-tabs__item[aria-selected=true],.ids-tabs__item--selected{border-bottom:var(--ids_size_border_medium) solid var(--ids_color_action_primary_base);font:var(--ids_textStyle_f02_s16_h24_wbd)}.ids-tabs--on-brand:after{border-color:var(--ids_color_contrast_onBrand_primary_medium)}.ids-tabs--on-brand .ids-tabs__item{border-color:var(--ids_color_contrast_onBrand_primary_medium);color:var(--ids_color_contrast_onBrand_primary)}.ids-tabs--on-brand .ids-tabs__item:disabled,.ids-tabs--on-brand .ids-tabs__item[aria-disabled=true]{color:var(--ids_color_contrast_onBrand_primary_medium)}.ids-tabs--on-brand .ids-tabs__item:hover{background-color:var(--ids_color_contrast_onBrand_primary_soft)}.ids-tabs--on-brand .ids-tabs__item[aria-selected=true],.ids-tabs--on-brand .ids-tabs__item--selected{border-bottom:var(--ids_size_border_medium) solid var(--ids_color_contrast_onBrand_primary_medium)}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.Renderer2 }, { type: i1$1.LiveAnnouncer }]; }, propDecorators: { id: [{
                type: Input
            }], tabs: [{
                type: Input
            }], contrast: [{
                type: Input
            }], selectedTabLiteral: [{
                type: Input
            }], change: [{
                type: Output
            }], selected: [{
                type: Output
            }], hostId: [{
                type: HostBinding,
                args: ['attr.id']
            }], tabPanels: [{
                type: ContentChildren,
                args: [IdsTabsPanelDirective]
            }], viewContainer: [{
                type: ViewChild,
                args: ['viewContainer', { read: ViewContainerRef, static: true }]
            }], tabListEl: [{
                type: ViewChild,
                args: ['tabListEl']
            }], tabElList: [{
                type: ViewChildren,
                args: ['tabEl']
            }] } });

class IdsTabsModule {
}
IdsTabsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTabsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsTabsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsTabsModule, imports: [IdsTabsPanelDirective, IdsTabsComponent], exports: [IdsTabsPanelDirective, IdsTabsComponent] });
IdsTabsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTabsModule, imports: [IdsTabsComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTabsModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsTabsPanelDirective, IdsTabsComponent],
                    exports: [IdsTabsPanelDirective, IdsTabsComponent],
                }]
        }] });

class IdsTrackerService {
    constructor() {
        this.NEXT_STEP = 0;
        this.typeSubject = new ReplaySubject();
        this.orientationSubject = new ReplaySubject();
        this.showStatusTextSubject = true;
    }
    nextStep() {
        return ++this.NEXT_STEP;
    }
}
IdsTrackerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTrackerService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
IdsTrackerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTrackerService, providedIn: null });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTrackerService, decorators: [{
            type: Injectable,
            args: [{ providedIn: null }]
        }] });

class IdsTrackerItemComponent {
    /**
     * Define o texto de cada status (finished: 'Concluído', inprogress: 'Em andamento', waiting: 'Em espera', error: 'Não realizado', alert: 'Atenção', disabled: '')
     */
    set statusText(value) {
        this._statusText = value;
    }
    get statusText() {
        return this._statusText || TRACKER_STATUS_MESSAGE[this.status];
    }
    get classes() {
        return {
            'ids-tracker-item': true,
            [`ids-tracker-item--${this.orientation}`]: this.orientation,
        };
    }
    get statusIcon() {
        if (this.type === 'number' && (this.status === 'finished' || this.status === 'error')) {
            return 'senha_circulo';
        }
        if (this.status === 'finished') {
            return 'check_circle_variant';
        }
        if (this.status === 'error') {
            return 'error_circle_variant';
        }
        return 'senha_circulo_outline';
    }
    constructor(trackerService) {
        this.trackerService = trackerService;
        this.showStatusText = true;
        this._destroy = new Subject();
        /** Imprime o valor numérico da etapa */
        this.step = 0;
        /** Titulo do item */
        this.title = '';
        /** Subtitulo do item */
        this.subtitle = '';
        /** Ícone personalizado do item */
        this.icon = '';
        /**
         * Status do tracker item, quando não enviado, assume o status padrão (waiting)
         */
        this.status = 'waiting';
        this.trackerService.typeSubject.pipe(takeUntil$1(this._destroy)).subscribe((type) => {
            this.type = type;
        });
        this.trackerService.orientationSubject
            .pipe(takeUntil$1(this._destroy))
            .subscribe((orientation) => {
            this.orientation = orientation;
        });
        this.step = this.trackerService.nextStep();
    }
    ngOnInit() {
        this.showStatusText = this.trackerService.showStatusTextSubject;
    }
    ngOnDestroy() {
        this._destroy.next();
        this._destroy.complete();
    }
}
IdsTrackerItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTrackerItemComponent, deps: [{ token: IdsTrackerService, optional: true }], target: i0.ɵɵFactoryTarget.Component });
IdsTrackerItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsTrackerItemComponent, isStandalone: true, selector: "[idsTrackerItem]", inputs: { title: "title", subtitle: "subtitle", icon: "icon", status: "status", type: "type", orientation: "orientation", statusText: "statusText" }, host: { properties: { "class": "this.classes" } }, viewQueries: [{ propertyName: "trackerItem", first: true, predicate: ["trackerItem"], descendants: true, static: true }], ngImport: i0, template: "<div class=\"ids-tracker-bar ids-tracker-bar--{{ status }}\" aria-hidden=\"true\">\n  <div class=\"ids-tracker-bar__indicator\" *ngIf=\"type !== 'icon'\">\n    <ids-icon> {{ statusIcon }} </ids-icon>\n    <span class=\"ids-tracker-bar__indicator-text\" *ngIf=\"type === 'number'\">\n      {{ step }}\n    </span>\n  </div>\n\n  <ids-icon *ngIf=\"type === 'icon'\">{{ icon }}</ids-icon>\n\n  <hr class=\"ids-tracker-bar__line\" />\n</div>\n\n<div class=\"ids-tracker-item__content\">\n  <h2 class=\"ids-section-title-2\" *ngIf=\"this.title\">{{ title }}</h2>\n  <p class=\"ids-subtitle -small ids-mt-1\" *ngIf=\"this.subtitle\">{{ subtitle }}</p>\n\n  <ng-content></ng-content>\n\n  <p class=\"ids-body-text ids-mt-2\" *ngIf=\"showStatusText\">{{ statusText }}</p>\n\n  <ng-content select=\"button\"></ng-content>\n</div>\n", styles: [".ids-tracker-bar{all:unset;all:revert;box-sizing:border-box;gap:var(--ids_spacing_3x);--ids-tracker-color-status: transparent;--ids-tracker-color-text: var(--ids_color_feedback_success_contrast);align-items:center;color:transparent;color:var(--ids-tracker-color-status);display:flex;flex-direction:column}.js-no-flexbox-gap .ids-tracker-bar{margin:calc(var(--ids_spacing_3x) / -2)!important}.js-no-flexbox-gap .ids-tracker-bar>*{margin:calc(var(--ids_spacing_3x) / 2)!important}.ids-tracker-bar__indicator{all:unset;all:revert;box-sizing:border-box;align-items:center;border-color:var(--ids-tracker-color-status);border-radius:100%;border-width:var(--ids_size_general_1x);display:flex;height:var(--ids_size_general_24x);justify-content:center;position:relative;width:var(--ids_size_general_24x)}.ids-tracker-bar__indicator-text{all:unset;all:revert;box-sizing:border-box;color:var(--ids-tracker-color-text);font:var(--ids_textStyle_f02_s12_h18_wbd);left:50%;position:absolute;top:50%;transform:translate(-50%,-53%)}.ids-tracker-bar__line{all:unset;all:revert;box-sizing:border-box;display:block;margin:0;background-color:var(--ids-tracker-color-status);border:0;border-radius:var(--ids_size_general_3x);flex:1;height:var(--ids_size_general_2x);width:var(--ids_size_general_2x)}.ids-tracker-bar--alert{--ids-tracker-color-status: var(--ids_color_feedback_alert);--ids-tracker-color-text: var(--ids_color_feedback_alert)}.ids-tracker-bar--disabled{--ids-tracker-color-status: var(--ids_color_action_disabled_base);--ids-tracker-color-text: var(--ids_color_action_disabled_base)}.ids-tracker-bar--error{--ids-tracker-color-status: var(--ids_color_feedback_error)}.ids-tracker-bar--finished{--ids-tracker-color-status: var(--ids_color_feedback_success)}.ids-tracker-bar--inprogress{--ids-tracker-color-status: var(--ids_color_feedback_information);--ids-tracker-color-text: var(--ids_color_feedback_information)}.ids-tracker-bar--waiting{--ids-tracker-color-status: var(--ids_color_feedback_neutral);--ids-tracker-color-text: var(--ids_color_feedback_neutral)}.ids-tracker-bar--waiting.ids-tracker-bar{opacity:var(--ids_opacity_medium)}.ids-tracker-item,:host.ids-tracker-item{all:unset;all:revert;box-sizing:border-box;gap:var(--ids_spacing_3x);display:flex;flex:1;min-width:6.25rem;text-align:left}.js-no-flexbox-gap .ids-tracker-item,.js-no-flexbox-gap :host.ids-tracker-item{margin:calc(var(--ids_spacing_3x) / -2)!important}.js-no-flexbox-gap .ids-tracker-item>*,.js-no-flexbox-gap :host.ids-tracker-item>*{padding:calc(var(--ids_spacing_3x) / 2)!important}.ids-tracker-item__content,:host.ids-tracker-item__content{all:unset;all:revert;box-sizing:border-box;align-items:flex-start;display:flex;flex-direction:column;padding:0 var(--ids_spacing_2x)}.ids-tracker-item__content .ids-subtitle+*,:host.ids-tracker-item__content .ids-subtitle+*{margin-top:var(--ids_size_general_8x)}.ids-tracker-item__content .ids-contextual-button,:host.ids-tracker-item__content .ids-contextual-button{margin-bottom:var(--ids_size_general_8x);margin-top:var(--ids_size_general_16x)}.ids-tracker-item:last-child .ids-tracker-bar__line,:host.ids-tracker-item:last-child .ids-tracker-bar__line{display:none}@media (min-width: 48rem){.ids-tracker-item:not(.ids-tracker-item--vertical),:host.ids-tracker-item:not(.ids-tracker-item--vertical){gap:var(--ids_spacing_2x);flex-direction:column}.js-no-flexbox-gap .ids-tracker-item:not(.ids-tracker-item--vertical),.js-no-flexbox-gap :host.ids-tracker-item:not(.ids-tracker-item--vertical){margin:calc(var(--ids_spacing_2x) / -2)!important}.js-no-flexbox-gap .ids-tracker-item:not(.ids-tracker-item--vertical)>*,.js-no-flexbox-gap :host.ids-tracker-item:not(.ids-tracker-item--vertical)>*{padding:calc(var(--ids_spacing_2x) / 2)!important}.ids-tracker-item:not(.ids-tracker-item--vertical) .ids-tracker-bar,:host.ids-tracker-item:not(.ids-tracker-item--vertical) .ids-tracker-bar{gap:var(--ids_spacing_2x);flex-direction:row}.js-no-flexbox-gap .ids-tracker-item:not(.ids-tracker-item--vertical) .ids-tracker-bar,.js-no-flexbox-gap :host.ids-tracker-item:not(.ids-tracker-item--vertical) .ids-tracker-bar{margin:calc(var(--ids_spacing_2x) / -2)!important}.js-no-flexbox-gap .ids-tracker-item:not(.ids-tracker-item--vertical) .ids-tracker-bar>*,.js-no-flexbox-gap :host.ids-tracker-item:not(.ids-tracker-item--vertical) .ids-tracker-bar>*{margin:calc(var(--ids_spacing_2x) / 2)!important}}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "ngmodule", type: IdsIconModule }, { kind: "component", type: IdsIconComponent, selector: "ids-icon", inputs: ["size", "variant", "contrast"] }] });
__decorate([
    Memo(['orientation']),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], IdsTrackerItemComponent.prototype, "classes", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTrackerItemComponent, decorators: [{
            type: Component,
            args: [{ selector: '[idsTrackerItem]', standalone: true, imports: [CommonModule, IdsIconModule], template: "<div class=\"ids-tracker-bar ids-tracker-bar--{{ status }}\" aria-hidden=\"true\">\n  <div class=\"ids-tracker-bar__indicator\" *ngIf=\"type !== 'icon'\">\n    <ids-icon> {{ statusIcon }} </ids-icon>\n    <span class=\"ids-tracker-bar__indicator-text\" *ngIf=\"type === 'number'\">\n      {{ step }}\n    </span>\n  </div>\n\n  <ids-icon *ngIf=\"type === 'icon'\">{{ icon }}</ids-icon>\n\n  <hr class=\"ids-tracker-bar__line\" />\n</div>\n\n<div class=\"ids-tracker-item__content\">\n  <h2 class=\"ids-section-title-2\" *ngIf=\"this.title\">{{ title }}</h2>\n  <p class=\"ids-subtitle -small ids-mt-1\" *ngIf=\"this.subtitle\">{{ subtitle }}</p>\n\n  <ng-content></ng-content>\n\n  <p class=\"ids-body-text ids-mt-2\" *ngIf=\"showStatusText\">{{ statusText }}</p>\n\n  <ng-content select=\"button\"></ng-content>\n</div>\n", styles: [".ids-tracker-bar{all:unset;all:revert;box-sizing:border-box;gap:var(--ids_spacing_3x);--ids-tracker-color-status: transparent;--ids-tracker-color-text: var(--ids_color_feedback_success_contrast);align-items:center;color:transparent;color:var(--ids-tracker-color-status);display:flex;flex-direction:column}.js-no-flexbox-gap .ids-tracker-bar{margin:calc(var(--ids_spacing_3x) / -2)!important}.js-no-flexbox-gap .ids-tracker-bar>*{margin:calc(var(--ids_spacing_3x) / 2)!important}.ids-tracker-bar__indicator{all:unset;all:revert;box-sizing:border-box;align-items:center;border-color:var(--ids-tracker-color-status);border-radius:100%;border-width:var(--ids_size_general_1x);display:flex;height:var(--ids_size_general_24x);justify-content:center;position:relative;width:var(--ids_size_general_24x)}.ids-tracker-bar__indicator-text{all:unset;all:revert;box-sizing:border-box;color:var(--ids-tracker-color-text);font:var(--ids_textStyle_f02_s12_h18_wbd);left:50%;position:absolute;top:50%;transform:translate(-50%,-53%)}.ids-tracker-bar__line{all:unset;all:revert;box-sizing:border-box;display:block;margin:0;background-color:var(--ids-tracker-color-status);border:0;border-radius:var(--ids_size_general_3x);flex:1;height:var(--ids_size_general_2x);width:var(--ids_size_general_2x)}.ids-tracker-bar--alert{--ids-tracker-color-status: var(--ids_color_feedback_alert);--ids-tracker-color-text: var(--ids_color_feedback_alert)}.ids-tracker-bar--disabled{--ids-tracker-color-status: var(--ids_color_action_disabled_base);--ids-tracker-color-text: var(--ids_color_action_disabled_base)}.ids-tracker-bar--error{--ids-tracker-color-status: var(--ids_color_feedback_error)}.ids-tracker-bar--finished{--ids-tracker-color-status: var(--ids_color_feedback_success)}.ids-tracker-bar--inprogress{--ids-tracker-color-status: var(--ids_color_feedback_information);--ids-tracker-color-text: var(--ids_color_feedback_information)}.ids-tracker-bar--waiting{--ids-tracker-color-status: var(--ids_color_feedback_neutral);--ids-tracker-color-text: var(--ids_color_feedback_neutral)}.ids-tracker-bar--waiting.ids-tracker-bar{opacity:var(--ids_opacity_medium)}.ids-tracker-item,:host.ids-tracker-item{all:unset;all:revert;box-sizing:border-box;gap:var(--ids_spacing_3x);display:flex;flex:1;min-width:6.25rem;text-align:left}.js-no-flexbox-gap .ids-tracker-item,.js-no-flexbox-gap :host.ids-tracker-item{margin:calc(var(--ids_spacing_3x) / -2)!important}.js-no-flexbox-gap .ids-tracker-item>*,.js-no-flexbox-gap :host.ids-tracker-item>*{padding:calc(var(--ids_spacing_3x) / 2)!important}.ids-tracker-item__content,:host.ids-tracker-item__content{all:unset;all:revert;box-sizing:border-box;align-items:flex-start;display:flex;flex-direction:column;padding:0 var(--ids_spacing_2x)}.ids-tracker-item__content .ids-subtitle+*,:host.ids-tracker-item__content .ids-subtitle+*{margin-top:var(--ids_size_general_8x)}.ids-tracker-item__content .ids-contextual-button,:host.ids-tracker-item__content .ids-contextual-button{margin-bottom:var(--ids_size_general_8x);margin-top:var(--ids_size_general_16x)}.ids-tracker-item:last-child .ids-tracker-bar__line,:host.ids-tracker-item:last-child .ids-tracker-bar__line{display:none}@media (min-width: 48rem){.ids-tracker-item:not(.ids-tracker-item--vertical),:host.ids-tracker-item:not(.ids-tracker-item--vertical){gap:var(--ids_spacing_2x);flex-direction:column}.js-no-flexbox-gap .ids-tracker-item:not(.ids-tracker-item--vertical),.js-no-flexbox-gap :host.ids-tracker-item:not(.ids-tracker-item--vertical){margin:calc(var(--ids_spacing_2x) / -2)!important}.js-no-flexbox-gap .ids-tracker-item:not(.ids-tracker-item--vertical)>*,.js-no-flexbox-gap :host.ids-tracker-item:not(.ids-tracker-item--vertical)>*{padding:calc(var(--ids_spacing_2x) / 2)!important}.ids-tracker-item:not(.ids-tracker-item--vertical) .ids-tracker-bar,:host.ids-tracker-item:not(.ids-tracker-item--vertical) .ids-tracker-bar{gap:var(--ids_spacing_2x);flex-direction:row}.js-no-flexbox-gap .ids-tracker-item:not(.ids-tracker-item--vertical) .ids-tracker-bar,.js-no-flexbox-gap :host.ids-tracker-item:not(.ids-tracker-item--vertical) .ids-tracker-bar{margin:calc(var(--ids_spacing_2x) / -2)!important}.js-no-flexbox-gap .ids-tracker-item:not(.ids-tracker-item--vertical) .ids-tracker-bar>*,.js-no-flexbox-gap :host.ids-tracker-item:not(.ids-tracker-item--vertical) .ids-tracker-bar>*{margin:calc(var(--ids_spacing_2x) / 2)!important}}\n"] }]
        }], ctorParameters: function () { return [{ type: IdsTrackerService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { trackerItem: [{
                type: ViewChild,
                args: ['trackerItem', { static: true }]
            }], title: [{
                type: Input
            }], subtitle: [{
                type: Input
            }], icon: [{
                type: Input
            }], status: [{
                type: Input
            }], type: [{
                type: Input
            }], orientation: [{
                type: Input
            }], statusText: [{
                type: Input
            }], classes: [{
                type: HostBinding,
                args: ['class']
            }] } });

/**
 * Componente de Diretiva do Tracker
 *
 * **Module:**
 *
 * `import { IdsTrackerModule } from '@ids/angular';`
 *
 * **Component:**
 *
 * `import { IdsTrackerDirective, IdsTrackerItemComponent } from '@ids/angular';
 */
class IdsTrackerDirective {
    get classes() {
        return {
            'ids-tracker': true,
            [`ids-tracker--${this.orientation}`]: this.orientation,
        };
    }
    /**
     * Orientação dos itens. Quando não enviado, assume a orientação padrão (horizontal em Desk e vertical em Mobile)
     */
    get orientation() {
        return this._orientation;
    }
    set orientation(orientation) {
        this.trackerService.orientationSubject.next(orientation);
        this._orientation = orientation;
    }
    /**
     * Tipo de indicador. Quando não informado assume a exibição padrão (circle)
     */
    get type() {
        return this._type;
    }
    set type(type) {
        this.trackerService.typeSubject.next(type);
        this._type = type;
    }
    /**
     * Define se mostrará a descrição do status do item
     */
    set showStatusText(showStatusText) {
        this._showStatusText = enforceBoolean(showStatusText);
        this.trackerService.showStatusTextSubject = this._showStatusText;
    }
    get showStatusText() {
        return this._showStatusText;
    }
    set idsTracker(type) {
        if (type) {
            this.type = type;
        }
    }
    constructor(trackerService) {
        this.trackerService = trackerService;
        this.role = 'list';
        this._showStatusText = true;
    }
}
IdsTrackerDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTrackerDirective, deps: [{ token: IdsTrackerService, optional: true }], target: i0.ɵɵFactoryTarget.Directive });
IdsTrackerDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsTrackerDirective, isStandalone: true, selector: "[idsTracker]", inputs: { orientation: "orientation", type: "type", showStatusText: "showStatusText", idsTracker: "idsTracker" }, host: { properties: { "class": "this.classes", "attr.role": "this.role" } }, providers: [IdsTrackerService], ngImport: i0 });
__decorate([
    Memo(['orientation']),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], IdsTrackerDirective.prototype, "classes", null);
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], IdsTrackerDirective.prototype, "showStatusText", null);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTrackerDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsTracker]',
                    standalone: true,
                    providers: [IdsTrackerService],
                }]
        }], ctorParameters: function () { return [{ type: IdsTrackerService, decorators: [{
                    type: Optional
                }] }]; }, propDecorators: { classes: [{
                type: HostBinding,
                args: ['class']
            }], role: [{
                type: HostBinding,
                args: ['attr.role']
            }], orientation: [{
                type: Input
            }], type: [{
                type: Input
            }], showStatusText: [{
                type: Input
            }], idsTracker: [{
                type: Input
            }] } });
/**
 * O componente Progress Tracker exibe o progresso em uma sequência, dividindo-a em várias etapas lógicas, mostrando a quantidade e o status de cada estágio.
 *
 * **Module:**
 *
 * `import { IdsTrackerModule } from '@ids/angular';`
 *
 * **Component:**
 *
 * `import { IdsTrackerComponent, IdsTrackerItemComponent } from '@ids/angular';`
 */
class IdsTrackerComponent extends IdsTrackerDirective {
}
IdsTrackerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTrackerComponent, deps: null, target: i0.ɵɵFactoryTarget.Component });
IdsTrackerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsTrackerComponent, isStandalone: true, selector: "ids-tracker", host: { properties: { "attr.class": "null", "attr.role": "null" } }, providers: [IdsTrackerService], usesInheritance: true, ngImport: i0, template: `<ul [class]="classes" role="list">
    <ng-content></ng-content>
  </ul>`, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTrackerComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'ids-tracker',
                    standalone: true,
                    host: {
                        '[attr.class]': 'null',
                        '[attr.role]': 'null',
                    },
                    template: `<ul [class]="classes" role="list">
    <ng-content></ng-content>
  </ul>`,
                    providers: [IdsTrackerService],
                }]
        }] });

class IdsTrackerModule {
}
IdsTrackerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTrackerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsTrackerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsTrackerModule, imports: [IdsTrackerComponent, IdsTrackerDirective, IdsTrackerItemComponent], exports: [IdsTrackerComponent, IdsTrackerDirective, IdsTrackerItemComponent] });
IdsTrackerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTrackerModule, imports: [IdsTrackerComponent, IdsTrackerItemComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTrackerModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsTrackerComponent, IdsTrackerDirective, IdsTrackerItemComponent],
                    exports: [IdsTrackerComponent, IdsTrackerDirective, IdsTrackerItemComponent],
                }]
        }] });

let NEXT_ID = 0;
/**
 * Tooltip é um componente de interface que permite a pessoa usuária expandir um pop-up com pequenas informações complementares
 *
 * **Module:**
 *
 * `import { IdsTooltipModule, IdsIconButtonModule } from '@ids/angular';`
 *
 * **Component:**
 *
 * `import { IdsTooltipComponent } from '@ids/angular;`
 */
class IdsTooltipComponent {
    constructor() {
        this.verticalMargin = 0;
        this.id = `ids-tooltip-${NEXT_ID++}`;
        /**
         * Input que recebe o tipo de tooltip a ser exibido
         */
        this.type = 'information';
        /**
         * Input que recebe o texto que vai aparecer dentro do tooltip
         */
        this.text = '';
        /**
         * input que recebe a posição qu o tooltip irá aparecer
         * em relação ao elemento que ele se relaciona, com os valores 'top','bottom','left' e 'right'
         */
        this.position = 'top';
        /**
         * recebe a posição que a seta vai ficar no tooltip sendo os valores 'start', 'middle' e 'end'
         */
        this.align = 'middle';
    }
    get classes() {
        return {
            'ids-tooltip': true,
            [`ids-tooltip--${this.position}`]: this.position !== 'top',
            [`ids-tooltip--${this.align}`]: this.align !== 'middle',
            [`ids-tooltip--${this.type}`]: this.type !== 'information',
            'ids-tooltip--show-arrow': this.showArrow,
        };
    }
    onResize() {
        this.resizeControl();
    }
    get styles() {
        if (!this.verticalMargin) {
            return {};
        }
        return {
            transform: 'translateY(-' + this.verticalMargin + 'px)',
        };
    }
    ngOnInit() {
        this.resizeControl();
    }
    resizeControl() {
        if (this.position === 'bottom' ||
            ((this.position === 'left' || this.position === 'right') && this.align !== 'end')) {
            return;
        }
        this.verticalMargin = window.innerHeight - document.documentElement.clientHeight;
    }
}
IdsTooltipComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTooltipComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IdsTooltipComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "15.2.10", type: IdsTooltipComponent, isStandalone: true, selector: "ids-tooltip", inputs: { type: "type", text: "text", icon: "icon", position: "position", align: "align", showArrow: "showArrow" }, host: { listeners: { "window:resize": "onResize()" } }, ngImport: i0, template: "<div role=\"tooltip\" [class]=\"classes\" [id]=\"id\" [ngStyle]=\"styles\">\n  <div class=\"ids-tooltip__text\">\n    <ids-icon class=\"ids-tooltip__icon\" *ngIf=\"icon\">\n      {{ icon }}\n    </ids-icon>\n\n    {{ text }}\n    <ng-content></ng-content>\n  </div>\n</div>\n", styles: [".ids-overlay-tooltip{z-index:0}.ids-tooltip{align-items:center;color:var(--ids_color_contrast_onDark);display:flex;flex-direction:column-reverse;justify-content:center;text-align:left}.ids-tooltip .ids-icon{color:inherit;margin-right:.9375rem}.ids-tooltip__text{align-items:center;background-color:var(--ids_color_feedback_information);border-radius:var(--ids_size_cornerRadius_tooltip);display:flex;font:var(--ids_textStyle_f02_s14_h20_wrg);line-height:1.09375rem;max-width:13.25rem;padding:var(--ids_size_general_12x)}@media (min-width: 64rem){.ids-tooltip__text{max-width:19rem}}.ids-tooltip:before{border:var(--ids_size_general_4x) solid transparent;border-top-color:var(--ids_color_feedback_information);content:\"\";margin:0 var(--ids_size_general_5x);opacity:0}.ids-tooltip--arrow:before{border-width:var(--ids_size_general_8x);opacity:1}.ids-tooltip--description .ids-tooltip__text{background-color:var(--ids_color_feedback_neutral);color:var(--ids_color_contrast_onDark)}.ids-tooltip--description:before{border-top-color:var(--ids_color_feedback_neutral)}.ids-tooltip--bottom{flex-direction:column}.ids-tooltip--bottom:before{border-color:transparent;border-bottom-color:var(--ids_color_feedback_information)}.ids-tooltip--left{flex-direction:row-reverse}.ids-tooltip--left:before{border-color:transparent;border-left-color:var(--ids_color_feedback_information);margin:var(--ids_size_general_5x) 0}.ids-tooltip--right{flex-direction:row}.ids-tooltip--right:before{border-color:transparent;border-right-color:var(--ids_color_feedback_information);margin:var(--ids_size_general_5x) 0}.ids-tooltip--right.ids-tooltip--description:before{border-right-color:var(--ids_color_feedback_neutral)}.ids-tooltip--bottom.ids-tooltip--description:before{border-bottom-color:var(--ids_color_feedback_neutral)}.ids-tooltip--left.ids-tooltip--description:before{border-left-color:var(--ids_color_feedback_neutral)}.ids-tooltip--start{align-items:flex-start;justify-content:flex-start}.ids-tooltip--end{align-items:flex-end;justify-content:flex-end}.ids-tooltip--left,.ids-tooltip--right{justify-content:initial}\n"], dependencies: [{ kind: "ngmodule", type: CommonModule }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { kind: "ngmodule", type: OverlayModule }, { kind: "ngmodule", type: IdsIconModule }, { kind: "component", type: IdsIconComponent, selector: "ids-icon", inputs: ["size", "variant", "contrast"] }] });
__decorate([
    EnforceBoolean(),
    __metadata("design:type", Object)
], IdsTooltipComponent.prototype, "showArrow", void 0);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTooltipComponent, decorators: [{
            type: Component,
            args: [{ selector: 'ids-tooltip', standalone: true, imports: [CommonModule, OverlayModule, IdsIconModule], template: "<div role=\"tooltip\" [class]=\"classes\" [id]=\"id\" [ngStyle]=\"styles\">\n  <div class=\"ids-tooltip__text\">\n    <ids-icon class=\"ids-tooltip__icon\" *ngIf=\"icon\">\n      {{ icon }}\n    </ids-icon>\n\n    {{ text }}\n    <ng-content></ng-content>\n  </div>\n</div>\n", styles: [".ids-overlay-tooltip{z-index:0}.ids-tooltip{align-items:center;color:var(--ids_color_contrast_onDark);display:flex;flex-direction:column-reverse;justify-content:center;text-align:left}.ids-tooltip .ids-icon{color:inherit;margin-right:.9375rem}.ids-tooltip__text{align-items:center;background-color:var(--ids_color_feedback_information);border-radius:var(--ids_size_cornerRadius_tooltip);display:flex;font:var(--ids_textStyle_f02_s14_h20_wrg);line-height:1.09375rem;max-width:13.25rem;padding:var(--ids_size_general_12x)}@media (min-width: 64rem){.ids-tooltip__text{max-width:19rem}}.ids-tooltip:before{border:var(--ids_size_general_4x) solid transparent;border-top-color:var(--ids_color_feedback_information);content:\"\";margin:0 var(--ids_size_general_5x);opacity:0}.ids-tooltip--arrow:before{border-width:var(--ids_size_general_8x);opacity:1}.ids-tooltip--description .ids-tooltip__text{background-color:var(--ids_color_feedback_neutral);color:var(--ids_color_contrast_onDark)}.ids-tooltip--description:before{border-top-color:var(--ids_color_feedback_neutral)}.ids-tooltip--bottom{flex-direction:column}.ids-tooltip--bottom:before{border-color:transparent;border-bottom-color:var(--ids_color_feedback_information)}.ids-tooltip--left{flex-direction:row-reverse}.ids-tooltip--left:before{border-color:transparent;border-left-color:var(--ids_color_feedback_information);margin:var(--ids_size_general_5x) 0}.ids-tooltip--right{flex-direction:row}.ids-tooltip--right:before{border-color:transparent;border-right-color:var(--ids_color_feedback_information);margin:var(--ids_size_general_5x) 0}.ids-tooltip--right.ids-tooltip--description:before{border-right-color:var(--ids_color_feedback_neutral)}.ids-tooltip--bottom.ids-tooltip--description:before{border-bottom-color:var(--ids_color_feedback_neutral)}.ids-tooltip--left.ids-tooltip--description:before{border-left-color:var(--ids_color_feedback_neutral)}.ids-tooltip--start{align-items:flex-start;justify-content:flex-start}.ids-tooltip--end{align-items:flex-end;justify-content:flex-end}.ids-tooltip--left,.ids-tooltip--right{justify-content:initial}\n"] }]
        }], propDecorators: { type: [{
                type: Input
            }], text: [{
                type: Input
            }], icon: [{
                type: Input
            }], position: [{
                type: Input
            }], align: [{
                type: Input
            }], showArrow: [{
                type: Input
            }], onResize: [{
                type: HostListener,
                args: ['window:resize']
            }] } });

/**
 * Tooltip é um componente de interface que permite ao usuário expandir um pop-up com pequenas informações complementares
 *
 * **Module:**
 *
 * `import { IdsTooltipModule, IdsIconButtonModule } from '@ids/angular';`
 *
 * **Diretiva:**
 *
 * `import { IdsTooltipDirective } from '@ids/angular;`
 */
class IdsTooltipDirective {
    constructor(overlayPositionBuilder, _scrollDispatcher, elementRef, renderer, overlay, la, _ngZone) {
        this.overlayPositionBuilder = overlayPositionBuilder;
        this._scrollDispatcher = _scrollDispatcher;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.overlay = overlay;
        this.la = la;
        this._ngZone = _ngZone;
        this._showArrow = false;
        this.showing = false;
        this.positionsToolTip = {
            top: {
                originY: 'top',
                overlayY: 'bottom',
            },
            bottom: {
                originY: 'bottom',
                overlayY: 'top',
            },
            left: {
                originX: 'start',
                overlayX: 'end',
            },
            right: {
                originX: 'end',
                overlayX: 'start',
            },
        };
        this.positionsArrow = {
            start: {
                originX: 'start',
                overlayX: 'start',
                originY: 'top',
                overlayY: 'top',
            },
            middle: {
                originX: 'center',
                overlayX: 'center',
                originY: 'center',
                overlayY: 'center',
            },
            end: {
                originX: 'end',
                overlayX: 'end',
                originY: 'bottom',
                overlayY: 'bottom',
            },
        };
        /**
         * Input que recebe o texto que irá aparecer dentro do tooltip.
         */
        this.content = '';
        this._type = 'information';
        /**
         * recebe a posição que o tooltip irá aparecer
         * em relação ao elemento que ele se relaciona, com os valores 'top','bottom','left' e 'right'.
         */
        this.position = 'top';
        /**
         * recebe a posição que a seta vai ficar no tooltip sendo os valores 'start', 'middle' e 'end'.
         */
        this.align = 'middle';
        /**
         * começa a leitura do component quando criado.
         */
        this.ariaLive = 'polite';
        /**
         * define como o tooltip se comporta com rolagem.
         */
        this.scrollStrategy = 'reposition';
        this.click = () => (this.showing ? this.hide() : this.show());
    }
    /**
     * input que recebe a maneira como o tooltip vai funcionar, 'description'
     * para exibir ao receber foco e 'information', para exibir ao clicar.
     */
    set type(type) {
        if (type) {
            this._type = type;
        }
    }
    get type() {
        return this._type || 'information';
    }
    /**
     * Define se a seta (tooltipArrow) está visível.
     */
    set showArrow(value) {
        this._showArrow = enforceBoolean(value);
    }
    get showArrow() {
        return this._showArrow;
    }
    /**
     * recebe o texto personalizado para aria label.
     */
    set ariaLabel(ariaLabel) {
        this._ariaLabel = ariaLabel;
    }
    get ariaLabel() {
        return this.type === 'description' && !this._ariaLabel ? this.content : this._ariaLabel;
    }
    set title(value) {
        this.content = value;
        this.type = 'description';
    }
    mouseenter() {
        if (this.type === 'description' && !platform.isMobile) {
            this.show();
        }
    }
    onResize() {
        if (this.showing && this.a11yToolTip) {
            this.setPositionTooltipA11y(this.a11yToolTip);
        }
    }
    focus() {
        if (!platform.isMobile && this.type === 'description') {
            this.show();
        }
    }
    bindTooltipMouseLeave() {
        this.mouseLeaveSubscription = fromEvent(this.overlayRef.overlayElement, 'mouseleave').subscribe(this.hide.bind(this));
    }
    mouseleave(event) {
        if (this.type !== 'description' || platform.isMobile) {
            return;
        }
        if (event.relatedTarget?.className.includes('ids-tooltip')) {
            this.bindTooltipMouseLeave();
            return;
        }
        this.hide();
    }
    blur() {
        if (!platform.isMobile && this.type === 'description') {
            this.hide();
        }
    }
    ngOnInit() {
        if (this.type === 'information') {
            this.controlAriaExpanded = false;
        }
    }
    subscribeDomClick() {
        this.documentClickSubscription = fromEvent(document, 'click').subscribe((event) => {
            const target = event.target;
            const clickedOnTooltip = target.className?.includes?.('ids-tooltip');
            const clickedOnOpenButton = event.composedPath().includes(this.elementRef.nativeElement);
            /* istanbul ignore next */
            if (clickedOnTooltip || clickedOnOpenButton) {
                return;
            }
            this.hide();
        });
    }
    subscribeKeyPress() {
        this.keyPressSubscription = fromEvent(document, 'keydown').subscribe((event) => {
            const keyClick = event;
            const escPressed = keyClick.code === 'Escape';
            if (this.showing && escPressed) {
                this.hide();
            }
        });
    }
    announce() {
        if (this.type !== 'information') {
            return;
        }
        this.controlAriaExpanded = true;
        this.la.announce(this.content, 1000);
        this.createA11yToolTip();
    }
    /**
     * nessa função é criada uma instância do componente tooltip e passada para o componente
     * os valores que são recebidos nessa diretiva
     *
     * In this function an instance of the tooltip component is created and passed to the component
     * the values that are received in this directive
     */
    show() {
        if (this.showing) {
            return;
        }
        this.createToolTip();
        this.showing = true;
        this.subscribeKeyPress();
        this.subscribeDomClick();
        this.announce();
        if (!this.zIndex) {
            this.zIndex = getElevation();
        }
    }
    unsubscribeAll() {
        if (this.mouseLeaveSubscription) {
            this.mouseLeaveSubscription.unsubscribe();
        }
        if (this.keyPressSubscription) {
            this.keyPressSubscription.unsubscribe();
        }
        if (this.documentClickSubscription) {
            this.documentClickSubscription.unsubscribe();
        }
    }
    removeClickTooltip() {
        if (this.type === 'information') {
            this.controlAriaExpanded = false;
            this.removeA11Y();
        }
    }
    hide() {
        if (!this.showing) {
            return;
        }
        if (this?.overlayRef?.detach) {
            this.overlayRef.detach();
        }
        this.showing = false;
        this.unsubscribeAll();
        this.removeClickTooltip();
    }
    removeA11Y() {
        this.a11yToolTip?.remove?.();
        this.a11yToolTip?.parentNode?.removeChild?.(this.a11yToolTip);
    }
    /**
     * Registra o scroll do elemento pai. Útil quando a rolagem não é no corpo da página
     * e o elemento com rolagem não faz parte do projeto que possui o tooltip.
     */
    registerParentScroll() {
        const scrollingParent = getScrollingParent(this.elementRef.nativeElement);
        if (scrollingParent) {
            this._scrollDispatcher.register(new CdkScrollable(new ElementRef(scrollingParent), this._scrollDispatcher, this._ngZone));
        }
    }
    createToolTip() {
        const scrollStrategy = this.overlay.scrollStrategies[this.scrollStrategy]();
        const positionStrategy = this.overlayPositionBuilder
            .flexibleConnectedTo(this.elementRef)
            .withPositions([this.positions]);
        const setLowerZIndex = document.querySelectorAll('.cdk-overlay-pane').length === 0;
        this.registerParentScroll();
        this.overlayRef = this.overlay.create({ positionStrategy, scrollStrategy });
        const tooltipRef = this.overlayRef.attach(new ComponentPortal(IdsTooltipComponent));
        tooltipRef.instance.text = this.content;
        tooltipRef.instance.type = this.type;
        tooltipRef.instance.position = this.position;
        tooltipRef.instance.align = this.align;
        tooltipRef.instance.showArrow = this.showArrow;
        tooltipRef.instance.icon = this.icon;
        const panel = this.overlayRef.overlayElement;
        if (setLowerZIndex) {
            this.renderer.setStyle(panel, 'z-index', this.zIndex);
        }
        panel.classList.add('ids-overlay-tooltip');
        panel.setAttribute('aria-hidden', 'true');
        this.overlayRef.detachments().subscribe(() => {
            if (setLowerZIndex) {
                this.renderer.removeStyle(panel, 'z-index');
            }
            panel.removeAttribute('aria-hidden');
            this.hide();
        });
    }
    /**
     * recebe a posição passada pelo usuário e passa os valores necessários para colocar o tooltip na posição desejada
     *
     * receives the position passed by the user and passes the necessary values to place the tooltip in the desired position
     */
    get positions() {
        return {
            ...this.positionsArrow[this.align],
            ...this.positionsToolTip[this.position],
        };
    }
    createA11yToolTip() {
        this.a11yToolTip = document.createElement('div');
        this.a11yToolTip.classList.add('ids-sr-only', 'ids-tooltip__text');
        this.a11yToolTip.setAttribute('role', 'tooltip');
        this.a11yToolTip.textContent = this.content;
        const tooltipA11y = this.elementRef.nativeElement.insertAdjacentElement('afterend', this.a11yToolTip);
        setTimeout(() => this.setPositionTooltipA11y(tooltipA11y));
        this._scrollDispatcher.scrolled(0).subscribe(() => this.setPositionTooltipA11y(tooltipA11y));
    }
    setPositionTooltipA11y(tooltip) {
        Promise.resolve().then(() => {
            const { top, right, bottom, left, height, width } = this.overlayRef.overlayElement.getBoundingClientRect();
            const difference = {
                x: this.position === 'right' ? 10 : 0,
                y: this.position === 'bottom' ? 10 : 0,
                width: this.position === 'left' || this.position === 'right' ? -10 : 0,
                height: this.position === 'top' || this.position === 'bottom' ? -10 : 0,
            };
            if (this.icon) {
                difference.x += 24;
                difference.width -= 24;
            }
            this.renderer.setStyle(tooltip, 'top', top + difference.y + 'px');
            this.renderer.setStyle(tooltip, 'right', right + difference.x + 'px');
            this.renderer.setStyle(tooltip, 'bottom', bottom + difference.y + 'px');
            this.renderer.setStyle(tooltip, 'left', left + difference.x + 'px');
            this.renderer.setStyle(tooltip, 'height', height + difference.height + 'px');
            this.renderer.setStyle(tooltip, 'width', width + difference.width + 'px');
        });
    }
}
IdsTooltipDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTooltipDirective, deps: [{ token: i1$3.OverlayPositionBuilder }, { token: i1$3.ScrollDispatcher }, { token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i1$3.Overlay }, { token: i1$1.LiveAnnouncer }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Directive });
IdsTooltipDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsTooltipDirective, isStandalone: true, selector: "[idsTooltip], [idsIconButton][title]", inputs: { content: "content", type: ["idsTooltip", "type"], icon: "icon", position: "position", align: "align", showArrow: "showArrow", ariaLive: ["aria-live", "ariaLive"], ariaLabel: ["aria-label", "ariaLabel"], scrollStrategy: "scrollStrategy", zIndex: "zIndex", title: "title" }, host: { listeners: { "mouseenter": "mouseenter()", "window:resize": "onResize()", "focus": "focus()", "click": "click()", "mouseleave": "mouseleave($event)", "blur": "blur()" }, properties: { "attr.title": "null", "attr.aria-label": "this.ariaLabel", "attr.aria-expanded": "this.controlAriaExpanded" } }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTooltipDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsTooltip], [idsIconButton][title]',
                    standalone: true,
                    host: {
                        '[attr.title]': 'null',
                    },
                }]
        }], ctorParameters: function () { return [{ type: i1$3.OverlayPositionBuilder }, { type: i1$3.ScrollDispatcher }, { type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i1$3.Overlay }, { type: i1$1.LiveAnnouncer }, { type: i0.NgZone }]; }, propDecorators: { content: [{
                type: Input
            }], type: [{
                type: Input,
                args: ['idsTooltip']
            }], icon: [{
                type: Input
            }], position: [{
                type: Input
            }], align: [{
                type: Input
            }], showArrow: [{
                type: Input
            }], ariaLive: [{
                type: Input,
                args: ['aria-live']
            }], ariaLabel: [{
                type: Input,
                args: ['aria-label']
            }, {
                type: HostBinding,
                args: ['attr.aria-label']
            }], scrollStrategy: [{
                type: Input
            }], zIndex: [{
                type: Input
            }], title: [{
                type: Input
            }], controlAriaExpanded: [{
                type: HostBinding,
                args: ['attr.aria-expanded']
            }], mouseenter: [{
                type: HostListener,
                args: ['mouseenter']
            }], onResize: [{
                type: HostListener,
                args: ['window:resize']
            }], focus: [{
                type: HostListener,
                args: ['focus']
            }], click: [{
                type: HostListener,
                args: ['click']
            }], mouseleave: [{
                type: HostListener,
                args: ['mouseleave', ['$event']]
            }], blur: [{
                type: HostListener,
                args: ['blur']
            }] } });

class IdsTooltipModule {
}
IdsTooltipModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTooltipModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsTooltipModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsTooltipModule, imports: [IdsTooltipDirective, IdsTooltipComponent], exports: [IdsTooltipDirective, IdsTooltipComponent] });
IdsTooltipModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTooltipModule, imports: [IdsTooltipComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsTooltipModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsTooltipDirective, IdsTooltipComponent],
                    exports: [IdsTooltipDirective, IdsTooltipComponent],
                }]
        }] });

class IdsCreditCardBrandModule {
}
IdsCreditCardBrandModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsCreditCardBrandModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsCreditCardBrandModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsCreditCardBrandModule, imports: [IdsCreditCardBrandComponent], exports: [IdsCreditCardBrandComponent] });
IdsCreditCardBrandModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsCreditCardBrandModule, imports: [IdsCreditCardBrandComponent] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsCreditCardBrandModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsCreditCardBrandComponent],
                    exports: [IdsCreditCardBrandComponent],
                }]
        }] });

/** @deprecated Módulo depreciado, importe diretamente o validador idsRequiredValidators
 *
 * import { idsRequiredValidators } from '@ids/angular'
 */
class RequiredValidatorModule {
}
RequiredValidatorModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: RequiredValidatorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
RequiredValidatorModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: RequiredValidatorModule });
RequiredValidatorModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: RequiredValidatorModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: RequiredValidatorModule, decorators: [{
            type: NgModule,
            args: [{}]
        }] });

/**
 * Cria um validador que verifica se o valor do controle está dentro de uma lista de valores permitidos.
 *
 * @param {string[]} allowedValues - Uma lista de strings representando os valores permitidos.
 * @returns {ValidatorFn} Uma função validadora que pode ser usada com controles Angular Forms.
 * Quando o valor do controle está na lista `allowedValues`, a validação passa e retorna `null`.
 * Caso contrário, retorna um objeto de erro `{ idsListOfValues: true }`.
 *
 * @example
 * // Exemplo de uso em um campo de formulário:
 * this.formBuilder.group({
 *   userId: ['', [idsListOfValuesValidator(['123', '456', '789'])]]
 * });
 */
const idsListOfValuesValidator = (valuesOrProvider) => (control) => {
    // Garante que valuesOrProvider seja sempre tratado como uma função
    const getValues = typeof valuesOrProvider === 'function' ? valuesOrProvider : () => valuesOrProvider;
    const allowedValues = getValues();
    return control.value === '' || allowedValues.includes(control.value)
        ? null
        : { idsListOfValues: true };
};

const noWhitespaceValidator = (control) => (control.value || '').trim().length ? null : { whitespace: true };
/**
 * Validação de formulário reativo que verifica se o campo está preenchido,
 * mas não permite que sejam apenas espaços em branco.
 */
const idsRequiredValidators = [Validators.required, noWhitespaceValidator];

/**
 * Diretiva para formulário.
 *
 * - Foca no primeiro campo inválido ao submeter o formulário.
 * - Altera o estado do ariaLive de acordo com o foco no elemento com erro para plataforma mobile
 *
 * Requisitos:
 *
 * - Aplicar a diretiva idsForm no formulário
 * - Utilizar campos de formulário com o componente formField
 *
 * **Module:**
 *
 * `import { IdsFormModule } from '@ids/angular';`
 *
 *  **Service:**
 *
 * `import { IdsFormDirective } from '@ids/angular';`
 *
 * @example
 * <form [formGroup]="exampleForm" idsForm (ngSubmit)="onGroupSubmit()">
 *   <button idsMainButton type="submit">
 *    salvar
 *  </button>
 * </form>
 *
 */
class IdsFormDirective {
    constructor(_elementRef, _cdf) {
        this._elementRef = _elementRef;
        this._cdf = _cdf;
        this._platform = platform;
        /**
         * Formulário em uso
         */
        this.formElement = this._elementRef.nativeElement;
    }
    ngAfterContentInit() {
        if (this.formFieldList.length > 0 && this._platform.isMobile) {
            this.setupFocusListenersFields();
        }
    }
    onSubmit() {
        this._cdf.detectChanges();
        this.firstInvalidControl?.field.focus();
    }
    get firstInvalidControl() {
        return this.formFieldList.find(({ field }) => field.invalid === true);
    }
    // Alterna o estado do ariaLive em plataforma mobile de acordo com o foco no elemento com erro.
    changeAriaLiveInFocus(formFieldFocus) {
        this.formFieldList.forEach((formField) => {
            formField.formMessage.observer.disconnect();
            formField.formMessage.ariaLive = 'off';
        });
        formFieldFocus.formMessage.ariaLive = 'polite';
    }
    setupFocusListenersFields() {
        this.formFieldList.forEach((formField) => {
            fromEvent(formField.field?.nativeElement, 'focus').subscribe(() => {
                this.changeAriaLiveInFocus(formField);
            });
        });
    }
}
IdsFormDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormDirective, deps: [{ token: i0.ElementRef }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Directive });
IdsFormDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsFormDirective, isStandalone: true, selector: "[idsForm]", host: { listeners: { "submit": "onSubmit()", "focus": "changeAriaLiveInFocus()" } }, queries: [{ propertyName: "formFieldList", predicate: IdsFormFieldComponent, descendants: true }], ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsForm]',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { formFieldList: [{
                type: ContentChildren,
                args: [IdsFormFieldComponent, { descendants: true }]
            }], onSubmit: [{
                type: HostListener,
                args: ['submit']
            }], changeAriaLiveInFocus: [{
                type: HostListener,
                args: ['focus']
            }] } });

class IdsFormModule {
}
IdsFormModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsFormModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsFormModule, imports: [IdsFormDirective], exports: [IdsFormDirective] });
IdsFormModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsFormModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsFormDirective],
                    exports: [IdsFormDirective],
                }]
        }] });

class IdsMotionPreferenceDirective {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.idsMotionPreference = 'animated';
    }
    ngOnChanges(changes) {
        if (changes.idsMotionPreference) {
            if (this.idsMotionPreference === 'none') {
                this.elementRef.nativeElement.classList.add('ids-motion-none');
                return;
            }
            this.elementRef.nativeElement.classList.remove('ids-motion-none');
        }
    }
}
IdsMotionPreferenceDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMotionPreferenceDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
IdsMotionPreferenceDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "15.2.10", type: IdsMotionPreferenceDirective, isStandalone: true, selector: "[idsMotionPreference]", inputs: { idsMotionPreference: "idsMotionPreference" }, usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMotionPreferenceDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[idsMotionPreference]',
                    standalone: true,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { idsMotionPreference: [{
                type: Input
            }] } });

class IdsMotionPreferenceModule {
}
IdsMotionPreferenceModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMotionPreferenceModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsMotionPreferenceModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsMotionPreferenceModule, imports: [IdsMotionPreferenceDirective], exports: [IdsMotionPreferenceDirective] });
IdsMotionPreferenceModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMotionPreferenceModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMotionPreferenceModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsMotionPreferenceDirective],
                    exports: [IdsMotionPreferenceDirective],
                }]
        }] });

class IdsAutoFocusModule {
}
IdsAutoFocusModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAutoFocusModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsAutoFocusModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsAutoFocusModule, imports: [IdsAutoFocusDirective], exports: [IdsAutoFocusDirective] });
IdsAutoFocusModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAutoFocusModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAutoFocusModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsAutoFocusDirective],
                    exports: [IdsAutoFocusDirective],
                }]
        }] });

class IdsAspectRatioModule {
}
IdsAspectRatioModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAspectRatioModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsAspectRatioModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsAspectRatioModule, imports: [IdsAspectRatioDirective], exports: [IdsAspectRatioDirective] });
IdsAspectRatioModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAspectRatioModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsAspectRatioModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [IdsAspectRatioDirective],
                    exports: [IdsAspectRatioDirective],
                }]
        }] });

/**
 * @internal
 * Token de Injeção de Dependência que contêm o valor do {@link SegmentValueTypes} padrão.
 */
const SegmentTypeDefault = new InjectionToken('SegmentTypeDefault');
/**
 * @internal
 * Token de Injeção de Dependência que permite configuração opcional do valor do {@link SegmentValueTypes} SegmentTypeDefault.
 */
const SegmentTypeConfig = new InjectionToken('SegmentTypeConfig');
/**
 * @internal
 * Token de Injeção de Dependência que contêm o valor do {@link element} padrão.
 */
const ElementToApplySegmentDefault = new InjectionToken('ElementToApplySegmentDefault');
/**
 * @internal
 * Token de Injeção de Dependência que permite configuração opcional do valor do {@link Element} ElementToApplySegmentDefault.
 */
const ElementToApplySegmentConfig = new InjectionToken('ElementToApplySegmentConfig');
/**
 * @internal
 * Token de Injeção de Dependência que permite configuração opcional do valor do {@link SegmentColorModes}.
 */
const SegmentColorModeConfig = new InjectionToken('SegmentColorModeConfig');
/**
 * @internal
 * Token de Injeção de Dependência que permite configuração do valor opcional do enableOverlayOnShadowRoot.
 */
const OverlayOnShadowRootConfig = new InjectionToken('OverlayOnShadowRootConfig');
/**
 * @internal
 * Factory function para criar o valor do SegmentTypeDefault
 */
const segmentTypeDefaultFactory = (segment) => segment || Segments.Varejo;
/**
 * @internal
 * Factory function para criar o valor do elemento
 */
const elementToApplySegmentDefaultFactory = (elementToApplySegment) => elementToApplySegment || document;
/**
 * @internal
 * Provider do valor do SegmentTypeDefault
 */
const SegmentTypeDefaultProvider = {
    provide: SegmentTypeDefault,
    useFactory: segmentTypeDefaultFactory,
    deps: [[new Optional(), SegmentTypeConfig]],
};
/**
 * @internal
 * Provider para o elemento a ser aplicado o estilo
 */
const ElementToApplySegmentDefaultProvider = {
    provide: ElementToApplySegmentDefault,
    useFactory: elementToApplySegmentDefaultFactory,
    deps: [[new Optional(), ElementToApplySegmentConfig]],
};

class IdsOverlayContainer extends OverlayContainer {
    constructor(document, platform, elementToApplySegment, overlayOnShadowRoot) {
        super(document, platform);
        this.elementToApplySegment = elementToApplySegment;
        this.overlayOnShadowRoot = overlayOnShadowRoot;
        this._destroy = new Subject();
        Segment.pipe(takeUntil$1(this._destroy)).subscribe((value) => {
            this._segment = value;
            if (this._containerElement) {
                applySegmentToElement(Segments[value], this.getContainerElement(), getCurrentColorMode());
            }
        });
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this._destroy.next();
        this._destroy.complete();
    }
    _createContainer() {
        super._createContainer();
        const container = this.getContainerElement();
        if (this.elementToApplySegment && this.overlayOnShadowRoot) {
            const element = typeof this.elementToApplySegment === 'string'
                ? document.querySelector(this.elementToApplySegment)
                : this.elementToApplySegment;
            if (element && element.shadowRoot) {
                element.shadowRoot.append(container);
            }
        }
        applySegmentToElement(Segments[this._segment], container, getCurrentColorMode());
    }
}
IdsOverlayContainer.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsOverlayContainer, deps: [{ token: DOCUMENT }, { token: i1$4.Platform }, { token: ElementToApplySegmentDefault, optional: true }, { token: OverlayOnShadowRootConfig, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
IdsOverlayContainer.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsOverlayContainer, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsOverlayContainer, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i1$4.Platform }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [ElementToApplySegmentDefault]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [OverlayOnShadowRootConfig]
                }] }]; } });

/**
 * Centraliza os métodos de manipulação de estilos para ambientes MFE
 *
 * @deprecated Não disponibilizamos esse mais esse service, pois fica fora do escopo
 * do iDS e causou conflitos com as versões do Angular que damos suporte.
 *
 * **Module:**
 *
 * `import { IdsMfeStyleManagerModule } from '@ids/angular';`
 *
 *  **Service:**
 *
 * `import { IdsMfeStyleManagerService } from '@ids/angular';`
 *
 * @example
 * &#64;NgModule({ imports: [MfeStyleManagerModule] })
 * class AppModule {}
 *
 * class AppComponent implements OnInit, OnDestroy {
 *   constructor(private mfeStyle: MfeStyleManagerService) {}
 *
 *   ngOnInit() {
 *     this.mfeStyle.mountStyles();
 *   }
 *
 *   ngOnDestroy() {
 *     this.mfeStyle.unmountStyles();
 *   }
 * }
 */
class IdsMfeStyleManagerService extends ɵSharedStylesHost {
    constructor() {
        super(...arguments);
        this.styles = [];
    }
    /**
     * Remove todos os estilos adicionados pelo Angular no elemento 'head'
     */
    unmountStyles() {
        // eslint-disable-next-line dot-notation
        this.styles = [...this['getAllStyles']()];
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - necessário para Angular 14
        if (typeof this.ngOnDestroy === 'function') {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore - necessário para Angular 14
            this.ngOnDestroy();
        }
    }
    /**
     * Adiciona todos os estilos removidos pelo método unmountStyles ao elemento 'head'
     */
    mountStyles() {
        if (this.styles.length > 0) {
            this.addStyles(this.styles);
        }
    }
}
IdsMfeStyleManagerService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMfeStyleManagerService, deps: null, target: i0.ɵɵFactoryTarget.Injectable });
IdsMfeStyleManagerService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMfeStyleManagerService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMfeStyleManagerService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }] });

/**
 * @deprecated Não disponibilizamos mais esse módulo, pois fica fora do escopo
 * do iDS e causou conflitos com as versões do Angular que damos suporte.
 *
 * @internal
 */
class IdsMfeStyleManagerModule {
}
IdsMfeStyleManagerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMfeStyleManagerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsMfeStyleManagerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsMfeStyleManagerModule });
IdsMfeStyleManagerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMfeStyleManagerModule, providers: [{ provide: ɵSharedStylesHost, useExisting: IdsMfeStyleManagerService }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsMfeStyleManagerModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [{ provide: ɵSharedStylesHost, useExisting: IdsMfeStyleManagerService }],
                }]
        }] });

/**
 * O IdsSegmentService permite que altere o segmento após a aplicação já ter sido
 * iniciada com algum outro segmento pelo IdsConfigModule.
 *
 * **Module:**
 *
 * `import { IdsSegmentModule } from '@ids/angular';`
 *
 * **Service:**
 *
 * `import { IdsSegmentService } from '@ids/angular';`
 *
 * @example
 * import { IdsSegmentService } from '@ids/angular';
 * import { Segments } from '@ids/tools';
 *
 * @Component({})
 * class App {
 *   constructor(private _segment: IdsSegmentService) {}
 *
 *   ngOnInit() {
 *     this.idsSegmentService.changeSegment(Segments.Varejo);
 *   }
 * }
 */
class IdsSegmentService {
    constructor(defaultSegment, elementToApplySegment, colorMode) {
        this.defaultSegment = defaultSegment;
        this.elementToApplySegment = elementToApplySegment;
        this.colorMode = colorMode;
        /**
         * Observable de Segmento
         */
        this.segment = Segment;
        this.changeSegment(this.defaultSegment, this.elementToApplySegment, this.colorMode);
    }
    /**
     * Envia novo valor de Segmento para os subscribers e para o root
     *
     * @param value novo valor de Segmento
     * @param elementToApplySegment elemento para aplicar o segmento
     * @param colorMode Modo de cor do segmento
     * @returns void
     */
    changeSegment(value, element, colorMode) {
        changeSegment(value, element || this.elementToApplySegment, colorMode);
    }
}
IdsSegmentService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSegmentService, deps: [{ token: SegmentTypeDefault }, { token: ElementToApplySegmentDefault }, { token: SegmentColorModeConfig, optional: true }], target: i0.ɵɵFactoryTarget.Injectable });
IdsSegmentService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSegmentService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSegmentService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [SegmentTypeDefault]
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [ElementToApplySegmentDefault]
                }] }, { type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [SegmentColorModeConfig]
                }] }]; } });

class IdsSegmentModule {
}
IdsSegmentModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSegmentModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IdsSegmentModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsSegmentModule });
IdsSegmentModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSegmentModule, providers: [SegmentTypeDefaultProvider, ElementToApplySegmentDefaultProvider] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsSegmentModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [SegmentTypeDefaultProvider, ElementToApplySegmentDefaultProvider],
                }]
        }] });

/**
 * Módulo para configurações globais do Ids.
 * A importação desse módulo é obrigatória e deve ser feita no módulo raiz da aplicação, utilizando o método `.forRoot()`
 *
 * **Module:**
 *
 * `import { IdsConfigModule } from '@ids/angular';`
 *
 * @example
 * import { IdsConfigModule } from '@ids/angular';
 * import { Segments } from '@ids/tools';
 *
 * &#64;NgModule({
 *   imports: [
 *     IdsConfigModule.forRoot({
 *       production: environment.production,
 *       segment: Segments.Varejo,
 *       // para MFE é recomendado passar o elemento raiz do projeto
 *       elementToApplySegment: 'seletor-do-elemento-raiz-do-projeto'
 *     }),
 *   ],
 * })
 * class AppModule {}
 */
class IdsConfigModule {
    /**
     * Método estático para gerar as configurações de módulo conforme parâmetros recebidos
     *
     * @param config Configuração desejada para o projeto
     */
    static forRoot(config) {
        return {
            ngModule: IdsConfigModule,
            providers: [
                { provide: OverlayContainer, useExisting: IdsOverlayContainer },
                {
                    provide: SegmentTypeConfig,
                    useValue: config.segment,
                },
                {
                    provide: ElementToApplySegmentConfig,
                    useValue: config.elementToApplySegment,
                },
                {
                    provide: SegmentColorModeConfig,
                    useValue: config.colorMode,
                },
                {
                    provide: OverlayOnShadowRootConfig,
                    useValue: config.overlayOnShadowRoot,
                },
            ],
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-empty-function,  @typescript-eslint/no-unused-vars
    constructor(_idsSegmentService) { }
}
IdsConfigModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsConfigModule, deps: [{ token: IdsSegmentService }], target: i0.ɵɵFactoryTarget.NgModule });
IdsConfigModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: IdsConfigModule });
IdsConfigModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsConfigModule, providers: [SegmentTypeDefaultProvider, ElementToApplySegmentDefaultProvider] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: IdsConfigModule, decorators: [{
            type: NgModule,
            args: [{
                    providers: [SegmentTypeDefaultProvider, ElementToApplySegmentDefaultProvider],
                }]
        }], ctorParameters: function () { return [{ type: IdsSegmentService }]; } });

/*
 * Public API Surface of iDS Angular
 */
// Components

/**
 * Generated bundle index. Do not edit.
 */

export { CURRENCY_CONFIG, DATE_CONFIG, FormSelectionService, HelperTextModule, IdsAccordionComponent, IdsAccordionGroupComponent, IdsAccordionHeaderDirective, IdsAccordionIconDirective, IdsAccordionModule, IdsActionButtonComponent, IdsActionButtonModule, IdsAlertComponent, IdsAlertModule, IdsAspectRatioDirective, IdsAspectRatioModule, IdsAutoFocusDirective, IdsAutoFocusModule, IdsAutocompleteDirective, IdsAutocompleteModule, IdsAvatarComponent, IdsAvatarModule, IdsBannerHighlightComponent, IdsBannerHighlightModule, IdsBottomSheetComponent, IdsBottomSheetFooterDirective, IdsBottomSheetModule, IdsBottomSheetPresentationDirective, IdsBreadcrumbsComponent, IdsBreadcrumbsModule, IdsCellDefDirective, IdsCellDirective, IdsCheckboxColumnComponent, IdsCheckboxComponent, IdsCheckboxDirective, IdsCheckboxModule, IdsChipsComponent, IdsChipsModule, IdsColumnDefDirective, IdsConfigModule, IdsContextualButtonComponent, IdsContextualButtonModule, IdsCreditCardBrandComponent, IdsCreditCardBrandModule, IdsDatepickerComponent, IdsDatepickerDirective, IdsDatepickerModule, IdsDatepickerSelectedDateDirective, IdsDirectionalButtonComponent, IdsDirectionalButtonModule, IdsDomChangeDirective, IdsEnsureScrollableAccessDirective, IdsEnsureScrollableAccessModule, IdsFavoriteButtonComponent, IdsFavoriteButtonModule, IdsFieldMixinBase, IdsFooterCellDefDirective, IdsFooterCellDirective, IdsFooterRowComponent, IdsFooterRowDefDirective, IdsFormControlComponent, IdsFormControlModule, IdsFormDirective, IdsFormFieldComponent, IdsFormFieldLabelDirective, IdsFormFieldModule, IdsFormMessageComponent, IdsFormMessageModule, IdsFormModule, IdsFormSelectionComponent, IdsFormSelectionGroupComponent, IdsFormSelectionGroupModule, IdsFormSelectionLegendDirective, IdsFormSelectionModule, IdsHeaderCellDefDirective, IdsHeaderCellDirective, IdsHeaderRowComponent, IdsHeaderRowDefDirective, IdsHelperTextComponent, IdsHighlightButtonComponent, IdsHighlightButtonModule, IdsIconButtonComponent, IdsIconButtonModule, IdsIconComponent, IdsIconModule, IdsInputDirective, IdsInputModule, IdsInputPasswordDirective, IdsInputSearchComponent, IdsInputSearchModule, IdsLabelDirective, IdsLikeComponent, IdsLikeModule, IdsLikertComponent, IdsLikertModule, IdsListComponent, IdsListItemComponent, IdsListItemDescriptionDirective, IdsListItemIconDirective, IdsListItemSubTextComponent, IdsListItemTextComponent, IdsListModule, IdsListSubDescriptionComponent, IdsListTagComponent, IdsListboxComponent, IdsListboxModule, IdsLoadingComponent, IdsLoadingModule, IdsMainButtonComponent, IdsMainButtonModule, IdsMaskDirective, IdsMaskModule, IdsMaskPipe, IdsMaskService, IdsMfeStyleManagerModule, IdsMfeStyleManagerService, IdsMobileHeaderActionContentDirective, IdsMobileHeaderComponent, IdsMobileHeaderControlsContentDirective, IdsMobileHeaderModule, IdsMobileHeaderTitleContentDirective, IdsModalComponent, IdsModalDescriptionDirective, IdsModalFooterComponent, IdsModalHeaderComponent, IdsModalModule, IdsModalTitleDirective, IdsMotionPreferenceDirective, IdsMotionPreferenceModule, IdsNativeSelectDirective, IdsNativeSelectOptionDirective, IdsNoDataRowDirective, IdsNumberBadgeComponent, IdsNumberBadgeModule, IdsNumberFieldDirective, IdsOptionComponent, IdsOptionModule, IdsOverlayContainer, IdsOverlayOriginDirective, IdsOverlayOriginModule, IdsPaginationComponent, IdsPaginationDotsComponent, IdsPaginationDotsModule, IdsPaginationModule, IdsPaginationNumberComponent, IdsPaginationNumberModule, IdsPasswordComponent, IdsPasswordModule, IdsPrefixDirective, IdsProgressBarComponent, IdsProgressBarModule, IdsRadioButtonComponent, IdsRadioButtonDirective, IdsRadioButtonModule, IdsRecycleRowsDirective, IdsRowComponent, IdsRowDefDirective, IdsSegmentModule, IdsSegmentService, IdsSelectComponent, IdsSelectDirective, IdsSelectModule, IdsShimmerComponent, IdsShimmerModule, IdsShortcutCarouselComponent, IdsShortcutCarouselItemDirective, IdsShortcutCarouselModule, IdsShortcutComponent, IdsShortcutModule, IdsSliderCurrencyComponent, IdsSliderCurrencyModule, IdsSliderDirective, IdsSliderModule, IdsSliderRangeComponent, IdsSnackbarComponent, IdsSnackbarModule, IdsSortComponent, IdsSuffixDirective, IdsSwitchComponent, IdsSwitchDirective, IdsSwitchModule, IdsTableComponent, IdsTableModule, IdsTableWrapperComponent, IdsTabsComponent, IdsTabsModule, IdsTabsPanelDirective, IdsTextColumnComponent, IdsTextFieldDirective, IdsTooltipComponent, IdsTooltipDirective, IdsTooltipModule, IdsTrackerComponent, IdsTrackerDirective, IdsTrackerItemComponent, IdsTrackerModule, KebabCaseModule, KebabCasePipe, RequiredValidatorModule, SanitizeUrlModule, SanitizeUrlPipe, VoxelEnsureScrollableAccessDirective, VoxelEnsureScrollableAccessModule, buildValueString, idsListOfValuesValidator, idsModalCloseDirective, idsRequiredValidators };
